/**
 * ARQUIVO GERADO — não editar à mão.
 *
 * Gerado por scripts/gen-i18n-pages.mjs a partir dos JSONs em
 * scripts/i18n-pages/. Um namespace por página; `pt` é o master (define as
 * chaves), `fr`/`en` são tipados por `PagesMessages`.
 */

/* eslint-disable */

export const ptPages = {
  about: {
    buildLabel: "Build",
    productLabel: "Produto",
    tagline: "Sistema de gestão interna do grupo Euro Storm.",
    title: "Sobre",
    versionLabel: "Versão",
  },
  account: {
    changePassword: "Trocar senha",
    confirmNewPassword: "Confirmar nova senha",
    currentPassword: "Senha atual",
    emailHint:
      "Seu email é usado para entrar no sistema e para recuperar a senha. Para trocá-lo, fale com o escritório.",
    emailLabel: "Email",
    errorMinLength: "A nova senha precisa ter pelo menos 8 caracteres.",
    errorMismatch: "A confirmação não confere com a nova senha.",
    errorSameAsCurrent: "A nova senha deve ser diferente da atual.",
    minHint: "Mínimo 8 caracteres.",
    newPassword: "Nova senha",
    pageSubtitle: "Seus dados de acesso e gestão da senha.",
    saving: "Salvando…",
    successChanged: "Senha alterada com sucesso.",
    title: "Minha conta",
    userLabel: "Usuário",
  },
  agendaPage: {
    cancelRdvBtn: "Cancelar RDV",
    chantierAutoHint: "Cliente com chantier no cadastro herda o chantier automaticamente.",
    chantierLabel: "Chantier",
    closeBtn: "Fechar",
    customerLabel: "Cliente",
    dateLabel: "Data",
    emptyDay: "Nenhum RDV",
    filterAllLabel: "Todos os chantiers e clientes",
    filterNoChantier: "Clientes sem chantier",
    kpiToday: "hoje",
    kpiWeek: "na semana",
    modalEditTitle: "Editar RDV",
    modalNewTitle: "Novo RDV",
    newRdvBtn: "Novo RDV",
    nextRdvLabel: "Próximos RDVs",
    noRdvWeek: "Nenhum RDV nesta semana.",
    noneOption: "— nenhum —",
    notesLabel: "Notas",
    openAgenda: "Abrir agenda",
    plateLabel: "Placa",
    saveBtn: "Salvar",
    savingBtn: "Salvando…",
    statusArrived: "Chegou",
    statusDone: "Concluído",
    statusEmReparacao: "Em reparação",
    statusFaturado: "Faturado",
    statusHint: "Clique no status para avançar (Agendado → Chegou → Concluído).",
    statusOrcamento: "Orçamento",
    statusPago: "Pago",
    statusRecebido: "Recebido",
    statusReparado: "Reparado",
    statusScheduled: "Agendado",
    subtitle: "RDVs dos chantiers e dos clientes — semana a semana",
    timeLabel: "Horário",
    title: "Agenda",
    todayBtn: "Hoje",
    vehicleLabel: "Veículo (marca/modelo)",
    weekPre: "Semana",
    weekTotalTitle: "Total a faturar na semana (HT)",
  },
  audit: {
    actionPlaceholder: "action (ex: login)",
    asUserPre: "como",
    colAction: "Ação",
    colChanges: "Mudanças",
    colEntity: "Entidade",
    colWhen: "Quando",
    colWho: "Quem",
    companyLabel: "Empresa:",
    emptyState: "Nenhum evento encontrado.",
    entityKindPlaceholder: "entity_kind (ex: customer)",
    filterAction: "Ação",
    filterCompany: "Empresa",
    filterEntity: "Entidade",
    loading: "Carregando…",
    nextBtn: "Próxima →",
    notAdmin: "Você não é administrador de nenhuma empresa.",
    of: "de",
    page: "Página",
    prevBtn: "← Anterior",
    title: "Audit log",
  },
  bankAccounts: {
    accountPlural: "contas",
    accountSingular: "conta",
    adminCreatesZeroBalance:
      "Admin comum cria a conta com saldo 0 (ajuste depois via super admin).",
    badgeActive: "ativa",
    badgeInactive: "inativa",
    bankLabel: "Banco",
    cancelBtn: "Cancelar",
    colActions: "Ações",
    colCurrency: "Moeda",
    colOpening: "Abertura",
    colWise: "Wise",
    companyLabel: "Empresa",
    createBtn: "Criar",
    currencyIsoLabel: "Moeda (ISO 4217)",
    deactivateAccountPre: "Desativar conta",
    deactivateBtn: "Desativar",
    deactivateMessage:
      "Conta inativa não recebe novos imports/syncs. Transações e reconciliações existentes não são afetadas.",
    deactivateReasonPlaceholder: "Ex: conta encerrada no banco",
    defaultInvoicesBadge: "padrão nas faturas",
    editBtn: "editar",
    emptyState: "Nenhuma conta encontrada.",
    filterActive: "Ativas",
    filterAll: "Todas",
    filterInactive: "Inativas",
    ibanChangeReasonLabel: "Motivo da alteração do IBAN",
    ibanPlaceholder: "FR76 ... (sem espaços)",
    invalidOpeningBalance: "Saldo inicial inválido.",
    labelField: "Rótulo",
    labelPlaceholder: "Ex: SocGen ES — corrente principal",
    loading: "Carregando…",
    makeDefaultInvoicesBtn: "Usar como padrão nas faturas",
    makeDefaultInvoicesShort: "Tornar padrão",
    modalTitleCreate: "Nova conta bancária",
    modalTitleEdit: "Editar conta bancária",
    newBtn: "+ Nova conta",
    nextBtn: "Próxima →",
    noCompanyAccess: "Você não tem acesso a nenhuma empresa.",
    notesLabel: "Notas",
    ofWord: "de",
    onlySuperAdminEditsOpening: "Apenas super administradores editam saldo inicial.",
    onlySuperAdminOpening:
      "Apenas super administradores podem alterar saldo inicial ou data de abertura.",
    openingBalanceLabel: "Saldo inicial",
    openingChangeReasonLabel: "Motivo da alteração de saldo/data de abertura",
    openingDateLabel: "Data de abertura",
    openingNonZeroReasonLabel: "Motivo do saldo inicial != 0",
    openingReasonRequired:
      "Justificativa obrigatória para alterar saldo inicial / data de abertura.",
    pageWord: "Página",
    prevBtn: "← Anterior",
    providerLabel: "Provedor (define a importação)",
    providerOther: "Outro — sem importação automática",
    providerSg: "Société Générale — upload CSV",
    providerWise: "Wise — sync API",
    reactivateBtn: "Reativar",
    saveBtn: "Salvar",
    saving: "Salvando…",
    searchLabel: "Buscar",
    searchPlaceholder: "Rótulo, IBAN, banco…",
    statusLabel: "Status",
    wiseAutoNote:
      "Depois de ligada, a conta sincroniza sozinha todo dia de manhã (a partir das 6h, hora de Paris). Você também pode clicar em Sincronizar agora.",
    wiseBalancePre: "saldo",
    wiseConnectBtn: "Ligar ao Wise",
    wiseCopied: "copiada",
    wiseCopyBtn: "Copiar chave",
    wiseDisconnectBtn: "Desligar",
    wiseDisconnectMsg:
      "O token e a chave de assinatura são apagados. As transações já importadas ficam.",
    wiseDisconnectTitle: "Desligar o Wise desta conta",
    wiseDoneBtn: "Concluir",
    wiseDownloadKeyBtn: "Baixar a chave (.pem)",
    wiseFetchProfilesBtn: "Buscar perfis",
    wiseKeyHint:
      "O Wise exige uma assinatura (SCA) para entregar o extrato. Copie a chave abaixo e cadastre no site do Wise: Paramètres → Clés API → Gérer les clés publiques → Ajouter. Depois clique em Testar.",
    wiseKeyReused:
      "A chave anterior foi mantida: se já está cadastrada no Wise, não precisa cadastrar de novo.",
    wiseLastSyncPre: "última sync",
    wiseLinkBtn: "Ligar esta conta",
    wiseLinked: "ligado",
    wiseLinkedTo: "Conta ligada ao perfil",
    wiseModalTitle: "Ligar ao Wise",
    wiseNeverSynced: "nunca sincronizado",
    wiseNewTokenBtn: "Trocar o token",
    wiseNoKey: "sem chave SCA",
    wiseNoProfiles: "Este token não dá acesso a nenhum perfil.",
    wiseNotLinked: "não ligado",
    wiseReconfigureBtn: "Reconfigurar",
    wiseStep1: "1 · Cole o token de API do Wise",
    wiseStep2: "2 · Escolha o perfil (a empresa)",
    wiseStep3: "3 · Cadastre a chave pública no Wise",
    wiseSyncDonePre: "Sincronizado:",
    wiseSyncDupSuf: "já existente(s)",
    wiseSyncNewSuf: "nova(s)",
    wiseSyncNowBtn: "Sincronizar agora",
    wiseTestBtn: "Testar",
    wiseTestCountSuf: "movimento(s) nos últimos 7 dias",
    wiseTestOkPre: "Ligação OK:",
    wiseTestSca: "assinatura SCA aceita",
    wiseTokenHint:
      "Crie o token no site do Wise (não no aplicativo): Paramètres → Clés API → Ajouter. Permissão: somente leitura. O Wise mostra o token uma vez só: cole aqui na hora. Ele fica cifrado no Gestion e nunca é mostrado de novo.",
    wiseTokenLabel: "Token de API",
  },
  bankCategories: {
    appliedEligibleSuf: "elegíveis",
    appliedNoMatchSuf: "sem match",
    appliedPre: "Aplicado",
    appliedRulesSuf: "regras",
    appliedUnchangedSuf: "inalteradas",
    appliedUpdatedSuf: "atualizadas",
    applyAllBtn: "↻ Aplicar todas",
    applyAllConfirmMessage:
      "Processa todas as transações elegíveis com as regras ativas. Transações já categorizadas como 'manual' são preservadas.",
    applyAllConfirmTitle: "Aplicar todas as regras ativas?",
    applyAllLabel: "Aplicar todas",
    applyingBtn: "Aplicando…",
    cancelBtn: "Cancelar",
    categoryBankFee: "Taxas bancárias",
    categoryInsurance: "Seguros",
    categoryIntermediaryFees: "Honorários / intermediários",
    categoryOther: "Outros",
    categoryPartnerContribution: "Aporte (sócio)",
    categoryPartnerReimbursement: "Reembolso (sócio)",
    categoryPersonal: "Pessoal (sócio)",
    categoryRent: "Aluguel / locação",
    categoryRevenue: "Receita",
    categorySalary: "Salário",
    categorySupplierPayment: "Fornecedor",
    categorySupplies: "Materiais / fornecimentos",
    categoryTax: "Imposto",
    categoryTransfer: "Transferência",
    categoryTravel: "Deslocamentos / recepção",
    categoryVatPayment: "TVA ao Estado (repasse)",
    colActions: "Ações",
    colActive: "Ativa",
    colCategory: "Categoria",
    colField: "Campo",
    colPriority: "Pri",
    colType: "Tipo",
    colValue: "Valor",
    createBtn: "Criar",
    deactivateBtn: "desativar",
    deactivateLabel: "Desativar",
    deactivateReasonPlaceholder: "Ex: regra obsoleta",
    deactivateRuleMessage:
      "A regra deixa de ser aplicada em novas categorizações automáticas (transações já categorizadas mantêm o estado).",
    deactivateRulePre: "Desativar regra",
    editBtn: "editar",
    emptyState: "Nenhuma regra cadastrada.",
    errorTitle: "Erro",
    filterActive: "Ativas",
    filterAll: "Todas",
    filterInactive: "Inativas",
    labelAmountMax: "Amount max",
    labelAmountMin: "Amount min",
    labelCategoryResult: "Categoria (resultado)",
    labelMatchField: "Campo de match",
    labelMatchType: "Tipo de match",
    labelMatchValue: "Valor de match",
    labelNotes: "Notas",
    labelPriority: "Prioridade",
    loading: "Carregando…",
    matchFieldAmount: "amount (numérico)",
    matchFieldBoth: "both (descrição + raw)",
    matchFieldDescription: "description (normalizada)",
    matchFieldRawDescription: "raw_description (original)",
    modalCreateTitle: "Nova regra de categorização",
    modalEditTitle: "Editar regra",
    name: "Nome",
    newRuleBtn: "+ Nova regra",
    noCompanyAccess: "Sem acesso a empresas.",
    placeholderContainsExample: "Ex: COMMISSION",
    placeholderRegexExample: "Ex: (CLIENT|RENAULT|RÈGLEMENT)",
    rulesCountSuf: "regra(s)",
    rulesOrderHint: "Ordenadas por prioridade DESC. Primeira regra que bate vence.",
    saveBtn: "Salvar",
    savingBtn: "Salvando…",
    subtitle: "Regras de categorização automática",
    subtitleCategories: "Categorias",
    testEligibleSuf: "transações elegíveis.",
    testMatchPre: "Match em",
    testRuleBtn: "↻ Testar regra",
    testRunsTitle: "Testa contra todas as transações elegíveis",
    testSampleNone: "(nenhuma)",
    testSamplePre: "Amostra",
    testSaveFirstError:
      "Salve a regra primeiro — o teste roda contra uma regra já gravada no banco.",
    testSaveFirstTitle: "Salve a regra primeiro para poder testá-la",
    testingBtn: "Testando…",
  },
  bankImport: {
    accountConfiguredPre: "Conta",
    accountConfiguredSuf: "configurada — credenciais cifradas",
    accountProvider: "Provedor da conta",
    chooseAccountFirst:
      "Escolha primeiro a conta do extrato, no seletor acima. O Gestion não escolhe por você.",
    closeBtn: "Fechar",
    colAccount: "Conta",
    colDate: "Data",
    colDuplicated: "Duplic.",
    colFailed: "Falhas",
    colFile: "Arquivo",
    colImported: "Importadas",
    colMethod: "Método",
    colStatus: "Status",
    colTotal: "Total",
    duplicatedWord: "duplicadas",
    emptyBatches: "Nenhum import realizado.",
    emptyFile: "Arquivo vazio.",
    failedWord: "falhas",
    fileReadError: "Falha ao ler o arquivo.",
    genericUploadHint:
      "Upload de CSV (ex.: extrato Wise). Detecta automaticamente separador, colunas (Data, Valor/Montant ou Débito/Crédito, Descrição) e formato de número/data.",
    idempotentNote: "Parser idempotente — re-import do mesmo arquivo não duplica transações.",
    importAnywayBtn: "Importar mesmo assim",
    importCsv: "Importar CSV",
    importCsvOrPdf: "Importar extrato (CSV ou PDF)",
    importHistory: "Histórico de importações",
    importOk: "Importação OK",
    importStatements: "Importar extratos",
    importSubtitle: "Importar",
    importedWord: "importadas",
    noCompanyAccess: "Sem acesso a empresas.",
    previewAlready: "Já nesta conta",
    previewAlreadySuf: "(entram como repetidos, não duplicam)",
    previewBalance: "Saldo final do arquivo",
    previewBank: "Banco do arquivo",
    previewBankUnknown: "não reconhecido",
    previewCancel: "Cancelar",
    previewFile: "Arquivo",
    previewGoesTo: "Vai para a conta",
    previewImportAnyway: "Importar mesmo assim na conta",
    previewImportTo: "Importar na conta",
    previewMovements: "Movimentos",
    previewOtherHint: "O arquivo parece ser de lá: confira a conta escolhida.",
    previewOtherMid: "dos",
    previewOtherSuf: "movimentos já estão na conta",
    previewTitle: "Confira antes de importar",
    processing: "Processando…",
    readOnlyNotice:
      "Somente leitura — importação disponível apenas para usuários com permissão de edição.",
    selectAccount: "— Escolha a conta —",
    selectAccountAbove: "Selecione uma conta acima",
    sgUploadHint:
      'CSV exportado da Société Générale ou o relevé mensal em PDF (o "RELEVÉ DE COMPTE"). O mesmo movimento vindo pelo CSV e pelo PDF não duplica.',
    showEmptyFailed: "Mostrar tentativas vazias do robô",
    statusCompleted: "Concluída",
    statusFailed: "Falhou",
    statusPending: "Pendente",
    statusProcessing: "Processando",
    statusUndone: "Desfeito",
    syncWiseBtn: "Sincronizar Wise",
    syncWiseOk: "Sincronização Wise OK",
    syncing: "Sincronizando…",
    totalWord: "total",
    undoAlready: "Este import já foi desfeito.",
    undoBlockAttachment: "com anexo",
    undoBlockClosedYear: "em exercício fiscal fechado",
    undoBlockLinked: "ligado(s) a recebimento, pagamento ou outro registro",
    undoBlockReconciled: "conciliado(s) — desfaça a conciliação antes",
    undoBlockedTitle: "Não dá para desfazer: alguns movimentos já foram usados.",
    undoBtn: "Desfazer",
    undoConfirmBtn: "Desfazer importação",
    undoExplain:
      'Os movimentos gravados por este import serão apagados. O import fica no histórico como "Desfeito", com o motivo, e entra na auditoria. Depois, suba o arquivo na conta certa.',
    undoMovements: "movimento(s)",
    undoReasonLabel: "Motivo (obrigatório)",
    undoReasonPlaceholder: "Ex.: extrato do Wise subido na conta Wamo",
    undoTitle: "Desfazer importação",
    wiseOnlyHint: "Disponível apenas para contas com provedor='wise'",
    wiseSyncTitle: "Sincronização Wise API",
    wrongAccountHint: 'Se o arquivo for mesmo desta conta, clique em "Importar mesmo assim".',
    wrongAccountTitle: "Conta certa?",
  },
  bankPartner: {
    accountCardSubtitle: "Saldo corrente derivado das transações + abertura",
    accountCardTitle: "Conta-corrente do sócio",
    allMovementsCounted: "Todos os movimentos categorizados são contados.",
    balanceZero: "Conta zerada.",
    calcMovements: "movimentos",
    calcOpeningPre: "Cálculo: abertura",
    cancel: "Cancelar",
    cancelBtnLower: "cancelar",
    companyLabel: "Empresa",
    companyOwesPartner: "A empresa deve este valor ao sócio.",
    contributions: "Aportes",
    currentBalance: "Saldo corrente",
    editBtn: "editar",
    emptyOpenings:
      "Nenhuma abertura cadastrada. O saldo acima considera abertura = 0 e soma os movimentos categorizados.",
    error: "Erro",
    loading: "Carregando…",
    missingDataTitle: "Faltam dados",
    missingPartnerName: "Informe o nome do sócio.",
    movementsFromPre: "Movimentos contados a partir de",
    movementsFromSuf: "(após a data de abertura).",
    movementsSourceNote:
      "Os movimentos vêm das transações marcadas como Aporte, Reembolso ou Pessoal na página Extratos.",
    multiPartnerWarning:
      "Há mais de um sócio cadastrado — os movimentos são a nível de empresa e não são divididos por sócio.",
    nameLabel: "Nome",
    newPartnerBtn: "+ Novo sócio",
    noCompanyAccess: "Você não tem acesso a nenhuma empresa.",
    opening: "Abertura",
    openingBalanceLabel: "Saldo de abertura (€)",
    openingDateLabel: "Data de abertura",
    openingEuroLabel: "Abertura (€)",
    openingsCardTitle: "Aberturas por sócio",
    partnerNameLabel: "Nome do sócio",
    partnerNamePlaceholder: "Ex: Landione Souza",
    partnerOwesCompany: "O sócio deve este valor à empresa.",
    personalExpenses: "Gastos pessoais",
    reimbursements: "Reembolsos",
    remove: "Remover",
    removeBtn: "remover",
    removeConfirmPre: "Remover a abertura de",
    removeConfirmSuf: "As transações não são afetadas.",
    removePartnerTitle: "Remover sócio",
    save: "Salvar",
    saveBtnLower: "salvar",
    saving: "Salvando…",
    subtitle: "Sócio",
  },
  bankReconciliation: {
    acceptBtn: "aceitar",
    acceptCreatesReceiptTitle:
      "Aceitar cria o recibo (source=bank_reconciliation) e marca a fatura/dossier como paga",
    colActions: "Ações",
    colAmount: "Valor",
    colBankTransaction: "Transação bancária",
    colConfidence: "Confiança",
    colReason: "Motivo",
    colStatus: "Status",
    colSuggestion: "Sugestão",
    colTargetId: "ID alvo",
    emptyState:
      'Nenhuma sugestão com esses filtros. Clique em "↻ Gerar sugestões" para rodar o engine.',
    error: "Erro",
    filterCompany: "Empresa",
    filterStatus: "Situação",
    generateBtn: "Gerar sugestões",
    generating: "Gerando…",
    highConfidence: "alta confiança",
    kindCustomerInvoice: "Fatura aberta → cria recibo",
    kindCustomerReceipt: "Recebimento cliente",
    kindIntercompany: "Intercompany",
    kindOther: "Outros",
    kindTaxPayment: "Pagamento de imposto",
    kindTechnicianPayment: "Pagamento técnico",
    loading: "Carregando…",
    minConfidenceLabel: "Confiança mínima",
    nextBtn: "Próxima",
    noCompanyAccess: "Sem acesso a empresas.",
    pageLabel: "Página",
    pageOf: "de",
    prevBtn: "Anterior",
    reconciliationSubtitle: "Reconciliação",
    rejectBtn: "rejeitar",
    rejectConfirm: "Rejeitar",
    rejectMessage:
      "A sugestão será bloqueada — engine não gera nova sugestão para esta transação até admin fazer unreject.",
    rejectPlaceholder: "Ex: alvo errado, montante não bate",
    rejectTitle: "Rejeitar sugestão",
    scanBlockedAccepted: "bloqueadas (accepted)",
    scanBlockedRejected: "bloqueadas (rejected)",
    scanCreated: "criadas",
    scanLabel: "Varredura",
    scanNoCandidate: "sem candidato",
    scanTx: "tx",
    scanUpdated: "atualizadas",
    statusAccepted: "Aceita",
    statusAll: "Todas",
    statusPending: "Pendente",
    statusRejected: "Rejeitada",
    suggestionsCount: "sugestão(ões)",
    suggestionsSubtitle: "Sugestões de reconciliação",
    unrejectBtn: "desfazer rejeição",
    unrejectConfirm: "Desfazer rejeição",
    unrejectMessage:
      "Admin only. Volta status para 'pending' — engine pode re-gerar sugestões para esta tx.",
    unrejectPlaceholder: "Ex: revisão concluída, alvo correto identificado",
    unrejectTitle: "Reabrir sugestão (unreject)",
  },
  bankShell: {
    moduleLabel: "Módulo banco",
    navCategories: "Categorias",
    navImport: "Importar",
    navPartner: "Sócio",
    navReconciliation: "Reconciliação",
    navStatements: "Extratos",
  },
  bankStatements: {
    accountantLinkNote: "Este é o documento que o extrato do contador linka nesta linha.",
    additionalDetailsPlaceholder: "Detalhes adicionais",
    advAddRow: "outro técnico",
    advDescHint: "Descrição (opcional; padrão = texto do extrato)",
    advFillAll: "valor inteiro",
    advNoRows: "Informe pelo menos um técnico com valor.",
    advPickTech: "Técnico…",
    advRemoveRow: "Remover",
    advRestNotAdvance: "resto não é adiantamento:",
    advSumExceeds: "a soma passa do valor da saída",
    advSummaryTag: "adiantamento a técnico",
    advToggle: "É adiantamento a técnico",
    advToggleHint:
      "Hotel, ferramentas, etc. pagos pela empresa para um ou mais técnicos: cada parte vira um adiantamento, descontado na próxima fatura dele.",
    allAccounts: "Todas as contas",
    allCategories: "Todas categorias",
    allCredits: "➕ Entradas (todas)",
    allCustomers: "Todos clientes",
    allDebits: "➖ Saídas (todas)",
    allStatuses: "Todos status",
    alreadyReceivedPre: "já recebido",
    amountHtPlaceholder: "Valor HT",
    attachBtnTitle: "Anexar / ver comprovantes (transação e faturas do lançamento)",
    attachEdspPdfs: "Anexar PDFs das faturas do eDSP (casa pelo nº)",
    attachFiles: "Anexar arquivo(s)",
    attachHelp:
      "Anexe o comprovante (PDF, imagem) de qualquer conciliação — fatura, recibo, guia de imposto, comprovante de pagamento. Ele vira o link clicável desta linha no PDF do extrato enviado ao contador.",
    attachInvoicePdf: "Anexar PDF da fatura",
    attachMonthBtn: "Anexar faturas do mês",
    attachMonthBtnTitle: "Anexar em massa os PDFs das faturas emitidas no período (casa pelo nº)",
    attachOriginalLabel: "Anexe o extrato original do banco (PDF e/ou CSV)",
    attachOriginalMessage:
      "Você não anexou o extrato original do banco (PDF/CSV). Ele deve acompanhar o relevé rapproché. Enviar mesmo assim?",
    attachOriginalTitle: "Anexar o extrato original?",
    attachPdfsFolder: "Anexar PDFs (selecione a pasta ou vários)",
    autoRecognizeBtn: "Reconhecer pendentes",
    autoRecognizeDoneMid: "de",
    autoRecognizeDoneSuf:
      "pendentes categorizadas automaticamente (confiança 'auto' — revisáveis pelo seletor de cada linha).",
    autoRecognizeTitle:
      "Categoriza automaticamente as transações sem categoria: vínculo do rapprochement, entidades cadastradas (cliente/fornecedor/sócio/grupo) e padrões já usados ≥3× sempre com a mesma categoria. Nunca altera categorização manual; tudo fica editável.",
    autoRecognizing: "Reconhecendo…",
    avoirNumberMissing: "Não foi possível sugerir o número do avoir. Tente de novo.",
    avoirOption: "A diferença é um avoir (nota de crédito)",
    avoirOptionHint: "cria o avoir nesta fatura e dá a fatura por paga:",
    avoirReasonDefault: "Avoir deduzido pelo cliente na transferência de",
    avoirReasonLabel: "Motivo do avoir",
    avoirTypeLabel: "Tipo do avoir",
    avoirWord: "avoir",
    backBtn: "Voltar",
    badgeIgnored: "ignorada",
    badgePending: "pendente",
    badgeReconciled: "Conciliada",
    bankTransaction: "Transação bancária",
    cancel: "Cancelar",
    cannotBeUndone: "Esta ação não pode ser desfeita.",
    catBankFee: "Taxas bancárias",
    catBankFeeShort: "Taxa banc.",
    catFees: "Honorários",
    catInsurance: "Seguros",
    catOther: "Outros",
    catPartnerContribution: "Aporte (sócio)",
    catPartnerReimbursement: "Reembolso (sócio)",
    catPendingChip: "A categorizar",
    catPersonal: "Pessoal (sócio)",
    catRent: "Aluguel / locação",
    catRevenue: "Receita",
    catSalary: "Salário",
    catSupplier: "Fornecedor",
    catSupplies: "Materiais",
    catTax: "Imposto",
    catTransfer: "Transferência",
    catTravel: "Deslocamentos",
    catVatPayment: "TVA ao Estado",
    categorizeBtn: "categorizar",
    categorizeHelpPre: "Clique numa categoria para aplicar. A escolha vira",
    categorizeHelpSuf: "— bloqueia futuras re-categorizações automáticas pelas regras.",
    categorizeTitle: "Categorizar transação",
    changePdf: "Trocar PDF",
    chooseIndividualFiles: "ou escolher arquivos avulsos",
    clearCategory: "Limpar categoria",
    clearSelection: "Limpar",
    clickToChooseOr: "Clique p/ escolher (vários: Ctrl+A) ou",
    close: "Fechar",
    colAccount: "Conta",
    colActions: "Ações",
    colAmount: "Valor",
    colCategory: "Categoria",
    colDate: "Data",
    colDescription: "Descrição",
    colEffectiveDate: "Data efetiva",
    colStatus: "Status",
    colTarget: "Alvo",
    confirm: "Confirmar",
    confirming: "Confirmando…",
    continueBtn: "Continuar",
    current: "atual",
    currentCategoryLabel: "Categoria atual",
    depositHigherMsg:
      "Se o depósito paga mais de uma fatura, use «Plusieurs factures / encaissements». Ligar aqui marca só esta fatura como paga.",
    depositHigherTitle: "O depósito é maior que a fatura",
    depositLabel: "Depósito",
    depositLowerMsg:
      "Pagamento parcial: registra o que chegou e a fatura continua em aberto pelo resto. Outras opções: marcar a fatura como paga mesmo assim.",
    depositLowerTitle: "O depósito é menor que a fatura",
    descriptionLabel: "Descrição",
    diffWord: "diferença",
    directBankFee: "Taxa bancária",
    directBankFeeHint: "Comissão, tarifa, anuidade",
    directCategoryLabel: "Categoria",
    directComplementHint: "Nº de fatura, nome… sai como foi escrito, sem tradução.",
    directComplementLabel: "Complemento / referência",
    directComplementRequired: 'Descreva o motivo no complemento (obrigatório para "Outro").',
    directConfirmQuestion: "nenhum documento ligado — marcar como conciliada diretamente?",
    directDescriptionPlaceholder: "Descreva o motivo da conciliação direta",
    directNote:
      "A transação fica registrada com a categoria e descrição abaixo no audit log. Não atualiza nenhuma entidade contábil (faturas, pagamentos).",
    directOther: "Outro",
    directOtherHint: "Descrever motivo (obrigatório)",
    directPartnerReimbursement: "Reembolso sócio",
    directPartnerReimbursementHint: "Adiantamento, reembolso de despesa pessoal",
    directPriorYear: "Liquidação 2025",
    directPriorYearHint:
      "Quita dívida do exercício anterior (comissão / fornecedor / TVA 2025) — sem impacto no P&L de 2026",
    directReasonHint: "O motivo sai traduzido no relevé ao contador, no idioma escolhido.",
    directReasonLabel: "Motivo",
    directReasonNone: "— sem motivo —",
    directReasonOthers: "Outros motivos",
    directReasonRequiredOther: 'Escolha um motivo para a categoria "Outros".',
    directReasonSuggested: "Sugeridos para esta categoria",
    directSalaryPersonal: "Salário / Pessoal",
    directSalaryPersonalHint: "Folha, encargos sociais",
    directSectionTitle: "Ou categorizar diretamente (sem documento) — mesma lista das categorias",
    directSupplierPurchaseHint:
      "Ferramenta, serviço, produto ou material pago na hora (cartão/débito) — charge operacional 2026",
    directTax: "Imposto / DGFiP",
    directTaxHint:
      "TVA, IS, CFE e outros impostos pagos à DGFiP (exercício corrente). Use 'Liquidação 2025' se for dívida do exercício anterior.",
    docKindTitle: "Que tipo de documento?",
    docPickTitle: "Escolha o documento",
    docRegisterNew: "Não está na lista? Registrar a fatura do fornecedor",
    downloadCsv: "Baixar CSV",
    downloadPdf: "Baixar PDF",
    downloadSection: "Baixar",
    dragFilesHere: "arraste os arquivos aqui",
    emailNote:
      "O email leva o relevé rapproché do Gestion (PDF + CSV) + o extrato original anexado. O email do contador fica salvo para a próxima vez.",
    emailPlaceholder: "email@contador.fr",
    emailSection: "Enviar ao contador por email",
    emptyState: "Nenhuma transação encontrada com esses filtros.",
    errorTitle: "Erro",
    existingReceiptsTitle: "Recebimentos existentes (não vinculados)",
    expandHint: "Clique para ver o texto completo do banco",
    exportBtnTitle: "Exportar o extrato do período (PDF + CSV) e enviar ao contador",
    exportModalTitle: "Extrato para o contador",
    failed: "falha",
    filterAccount: "Conta",
    filterByMonthTitle: "Filtrar por mês/ano",
    filterCategory: "Categoria",
    filterCompany: "Empresa",
    filterInvoicesByCustomerTitle: "Filtrar faturas por cliente",
    filterMonth: "Mês",
    filterPeriod: "Período",
    filterSearch: "Buscar",
    filterStatus: "Status",
    fullOptionHint: "a diferença deixa de ser cobrada",
    fullPaymentBtn: "Paga integral",
    fullPaymentMsg:
      "A diferença deixa de ser cobrada. Se o cliente ainda vai pagar o resto, volte e escolha pagamento parcial.",
    fullPaymentTitle: "Marcar a fatura como paga mesmo assim?",
    generatePdfCsv: "Gerar PDF + CSV",
    generating: "Gerando…",
    higherNote:
      "O depósito é maior que a fatura. Se ele paga mais de uma fatura, volte e marque «Este depósito paga várias faturas».",
    hintBankFee: "Comissão, taxas do banco",
    hintFees: "Contador, advogado, consultores, intermediários",
    hintInsurance: "Prêmios de seguro (RC, veículos, multirriscos…)",
    hintOther: "Não se encaixa nas categorias acima",
    hintPartnerContribution:
      "Empréstimo/aporte seu PARA a empresa (entrada) — aumenta o que ela te deve",
    hintPartnerReimbursement:
      "Reembolso da empresa PARA você (saída) — quita parte do que ela te deve",
    hintPersonal: "Gasto pessoal seu no cartão da empresa (sai do seu reembolso/lucro)",
    hintRent: "Aluguel, leasing, encargos locativos",
    hintRevenue: "Recebimento de cliente, faturamento",
    hintSalary: "Folha de pagamento, encargos sociais",
    hintSupplier: "Pagamento a fornecedor",
    hintSupplies: "Fornecimentos e consumíveis (não estocados)",
    hintTax: "IS, TVA, impostos",
    hintTransfer: "Transferência entre contas próprias",
    hintTravel: "Viagens, combustível, pedágio, hotel, recepção",
    hintVatPayment: "Repasse de TVA ao Estado — NÃO é despesa (confere com o módulo TVA)",
    ignoreBtn: "ignorar",
    ignoreConfirm: "Ignorar",
    ignoreMessage:
      "Use para frais interne, transferência entre contas próprias, etc. Motivo obrigatório.",
    ignorePlaceholder: "Ex: virement entre comptes",
    ignoreTitle: "Ignorar transação",
    invalidAmountMessage: "Confira HT e TVA (%).",
    invalidAmountTitle: "Valor inválido",
    invalidEmailMessage: "Informe o email do contador.",
    invalidEmailTitle: "Email inválido",
    invoiceCreatedPdfFailed: "Fatura criada, mas falhou ao anexar o PDF.",
    invoiceDocWord: "fatura",
    invoiceFromPlaceholder: "Fatura de (ex: F2026-00300)",
    invoiceNumberPlaceholder: "N° da fatura",
    invoiceToPlaceholder: "até (ex: F2026-00334)",
    invoiceWord: "fatura",
    invoicesOfEntry: "Faturas deste lançamento",
    invoicesUnit: "fatura(s)",
    langEn: "English",
    langFr: "Français (contador FR)",
    langPt: "Português",
    languageLabel: "Idioma do relevé",
    lblCb: "Cartão (CB)",
    lblFrais: "Tarifa bancária",
    lblPrlv: "Débito automático",
    lblVirEmis: "Transferência emitida",
    lblVirRecu: "Transferência recebida",
    linkBtn: "vincular",
    linkCustomerReceipt: "Recebimento cliente",
    linkProforma: "Proforma (pagamento)",
    linkPurchaseInvoice: "Fornecedor / Compra",
    linkSectionTitle: "Vincular a documento existente",
    linkTaxPayment: "Pagamento de imposto",
    linkTechnicianPayment: "Pagamento técnico",
    linkedInvoicesAlertTitle: "Faturas do lançamento",
    loading: "Carregando…",
    manualWord: "manual",
    matchByAmount: "valor exato",
    matchByFilenameHint: "Casa pelo nº do arquivo (ex.: F2025-00006.pdf) · máx. 25 MB cada",
    matchByNumber: "nº na transferência",
    matchSurplus: "fecha a sobra",
    maxSizeEach: "máx. 25 MB cada",
    missingDataMessage: "Selecione o fornecedor e informe o nº da fatura.",
    missingDataTitle: "Faltam dados",
    monthAttachAlertTitle: "Anexos das faturas do mês",
    monthInvoicesHelp:
      "Anexe os PDFs (do eDSP) — cada arquivo é casado com a fatura de mesmo número e vira link no extrato do contador.",
    monthInvoicesTitle: "Faturas emitidas no período",
    moreActions: "Mais ações",
    multiBtn: "Várias faturas / recebimentos",
    multiHelp:
      "Marque faturas EM ABERTO (serão pagas: cria recibo + marca paga) e/ou recebimentos JÁ EXISTENTES (só vincula). Os valores mostrados são o FATURADO TTC (o que o cliente paga — base do depósito); o recibo gravado internamente é HT (líquido). A soma deve ficar próxima do depósito.",
    multiSectionTitle: "Ou conciliar VÁRIAS de cliente (um depósito paga muitas faturas)",
    multiShortfall:
      "A soma das faturas marcadas passa do depósito: não dá para dar tudo por pago. Desmarque alguma ou, para pagamento parcial, deixe uma fatura só.",
    newPurchaseHelp:
      "Sem fatura de fornecedor pendente? Registre uma aqui (com PDF opcional) e concilie o pagamento de uma vez. HT pré-preenchido = |depósito| ÷ 1,20.",
    next: "Próxima",
    nextMonth: "Próximo mês",
    noAttachments: "Nenhum comprovante anexado ainda.",
    noCandidates: "Nenhum candidato pendente nesta categoria.",
    noCompanyAccess: "Você não tem acesso a nenhuma empresa.",
    noInvoicesInPeriod: "Nenhuma fatura emitida neste período.",
    noMatchingInvoiceInEntry: "sem fatura correspondente neste lançamento",
    noMatchingInvoiceInPeriod: "sem fatura correspondente no período",
    noOpenInvoices: "Nenhuma fatura em aberto no filtro.",
    noPdf: "sem PDF",
    noPendingReceipts: "Nenhum recebimento pendente de vínculo no filtro.",
    noteLabel: "Observação",
    ofLabel: "de",
    open: "abrir",
    openInvoicePdfTitle: "Abrir / baixar o PDF da fatura",
    openInvoiceWord: "Fatura aberta",
    openInvoicesTitle: "Faturas em aberto",
    openPdf: "abrir PDF",
    openProformaInvoicePdfTitle: "Abrir / baixar o PDF da fatura anexada na proforma",
    openPurchasePdfTitle: "Abrir / baixar o PDF da fatura de fornecedor",
    optionalSuffix: "(opcional)",
    otherOptionsBtn: "Outras opções",
    pageLabel: "Página",
    partialOptionHint: "registra o que chegou; a fatura continua em aberto pelo resto",
    partialPaymentBtn: "Pagamento parcial",
    pdfOptional: "PDF opcional",
    pdfsAttached: "PDF(s) anexado(s).",
    pdfsAttachedToInvoices: "PDF(s) anexado(s) à(s) fatura(s).",
    periodLabel: "Período",
    piAchatsConsommes: "Compras consumidas",
    piAssurances: "Seguros",
    piAutresCharges: "Outros encargos de exploração",
    piChargesPersonnel: "Encargos de pessoal",
    piDeplacements: "Deslocamentos / recepção",
    piFournitures: "Fornecimentos / consumíveis",
    piFraisBancaires: "Taxas bancárias",
    piHonoraires: "Honorários / intermediários",
    piImpots: "Impostos / taxas",
    piLocations: "Locações / encargos",
    pickOneToContinue: "Escolha um item para continuar.",
    prev: "Anterior",
    prevMonth: "Mês anterior",
    proformaAlreadyPaid:
      "Já marcada paga — ligar só registra o pagamento no extrato (nada é refeito).",
    proformaDocReconciled: "Proforma conciliada — fatura recebida",
    proformaNeedsApproval:
      "Proforma ainda só enviada — aprove e registre a fatura recebida antes de conciliar.",
    proformaNeedsInvoice:
      "Falta registrar a fatura recebida na proforma — faça isso antes de conciliar.",
    proformaNoInvoicePdf: "sem PDF da fatura — anexe na proforma",
    proformaWillBePaid: "Ao ligar, a proforma fica paga e os carros dela ficam pagos ao técnico.",
    purchaseInvoiceReconciled: "Fatura de fornecedor conciliada",
    purchaseWord: "Compra",
    readFileError: "Não foi possível ler o arquivo anexado.",
    reasonRecorded: "Motivo registrado:",
    receiptFilterNumber: "nº da fatura…",
    receiptMultiToggle: "Este depósito paga várias faturas",
    receiptPickHint: "Marque uma ou várias; a soma aparece acima.",
    receiptPickTitle: "Quais faturas este depósito paga?",
    receiptWord: "Recebimento",
    reconcileBtn: "Conciliar",
    reconcileTitle: "Conciliar a transação",
    reconcileVerb: "Conciliar",
    reconciling: "Conciliando…",
    registerAndReconcile: "Registrar fatura + conciliar",
    registering: "Registrando…",
    remainingWord: "falta",
    removeBtn: "remover",
    removeConfirm: "Remover",
    removeFileTitle: "Remover arquivo",
    removeQuestionPre: "Remover",
    removeReceiptTitle: "Remover comprovante",
    removeTitle: "Remover",
    searchPlaceholder: "Descrição…",
    selectAllInvoices: "Selecionar todas",
    selectAllReceipts: "Selecionar todos",
    selectPdfsMid: "PDFs (ex.:",
    selectPdfsPre: "Selecione os",
    selectPdfsSuf: ".pdf) — cada arquivo é anexado à sua fatura.",
    selectPeriodFirst: "Selecione um mês (ou um intervalo de datas) na barra antes de exportar.",
    selectVisible: "Marcar as visíveis",
    selectedCount: "selecionado(s)",
    send: "Enviar",
    sendAnyway: "Enviar mesmo assim",
    sendFailed: "Falha ao enviar",
    sendToAccountantBtn: "Enviar ao contador",
    sending: "Enviando",
    sendingEllipsis: "Enviando…",
    sentTitle: "Enviado",
    sheetCloseLabel: "Fechar o painel",
    sortNewest: "Mais recentes primeiro",
    sortOldest: "Mais antigos primeiro",
    sortToggleTitle: "Inverter a ordem da lista",
    statementBalancePre: "saldo do extrato em",
    statementBalanceTitle:
      "Saldo informado pelo arquivo importado, na data do extrato. Não é calculado pelo Gestion.",
    statementSentTo: "Extrato enviado para",
    statusIgnored: "Ignorada",
    statusPending: "Pendente",
    statusReconciled: "Conciliada",
    stepConfirm: "Confirmar",
    stepDetails: "Detalhes",
    stepWhat: "O que é?",
    subtitle: "Extratos bancários",
    subtitleShort: "Extratos",
    sugAcceptMsgPre: "Conciliar esta transação com base em:",
    sugAcceptMsgSuf:
      "Isso cria o recibo e marca a fatura como paga (mesmo efeito do Conciliar manual).",
    sugAcceptTitle: "Aceitar sugestão de conciliação",
    sugApplied: "Sugestão aplicada",
    sugBadge: "Sugestão do Gestion",
    sugEntityPre: "reconhecido no cadastro:",
    sugHistoryPre: "já usada",
    sugInvoicesCited: "faturas citadas na transferência",
    sugMaybe: "Talvez?",
    sugReconcilePre: "Conciliar:",
    sugSimilarMany: "transações parecidas",
    sugSimilarManySuf: "foram marcadas como",
    sugSimilarOne: "transação parecida",
    sugSimilarOneSuf: "foi marcada como",
    sugUseSame: "Usar a mesma",
    sumAvoirMid: "vira o avoir",
    sumAvoirPre: "a diferença de",
    sumAvoirSuf: "e a fatura fica paga.",
    sumDepositWord: "Depósito de",
    sumDirectNote: "sai no relevé ao contador no idioma escolhido · categoria editável depois",
    sumDocPaid: "O documento fica pago e ligado ao extrato.",
    sumInvoiceFullAnyway: "que fica paga mesmo assim (a diferença deixa de ser cobrada).",
    sumInvoicePaid: "que fica paga.",
    sumInvoicePartial: "em parte —",
    sumLinksReceipt: "fica ligado ao recebimento",
    sumMatches: "bate com o depósito",
    sumMultiMid: "ligado a",
    sumMultiPaidSuf: "que ficam pagas.",
    sumMultiSuf: "fatura(s) / recebimento(s), que ficam pagos.",
    sumNoReason: "sem motivo",
    sumOutflowWord: "Saída de",
    sumOverPre: "a soma passa do depósito em",
    sumPartialHint: "pagamento parcial possível no próximo passo",
    sumPaysDoc: "paga",
    sumPaysInvoice: "paga a fatura",
    sumPaysInvoices: "paga as faturas",
    sumSurplusPre: "sobra no depósito:",
    summaryPre: "Vai ficar:",
    supplierPlaceholderOption: "— Fornecedor —",
    tlMonthIn: "Entradas",
    tlMonthOut: "Saídas",
    toDate: "a",
    txAttachmentsTitle: "Comprovantes da transação",
    txCountMany: "transações",
    txCountOne: "transação",
    typeDirect: "Sem documento",
    typeDirectHint:
      "Compra no cartão, taxa, transferência. Categoria + motivo padronizado + complemento.",
    typeDocument: "Pagamento de um documento",
    typeDocumentHint:
      "Fatura de fornecedor, proforma, pagamento de técnico, imposto. Escolhe-se o documento na lista.",
    typeReceipt: "Recebimento de cliente",
    typeReceiptHint:
      "Paga uma ou várias faturas. O Gestion sugere as faturas abertas com este valor.",
    undoBtn: "desfazer",
    undoConfirm: "Desfazer",
    unignoreMessage: "A transação voltará a pendente e poderá ser conciliada novamente.",
    unignoreTitle: "Desfazer ignorar",
    unreconcileBtn: "desfazer conciliação",
    unreconcileMessage:
      "A transação voltará a pendente e o documento ligado ficará disponível para nova conciliação.",
    unreconcilePlaceholder: "Ex: vinculei à fatura errada",
    unreconcileTitle: "Desfazer conciliação",
    untriagedFilterBtn: "Ver e tratar",
    untriagedHint: "Elas NÃO entram nas receitas do fiscal até serem tratadas.",
    untriagedManySuf: "entradas sem categoria e sem conciliação no período",
    untriagedOneSuf: "entrada sem categoria e sem conciliação no período",
    uploadFailed: "Falha ao enviar o arquivo.",
    withPdf: "com PDF",
  },
  breakevenChart: {
    ariaLabel: "Gráfico do ponto de equilíbrio",
  },
  bulkActionBar: {
    clear: "Limpar",
    clearSelectionTitle: "Limpar seleção",
    selectedMany: "selecionados",
    selectedOne: "selecionado",
    selectionLabel: "Seleção",
  },
  chantier: {
    agendaAddBtn: "+ Agendar",
    agendaArrivedBtn: "Chegou",
    agendaCancelBtn: "Cancelar",
    agendaDoneBtn: "Concluído",
    agendaEmpty: "Nada agendado nos próximos dias.",
    agendaSaveBtn: "Salvar agendamento",
    agendaTitle: "Agenda do chantier",
    attachChantierAutoPre: "Ao gravar a recepção, o cliente",
    attachChantierAutoSuf: "entra no chantier",
    attachChantierHint:
      "Com o cliente no chantier, os técnicos com par por chantier passam a ver este carro no portal.",
    attachChantierMid: "ainda não pertence a nenhum chantier. Adicionar ao chantier",
    attachChantierNo: "Não",
    attachChantierPre: "O cliente",
    attachChantierYes: "Sim, adicionar",
    carRepairedHint: "Todos os serviços deste carro foram concluídos.",
    carRepairedTitle: "Veículo já reparado",
    carsEmpty: "Nenhum carro neste chantier ainda (vincule os clientes ao chantier no cadastro).",
    carsTitle: "Carros do chantier",
    claimRefLabel: "Nº do sinistro",
    damagePlaceholder: "Ex.: retrovisor esquerdo trincado",
    damagesLabel: "Danos / peças quebradas pré-existentes",
    deliveryAlarmHint:
      "Carros reparados sem entrega registrada. Toque na placa e registre a entrega e o controle: só então o carro é faturado e conta no seu repasse.",
    deliveryAlarmInvoiced: "já faturado",
    deliveryAlarmTitle: "Entregas pendentes",
    deliveryPhotosMissingPre: "Faltam",
    deliveryPhotosMissingSuf: "foto(s) da entrega — fotografe o carro antes de entregar.",
    deliveryPhotosTitle: "Fotos da entrega",
    deliveryTitle: "Entrega e controle",
    deposeReposeLabel: "Desmontar/Remontar",
    devisPareBrise: "Para-brisa",
    devisPieces: "Peças",
    devisTitle: "Devis",
    docCarteGrise: "Documento do carro",
    docCnh: "Carteira de motorista",
    docExpertise: "Report de expertise",
    docReplaceBtn: "Trocar",
    docSentBadge: "enviado",
    docUploadFail: "Não consegui ler o arquivo — tente de novo.",
    docUploading: "Enviando documento…",
    docsTitle: "Documentos da recepção",
    doneBadge: "feito",
    expAlarmTitle: "Carro a finalizar",
    expAmountLabel: "Valor do rapport de expertise (HT)",
    expConfirmBtn: "Confirmar conferência",
    expDevisLabel: "Valor a faturar (devis)",
    expDiffBadge: "com diferença",
    expDiffOver: "acima do valor a faturar.",
    expDiffPre: "Diferença de",
    expDiffUnder: "abaixo do valor a faturar.",
    expHint:
      "Confira o valor do rapport de expertise com o valor a faturar antes de finalizar o carro.",
    expInvoiceLabel: "Fatura",
    expMatch: "Os valores batem.",
    expNeedDoc: "Anexe o rapport de expertise abaixo antes de confirmar.",
    expNotePh: "Explique a diferença para o escritório",
    expSaving: "Gravando…",
    expTitle: "Rapport de expertise conferido",
    expertEmailLabel: "E-mail da peritagem",
    expertNameLabel: "Gabinete de peritagem",
    finalizeAlarmHint:
      "Rapport de expertise por conferir com o valor a faturar. Busque a placa para concluir.",
    finalizeAlarmTitle: "Carros a finalizar",
    finalizeNoDoc: "sem rapport",
    franchiseAmountPh: "Valor da franquia (€)",
    franchiseChangeBtn: "Alterar",
    franchiseFirstHint: "Responda a franquia para liberar as fotos e a assinatura.",
    franchiseLabel: "Franquia",
    franchiseNo: "Não",
    franchiseNone: "sem franquia",
    franchiseQ: "O carro tem desconto de franquia ao cliente?",
    franchiseRequiredBadge: "obrigatória",
    franchiseStep: "1 · Franquia — obrigatório",
    franchiseToggle: "O carro terá desconto de franquia",
    franchiseYes: "Sim",
    hidePhotosBtn: "Esconder fotos",
    impactsWord: "impactos",
    incompleteBadge: "incompleto",
    insuranceHint:
      "A fatura vai para o cliente E para estes contatos. Sem eles o pagamento atrasa.",
    insuranceMissing: "falta registrar",
    insuranceTitle: "Seguradora e peritagem",
    insurerEmailLabel: "E-mail da seguradora",
    insurerNameLabel: "Seguradora",
    invColCount: "faturas",
    invColOpen: "Em aberto",
    invColOverdue: "Em atraso",
    invColReceived: "Recebido",
    invColTotal: "Faturado",
    invDaysLate: "dias",
    invDue: "venc.",
    invOverdueNone: "Nenhuma fatura em atraso.",
    invOverdueTitle: "Faturas em atraso",
    invoicesEmpty: "Nenhuma fatura emitida para os clientes deste chantier.",
    invoicesHint:
      "Valores HT das faturas emitidas aos clientes deste chantier. « Em atraso » = vencida e sem nenhum recebimento.",
    invoicesTitle: "Faturas dos clientes do chantier",
    loanerPh: "Qual carro (placa/modelo)",
    loanerToggle: "Veículo de substituição emprestado ao cliente?",
    logout: "Sair",
    mileageLabel: "Quilometragem",
    mileagePh: "km no painel",
    montageShort: "Montagem",
    noChantiers: "Nenhum chantier cadastrado — o escritório cria em Chantiers.",
    noResults: "Nenhum carro com essa placa nesta empresa.",
    noTechWarning:
      "Nenhum técnico assumiu este carro no portal. Se registrar a entrega agora, o carro fecha sem técnico e o escritório terá de lançar o técnico no dossier.",
    notManagerNote: "Sua conta não tem papel de gerente de projeto em nenhuma empresa.",
    notesPh: "Observações…",
    openGestion: "Abrir o Gestion",
    photosDelivery: "Entrega",
    photosDemontage: "Desmontagem",
    photosMontageEnd: "Fim do trabalho",
    photosReception: "Recepção",
    recMissCiel: "responder o forro do teto",
    recMissPareBrise: "responder o pára-brisa",
    recMissPhoto: "foto",
    recMissPhotoCiel: "foto do forro do teto",
    recMissPhotoPareBrise: "foto do pára-brisa",
    recMissPhotos: "fotos",
    recMissSignature: "assinatura do cliente",
    recMissingPre: "Falta na recepção:",
    receptionTitle: "Recepção do veículo",
    remiseCheckPre: "Remise do cliente (cadastro):",
    remiseCheckSuf: "— confira na recepção.",
    repasseByDelivery: "O carro entra no mês em que você registra a ENTREGA dele no portal.",
    repasseEmpty:
      "Nenhuma entrega registrada neste mês (ou comissão ainda não configurada pelo escritório).",
    repasseParticular: "Particular",
    repassePro: "Profissional",
    repasseTitle: "Meu repasse do mês",
    repasseTotal: "Total",
    reservesLabel: "Ressalvas da entrega",
    saveBtn: "Salvar",
    saved: "✓ Check-list salvo.",
    savingBtn: "Salvando…",
    scanFail: "Não consegui ler na foto — aproxime, evite reflexo e tente de novo, ou digite.",
    scanning: "Lendo a foto…",
    searchBtn: "Buscar",
    searching: "Buscando…",
    serviceDemontage: "Desmontagem",
    serviceMontage: "Montagem",
    servicePdrLabel: "PDR",
    servicesTitle: "Serviços deste carro",
    showPhotosBtn: "Ver fotos",
    statusArrived: "recebido",
    statusDone: "concluído",
    statusScheduled: "agendado",
    stepBlockedHint:
      "O técnico não consegue assumir este carro enquanto a recepção não estiver completa.",
    stepDelivered: "carro entregue.",
    stepDoDelivery: "fazer a entrega e o controle do trabalho.",
    stepInRepair: "reparo em andamento.",
    stepNextPre: "Próximo passo:",
    stepNotReceived: "Veículo ainda não recebido",
    stepReceptionIncomplete: "Recepção incompleta",
    stepReleased: "Carro liberado para o reparo",
    stepWaitingTechnician: "aguardando um técnico assumir.",
    title: "Chantier",
    undeliveredPre: "carro(s) já faturado(s) sem entrega registrada —",
    undeliveredSuf: "de comissão esperando o registro. Registre a entrega para receber.",
    workOkNo: "Trabalho com ressalvas",
    workOkToggle: "Trabalho conferido e aprovado",
    workOkYes: "Trabalho aprovado",
  },
  chantiers: {
    commBase: "Base",
    commBaseFaturado: "Faturado (Total Facture)",
    commBaseOrcamento: "Orçamento (Prix Brut)",
    commClientPct: "% Remise cliente",
    commHint:
      "Vale para TODOS os técnicos × clientes deste chantier (pro ou particular) que não tenham par específico — o par técnico×cliente, quando existir, vence.",
    commIntermediary: "Intermediário",
    commIntermediaryNone: "— sem intermediário —",
    commIntermediaryPct: "% Intermediário",
    commPct: "% Técnico",
    commTitle: "Comissão do chantier (default)",
    customersWord: "clientes",
    detailAgendaEmpty: "Nada agendado.",
    detailAgendaTitle: "Agenda (próximos dias)",
    detailAgendaWord: "agendados",
    detailCarsEmpty: "Nenhum veículo ainda (entram pelos devis/faturas dos clientes vinculados).",
    detailCarsTitle: "Veículos / dossiers",
    detailCarsWord: "carros",
    detailCustomersEmpty: "Nenhum cliente vinculado — vincule no cadastro de Clientes.",
    detailCustomersTitle: "Clientes do chantier",
    detailDevisWord: "devis a executar",
    devisChip: "devis",
    editBtn: "Editar",
    editTitle: "Editar chantier",
    empty:
      "Nenhum chantier ainda. Crie o primeiro e vincule os clientes a ele no cadastro de Clientes.",
    fieldActive: "Ativo",
    fieldAddress: "Endereço",
    fieldCity: "Cidade",
    fieldEnd: "Fim",
    fieldName: "Nome",
    fieldNotes: "Observações",
    fieldPostal: "Código postal",
    fieldStart: "Início",
    inactiveWord: "inativo",
    managerAdd: "Vincular",
    managerHint:
      "Comissão sobre PDR + dégarnissage, base devis HT (pós-franquia), paga pela parte da casa.",
    managerNoCandidates:
      "Nenhum usuário com papel gerente nesta empresa — crie a conta em Usuários primeiro.",
    managerPartShort: "Particular",
    managerPick: "Escolher usuário (papel gerente)…",
    managerProShort: "Pro",
    managerRemove: "Remover",
    managerTitle: "Responsável do chantier",
    newBtn: "Novo chantier",
    openBtn: "Abrir",
    saveBtn: "Salvar",
    subtitle:
      "Locais de trabalho — clientes são vinculados a um chantier no cadastro (como no eDSP).",
    title: "Chantiers",
  },
  clientPortal: {
    bookBtn: "Agendar",
    bookTitle: "Agendar veículo",
    created: "✓ Veículo agendado.",
    dateLabel: "Dia",
    logout: "Sair",
    myBookingsEmpty: "Nenhum agendamento ainda.",
    myBookingsTitle: "Meus agendamentos",
    notClientNote: "Sua conta não tem papel de cliente em nenhuma empresa.",
    notLinkedNote: "⚠ Conta ainda não vinculada a um cliente/chantier — fale com o escritório.",
    occupancyEmpty: "Agenda livre nos próximos 30 dias.",
    occupancySuffix: "veículo(s) agendado(s) no dia",
    occupancyTitle: "Ocupação do chantier (30 dias)",
    plateLabel: "Placa",
    statusArrived: "recebido",
    statusDone: "concluído",
    statusScheduled: "agendado",
    svcMontage: "Montagem",
    svcPeinture: "Pintura",
    svcPieces: "Peças",
    timeLabel: "Horário",
    title: "Agenda",
    vehicleLabel: "Veículo (opcional)",
    vehiclePh: "Ex.: Renault Clio cinza",
  },
  commissionCascade: {
    rowClient: "Cliente",
    rowIntermediary: "Interm.",
    rowMontage: "Montagem",
    rowTech: "Téc",
  },
  companies: {
    addrCity: "Cidade",
    addrCountry: "País",
    addrPostal: "CEP / Code postal",
    addrStreet: "Endereço (rua)",
    bankAccountsLink: "Contas bancárias",
    capitalSocial: "Capital social (€)",
    codeApe: "Código APE",
    dataSaved: "Dados salvos.",
    descEmphasis: "emissor",
    descMid:
      " que aparecem na fatura (razão social, SIREN/SIRET, código APE, capital social, nº TVA, endereço). Dados bancários (IBAN/BIC) ficam em ",
    descPre: "Dados fiscais do ",
    fiscalIdOther: "ID fiscal (outro)",
    institutionalEmail: "Email institucional",
    legalName: "Razão social",
    loading: "Carregando…",
    logoAlt: "Logo da empresa",
    logoHintPre: "Clique em ",
    logoHintSuf: " para aplicar. SVG não é suportado.",
    logoLabel: "Logo na fatura (PNG ou JPEG)",
    logoUploaded: "Logo enviado — clique em Salvar para aplicar.",
    noCompanies: "Nenhuma empresa acessível.",
    noLogo: "sem logo",
    pageSubtitle: "Dados que saem no cabeçalho e no rodapé das suas faturas.",
    removeLogo: "remover logo",
    save: "Salvar",
    saving: "Salvando…",
    secContact: "Contacto da empresa",
    secContactDesc: "Esta informação aparece nos documentos.",
    secIdentity: "Nome e endereço",
    secLegal: "Informações legais",
    secLegalDesc: "Dados obrigatórios usados nos documentos.",
    siren: "SIREN (9 díg)",
    siret: "SIRET (14 díg)",
    title: "Minha empresa",
    tradeName: "Nome comercial",
    uploadFailed: "Falha no upload",
    uploading: "Enviando…",
    vatNumber: "Nº TVA",
  },
  comparisonTable: {
    colAnnualized: "Anualizado",
    colBudget: "Budget",
    colExercice: "Exercício",
    colRubrique: "Rubrica",
    colVarianceEur: "Variação (€)",
    colVariancePct: "Variação (%)",
  },
  creditNoteDoc: {
    cancel: "Cancelar",
    emailBtn: "E-mail",
    emailTitle: "Enviar o avoir por e-mail",
    messageLabel: "Mensagem (opcional)",
    messagePlaceholder: "Vazio = texto padrão em francês com o avoir anexado.",
    pdfTitle: "Baixar o PDF do avoir",
    sendBtn: "Enviar",
    sentTitle: "Avoir enviado",
    toLabel: "Para (e-mail do cliente)",
  },
  customerCredit: {
    amountLabel: "Valor a abater (TTC)",
    available: "disponível",
    balanceWord: "saldo",
    cancel: "Cancelar",
    cardHint:
      "Sobra de depósito que pagou mais do que as faturas. Abater numa fatura cria um recebimento ligado ao mesmo depósito; desfazer a conciliação do depósito desfaz o crédito e o que foi abatido.",
    cardTitle: "Crédito do cliente",
    comboCitedOut: "O motivo da transferência cita",
    comboCitedOutSuf: "que fica de fora (provável erro de número).",
    comboMid: "somam exatamente",
    comboPre: "💡 Combinação exata:",
    comboUse: "Usar estas faturas",
    confirmUse: "Abater",
    errNone: "Não há crédito disponível.",
    errNotOpen: "Esta fatura não está em aberto.",
    invoicePanelBtn: "Abater nesta fatura",
    invoicePanelPre: "Crédito do cliente disponível:",
    noOpenInvoices: "Nenhuma fatura em aberto deste cliente.",
    originPre: "Sobra do depósito de",
    pickInvoice: "Fatura em aberto",
    surplusNoCredit: "faturas de clientes diferentes: a sobra não vira crédito",
    surplusToCredit: "→ vira crédito do cliente",
    useBtn: "Abater numa fatura",
    usedOk: "Crédito abatido:",
    usedOn: "em",
    usedPre: "usado",
  },
  customerDetail: {
    activeValue: "ativo",
    auditRequiresAdmin: "Audit log requer permissão admin.",
    avgDaysToPayment: "Dias médios pagamento",
    avgTicket: "Ticket médio",
    backLink: "Lista",
    backToList: "Voltar à lista",
    carsWordShort: "carros",
    colAction: "Ação",
    colAmount: "Valor",
    colBy: "Por",
    colCode: "Código",
    colDate: "Data",
    colDossier: "Dossier",
    colDueDate: "Vencimento",
    colInvoice: "Fatura",
    colInvoiceNumber: "N° fatura",
    colIssued: "Emitida",
    colMethod: "Método",
    colPlate: "Plate",
    colReason: "Motivo",
    colReference: "Referência",
    colRetention: "Retenção",
    colSituation: "Situação",
    colTotalHt: "Total HT",
    colVehicle: "Veículo",
    colWhen: "Quando",
    colorLabel: "Cor",
    consolidatedHint: "Fatura de vários carros (consolidada)",
    consolidatedPre: "Fatura consolidada ·",
    contactAddBtn: "Adicionar contato",
    contactCancelBtn: "Cancelar",
    contactEditBtn: "editar",
    contactName: "Nome",
    contactNotes: "Observação",
    contactReceivesInvoices: "recebe faturas",
    contactReceivesInvoicesLong: "Recebe as faturas (sugerido primeiro no envio por e-mail)",
    contactRemoveBtn: "remover",
    contactRemoveTitle: "Remover este contato?",
    contactRole: "Função",
    contactRolePh: "Ex.: contabilidade, chefe de oficina",
    contactSaveBtn: "Salvar contato",
    contactsEmpty: "Nenhum contato cadastrado.",
    contactsTitle: "Contatos",
    country: "País",
    customerAuditLog: "Audit log do cliente",
    customerDossiers: "Dossiers do cliente",
    customerInvoices: "Faturas do cliente",
    customerNotFound: "Cliente não encontrado nas empresas acessíveis.",
    customerReceipts: "Recebimentos do cliente",
    dayAbbr: "d",
    daysUnit: "dias",
    editBtn: "Modificar",
    email: "E-mail",
    emptyAudit: "Nenhum evento.",
    emptyDossiers: "Nenhum dossier nesta janela.",
    emptyInvoices: "Nenhuma fatura nesta janela.",
    emptyReceipts: "Nenhum recebimento nesta janela.",
    emptyVehicles: "Nenhum veículo cadastrado para este cliente.",
    fiscalId: "Fiscal ID",
    inactiveValue: "inativo",
    invalidId: "ID inválido.",
    invoicedHt: "Faturado HT",
    invoicesIssuedPaid: "Faturas (emitidas + pagas)",
    language: "Idioma",
    loading: "Carregando…",
    openBalance: "Saldo aberto",
    openBtn: "abrir",
    openInvoiceTitle: "Abrir a fatura",
    overdueBalance: "Saldo em atraso",
    overdueInvoices: "Faturas em atraso",
    paymentTerm: "Prazo de pagamento",
    period12m: "Últimos 12 meses",
    period30d: "Últimos 30 dias",
    period3m: "Últimos 3 meses",
    period6m: "Últimos 6 meses",
    periodAll: "Tudo",
    periodSelectorLabel: "Janela:",
    periodSince: "Desde 01/05/2026 (início do Gestion)",
    periodYear: "Ano atual",
    phone: "Telefone",
    receivedOnPre: "recebida em",
    registeredVehicles: "Veículos cadastrados",
    reversalBadge: "estorno",
    sectionFinancial: "Financeiro",
    sectionOperational: "Operacional",
    sectionRecord: "Cadastro",
    seeInCarros: "Ver em Carros ↗",
    stageAll: "Todos",
    stageHint:
      "Etapa escolhida: mostra todos os dossiers nessa situação hoje, sem a janela de datas.",
    stageReceived: "Recebido",
    stageToday: "Situação dos carros hoje",
    statementBtn: "📄 Relevé de compte",
    statusCancelled: "cancelada",
    statusIssued: "emitida",
    statusLabel: "Status",
    statusPaid: "recebida",
    statusPending: "pendente",
    statusUncollectible: "Irrecuperável",
    statusVoid: "anulada",
    stmtClose: "Fechar",
    stmtClosing: "Saldo final (TTC)",
    stmtCredit: "Crédito disponível",
    stmtErrorTitle: "Não foi possível",
    stmtFrom: "De",
    stmtMessage: "Mensagem do e-mail",
    stmtModeOpen: "Em aberto hoje",
    stmtModePeriod: "Extrato por período",
    stmtMovements: "Movimentos no período",
    stmtNoEmail: "O cliente não tem e-mail cadastrado: digite um endereço.",
    stmtOpenInvoices: "Faturas em aberto",
    stmtOpening: "Saldo anterior",
    stmtOverdue: "das quais vencidas",
    stmtPdfBtn: "📄 Abrir o PDF",
    stmtRecipient: "Enviar para",
    stmtSendBtn: "✉ Enviar por e-mail",
    stmtSentMsg: "O relevé de compte foi enviado para",
    stmtSentTitle: "Relevé enviado",
    stmtTitle: "Relevé de compte",
    stmtTo: "Até",
    stmtToPay: "Saldo a pagar (TTC)",
    stmtTotalOpen: "Total em aberto (TTC)",
    tabAudit: "Auditoria",
    tabDossiers: "Dossiers",
    tabFaturas: "Faturas",
    tabRecebimentos: "Recebimentos",
    tabResumo: "Resumo",
    tabVeiculos: "Veículos",
    tabWorklog: "Worklog por ateliê",
    total: "total",
    totalCredited: "Avoirs emitidos",
    totalIssued: "Total emitido",
    totalReceived: "Total recebido",
    totalRetention: "Retenção total",
    wlColFacture: "Líquido HT (após remise)",
    wlColLines: "Prestações · técnico",
    wlColStatus: "Situação",
    wlLineDepose: "Desmontagem",
    wlLineEnCours: "em andamento",
    wlLinePdr: "PDR",
    wlLineRepose: "Montagem",
    wlLineTiers: "terceiro (garage)",
    wlNoAtelier: "sem ateliê",
    wlNoDemontage: "desmontagem não lançada",
    wlNoDemontageHint:
      "O devis tem desmontagem/montagem, mas ninguém lançou esse serviço — ele fica fora da fatura até ser lançado.",
    wlSelectHint: "Toque num status para incluir ou tirar do worklog (tela, PDF e e-mail).",
    wlSentScopePre: "PDF e e-mail ao cliente:",
    wlSentScopeSuf: "reparados, em reparação e faturados (só os devis sem técnico ficam de fora)",
    wlShowAll: "Mostrar todos",
    wlStatusDevis: "Devis",
    wlStatusEmReparacao: "Em reparação",
    wlStatusFacture: "Faturado",
    wlStatusRepare: "Reparado",
    wlValorDevis: "Valor do devis HT",
    wlValorFacture: "Após remise do cliente (HT)",
    wlValorFactureHint:
      "Só super admin. Valor que a fatura cobra (ou cobrará): devis menos remise e franquia. Carro sem prestação lançada aparece com — e fica fora do total.",
    wlValorLabel: "Valores",
    worklogAllAteliers: "— todos os ateliês —",
    worklogAtelier: "Ateliê",
    worklogBadPeriod: "A data inicial é depois da final.",
    worklogCarsWord: "carro(s)",
    worklogChooseAtelier: "— escolher o ateliê —",
    worklogColAtelier: "Ateliê",
    worklogColDate: "Data",
    worklogColDevis: "Total do devis HT",
    worklogColPlate: "Placa / VIN",
    worklogColTech: "Técnico do PDR",
    worklogColVehicle: "Veículo",
    worklogEmailBtn: "Enviar ao cliente",
    worklogEmailLabel: "E-mail do cliente",
    worklogEmpty: "Nenhum carro neste ateliê no período.",
    worklogFrom: "De",
    worklogHint:
      "Todos os carros feitos no ateliê, por todos os técnicos, no período: as linhas PDR / desmontagem / montagem com o técnico e o valor de cada uma. O PDF sai em francês para o cliente.",
    worklogNoAtelier: "Este cliente não tem ateliê cadastrado.",
    worklogPdfBtn: "Baixar PDF",
    worklogSentPre: "Worklog enviado para",
    worklogTitle: "Worklog por ateliê",
    worklogTo: "Até",
  },
  customerReview: {
    badge: "a revisar",
    bannerPre: "Cliente do eDSP a revisar.",
    cancel: "Cancelar",
    chantierLabel: "Chantier",
    chantierNone: "— sem chantier —",
    chip: "A revisar",
    confirm: "✓ Confirmar",
    doneCarsPre: "Carros refeitos:",
    doneMsg: "Cliente confirmado.",
    errRemise: "Informe a remise do cliente profissional (0 % é aceito).",
    homeAction: "Revisar",
    homeCarsWord: "carro(s) em andamento",
    homeTitle: "Clientes do eDSP a revisar",
    intro:
      "As listas do eDSP não trazem tipo, SIRET nem TVA. Confira o tipo, a remise e o chantier; o Gestion já sugeriu o tipo.",
    kindBusiness: "Profissional",
    kindBusinessHint: "Informe a remise (0 % é aceito). A franquia reduz a fatura e a comissão.",
    kindIndividual: "Particular",
    kindIndividualHint: "Remise 0 %. A franquia não reduz a fatura, só a comissão do técnico.",
    openCarsHint: "se algo mudar, a remise e a franquia deles são refeitas.",
    openCarsPre: "Carros ainda sem fatura:",
    openRecord: "Abrir ficha",
    proMissingRemise:
      "Profissional sem remise: sem ela, o Gestion não calcula a comissão dos técnicos em base devis. Informe a remise (0 % é aceito).",
    reasonIndefinido: "o nome não dá pista, confira",
    reasonNomeEmpresa: "nome de empresa",
    reasonNomePessoa: "nome de pessoa",
    reasonSiretTva: "tem SIRET ou TVA",
    remiseLabel: "Remise do cliente (%)",
    reviewBtn: "Revisar",
    suggestionPre: "Sugestão do Gestion:",
    title: "Revisar cliente do eDSP",
  },
  customers: {
    appliesTvaLabel: "Aplica TVA (desmarque para autoliquidação intra-UE)",
    atelierAddBtn: "Adicionar ateliê",
    atelierAliasesPh: "Nomes no eDSP, separados por vírgula (ex.: REPARE GRELE P2)",
    atelierCityPh: "Cidade (opcional)",
    atelierNamePh: "Nome do ateliê (ex.: Julien)",
    atelierRemiseCustomer: "remise do cadastro",
    atelierRemiseLabel: "remise",
    atelierRemisePh: "Remise % (opcional)",
    atelierSaveBtn: "Salvar",
    ateliersHelp:
      "Locais deste cliente onde os carros são reparados (ex.: Julien, Garage Peugeot St Alexandre). O técnico escolhe o ateliê ao importar o devis.",
    ateliersTitle: "Ateliês / locais de serviço",
    badgeActive: "ativo",
    badgeInactive: "inativo",
    badgeInsurer: "Seguradora",
    badgePart: "PF",
    badgeProf: "Prof.",
    cancel: "Cancelar",
    chantierHint:
      "Vincula o cliente a um chantier (os carros dele aparecem no portal do gerente daquele chantier).",
    chantierNone: "— nenhum —",
    close: "Fechar",
    colActions: "Ações",
    colCountry: "País",
    colEmail: "E-mail",
    colFiscalId: "Fiscal ID",
    colName: "Nome",
    colStatus: "Status",
    colType: "Tipo",
    commissionHelp:
      "Comissão padrão retida pelo cliente. Aplicada em base ORÇAMENTO ao criar dossier (editável por dossier).",
    commissionRangeError: "% Comissão deve ser entre 0 e 100.",
    companyLabel: "Empresa",
    create: "Criar",
    customerPlural: "clientes",
    customerSingular: "cliente",
    deactivate: "Desativar",
    deactivateMessage:
      "Cliente inativo não aparece em novas faturas. Faturas existentes não são afetadas.",
    deactivatePlaceholder: "Ex: cliente encerrou contrato",
    deactivateTitlePre: "Desativar cliente",
    editLink: "editar",
    editTitle: "Editar cliente",
    emptyState: "Nenhum cliente encontrado.",
    fieldBillingEmail: "E-mail de cobrança",
    fieldChantier: "Chantier",
    fieldCommission: "% Comissão (retenção do cliente)",
    fieldCountry: "País (ISO-2)",
    fieldDisplayName: "Nome (UI)",
    fieldEmail: "E-mail (geral)",
    fieldFiscalIdKind: "Tipo do Fiscal ID",
    fieldLegalName: "Razão social (PJ)",
    fieldManagerPct: "Comissão do gerente do chantier neste cliente (%)",
    fieldNotes: "Notas",
    fieldPaymentTerm: "Prazo de pagamento (dias)",
    fieldPhone: "Telefone",
    fieldPortalUser: "Conta do portal (cliente)",
    fieldPreferredLang: "Idioma preferido",
    fieldReason: "Motivo da alteração do Fiscal ID",
    fieldTvaOnInvoice: "TVA na fatura",
    fieldVatNumber: "N° VAT · TVA · USt-IdNr. · IVA (intracomunitário)",
    fiscalAdminOnly: "Apenas administradores editam o ID fiscal.",
    fiscalKindOther: "Outro",
    fiscalKindVatEu: "VAT (outro país UE)",
    franchiseRequiredHelp:
      "Cliente particular sempre exige, independente desta opção. O valor é digitado por veículo na recepção e fica congelado nele.",
    franchiseRequiredLabel: "Franquia na recepção",
    franchiseRequiredToggle: "Exigir informação de franquia na recepção",
    kindBusiness: "Profissional",
    kindIndividual: "Particular",
    kindInsurer: "Seguradora",
    loading: "Carregando…",
    managerPctHint:
      "Vazio = o % do cadastro do gerente (profissional ou particular). Preencha só para uma exceção deste cliente; sai da parte da empresa.",
    managerPctPlaceholder: "padrão do chantier",
    newBtn: "Novo cliente",
    next: "Próxima",
    noAccess: "Você não tem acesso a nenhuma empresa.",
    openLink: "abrir",
    pageMid: "de",
    pagePre: "Página",
    parcCarsHelp:
      "Categorias com valor fixo (cliente, débosselage, montagem). No portal, quando o carro não tem devis, o técnico escolhe a categoria e informa marca e modelo.",
    parcCarsTitle: "Carros de parc",
    parcClosed: "fechado",
    parcDefaultName: "Carros de parc",
    parcEditCategories: "Configurar categorias",
    parcEnableBtn: "Ativar carros de parc",
    parcOpen: "aberto",
    placeholderEx20: "ex: 20",
    placeholderEx30: "ex: 30",
    portalUserHint:
      "Vincula uma conta com papel 'Cliente (portal)' — ela vê a agenda do chantier deste cliente e agenda veículos.",
    portalUserNone: "— nenhuma —",
    prev: "Anterior",
    proLooksIndividual:
      "Profissional sem SIRET, sem TVA e sem remise: parece um particular? Se for pessoa física, escolha Particular (remise 0 %). Sem remise, o Gestion não calcula a comissão dos técnicos em base orçamento para este cliente.",
    purgeBtn: "excluir",
    purgeBtnTitle:
      "Excluir o cliente com seus dossiers VIRGENS e veículos (só super admin; bloqueado se houver fatura/linha/proforma)",
    purgeConfirmMsg:
      "Isto exclui o cliente, os dossiers dele SEM movimento (sem linha, fatura, proforma ou compra) e os veículos sem outros dossiers. Se houver qualquer movimento, nada é excluído. Feito para desfazer um import na empresa errada. Continuar?",
    purgeDoneDossiers: "dossier(s) excluído(s)",
    purgeDoneTitle: "Cliente excluído",
    purgeDoneVehicles: "veículo(s) excluído(s)",
    purgeReasonPlaceholder: "Ex.: import de devis feito na empresa errada",
    purgeReasonTitle: "Motivo da exclusão",
    purgeTitle: "Excluir cliente",
    reactivate: "Reativar",
    reasonPlaceholder: "Obrigatório ao alterar dados fiscais",
    save: "Salvar",
    saving: "Salvando…",
    searchLabel: "Buscar",
    searchPlaceholder: "Nome, email, fiscal id…",
    statusActive: "Ativos",
    statusAll: "Todos",
    statusInactive: "Inativos",
    statusLabel: "Status",
    totalLabel: "Total",
    tvaExemptOption: "Isento / fora do campo de aplicação",
    tvaHelpApplies: "Alíquota aplicada na fatura (ex: 20% débosselage FR).",
    tvaHelpExempt: "Isento / fora do campo: TVA 0%, sem menção de autoliquidação.",
    tvaHelpReverse:
      "Autoliquidação: TVA 0% + menção legal na fatura (TVA devida pelo destinatário, intra-UE B2B). Ex.: Brazilian Storms OÜ → Euro Storm.",
    tvaReverseChargeOption: "Autoliquidação (reverse-charge, intra-UE B2B)",
    typeAll: "Todos os tipos",
    typeLabel: "Tipo",
  },
  dashboard: {
    accessBtn: "Acessar",
    actionInformFranchise: "Informar a franquia",
    actionInvoiceNow: "Faturar agora",
    allCaughtUp: "Tudo em dia",
    amendedInvoicesSub: "O devis mudou depois da emissão; a fatura foi refeita no mesmo número",
    amendedInvoicesSuf: "faturas modificadas — reenviar ao cliente",
    awaitingReconciliationSuf: "transações aguardam conciliação",
    bankReconciliation: "Reconciliação bancária",
    bankStatement: "Extrato bancário",
    carWord: "carro",
    cardFranchise: "Franquia não informada",
    cardToInvoice: "Veículos a faturar",
    carsWord: "carros",
    chantierNoEnd: "sem data de fim",
    chantierStartsPre: "Começa",
    chantierUntilPre: "até",
    chantiersBarHint: "Barra = carros entregues sobre o total do chantier.",
    chantiersEmpty: "Nenhum chantier ativo.",
    chantiersTitle: "Chantiers em curso",
    chipAll: "Todos",
    chipPending: "Pendentes",
    chipToInvoice: "A faturar",
    colDate: "Data",
    colGarage: "Garagem",
    colGross: "Bruto",
    colProfit: "Benefício",
    colRef: "Ref.",
    colStatus: "Status",
    colTechnician: "Técnico",
    colVehicle: "Veículo",
    commissionsNotComputed: "comissões não computadas",
    degarnHint:
      "Carros já reparados (PDR finalizado) com o dégarnissage do devis sem lançamento ou não concluído. Sem lançamento, o valor do dégarnissage fica fora da fatura e do pagamento do técnico.",
    degarnNoLine: "sem lançamento",
    degarnOpen: "não concluído",
    degarnOpenList: "Ver os carros",
    degarnOutOfInvoicePre: "fora da fatura:",
    degarnTitle: "Dégarnissage não finalizado",
    degarnTotalPre: "Dégarnissage pendente no devis:",
    dossiersCommissionsSuf: "dossiers — comissões",
    dossiersPayoutTechnicianSuf: "dossiers — repassar ao técnico",
    dossiersSuf: "dossiers",
    einvoiceLine: "Recepção via PDP: desde 01/09/2026 · Emissão obrigatória (ES): 01/09/2027",
    emptyDossiers: "Nenhum dossier",
    feedClaim: "Carro assumido no portal",
    feedCreditNote: "Avoir criado",
    feedDelivery: "Entrega registrada",
    feedDerogation: "Derrogação aplicada",
    feedDevisEdit: "Devis modificado",
    feedDevisImport: "Devis importado pelo portal",
    feedDocUpload: "Documento da recepção enviado",
    feedEmailSent: "E-mail enviado",
    feedEmpty: "Nada registrado hoje ainda.",
    feedInvoiceCancelled: "Fatura cancelada",
    feedInvoiceIssued: "Fatura emitida",
    feedInvoiceReissued: "Fatura reemitida",
    feedMarkPaid: "Pagamento marcado",
    feedOfficeLaunch: "Técnico lançado pelo escritório",
    feedReception: "Recepção registrada",
    feedTitle: "Entrou hoje",
    feedWiseFail: "Sincronização Wise falhou",
    feedWiseOk: "Extrato Wise sincronizado",
    feedWorkOk: "trabalho aprovado",
    feedWorkReserves: "com ressalvas",
    filters: "Filtros",
    fiscalYearLabel: "exercício",
    greetingAfternoon: "Boa tarde",
    greetingEvening: "Boa noite",
    greetingMorning: "Bom dia",
    importEdsp: "Importar eDSP",
    inFiscalYear: "no exercício",
    invoicedMinusCommissionsPre: "faturado − comissões",
    itemsSuf: "itens",
    kpiGrossProfit: "Lucro bruto",
    kpiOpenDossiers: "Dossiers abertos",
    kpiReceivable: "A receber",
    kpiReceived: "Já recebido",
    kpiRevenue: "Faturamento (exercício)",
    kpiTechPayouts: "A repassar aos técnicos",
    moreCustomersSuf: "outros clientes",
    needsYouTitle: "Precisa de você",
    newDossier: "Novo carro",
    nothingPending: "Nada pendente",
    nothingPendingLine: "Nada pendente.",
    ofInvoiced: "do faturado",
    open: "Abrir",
    openInvoicesSuf: "faturas em aberto",
    overdue: "Em atraso",
    overdueInvoices: "Faturas em atraso",
    overdueSuf: "vencidos",
    payableTechnicians: "A pagar (técnicos)",
    pendingCustomerAction: "Confirmar na ficha do carro",
    pendingCustomerTitle: "Cliente do devis mudou",
    pendingPlural: "pendências",
    pendingSingular: "pendência",
    period12m: "12 m",
    periodMonth: "Mês",
    periodYear: "Exercício",
    receivableCustomers: "A receber (clientes)",
    receivedToPaySuf: "recebido, a pagar",
    recentDossiers: "Dossiers recentes",
    reconciledSuf: "conciliadas",
    statusInvoiced: "Faturado",
    statusPending: "Pendente",
    statusReview: "Revisão",
    supplierInvoicesSuf: "faturas fornecedores",
    techApplicationsHint: "aguardando sua aprovação",
    techApplicationsOneSuf: "candidatura de técnico",
    techApplicationsSuf: "candidaturas de técnico",
    techPayoutsBlockedHint: "aguardando o cliente pagar",
    techPayoutsEmpty: "Nenhum técnico a pagar",
    techPayoutsOthersPre: "+",
    techPayoutsOthersSuf: "outros técnicos",
    techPayoutsPayNow: "em caixa — pagar agora",
    techPayoutsReleasedHint: "recebido do cliente — liberado",
    techPayoutsTechCountSuf: "técnicos a pagar",
    techPayoutsTechCountSufSingular: "técnico a pagar",
    tileActiveChantiers: "Chantiers ativos",
    tileOpenCars: "Carros em aberto",
    tilePendingDeliveries: "Entregas pendentes",
    tileToInvoice: "A faturar · HT",
    tilesAria: "Indicadores",
    title: "Painel",
    toInvoice: "a faturar",
    toInvoiceMoreCustomers: "outro(s) cliente(s)",
    toInvoiceSeeAll: "Ver todos",
    toInvoiceShowLess: "Mostrar menos",
    toInvoiceTitle: "Há carros a faturar",
    toPaySuf: "a pagar",
    todoTitle: "A fazer",
    treasuryTitle: "Tesouraria",
    unreconciledTxSuf: "transações não conciliadas",
    unsentCardAction: "Enviar",
    unsentCardTitle: "Faturas não enviadas",
    viewAll: "Ver todos",
    weekPre: "semana",
  },
  devisPage: {
    colCustomer: "Cliente",
    colDevis: "Nº do devis",
    colImpacts: "Impactos",
    colStage: "Situação",
    colTotal: "Total HT",
    colVehicle: "Veículo",
    countSuffix: "devis",
    empty: "Nenhum devis com esses filtros.",
    filterSearch: "Buscar",
    filterStage: "Etapa",
    pageTitle: "Devis",
    searchPlaceholder: "Cliente, placa ou nº do devis…",
    stageAll: "Todos",
    stageDevis: "Orçado",
    stageInvoiced: "Faturado",
    stageRepairing: "Em reparação",
    withDegarnissage: "com desmontagem",
  },
  dossierDetail: {
    activityBadge: "Atividade · 100% casa",
    activityCost: "Custo (HT)",
    activityMargin: "Margem",
    activityTypeLabel: "Tipo de atividade",
    addPaymentBtn: "+ Pagamento",
    addReceiptBtn: "+ Recebimento",
    addServiceLineTitle: "Adicionar linha de serviço",
    amountEuro: "Valor (€)",
    amountMustBePositive: "Valor deve ser > 0.",
    amountPositiveShort: "Valor > 0.",
    appliedLabel: "Aplicado",
    approveInvoice: "aprovar fatura",
    approveLower: "aprovar",
    auditLogTitle: "Audit log do dossier",
    auditRequiresAdmin: "Audit log requer permissão admin.",
    autoCalculatedTitle: "Calculado automaticamente",
    avoirBtn: "Avoir",
    avoirBtnTitle:
      "Fazer um avoir (nota de crédito) sobre esta fatura: completo ou parcial, com motivo",
    avoirCancelledTag: "anulado",
    avoirEmbeddedTag: "já descontado na fatura",
    avoirWord: "Avoir",
    avoirsEffective: "Avoirs (a casa absorve)",
    avoirsLabel: "Avoirs",
    avoirsNotePre: "Avoirs deste carro, descontados do lucro da casa:",
    avoirsSplit: "rateado entre os carros da fatura",
    backShort: "← Lista",
    backToList: "← Voltar à lista",
    balance: "Saldo",
    bankAccountOptional: "Conta bancária (opcional)",
    base: "Base",
    baseAfterFranchise: "Base após franquia",
    baseBudget: "Orçamento (Prix Brut)",
    baseInvoiced: "Faturado (Total Facture)",
    bruteCheck: "Conferência do bruto",
    calcAndPromote: "Calcular e promover",
    calcBase: "Base de cálculo",
    calcCommissionBtn: "⚠ Calcular comissão",
    calcCommissionTitle:
      "Linha sem cascade calculada — clique para definir % cliente/técnico/intermediário",
    calcLineCommissionTitle: "⚠ Calcular comissão da linha",
    cancel: "Cancelar",
    cancelIcTitle: "Cancelar IC",
    cancelInvoiceMsg: "Cancela com efeito fiscal. Reversível via reissue.",
    cancelInvoiceTitle: "Cancelar fatura",
    cancelLineBtn: "Cancelar linha",
    cancelLineMsg:
      "A linha sai da lista do técnico, do pagamento e da fatura dele, e o serviço sai da base da fatura do cliente (se a casa ainda deve cobrá-lo, lance outro técnico). Não se desfaz. Informe o motivo.",
    cancelLineTitle: "Cancelar a linha de serviço",
    cancelLower: "cancelar",
    cascadeClient: "Cliente",
    cascadeIntermediary: "Intermediário",
    cascadeTechnician: "Técnico",
    cascadeTitle: "Cascata de comissão",
    chantierDelivery: "Entrega",
    chantierDeliveryNa:
      "não se aplica fora de chantier (o carro conta como entregue ao ser faturado)",
    chantierFranchiseAmountPh: "Valor TTC",
    chantierFranchiseCancel: "Cancelar",
    chantierFranchiseEdit: "Corrigir",
    chantierFranchiseHas: "Este carro tem franquia",
    chantierFranchiseHint:
      "O desconto é recalculado do valor cheio do devis e fica no log de auditoria.",
    chantierFranchisePre: "Franquia a descontar:",
    chantierFranchisePreParticular: "Franquia (cliente particular):",
    chantierFranchiseReasonPh: "Motivo da correção (obrigatório)",
    chantierFranchiseSave: "Gravar franquia",
    chantierFranchiseSaving: "Gravando…",
    chantierFranchiseSuf: "— abater da fatura do cliente ou gerar um avoir.",
    chantierFranchiseSufParticular:
      "— a fatura sai cheia; a franquia reduz só a base das comissões. Desconto ao cliente, só por avoir.",
    chantierNoFranchise: "Recepção sem franquia.",
    chantierPendingWord: "pendente",
    chantierReception: "Recepção",
    chantierSectionTitle: "Chantier (gerente de projeto)",
    chantierWorkOkNo: "⚠ Trabalho com ressalvas",
    chantierWorkOkYes: "✓ Trabalho conferido e aprovado",
    chgCustAtelier: "Ateliê",
    chgCustBlocked: "Não dá para trocar o cliente:",
    chgCustBtn: "Trocar cliente ou ateliê",
    chgCustChoose: "— escolher o cliente —",
    chgCustColInvoiced: "A faturar",
    chgCustColRemise: "Remise",
    chgCustColService: "Serviço",
    chgCustColTech: "Técnico",
    chgCustColTechAmount: "Técnico recebe",
    chgCustCurrent: "Cliente atual",
    chgCustDone: "Cliente trocado — linhas, franquia e ordem de reparação recalculadas.",
    chgCustImpact: "O que muda com o cliente novo",
    chgCustNew: "Novo cliente",
    chgCustNoAtelier: "— sem ateliê —",
    chgCustOnlyAtelier: "cliente atual (trocar só o ateliê)",
    chgCustReason: "Motivo (fica na auditoria)",
    chgCustSave: "Trocar cliente",
    chgCustSearchPh: "Buscar pelo nome…",
    chgCustTitle: "Trocar o cliente ou o ateliê do dossier",
    clientPctRange: "% Cliente deve ser entre 0 e 100.",
    clientRetainedPre: "Cliente reteve",
    colAction: "Ação",
    colBy: "Por",
    colReasonDetails: "Motivo / detalhes",
    colWhen: "Quando",
    commBlockProSemRemise:
      'Sem comissão: o cliente está cadastrado como Profissional sem remise. Defina a remise no cadastro do cliente ou, se for uma pessoa física, mude o tipo para Particular. Depois clique em "Calcular comissão".',
    commBlockSemPar:
      'Sem comissão: o técnico não tem par com este cliente (nem com o ateliê ou o chantier). Configure o par e clique em "Calcular comissão".',
    companyLabel: "Empresa",
    companyShort: "Emp",
    complementaryRequiresValues: "Modelo complementar exige orçamento e faturado preenchidos.",
    create: "Criar",
    createIcDraftBtn: "+ Criar IC draft",
    createIcDraftTitle: "Criar IC draft",
    createTechInvoicesFirst: "Crie faturas de técnico antes de registrar pagamentos.",
    createsNegativeMirror: "Cria espelho com valor negativo.",
    creating: "Criando…",
    customerEffective: "Cliente efetivo",
    customerInvoicesTitle: "Faturas para o cliente",
    customerPct: "Cliente pct",
    dateTime: "Data/hora",
    degarnAlertHint:
      'O carro conta como reparado (PDR finalizado), mas ninguém registrou quem desmontou e montou. Enquanto não for lançado, o valor do dégarnissage fica fora da fatura e do pagamento do técnico. Lance pelo portal (técnico ou montador, ou "feito pelo garage").',
    degarnAlertOpenHint:
      "O carro conta como reparado (PDR finalizado). O dégarnissage foi assumido, mas a desmontagem ou a montagem não foi marcada como feita. O valor já entra na fatura; falta concluir as etapas no portal.",
    degarnAlertTitle: "Dégarnissage não finalizado",
    degarnLaunchBtn: "👷 Lançar o dégarnissage",
    degarnLaunchTabHint: "O devis tem dégarnissage ainda sem registro completo.",
    degarnLaunchTitle: "Lançar o dégarnissage",
    deletedTitle: "Excluído",
    deliveryDerogBtn: "Marcar entregue (derrogação)",
    deliveryDerogConfirm: "Marcar entregue",
    deliveryDerogMessage:
      "O carro passa a 'entregue' sem a conferência do chantier. Informe o motivo (fica na auditoria).",
    deliveryDerogTitle: "Registrar a entrega sem as fotos do gerente",
    deposeReposeLabel: "Desmontar/Remontar",
    derogBtn: "Liberar reparo sem recepção",
    derogConfirm: "Confirmar liberação",
    derogHint: "Só super admin. Sem recepção, o carro fica sem franquia registrada.",
    derogNoReception:
      "Carro sem recepção: técnicos não conseguem assumir até a recepção ser feita. Em caso excepcional, libere aqui.",
    derogReasonPh: "Motivo (obrigatório — fica no histórico)",
    derogReleased: "Reparo liberado sem recepção",
    derogTitle: "Liberação do reparo",
    devisClassCol: "Classe",
    devisImpactsCol: "Impactos",
    devisMethodCol: "Método",
    devisNoteCol: "Observação",
    devisOriginalBtn: "PDF original",
    devisOriginalHint:
      "Abre o PDF do devis como foi recebido (portal do técnico, e-mail devis@ ou importação do escritório).",
    devisOriginalLatest: "mais nova",
    devisOriginalVersions: "versões",
    devisPanelCol: "Peça",
    devisSectionTitle: "Devis (eDSP)",
    downloadInvoicePdfTitle: "Baixar PDF da fatura",
    draftBannerOpen: "Abrir o rascunho",
    draftBannerPre: "Rascunho de fatura em espera (ainda não emitida)",
    draftBannerReplaces: "substitui a fatura cancelada",
    dueDate: "Vencimento",
    dueQuick15: "15 dias",
    dueQuick30: "30 dias",
    dueQuick60: "2 meses",
    dueQuick7: "1 semana",
    editActivityBtn: "Editar atividade",
    editActivityTitle: "Editar linha de atividade",
    editCommission: "Editar comissão",
    editDevisAddOther: "Outra parcela",
    editDevisAddPanel: "Adicionar peça",
    editDevisAmounts: "Valores",
    editDevisBlockedInvoice:
      "Fatura já emitida: não dá para lançar técnico neste carro. Para mudar valores, use Modificar devis (a fatura é refeita no mesmo número).",
    editDevisBtn: "Modificar devis",
    editDevisDoneCreated: "linha(s) criada(s)",
    editDevisDoneLines: "linha(s) recalculada(s)",
    editDevisDoneOr: "Ordem de reparação atualizada",
    editDevisDoneRemoved: "linha(s) removida(s)",
    editDevisDoneTitle: "Devis atualizado",
    editDevisDoneTotalPre: "Novo total HT:",
    editDevisHint:
      "O devis é o começo de tudo: ao guardar, as linhas de serviço, as comissões, a franquia e a ordem de reparação são recalculadas.",
    editDevisInvoiceAmended: "refeita no mesmo número",
    editDevisInvoiceConfirm:
      "Continuar? A fatura será refeita no mesmo número e ficará marcada para reenviar ao cliente.",
    editDevisInvoiceNote:
      "Este carro já tem fatura emitida. Ao guardar, a fatura é refeita no MESMO número e para o mesmo cliente; a versão anterior fica guardada e ela fica marcada para reenviar ao cliente.",
    editDevisInvoiceResend: "reenvie ao cliente",
    editDevisPanels: "Peças",
    editDevisReason: "Motivo da alteração",
    editDevisRemiseExc: "Remise exceptionnelle (HT)",
    editDevisRemiseExcHint:
      'Sai na fatura como "Remise exceptionnelle" e baixa o montante a faturar da ordem de reparação. Não muda as comissões.',
    editDevisSave: "Guardar e recalcular",
    editDevisTitle: "Modificar o devis",
    editLineCommissionTitle: "Editar comissão da linha",
    edspNonBank: "eDSP · não bancário",
    edspReceiptTitle:
      "Recebimento importado do eDSP — não veio do extrato bancário (não reconciliado no banco). Valor pode ser o bruto, não o líquido recebido.",
    emailBtn: "📧 Email",
    emailLabel: "Email",
    emailPlaceholder: "cliente@exemplo.com",
    errorGeneratingPdf: "Erro ao gerar PDF",
    errorSending: "Erro ao enviar",
    errorTitle: "Erro",
    eurostormEffective: "Eurostorm efetivo",
    eurostormPct: "Eurostorm pct",
    expected100: "esperado 100%",
    fieldAtelier: "Ateliê",
    fieldBillingCompany: "Empresa faturamento",
    fieldCustomer: "Cliente",
    fieldDate: "Data",
    fieldEndCustomer: "Cliente final",
    fieldInvoiceStatus: "Status fatura",
    fieldInvoices: "Fatura(s)",
    fieldLines: "Linhas",
    fieldReceivingCompany: "Empresa recebedora",
    fieldRepair: "Reparação",
    fieldVehicle: "Veículo",
    fixedClearBtn: "Limpar (voltar ao par)",
    fixedDspLabel: "PDR — técnico recebe (€ HT)",
    fixedEditBtn: "Alterar",
    fixedFollowPair: "vazio = segue o par",
    fixedHint:
      'Exceção ao par, só para este carro: vale para quem assumir (também antes de o técnico assumir no portal). Quem assumir o PDR recebe o fixo do PDR; quem desmontar/montar recebe o fixo do dégarnissage (metades 50/50). Só a parte do técnico muda — remise do cliente e intermediário seguem o par, a casa fica com o resto. A franquia, informada pelo técnico como sempre, afeta só a fatura do cliente: não reduz o fixo. Confidencial: no portal o técnico vê só "Sua comissão", sem saber que é fixo. Deixe vazio para seguir o par.',
    fixedMontageLabel: "Dégarnissage — técnico recebe (€ HT)",
    fixedMontageShort: "Dégarnissage",
    fixedNone:
      "Padrão: o técnico recebe pelo par técnico × cliente. Valor fixo só em exceção, definido aqui.",
    fixedSaveBtn: "Salvar valor fixo",
    fixedSetBtn: "Definir valor fixo (exceção)",
    fixedTechAmountHint:
      "O técnico recebe exatamente este valor; o % é derivado e a casa absorve a diferença. Fica como ajuste manual (recálculos automáticos não mexem).",
    fixedTechAmountLabel: "Valor fixo do técnico (€ HT) — opcional",
    fixedTechAmountPh: "ex.: 1200",
    fixedTitle: "Valor fixo do técnico neste carro",
    fixedTopBtn: "Valor fixo",
    fixedTopHint: "Valor fixo do técnico neste carro (exceção ao par) — só o admin vê",
    franchiseAddBtn: "Informar franquia",
    franchiseCommissionsOnlyBadge: "exceção: fatura cheia",
    franchiseCommissionsOnlyHint:
      "Regra normal do Profissional: a franquia reduz a fatura e as comissões. Marcado, só as comissões dos técnicos reduzem, como no Particular.",
    franchiseCommissionsOnlyLabel: "Exceção: franquia só nas comissões (a fatura sai cheia)",
    franchiseNoReception: "Carro sem recepção registrada — franquia não informada.",
    franchiseSectionTitle: "Franquia",
    impactsWord: "impactos",
    intercompanyEffective: "Intercompany efetivo",
    intercompanyInvoicesTitle: "Intercompany invoices",
    intermediary: "Intermediário",
    intermediaryEffective: "Intermediário efetivo",
    intermediaryPct: "Intermediário pct",
    intermediaryPctRange: "% Intermediário deve ser entre 0 e 100.",
    internalCodePre: "nº interno",
    invalidEmail: "Informe um email válido.",
    invalidId: "ID inválido.",
    invoiceIssuedOnPre: "emitida em",
    invoiceNumberField: "N° fatura (opcional — auto se vazio)",
    invoiceNumberPlaceholder: "F2026-00001 (automático se vazio)",
    invoiceReceivedOnPre: "recebida em",
    invoiceSentTo: "Fatura enviada para",
    invoiced: "Faturado",
    invoicesNone: "nenhuma emitida",
    issue: "Emitir",
    issueCustomerInvoiceTitle: "Emitir fatura do cliente",
    issueInvoiceBeforeReceipts: "Emita uma fatura no dossier antes de registrar recebimentos.",
    issueInvoiceBtn: "+ Emitir fatura",
    issueLower: "emitir",
    issuer: "Issuer",
    issuerCompany: "Empresa emissora",
    issuing: "Emitindo…",
    launchTechBtn: "Lançar técnico",
    launchTechCancel: "Cancelar",
    launchTechChoice: "O que ele fez",
    launchTechChoose: "— escolher o técnico —",
    launchTechClose: "Fechar",
    launchTechDone: "Carro já reparado (marca PDR finalizado e etapas concluídas)",
    launchTechHint:
      "Mesma regra do portal: comissão pelo par técnico × cliente, funilaria e peças 100% da casa, franquia e ordem de reparo. Sem recepção, o Super Admin libera por derrogação com o motivo.",
    launchTechMontage: "Só desmontagem e montagem",
    launchTechOk: "Técnico lançado no carro.",
    launchTechPdr: "Só PDR",
    launchTechPdrMontage: "PDR + desmontagem e montagem",
    launchTechReason: "Motivo",
    launchTechSubmit: "Lançar",
    launchTechTech: "Técnico",
    launchTechTitle: "Lançar técnico no carro",
    legacyHintPre: "Linha legacy sem cascade — pré-preenchido do par técnico×cliente",
    legacyHintSuf: "Ajuste e salve para promover.",
    lineStatusApproved: "aprovada",
    lineStatusCancelled: "cancelado",
    lineStatusNotApplicable: "não se aplica",
    lineStatusPaid: "pago",
    lineStatusPending: "pendente",
    lineStatusProformaIssued: "proforma emitida",
    lineStatusReceived: "recebida",
    lineStatusRejected: "recusada",
    lineTakenOnPre: "assumido em",
    linesEmpty: "Nenhuma linha. Linhas são criadas automaticamente ao importar dossiers do eDSP.",
    linesTotalTitle: "Total do dossier",
    loading: "Carregando…",
    managerAmount: "Comissão do gerente",
    managerBase: "Base (PDR + dégarnissage após franquia)",
    managerCancelBtn: "Cancelar",
    managerCardTitle: "Gerente do chantier",
    managerDefaultWas: "padrão",
    managerDeliveredPre: "Conta no mês da entrega registrada em",
    managerEditBtn: "Modificar",
    managerEditHint: "Só neste carro; sai da parte da empresa.",
    managerEffective: "Gerente efetivo",
    managerFixedWord: "fixo",
    managerHint:
      "Sobre PDR + dégarnissage; sai da parte da casa, não muda técnico nem cliente. Mesmo cálculo do repasse no portal do gerente.",
    managerModeDefault: "Padrão",
    managerModeFixed: "Valor fixo (€ HT)",
    managerModePct: "Percentual",
    managerNotDelivered:
      "Aguardando o gerente registrar a entrega — sem o registro a comissão não entra em mês nenhum.",
    managerOverrideLabel: "Exceção deste carro",
    managerPctEquiv: "% equivalente",
    managerPctOverride: "% (exceção do carro)",
    managerPctParticular: "% particular",
    managerPctPro: "% profissional",
    managerPreview: "O gerente recebe",
    managerReasonPh: "Motivo (obrigatório)",
    managerSaveBtn: "Salvar",
    markInvoiceReceived: "marcar fatura recebida",
    markPaid: "marcar pago",
    markPaidInvoice: "marcar paga",
    markReceived: "marcar recebida",
    method: "Método",
    methodCard: "Cartão",
    methodCash: "Dinheiro",
    methodCheck: "Cheque",
    methodOther: "Outro",
    methodTransfer: "Transferência",
    model: "Modelo",
    modelComplementary: "Complementar (F8)",
    modelLegacy: "Legacy (atual)",
    moreBtn: "Mais",
    netAfterAvoirPre: "líquido após avoir",
    netInvoicedLabel: "Faturado líquido",
    netSuffix: "(líquido)",
    newReceiptTitle: "Novo recebimento",
    newTechnicianPaymentTitle: "Novo pagamento ao técnico",
    noCustomerEmailWarn: "⚠ Cliente sem email cadastrado — informe um endereço acima.",
    noEvents: "Nenhum evento.",
    noIcCandidateTitle: "Nenhuma linha tem responsible_company diferente da billing_company.",
    noIcForDossier: "Nenhuma IC para este dossier.",
    noInvoicesYet: "Nenhuma fatura emitida ainda.",
    noPayments: "Nenhum pagamento.",
    noReceipts: "Nenhum recebimento registrado.",
    noTechnicianInvoices: "Nenhuma fatura de técnico cobre linhas deste dossier ainda.",
    noneOption: "— nenhuma —",
    notFound: "Dossier não encontrado nas empresas acessíveis.",
    notesLabel: "Notas",
    onDate: "Em",
    onPrixBrut: "sobre o preço bruto",
    openBalance: "Saldo aberto",
    overrideApplied: "Override aplicado",
    overrideLabel: "Ajuste manual",
    payment: "Pagamento",
    payoutEffective: "A repassar (técnico + intermediário)",
    pctLabel: "Percentual",
    pdfAutoAttachHint:
      "O PDF da fatura será gerado/atualizado e anexado automaticamente. O email é enviado com remetente da empresa emissora configurado em SMTP.",
    pendingCustomerKeep: "Manter",
    pendingCustomerNow: "hoje o carro está em",
    pendingCustomerPre: "Devis reenviado com outro cliente:",
    pendingCustomerSwitch: "Trocar para",
    phaseDemontage: "Desmontagem",
    phaseExternal: "terceiro (garage)",
    phaseMontage: "Montagem",
    phasePdrDone: "PDR finalizado",
    phasePdrOpen: "PDR em curso",
    portalDoc_carte_grise: "Carte grise",
    portalDoc_cnh: "Carteira de motorista",
    portalDoc_expertise: "Rapport d'expertise",
    portalDoc_outro: "Outro documento",
    portalFilesHint:
      "Enviados pelo portal do gerente e dos técnicos (recepção, entrega e montagem). Toque na foto para abrir em tamanho real.",
    portalFilesTitle: "Documentos e fotos dos portais",
    portalOpenBtn: "Abrir",
    portalPhotosDelivery: "Fotos da entrega",
    portalPhotosMontage: "Fotos da desmontagem",
    portalPhotosMontageEnd: "Fotos da montagem",
    portalPhotosReception: "Fotos da recepção",
    quote: "Orçamento",
    reasonInline: "· motivo:",
    reasonRequired: "Motivo obrigatório.",
    reassignBtn: "Reatribuir",
    reassignDemontageDone: "Desmontagem concluída",
    reassignDemontageExternal: "Desmontagem feita por terceiro (garage) — ninguém da ES/BS recebe",
    reassignDemontageLabel: "Desmontagem (dono da linha)",
    reassignDspDone: "PDR finalizado",
    reassignExternalHint:
      "A metade externa conta como feita (o carro fecha), não entra na fatura do cliente e ninguém do grupo recebe por ela.",
    reassignHint:
      "A comissão é refeita pelo par do novo técnico com o cliente. Sem par, a linha fica legacy até o escritório recalcular. Etapas já concluídas são preservadas.",
    reassignMontageDone: "Montagem concluída",
    reassignMontageExternal: "Montagem feita por terceiro (garage) — ninguém da ES/BS recebe",
    reassignMontageLabel: "Montagem",
    reassignPdrLabel: "Técnico do PDR",
    reassignReasonLabel: "Motivo (obrigatório)",
    reassignReasonMin: "Escreva pelo menos 3 letras para liberar o botão.",
    reassignSameAsOwner: "Mesmo técnico da desmontagem",
    reassignSave: "Reatribuir",
    reassignTitle: "Reatribuir técnico",
    reassignWorkState: "Estado do trabalho",
    receiptsByInvoiceTitle: "Recebimentos por fatura",
    received: "Recebido",
    receiver: "Receiver",
    receiverBillingCompany: "Receptora (billing_company)",
    recipient: "Destinatário",
    reference: "Referência",
    register: "Registrar",
    rejectInvoice: "rejeitar fatura",
    rejectLower: "rejeitar",
    rejectTechnicianInvoiceTitle: "Rejeitar fatura técnico",
    repairEdspOrderPre: "ordem eDSP de",
    requestProformaBtn: "Solicitar proforma ao técnico",
    requestProformaTitle:
      "Adiantar o pagamento do técnico: a proforma não precisa da fatura nem do recebimento do cliente.",
    responsibleCompany: "Empresa responsável",
    responsibleCompanyRequired: "Empresa responsável é obrigatória.",
    retentionFromPairNote: "Remise do cliente definida no par técnico × cliente (soma das linhas).",
    retentionPctVaries: "varia por linha",
    reversalOf: "estorno de",
    reverseLower: "estornar",
    reversePaymentTitle: "Estornar pagamento",
    reverseReceiptTitle: "Estornar recebimento",
    roAddMontageAmount: "Valor do dégarnissage (HT)",
    roAddMontageBtn: "Lançar a montagem do devis",
    roAddMontageConfirm: "Lançar",
    roAddMontageExternal: "Feito por terceiro (garage) — ninguém da ES/BS recebe",
    roAddMontageHint:
      "O devis tem dégarnissage mas ninguém assumiu a montagem no portal. Escolha quem fez (ou marque terceiro), confirme o valor e as etapas feitas.",
    roAddMontageTech: "Técnico (desmontagem e montagem)",
    roAddMontageTitle: "Lançar a linha de montagem (dégarnissage do devis)",
    roAmount: "Valor a faturar HT",
    roClientPo: "Nº de pedido do cliente",
    roComment: "Comentário",
    roCreateBtn: "Criar a ordem",
    roDevisAmount: "Devis HT",
    roEditBtn: "Editar",
    roEditHint:
      "Baixar o valor gera uma remise excepcional na fatura. Só é possível antes de faturar.",
    roEmpty: "A ordem nasce quando o técnico assume o carro no portal.",
    roIncompleteAsk: "Faturar assim mesmo?",
    roIncompleteConfirm: "Faturar assim mesmo",
    roIncompleteTitle: "O carro ainda não está completo",
    roInitialAmount: "Valor inicial HT",
    roInvoicedLocked: "Carro já faturado — a ordem está congelada.",
    roMissingDelivery: "aguardando entrega",
    roMissingDsp: "falta o débosselage",
    roMissingMontage: "aguardando montagem",
    roMissingMontagePhases: "montador ainda não terminou",
    roReady: "Pronta para faturar",
    roRemise: "Remise excepcional",
    roSectionTitle: "Ordem de reparação",
    roSplitDegBtn: "Dégarnissage feito pelo próprio técnico",
    roSplitDegConfirm: "Dividir e marcar concluído",
    roSplitDegMsgPre:
      "A linha PDR engloba o dégarnissage do devis. Será criada a linha de montagem, já concluída, para",
    roSplitDegMsgSuf:
      "Nenhum valor muda (cliente, técnico, casa, OR). O PDR também será marcado como concluído. Informe o motivo.",
    roSplitDegTitle: "Dividir a linha PDR em PDR + montagem",
    save: "Salvar",
    saveCommission: "Salvar comissão",
    saving: "Salvando…",
    sectionCustomerRetention: "Retenção do cliente",
    sectionHeader: "Cabeçalho",
    sectionTotals: "Totais agregados",
    selectIssuer: "Selecione o emissor.",
    selectPlaceholder: "— selecione —",
    selectTechnicianForCascade: "Selecione um técnico para editar a cascade de comissão.",
    send: "Enviar",
    sendInvoiceEmailTitle: "Enviar fatura por email",
    sending: "Enviando…",
    serviceLinesTitle: "Linhas de serviço",
    serviceTypeMontage: "Montagem/Desmontagem",
    serviceTypePeinture: "Carroçaria/Pintura",
    serviceTypePieces: "Peças",
    softDeletedBadge: "soft-deleted",
    statusApproved: "aprovada",
    statusCancelled: "cancelada",
    statusCustomerReceived: "recebida",
    statusDraft: "rascunho",
    statusIssued: "emitida",
    statusPaid: "paga",
    statusPending: "pendente",
    statusReceived: "recebida",
    statusRejected: "rejeitada",
    statusReversed: "estornada",
    statusVoid: "anulada",
    suggestedFromDossierHint:
      "Sugerido do dossier (preserva formato original do eDSP — não altere se quiser que receipts do CSV casem com esta fatura).",
    suggestedLabel: "Sugerido",
    suggestedNextHint: "Próximo número da série — pode alterar.",
    sumEquals: "Soma =",
    sumExceedsPre: "⚠ Soma dos pcts ultrapassa 100%.",
    sumExceedsSuf: "ficaria negativo.",
    sumMust100: "Soma dos percentuais deve ser 100%",
    sumMust100Save: "Soma dos percentuais precisa ser 100% para salvar.",
    tabAudit: "Auditoria",
    tabFaturacao: "Faturação cliente",
    tabFinanceiro: "Faturação e pagamentos",
    tabHistorico: "Histórico e documentos",
    tabIntercompany: "Intercompany",
    tabLinhas: "Linhas",
    tabRecebimentos: "Recebimentos",
    tabResumo: "Resumo",
    tabServicos: "Serviços e técnicos",
    tabTecnicoFaturas: "Faturas técnico",
    tabTecnicoPagamentos: "Pagamentos técnico",
    technician: "Técnico",
    technicianAmountKnown: "Valor do técnico conhecido",
    technicianAmountUnknownWarn: "Valor do técnico ainda não conhecido.",
    technicianEffective: "Técnico efetivo",
    technicianInvoice: "Fatura técnico",
    technicianInvoiceImportHint:
      "A fatura do técnico é importada ao anexá-la na proforma correspondente.",
    technicianInvoicesTitle: "Faturas dos técnicos (com linhas deste dossier)",
    technicianPaymentsTitle: "Pagamentos a técnicos",
    technicianPct: "Técnico pct",
    technicianPctRange: "% Técnico (override) deve ser entre 0 e 100.",
    technicianRequired: "Técnico é obrigatório.",
    thirdPartyNotBilledAll:
      "Desmontagem e montagem feitas por terceiro (garage): este dégarnissage não entra na fatura.",
    thirdPartyNotBilledHalf:
      "Uma metade feita por terceiro (garage): só a metade feita pelo grupo entra na fatura.",
    tlActIssue: "Emitir fatura",
    tlActPayout: "Repassar ao técnico",
    tlActReceipt: "Registrar recebimento",
    tlDelivered: "Entregue",
    tlDevis: "Orçamento (devis)",
    tlDone: "Concluído",
    tlInvoiced: "Faturado",
    tlMontage: "Montagem",
    tlNoTech: "sem técnico",
    tlPayout: "Repasse ao técnico",
    tlPortal: "no portal",
    tlPortalHint: "Etapa registrada no portal (técnico ou gerente).",
    tlReceived: "Recebido",
    tlRepaired: "Reparado",
    tlTitle: "Onde o carro está",
    total: "Total",
    totalCustomerRetention: "Retenção cliente",
    totalIntercompanyInvoice: "Intercompany invoice",
    totalIntermediaryCommission: "Comissão intermediário",
    totalInvoiced: "Faturado total",
    totalNetUpper: "TOTAL NET",
    totalQuote: "Orçamento total",
    totalTechnicianCommission: "Comissão técnico",
    totalUpper: "TOTAL",
    type: "Tipo",
    usingBillingEmailHint:
      "Usando email de cobrança do cliente. Edite se quiser enviar para outro destinatário.",
    vehicleHistoryBtn: "Ficha do veículo",
    vehicleOthersHint: "Este veículo tem outros dossiers: abra a ficha para ver todos.",
    voidInvoiceMsg: "Anulada (void). Diferente de cancel: sem efeito fiscal.",
    voidInvoiceTitle: "Anular fatura",
    voidLower: "anular",
  },
  dossierWizard: {
    addFirstLineHint: "(pode adicionar/editar depois no detalhe)",
    addFirstLineNow: "Adicionar primeira linha de serviço agora",
    back: "← Voltar",
    cancel: "Cancelar",
    commissionAmountKnown: "Valor da comissão conhecido",
    commissionUnknownValue: "valor desconhecido (será definido depois)",
    dupConfirmBtn: "É um serviço novo — criar outro dossier mesmo assim",
    errAmountUnknownFieldsEmpty:
      "technicianAmountKnown=false: pct, base e valor da comissão devem ficar vazios.",
    errCommissionAmountMin: "Comissão valor: ≥ 0.",
    errCommissionPctRange: "Comissão %: entre 0 e 100.",
    errInvoicedMin: "Faturado deve ser ≥ 0.",
    errLineCreatePre: "Dossier criado, mas falhou ao adicionar a primeira linha",
    errLineCreateSuf: "Você pode adicionar manualmente na aba 'Linhas' do detalhe.",
    errQuoteMin: "Orçamento deve ser ≥ 0.",
    errResponsibleCompanyRequired: "Empresa responsável é obrigatória.",
    errRetentionRange: "Retenção do cliente: % deve estar entre 0 e 100.",
    errSelectBillingCompany: "Selecione a empresa de faturamento.",
    errSelectCustomer: "Selecione o cliente.",
    errTechnicianRequired: "Técnico é obrigatório.",
    errVehicleRequired: "Informe um veículo, plate ou VIN.",
    fieldBase: "Base",
    fieldBillingCompany: "Empresa de faturamento",
    fieldCommissionPct: "Comissão %",
    fieldCustomer: "Cliente",
    fieldCustomerRetention: "Retenção do cliente (%) — opcional",
    fieldEffectiveAmountEur: "Valor efetivo (€)",
    fieldExternalInvoiceNumber: "N° fatura externo (eDSP)",
    fieldInvoiceDate: "Data da fatura",
    fieldInvoicedEur: "Faturado (€)",
    fieldNotes: "Notas",
    fieldPlate: "Plate",
    fieldQuoteEur: "Orçamento (€)",
    fieldReceivingCompany: "Empresa recebedora (opcional)",
    fieldResponsibleCompany: "Empresa responsável",
    fieldSelectVehicle: "Selecionar veículo do cliente",
    fieldServiceType: "Tipo de serviço",
    fieldTechnician: "Técnico",
    fieldVin: "VIN",
    lineNotCreated: "(não criada)",
    loading: "carregando…",
    next: "Próximo →",
    noLineHint: "Pode adicionar linhas a qualquer momento no detalhe do dossier.",
    optionAuto: "automático",
    optionBaseInvoiced: "faturado",
    optionBaseQuote: "orçamento",
    optionNoVehicleLink: "— sem vínculo (informar plate/VIN abaixo) —",
    optionNone: "— nenhuma —",
    optionSelect: "— selecione —",
    optionSelectCustomerFirst: "selecione cliente primeiro",
    optionServiceDsp: "DSP (débosselage sans peinture)",
    optionServiceDspShort: "DSP",
    optionServiceMontage: "Montagem/Desmontagem",
    overrideNotice:
      "Os valores efetivos serão calculados pelo backend (suggested = pct × base) e gravados como override só se você passar amount diferente. Override exige role admin + motivo.",
    placeholderAutoCalculated: "auto (calculado)",
    placeholderAutoFromContract: "auto (do cadastro/contrato)",
    placeholderAutoFromRecord: "auto (do cadastro)",
    placeholderExternalInvoiceNumber: "opcional · ex: F-2026-0042",
    placeholderOptional: "opcional",
    placeholderPlate: "ex: AB-123-CD",
    rowBillingCompany: "Empresa faturamento",
    rowCustomerRetention: "Retenção cliente %",
    rowDate: "Data",
    rowExternalInvoiceNumber: "N° fatura externo",
    rowInvoiced: "Faturado",
    rowQuote: "Orçamento",
    rowReceivingCompany: "Empresa recebedora",
    rowTechnicianCommission: "Comissão técnico",
    rowType: "Tipo",
    saveDossier: "Salvar dossier",
    saving: "Salvando…",
    sectionVehicle: "Veículo",
    stepFirstLine: "Primeira linha de serviço",
    stepHeader: "Cabeçalho",
    stepLabelPre: "Passo",
    stepLabelSuf: "de 3",
    stepReviewAndSave: "Revisar e salvar",
    stepperLine: "1ª linha",
    stepperReview: "Revisar",
    title: "Novo dossier",
    vehicleManualHint:
      "Ou informe plate/VIN manualmente (sem cadastro). Pelo menos um é obrigatório.",
  },
  dossiers: {
    actIssue: "Emitir fatura",
    actLaunch: "Lançar técnico",
    actOpen: "Abrir",
    actPayout: "Repassar",
    actReceipt: "Registrar recebimento",
    analyzing: "Analisando…",
    applying: "Aplicando…",
    assignBtn: "Atribuir",
    assignTechBtn: "Atribuir técnico",
    assignTechHintBold: "todas",
    assignTechHintPre: "Aplica em",
    assignTechHintSuf: "as service_lines de cada dossier selecionado.",
    assignTechModalTitlePre: "Atribuir técnico em",
    assignTechReasonPlaceholder: "Ex: reatribuição de carteira",
    assignTechTitle:
      "Atribui (ou troca) o técnico em todas as service_lines dos dossiers selecionados",
    badgeApproved: "aprovada",
    badgeCancelled: "cancelada",
    badgeClientPre: "Cliente",
    badgeDraft: "rascunho",
    badgeInvoicePaid: "recebida",
    badgeIssued: "emitida",
    badgePaid: "pago",
    badgePartial: "parcial",
    badgePending: "pendente",
    badgeReceived: "recebida",
    badgeRejected: "rejeitada",
    badgeTechPre: "Téc",
    bulkGroupClient: "Fatura cliente",
    bulkGroupDocs: "Documentos",
    bulkGroupEdit: "Edição",
    bulkGroupExport: "Exportar",
    bulkGroupTech: "Pag. técnico",
    bulkSelectedWord: "selecionado",
    bulkSelectedWordPlural: "selecionados",
    cancelBtn: "Cancelar",
    cancelReasonPlaceholder: "Ex: erro de emissão em lote",
    cancelStatusConfirmLabel: "Cancelar status",
    cancelStatusMessage:
      "Cancela o status da fatura cliente. Diferente de excluir — o dossier continua na listagem. Reversível.",
    cancelStatusTitle: "Marca os dossiers selecionados como 'Cancelada' (status da fatura)",
    cardDevisSub: "aguardando técnico",
    cardInRepairSub: "técnico trabalhando",
    cardInvoicedPartial: "faturado",
    cardInvoicedSuf: "HT faturado, a receber",
    cardToInvoiceSuf: "HT a faturar",
    chipAll: "Todos",
    chipInRepair: "Em reparação",
    chipInvoiced: "Faturados",
    chipNoTech: "Sem técnico",
    chipReceived: "Recebidos",
    chipRepaired: "Reparados a faturar",
    chipToExecute: "A executar",
    clearFilters: "Limpar filtros",
    clearFiltersTitle: "Limpar todos os filtros",
    close: "Fechar",
    colAction: "Ação",
    colActions: "Ações",
    colBenefice: "Lucro",
    colComm: "Comm.",
    colCommTitle: "Repartição da comissão: Técnico / Intermediário / Euro Storm",
    colCustomer: "Cliente",
    colDateDossier: "Data / dossier",
    colDevis: "Devis",
    colEncaisse: "Encaisse.",
    colEncaisseTitle: "Encaixe cliente: status da fatura cliente",
    colFactTec: "Fact. tec.",
    colFactTecTitle: "Status do documento da fatura do técnico",
    colFacture: "Faturado",
    colInvoiceNumber: "N° fatura",
    colMake: "Marca",
    colModel: "Modelo",
    colNumFactTec: "N° fact. tec.",
    colNumFactTecTitle: "Número da fatura do técnico",
    colPagTec: "Pag. tec.",
    colPagTecTitle: "Status do pagamento ao técnico",
    colPj: "PJ",
    colPjTitle: "Anexo (PJ): documento ou comprovante",
    colPlate: "Placa",
    colRepartition: "Repartição",
    colStatut: "Situação",
    colTechnician: "Técnico",
    colValeurs: "Valores",
    colVehicule: "Veículo",
    columnsBtn: "Colunas",
    commHintFormula: "100 − cliente − técnico − intermediário",
    commHintMid: "(F8). Lines legacy são puladas.",
    commHintPre: "Aplica apenas em service_lines com modelo",
    commHintResidual: "é recalculado como resíduo",
    commHintSuf: "Deixe vazio o que não quiser alterar.",
    commissionReasonPlaceholder: "Ex: reajuste de % padrão do técnico",
    companyLabel: "Empresa",
    confirmMarkReceivedPre: "Marcar",
    confirmMarkReceivedSuf:
      "dossier(s) como Recebida? A customer_invoice (issued) vai virar paid automaticamente.",
    confirmRevertIssuedPre: "Reverter",
    confirmRevertIssuedSuf: "dossier(s) para Emitida (saiu de Recebida)?",
    confirmTechPaidPre: "Marcar o pagamento ao TÉCNICO como pago em",
    confirmTechPaidSuf:
      "dossier(s) selecionado(s)? O selo Téc vira “pago” e eles saem do KPI “Técnicos a pagar”. Isso é um marcador de status — não registra o pagamento em dinheiro.",
    confirmTechPendingPre: "Voltar o pagamento ao TÉCNICO para pendente em",
    confirmTechPendingSuf: "dossier(s) selecionado(s)?",
    confirmTitle: "Confirmar",
    csvBenefice: "Lucro",
    csvCode: "Código",
    csvCustomer: "Cliente",
    csvDate: "Data",
    csvDevis: "Devis",
    csvFacturado: "Facturado",
    csvInvoiceNumber: "N° Fatura",
    csvInvoiceStatus: "Status fatura",
    csvMake: "Marca",
    csvModel: "Modelo",
    csvPlate: "Placa",
    csvTechInvoiceNumber: "N° Fact. tec.",
    csvTechInvoiceStatus: "Status Fact. tec.",
    csvTechnician: "Técnico",
    customerLabel: "Cliente",
    dateFromTitle: "Data inicial",
    dateKindCreated: "Data de criação do dossier (sem devis nem fatura)",
    dateKindDevis: "Data do devis (ainda sem fatura)",
    dateKindInvoice: "Data da fatura",
    dateKindRepaired: "Data da reparação (PDR finalizado; ainda sem fatura)",
    dateLabel: "Data",
    dateToTitle: "Data final",
    deleteBtn: "excluir",
    deleteConfirmLabel: "Excluir",
    deleteDossierMessage: "Soft delete. Reversível via 'restaurar'. Motivo obrigatório para audit.",
    deleteDossierTitlePre: "Excluir dossier",
    deleteReasonPlaceholder: "Ex: criado por engano",
    devisToExecuteBannerSuf: "devis a executar — aguardando um técnico assumir no portal.",
    devisToExecuteBannerSufSingular: "devis a executar — aguardando um técnico assumir no portal.",
    doneLabel: "Concluído",
    emptyState: "Nenhum carro encontrado.",
    errorTitle: "Erro",
    exportCsvBtn: "Exportar CSV",
    faturadoLabel: "Faturado",
    filterBtn: "Filtrar",
    filterTechPayTitle: "Pagamento ao técnico/intermediário (coluna PAG. TEC)",
    filterTechnicianTitle: "Filtrar por técnico (via service_lines)",
    filtersActivePre: "Filtros ativos",
    filtersBtn: "Filtros",
    generateProformaBtn: "Gerar proforma",
    generateProformaTitle: "Cria proforma com os dossiers selecionados — todos do mesmo técnico",
    generating: "Gerando…",
    includeDeleted: "Incluir excluídos",
    invoiceFromTitle: "N° de fatura mínimo (ex.: F-2025-0045)",
    invoiceRangeLabel: "Faixa de nº fatura",
    invoiceStatusLabel: "Status fatura",
    invoiceToTitle: "N° de fatura máximo (ex.: F-2025-0089)",
    issueInvoiceBtn: "Emitir fatura",
    issueInvoiceTitle:
      "Revisar e emitir 1 fatura cobrindo os serviços selecionados (mesmo cliente)",
    kpiAReceber: "A receber do cliente",
    kpiAllPaid: "tudo pago",
    kpiAvoirsWord: "avoirs",
    kpiCardToggleTitle: "Filtro rápido — clique para alternar",
    kpiClickToFilter: "clique para filtrar",
    kpiCommissionsNotComputed: "comissões não computadas",
    kpiDossiers: "Dossiers",
    kpiEurostormShare: "Euro Storm share total",
    kpiFaturadoMinusCommissions: "Faturado − comissões",
    kpiFilterAppliedClickRemove: "filtro aplicado — clique para remover",
    kpiGrossWord: "bruto",
    kpiIssuedPending: "invoices emitidas pendentes",
    kpiLucroBruto: "Lucro bruto",
    kpiLucroPrevisto: "Lucro previsto",
    kpiPctOfDevisSuf: "do total orçado",
    kpiPctOfFactureSuf: "do faturado",
    kpiScopeFiltered: "Filtrado",
    kpiScopeGeneral: "Geral",
    kpiTechniciansToPay: "Técnicos a pagar",
    kpiTotalDevis: "Total dos devis",
    kpiTotalFacture: "Total faturado",
    kpisCollapse: "Compacto",
    kpisExpand: "Detalhes",
    linesWord: "linhas",
    loading: "Carregando…",
    markReceivedBtn: "Marcar Recebida",
    markReceivedTitle: "Marca os dossiers selecionados como 'Recebida' (paga)",
    markTechPaidBtn: "Téc. pago",
    markTechPaidTitle:
      "Marca o pagamento ao técnico como PAGO em todas as linhas dos dossiers selecionados (mesmo sinal do selo Téc e do KPI Técnicos a pagar)",
    menuAttach: "Anexar documento",
    menuDeleteHint: "cancela a fatura",
    menuHistory: "Ver histórico",
    menuModify: "Editar",
    menuRestoreHint: "reativa a fatura",
    montageOtherLabel: "Montagem (outro técnico)",
    newDossierBtn: "Novo carro",
    nextPage: "Próxima",
    noCompanyAccess: "Você não tem acesso a nenhuma empresa.",
    okBtn: "OK",
    onlySelectedActive: "Vendo só selecionados",
    onlySelectedIdle: "Ver só selecionados",
    onlySelectedTitle: "Filtra a tabela para mostrar só os dossiers marcados",
    openBtn: "abrir",
    optAllCustomers: "Todos clientes",
    optAllInvoiceStatus: "Todos status fatura",
    optAllProformas: "Todas",
    optAllTechPay: "Todos pag. téc",
    optAllTechnicians: "Todos técnicos",
    optCancelled: "Cancelada",
    optChooseTechnician: "— escolha um técnico —",
    optIssued: "Emitida",
    optPending: "Pendente",
    optReceived: "Recebida",
    optTechPayPaid: "Pag. téc: pago",
    optTechPayPending: "Pag. téc: pendente",
    optWithoutTechnician: "Sem técnico",
    pageOf: "de",
    pageWord: "Página",
    paidTechnicianLabel: "Pago técnico",
    pctCustomer: "% Cliente",
    pctCustomerPlaceholder: "ex: 30",
    pctIntermediary: "% Intermediário",
    pctIntermediaryPlaceholder: "ex: 10",
    pctTechnician: "% Técnico",
    pctTechnicianPlaceholder: "ex: 40",
    periodLabel: "Período (data fatura)",
    pjNotImplementedTitle: "Anexo ainda não implementado (PJ)",
    prevPage: "Anterior",
    previewNotApplied: "Preview (não foi aplicado)",
    proformaFilterLabel: "Proforma da Euro Storm",
    proformaFilterTitle: "Só os carros espelho desta proforma (uma fatura por proforma).",
    proformaOptSuffix: "a faturar",
    promoteAndMorePre: "e mais",
    promoteApplyingV3: "aplicando V3.",
    promoteBrokenCode: "complementary com faturado=orçamento",
    promoteBrokenDesc:
      "— bug do importador eDSP antigo (não aplicava retenção do cliente). Só altera se o cliente tem",
    promoteBtnPre: "Promover",
    promoteBullet1: "Quantas linhas serão promovidas",
    promoteBullet2: "Quantas serão puladas (e por que motivo)",
    promoteBullet3: "Quantas falharão (ex: soma > 100% por defaults inconsistentes)",
    promoteErrorsDuringCalc: "erro(s) durante o cálculo",
    promoteErrorsLogged: "erro(s) registrado(s) no audit log",
    promoteIntro: "Aplica defaults dos cadastros de técnico e cliente em 3 cenários:",
    promoteLinesWord: "Linhas",
    promotePromoted: "Promovidas",
    promoteRecommendedLabel: "Recomendado:",
    promoteRecommendedPre: "rode primeiro o",
    promoteRecommendedSuf: "(não altera nada) para ver:",
    promoteRemainedLegacy: "Permaneceram legacy",
    promoteSeeReasonsPre: "Ver motivos das",
    promoteSeeReasonsSuf: "pulada(s)",
    promoteStaleCode: "técnico=0% (mesmo com intermediário)",
    promoteStaleDesc: "— import com par desatualizado; linha já paga fica fora",
    promoteToWord: "promove para",
    promoteTotalLegacy: "Total legado",
    promoteTotalLegacyWas: "Total legacy era",
    promoteWarnPre:
      "Antes de rodar real, garanta que cada par técnico×cliente está vinculado em Técnicos → Comissões por cliente e que clientes têm",
    promoteWarnSuf: "preenchidos.",
    promoteWillPromote: "Vão promover",
    promoteWillSkip: "Vão pular",
    promoting: "Promovendo…",
    rangeFromPlaceholder: "de",
    rangeToPlaceholder: "até",
    reasonOptionalLabel: "Motivo (opcional)",
    recalcCommissionsBtn: "Recalcular comissões",
    recalcCommissionsTitle:
      "Recalcula comissão em 3 cenários (legacy → complementary; complementary stale; faturado=orçamento).",
    reportBtn: "Gerar relatório",
    reportBtnTitle: "Gera um PDF dos dossiers marcados com os totais (faturado / pago técnico)",
    reportErrorTitle: "Erro ao gerar relatório",
    residualWord: "resíduo",
    restoreBtn: "restaurar",
    revertIssuedBtn: "Emitida",
    revertIssuedTitle: "Reverte para 'Emitida' (caso o pagamento tenha sido estornado)",
    revertTechPendingBtn: "Téc. pendente",
    revertTechPendingTitle:
      "Desfaz: volta o pagamento ao técnico para PENDENTE nos dossiers selecionados",
    runDryRunBtn: "Rodar preview (dry-run)",
    searchLabel: "Buscar",
    searchPlaceholder: "Nº fatura / code / plate / VIN…",
    selectPageTitle: "Selecionar página atual",
    sitCancelled: "Fatura cancelada",
    sitDeleted: "Excluído",
    sitDevisWaiting: "Devis · à espera de técnico",
    sitInRepair: "Em reparação",
    sitInvoiced: "Faturado",
    sitNoTech: "⚠ sem técnico",
    sitPartial: "Faturado · recebido em parte",
    sitPayoutMissingPre: "Falta repassar:",
    sitPayoutPending: "repasse ao técnico pendente",
    sitPayoutTbd: "a calcular",
    sitReceived: "Recebido",
    sitRepairedToInvoice: "Reparado · a faturar",
    sitTechPaid: "técnico pago",
    sortActivity: "Data da lista (fatura, reparação ou devis)",
    sortAsc: "Crescente",
    sortAscTitle: "Crescente — clique para decrescente",
    sortByLabel: "Ordenar por",
    sortByTitlePre: "Ordenar por",
    sortDesc: "Decrescente",
    sortDescTitle: "Decrescente — clique para crescente",
    sortFieldTitle: "Campo de ordenação",
    statDevis: "Devis",
    statDossiersWord: "dossiers",
    statFiltered: "filtrado",
    statGross: "Lucro bruto",
    statInvoiced: "Faturado",
    statOfDevis: "do devis",
    statReceivable: "A receber",
    statTechPay: "Técnicos a pagar",
    statTechPayHint: "clique para filtrar",
    statTechPayOn: "filtro ativo",
    statTechPayTitle: "Clique para filtrar os dossiers com repasse pendente",
    sumLabel: "Soma cliente+técnico+intermediário =",
    sumTooHigh: "soma > 100%, impossível.",
    techPartAwaiting: "aguardando cliente",
    techPartMissing: "falta",
    techPartPaid: "pago",
    techPartPaidBefore: "pago antes do cliente",
    techPartReleased: "liberado",
    techPartToReceive: "a receber",
    techPayLabel: "Pag. técnico",
    technicianLabel: "Técnico",
    title: "Carros",
    toastCommissionUpdatedPre: "Comissão atualizada em",
    toastSkippedNoComplementaryReason: "sem lines complementary ou soma > 100",
    toastSkippedSameStatusReason: "status já era o mesmo ou inválido",
    toastSkippedWord: "pulado",
    toastSkippedWordPlural: "pulados",
    toastStatusUpdatedPre: "Status atualizado em",
    toastTechAssignedPre: "Técnico atribuído em",
    updateBtn: "Atualizar",
    updateCommissionBtn: "Atualizar comissão",
    updateCommissionModalTitlePre: "Atualizar comissão em",
    updateCommissionTitle:
      "Atualiza % cliente/técnico/intermediário em service_lines complementary",
    valDevisShort: "Orç.",
    valFactShort: "Fat.",
    vehicleDossiersHint: "Dossiers deste veículo: abrir a ficha do veículo",
    viewCompact: "Vista compacta",
    withoutTechBannerSuf: "sem técnico associado — revisar.",
  },
  emailOutbox: {
    allKinds: "Todos os tipos",
    allStatus: "Enviados e falhas",
    asUserPre: "como",
    attachmentsPre: "Anexos:",
    backfillHint: "histórico (importado da auditoria, sem detalhes de anexo)",
    ccPre: "Cópia:",
    colBy: "Enviado por",
    colKind: "Tipo",
    colRef: "Referência",
    colStatus: "Situação",
    colSubject: "Assunto",
    colTo: "Destinatário",
    colWhen: "Quando",
    companyLabel: "Empresa:",
    customMessagePre: "Mensagem:",
    emptyState: "Nenhum e-mail encontrado.",
    errorPre: "Erro:",
    filterCompany: "Empresa",
    filterKind: "Tipo",
    filterSearch: "Buscar",
    filterStatus: "Situação",
    kindBankStatement: "Extrato ao contador",
    kindCreditNote: "Avoir",
    kindCustomerInvoice: "Fatura",
    kindInvoiceReminder: "Relance de fatura",
    kindOther: "Outro",
    kindPasswordReset: "Redefinição de senha",
    kindProforma: "Proforma",
    kindTechnicianApplication: "Aprovação de técnico",
    kindUserInvite: "Convite de usuário",
    kindWorklog: "Worklog (semana)",
    loading: "Carregando…",
    nextBtn: "Próxima →",
    notAdmin: "Você não é administrador de nenhuma empresa.",
    of: "de",
    openDossier: "Abrir dossier",
    openProforma: "Abrir proforma",
    page: "Página",
    prevBtn: "← Anterior",
    searchPh: "Buscar destinatário, assunto, nº fatura/proforma…",
    statusFailed: "Falhou",
    statusSent: "Enviado",
    subtitle:
      "Todos os e-mails enviados pelo Gestion: faturas, proformas, worklogs, extratos, convites.",
    title: "Caixa de saída",
  },
  erpShell: {
    backToPortal: "Voltar ao portal do chantier",
    impersonatingBy: "por",
    impersonatingExit: "Encerrar visão",
    impersonatingPre: "Vendo como",
    navAgenda: "Agenda",
    navBankAccounts: "Contas bancárias",
    navCaGap: "Gap de CA",
    navChantiers: "Chantiers",
    navDevis: "Devis",
    navEmailOutbox: "Caixa de saída",
    navIntermediaries: "Intermediários",
    navParcGrele: "Parc Grêle",
    notifAmendedSub: "O devis mudou depois da emissão (mesmo número)",
    notifAmendedSuffix: "faturas modificadas — reenviar ao cliente",
    notifDossiersCommissionsSuffix: "dossiers — comissões",
    notifEmpty: "Nada pendente",
    notifNoticeTitle: "Recado do escritório",
    notifOverdueInvoices: "Faturas em atraso",
    notifOverdueSuffix: "vencidos",
    notifSupplierInvoicesSuffix: "faturas fornecedores",
    notifToPaySuffix: "a pagar",
    notifUnreconciledSuffix: "transações não conciliadas",
    pinTitle: "Fixar: todas as pesquisas passam a filtrar por este item",
    unpinTitle: "Soltar o alfinete — pesquisas voltam ao geral",
    wsFin: "Finanças",
    wsOps: "Operação",
  },
  financeApp: {
    loading: "carregando…",
  },
  financeClosing: {
    by: "por",
    closingBalanceByAccount: "Saldo final por conta (acumulado)",
    colClosingBalance: "Saldo final",
    colInflows: "Entradas",
    colMonth: "Mês",
    colOutflows: "Saídas",
    colResult: "Resultado",
    consolidatedSummary: "Resumo consolidado",
    edit: "Editar",
    emptyHint: "Classifique/distribua lançamentos para ver o fechamento.",
    emptyTitle: "Sem lançamentos classificados ainda.",
    footnote:
      "Entradas/Saídas = movimento externo do mês (transferências internas entre contas não contam no bruto). Saldo final = acumulado (carrega de um mês para o outro). Reflete o que está lançado no app.",
    loading: "Carregando…",
    monthApr: "abr",
    monthAug: "ago",
    monthDec: "dez",
    monthFeb: "fev",
    monthJan: "jan",
    monthJul: "jul",
    monthJun: "jun",
    monthMar: "mar",
    monthMay: "mai",
    monthMovementByAccount: "Movimento do mês por conta",
    monthNov: "nov",
    monthOct: "out",
    monthSep: "set",
    openingBalances: "Saldos de abertura",
    range12Months: "12 meses",
    range3Months: "3 meses",
    range6Months: "6 meses",
    rangeAll: "Tudo",
    title: "Fechamento mensal",
    updatedOn: "atualizado em",
  },
  financeEntries: {
    accountLabel: "Conta",
    addBtn: "Adicionar",
    addDestination: "Adicionar destino",
    addSource: "Adicionar fonte",
    allocated: "Alocado",
    amountPlaceholder: "valor",
    applyBtn: "Aplicar",
    autoReconcileBtn: "Conciliar automático",
    bankLabel: "banco",
    bulkOptCompany: "— empresa —",
    bulkOptIn: "↓ entrada —",
    bulkOptOut: "↑ saída —",
    bulkOptType: "— tipo —",
    cancel: "Cancelar",
    childManagedTitle: "Parcela gerida pelo lançamento-pai",
    classifyAs: "Classificar como:",
    clearPendingBtn: "Limpar pendentes",
    close: "Fechar",
    colAccounts: "Contas",
    colCompany: "Empresa",
    colDate: "Data",
    colDescription: "Descrição",
    colIn: "Entrada",
    colOut: "Saída",
    colType: "Tipo",
    confirmClearPending: "Apagar todos os lançamentos pendentes importados?",
    confirmDeleteEntry: "Apagar este lançamento manual? Esta ação é permanente.",
    confirmTitle: "Confirmar",
    deletePermanentTitle: "Apagar (permanente)",
    destinations: "Destinos",
    distExpenseHint:
      "Escolha de qual conta cada parte SAI (fonte) — a conta é debitada e pode ficar negativa. O que sobrar sai da conta da empresa.",
    distParentAccountTitle:
      "Pai de distribuição — conta gerida pelas parcelas-filhas. Use ⚡ para editar.",
    distRevenueHint: "Cada linha credita o destino e debita a empresa; o residual fica na empresa.",
    distributeBtn: "Distribuir",
    distributeExpenseTitle: "Distribuir despesa",
    distributeRevenueTitle: "Distribuir receita",
    distributeTitle: "Distribuir",
    distributionChild: "distribuição",
    duplicatesRemoved: "duplicata(s) removida(s).",
    editing: "editando",
    emptyState: "Nenhum lançamento ainda.",
    emptyStateHint: "Importe um CSV ou adicione manualmente.",
    entriesPlural: "lançamentos",
    entrySingular: "lançamento",
    entryTotal: "Total do lançamento",
    errMinTwoWords: "Use pelo menos 2 palavras.",
    exceeds: "(excede!)",
    fieldIn: "↓ Entrada (conta · valor)",
    fieldOut: "↑ Saída (conta · valor)",
    filterAllAccounts: "Todas contas",
    filterAllCompanies: "Todas empresas",
    filterAllTypes: "Todos os tipos",
    finalBalance: "Saldo final",
    inMonth: "em",
    loading: "Carregando…",
    monthLabel: "Mês",
    newBtn: "Novo",
    newEntryTitle: "Novo lançamento",
    noRulesYet: "Nenhuma regra ainda.",
    optAccountPlaceholder: "— conta —",
    reconciledByRule: "por regra",
    reconciledToCompanyAccount: "na conta da empresa.",
    reconciling: "Conciliando…",
    redistributeTitle: "Redistribuir",
    removeDuplicatesBtn: "Remover duplicatas",
    residualFrom: "Residual sai de →",
    residualTo: "Residual →",
    residualZeroTitle: "Residual zerado — reduza um valor já alocado para liberar espaço",
    ruleActive: "ativa",
    ruleInactive: "inativa",
    rulesBtn: "Regras",
    rulesDescription:
      'Se a descrição contém o padrão, o lançamento é conciliado na conta (saída debita a conta; entrada credita). Aplicado no import e no botão "Conciliar automático". Padrão: mín. 2 palavras.',
    rulesPatternLabel: "Padrão (≥ 2 palavras)",
    rulesPatternPlaceholder: "ex.: Milton Vieira",
    rulesTitle: "Regras de conciliação automática",
    save: "Salvar",
    saveChanges: "Salvar alterações",
    searchPlaceholder: "Buscar descrição…",
    selectedCount: "selecionado(s)",
    sources: "Fontes (de qual conta sai)",
    toDistribute: "a distribuir",
    toReconcile: "a conciliar",
    unreconcileTitle: "Desconciliar — volta o lançamento pra pendente (não apaga)",
    warnAddAtLeastOneLine: "Adicione ao menos uma linha com valor.",
    warnAllocatedExceeds: "Valor alocado excede o lançamento.",
    warnFillDateAndDescription: "Preencha data e descrição.",
    warnSymmetricTransfer: "Transferência simétrica: Entrada e Saída devem ser iguais.",
    warningTitle: "Aviso",
  },
  financeImport: {
    accountLabel: "conta",
    andMorePre: "… e mais",
    andMoreSuf: "transações",
    bankLabel: "banco",
    cancel: "Cancelar",
    colAmount: "Valor",
    colDate: "Data",
    colDescription: "Descrição",
    colStatus: "Status",
    companyGeneral: "Geral",
    confirmImportBtn: "✓ Confirmar importação",
    dropzoneEncoding: "Encoding ISO-8859-1 / UTF-8 detectado automaticamente",
    dropzoneFormats: "CSV exportado do banco · Société Générale e outros formatos",
    dropzoneHint: "Arraste o arquivo aqui ou clique para selecionar",
    dropzoneTitle: "Carregar extrato CSV",
    duplicatesSkipped: "duplicatas ignoradas",
    entriesImported: "lançamentos importados",
    headerLineLabel: "cabeçalho linha",
    importing: "Importando…",
    newEntryBtn: "+ Novo lançamento",
    orAddManually: "Ou adicionar manualmente:",
    parsingFile: "Analisando arquivo…",
    previewTitle: "Prévia da importação (primeiras 30)",
    separatorLabel: "separador",
    statementCompanyLabel: "Empresa do extrato:",
    statusPending: "Pendente",
    transactionsDetected: "transações detectadas",
  },
  financeKpis: {
    addBtn: "+ Adicionar",
    balancesInMonth: "Saldos no mês",
    cancel: "Cancelar",
    cardBalanceLandione: "Saldo Landione",
    cardBalanceNeto: "Saldo Neto",
    cardExpensesForecast: "Despesas previstas",
    cardExpensesPaid: "Despesas pagas",
    cardForecastBalance: "Saldo previsto",
    cardForecastBalanceLandione: "Saldo previsto Landione",
    cardForecastBalanceNeto: "Saldo previsto Neto",
    cardInflows: "Entradas",
    cardOperatingCash: "Caixa operacional",
    cardOutflows: "Saídas",
    cardResult: "Resultado",
    closingOf: "fechamento de",
    colTotal: "Total",
    fixedCostsEmpty: "Nenhum custo fixo cadastrado. Adicione impostos mensais, contabilidade, etc.",
    fixedCostsTitle: "Custos fixos mensais",
    formTitle: "Custo fixo mensal",
    labelAmount: "Valor (€)",
    labelCategory: "Categoria",
    labelCompany: "Empresa",
    labelDescription: "Descrição",
    labelExpenses: "Despesas",
    labelRevenue: "Receita",
    loading: "Carregando…",
    monthApr: "abr",
    monthAug: "ago",
    monthDec: "dez",
    monthFeb: "fev",
    monthJan: "jan",
    monthJul: "jul",
    monthJun: "jun",
    monthMar: "mar",
    monthMay: "mai",
    monthNov: "nov",
    monthOct: "out",
    monthSep: "set",
    negativeCashAlertPre: "⚠️ Caixa operacional (Despesas) negativo:",
    negativeCashAlertSuf: "— distribuições/gastos excedem o que entrou.",
    optionAdministrative: "Administrativo",
    optionGeneral: "Geral",
    optionOperational: "Custo operacional",
    optionOther: "Outro",
    optionTax: "Imposto / taxa",
    perMonthSuffix: "/mês",
    period12m: "12m",
    period3m: "3m",
    period6m: "6m",
    periodAll: "Tudo",
    periodCurrentMonth: "Mês atual",
    placeholderDescription: "Ex: Contabilidade",
    rowCompanyAccountBalance: "Saldo conta empresa",
    rowCompanyExpenses: "(-) Despesas empresa",
    rowGrossRevenue: "Receita bruta",
    rowOperationalCosts: "(-) Custos operacionais",
    save: "Salvar",
    sectionBreakdown: "Breakdown consolidado",
    sectionPartners: "Sócios",
    sectionPeriodMovement: "Movimento do período",
    subAfterForecastExpenses: "após despesas previstas",
    subExpensesAccount: "conta Despesas",
    subFixedPlusFuture: "fixos + futuros cadastrados",
    subInflowsMinusOutflows: "entradas − saídas",
    subPaidToDate: "pagas até hoje",
    subReceivedInPeriod: "recebido no período",
    subShare: "participação",
    subSpentInPeriod: "gasto no período",
    toggleByCompany: "ver por empresa ▾",
    toggleHide: "ocultar ▴",
  },
  financeLayout: {
    accountExpenses: "Despesas",
    accountPayTechnician: "Pagar Técnico",
    backToErp: "← ERP",
    monthApr: "abr",
    monthAug: "ago",
    monthDec: "dez",
    monthFeb: "fev",
    monthJan: "jan",
    monthJul: "jul",
    monthJun: "jun",
    monthMar: "mar",
    monthMay: "mai",
    monthNov: "nov",
    monthOct: "out",
    monthSep: "set",
    parameters: "Parâmetros",
    rowClassified: "Classificados",
    rowPending: "Pendentes",
    sumBanks: "Σ = bancos",
    summary: "Resumo",
    tabClosing: "Fechamento",
    tabEntries: "Lançamentos",
    tabImport: "Importar",
    tabKpis: "KPIs",
    totalCash: "Caixa total",
    virtualAccounts: "Contas virtuais",
  },
  financeOpeningBalances: {
    cancel: "Cancelar",
    close: "Fechar",
    confirmSave: "Confirma alterar os saldos de abertura? A mudança fica registrada (quem/quando).",
    save: "Salvar",
    saving: "Salvando…",
    subtitle:
      "Saldo de cada conta antes do 1º lançamento no app. Soma na base de todos os cálculos (sidebar e fechamento).",
    title: "Saldos de abertura",
    yesSave: "Sim, salvar",
  },
  fiscal: {
    accountingCashLabel: "Tesouraria contábil",
    accountingCashTooltip: "Saldo de tesouraria do último lançamento com balanço preenchido",
    accountsSuf: "conta(s)",
    actualCumulative: "Real acumulado",
    aggregateLabel: "Agregado",
    alertDsoHighPre: "Prazo de clientes elevado",
    alertDsoHighSuf: "alerta se > 60 dias.",
    alertGapNarrowPre: "Folga do ponto de equilíbrio estreita",
    alertGapNarrowSuf: "alerta se < 10%.",
    alertLowMarginPre: "Taxa de margem global baixa",
    alertLowMarginSuf: "alerta se < 15%.",
    alertNegativeCashPre: "Tesouraria líquida negativa",
    alertPersonnelHighPre: "Despesas de pessoal elevadas",
    alertPersonnelHighSuf: "alerta se > 35%.",
    annualized: "Anualizado",
    balanceSheetPre: "Balanço",
    bankBalanceEmptyTooltip: "Nenhuma bank_transaction no intervalo do exercício selecionado",
    bankBalanceLabel: "Saldo bancário atual",
    bankBalanceTooltip:
      "Σ opening_balance das contas ativas + Σ amount das bank_transactions no intervalo do FY",
    breakEvenLabel: "Ponto de equilíbrio",
    breakEvenTooltip: "CA mínimo para cobrir custos fixos (econômico) e cash-flow (financeiro)",
    caHtLabel: "CA HT",
    caLabel: "Faturamento",
    caTooltip: "Soma dos customer_invoices issued+paid no exercício",
    cafLabel: "CAF",
    cafTooltip: "Capacidade de autofinanciamento = RL + dotações",
    closedBadge: "Encerrado — recálculo indisponível",
    closedForecastNote:
      "Exercício fechado — dados reais disponíveis. A projeção não é calculada para um exercício encerrado.",
    closedRecomputeTitle: "Exercício fechado — reabra o exercício para recalcular",
    commercialConvention: "Convenção comercial (mês = 30j)",
    computationPre: "Cálculo",
    computedAtPre: "Calculado em",
    contextTitle: "Contexto do exercício",
    corporateTaxLabel: "Imposto sobre sociedades",
    corporateTaxTooltip: "IS lançado nos fiscal_month_entries (acumulado)",
    dpoLabel: "Prazo fornecedores (DPO)",
    dpoTooltip: "(Contas a pagar a fornecedores / Compras consumidas) × nb_jours_exercice",
    dsoLabel: "Prazo clientes (DSO)",
    dsoTooltip: "(Contas a receber de clientes / CA HT) × nb_jours_exercice",
    ebeLabel: "EBE",
    ebeTooltip: "Excedente bruto de exploração = VA − impostos/taxas − despesas de pessoal",
    exercisePre: "Exercício",
    externalChargesLabel: "Despesas externas (total)",
    externalChargesTooltip:
      "Σ fornecimentos + locações + prêmios + intermediários + deslocamentos + tarifas bancárias",
    financialLabel: "Financeiro",
    forecastEmptySubtitle: "Nenhuma projeção gerada ainda. Clique para estimar o fechamento.",
    forecastTitle: "Projeção de Fechamento",
    fyStatusLabel: "Status FY",
    generateForecastBtn: "Gerar projeção",
    generating: "Gerando…",
    goToEntries: "Vá para Lançamentos",
    grossMarginLabel: "Margem global",
    grossMarginTooltip: "CA − Compras consumidas",
    monthsElapsedLabel: "Meses transcorridos",
    monthsElapsedSuf: "meses transcorridos",
    nbMonthsFyLabel: "Nº meses exercício",
    netResultLabel: "Resultado líquido",
    netResultTooltip: "Resultado operacional − IS",
    noBalanceSheet: "Sem balanço",
    noFiscalYearBody: "Não há exercício fiscal selecionado.",
    noFiscalYearTitle: "Sem exercício selecionado",
    noKpisBodyPre: "Este exercício ainda não tem KPIs calculados. Clique em",
    noKpisBodySuf: "acima para gerar.",
    noKpisTitle: "Sem KPIs calculados",
    noTransactionsImported: "Nenhuma transação importada",
    ofCaSuf: "do CA",
    ofVaSuf: "da VA",
    operatingResultLabel: "Resultado operacional",
    operatingResultTooltip: "EBE − dotações − outras despesas + outras receitas",
    otherVarChargesLabel: "Outras despesas var.",
    pctDuCa: "% do CA",
    pctOnCa: "% sobre CA",
    pctOnRe: "% sobre RE",
    pointMortLabel: "Ponto morto",
    pointMortTooltip: "Dias necessários para atingir o seuil de rentabilité",
    purchasesConsumedLabel: "Compras consumidas",
    recomputeBtn: "Recalcular KPIs",
    recomputing: "Recalculando…",
    selectCompanyBody: "Escolha uma empresa no seletor acima para visualizar o módulo fiscal.",
    selectCompanyTitle: "Selecione uma empresa",
    subtitle: "Dashboard KPIs",
    thresholdGapLabel: "Folga do ponto de equilíbrio",
    thresholdGapTooltip: "CA − Seuil. Indica margem de segurança até atingir o ponto de equilíbrio",
    toCreateOneSuf: "para criar um.",
    txSuf: "tx",
    unavailable: "Indisponível",
    vaLabel: "Valor agregado",
    vaTooltip: "Margem global − Despesas externas (PRD §3)",
  },
  fiscalBilan: {
    actif: "Actif",
    autresCreances: "Autres créances",
    autresDettes: "Autres dettes",
    bfr: "BFR",
    bilanAsOf: "Bilan",
    bilanNotFilledPre:
      "Nenhum fiscal_month_entry deste FY tem dados de balanço preenchidos. Acesse",
    bilanNotFilledSuf:
      "e edite um mês incluindo os 8 campos de bilan (immobilisations, créances, trésorerie, capitaux, dettes…).",
    bilanNotFilledTitle: "Bilan non rempli",
    capitauxPropres: "Capitaux propres",
    creancesClients: "Créances clients",
    dettesFinancieres: "Dettes financières",
    dettesFournisseurs: "Dettes fournisseurs",
    dpo: "Délai fournisseurs (DPO)",
    dso: "Délai clients (DSO)",
    ecartBilanTreso: "Écart bilan/trésorerie",
    emptyValue: "— vazio —",
    entriesLabel: "Lançamentos",
    fondsRoulement: "Fonds de roulement (FR)",
    immobilisationsNettes: "Immobilisations nettes",
    mismatchMid: "e Passif",
    mismatchSuf: "não batem — diferença",
    noKpisTitle: "Sem KPIs",
    passif: "Passif",
    runRecompute: "Rode recompute no dashboard.",
    selectCompanyFy: "Selecione empresa + exercício.",
    subtitle: "Bilan patrimonial",
    tooltipBfr: "Créances clients + autres créances − dettes fournisseurs − autres dettes",
    tooltipDpo: "(Dettes fournisseurs / Achats consommés) × nb_jours_exercice",
    tooltipDso: "(Créances clients / CA HT) × nb_jours_exercice",
    tooltipEcart: "Trésorerie do entry − trésorerie nette calculada",
    tooltipFr: "Capitaux propres + dettes financières − immobilisations",
    tooltipTresorerieNette: "FR − BFR",
    totalActif: "Total actif",
    totalPassif: "Total passif",
    tresorerie: "Trésorerie",
    tresorerieEntry: "Trésorerie (entry)",
    tresorerieNette: "Trésorerie nette",
  },
  fiscalBudget: {
    activeBadge: "ativa",
    activeSuffix: "ATIVA",
    archiveLabel: "Arquivar",
    archiveMessage: "Soft delete — libera o nome para reuso. Motivo obrigatório.",
    archivePlaceholder: "ex: cenário descartado",
    archiveTitlePre: "Arquivar revisão",
    baselinePre: "Baseline:",
    cancel: "cancelar",
    cloneLabel: "Clonar",
    cloneMessage: "Novo nome (deve ser único dentro do exercício).",
    colDeltaVsReal: "Δ vs Real",
    colEffective: "Effective",
    colRealiseN: "Realisé N",
    colRubrique: "Rubrique",
    colSuggested: "Suggested",
    colVariationPct: "Variation %",
    compareBtn: "Comparar",
    createBudgetBtn: "+ Criar budget",
    createLabel: "Criar",
    creating: "Criando…",
    daysUnit: "j",
    groupAggregate: "Aggregate",
    groupChargesExternes: "Charges externes",
    groupOtherCharges: "Outras cargas",
    groupOtherIncome: "Outros produtos",
    identificationTitle: "Identificação",
    kpiCaf: "CAF (proj.)",
    kpiEbe: "EBE (proj.)",
    kpiMargeGlobale: "Marge globale (proj.)",
    kpiPointMort: "Point mort (proj.)",
    kpiRn: "RN (proj.)",
    kpiSeuilEco: "Seuil économique (proj.)",
    kpiSeuilFin: "Seuil financier (proj.)",
    kpiVa: "VA (proj.)",
    lineAchatsConsommes: "Achats consommés",
    lineAutresChargesExploitation: "Autres charges d'exploitation",
    lineAutresChargesVariables: "Autres charges variables",
    lineAutresProduitsExploitation: "Autres produits d'exploitation",
    lineCaHt: "Chiffre d'affaires HT",
    lineChargesPersonnel: "Charges de personnel",
    lineDeplacementsReception: "Déplacements & réception",
    lineDotationsAmortissements: "Dotations amortissements",
    lineDotationsProvisions: "Dotations provisions",
    lineFournituresConsommables: "Fournitures & consommables",
    lineFraisBancaires: "Frais bancaires",
    lineImpotSocietes: "Impôt sur les sociétés",
    lineImpotsTaxes: "Impôts & taxes",
    lineIntermediairesHonoraires: "Intermédiaires & honoraires",
    lineLocationsChargesLocatives: "Locations & charges locatives",
    linePrimesAssurance: "Primes d'assurance",
    lineSubventionsExploitation: "Subventions d'exploitation",
    newRevisionBtn: "+ Nova revisão",
    newRevisionMessage: "Nome único dentro do exercício (ex: 'otimista', 'v2-conservador').",
    newRevisionPlaceholder: "ex: otimista",
    newRevisionTitle: "Nova revisão de budget",
    noBudgetHelp:
      "O backend irá resolver automaticamente o FY anterior como baseline, garantir que ele tenha KPIs calculados, e gerar suggested/effective a partir das variations zero (cópia direta do baseline). Depois você pode ajustar.",
    noBudgetSubtitle: "Um budget pode ser criado a partir do FY anterior (auto-detecção).",
    noBudgetTitle: "Sem budget para este exercício",
    overrideTooltip: "Clique para fazer override",
    placeholderExPre: "ex:",
    realN: "Real N",
    revisionLabel: "Revisão",
    save: "Salvar",
    saving: "Salvando…",
    selectCompanyFy: "Selecione empresa + exercício.",
    setActiveBtn: "Marcar ativa",
    subtitle: "Budget N+1",
    toastArchived: "Revisão arquivada.",
    toastSaved: "Budget atualizado.",
    toastSetActive: "Revisão marcada como ativa.",
    updatedAtPre: "Atualizado em",
    variationsSubtitle:
      "Variation % = ajuste sobre o baseline. Override = valor absoluto que ignora a variation.",
    variationsTitle: "Variations & overrides",
  },
  fiscalBudgetCompare: {
    activeSuffix: "ATIVA",
    backToBudgets: "Voltar para budgets",
    colCategory: "Categoria",
    colKpi: "KPI",
    goToBudgets: "Ir para budgets",
    inputsTitle: "Inputs efetivos",
    kpiCaf: "CAF",
    kpiEbe: "EBE",
    kpiMargeGlobale: "Marge globale",
    kpiPointMort: "Point mort (j)",
    kpiResultatExploitation: "Résultat exploitation",
    kpiResultatNet: "Résultat net",
    kpiSeuilEconomique: "Seuil économique",
    kpiSeuilFinancier: "Seuil financier",
    kpiValeurAjoutee: "Valeur ajoutée",
    kpisTitle: "KPIs projetados",
    leftLabel: "Esquerda",
    lineAchatsConsommes: "Achats consommés",
    lineAutresChargesExpl: "Autres charges expl.",
    lineAutresChargesVariables: "Autres charges variables",
    lineAutresProduits: "Autres produits",
    lineCaHt: "CA HT",
    lineChargesPersonnel: "Charges personnel",
    lineDeplacements: "Déplacements",
    lineDotationsAmort: "Dotations amort.",
    lineDotationsProv: "Dotations prov.",
    lineFournitures: "Fournitures",
    lineFraisBancaires: "Frais bancaires",
    lineImpotsTaxes: "Impôts & taxes",
    lineIntermediaires: "Intermédiaires",
    lineIs: "IS",
    lineLocations: "Locations",
    linePrimesAssurance: "Primes assurance",
    lineSubventions: "Subventions",
    needTwoRevisionsPre: "Necessário 2+ revisões para comparar. Atualmente:",
    rightLabel: "Direita",
    selectCompanyYear: "Selecione empresa + exercício.",
    subtitle: "Comparar revisões de budget",
  },
  fiscalEntries: {
    bilanSectionTitle: "Bilan (deixe vazio se não aplicável)",
    cancel: "Cancelar",
    closeFyBtn: "Fechar exercício",
    closeFyFailPre: "Falha ao fechar exercício",
    closeFyModalMsg:
      "Todos os entries não-lockados serão lockados automaticamente. Motivo obrigatório para audit log.",
    closeFyModalTitle: "Fechar exercício fiscal",
    closeFyPlaceholder: "Ex: fechamento contábil 2025",
    closingFy: "Fechando…",
    createEntryTitle: "Criar entry",
    createFyBtn: "Criar exercício",
    creatingFy: "Criando…",
    daysSuf: "dias",
    editEntryTitle: "Editar entry",
    endField: "Fim",
    errorTitle: "Erro",
    fieldAutresChargesExploitation: "Autres charges d'exploitation",
    fieldAutresCreances: "Autres créances",
    fieldAutresDettes: "Autres dettes",
    fieldAutresProduitsExploitation: "Autres produits d'exploitation",
    fieldCapitauxPropres: "Capitaux propres",
    fieldChargesPersonnel: "Charges de personnel",
    fieldCreancesClients: "Créances clients",
    fieldDeplacementsReception: "Déplacements & réception",
    fieldDettesFinancieres: "Dettes financières",
    fieldDettesFournisseurs: "Dettes fournisseurs",
    fieldDotationsAmortissements: "Dotations amortissements",
    fieldDotationsProvisions: "Dotations provisions",
    fieldFournituresConsommables: "Fournitures & consommables",
    fieldFraisBancaires: "Frais bancaires",
    fieldImmobilisationsNettes: "Immobilisations nettes",
    fieldImpotSocietes: "Impôt sur les sociétés",
    fieldImpotsTaxes: "Impôts & taxes",
    fieldIntermediairesHonoraires: "Intermédiaires & honoraires",
    fieldLocationsChargesLocatives: "Locations & charges locatives",
    fieldPrimesAssurance: "Primes d'assurance",
    fieldRecettesATrier: "Entradas a triar (TTC)",
    fieldRecettesEncaisseesHt: "Recettes encaissées HT",
    fieldSubventionsExploitation: "Subventions d'exploitation",
    fieldTresorerie: "Trésorerie",
    fieldTvaCollecteeEncaissements: "TVA coletada (encaissements)",
    fiscalYearPre: "Exercício",
    groupChargesExternes: "Charges externes",
    groupOutrasCargas: "Outras cargas",
    groupOutrosProdutos: "Outros produtos",
    groupRecettes: "Receitas (caixa)",
    invalidValuePre: "Valor inválido em",
    labelField: "Label",
    lockEntryMsg: "Motivo (opcional). Trancar impede edição até unlock por admin.",
    lockEntryPlaceholder: "Ex: fechamento mensal validado",
    lockEntryTitle: "Trancar entry",
    lockFailPre: "Falha ao trancar",
    monthsSuf: "meses",
    newFyBtn: "+ Novo exercício",
    newFyModalTitle: "Novo exercício fiscal",
    reopenConfirm: "Reabrir",
    reopenFyBtn: "Reabrir exercício",
    reopenFyFailPre: "Falha ao reabrir exercício",
    reopenFyModalMsg:
      "Status volta para 'open'. Entries permanecem lockados (use unlock individual quando precisar).",
    reopenFyModalTitle: "Reabrir exercício fiscal",
    reopenFyPlaceholder: "Ex: correção de lançamento",
    reopeningFy: "Reabrindo…",
    save: "Salvar",
    saving: "Salvando…",
    selectCompany: "Selecione uma empresa.",
    selectFyHint: "Escolha um exercício existente ou crie um novo no botão acima.",
    selectFyTitle: "Selecione um exercício",
    startField: "Início",
    subtitle: "Lançamentos mensais",
    syncATrierPre: "⚠ entradas a triar",
    syncBtn: "↻ Sincronizar do banco (custos + receitas)",
    syncBtnTitle:
      "Preenche as caixas de custo dos meses (aluguel, seguro, salário, honorários, materiais, taxas, impostos) a partir do relevé + faturas de compra. Não toca amortização/IS/balanço nem meses fechados.",
    syncFailPre: "Falha ao sincronizar custos",
    syncMonthsSkippedSuf: "pulado(s) (fechados)",
    syncMonthsUpdatedSuf: "mês(es) preenchido(s) a partir do relevé (banco) + faturas de compra",
    syncRecettesPre: "receitas encaissées HT",
    syncRecomputeHint:
      'Agora rode o "↻ Recompute KPIs" no dashboard fiscal para o lucro/SIG atualizar.',
    syncSuccessTitle: "Sincronizado do banco",
    syncingBtn: "Sincronizando…",
    unlockEntryMsg: "Admin only. Motivo obrigatório para audit log.",
    unlockEntryPlaceholder: "Ex: correção solicitada pelo contador",
    unlockEntryTitle: "Destrancar entry",
    unlockFailPre: "Falha ao destravar",
  },
  fiscalResultat: {
    cardSubtitleNoBudget: "Real vs Annualisé — sem budget criado para este FY",
    cardSubtitleWithBudget: "Real vs Annualisé vs Budget N+1",
    cascadeTitle: "Compte de résultat en cascade",
    hintCaf: "RN + dotations amortissements + dotations provisions",
    hintEbe: "VA − impôts/taxes − personnel + subventions",
    hintMargeGlobale: "CA HT − Achats consommés",
    hintValeurAjoutee: "Marge globale − Charges externes",
    noKpisTitle: "Sem KPIs calculados",
    recomputeKpisBtn: "↻ Recompute KPIs",
    rowAchatsConsommes: "− Achats consommés",
    rowAutresChargesExploitation: "− Autres charges d'exploitation",
    rowAutresChargesVariables: "− Autres charges variables",
    rowAutresProduitsExploitation: "+ Autres produits d'exploitation",
    rowCaHt: "Chiffre d'affaires (CA HT)",
    rowCaf: "= CAF",
    rowChargesExternesTotal: "− Charges externes (total)",
    rowChargesPersonnel: "− Charges de personnel",
    rowDeplacementsReception: "Déplacements & réception",
    rowDotationsAmortissements: "− Dotations amortissements",
    rowDotationsProvisions: "− Dotations provisions",
    rowEbe: "= EBE",
    rowFournituresConsommables: "Fournitures & consommables",
    rowFraisBancaires: "Frais bancaires",
    rowImpotSocietes: "− Impôt sur les sociétés",
    rowImpotsTaxes: "− Impôts & taxes",
    rowIntermediairesHonoraires: "Intermédiaires & honoraires",
    rowLocationsChargesLocatives: "Locations & charges locatives",
    rowMargeGlobale: "= Marge globale",
    rowPrimesAssurance: "Primes d'assurance",
    rowResultatExploitation: "= Résultat d'exploitation",
    rowResultatNet: "= Résultat net",
    rowSubventionsExploitation: "+ Subventions d'exploitation",
    rowValeurAjoutee: "= Valeur ajoutée (VA)",
    runRecomputePre: "Rode",
    runRecomputeSuf: "no dashboard.",
    selectCompanyPrompt: "Selecione empresa + exercício no topo.",
    subtitle: "Compte de résultat",
    tresoATrierPre: "Entradas a triar (fora do resultado):",
    tresoColCumule: "Acumulado",
    tresoColDepenses: "Dépenses",
    tresoColMois: "Mês",
    tresoColRecettes: "Recettes HT",
    tresoColResultat: "Résultat",
    tresoColTva: "TVA coletada",
    tresoEmpty: "Sem dados de caixa ainda — rode o “Sincronizar do banco” na aba Lançamentos.",
    tresoNote:
      "Base: relevé bancário categorizado (caixa). Amortizações, provisões e IS não são desembolsos do mês e ficam fora desta visão. TVA coletada é informativa (não soma no résultat).",
    tresoSubtitle:
      "Recettes encaissées HT − dépenses categorizadas do relevé (sincronizadas na aba Lançamentos)",
    tresoTitle: "Résultat caixa — mês a mês",
    tresoTotalLabel: "Total do exercício",
    viewEngagement: "Competência (faturas)",
    viewTresorerie: "Caixa (relevé)",
  },
  fiscalSeuil: {
    achatsConsommes: "Achats consommés",
    autresChargesVar: "Autres charges var.",
    breakevenChartSubtitle: "Cruzamento das curvas Receita × Custos totais. Área verde = lucro.",
    breakevenChartTitle: "Diagramme du point mort",
    caHt: "CA HT",
    chargesFixes: "Charges fixes",
    chargesFixesSeuilFin: "Charges fixes (seuil fin)",
    chargesVariables: "Charges variables",
    componentsSubtitle: "Estrutura de custos do exercício",
    componentsTitle: "Componentes do seuil",
    ecartSeuil: "Écart du seuil",
    ecartSeuilTooltip: "CA − seuil económico",
    margeCv: "Marge CV",
    noKpisHint: "Rode recompute no dashboard.",
    noKpisTitle: "Sem KPIs",
    pctOfCa: "% du CA",
    pointMort: "Point mort",
    pointMortSubtitle: "Convenção comercial (mês = 30j)",
    pointMortTooltip: "Dias até atingir o seuil",
    selectCompanyFy: "Selecione empresa + exercício.",
    seuilEconomique: "Seuil économique",
    seuilEconomiqueTooltip: "Charges fixes / taux de marge sur coûts variables",
    seuilFinancier: "Seuil financier",
    seuilFinancierSubtitle: "Interpretação cash-flow",
    seuilFinancierTooltip: "(CF − dotations + IS − autres produits) / taux",
    subtitle: "Seuil de rentabilité",
    tauxMargeCv: "Taux marge CV",
  },
  fiscalShell: {
    moduleLabel: "Módulo fiscal",
    navBilan: "Balanço",
    navBudget: "Orçamento N+1",
    navEntries: "Lançamentos",
    navKpis: "KPIs",
    navResultat: "Resultado",
    navSeuil: "Ponto de equilíbrio",
    navSig: "SIG",
    navTva: "TVA",
  },
  fiscalSig: {
    achatsSubtitle:
      "A marge = CA − Achats. O Achats vem das faturas INTERCOMPANY (BS→ES) + faturas de TÉCNICO — NÃO de Fournisseurs/Achats. Confira aqui se há duplicata inflando o custo.",
    achatsTitle: "Detalhamento do Achats consommés",
    achatsTotalLabel: "Achats consommés (total)",
    blockCaFormula: "Σ customer_invoices issued+paid",
    blockCaLabel: "Chiffre d'affaires (CA HT)",
    blockCafFormula: "RN + dotations amortissements + dotations provisions",
    blockCafLabel: "CAF (Capacité d'autofinancement)",
    blockEbeFormula: "VA − impôts/taxes − personnel + subventions",
    blockEbeLabel: "EBE",
    blockMargeFormula: "CA HT − Achats consommés",
    blockMargeLabel: "Marge globale",
    blockRexFormula: "EBE − dotations − autres charges + autres produits",
    blockRexLabel: "Résultat d'exploitation",
    blockRnFormula: "Résultat d'exploitation − IS",
    blockRnLabel: "Résultat net",
    blockVaFormula: "Marge globale − Charges externes",
    blockVaLabel: "Valeur ajoutée (VA)",
    cascadeSubtitle: "Cada bloco aplica uma dedução/adição sobre o bloco anterior",
    cascadeTitle: "Cascade SIG",
    colAmount: "Valor",
    colDate: "Data",
    colNumber: "N°",
    colOrigin: "Origem",
    colStatus: "Status",
    emptyState: "Nenhuma fatura intercompany ou de técnico no exercício.",
    intercompanyLabel: "Intercompany",
    isCardSubtitle:
      "Estimativa sobre o résultat d'exploitation acumulado, ANTES dos retraitements fiscais (2058-A) do contador",
    isCardTitle: "IS estimado (15% / 25%)",
    isNoProfit: "Sem lucro acumulado no exercício — IS estimado: 0 €.",
    isRowBase: "Résultat d'exploitation acumulado",
    isRowNet: "Lucro líquido estimado",
    isRowTotal: "IS estimado total",
    isRowTranche15Pre: "Faixa reduzida — até",
    isRowTranche25Pre: "Faixa normal — acima de",
    noKpisHintPre: "Rode",
    noKpisHintSuf: "no dashboard.",
    noKpisTitle: "Sem KPIs",
    recomputeKpisLabel: "↻ Recompute KPIs",
    selectCompanyFy: "Selecione empresa + exercício.",
    subtitle: "Soldes intermédiaires de gestion (SIG)",
    technicianLabel: "Técnico",
  },
  fiscalTva: {
    colAchatsHt: "Achats HT",
    colCaHt: "CA HT",
    colMonth: "Mês",
    colToPayCredit: "A pagar / Crédito",
    computeBtn: "↻ compute",
    computedAtPre: "Calculado em",
    creditSuf: "crédito",
    declareConfirm: "Declarar (travar)",
    declareMessage:
      "Status muda para 'declarada' e bloqueia edição dos campos numéricos. Referência DGFiP (opcional).",
    declarePlaceholder: "Ex: referência retornada pelo impots.gouv.fr",
    declareTitle: "Declarar à DGFiP",
    declaredAtPre: "Declarada em",
    detailPre: "Detalhe",
    emptyMonth: "— vazio —",
    error: "Erro",
    errorGeneratingExport: "Erro ao gerar export",
    exportCsvBtn: "📦 Export CSV",
    exportPdfBtn: "📄 Export PDF",
    generateCsvTitle: "Gerar ZIP com recettes.csv + depenses.csv",
    generatePdfTitle: "Gerar export PDF para o cabinet",
    labelAchatsHtDeductible: "Achats HT dedutível",
    labelCaHtCollected: "CA HT coletado",
    labelCreditReportable: "Crédit reportable",
    labelDgfipReference: "Referência DGFiP",
    labelPaidAmount: "Valor pago",
    labelTvaAPayer: "TVA à Payer",
    lastPre: "último",
    markPaidBtn: "Marcar como paga",
    markPaidConfirm: "Marcar como pago",
    markPaidTitle: "Marcar como paga à DGFiP",
    monthApril: "Abril",
    monthAugust: "Agosto",
    monthDecember: "Dezembro",
    monthFebruary: "Fevereiro",
    monthJanuary: "Janeiro",
    monthJuly: "Julho",
    monthJune: "Junho",
    monthMarch: "Março",
    monthMay: "Maio",
    monthNovember: "Novembro",
    monthOctober: "Outubro",
    monthSeptember: "Setembro",
    overrideAppliedPre: "Override aplicado em",
    overrideSuf: "override",
    paidAtPre: "Pago em",
    regeneratePre: "Regerar",
    reopenConfirm: "Reabrir",
    reopenMessage: "Apenas admin. Volta status para 'rascunho' e desbloqueia edição.",
    reopenPlaceholder: "Motivo da reabertura",
    reopenTitle: "Reabrir a declaração TVA",
    selectCompany: "Selecione uma empresa.",
    status: "Status",
    statusCancelled: "cancelada",
    statusDeclared: "declarada",
    statusDraft: "rascunho",
    statusPaid: "recebida",
    subAchatsHtDeductible: "Soma das faturas de compra (received/paid) do mês",
    subCaHtCollected: "Recebimentos de clientes do mês (encaissements — base caixa, relevé)",
    subCreditReportable: "Déductible − Collectée (mín. 0)",
    subTvaAPayer: "Collectée − Déductible (mín. 0)",
    subtitle: "Declarações TVA (CA3 mensal)",
    suggestedPre: "Sugerido",
    tableSubtitle: "Uma linha por mês. Clique para abrir / calcular.",
    tvaCollectee: "TVA Collectée",
    tvaDeductible: "TVA Déductible",
    tvaYearLabel: "Ano TVA",
    yearPre: "Ano",
  },
  fiscalYearSelector: {
    companyLabel: "Empresa",
    fiscalYearLabel: "Exercício",
    loadingOption: "Carregando…",
    noAccessOption: "— sem acesso —",
    noFiscalYearOption: "— nenhum exercício —",
  },
  forecastPanel: {
    colKpi: "KPI",
    colProjection: "Projeção",
    colRealN1: "Real N-1",
    colVariation: "Variação",
    computedAt: "Projeção calculada em",
    factorLabel: "factor",
    isStrategyLabel: "estratégia IS:",
    isStrategyLancements: "IS lançado × factor",
    isStrategyNone: "Sem estimativa (RE ≤ 0)",
    isStrategyTaxeFr25: "Taxa FR 25% sobre RE",
    linearTrend: "Tendência linear",
    monthsActual: "meses reais",
    monthsProjected: "meses projetados",
    recomputeBtn: "Atualizar projeção",
    recomputing: "Atualizando…",
    rowCaf: "CAF",
    rowChiffreAffaires: "Faturamento",
    rowIsEstime: "IS estimado",
    rowMargeGlobale: "Margem global",
    rowPointMort: "Ponto de equilíbrio",
    rowResultatNet: "Resultado líquido",
    rowTresorerieEstimee: "Tesouraria estimada",
    title: "Projeção de fechamento",
  },
  hailParcDetail: {
    addBtn: "Add",
    autoPlaceholder: "auto",
    backToParcs: "Parc Grêle",
    cancel: "Cancelar",
    cancelInvoiceBtn: "Cancelar fatura",
    catPlaceholder: "Cat",
    close: "Fechar",
    colClient: "Cliente",
    colDebosselage: "Débosselage",
    colForfaitName: "Forfait (nome)",
    colMontage: "Montage",
    colQty: "Qtd",
    colRetained: "Retido ES/BS",
    colTotalHt: "Total HT",
    colUnitPriceHt: "PU HT",
    colVehicle: "Veículo",
    confirmCancelMsgPre: "Cancelar",
    confirmCancelMsgSuf: "Você poderá gerar uma nova.",
    confirmCancelTitle: "Cancelar fatura?",
    downloadPdfBtn: "Baixar PDF",
    downloadTemplate: "Baixar modelo (.xlsx)",
    dueLabel: "vencimento",
    emptyVehicles: "Nenhum veículo ainda.",
    errChooseForfait: "Escolha o forfait.",
    errPdf: "Falha ao gerar o PDF.",
    errPlateOrVin: "Informe placa ou chassi (VIN).",
    errReadFile: "Falha ao ler o arquivo.",
    errorsCountSuffix: "erro(s):",
    forfaitGridHelp:
      "O montage (démontage/remontage) é parte reservada do forfait — não soma ao preço. Retido ES/BS = cliente − débosselage − montage. Deixe o nome vazio para ignorar a linha.",
    forfaitGridTitle: "Grade de preços por veículo (até 5 forfaits)",
    generateInvoiceBtn: "Gerar fatura",
    generating: "Gerando…",
    importBtn: "Importar",
    importModalTitle: "Importar veículos",
    importSheetBtn: "Importar planilha",
    importedSuffix: "veículo(s) importado(s).",
    importing: "Importando…",
    invoiceSectionTitle: "Fatura da carrosserie",
    issuedOnPrefix: "Emitida em",
    labelDebosShort: "Débos.",
    labelForfait: "Forfait",
    labelMake: "Marca",
    labelModel: "Modelo",
    labelPlate: "Placa",
    labelVin: "Chassi (VIN)",
    linePrefix: "Linha",
    linesReadFrom: "linha(s) lidas de",
    loading: "Carregando…",
    missingForfaitSuffix: "sem forfait — serão rejeitadas.",
    missingIdSuffix: "sem placa nem VIN — serão rejeitadas.",
    noForfaitsWarning: "Defina a grade de forfaits antes de cadastrar veículos.",
    noInvoiceHint: "Nenhuma fatura emitida. Gera a fatura com os veículos do parc × forfait.",
    removeFromParcTitle: "Remover do parc",
    saveGridBtn: "Salvar grade",
    saved: "Salvo",
    saving: "Salvando…",
    skippedSuffix: "já estavam no parc (ignorados).",
    statToPayDebos: "A pagar débos.",
    statToPayMontage: "A pagar montage",
    statTotalClient: "Total cliente",
    statusClosed: "Fechado",
    statusOpen: "Aberto",
    techOverClient: "débosselage + montagem passam o valor do cliente — corrija antes de salvar.",
    totalTtc: "Total TTC",
    tvaReverseChargeNote: "TVA non applicable — autoliquidation",
    vehiclesCountSuffix: "veículos",
    vehiclesTitle: "Veículos",
  },
  hailParcs: {
    cancel: "Cancelar",
    colActions: "Ações",
    colCarrosserie: "Carrosserie",
    colDate: "Data",
    colName: "Nome",
    colStatus: "Status",
    create: "Criar",
    createModalTitle: "Novo parc grêle",
    creating: "Criando…",
    customerLabel: "Carrosserie (cliente)",
    emptyState: "Nenhum parc ainda. Crie o primeiro.",
    eventDateLabel: "Data do evento",
    loading: "Carregando…",
    nameLabel: "Nome do chantier",
    namePlaceholder: "Ex: Grêle Montpellier juin 2026",
    newBtn: "+ Novo parc",
    openLink: "abrir",
    selectPlaceholder: "— selecione —",
    statusClosed: "fechado",
    statusOpen: "aberto",
    subtitle: "Chantiers de reparação de granizo — orçamento por forfait",
    title: "Parc Grêle",
    validationNameCustomer: "Informe o nome e a carrosserie.",
  },
  importEdsp: {
    alreadyExisted: "já existiam",
    alreadyExistsInline: "(já existe)",
    clientCol: "Cliente",
    companyBannerPre: "Você está importando para:",
    companyBannerSuf:
      "confira antes de importar (devis, listas e recebimentos entram TODOS nesta empresa).",
    companyLabel: "Empresa:",
    csvColumnsLabel: "CSV ou XLSX com colunas",
    custBadHeader:
      "Cabeçalho não reconhecido — exporte a lista diretamente do eDSP (Nom usuel / Raison sociale / Adresse / CP / Ville).",
    custColName: "Cliente",
    custColStatus: "Status",
    custContactsWord: "contato(s)",
    custEnrichedWord: "enriquecidos",
    custFileClients: "Lista de clientes:",
    custFileContacts: "Lista de contatos (opcional):",
    custHint:
      "Exporte no eDSP a liste-clients.xlsx (e opcionalmente a liste-contacts.xlsx para e-mail/telefone). Sem duplicar: clientes existentes são só enriquecidos (campos vazios).",
    custImportBtn: "Importar clientes",
    custImported: "Clientes importados",
    custPreviewBtn: "Pré-visualizar",
    custRowsWord: "clientes no arquivo",
    custStatusEnrich: "enriquecer",
    custStatusNew: "novo",
    custStatusUnchanged: "já completo",
    custTitle: "Clientes (eDSP)",
    custUnchangedWord: "já completos",
    dateCol: "Data",
    devisAlignBlockedPre: "Não vai alinhar:",
    devisAlignedWord: "alinhados ao devis",
    devisBatchOf: "de",
    devisBatchPre: "lote",
    devisColClient: "Cliente",
    devisColDate: "Data",
    devisColDevis: "Devis",
    devisColFile: "Arquivo",
    devisColPlate: "Placa",
    devisColStatus: "Status",
    devisColTotal: "Total HT",
    devisEnrichedWord: "enriquecidos com peças",
    devisImportBtn: "Importar devis novos",
    devisImported: "Devis importados",
    devisParsing: "Lendo PDFs…",
    devisStatusAlign: "vai alinhar ao devis",
    devisStatusEnrich: "Existente — vai ganhar peças",
    devisStatusError: "erro",
    devisStatusExisting: "já existe",
    devisStatusNew: "novo",
    devisUnreadableHint:
      "Extraia o .zip para uma pasta antes de selecionar (não selecione de dentro do zip) e tente de novo — os demais seguiram normalmente.",
    devisUnreadablePre: "Arquivos que o navegador não conseguiu ler",
    docAttachBtn: "Anexar os originais",
    docColDoc: "Documento",
    docColGestionHt: "HT no Gestion",
    docColPdfHt: "HT no PDF",
    docDupPre: "Mesmo documento de",
    docHint:
      "Anexa o PDF ORIGINAL do eDSP (o documento que o cliente recebeu) à fatura ou ao avoir que já está no Gestion. O Gestion confere número e valores; se não baterem, não anexa. Vários de uma vez, em lotes.",
    docStAlready: "já anexado",
    docStAttach: "a anexar",
    docStAttached: "anexado",
    docStDuplicate: "repetido",
    docStMismatch: "valor diferente",
    docStNotFound: "não existe no Gestion",
    docStUnreadable: "não reconhecido",
    docTitle: "Faturas e avoirs (PDF) do eDSP",
    dossierWord: "dossier",
    dossiersImported: "Dossiers importados",
    emptyRaw: "(vazio)",
    errorsLabel: "Erros",
    existLabel: "já existem",
    failures: "falhas",
    file1Title: "Arquivo 1 — Dossiers / Faturas",
    file2Title: "Arquivo 2 — Encaissements",
    file3Hint:
      'Exporte os devis do eDSP em PDF e selecione vários de uma vez — cria dossiers "a executar" com a decomposição do devis, sem fatura.',
    file3Title: "Devis (PDF) — antes da fatura",
    importAction: "Importar",
    importReceiptsBtn: "Importar receipts",
    importingLabel: "Importando…",
    invoiceSettledInline: "(fatura já quitada por outro recibo — pulada)",
    invoicesSplitCol: "Faturas (split)",
    lineLabel: "Linha",
    linesParseErrorExpand: "linha(s) com erro de parse — clique para expandir",
    mailAddress: "Encaminhar para:",
    mailColDetail: "Detalhe",
    mailColDevis: "Devis · placa",
    mailColFrom: "Remetente",
    mailColStatus: "Situação",
    mailColWhen: "Recebido",
    mailDisabled: "recebimento desligado no servidor",
    mailEmpty: "Nenhum email recebido ainda.",
    mailHint:
      "O técnico envia o devis pelo eDSP para a caixa da empresa, que encaminha para o endereço abaixo. O Gestion lê o PDF e cria o devis sozinho, na empresa do emissor impresso (EURO STORM ou BRAZILIAN STORMS). Devis reenviado de um carro que já existe atualiza as linhas (salvo fatura emitida ou linha paga). Atualiza a cada 30 s.",
    mailNoAddress: "endereço ainda não configurado",
    mailStDuplicate: "já existia",
    mailStEnriched: "completado",
    mailStError: "erro",
    mailStIgnored: "ignorado",
    mailStImported: "criado",
    mailStProcessing: "processando",
    mailStReview: "a revisar",
    mailStUpdated: "atualizado",
    mailTitle: "Devis recebidos por email",
    morePre: "e mais ",
    moreSuf: ".",
    new: "novos",
    noInvoiceV2: "sem fatura no v2",
    noValueInline: "(sem valor líquido — pulada)",
    oldPdfAttachBtn: "Guardar os PDFs",
    oldPdfColDevis: "Nº do devis",
    oldPdfColDossier: "Dossier",
    oldPdfHint:
      'Para carros importados antes de 26/10/2026, quando o Gestion ainda não guardava o arquivo: baixe os devis de novo no eDSP e escolha os PDFs aqui. O Gestion acha o dossier pelo nº do devis e pela placa e só guarda o PDF, que aparece em "PDF original". Não reimporta e não muda valores, linhas nem franquia. Vários de uma vez, em lotes.',
    oldPdfStAlready: "já guardado",
    oldPdfStAmbiguous: "mais de um dossier",
    oldPdfStAttach: "a guardar",
    oldPdfStAttached: "guardado",
    oldPdfStNotFound: "dossier não achado",
    oldPdfStUnreadable: "não é devis",
    oldPdfTitle: "PDFs antigos de devis (só guardar)",
    oldPdfViaPlate: "achado pela placa (o nº do devis não estava no dossier)",
    omitted: "omitidas",
    openDossierTag: "fatura o dossier em aberto do carro",
    parseErrorsBadge: "erros de parse",
    parseErrorsShort: "erros parse",
    parseErrorsSummaryShort: "linha(s) com erro de parse",
    parsingLabel: "Parseando…",
    partialLabel: "parciais",
    readOnlyNote:
      "Somente leitura — importação disponível apenas para usuários com permissão de edição.",
    receiptsColumnsNote:
      ". N° Facture pode conter múltiplos números separados por espaço (split pro-rata pelo Prix Net).",
    receiptsCreated: "Receipts criados",
    receiptsDisabledNote:
      "Desativado. Os pagamentos dos clientes agora entram só pela conciliação do extrato bancário (Banco → Conciliação), com o dinheiro que de fato caiu na conta.",
    repairsApplyFixesPre: "aplicar correções de valores",
    repairsApplyFixesSuf:
      "confira o devis antes: se o HT do arquivo já for o líquido (remise aplicada no eDSP), NÃO marque",
    repairsBadHeader:
      "Cabeçalho não reconhecido — esperado: Client, Date Réparation, N° Ordre, Utilisateur, HT, Immatriculation.",
    repairsChipExists: "já existem",
    repairsChipFix: "a corrigir (valores)",
    repairsChipMismatch: "divergência de técnico",
    repairsChipNew: "novos",
    repairsChipNoPlate: "sem placa (carro novo · VIN)",
    repairsChipPlateConflict: "nº usado por outro carro",
    repairsColClient: "Cliente",
    repairsColDate: "Reparo",
    repairsColOrdre: "Ordem",
    repairsColPlate: "Placa",
    repairsColStatus: "Status",
    repairsColTech: "Técnico",
    repairsCreatedWord: "criadas",
    repairsDevisNoTech:
      "só existe como devis, sem técnico, e já tem fotos/checks — o técnico assume no portal",
    repairsEmptyFile: "Arquivo sem linhas de reparação.",
    repairsFixedWord: "corrigidas",
    repairsHint:
      'Exportação de reparações do eDSP: cria os carros reparados que ainda não existem no Gestion, com status Reparado, técnico do arquivo e comissão pelo par — eles caem no card "a faturar" do Painel. Re-importável: quem já existe (nº de ordem ou placa) é pulado.',
    repairsImportBtn: "Importar reparações",
    repairsNoPlateCandidatesPre: "provável:",
    repairsNoPlateMsg:
      "sem placa no arquivo — carro novo entra pelo devis (VIN); esta ordem não cria dossier",
    repairsResultPre: "Reparações importadas",
    repairsStatusExists: "já existe",
    repairsStatusNew: "novo",
    repairsTagMismatchPre: "no Gestion:",
    repairsTagNewTech: "técnico será criado",
    repairsTagNoPair: "sem par ou 0%",
    repairsTagPlateConflictPre:
      "nº de ordem já usado por outro carro — não entra; placa existente:",
    repairsTitle: "Reparações (liste-orders)",
    repairsUpgradeDevisPre: "completa o devis",
    repairsWillFix: "valores serão corrigidos ao importar (remise do cliente)",
    settledLabel: "já quitados (nada a criar)",
    settledWord: "quitado",
    statusCol: "Status",
    technicianCol: "Técnico",
    warningsLabel: "Avisos",
  },
  intermediaries: {
    awaitingSuf:
      "carro(s) aguardando o pagamento do cliente — entram quando o cliente pagar. Total",
    badgeActive: "ativo",
    badgeInactive: "inativo",
    blockedSuf: "dossier(s) já estão em outra proforma ativa e foram ignorados:",
    cancelBtn: "Cancelar",
    closeBtn: "Fechar",
    colActions: "Ações",
    colAmount: "Valor",
    colCountry: "País",
    colCustomer: "Cliente",
    colDossier: "Dossier",
    colEmail: "Email",
    colName: "Nome",
    colPlate: "Placa",
    colStatus: "Status",
    colTaxId: "ID fiscal",
    colTechnician: "Técnico",
    deactivateBtn: "desativar",
    dossierCount: "dossier(s)",
    editBtn: "editar",
    emptyState: "Nenhum intermediário externo cadastrado.",
    fieldCountry: "País (2 letras)",
    fieldEmail: "Email",
    fieldName: "Nome *",
    fieldNotes: "Notas",
    fieldPhone: "Telefone",
    fieldTaxId: "ID fiscal",
    fieldTaxIdKind: "Tipo do ID",
    fieldTaxIdPlaceholder: "SIRET / TVA / CNPJ…",
    generatePaymentBtn: "gerar pagamento",
    generateProformasBtn: "Gerar proforma(s)",
    generatingBtn: "Gerando…",
    includeInactive: "Incluir inativos",
    loading: "Carregando…",
    loadingEligible: "Buscando dossiers elegíveis…",
    modalTitleEdit: "Editar intermediário",
    modalTitleNew: "Novo intermediário externo",
    newBtn: "+ Novo intermediário",
    noEligible:
      "Nenhum dossier elegível no momento (nada a pagar ou todos já estão em proforma ativa).",
    payModalSubtitle:
      "Proforma somando comissão do técnico + do intermediário (o externo repassa o técnico por fora). Um documento por empresa pagadora.",
    payModalTitle: "Gerar pagamento",
    payingCompaniesSuf: "empresas pagadoras",
    proformaGeneratedSingular: "Proforma gerada com sucesso.",
    proformasGeneratedSuf: "proformas geradas com sucesso.",
    reactivateBtn: "reativar",
    saveBtn: "Salvar",
    savingBtn: "Salvando…",
    searchPlaceholder: "Buscar por nome / email / ID fiscal…",
    subtitle:
      "Pessoas/empresas de fora do grupo que ganham comissão. Vinculados por par técnico×cliente; o pagamento (proforma) é gerado aqui.",
    title: "Intermediários externos",
    totalLabel: "Total",
    viewInProformas: "Ver em Proformas →",
  },
  invites: {
    accessGrantedTo: "Acesso concedido a:",
    actions: "Ações",
    alreadyHadAccess: "Já tinha acesso/convite em:",
    cancel: "Cancelar",
    companiesLabel: "Empresas (uma ou mais)",
    companyLabel: "Empresa:",
    email: "E-mail",
    emailLang: "Idioma do e-mail",
    expires: "Expira",
    inviteSentTitle: "Convite enviado",
    invitedBy: "Convidado por",
    loading: "Carregando…",
    name: "Nome",
    newInviteBtn: "+ Novo convite",
    noInvites: "Nenhum convite registrado.",
    notAdminOfAnyCompany: "Você não é administrador de nenhuma empresa.",
    pageTitle: "Convites",
    permission: "Permissão",
    resend: "Reenviar",
    revoke: "Revogar",
    revokeConfirmPre: "O convite enviado para",
    revokeConfirmSuf: " será cancelado. O link de aceitar deixa de funcionar.",
    revokeInviteTitle: "Revogar convite",
    roleAdmin: "Administrador",
    roleAdminOption: "Administrador (gestão)",
    roleClient: "Cliente",
    roleClientOption: "Cliente (portal)",
    roleManager: "Gerente",
    roleManagerOption: "Gerente de projeto (chantier)",
    roleTechnician: "Técnico (portal)",
    roleTechnicianOption: "Técnico (portal — sem acesso ao ERP)",
    roleUser: "Usuário",
    roleUserOption: "Usuário (operacional)",
    roleViewer: "Visualizador",
    roleViewerOption: "Visualizador (somente leitura)",
    selectAtLeastOneCompany: "Selecione ao menos uma empresa.",
    sendInvite: "Enviar convite",
    sending: "Enviando…",
    status: "Status",
    statusAccepted: "Aceito",
    statusExpired: "Expirado",
    statusPending: "Pendente",
    statusRevoked: "Revogado",
  },
  invoiceDraft: {
    ackWarnings: "Li os avisos acima e quero emitir assim mesmo.",
    bankDefaultTag: "padrão",
    blocksWord: "bloqueio(s)",
    cClientesDiferentes: "Carros de clientes diferentes não cabem numa fatura só.",
    cDegarnPre: "dégarnissage pendente de",
    cDegarnSuf: "— lance antes de faturar.",
    cDevis: "Orçamento (devis)",
    cFatura: "fatura",
    cFranquiaExcecao:
      "TTC (exceção neste carro): a fatura sai cheia; só as comissões dos técnicos foram reduzidas.",
    cFranquiaNaoInformada: "franquia não informada na recepção.",
    cFranquiaParticular:
      "TTC (particular): a fatura sai cheia; só a comissão do técnico é reduzida.",
    cFranquiaPre: "franquia de",
    cFranquiaPro: "TTC (profissional): já descontada da fatura e da comissão.",
    cJaFaturado: "já faturado (fatura emitida).",
    cOldAvoir: "a fatura antiga tem avoir emitido de",
    cOldPaid:
      "Pagamento já recebido na fatura antiga passa para a nova; o que sobrar vira crédito do cliente:",
    cParticularSemTva:
      "Cliente particular cadastrado sem TVA: particular paga TVA — confira o cadastro.",
    cProSemRemise:
      "Cliente profissional sem desconto (remise) configurado: as comissões podem sair erradas.",
    cProSemSiret: "Cliente profissional sem SIRET nem nº de TVA.",
    cReparoIncompleto: "reparo incompleto, falta:",
    cReplaces: "Substitui a fatura",
    cSemComissao: "linha(s) sem comissão configurada (par técnico × cliente).",
    cSemEmail: "Cliente sem e-mail: a fatura não poderá ser enviada pelo Gestion.",
    cSemEndereco: "Cliente sem endereço: a fatura precisa do endereço do cliente.",
    cSemPlaca: "Carro sem placa nem VIN: a fatura sai sem identificar o veículo.",
    cTecnicoAReceber:
      "técnico já pago pela proforma anterior ainda tem a receber (devis subiu): pague à parte",
    cTotalZero: "valor zero: nada a faturar.",
    cTudoCerto: "Tudo certo: nenhum problema encontrado.",
    checksTitle: "Conferência automática",
    createdBy: "criado por",
    discardBtn: "Descartar rascunho",
    draftsChip: "Rascunhos",
    draftsPanelTitle: "Rascunhos de fatura (ainda não emitidos)",
    errBlocked: "A conferência encontrou um bloqueio: corrija antes de emitir.",
    errReplacementHasPayment:
      "A fatura antiga tem pagamento recebido: valide a substituição (o pagamento passa para a nova). Não dá para descartar.",
    errWarnings: "Marque que leu os avisos antes de emitir.",
    fieldBankAccount: "Receber na conta",
    fieldDue: "Vencimento",
    fieldNotes: "Observações",
    fieldNumber: "Nº da fatura (vazio = próximo da série)",
    issueAndSendBtn: "Emitir e enviar",
    issueAndSendTitle: "Emite a fatura e abre o envio por e-mail ao cliente (PDF anexado).",
    issueBtn: "Validar e emitir",
    issuedOk: "Fatura emitida:",
    numberJumpRetry: "O nº digitado pula a série. Emitir assim mesmo?",
    openDraft: "📝 Rascunho aberto",
    openNewTab: "Abrir em nova aba",
    pdfBtn: "Ver PDF (rascunho)",
    previewLoading: "Gerando a prévia…",
    previewStale: "Salve as alterações para atualizar a prévia.",
    previewTitle: "Prévia do PDF (rascunho)",
    replacesCancelled: "já cancelada",
    replacesOld: "total anterior",
    replacesPayment: "pagamento já recebido, transferido para a fatura nova:",
    replacesPre: "Substitui a fatura",
    reverseCharge: "Autoliquidação (sem TVA)",
    save: "Salvar alterações",
    saveAsDraft: "📝 Rascunho e conferência",
    saveFirst: "Salve as alterações primeiro",
    sendNowBtn: "Enviar por e-mail",
    sentToPre: "enviada para",
    stepDelivery: "entrega",
    stepMontage: "montagem",
    stepMontagePhases: "etapas da montagem (desmontar/remontar)",
    stepPdr: "desamassamento (PDR)",
    summaryTitle: "Resumo (valores atuais dos dossiers)",
    title: "Rascunho de fatura",
    totalHt: "Total sem TVA (HT)",
    totalTtc: "Total com TVA (TTC)",
    tva: "TVA de",
    warningsWord: "aviso(s)",
  },
  invoiceNew: {
    addDossiers: "+ Acrescentar dossiers",
    addDossiersTitle: "Selecione mais dossiers do mesmo cliente e emita novamente",
    alreadyInvoicedBadge: "já faturado — será excluído",
    cancel: "Cancelar",
    cannotIssueTitle: "Resolva os bloqueios acima (cliente único, ao menos 1 dossier válido).",
    colDossier: "Dossier",
    colPlate: "Matrícula",
    colTotalHt: "Total HT",
    colVehicle: "Veículo",
    confirmEmit: "Confirmar e emitir",
    customer: "Cliente",
    degarnOpenBadge: "dégarnissage não concluído:",
    degarnOpenTitle:
      "O dégarnissage foi assumido, mas falta marcar a desmontagem ou a montagem. O valor já está nesta fatura.",
    degarnPendingBadge: "dégarnissage fora:",
    degarnPendingTitle:
      "O devis tem dégarnissage, mas ninguém o registrou: o valor não entra nesta fatura. Lance pelo portal antes de faturar, ou fature sem ele.",
    differentCustomersBold: "clientes diferentes",
    differentCustomersPre: "Os dossiers selecionados são de",
    differentCustomersSuf:
      "Uma fatura consolidada precisa ser de um único cliente — remova os que não pertencem.",
    dueQuick15: "15 dias",
    dueQuick30: "30 dias",
    dueQuick60: "2 meses",
    dueQuick7: "1 semana",
    emailPlaceholder: "deixe vazio p/ não enviar",
    fieldDueDate: "Data de vencimento (opcional)",
    fieldEmail: "Email do cliente (envia a fatura ao confirmar)",
    fieldInvoiceNumber: "Nº da fatura (segue o último; edite p/ o padrão da empresa)",
    fieldNotes: "Notas (interno, opcional)",
    invoiceNumberPlaceholder: "ex.: F-2026-0001",
    issuer: "Emissor",
    issuing: "Emitindo…",
    loadingPreview: "Carregando preview…",
    noDossierPre: "Nenhum dossier selecionado. Volte a",
    noDossierSuf: "e use “Emitir fatura”.",
    numberJumpAsk:
      "Todas as faturas seguintes vão continuar a partir deste número. Confirmar mesmo assim?",
    numberJumpConfirm: "Emitir com este número",
    numberJumpMid: "pula",
    numberJumpMid2: "posições da série — o próximo seria",
    numberJumpTitle: "Número fora da sequência",
    removeDossierTitle: "Remover este dossier da fatura",
    reverseChargeNote: "Autoliquidação — TVA devida pelo destinatário (art. 283-2 CGI).",
    servicePlural: "serviços",
    serviceSingular: "serviço",
    toastEmailFailed: "emitida, mas o envio do email falhou",
    toastInvoiceWord: "Fatura",
    toastIssued: "emitida",
    toastSentTo: "e enviada para",
    totalTtc: "Total TTC",
  },
  invoices: {
    allCustomers: "Todos clientes",
    allStatuses: "Todos status",
    allocateMenu: "Carros quitados pelo pagamento",
    amendDonePre: "atualizada no mesmo número",
    amendDoneResend: "Reenvie ao cliente.",
    amendDoneTitle: "Fatura atualizada",
    amendNoChange:
      "Os valores dos carros são os mesmos da fatura: nada mudou. Para mudar o valor, edite o devis do carro (Modificar devis); a fatura acompanha no mesmo número.",
    amendedResendBadge: "reenviar ao cliente",
    amendedResendHint:
      "O devis mudou depois da emissão e a fatura foi refeita no mesmo número. Envie a versão nova ao cliente (E-mail) ou marque como enviada fora do Gestion.",
    amendedResentNote: "versão atual já enviada ao cliente",
    amendedTitle: "Modificada em",
    amountHtLabel: "Valor HT",
    attach: "Anexar",
    attachMenu: "Anexar PDF externo",
    attachPdfErrorPre: "Erro ao anexar PDF: ",
    attachStatement: "Anexar o relevé de compte (faturas em aberto)",
    attachTitle: "Anexar PDF externo desta fatura (usado no relatório mensal ao contador)",
    avoirBtn: "Avoir",
    avoirCreateErrorTitle: "Erro ao criar avoir",
    avoirCreatedMid: " — TTC ",
    avoirCreatedSuf: ".",
    avoirCreatedTitle: "Avoir criado",
    avoirDeleteConfirmPre: "Apagar o avoir ",
    avoirDeleteConfirmSuf: "? Esta ação não pode ser desfeita.",
    avoirDeleteConfirmTitle: "Apagar avoir?",
    avoirDeleteErrorTitle: "Erro ao apagar avoir",
    avoirDeleteTitle: "Apagar avoir",
    avoirFullBtn: "Avoir completo",
    avoirMenu: "Emitir avoir",
    avoirModalTitle: "Avoir (nota de crédito)",
    avoirNumberLabel: "Nº do avoir",
    avoirPartialBtn: "Avoir parcial",
    avoirStatusCancelled: "anulado",
    avoirStatusEmbedded: "já descontado na fatura",
    backAllClients: "Todos os clientes",
    badgeAmended: "modificada",
    badgeCancelled: "cancelada",
    badgeIssued: "emitida",
    badgePaid: "recebida",
    badgeVoid: "anulada",
    bankChangeBtn: "Trocar conta",
    bankChangeDone: "Conta trocada: o PDF foi regerado com o mesmo número. Reenvie ao cliente.",
    bankChangeLocked: "fatura paga: a conta não muda",
    bankChangeReasonPh: "Motivo da troca (fica na auditoria)",
    bankChangeResend: "Reenviar por e-mail",
    bankChangeSave: "Trocar e regerar o PDF",
    bulkAttachLabel: "Anexar PDFs em massa:",
    bulkDoneTitle: "Upload em massa concluído",
    bulkErrorTitle: "Erro no upload em massa",
    bulkFailedMid: " falharam no envio: ",
    bulkFailedPre: "❌ ",
    bulkHintMid: "). ",
    bulkHintOr: " ou ",
    bulkHintPre: "Nomeie cada PDF como a fatura (ex.: ",
    bulkHintStrong: '"Selecionar pasta"',
    bulkHintSuf: " pega todos de uma vez.",
    bulkOkPre: "✅ ",
    bulkOkSuf: " PDF(s) anexado(s) com sucesso.",
    bulkSelectTitle: "Selecione vários PDFs de uma vez; cada um é anexado à fatura de mesmo número",
    bulkUnmatchedMid: " sem fatura correspondente: ",
    bulkUnmatchedPre: "⚠️ ",
    byClientColCount: "Faturas",
    byClientColOverdue: "Em atraso",
    byClientHint:
      "Clique no cliente para abrir as faturas dele. Em atraso = emitida, sem recebimento e com vencimento passado.",
    cancel: "Cancelar",
    cancelInvoiceBtn: "Cancelar fatura",
    cancelInvoiceHint: "A fatura fica cancelada (o número não se reutiliza). Informe o motivo.",
    cancelledOn: "Cancelada em",
    checking: "Verificando…",
    chipAll: "Todas",
    chipAmended: "Modificadas — reenviar",
    chipAwaiting: "A receber",
    chipOverdue: "Em atraso",
    chipPartial: "Parcial",
    chipsAria: "Filtrar por situação",
    cleanDuplicates: "Limpar duplicados",
    cleanupDoneTitle: "Limpeza concluída",
    cleanupErrorTitle: "Erro na limpeza",
    clearFilters: "limpar filtros",
    clearSearch: "limpar",
    clearSearchTitle: "Limpar busca",
    clearSelection: "limpar seleção",
    close: "Fechar",
    colActions: "Ações",
    colCars: "Carros",
    colCustomer: "Cliente",
    colDate: "Data",
    colHt: "HT",
    colInvoiceNumber: "Nº fatura",
    colNum: "Nº",
    colServices: "Serviços",
    colSituation: "Situação",
    colStatus: "Status",
    colTotal: "Total",
    colTotalHt: "Total HT",
    colTtc: "TTC",
    colType: "Tipo",
    collectBtn: "Cobrar (relance)",
    companyLabel: "Empresa:",
    consolidatedBadge: "vários carros",
    consolidatedExplain:
      "Fatura de vários carros (uma fatura só para vários dossiers, ex.: fatura mensal do cliente). Abra cada carro pelos dossiers.",
    consolidatedNoLinkHint: "Fatura consolidada (vários dossiers) — abra pelos dossiers",
    createAvoirBtn: "Criar avoir",
    creating: "Criando…",
    creditNoteTitle: "Gerar avoir (nota de crédito)",
    creditTypeCommercial: "Remise comercial (reduz CA)",
    creditTypeError: "Correção de erro (reduz CA)",
    creditTypeIrrecoverable: "Irrecuperável (perda, não reduz CA)",
    creditTypeReturn: "Devolução (reduz CA)",
    customersWord: "clientes",
    dayWord: "dia",
    daysWord: "dias",
    dedupeConfirmP1: "Encontrei ",
    dedupeConfirmP2: " cópia(s) duplicada(s) em ",
    dedupeConfirmP3: " documento(s) (~",
    dedupeConfirmP4:
      " MB). Mantenho sempre a mais recente de cada e removo o resto. Esta ação não pode ser desfeita. Confirmar?",
    dedupeTitle: "Remove cópias duplicadas do mesmo PDF (mantém a mais recente)",
    deleteConfirm: "Apagar",
    detailBankAccount: "Conta de recebimento",
    detailCars: "Carros",
    detailDue: "Vencimento",
    detailEditHint:
      "Fatura emitida: quando o devis do carro muda, ela é atualizada no mesmo número e fica marcada para reenviar ao cliente. Desconto pontual: avoir.",
    detailGeneratePdf: "Gerar PDF",
    detailIssued: "Emitida",
    detailReceived: "Recebido",
    detailReceivedOn: "Recebida em",
    email: "Email",
    emailBtn: "E-mail",
    emailFailedTitle: "Falha no envio",
    emailMessageLabel: "Mensagem (opcional)",
    emailMessagePh: "Substitui a frase padrão do e-mail. A fatura continua em anexo.",
    emailModalInvoicePre: "Fatura",
    emailModalTitle: "Enviar fatura por email",
    emailSentMid: " enviada para ",
    emailSentPre: "Fatura ",
    emailSentSuf: ".",
    emailSentTitle: "Email enviado",
    emailTitle: "Enviar fatura por email",
    emptyState: "Nenhuma fatura.",
    filterCompanyLabel: "Empresa",
    filterSearchLabel: "Buscar",
    filterStatusLabel: "Situação",
    folderSelectTitle: "Escolha a PASTA inteira de PDFs — sem precisar selecionar um a um",
    generatePdfOption: "Gerar PDF ▾",
    generatePdfTitle:
      "Gerar PDF da fatura — o idioma vem da empresa (Euro Storm → francês, Brazilian Storms → inglês) ou escolha aqui",
    generateReportBtn: "Gerar relatório (PDF com links)",
    generating: "Gerando…",
    invalidMonthMsg: "Escolha um mês válido.",
    invalidMonthTitle: "Mês inválido",
    langAuto: "Idioma automático",
    loading: "Carregando…",
    markSentMenu: "Marcar como enviada (fora do Gestion)",
    markSentPh: "Ex.: entregue em mãos, enviada pelo WhatsApp",
    markSentTitle: "Como a fatura foi entregue ao cliente?",
    matchingFiles: "Casando arquivos com faturas…",
    modifyBtn: "Modificar fatura",
    modifyHint:
      "A fatura é refeita com os valores atuais do carro (devis e ordem de reparação), no MESMO número e para o mesmo cliente. A versão anterior fica guardada e a fatura fica marcada para reenviar ao cliente. Para mudar o valor, edite antes o devis do carro. Motivo:",
    monthlyChartTitle: "Faturado por mês (HT)",
    monthlyInReportNote: "O faturado por mês está em Relatórios → Relatório CA.",
    monthlyReportLabel: "Relatório mensal (contador):",
    moreBtn: "Mais",
    next: "Próxima",
    noCustomerEmailMsg: "Cliente sem email cadastrado — informe um endereço.",
    noDuplicatesMsg: "Nenhum anexo duplicado encontrado nesta empresa.",
    noDuplicatesTitle: "Sem duplicatas",
    noInvoices: "Nenhuma fatura",
    noPdfYet: "PDF ainda não gerado — use o menu ⋮",
    openDetailTitle: "Abrir a fatura (ações, carros, recebimentos)",
    openDossierBtn: "Abrir o dossier",
    openInvoiceBtn: "Abrir",
    openPdfErrorPre: "Erro ao abrir PDF: ",
    or: "ou",
    overdueBadge: "atrasada",
    overdueSince: "Vencida em",
    pagePre: "Página ",
    pageSubInvoices: "faturas",
    pageTitle: "Faturas",
    pdfAttachedMsg:
      "O PDF externo foi anexado à fatura e será usado no relatório mensal ao contador.",
    pdfAttachedTitle: "PDF anexado",
    pdfAutoAttachedMsg: "O PDF da fatura é anexado automaticamente.",
    pdfBtn: "PDF",
    pdfErrorPre: "Erro ao gerar PDF: ",
    pdfMenuGen: "Gerar o PDF em",
    pdfMenuRegen: "Refazer o PDF em",
    previous: "Anterior",
    reasonLabel: "Motivo (opcional)",
    reasonPlaceholder: "Remise de 40% sobre o devis…",
    receivedOnPre: "recebida em",
    recipientEmailLabel: "Email do destinatário",
    recipientEmailPlaceholder: "cliente@exemplo.com",
    regeneratePdfTitle: "Refazer o PDF (substitui o arquivo atual)",
    registerReceiptBtn: "Registrar recebimento",
    reissueBtn: "Reemitir",
    reissueDonePre: "Nova fatura:",
    reissueDoneTitle: "Fatura reemitida",
    reissueHint:
      "Cancela esta fatura e emite uma nova com os valores atuais do dossier (novo número). Informe o motivo.",
    relancerBtn: "Cobrar",
    relancerTitle: "Enviar relance (cobrança) desta fatura por e-mail, com o PDF anexo",
    remainingPre: "falta",
    reminderBatchMultiCustomers:
      "Faturas de vários clientes: cada cliente recebe um e-mail no endereço de faturação cadastrado, com as faturas dele em anexo.",
    reminderBatchSentTitle: "Cobranças enviadas",
    reminderBatchTitlePre: "Cobrar",
    reminderBatchTitleSuf: "faturas",
    reminderModalHint:
      "Será enviado um e-mail de RELANCE (cobrança amigável) com a fatura em PDF anexa.",
    reminderModalTitle: "Cobrar o cliente",
    removeDuplicatesConfirm: "Remover duplicatas",
    removeDuplicatesTitle: "Remover anexos duplicados",
    removedDuplicatesPre: "Removidas ",
    removedDuplicatesSuf: " duplicata(s).",
    replacedBy: "substituída por",
    reportErrorPre: "Erro ao gerar relatório: ",
    reportGeneratedTitle: "Relatório gerado",
    reportHint:
      "Lista as faturas emitidas no mês com link p/ baixar o PDF de cada uma (anexo externo se houver, senão o gerado).",
    reportMsgP1: " fatura(s) no mês · Total HT ",
    reportMsgP2: " · TTC ",
    reportMsgP3: ".",
    reportWarnPre: " ⚠️ ",
    reportWarnSuf:
      ' fatura(s) sem PDF — anexe o PDF na linha da fatura (botão "⬆ Anexar") e gere de novo.',
    resyncApplyPre: "Aplicar em",
    resyncBtn: "Re-sincronizar valores",
    resyncBtnTitle:
      "Corrige o valor da fatura a partir das linhas do dossier (após um Recalcular comissões)",
    resyncClose: "Fechar",
    resyncColInvoice: "Fatura",
    resyncColNew: "Corrigido (HT)",
    resyncColOld: "Valor atual (HT)",
    resyncColReceipt: "Recibo eDSP",
    resyncDoneSuf: "fatura(s) corrigida(s). Rode o Sincronizar/Recompute do fiscal em seguida.",
    resyncEmpty: "Tudo coerente — nenhuma fatura difere das linhas.",
    resyncHelp:
      "Lista as faturas do exercício aberto cujo valor difere da soma das linhas do dossier (ex.: devis inflado do importador antigo). Aplicar corrige o snapshot da fatura e o recibo do eDSP correspondente. Nada é alterado sem a sua confirmação.",
    resyncLoading: "Analisando…",
    resyncRun: "Verificar diferenças",
    resyncTitle: "Re-sincronizar valores (linhas → faturas)",
    searchPlaceholder: "Buscar nº da fatura ou placa… (ex.: F2025-00274, GK-294-GV)",
    selectAllOpenTitle: "Selecionar todas as faturas em aberto desta página",
    selectFolder: "Selecionar pasta",
    selectForReminderTitle: "Selecionar para cobrança",
    selectPdfs: "Selecionar PDFs…",
    selectedMany: "faturas selecionadas",
    selectedOne: "fatura selecionada",
    send: "Enviar",
    sendReminder: "Enviar relance",
    sending: "Enviando…",
    sendingProgressPre: "Enviando ",
    showingMid: " de ",
    showingPre: "Mostrando ",
    sitAwaiting: "a receber",
    sitUncollectible: "Irrecuperável",
    sortByDateTitle: "Ordenar por data (mais recente primeiro)",
    sortByNumberTitle: "Ordenar pelo numero da fatura (clique alterna crescente/decrescente)",
    statusCancelled: "Cancelada",
    statusIssued: "Emitida",
    statusPaid: "Recebida",
    statusVoid: "Anulada",
    toastErrorTitle: "Erro",
    toolsBtn: "Ferramentas",
    ttcCalculatedLabel: "TTC (calculado)",
    ttcInputLabel: "Valor TTC",
    tvaLabel: "TVA %",
    typeCommercial: "Remise",
    typeError: "Erro",
    typeIrrecoverable: "Irrecuperável",
    typeReturn: "Devolução",
    uncollectibleBtn: "Declarar irrecuperável",
    uncollectibleHint:
      "A fatura continua emitida, mas sai das cobranças e da lista em atraso. Informe o motivo (fica na auditoria).",
    uncollectibleTitle: "Declarar a fatura irrecuperável",
    uncollectibleUndoBtn: "Reverter irrecuperável",
    unsentBadge: "não enviada",
    unsentBadgeTitle: "Nenhum envio desta fatura ao cliente registrado no Gestion.",
    unsentHint:
      "Envie pelo ✉ da linha, ou marque como enviada pelo menu ⋮ se foi entregue por outro meio.",
    unsentMany: "faturas emitidas ainda não enviadas ao cliente",
    unsentOne: "fatura emitida ainda não enviada ao cliente",
    unsentShowAll: "Mostrar todas",
    unsentShowOnly: "Ver só as não enviadas",
    uploadFailedPre: "Falha no upload (HTTP ",
    uploadFailedSuf: ").",
    vehiclesMoreHint: "Ver todos os veículos desta fatura",
    versionUntil: "valeu até",
    versionsTitle: "Versões anteriores",
    voidInvoiceBtn: "Anular fatura",
    voidInvoiceHint: "Anula uma fatura já recebida. Informe o motivo.",
  },
  modals: {
    alertTitle: "Aviso",
    cancel: "Cancelar",
    close: "Fechar",
    confirm: "Confirmar",
    invalidValue: "Valor inválido",
    maxAbbr: "máx",
    minAbbr: "mín",
    ok: "OK",
  },
  monthlyEntryGrid: {
    aTrierTitlePre: "Entradas sem categoria/conciliação neste mês:",
    cellEmpty: "— vazio —",
    colActions: "Ações",
    colBilan: "Bilan?",
    colChargesExternes: "Charges externes",
    colMonth: "Mês",
    colOtherCharges: "Outras cargas",
    colOtherIncome: "Outros produtos",
    colRecettes: "Recettes HT",
    colStatus: "Estado",
    createBtn: "criar",
    editBtn: "editar",
    lockBtn: "lock",
    monthApril: "Abril",
    monthAugust: "Agosto",
    monthDecember: "Dezembro",
    monthFebruary: "Fevereiro",
    monthJanuary: "Janeiro",
    monthJuly: "Julho",
    monthJune: "Junho",
    monthMarch: "Março",
    monthMay: "Maio",
    monthNovember: "Novembro",
    monthOctober: "Outubro",
    monthSeptember: "Setembro",
    statusLocked: "🔒 locked",
    statusOpen: "aberto",
    totalLabel: "Total",
    unlockBtn: "unlock",
  },
  notFound: {
    backHome: "Voltar ao início",
    title: "Página não encontrada",
  },
  operationBoard: {
    allCustomers: "Todos os clientes",
    degarnChip: "dégarnissage pendente",
    degarnChipTitle: "PDR finalizado; falta registrar quem fez o dégarnissage",
    empty: "Nenhum carro nesta situação.",
    emptyAll: "Nenhum carro em operação.",
    franchiseChip: "franquia",
    hideDelivered: "Esconder entregues",
    moreCars: "outros carros",
    noChantier: "Fora de chantier",
    notReceived: "sem recepção",
    openList: "Abrir a lista",
    showDelivered: "Mostrar entregues",
    statusDelivered: "Entregue",
    statusInRepair: "Em reparação",
    statusRepaired: "Reparado",
    statusToRepair: "A reparar",
    title: "Carros na operação",
    totalWord: "carros",
  },
  pagination: {
    aria: "Páginas da lista",
    next: "Seguinte",
    of: "de",
    page: "Página",
    prev: "Anterior",
  },
  paymentAllocation: {
    alreadyReceived: "já recebido",
    available: "Disponível",
    cancelBtn: "Cancelar",
    cars: "carros",
    colCar: "Carro",
    colOrder: "Ordem",
    colStatus: "Situação",
    colTech: "Técnico",
    colValue: "Valor HT",
    creditLeft: "Fica de crédito",
    exceeds: "Os carros marcados passam do valor recebido",
    hint: "Pagamento parcial de fatura com vários carros: marque os carros que o dinheiro quita. Só eles liberam o repasse ao técnico; a sobra fica como crédito na fatura e entra no próximo pagamento. O Gestion já sugere os mais antigos.",
    invoiceBtn: "Carros pagos",
    invoiceBtnTitle: "Pagamento parcial: definir quais carros o valor recebido quita",
    invoiceTotal: "fatura",
    linkBtn: "Ligar e quitar os marcados",
    linkNoCarsBtn: "Ligar sem escolher carros",
    linkNoCarsTitle: "O valor inteiro fica como crédito na fatura; nenhum carro novo é liberado",
    loading: "Carregando…",
    lockProforma: "Em proforma ativa — não pode sair da distribuição",
    lockTechPaid: "Técnico já pago — não pode sair da distribuição",
    saveBtn: "Salvar",
    selected: "Marcados",
    stPaid: "quitado",
    suggestBtn: "Sugerir mais antigos",
    techGets: "repasse",
    thisDeposit: "este depósito",
    title: "Quais carros este pagamento quita?",
  },
  proformaDetail: {
    add: "Adicionar",
    addItemBtn: "+ Adicionar item",
    addItemTitle: "Adicionar item",
    adding: "Adicionando…",
    advancesExpected: "Valor esperado da fatura:",
    advancesHint:
      "A fatura do técnico deve vir com o desconto destes adiantamentos. Desmarque o que ele NÃO descontou (fica aberto para a próxima).",
    advancesTitle: "Adiantamentos a descontar",
    allAlreadyImported: "Todos os itens já tinham sido importados.",
    alreadyExistedSuffix: "já existia(m).",
    alreadyImported: "✓ Já importada",
    alsoSendEmail: "Também enviar por email agora",
    attachInvoicePdfLabel: "Anexar PDF da invoice (opcional)",
    attachPdf: "📎 Anexar PDF",
    auditAdminOnlyPost: "para o log completo.",
    auditAdminOnlyPre: "Apenas administradores podem ver o histórico aqui. Acesse",
    byPlate: "(por placa)",
    canReattachLater: "Você pode reanexar depois.",
    cancel: "Cancelar",
    cancelMirrorsBlockedMid: "de",
    cancelMirrorsBlockedPre: "Não dá para cancelar:",
    cancelMirrorsBlockedSuf:
      "dossier(s) espelho na empresa destino já foram pagos, postos em proforma ou faturados. Resolva lá primeiro.",
    cancelMirrorsPre: "Esta proforma já foi importada na empresa destino:",
    cancelMirrorsSuf: "dossier(s) espelho serão excluídos lá ao cancelar.",
    colAction: "Ação",
    colAmount: "Valor",
    colCustomerVehicle: "Cliente / Veículo",
    colDate: "Data",
    colDescription: "Descrição",
    colDossierBs: "Dossier BS",
    colExpected: "Esperado",
    colGross: "Bruto",
    colInBs: "Na BS",
    colIntermShare: "Intermediário",
    colInvoice: "Fatura",
    colInvoiced: "Faturado",
    colInvoicedTitle: "Faturado HT ao cliente pelo trabalho deste técnico no carro",
    colMargin: "Margem",
    colMarginTitle: "Faturado − pago ao técnico (fica com a empresa)",
    colNet: "Líquido",
    colOk: "OK?",
    colPlate: "Placa",
    colReasonChanges: "Motivo / Mudanças",
    colTechShare: "Técnico",
    colTechnician: "Técnico",
    companiesBold: "Empresas",
    confirm: "Confirmar",
    dossierIdHelp: "Backend valida R12 (job em só 1 proforma ativa) e que pertence à empresa.",
    dossierIdLabel: "Dossier ID",
    dossierIdPlaceholder: "ex: 501",
    dossierWord: "dossier",
    dossiersCreatedSuffix: "dossier(s) criado(s) na empresa destino.",
    emailFailedPre: "Proforma enviada, mas o e-mail falhou para:",
    emailResendFailed: "Falha ao reenviar email",
    emailResent: "Email reenviado.",
    errInvalidDossierId: "Dossier ID inválido.",
    errInvalidEmail: "E-mail inválido:",
    errNoRecipient:
      "Marque o e-mail cadastrado ou informe outro e-mail (ou desmarque o envio por e-mail).",
    errReasonRequired: "Motivo obrigatório.",
    errRetentionRange: "Retenção deve ser entre 0 e 100.",
    errSelectTechnician: "Selecione técnico.",
    errSupplierInvoiceNumberRequired: "Informe o nº da invoice do fornecedor.",
    errTooManyRecipients: "No máximo 5 destinatários.",
    error: "Erro",
    expectedProforma: "Esperado (proforma)",
    extHint:
      "Registro interno: sem e-mail, PDF nem fatura do técnico. As peças abaixo estão pagas.",
    extMethodDinheiro: "Dinheiro",
    extMethodOutro: "Outro",
    extMethodSalario: "Salário (equipe interna)",
    extMethodTransferencia: "Transferência",
    extTitle: "Pago por fora (registro interno)",
    extUndoBtn: "Desfazer (peças voltam a pagar)",
    extUndoCancel: "Voltar",
    extUndoConfirm: "Desfazer pagamento",
    extUndoReasonPh: "Motivo (mínimo 5 letras)",
    extUndoneReason: "Motivo",
    extUndoneTitle: "Pagamento por fora desfeito",
    importBtnTitle: "Cria dossiers próprios na empresa destino a partir dos itens desta proforma",
    importConfirmMid: "dossier(s) para",
    importConfirmPre: "Importar",
    importConfirmSuffix: "Cria dossiers próprios na empresa destino (cliente = empresa remetente).",
    importFailed: "Falha ao importar",
    importTo: "Importar pra",
    importedWithWarnings: "Importado com avisos",
    importing: "Importando…",
    intercompanyHint:
      "Esta proforma é intercompany. Envie-a (mude o status para 'enviada') para habilitar a importação dos dossiers para a empresa destino.",
    invalidId: "ID inválido.",
    invoiceSavedUploadFailedPre: "Invoice registrada, mas o upload do PDF falhou",
    kpiAdvancesShort: "adiantamentos",
    kpiGross: "Bruto",
    kpiNet: "Líquido",
    kpiPeriod: "Período",
    kpiRetention: "Retenção",
    kpiToPay: "A pagar",
    linesWithoutCommission: "linha(s) sem comissão configurada (criadas como legacy):",
    loading: "Carregando…",
    loadingAudit: "Carregando audit…",
    marginAlert:
      "A proforma paga o mesmo valor ou mais do que foi faturado ao cliente — confira antes de enviar.",
    marginGross: "Margem bruta da empresa",
    marginHint:
      "Faturado = soma HT das linhas deste técnico nos carros da proforma (base de tudo).",
    marginInvoiced: "Faturado ao cliente (HT)",
    marginPaid: "Pago nesta proforma",
    marginTitle: "Conferência da margem (interno — não vai para o técnico)",
    mirrorAllOk: "✓ Tudo espelhado e os valores batem",
    mirrorCheckPre: "Conferência do espelho na",
    mirroredBs: "Espelhado (BS)",
    mirroredCount: "espelhados",
    missing: "✗ falta",
    noAuditEntries: "Nenhuma entrada de audit.",
    noEmailOtherPre:
      "Destinatário sem e-mail cadastrado. Para mandar a proforma, marque «Também enviar por email agora» e digite o endereço em «Outro e-mail (opcional)». Sem isso ela só fica marcada como enviada. Para não digitar da próxima vez, cadastre o e-mail em",
    noEmailWarnMid: "e use",
    noEmailWarnPost: "depois.",
    noEmailWarnPre:
      "⚠ Destinatário sem email cadastrado. A proforma será marcada como enviada (transição administrativa) mas nenhum email será disparado. Para enviar email, cadastre o email do destinatário em",
    noItemsYet: "Nenhum item ainda.",
    noOtherServices: "Nenhum outro serviço.",
    noPdfAttached: "(sem PDF anexado)",
    notFound: "Proforma não encontrada nas empresas acessíveis.",
    optIntercompanyInvoice: "Intercompany invoice",
    optTechnicianInvoice: "Technician invoice",
    otherEmailHint: "Vários: separe por vírgula. Vale só para este envio — o cadastro não muda.",
    otherEmailLabel: "Outro e-mail (opcional)",
    pdfAttachedNote: "(PDF da proforma vai como anexo)",
    pdfBtn: "📄 Baixar PDF",
    pdfBtnTitle: "Abre o PDF da proforma (o mesmo enviado por e-mail)",
    pdfErrorPre: "Não foi possível abrir o PDF: ",
    pdfGenerating: "Gerando PDF…",
    processing: "Processando…",
    reasonLabel: "Motivo",
    reasonPlaceholder: "Obrigatório para audit.",
    recipientEmailLabel: "Email do destinatário",
    recipientPrefix: "Para",
    refreshItemsBtn: "Recalcular valores",
    refreshItemsDoneSuf: "item(ns) atualizado(s)",
    refreshItemsHint:
      "Refaz os valores dos itens a partir das linhas atuais (ex.: metade da montagem marcada depois de criar a proforma).",
    refreshItemsNone: "Nenhum valor mudou.",
    refreshItemsResend:
      "A proforma já tinha sido enviada: reenvie o e-mail ao técnico para ele receber os valores novos.",
    registeredEmailTag: "e-mail cadastrado",
    remainingPre: "restam",
    removeBtn: "remover",
    removeConfirmPre: "Remover",
    requiresAdminRole: "Requer role admin",
    resendConfirmPre: "Reenviar proforma por email para",
    resendEmail: "📧 Reenviar email",
    resendEmailBold: "📧 Reenviar email",
    resendInvalidEmail: "Endereço de email inválido.",
    resendPromptMessage:
      "Confira ou altere o endereço do destinatário. A alteração vale só para este envio — o cadastro da proforma e o PDF não mudam.",
    resendPromptPlaceholder: "destinatario@exemplo.com",
    resendPromptTitle: "Reenviar proforma por email",
    resendSendBtn: "Enviar",
    resendSentToPre: "Email enviado para",
    resendTo: "Reenviar para",
    retentionLabel: "Retenção (%)",
    returnedInvoice: "Invoice retornada",
    returnedInvoiceTypeLabel: "Tipo de invoice retornada",
    selectPlaceholder: "— selecione —",
    sendFirst: "envie a proforma primeiro",
    sendToLabel: "Enviar para",
    sending: "Enviando…",
    sentNoEmail:
      "Proforma marcada como enviada (sem email automático). Use 📧 Reenviar email quando quiser disparar o envio.",
    sentWithEmailPost: "Se não chegar, use 📧 Reenviar email para tentar novamente.",
    sentWithEmailPre: "Proforma marcada como enviada e email disparado para",
    splitTotalsLabel: "Totais (técnico · intermediário · bruto)",
    statusApproved: "aprovada",
    statusCancelled: "cancelada",
    statusClosed: "fechada",
    statusDraft: "rascunho",
    statusInvoiceReceived: "fatura recebida",
    statusPaid: "paga",
    statusRejected: "rejeitada",
    statusSent: "enviada",
    supplierInvoiceNumberHelp:
      "Número do documento emitido pelo fornecedor (a invoice que ele mandou).",
    supplierInvoiceNumberLabel: "Nº da invoice do fornecedor",
    supplierInvoiceNumberPlaceholder: "ex: BS-2026-0042",
    tabAudit: "Audit",
    tabItems: "Items",
    tabOtherServices: "Outros serviços",
    technicianLabel: "Técnico",
    techniciansBold: "Técnicos (cadastro do técnico)",
    transApprove: "Aprovar",
    transCancel: "Cancelar",
    transCancelAdmin: "Cancelar (admin)",
    transClose: "Fechar",
    transMarkPaid: "Marcar paga",
    transReceiveInvoice: "Registrar invoice",
    transReject: "Rejeitar",
    transReopen: "Reabrir",
    transSend: "Enviar",
    uploadFailed: "Upload falhou",
    uploading: "Enviando…",
    uploadingAttachment: "Enviando anexo…",
    valueMismatch: "≠ valor",
  },
  proformaNew: {
    addAtLeastOne: "Adicione pelo menos 1 dossier.",
    addEditDossiers: "Adicionar / editar dossiers",
    allCustomers: "Todos clientes",
    allTechnicians: "Todos técnicos",
    backToList: "← Voltar à lista",
    backendQueryError: "Erro na query backend",
    causesPost: "e selecione apenas dossiers com técnico já cadastrado.",
    causesPre:
      "Causas possíveis: dossiers sem técnico atribuído, dossiers em empresa diferente da selecionada (Euro Storm Débosselage), ou dossiers sem cliente. Volte a",
    changeCompanyTitle: "Troque a empresa voltando ao step 1",
    clientRetentionLabel: "Retenção do cliente",
    clientRetentionSubtitle: "o que o cliente fica",
    colCustomer: "Cliente",
    colDate: "Data",
    colDossier: "Dossier",
    colGross: "Gross",
    colInterm: "Interm.",
    colPlate: "Matrícula",
    colTec: "Téc",
    colTechnician: "Técnico",
    colTotal: "Total",
    commissionIntermShort: "Comissão interm.",
    commissionIntermediary: "Comissão do intermediário",
    commissionTecShort: "Comissão téc",
    commissionTechnician: "Comissão do técnico",
    commissionTechnicianReceive: "Comissão do técnico — quanto o técnico vai receber",
    conflictsBannerSuffix: " dossier(s) já estão em outra proforma ativa — remova antes de criar:",
    createProformaDraft: "Criar proforma (RASCUNHO)",
    creating: "Criando…",
    customMessageLabel: "Mensagem para o destinatário (opcional)",
    customMessagePlaceholder: "Texto livre que aparece no corpo do email.",
    dateFromTitle: "Data inicial",
    dateToTitle: "Data final",
    dossierInActiveProformaPre: "Dossier já em proforma ativa (linha ",
    dossiersSelectedSuffix: "dossier(s) selecionado(s).",
    dossiersWordSuffix: "dossier(s)",
    emailHelper:
      "Opcional. Sem email cadastrado a proforma fica disponível só para download manual do PDF.",
    emailPlaceholderIntercompany: "Auto-preenchido se a empresa tem email cadastrado",
    emailPlaceholderPartner: "Informe manualmente (partner externo)",
    emailPlaceholderTechnician: "Auto-preenchido se o técnico tem email cadastrado",
    eurostormKeepsLabel: "Euro Storm fica com",
    eurostormNegativeSubtitle: "⚠ negativo — a proforma cobre mais do que Euro Storm recebe",
    eurostormPositiveSubtitle: "sobre estes dossiers, após pagar a proforma",
    fieldDestinatario: "Destinatário",
    fieldIdioma: "Idioma",
    fieldItens: "Itens",
    fieldTipo: "Tipo",
    filterCustomerTitle: "Filtrar por cliente",
    filterPlateTitle: "Filtrar por placa",
    financialSummaryDesc:
      "Panorama informativo do fluxo do dinheiro. Não altera a proforma — só ajuda a aprovar com contexto.",
    financialSummaryTitle: "Resumo financeiro destes dossiers",
    grossColTitle: "Comissão V3 a faturar (depende do tipo de destinatário)",
    grossQuoteLabel: "Orçamento bruto (Prix Brut)",
    grossTotal: "Gross total",
    inProformaBadge: "em proforma",
    invalidRetention: "Retenção inválida (0..100).",
    issuerCompanyLabel: "Empresa emissora:",
    loadedReadySuffix: " dossier(s) carregado(s) — pronto para revisar.",
    loading: "Carregando…",
    loadingDossierLines: "Carregando linhas dos dossiers…",
    net: "Net",
    nextArrow: "Próximo →",
    noCompanyAccess: "Você não tem acesso a nenhuma empresa.",
    noDossierInFilter: "Nenhum dossier no filtro. Ajuste o período ou o técnico.",
    noLinesReturned: "Nenhuma linha retornada pelos dossiers selecionados",
    notesLabel: "Notas (interno)",
    notesPlaceholder: "Ex: pago via TED, comissão extra…",
    pairMismatchHint:
      "A proforma usa os valores das LINHAS. Corrija antes em Dossier → Linhas → Editar comissão (o intermediário de cada linha), depois volte aqui.",
    pairMismatchLines: "linhas",
    pairMismatchOpen: "abrir o dossier",
    pairMismatchPair: "par",
    pairMismatchTitle:
      "As linhas destes carros foram calculadas com outra fatia do intermediário que a do par técnico × cliente:",
    partnerHelper: "Partner externo (fora do grupo). Sem CHECK constraint estrita.",
    partnerParenSuffix: "(partner)",
    pdfLanguageLabel: "Idioma do PDF",
    platePlaceholder: "Placa",
    populatingSelection: "Populando selecção…",
    preselectedFromDossiersSuffix: " dossier(s) pré-selecionado(s) de /dossiers",
    preselectedLabel: "Dossiers pré-selecionados",
    preselectionWaitTitle:
      "Aguarde os dossiers carregarem, ou volte ao /dossiers se a mensagem amarela acima indicar problema.",
    prevArrow: "← Anterior",
    proformaTotalForDossier: "Total da proforma para este dossier (= téc + interm)",
    readOnlyNotice: "Somente leitura — criação de proforma exige permissão de edição.",
    recipientCompanyLabel: "Empresa destinatária",
    recipientEmailLabel: "Email do destinatário",
    recipientPartnerLabel: "Empresa partner (FK app-layer)",
    recipientTechnicianLabel: "Técnico destinatário",
    recipientTypeIntercompany: "Empresa do grupo",
    recipientTypePartner: "Partner externo",
    recipientTypeTechnician: "Técnico",
    removeAria: "Remover",
    removeConflictsPre: "Remover os",
    removeConflictsSuf: "conflitantes",
    removeConflictsTitlePre: "Remova os",
    removeConflictsTitleSuf: "dossier(s) já em outra proforma antes de criar.",
    removeDossierTitle: "Remover este dossier da proforma",
    removeHintPost: "ou inclua mais abaixo.",
    removeHintPre: "Remova um dossier com",
    retentionLabel: "Retenção",
    retentionLabel2: "Retenção (%) — aplicada a todos os items",
    reviewArrow: "Revisar →",
    searchPlaceholder: "Busca: dossier / matrícula / n° fatura",
    selectPlaceholder: "— selecione —",
    step1Title: "Tipo de destinatário",
    step2Title: "Selecionar dossiers",
    step3Title: "Revisão",
    stepDestinatario: "Destinatário",
    stepDossiers: "Dossiers",
    stepRevisao: "Revisão",
    technicianParenSuffix: "(técnico)",
    thisProforma: "esta proforma",
    toPayTo: "A pagar a",
    totalInvoicedClientLabel: "Total faturado ao cliente",
    totalInvoicedClientSubtitle: "= Prix Brut − retenção (= Total Facture xlsx)",
  },
  proformas: {
    approveBtn: "✓ Aprovar",
    approveBtnTitle: "Transição sent → approved em lote",
    approveConfirmMsg: "Apenas proformas em 'enviada' são aprovadas. As demais ficam puladas.",
    approveVerb: "Aprovar",
    cancelBtn: "✕ Cancelar",
    cancelBtnTitle: "Cancela proformas selecionadas (R14: bloqueia se IC já emitida)",
    cancelConfirmLabel: "Cancelar proformas",
    cancelReasonMsg:
      "Cancela proformas em qualquer estado pré-IC. Motivo é obrigatório (vai para audit).",
    cancelReasonPlaceholder: "Ex: cliente desistiu / duplicada",
    cancelVerb: "Cancelar",
    clearFilters: "✕ Limpar filtros",
    clientAll: "Todos clientes",
    clientFilterTitle: "Cliente final dos dossiers vinculados (não o destinatário da proforma)",
    clientLabel: "Cliente",
    colCreatedAt: "Criada em",
    colGross: "Bruto",
    colInvoiced: "Faturado",
    colInvoicedTitle: "Faturado HT ao cliente pelo trabalho do técnico desta proforma",
    colNet: "Líquido",
    colRecipient: "Destinatário",
    colReference: "Referência",
    colStatus: "Status",
    colTecExpected: "Téc. previsto",
    colTecExpectedTitle:
      "Valor do técnico pelos pares técnico×cliente (o que a proforma deve pedir)",
    colTecInvoiced: "Téc. facturado",
    colTecInvoicedTitle: "Valor das faturas físicas já emitidas pelos técnicos",
    colTecPct: "Téc. %",
    colTecPctTitle: "Percentual médio ponderado da comissão técnica nos dossiers",
    colType: "Tipo",
    companyLabel: "Empresa",
    dateFromTitle: "Data inicial (created_at)",
    dateToTitle: "Data final (created_at)",
    dossiersWord: "dossier(s)",
    emptyState: "Nenhuma proforma encontrada.",
    errorMany: "erros",
    errorOne: "erro",
    errorPrefix: "Erro",
    errorTitle: "Erro",
    errorsWord: "erro(s)",
    importBtn: "📥 Importar p/ BS",
    importBtnTitle: "Espelha as proformas intercompany como dossiers na empresa destino (BS)",
    importConfirmLabel: "Importar p/ BS",
    importConfirmMsg:
      "Espelha os dossiers das proformas intercompany na empresa destino (BS). Idempotente — já importadas ou não-elegíveis (não-intercompany, ainda não enviadas) são puladas. Não altera o status.",
    importLimitTitle: "Importação limitada a 200 por chamada",
    importTitleSuf: "proforma(s) para a Brazilian Storms?",
    importVerb: "Importar",
    imported: "Importadas",
    inBS: "na BS",
    includeDeleted: "Incluir excluídas (canceladas)",
    loading: "Carregando…",
    newBtn: "+ Nova proforma",
    nextPage: "Próxima →",
    noCompanyAccess: "Você não tem acesso a nenhuma empresa.",
    ofWord: "de",
    okSuffix: "ok",
    pageWord: "Página",
    pdfBtnTitle: "Abrir o PDF da proforma (o mesmo enviado por e-mail)",
    pdfErrorPre: "Não foi possível abrir o PDF: ",
    pdfErrorTitle: "Erro",
    periodLabel: "Período (criação)",
    prevPage: "← Anterior",
    proformasParen: "proforma(s)",
    proformasParenQ: "proforma(s)?",
    proformasWord: "proforma(s)",
    recipientAll: "Todos destinatários",
    recipientIntercompany: "Intercompany",
    recipientLabel: "Destinatário",
    recipientPartner: "Parceiro",
    recipientTechnician: "Técnico",
    rejectReasonMsg: "Motivo obrigatório para rejeição.",
    rejectReasonPlaceholder: "Ex: divergência no valor faturado",
    rejectVerb: "Rejeitar",
    resendBtnTitle: "Regera PDF + envia e-mail novamente",
    resendConfirmLabel: "Reenviar",
    resendConfirmMsg:
      "Regera o PDF e dispara novo envio. Falhas individuais não bloqueiam os demais.",
    resendEmailBtn: "✉ Reenviar e-mail",
    resendEmailOfPre: "Reenviar e-mail de",
    resendLimitTitle: "Reenvio de e-mail limitado a 200 por chamada",
    searchLabel: "Buscar",
    searchPlaceholder: "Referência / destinatário…",
    selectCurrentPage: "Selecionar página atual",
    selectedMany: "selecionadas",
    selectedOne: "selecionada",
    skippedImport: "pulada(s) (não-elegível ou já importada)",
    skippedMany: "puladas",
    skippedOne: "pulada",
    statusAll: "Todos status",
    statusApproved: "aprovada",
    statusApprovedOpt: "Aprovada",
    statusCancelled: "cancelada",
    statusCancelledOpt: "Cancelada",
    statusClosed: "fechada",
    statusClosedOpt: "Fechada",
    statusDraft: "rascunho",
    statusDraftOpt: "Rascunho",
    statusInvoiceReceived: "fatura recebida",
    statusInvoiceReceivedOpt: "Fatura recebida",
    statusLabel: "Status",
    statusPaid: "paga",
    statusPaidOpt: "Paga",
    statusRejected: "rejeitada",
    statusRejectedOpt: "Rejeitada",
    statusSent: "enviada",
    statusSentOpt: "Enviada",
    summaryApproved: "Aprovadas",
    summaryCancelled: "Canceladas",
    summaryEmailsSent: "E-mails enviados",
    summaryStatusUpdated: "Status atualizado",
    technicianAll: "Todos técnicos",
    technicianFilterTitle:
      "Técnico das lines dos dossiers (não o destinatário quando tipo=Técnico)",
    technicianLabel: "Técnico",
    updateStatusConfirmLabel: "Atualizar",
    updateStatusConfirmMsg: "Apenas transições válidas serão aplicadas. As demais ficam puladas.",
    updateStatusOptApproved: "Aprovar (sent → approved)",
    updateStatusOptClosed: "Fechar (paid → closed)",
    updateStatusOptDefault: "↻ Atualizar status…",
    updateStatusOptPaid: "Marcar paga (invoice_received → paid)",
    updateStatusOptRejected: "Rejeitar (sent → rejected)",
    updateStatusOptReopen: "Reabrir (rejected → draft)",
    updateStatusOptSent: "Enviar (draft → sent)",
    updateStatusSelectTitle:
      "Transição de status genérica (send/approve/reject/reopen/mark_paid/close)",
    updateStatusTitleMid: "em",
    updateStatusTitlePre: "Atualizar status para",
  },
  purchaseInvoices: {
    allSuppliers: "Todos fornecedores",
    attachBtnTitle: "Anexar / ver PDF da fatura",
    attachFilesCta: "+ Anexar arquivo(s) (pode selecionar vários · máx. 25 MB cada)",
    attachmentsHelp:
      "Anexe o PDF/imagem da fatura do fornecedor. O documento vira o link clicável da fatura no PDF do extrato e nos relatórios enviados ao contador.",
    attachmentsModalTitle: "Anexos da fatura de compra",
    bulkAttachTitle: "📎 Anexar PDFs em massa:",
    bulkAttachedSuf: "PDF(s) anexado(s) com sucesso.",
    bulkDoneTitle: "Upload em massa concluído",
    bulkErrorTitle: "Erro no upload em massa",
    bulkFailedSuf: "falharam no envio",
    bulkHintFolderQuoted: '"Selecionar pasta"',
    bulkHintPre: "Nomeie cada PDF com o nº externo da fatura (ex.:",
    bulkHintSuf: "pega todos de uma vez.",
    bulkMatching: "Casando arquivos com faturas…",
    bulkPickFiles: "Selecionar PDFs…",
    bulkPickFilesTitle:
      "Selecione vários PDFs de uma vez; cada um é anexado à fatura de mesmo número externo",
    bulkPickFolder: "📁 Selecionar pasta",
    bulkPickFolderTitle: "Escolha a PASTA inteira de PDFs — sem precisar selecionar um a um",
    bulkSendingPre: "Enviando",
    bulkUnmatchedSuf: "sem fatura correspondente",
    cancelBtn: "cancelar",
    cancelFormBtn: "Cancelar",
    cancelInvoiceConfirm: "Cancelar fatura",
    cancelInvoiceMessage:
      "Fatura cancelada não aparece em totais. Motivo obrigatório para audit log.",
    cancelInvoiceTitlePre: "Cancelar fatura",
    cancelReasonPlaceholder: "Ex: fornecedor cancelou o pedido",
    close: "Fechar",
    colActions: "Ações",
    colCategory: "Categoria",
    colDate: "Data",
    colExternalNumber: "N° externo",
    colHt: "HT",
    colStatus: "Status",
    colSupplier: "Fornecedor",
    colTtc: "TTC",
    colTva: "TVA",
    colTvaRate: "TVA %",
    companyLabel: "Empresa:",
    createBtn: "Criar fatura",
    createModalTitle: "Nova fatura de compra",
    creating: "Criando…",
    dupNumberPrefix: "n°",
    dupWarnHint: "Confira antes de criar — pode ser o mesmo invoice lançado com número diferente.",
    dupWarnTitle: "⚠️ Possível duplicata — já existe fatura deste fornecedor com este valor:",
    emptyState: "Nenhuma fatura encontrada.",
    errInvalidTotalHt: "Total HT inválido.",
    errInvalidTvaRate: "Taxa TVA inválida (0..30).",
    errSelectSupplier: "Selecione um fornecedor.",
    error: "Erro",
    fieldCurrency: "Moeda",
    fieldDueDate: "Vencimento",
    fieldInvoiceNumber: "N° fatura (fornecedor)",
    fieldIssueDate: "Data de emissão",
    fieldNotes: "Notas",
    fieldTotalHt: "Total HT",
    fieldTvaRate: "Taxa TVA (%)",
    filterAllExceptCancelled: "Todas (exceto canceladas)",
    filterCompany: "Empresa",
    filterSearch: "Buscar",
    filterStatus: "Situação",
    filterSupplier: "Fornecedor",
    invoiceNumberPlaceholder: "ex: HERTZ-2025-0042",
    invoicePlural: "faturas",
    invoiceSingular: "fatura",
    loading: "Carregando…",
    markPaidBtn: "marcar paga",
    markReceivedBtn: "marcar recebida",
    newBtn: "+ Nova fatura de compra",
    nextPage: "Próxima →",
    noAttachmentsYet: "Nenhum anexo ainda.",
    noCompanyAccess: "Você não tem acesso a nenhuma empresa.",
    ofWord: "de",
    or: "ou",
    pageWord: "Página",
    prevPage: "← Anterior",
    previewLabel: "Preview",
    removeAttachmentPre: "Remover",
    removeAttachmentSuf: "Esta ação não pode ser desfeita.",
    removeAttachmentTitle: "Remover anexo",
    removeBtn: "remover",
    removeConfirm: "Remover",
    searchPlaceholder: "Buscar n° fatura...",
    sending: "Enviando…",
    statusCancelled: "Cancelada",
    statusCancelledBadge: "cancelada",
    statusDraft: "Rascunho",
    statusDraftBadge: "rascunho",
    statusPaid: "Paga",
    statusPaidBadge: "paga",
    statusReceived: "Recebida",
    statusReceivedBadge: "recebida",
    uploadFailed: "Falha ao enviar o arquivo.",
  },
  report: {
    all: "Todos",
    allFem: "Todas",
    awaiting: "Aguardando",
    billingCompany: "Empresa Faturamento",
    cancelled: "Cancelado",
    colCompany: "Empresa",
    colCustomer: "Cliente",
    colDate: "Data",
    colExpectedProfit: "Lucro Prev.",
    colInvoiced: "Faturado",
    colPayTech: "Pagar Téc.",
    colPayTechStatus: "Pag. Téc.",
    colPctTech: "% Téc.",
    colPlate: "Matrícula",
    colQuote: "Orçamento",
    colReceipt: "Receb.",
    colTechnician: "Técnico",
    colToReceive: "A Receber",
    companyLabel: "Empresa:",
    csvDossier: "Dossier",
    csvPaidTechnician: "Pago Técnico",
    csvPayTechnician: "Pagar Técnico",
    csvPayingCompany: "Empresa Pagadora",
    csvPaymentStatus: "Status Pagamento",
    csvPctTechnician: "% Técnico",
    csvVehicle: "Veículo",
    customer: "Cliente",
    dateFrom: "Data Inicial",
    dateTo: "Data Final",
    emptyState: 'Nenhum lançamento encontrado. Ajuste os filtros e clique em "Gerar Relatório".',
    entriesTitle: "Lançamentos do Período",
    expectedProfit: "Lucro Previsto",
    expectedProfitAbbrev: "Lucro Prev.",
    exportCsvBtn: "Exportar CSV",
    filtersTitle: "Filtros do Relatório",
    freeSearch: "Busca livre",
    freeSearchPlaceholder: "dossier / matrícula / cliente / técnico",
    generateReport: "Gerar Relatório",
    invoiceNumber: "N° Fatura",
    invoiceNumberPlaceholder: "Ex: 2025-001",
    invoiced: "Faturado",
    loading: "Carregando…",
    negativeProfitAlert: "lançamentos com lucro previsto negativo no período.",
    negativeProfitAlertSingular: "lançamento com lucro previsto negativo no período.",
    noCompanyAccess: "Você não tem acesso a nenhuma empresa.",
    paid: "Pago",
    paidTechnicians: "Pago Técnicos",
    payTechnicians: "Pagar Técnicos",
    pending: "Pendente",
    quickRange: "Período Rápido",
    quote: "Orçamento",
    receiptStatus: "Status Recebimento",
    receivedPartial: "Recebido Parcial",
    receivedTotal: "Recebido Total",
    recordWord: "registros",
    recordWordSingular: "registro",
    recordsAbbrev: "reg.",
    sixMonths: "6 meses",
    technician: "Técnico",
    technicianPaymentStatus: "Status Pag. Técnico",
    toReceive: "A Receber",
    totalsRow: "Totais",
    truncatedPre: "Resultado limitado a",
    truncatedSuf: "registros. Refine os filtros para ver mais.",
    twelveMonths: "12 meses",
  },
  reportCaGap: {
    colAmount: "Valor",
    colCaHt: "CA HT",
    colDate: "Data",
    colDescription: "Descrição",
    colMonth: "Mês",
    colOpenHt: "Em aberto HT",
    colReceivedHt: "Recebido HT",
    colTvaCollected: "TVA coletada",
    creditsCardSubtitle:
      "Entradas ainda não casadas a nenhuma fatura (e que não são pessoais / aporte de sócio). São os principais suspeitos de venda recebida mas não faturada — o que explica bilan > Gestion.",
    creditsCardTitle: "Créditos no banco sem fatura",
    creditsEmpty:
      "Nenhum crédito sem fatura no período. 🎉 (Ou o extrato ainda não foi importado / reconciliado.)",
    entriesUnit: "lançamento(s)",
    eyebrow: "Rapports — Gap de CA (HT)",
    kpiCaInvoiced: "CA facturé (HT)",
    kpiCreditsNoInvoice: "Créditos sem fatura",
    kpiOpen: "Em aberto (HT)",
    kpiReceived: "Recebido (HT)",
    loading: "Calculando…",
    methodology:
      "Metodologia v1 (iterável). CA e TVA vêm das faturas de cliente; os suspeitos vêm do extrato reconciliado. Se algum número não bater com a realidade, ajustamos a regra — é só leitura.",
    monthlyCardTitle: "CA facturé por mês (HT)",
    monthlyEmpty: "Nenhuma fatura emitida no exercício.",
    selectPrompt: "Selecione empresa e exercício.",
    total: "Total",
    totalCapped: "(200+ — truncado)",
    tvaCardSubtitle:
      "A pagar ao Estado = coletada (vendas) − dedutível (compras). Compare com a transferência real no extrato.",
    tvaCardTitle: "TVA do período",
    tvaCollected: "Coletada (vendas)",
    tvaDeductible: "Dedutível (compras)",
    tvaDue: "Devida",
  },
  suppliers: {
    badgeActive: "ativo",
    badgeInactive: "inativo",
    cancel: "Cancelar",
    colActions: "Ações",
    colDefaultCategory: "Categoria default",
    colName: "Nome",
    colStatus: "Status",
    companyLabel: "Empresa",
    create: "Criar",
    deactivate: "Desativar",
    deactivateMessage:
      "Fornecedor inativo não aparece em novas faturas. Faturas existentes não são afetadas.",
    deactivatePlaceholder: "Ex: fornecedor encerrou atividade",
    deactivateTitlePrefix: "Desativar fornecedor",
    editAction: "editar",
    editSupplier: "Editar fornecedor",
    emptyState: "Nenhum fornecedor encontrado.",
    fieldCountry: "País (ISO 2)",
    fieldDefaultCategory: "Categoria default",
    fieldDefaultTvaRate: "Taxa TVA default (%)",
    fieldDisplayName: "Nome de exibição",
    fieldEmail: "E-mail",
    fieldKind: "Tipo",
    fieldLegalName: "Razão social",
    fieldNotes: "Notas",
    fieldPhone: "Telefone",
    fieldSiren: "SIREN (9 dígitos)",
    fieldSiret: "SIRET (14 dígitos)",
    fieldVatNumber: "TVA intracomm.",
    filterActive: "Ativos",
    filterAll: "Todos",
    filterInactive: "Inativos",
    kindBusiness: "Empresa",
    kindIndividual: "Indivíduo (freelance)",
    loading: "Carregando…",
    newSupplier: "Novo fornecedor",
    nextPage: "Próxima",
    noCompanyAccess: "Você não tem acesso a nenhuma empresa.",
    pageLabel: "Página",
    pageOf: "de",
    prevPage: "Anterior",
    reactivate: "Reativar",
    save: "Salvar",
    saving: "Salvando…",
    searchLabel: "Buscar",
    searchPlaceholder: "Nome, SIRET, vatNumber…",
    supplierPlural: "fornecedores",
    supplierSingular: "fornecedor",
  },
  tasks: {
    backBtn: "Voltar",
    boardEmpty: "Nenhuma tarefa criada ainda.",
    boardTitle: "Tarefas da equipe",
    cancelBtn: "Cancelar tarefa",
    cancelConfirm: "Cancelar esta tarefa? Ela some da lista da pessoa.",
    cancelledBadge: "Cancelada",
    commentPh: "Comentário (opcional)",
    companyLabel: "Empresa",
    confirmBtn: "Confirmar",
    createBtn: "Criar tarefa",
    created: "Tarefa criada. A pessoa vê no sino e no Painel.",
    descLabel: "Detalhes (opcional)",
    doneBtn: "Feito",
    dueAtLabel: "Prazo (dia e hora)",
    dueBy: "até",
    endLabel: "Termina em (opcional)",
    endOfDay: "fim do dia",
    everyMonthWord: "de cada mês",
    groupOffice: "Escritório",
    groupOverdue: "Atrasadas",
    groupToday: "Hoje",
    groupUpcoming: "Próximos 7 dias",
    hint: "Tarefas do escritório para a equipe. A tarefa não feita no prazo fica atrasada e continua na lista até ser feita.",
    historyLabel: "Últimos dias",
    kindLabel: "Tipo",
    kindOnce: "Pontual",
    kindRecurring: "Recorrente",
    lastDone: "Última feita",
    mineEmpty: "Nenhuma tarefa para você.",
    monthDayLabel: "Dia do mês",
    monthDayWord: "dia",
    myCardTitle: "Suas tarefas",
    newTitle: "Nova tarefa",
    noAdmin: "Só Administradores criam tarefas.",
    notifMineOverdue: "Você tem tarefas atrasadas",
    notifMineToday: "Tarefas para hoje",
    notifTeamOverdue: "Tarefas atrasadas da equipe",
    onceWord: "Pontual",
    openTasks: "Abrir tarefas",
    overdueWord: "atrasada(s)",
    personLabel: "Para quem",
    personPh: "Escolha a pessoa",
    rec_business_days: "Todo dia útil (segunda a sexta)",
    rec_monthly_day: "Todo mês, no dia",
    rec_monthly_last_business: "Último dia útil do mês",
    rec_weekly: "Em dias da semana",
    recurringBadge: "Recorrente",
    repeatLabel: "Repete",
    requestedBy: "Pedida por",
    showCancelled: "Mostrar canceladas",
    sinceWord: "desde",
    skipBtn: "Não se aplica",
    skipReasonPh: "Por quê? (obrigatório)",
    st_done: "Feita",
    st_doneLate: "Feita com atraso",
    st_open: "Aberta",
    st_overdue: "Atrasada",
    st_skipped: "Não se aplica",
    startLabel: "Começa em",
    tabMine: "Minhas tarefas",
    tabTeam: "Equipe",
    teamOverdueNone: "Nenhuma tarefa atrasada na equipe.",
    teamOverdueTitle: "Tarefas atrasadas da equipe",
    timeHint: "Vazio = até o fim do dia",
    timeLabel: "Até que horas",
    title: "Tarefas",
    titleLabel: "O que fazer",
    titlePh: "Ex.: Conferir as proformas emitidas",
    urgent: "Urgente",
    urgentLabel: "Marcar como urgente",
  },
  teamNotices: {
    ackBtn: "Ciente",
    cancelBtn: "Cancelar",
    closeBtn: "Fechar",
    closeConfirmMsg: "Está ciente de que há tarefas a concluir?",
    closeConfirmNo: "Não",
    closeConfirmTitle: "Fechar as tarefas?",
    closeConfirmYes: "Sim, fechar",
    companyLabel: "Empresa",
    dayLong1: "segunda",
    dayLong2: "terça",
    dayLong3: "quarta",
    dayLong4: "quinta",
    dayLong5: "sexta",
    dayLong6: "sábado",
    dayLong7: "domingo",
    doneBtn: "Feito",
    doneBy: "feito por",
    expiresHint: "Vazio = sem prazo.",
    expiresLabel: "Válido até",
    hint: "O recado abre em pop-up quando a pessoa entra no Gestion (ou no portal, se for técnico). «Ciente» fecha até a próxima entrada na conta; «Feito» encerra para aquela pessoa.",
    infoBadge: "informativo",
    laterBtn: "Ver depois",
    listEmpty: "Nenhum recado ainda.",
    listTitle: "Recados enviados",
    messagePlaceholder: "Ex.: sexta-feira às 17h, fechem os worklogs da semana.",
    noAdmin: "Só Administradores enviam recados.",
    popupHint: "«Ciente» fecha até a próxima entrada na conta · «Feito» não aparece mais.",
    popupNoticesSub: "Informativo",
    popupOpenTasks: "Abrir Minhas tarefas",
    popupTasksHint:
      "Marque «Feito» ao terminar. «Ver depois» fecha até a próxima entrada na conta; a tarefa atrasada continua na lista até ser feita.",
    popupTasksTitle: "Tarefas a realizar",
    popupTitle: "Informativo",
    readBy: "lido por",
    repeatDoneHint: "Recado que se repete: «Feito» vale só para hoje.",
    repeatEvery: "toda",
    repeatHint:
      "Aparece só nesses dias (hora de Paris). «Feito» vale para o dia; volta no próximo dia marcado. Use «Válido até» para o fim.",
    repeatLabel: "Repetir nos dias",
    roleLabel: "Papel",
    role_admin: "Administrador",
    role_client: "Cliente",
    role_manager: "Gerente de chantier",
    role_technician: "Técnico",
    role_user: "Usuário",
    role_viewer: "Visualizador",
    sendBtn: "Enviar recado",
    sent: "Recado enviado.",
    showFromHint: "Vazio = agora.",
    showFromLabel: "Mostrar a partir de",
    statusActive: "no ar",
    statusCancelled: "cancelado",
    statusExpired: "expirado",
    statusScheduled: "agendado",
    targetAll: "Todos (escritório + técnicos)",
    targetCompany: "Equipe do escritório (Gestion)",
    targetLabel: "Para quem",
    targetRole: "Um papel",
    targetTechnicians: "Todos os técnicos (portal)",
    targetUser: "Uma pessoa",
    title: "Recados para a equipe",
    today: "hoje",
    userLabel: "Pessoa",
  },
  techPortal: {
    advDeductedIn: "descontado em",
    advHint:
      "A empresa adiantou estes valores. Desconte o total na sua próxima fatura (o e-mail da proforma já mostra o valor esperado).",
    advHistory: "já descontados",
    advNoneOpen: "Nenhum adiantamento em aberto.",
    advTitle: "Adiantamentos a descontar",
    agendaEmpty: "Nada agendado nos próximos dias.",
    agendaTitle: "Agenda do chantier",
    alreadyInvoicedHint:
      "O reparo anterior está fechado. Se o carro voltou para um novo reparo, o devis novo precisa entrar no Gestion (pelo escritório ou pelo botão de importar o devis abaixo); depois ele aparece aqui para você assumir.",
    alreadyInvoicedTitle: "Serviço deste carro já foi faturado",
    camAimPlate: "Enquadre a placa na moldura",
    camAimVin: "Enquadre o VIN na moldura",
    camClose: "Fechar",
    camConflictDevis: "mas o orçamento é de",
    camConflictPre: "O VIN é de",
    camDenied:
      "Câmera bloqueada. Para usar, permita a câmera para este site nas configurações do navegador. Enquanto isso, digite.",
    camNotFound: "Não está no Gestion — continuo lendo.",
    camOffline: "Sem conexão — continuo tentando.",
    camPickOne: "Qual destes carros?",
    camRetry: "Ler de novo",
    camStarting: "Abrindo a câmera…",
    camTitlePlate: "Placa",
    camTorch: "Lanterna",
    camType: "Digitar",
    camUnavailable: "Câmera indisponível neste aparelho — digite.",
    camUseAnyway: "Usar mesmo assim",
    carClosedNoTechHint:
      "O gerente registrou a entrega, mas ninguém assumiu este carro no portal. Avise o escritório para lançar o técnico no dossier — só assim o carro entra na sua lista e no seu pagamento.",
    carClosedNoTechTitle: "Carro entregue sem técnico lançado",
    carRepairedHint: "Todos os serviços deste carro foram concluídos.",
    carRepairedTitle: "Veículo já reparado",
    chkCielLabel: "Forro do teto",
    chkClaimQ: "Como você vai reparar este carro?",
    chkClearIssue: "Tirar a marcação",
    chkCompleteBadge: "Check-list completo",
    chkCrackedBtn: "Trincado",
    chkDefectBtn: "Com defeito",
    chkFranchiseEditBtn: "Editar franquia",
    chkIncompleteHint: "Check-list incompleto — complete os pontos abaixo para liberar o reparo.",
    chkIssueNotePlaceholder: "O que está errado? (opcional)",
    chkIssuesBrokenSummary: "peça(s) quebrada(s) no trabalho",
    chkIssuesDefectSummary: "peça(s) já com defeito",
    chkMarkBroken: "Quebrou no trabalho",
    chkMarkDefect: "Peça já com defeito",
    chkMileageLabel: "Quilometragem (km)",
    chkMileagePh: "Ex.: 45200",
    chkMissingCiel: "responder o forro do teto",
    chkMissingPareBrise: "responder o pára-brisa",
    chkMissingPhoto: "foto",
    chkMissingPhotos: "fotos",
    chkMissingPre: "Falta:",
    chkMissingSignature: "assinatura do cliente",
    chkNextPhotoPre: "Próxima foto:",
    chkOkBtn: "OK",
    chkPareBriseLabel: "Pára-brisa",
    chkPhotoAngle1: "Frente esq.",
    chkPhotoAngle2: "Frente dir.",
    chkPhotoAngle3: "Traseira esq.",
    chkPhotoAngle4: "Traseira dir.",
    chkPhotoCameraBtn: "Câmera",
    chkPhotoCancelBtn: "Cancelar",
    chkPhotoDashboard: "Painel de instrumentos (chave ligada)",
    chkPhotoDoorTrim1: "Guarnição porta 1",
    chkPhotoDoorTrim2: "Guarnição porta 2",
    chkPhotoDoorTrim3: "Guarnição porta 3",
    chkPhotoDoorTrim4: "Guarnição porta 4",
    chkPhotoDoorTrim5: "Guarnição porta 5",
    chkPhotoFree: "Foto livre",
    chkPhotoFront: "Frente",
    chkPhotoFrontLeft: "Lateral frontal esq.",
    chkPhotoFrontRight: "Lateral frontal dir.",
    chkPhotoGalleryBtn: "Galeria",
    chkPhotoHeadliner: "Forro do teto com defeito",
    chkPhotoHeadlinerFront: "Forro do teto — frente",
    chkPhotoHeadlinerRear: "Forro do teto — traseira",
    chkPhotoHood: "Capô",
    chkPhotoHoodLiner: "Forro do capô",
    chkPhotoRear: "Traseira",
    chkPhotoRearLeft: "Lateral traseira esq.",
    chkPhotoRearLight1: "Farol traseiro 1",
    chkPhotoRearLight2: "Farol traseiro 2",
    chkPhotoRearLight3: "Farol traseiro 3",
    chkPhotoRearRight: "Lateral traseira dir.",
    chkPhotoRoof: "Teto",
    chkPhotoSourcePre: "Foto:",
    chkPhotoTake: "Tirar",
    chkPhotoWindshield: "Pára-brisa trincado",
    chkPhotosDone: "Fotos completas",
    chkPhotosTitle: "Fotos do veículo (obrigatórias)",
    chkRetakePhoto: "Refazer a foto",
    chkSaveBtn: "Salvar check-list",
    chkSavedMsg: "Check-list salvo.",
    chkSaving: "Salvando…",
    chkSignClear: "Limpar",
    chkSignHint: "Assine com o dedo no quadro branco",
    chkSignNamePh: "Nome de quem assina",
    chkSignTitle: "Assinatura do cliente",
    chkSignedBadge: "Assinatura registrada",
    chkTakePhotoBtn: "Tirar foto",
    chkTitle: "Check-list do veículo",
    chkUploading: "Enviando…",
    claimDemontageHint: "A montagem fica com você, a menos que outro técnico a assuma.",
    claimDemontageQ: "Assumir a desmontagem?",
    claimDevisNoPanels:
      "Devis sem tabela de peças (importado antes do parser — peça o re-upload do PDF)",
    claimFranchisePre: "Franquia de",
    claimFranchiseSuf: "descontada da base de cálculo — devis intacto.",
    claimFranchiseSufParticular:
      "cliente particular: fatura integral (avoir); comissões na base reduzida.",
    claimMontage: "Assumir a desmontagem",
    claimMontageOnly: "Assumir só a desmontagem/montagem",
    claimNeedsReception: "Salve a recepção acima para liberar os botões de assumir o carro.",
    claimNoMontage: "Este devis não tem desmontagem — nada para o montador neste carro.",
    claimOkPre: "✓ Assumido:",
    claimPdr: "Assumir só PDR",
    claimPdrMontage: "Assumir PDR + Montagem",
    claimedAlready: "Você já assumiu este carro",
    commissionDemontage: "Desmontagem",
    commissionFixedBadge: "valor fixo",
    commissionMontageHalf: "Montagem",
    commissionPendingHint: "a fazer",
    commissionTbd: "a calcular",
    degarnissageGarageBtn: "Dégarnissage feito pelo garage (terceiro)",
    degarnissageGarageConfirm:
      "Confirmar: a desmontagem e a montagem deste carro foram feitas pelo garage? Ninguém da ES/BS receberá por elas.",
    degarnissageGarageDone: "Dégarnissage registrado como feito pelo garage.",
    deposeReposeLabel: "Desmontar/Remontar",
    devisHtLabel: "Devis HT",
    devisNetOfFranchise: "franquia já descontada",
    docsA1: "Certificado A1 ou attestation URSSAF",
    docsAllDone: "Documentos completos. Obrigado.",
    docsBannerTitle: "Faltam seus documentos",
    docsDaysLeftPre: "Você tem",
    docsDaysLeftSuf: "dias para enviar.",
    docsIdentity: "Documento de identidade",
    docsIdentity2: "Carta de identidade",
    docsKbis: "Kbis / auto-entrepreneur",
    docsKbis2: "Kbis ou registro da empresa (contrato social)",
    docsLastDay: "Último dia do prazo.",
    docsOverdue: "Prazo vencido — envie hoje.",
    docsRcPro: "Seguro RC Pro",
    docsSendBtn: "Enviar",
    docsSending: "Enviando…",
    docsSentBadge: "enviado",
    docsUrssaf: "Attestation URSSAF ou certificado A1",
    filterAll: "Todos",
    filterMonth: "Último mês",
    filterRange: "Intervalo de datas",
    filterSince: "Desde 01/05/2026",
    filterThisWeek: "Esta semana",
    filterWeek: "Últimos 7 dias",
    foundInOtherCompanyPre: "Este carro está na empresa",
    hidePhotosBtn: "Esconder fotos",
    impactsWord: "impactos",
    impersonatingBy: "por",
    impersonatingExit: "Encerrar visão",
    impersonatingPre: "Vendo como",
    importAtelierLabel: "Ateliê / local do serviço",
    importAtelierPlaceholder: "— escolher o ateliê —",
    importChantierHint:
      "O cliente sai do nome impresso no devis e entra no chantier. Use esta opção para carro de particular.",
    importClientPlaceholder: "— escolher o cliente —",
    importExistsPre: "Este devis JÁ EXISTE no Gestion — nada foi duplicado. Carro:",
    importHint:
      "Recebeu no local um devis que não aparece na busca? Escolha o cliente do chantier e envie o PDF — o carro entra na hora e você já pode assumir.",
    importLink: "ou importar um devis (PDF)",
    importNoClients:
      "Nenhum cliente vinculado a você — peça ao escritório para configurar o par de comissão.",
    importOkPre: "Devis importado:",
    importPanelsWord: "peças",
    importPhotoBtn: "Importar por foto / print de tela",
    importPhotoFail:
      "Não consegui ler o devis na foto — tente um print de tela mais nítido ou use o PDF.",
    importPhotoHint:
      "Print de tela funciona melhor que foto de papel. A leitura acontece no seu aparelho; a 1ª vez baixa o leitor (~6 MB).",
    importPhotoReading: "Lendo a foto…",
    importPickBtn: "Escolher PDF e importar",
    importReadFail: "Não consegui ler o arquivo — tente selecionar de novo (fora de zip).",
    importScanCancelBtn: "Cancelar",
    importScanConfirmBtn: "Importar com esta placa",
    importScanFail:
      "Não consegui ler o PDF digitalizado. Fotografe o devis com boa luz e use o botão de foto.",
    importScanPlatePrompt: "Placa lida do devis — confirme ou corrija antes de importar:",
    importScanReading: "PDF digitalizado — lendo o texto com OCR no aparelho…",
    importTitle: "Importar devis (PDF)",
    importing: "Importando…",
    logout: "Sair",
    menuBtnAria: "Menu",
    menuHome: "Início",
    modePlate: "Placa",
    montageEndPhotosTitle: "Fotos do fim do trabalho",
    montageExternalBtn: "Montagem feita por terceiro (garage)",
    montageExternalConfirm:
      "Confirmar: a montagem deste carro foi feita por terceiro (garage)? Ninguém da ES/BS receberá por ela.",
    montageExternalDone: "montagem feita por terceiro (garage)",
    montageExternalHint: "Ninguém da ES/BS recebe por esta etapa.",
    montageHtLabel: "Montagem HT",
    montagePhotosTitle: "Fotos da desmontagem",
    montageShort: "Montagem",
    myCarsEmpty: "Nenhum carro assumido ainda.",
    myCarsTitle: "Meus carros",
    myCommissionMontage: "Sua comissão (Montagem)",
    myCommissionPdr: "Sua comissão (PDR)",
    myTasksDoneBtn: "Feito",
    myTasksDue: "Prazo",
    myTasksHint: "Toque em Feito quando terminar. A tarefa atrasada fica aqui até ser feita.",
    myTasksLaterBtn: "Ver depois",
    myTasksOverdue: "Atrasada",
    myTasksTitle: "Tarefas do escritório",
    myTasksToday: "Hoje",
    mycarsMarkPhasesBtn: "Marcar desmontagem / montagem (abre o carro)",
    navCars: "Carros",
    navMore: "Mais",
    navPayments: "Pagamentos",
    navScanner: "Escanear",
    navWorklog: "Worklog",
    noPairHint:
      "Este carro é de um cliente com quem você não tem par configurado, e o cliente não está ligado a um chantier onde você tem par. Peça ao escritório para configurar o par ou ligar o cliente ao chantier.",
    noPairTitle: "Carro encontrado, mas não está liberado para você",
    noResults:
      'Nenhum carro "a executar" com essa placa. Confira a placa ou fale com o escritório.',
    notLinkedNote:
      "⚠ Conta ainda não vinculada a um cadastro de técnico — peça ao escritório (Técnicos → editar → Conta do portal).",
    notTechnicianNote: "Sua conta não tem papel de técnico em nenhuma empresa.",
    noticeAckBtn: "Ciente",
    noticeAckHint: "Ciente: volta na próxima entrada · Feito: não aparece mais.",
    noticeBlockedHint: "Finalize as tarefas pendentes ou consulte o escritório:",
    noticeBlockedTitle: "Portal bloqueado",
    noticeBlockedWait:
      "Só o escritório libera o portal (carro novo, importação de devis e scanner).",
    noticeDoneBtn: "Feito",
    noticeTitle: "Recado do escritório",
    openCarBtn: "Abrir o carro",
    openCarsMontage: "montagem não registrada · desmontagem:",
    openCarsNoMontage: "dégarnissage do devis não lançado — assuma-o ou declare feito pelo garage",
    openCarsNote:
      "Seu PDR está concluído, mas a montagem ainda não foi registrada. Finalize o veículo: registre a montagem ou avise o montador.",
    openCarsOpen: "Abrir",
    openCarsTitle: "Veículos que você iniciou e ainda não finalizou",
    otherCarsHint:
      "Para assumir este carro é preciso o devis — importe o PDF abaixo ou fale com o escritório.",
    otherCarsTitle: "Esta placa já está no Gestion, mas sem devis importado:",
    otherCarsWith: "com",
    panelsTitle: "Peças a reparar",
    parcCarBtn: "Carro de parc",
    parcChoiceLater:
      "O valor fica definido quando você assumir o carro, depois da recepção: só PDR, ou PDR + desmontagem/montagem.",
    parcChooseAtelier: "— escolher o ateliê —",
    parcChooseCategory: "— escolher a categoria —",
    parcChooseClient: "— escolher o cliente —",
    parcCreateBtn: "Lançar carro de parc",
    parcCreatedPre: "Carro de parc lançado — faça a recepção:",
    parcImportPdfBtn: "Importar PDF do devis",
    parcMakePh: "Marca",
    parcModelPh: "Modelo",
    parcNoneHint: "Nenhum cliente seu tem categorias de carro de parc — fale com o escritório.",
    parcOnlyPdr: "só PDR",
    parcPlateLabel: "Placa:",
    parcWithMontage: "PDR + desmontagem/montagem",
    parcYouReceive: "você recebe",
    pdrDoneBtn: "Marcar PDR finalizado",
    pdrDoneQ: "Terminou o PDR deste carro?",
    pdrPendingNote: "Finalize o PDR destes carros antes de assumir outro carro:",
    pendingTasksBtn: "Tarefas pendentes",
    pendingTasksClose: "Fechar",
    pendingTasksHint:
      "Você pode fechar e consultar seus carros, mas não assume nem lança um carro novo enquanto houver PDR sem “PDR finalizado”.",
    pendingTasksNone: "Nenhuma tarefa pendente.",
    pendingTasksTitle: "Tarefas pendentes",
    periodAria: "Período",
    phaseBothDoneBy: "Desmontagem e montagem feitas por",
    phaseDemontageBtn: "Marcar desmontagem concluída",
    phaseDemontageByPre: "Desmontado por",
    phaseDemontageDone: "Desmontagem feita",
    phaseDemontageTitle: "Desmontagem",
    phaseDoneDemontageHint: "Já está na sua lista como desmontado. Falta a montagem.",
    phaseDoneDemontageMsg: "Carro desmontado",
    phaseDoneMontageHint: "Trabalho concluído neste carro.",
    phaseDoneMontageMsg: "Carro montado",
    phaseExternalShort: "terceiro (garage)",
    phaseMontageAfterDemontage: "2 · Montagem — depois de concluir a desmontagem.",
    phaseMontageBtn: "Marcar montagem concluída",
    phaseMontageDone: "Montagem feita",
    phaseMontagePending: "falta a montagem",
    phaseMontageTitle: "Montagem",
    photoUploadFailPre: "A foto não subiu:",
    photosDemontage: "Desmontagem",
    photosMontageEnd: "Fim do trabalho",
    photosReception: "Recepção",
    plateLabel: "Placa do carro",
    prodAllTime: "Total geral",
    prodCar: "carro",
    prodCars: "carros",
    prodPaid: "Pago",
    prodTbdNote: "carros com valor ainda a calcular não entram na soma",
    prodTitle: "Minha produção",
    prodToReceive: "a receber",
    readOnlyNote:
      "Conta somente para consulta: você vê os carros que fez e a situação de cada pagamento, mas não pode lançar nem alterar nada.",
    recAmountPh: "Valor da franquia (€ TTC)",
    recDamagesPh: "Danos/peças quebradas pré-existentes (opcional, separe por vírgula)",
    recDoneLabel: "Recepção feita",
    recFranchiseFirstHint: "Responda a franquia para liberar as fotos da recepção.",
    recFranchisePre: "Franquia:",
    recFranchiseQ: "O veículo tem desconto de franquia ao cliente?",
    recFranchiseStep: "1 · Franquia — obrigatório",
    recHint:
      "Responda a franquia e anote danos pré-existentes. O gerente do chantier também pode fazer isso — se já fez, o carro chega liberado.",
    recHintNoPhotos:
      "Fora do chantier não há fotos: responda só se o carro tem dedução de franquia (obrigatório) e assuma o serviço.",
    recIncompleteWait:
      "Recepção incompleta — quem a fez (gerente, sênior ou técnico PDR) precisa completá-la antes de você assumir o serviço.",
    recNo: "Não",
    recNoFranchise: "sem franquia",
    recPhotosStep: "2 · Danos e fotos",
    recSaveBtn: "Salvar recepção",
    recSavedMsg: "Recepção salva — o carro está liberado para reparo.",
    recSaving: "Salvando…",
    recTitle: "Recepção do veículo (obrigatória antes de reparar)",
    recWaitingHint:
      "No chantier, a recepção (franquia, check-list, fotos e assinatura) é do gerente ou do técnico sênior; fora do chantier, do técnico PDR do carro. Depois disso você pode assumir o serviço.",
    recWaitingTitle: "Aguardando a recepção",
    recYes: "Sim",
    repairedAtPre: "Assumido em",
    roleMontador: "Montador",
    rolePdr: "Técnico PDR",
    rowDemontageDone: "desmontado",
    rowMontageDone: "montado",
    rowPaid: "Pago",
    rowPaidPartial: "Pago em parte",
    scanFail: "Não consegui ler na foto — aproxime, evite reflexo e tente de novo, ou digite.",
    scanTitle: "Ler pela câmera",
    scanWarn_car_existed: "O carro já existia no Gestion — dossier completado, nada duplicado.",
    scanWarn_customer_created: "Cliente novo criado a partir do devis.",
    scanWarn_customer_matched: "Cliente casado com um cadastro já existente.",
    scanWarn_devis_linked_existing: "Nº do devis vinculado ao dossier já existente.",
    scanWarn_make_model_backfilled: "Marca/modelo do carro preenchidos a partir do devis.",
    scanWarn_num_from_filename: "Nº do devis lido do nome do arquivo.",
    scanWarn_plate_confirmed: "Placa confirmada por você.",
    scanWarn_scan_deg_adjusted:
      "Dégarnissage ajustado pelo Total HT (a caixa saiu ilegível no OCR).",
    scanWarn_scan_dsp_derived:
      "Total DSP calculado a partir do Total HT (o OCR não leu a caixa do DSP).",
    scanWarn_scan_ht_from_sum: "Total HT calculado pela soma das parcelas.",
    scanWarn_scan_ht_from_ttc: "Total HT calculado a partir do TTC.",
    scanWarn_scan_no_client: "Nome do cliente não identificado.",
    scanWarn_scan_no_date: "Data do devis não reconhecida.",
    scanWarn_scan_no_panels: "Peças e impactos não extraídos do diagrama (devis digitalizado).",
    scanWarn_scan_no_plate: "Placa não identificada no documento.",
    scanWarn_scan_ocr:
      "Devis digitalizado lido por OCR — confira placa, cliente e valores no documento.",
    scanWarn_scan_plate_ocr: "Placa lida por OCR — confira.",
    scanWarn_scan_sum_mismatch: "A soma das parcelas difere do Total HT — confira o documento.",
    scanning: "Lendo a foto…",
    searchBtn: "Buscar",
    searchCarBtn: "Buscar o carro",
    searchHint:
      "Digite a placa OU o VIN para buscar o veículo. O botão ⇄ alterna entre os dois campos.",
    searching: "Buscando…",
    servicePdrLabel: "PDR",
    servicesTitle: "Serviços deste carro",
    showPhotosBtn: "Ver fotos",
    sitDone: "Terminado · a receber",
    sitInRepair: "Em reparação",
    sitMontage: "Montagem a fazer",
    statusAria: "Situação do pagamento",
    statusPaid: "Pagos",
    statusPending: "A receber",
    switchCompanyBtn: "Ver em",
    takeDemontageBtn: "Assumir a desmontagem",
    takeHint: "Você recebe a metade desta etapa, pelo seu percentual com o cliente.",
    takeMontageBtn: "Assumir a montagem",
    takeOwnMontageBtn: "Assumir a montagem",
    takeOwnMontageHint:
      "Desmontagem concluída. Assuma a montagem quando for começá-la — até lá outro técnico pode pegá-la.",
    title: "Portal do Técnico",
    toastDemontageDone: "Desmontagem finalizada",
    toastDemontageTaken: "Desmontagem assumida",
    toastMontageDone: "Montagem finalizada",
    toastPdrDone: "Serviço PDR finalizado",
    toastPdrStarted: "Serviço PDR iniciado",
    weekWord: "Semana",
    worklogEmpty: "Sem produção nesta semana.",
    worklogPdfBtn: "Baixar PDF",
    worklogTitle: "Worklog (PDF)",
    worklogWeekPre: "Semana",
  },
  techSignup: {
    backToLogin: "Já tenho conta",
    countryLabel: "País onde você trabalha",
    docsNotice:
      "Depois de liberado, o portal vai pedir seus documentos: carta de identidade, Kbis ou documento equivalente e — conforme onde você reside — o documento da URSSAF (residentes na França) ou o certificado A1. Você tem 7 dias para enviá-los; o trabalho não fica parado esperando.",
    emailHint: "Será o seu login. Você recebe nele o link para criar a senha.",
    emailLabel: "E-mail",
    errorRequired: "Preencha nome, e-mail, telefone e país.",
    intro: "Preencha seus dados. A Euro Storm confere e libera o seu acesso ao portal.",
    langLabel: "Idioma do portal",
    nameLabel: "Nome completo",
    phoneLabel: "Telefone / WhatsApp",
    residenceHint: "É isto que define quais documentos vamos pedir depois.",
    residenceLabel: "País de residência / autorização de trabalho",
    roleDebosselage: "Técnico PDR (débosselage)",
    roleLabel: "O que você faz",
    roleMontage: "Montador (desmontagem e montagem)",
    sending: "Enviando…",
    submitBtn: "Enviar cadastro",
    subtitle: "Cadastro de técnico",
    successBody:
      "A Euro Storm vai conferir seus dados. Quando liberar, você recebe um e-mail para criar a sua senha.",
    successTitle: "Cadastro enviado.",
  },
  technicianDetail: {
    approvalRate: "Taxa de aprovação",
    auditLogOfTechnician: "Audit log do técnico",
    auditRequiresAdmin: "Audit log requer permissão admin.",
    avgDaysToPayment: "Dias médios pagamento",
    avgInvoicedPerLine: "Faturado médio por linha",
    backToList: "Voltar à lista",
    colAction: "Ação",
    colAmount: "Valor",
    colBy: "Por",
    colCode: "Code",
    colCustomer: "Cliente",
    colDate: "Data",
    colInvoiceNumber: "N° fatura",
    colIssueDate: "Data emissão",
    colMethod: "Método",
    colNumberExternal: "N° (externo)",
    colPeriod: "Período",
    colPlate: "Placa",
    colReason: "Motivo",
    colReference: "Referência",
    colStatus: "Status",
    colTi: "TI",
    colTotal: "Total",
    colWhen: "Quando",
    commissionsByCustomer: "Comissões (por cliente)",
    configureCommissions: "Configurar comissões",
    country: "País",
    createPortalAccess: "Criar acesso ao portal",
    dossiers: "Dossiers",
    dossiersOfTechnician: "Dossiers do técnico",
    emptyAudit: "Nenhum evento.",
    emptyDossiers: "Nenhum dossier nesta janela.",
    emptyInvoices: "Nenhuma fatura nesta janela.",
    emptyPayments: "Nenhum pagamento nesta janela.",
    financial: "Financeiro",
    inactive: "inativo",
    invalidId: "ID inválido.",
    invoicedHtLines: "Faturado HT (lines)",
    invoicesIssuedByTechnician: "Faturas emitidas pelo técnico",
    linesHandled: "Linhas atendidas",
    list: "Lista",
    loading: "Carregando…",
    net: "líquido",
    noPairConfigured: "nenhum par configurado",
    notFound: "Técnico não encontrado nas empresas acessíveis.",
    noticesBlockHint:
      "O técnico não assume carro novo, não importa devis nem usa o scanner. «Ciente» não solta: só o botão «Tarefa concluída — liberar» aqui.",
    noticesBlockLabel: "Travar o portal até o escritório liberar",
    noticesBlockedBadge: "portal bloqueado",
    noticesDonePre: "feito em",
    noticesEmpty: "Nenhum recado enviado.",
    noticesHint:
      "O recado abre em pop-up toda vez que o técnico entra no portal. «Ciente» fecha até a próxima entrada; «Feito» encerra. Escreva no idioma dele. Para a equipe toda, use o menu Recados.",
    noticesNoLogin: "Este técnico não tem login no portal.",
    noticesPlaceholder: "Ex.: finalize os carros GE-707-JH e GC-166-WP no portal…",
    noticesReadPre: "lido em",
    noticesResolveBtn: "Tarefa concluída — liberar o portal",
    noticesResolvedPre: "liberado em",
    noticesSendBtn: "Enviar recado",
    noticesTitle: "Recado no portal do técnico",
    noticesUnread: "ainda não lido",
    open: "abrir",
    operational: "Operacional",
    paymentsToTechnician: "Pagamentos ao técnico",
    period12m: "Últimos 12 meses",
    period30d: "Últimos 30 dias",
    period3m: "Últimos 3 meses",
    period6m: "Últimos 6 meses",
    periodAll: "Tudo",
    periodCustom: "Datas personalizadas",
    periodSince: "Desde 01/05/2026 (início do Gestion)",
    periodYear: "Ano atual",
    phone: "Telefone",
    portalRoleLabel: "Função no portal",
    registration: "Cadastro",
    reversal: "estorno",
    statusApproved: "aprovada",
    statusCancelled: "cancelada",
    statusCustomerReceived: "recebida",
    statusDraft: "rascunho",
    statusIssued: "emitida",
    statusPaid: "paga",
    statusPending: "pendente",
    statusReceived: "recebida",
    statusRejected: "rejeitada",
    tabAudit: "Audit",
    tabFaturas: "Faturas técnico",
    tabNotices: "Recados no portal",
    tabPagamentos: "Pagamentos",
    tabResumo: "Resumo",
    tabWorklog: "Worklog",
    taxId: "Tax ID",
    toPay: "A pagar",
    total: "total",
    totalIssuedByTechnician: "Total emitido pelo técnico",
    totalPaid: "Total pago",
    window: "Janela",
    wlAwaitingClient: "Aguardando cliente",
    wlByCustomer: "CA por cliente",
    wlCardFilterHint: "Clique num cartão para filtrar a lista abaixo.",
    wlCarsWord: "carros no período",
    wlClearFilter: "limpar filtro",
    wlClientInvoiced: "Faturado",
    wlClientPaidBadge: "Recebido",
    wlClientReceived: "Recebido do cliente",
    wlClientToInvoice: "A faturar",
    wlColCar: "Carro",
    wlColClientReceived: "Recebido cliente",
    wlColCommission: "Comissão",
    wlColProduced: "Produzido",
    wlColService: "Serviço",
    wlEmpty: "Nenhuma linha de serviço no período.",
    wlMontage: "Montagem",
    wlNoPairBtn: "Configurar pares",
    wlNoPairChip: "Par técnico×cliente ausente ou com 0% — comissão não calculada",
    wlNoPairPre: "Comissão zerada — par técnico×cliente ausente ou com 0% para:",
    wlNoPairShort: "sem par",
    wlNoPairSuf:
      "Edite o % do par (e salve a linha) e depois use 'Recalcular comissões' em Dossiers.",
    wlOfProduced: "do produzido",
    wlPaidBeforeClient: "Pago antes do cliente",
    wlPaidBeforeClientHint:
      "O técnico recebeu este carro antes de o cliente pagar (adiantado pela empresa).",
    wlPayBtn: "Pagar liberados",
    wlPendingCalc: "linhas a calcular",
    wlProduced: "Produzido (faturado)",
    wlProducedShort: "produz.",
    wlProducedSub: "valor HT dos carros dele",
    wlReceived: "Pago ao técnico (período)",
    wlReceivedShort: "receb.",
    wlReleased: "Liberado (cliente pagou)",
    wlRemaining: "Falta",
    wlShareDemontage: "Desmontagem (metade)",
    wlShareMontage: "Montagem (metade)",
    wlStatusAwaiting: "Aguard. cliente",
    wlStatusReleased: "Liberado",
    wlTbd: "a calcular",
    wlToReceive: "CA a receber (comissões)",
  },
  technicianPayments: {
    advAccountHint:
      'Cada adiantamento fica aberto até o técnico descontá-lo na fatura dele (marcado em "Registrar fatura recebida").',
    advAmount: "Valor",
    advBankHint:
      'Saiu da conta da empresa? Então concilie a saída no extrato e marque "É adiantamento a técnico" lá — não lance aqui.',
    advCancel: "Cancelar",
    advCancelMsg: "Motivo do cancelamento (fica no histórico):",
    advCancelTitle: "Cancelar adiantamento",
    advDate: "Data",
    advDescription: "Descrição",
    advDescriptionHint: "Ex.: hotel Ibis 3 noites, ferramentas PDR PILLON…",
    advFormIncomplete: "Escolha o técnico, informe um valor maior que zero e uma descrição.",
    advNew: "Novo adiantamento",
    advNoneOpen: "Nenhum adiantamento por conta em aberto.",
    advOrigin: "Origem",
    advOriginAdjustment: "ajuste do devis",
    advOriginBank: "Conta da empresa (extrato)",
    advOriginCash: "Dinheiro em espécie",
    advOriginPartner: "Bolso / conta do sócio",
    advPartnerNote: "Pagos do bolso do sócio (não saem do caixa da empresa):",
    advSave: "Lançar",
    allPayers: "Todas pagadoras",
    allPaymentStatuses: "Todos status pag.",
    allTechnicians: "Todos técnicos",
    amountLabel: "Valor (€)",
    backAllTechs: "Todos os técnicos",
    byTechCars: "carro(s)",
    byTechColAdvanced: "Adiantado",
    byTechColAdvancedTitle: "Adiantamentos por conta ainda não descontados na fatura do técnico",
    byTechColPaid: "Pago",
    byTechColPending: "Pendências",
    byTechColReleased: "Liberado (repassar)",
    byTechColWaiting: "Aguardando cliente",
    byTechHint:
      "Clique no técnico para abrir as linhas dele. Liberado = cliente já pagou; Aguardando = fatura do cliente ainda em aberto.",
    byTechLines: "linha(s)",
    cancel: "Cancelar",
    cardNoInvoice: "Sem fatura técnico",
    cardPaid: "Pago",
    cardPaidTotal: "Pago Total",
    cardToPay: "A pagar",
    cardWaiting: "Aguardando",
    clearBtn: "Limpar",
    clearFilters: "Limpar filtros",
    clearFiltersTitle: "Restaura todos os filtros para o padrão",
    colAction: "Ação",
    colAttachment: "Anexo",
    colCustomer: "Cliente",
    colCustomerInvoice: "Fatura do cliente",
    colDossier: "Dossier",
    colInvoiceStatus: "Status fatura",
    colPaid: "Pago",
    colPaymentStatus: "Status pag.",
    colPlate: "Matrícula",
    colSituation: "Situação",
    colTechnician: "Técnico",
    colToPay: "A pagar",
    colVehicle: "Veículo",
    commissionInvalid: "commissionPercent inválido (0..100).",
    commissionLabel: "Comissão (%) — opcional",
    createProforma: "Criar proforma",
    creating: "Criando…",
    custRecAll: "Todos",
    custRecReceived: "Recebido (repasse liberado)",
    custRecWaiting: "Aguardando cliente",
    customMessageLabel: "Mensagem customizada (opcional)",
    cxAdvances: "Adiantamentos em aberto",
    cxAdvancesAccount: "adiantamentos por conta",
    cxAdvancesAccountTitle:
      "Hotel, ferramentas, dinheiro do sócio… descontados na próxima fatura do técnico",
    cxAdvancesTitle:
      "Carros cujo cliente ainda não pagou, mas que já foram pagos ao técnico ou estão numa proforma",
    cxAvailable: "Disponível para repassar",
    cxBankBalance: "Saldo do extrato",
    cxBankBalanceNone: "sem saldo importado: importe o último extrato em Banco → Importar",
    cxBankBalanceTitle:
      "Saldo informado pelo último arquivo importado do banco, na data do extrato. Não é calculado pelo Gestion.",
    cxColAdvanced: "Adiantado",
    cxHint:
      'O dinheiro recebido é um só: dá para adiantar carros de um técnico (aba "Aguardando o cliente") com o caixa de outro. Cada carro só é pago uma vez — proforma ativa ou pago, ele não volta.',
    cxInProforma: "Já em proforma",
    cxNoAdvances: "Nenhum adiantamento em aberto.",
    cxOverBankPre: "O disponível passa do saldo do extrato em",
    cxOverBankSuf:
      "Pague até o menor dos dois (o dinheiro recebido também pagou impostos, fornecedores e sócios).",
    cxPaidBefore: "pago antes do cliente",
    cxReleasedFree: "Recebido a repassar (sem proforma)",
    dateFrom: "Data inicial",
    dateTo: "Data final",
    degPendingHint:
      "Cada peça do carro (PDR, desmontagem, montagem) é paga uma vez, a quem a fez. Pode pagar o que está pronto agora; o resto entra na próxima proforma de quem fizer.",
    degPendingOther:
      "falta a desmontagem ou a montagem de outro técnico (não entra nesta proforma)",
    degPendingOwn:
      "a desmontagem ou a montagem deste técnico ainda falta: essa parte fica para uma próxima proforma",
    degPendingTitle: "Dégarnissage ainda em aberto nestes carros",
    detailsHint:
      "Totais sobre todo o filtro. Clique no carro para ver a repartição, a fatura do técnico e pagar.",
    devisLabel: "Devis",
    diffTechnicians: "técnicos diferentes — selecione do mesmo técnico",
    emptyState: "Nenhum lançamento encontrado.",
    entryPlural: "lançamentos",
    entrySingular: "lançamento",
    extBtn: "Registrar pago por fora",
    extBtnHint: "O técnico já recebeu fora da proforma (equipe interna)",
    extDate: "Data do pagamento",
    extHint:
      'Para quem já recebeu fora da proforma: equipe interna, salário, dinheiro ou transferência. O Gestion cria um registro interno (INT) já pago: as peças passam a pagas e saem de "a pagar". Não envia e-mail, não gera PDF e não lança nada no banco nem nos adiantamentos. Desfazer: na página do registro (admin).',
    extIntermPre: "A parte do intermediário",
    extIntermSuf: "não entra neste registro: só a parte do técnico fica paga.",
    extMethod: "Forma",
    extMethodDinheiro: "Dinheiro",
    extMethodOutro: "Outro",
    extMethodSalario: "Salário (equipe interna)",
    extMethodTransferencia: "Transferência",
    extNote: "Motivo / observação (obrigatório)",
    extNotePh: "ex.: salário de outubro, equipe interna",
    extSubmit: "Registrar pagamento",
    extTitle: "Registrar pagamento feito por fora",
    filterCompany: "Empresa",
    filterCustomerReceived: "Cliente recebido",
    filterPayer: "Pagadora",
    filterPaymentStatus: "Status pag.",
    filterPeriod: "Período (data fatura)",
    filterSearch: "Buscar",
    filterSortBy: "Ordenar por",
    filterTechnician: "Técnico",
    flowDetected: "Fluxo detectado:",
    flowDirect: "Direto ao técnico",
    flowExternal: "Intermediário externo",
    flowExternalPre: "Este técnico é pago por",
    flowExternalSuf: "(intermediário externo). Gere o pagamento em Intermediários.",
    flowGroup: "Empresa do grupo (intercompany)",
    flowMismatchHint:
      "A proforma usa os valores das LINHAS. Corrija a comissão das linhas no dossier antes de gerar.",
    flowMismatchLines: "linhas",
    flowMismatchPair: "par",
    flowMismatchTitle: "Linhas calculadas com outra fatia do intermediário que a do par:",
    flowPreviewError: "Não foi possível determinar o destinatário.",
    flowSourceNote:
      "Decidido pelo par técnico × cliente de cada carro (ou pelo intermediário do cadastro do técnico).",
    forceOverride: "Forçar (override admin)",
    gateBlocked: "Payment gate (F10.3) bloqueou:",
    generateProforma: "Gerar proforma",
    inProforma: "Em proforma",
    invStatusApproved: "aprovada",
    invStatusPending: "sem fatura",
    invStatusReceived: "recebida",
    invStatusRejected: "rejeitada",
    invalidAmount: "Valor inválido.",
    invoiceLabel: "Fatura",
    invoicedLabel: "Faturado",
    kpiPrefix: "KPIs refletem a página atual",
    kpiSuffix: "linhas no filtro",
    lineInProforma: "Linha já está na proforma",
    linePlural: "linhas",
    lineSelectedPlural: "linhas selecionadas",
    lineSelectedSingular: "linha selecionada",
    lineSingular: "linha",
    linesSubtitle: "linhas",
    loading: "Carregando…",
    loadingTechnician: "Carregando técnico…",
    methodBankTransfer: "Transferência",
    methodCard: "Cartão",
    methodCash: "Espécie",
    methodCheck: "Cheque",
    methodLabel: "Método",
    methodOther: "Outro",
    next: "Próxima",
    noCommissionTag: "sem comissão",
    noCommissionTitle:
      "Carros com o cliente já pago e sem comissão calculada: o par técnico × cliente não está configurado.",
    noCommissionWarn:
      "carro(s) com o cliente já pago estão SEM comissão calculada (par técnico × cliente não configurado) e não entram no valor liberado. Configure o par no cadastro do técnico.",
    noCompanyAccess: "Você não tem acesso a nenhuma empresa.",
    noInvoiceAlert:
      "Esta linha ainda não tem fatura do técnico criada. Crie a technician_invoice antes de pagar.",
    noTechInvoice: "ainda não recebida",
    noTechnicianData: "Sem dados do técnico.",
    notReceived: "a receber",
    notesLabel: "Notas (opcional)",
    of: "de",
    optCancelled: "Cancelado",
    optPaid: "Pago",
    optPending: "Aguardando",
    overridePlaceholder: "Justificativa (min 5 chars) — registrada em audit",
    pageWord: "Página",
    paidAtLabel: "Pago em",
    payBtn: "Pagar",
    payDialogTitle: "Registrar pagamento ao técnico",
    payStatusCancelled: "cancelado",
    payStatusPaid: "pago",
    payStatusPending: "aguardando",
    payTitle: "Registrar pagamento",
    payTitleNoInvoice: "Crie technician_invoice primeiro",
    pdfLanguageLabel: "Idioma do PDF",
    pillReleased: "Liberado",
    pillWaiting: "Aguardando cliente",
    prev: "Anterior",
    proformaDialogTitle: "Gerar proforma do técnico",
    proformaTechnicianNote: "Proforma técnico — gatilho administrativo NÃO dispara.",
    receivedOn: "recebido em",
    receivedWord: "recebido",
    recipientLabel: "Destinatário:",
    recipientTypeLabel: "Tipo destinatário:",
    referenceLabel: "Referência (opcional)",
    register: "Registrar",
    retentionInvalid: "retentionPercent inválido (0..100).",
    retentionLabel: "Retenção (%)",
    saving: "Registrando…",
    searchPlaceholder: "N° fatura / dossier / matrícula…",
    selAdvanceOver: "o adiantamento passa do disponível:",
    selAdvancePart: "adiantamento",
    selIntermPart: "intermediário",
    selReleasedPart: "liberado",
    selTechPart: "técnico",
    selectFreeLines: "Selecionar linhas livres",
    selectionLabel: "Seleção",
    sortDefault: "Ordem: data ↓ (padrão)",
    sortInvoiceAsc: "N° fatura ↑",
    sortInvoiceDesc: "N° fatura ↓",
    sortTitle: "Ordenação",
    stageAll: "Todos",
    stageReleased: "Liberado a repassar",
    stageReleasedShort: "liberado(s)",
    stageWaiting: "Aguardando o cliente",
    stageWaitingShort: "aguardando",
    statusWord: "status",
    techInvoiceLabel: "Fatura do técnico",
    technicianLabel: "Técnico",
    totalToPay: "Total a pagar",
  },
  technicians: {
    allLinked: "— todos os clientes já vinculados —",
    appApproveBtn: "Aprovar",
    appApproved: "Aprovado",
    appCompaniesLabel: "Empresas:",
    appExistsCars: "carros",
    appExistsPre: "Já está no Gestion como",
    appExistsSuf: "— a ficha será reaproveitada, nada é duplicado.",
    appPending: "Pendente",
    appPrefixMade: "prefixo gerado",
    appRejectBtn: "Recusar",
    appRejectPrompt: "Motivo da recusa:",
    appRejected: "Recusado",
    appRoleLabel: "Função",
    appRoleMontador: "Montador",
    appRolePdr: "Técnico PDR",
    appShowAll: "Ver todas",
    appShowPending: "Só pendentes",
    appsEmpty: "Nenhuma candidatura pendente.",
    appsHint:
      "Cadastros enviados pela página pública. Aprovar cria o usuário e o cadastro de técnico, com o prefixo da ordem gerado sem colidir.",
    badgeActive: "ativo",
    badgeBlocked: "portal bloqueado",
    badgeInactive: "inativo",
    baseFaturado: "Faturado",
    baseFaturadoFull: "Faturado (Total Facture)",
    baseOrcamento: "Orçamento",
    baseOrcamentoFull: "Orçamento (Prix Brut)",
    cancel: "Cancelar",
    chantierAllLinked: "Todos os chantiers já vinculados",
    chantierBaseFaturado: "Faturado (Total Facture)",
    chantierBaseLabel: "Base de cálculo",
    chantierBaseOrcamento: "Orçamento (Prix Brut)",
    chantierCommHint:
      "o % deste técnico no chantier vale p/ todos os clientes dele sem par específico",
    chantierCommTitle: "Comissões por chantier",
    chantierIntermLabel: "Intermediário",
    chantierIntermNone: "— sem intermediário —",
    chantierIntermPctLabel: "% Intermediário",
    chantierLinkOption: "+ Vincular chantier — selecionar…",
    chantierNewTag: "novo — defina o %",
    chantierPctLabel: "Comissão do técnico (%)",
    chantierRemiseNote:
      "A remise do cliente vem do CADASTRO de cada cliente (inclusive particular) e é conferida na recepção do veículo — o chantier não define remise.",
    chantierSave: "Salvar",
    chantierUnlink: "Remover vínculo",
    clientPctFallbackPre: "Vazio: usa a retenção do cadastro do cliente —",
    clientPctFallbackSuf: "",
    clientPctHint: "Este % vale só para este par e tem prioridade sobre o cadastro do cliente.",
    clientPctMissing:
      "⚠ Cliente sem retenção no cadastro — informe o % aqui para a base orçamento funcionar.",
    clientShort: "cli.",
    colActions: "Ações",
    colCommission: "Comissão",
    colTaxId: "Tax ID",
    commissionRange: "Comissão deve ser 0–100%",
    commissionsSaveFirst:
      "Comissões por cliente: salve o técnico primeiro — depois reabra para vincular clientes com % e base próprios.",
    commissionsSectionHint: "cada par cliente×técnico tem % + base + intermediário próprios",
    commissionsSectionTitle: "Comissões por cliente",
    companyLabel: "Empresa",
    create: "Criar",
    customerMissingPre: "Cliente",
    customerMissingSuf:
      "não tem % de retenção cadastrado. Atualize na ficha do cliente (menu Clientes) — em base ORÇAMENTO o cliente entra no split.",
    dash: "—",
    deactivate: "Desativar",
    deactivateMessage:
      "Técnico inativo não aparece em novas linhas de dossier. Linhas existentes não são afetadas.",
    deactivatePlaceholder: "Ex: técnico encerrou parceria",
    deactivateTitle: "Desativar técnico",
    dossierCountSuffix: "dossier(s)",
    edit: "editar",
    email: "E-mail",
    emptyState: "Nenhum técnico encontrado.",
    fieldBase: "Base de cálculo",
    fieldClientPct: "% Remise do cliente (neste par)",
    fieldCommissionPct: "Comissão (%)",
    fieldCountry: "País (ISO-2)",
    fieldIntermediaryPct: "% Intermediário",
    fieldNotes: "Notas",
    fieldParcRole: "Tipo de serviço — Parc Grêle",
    fieldPhone: "Telefone",
    fieldPortalUser: "Conta do portal (login do técnico)",
    fieldSenior: "Técnico sênior (pode alterar a franquia)",
    fieldTaxId: "Tax ID (RIB/CPF/...)",
    fieldTaxIdKind: "Tipo do Tax ID",
    fieldTaxReason: "Motivo da alteração do Tax ID",
    fillIntermediary: "Preencha o intermediário",
    filterActive: "Ativos",
    filterAll: "Todos",
    filterInactive: "Inativos",
    hintFatPre: "Em base FATURADO o cliente já reteve antes da fatura; técnico + intermediário +",
    hintFatSuf: "= 100% sobre o que sobra.",
    hintOrcPre: "Em base ORÇAMENTO o cliente entra no split;",
    hintOrcSuf: "absorve o restante.",
    intermShort: "+ interm.",
    intermediary: "Intermediário",
    linkCustomerOption: "+ Vincular cliente — selecionar…",
    loading: "Carregando…",
    loadingLinks: "Carregando vínculos…",
    modalTitleCreate: "Novo técnico",
    modalTitleEdit: "Editar técnico",
    name: "Nome",
    newBtn: "+ Novo técnico",
    next: "Próxima",
    noCompanyAccess: "Você não tem acesso a nenhuma empresa.",
    noIntermediary: "Sem intermediário",
    noIntermediaryAvailable:
      "Nenhum intermediário disponível. Cadastre um em “Intermediários” (externo) ou adicione outra empresa ao grupo.",
    noLinkedWarning:
      "Nenhum cliente vinculado — sem par configurado, criar/recalcular linhas deste técnico falha (informe os % manualmente no dossier ou vincule o cliente aqui).",
    noPctRegistered: "sem % cadastrado",
    open: "abrir",
    optgroupExternal: "Intermediários externos",
    optgroupGroupCompanies: "Empresas do grupo",
    paginationOf: "de",
    paginationPage: "Página",
    pairMissingTag: "sem par",
    pairZeroTag: "par com 0%",
    parcRoleHint:
      "Só relevante para chantiers de granizo (Parc Grêle). Cada técnico é autorizado a UM tipo de serviço; o pagamento vem do valor fixo do forfait (não da comissão).",
    parcRoleMontage: "Montador / démontage",
    parcRoleNone: "— não atua no parc (técnico normal) —",
    perCustomer: "por cliente",
    portalUserHint:
      'Crie o usuário em Usuários com papel "Técnico (portal)" e vincule aqui. O técnico loga e assume carros pela placa em /portal.',
    portalUserNone: "— sem conta vinculada —",
    prev: "Anterior",
    previewSampleBase: "base de exemplo: 1 000,00 €",
    previewTitle: "Prévia de divisão",
    reactivate: "Reativar",
    removeLink: "Remover vínculo",
    residualExceedFat: "Técnico + intermediário",
    residualExceedOrc: "Cliente + técnico + intermediário",
    residualExceedSuf: "ficaria negativo — salvar linha vai falhar.",
    save: "Salvar",
    savedNoChanges: "Salvo — sem alterações",
    savedShort: "Salvo",
    saving: "Salvando…",
    searchLabel: "Buscar",
    searchPlaceholder: "Nome, email, taxId…",
    selectOption: "— Selecionar —",
    seniorHint:
      "Todo técnico VÊ a franquia no portal. Só o sênior autorizado pode alterá-la — e o montador nunca.",
    status: "Status",
    sumExceedPre: "Técnico + intermediário =",
    sumExceedSuf: "% > 100%.",
    sumOver100: "Técnico + intermediário passa de 100%",
    tabActive: "Técnicos",
    tabApplications: "Candidaturas",
    taxIdAdminOnly: "Apenas administradores editam o Tax ID.",
    taxKindOther: "Outro",
    taxKindVatEu: "VAT (outro país UE)",
    taxReasonPlaceholder: "Obrigatório ao alterar dados fiscais",
    technicianLabel: "Técnico",
    technicianPlural: "técnicos",
    technicianSingular: "técnico",
    theCompany: "a empresa",
    totalLabel: "Total",
    withIntermediary: "Com intermediário",
    withoutPairCount: "cliente(s) com dossiers sem par configurado ou com par em 0%",
    withoutPairHint:
      "Sem par o cálculo usa a base padrão (faturado) por fallback; par com 0% deixa a comissão do técnico zerada. Configure/ajuste o par abaixo pra o cálculo ficar correto:",
  },
  treasury: {
    allCommissionsOk:
      "Todas as linhas fecham com a base certa (cliente + técnico + metades + intermediário + Euro Storm = devis − franquia − parte feita pela garage). Nada suspeito.",
    badgeConsolidated: "consolidada",
    blockedClientNotPaid: "bloqueado (cliente não pagou)",
    blockedLabel: "bloqueado",
    cascadeBaseHint:
      "Base esperada = devis − franquia (cliente particular e valor manual: devis cheio) − metade do dégarnissage feita pela garage. A soma inclui as metades passadas a outro técnico.",
    cascadeNotClosingSuffix: "com cascata que NÃO fecha com a base — revisar antes de pagar.",
    col1_30: "1–30 d",
    col31_60: "31–60 d",
    col61_90: "61–90 d",
    col90: "> 90 d",
    colBalance: "Saldo",
    colBudget: "Orçamento",
    colCascadeSum: "Soma cascata",
    colCustomer: "Cliente",
    colDelay: "Atraso",
    colDiff: "Diferença",
    colDossier: "Dossier",
    colDueDate: "Vencimento",
    colExpectedBase: "Base esperada",
    colIntermediary: "Interm.",
    colInvoiceNumber: "Nº fatura",
    colInvoices: "Faturas",
    colMaxDelay: "maior atraso",
    colNotDue: "A vencer",
    colTechnician: "Técnico",
    colTotalHt: "Em aberto HT",
    colTotalTtc: "A pagar TTC",
    commissionCheckTitle: "Conferência de comissões",
    companyLabel: "Empresa:",
    daysAbbrev: "d",
    emptyByCustomer: "Nenhuma fatura em aberto.",
    emptyNoOverdue: "Nenhuma fatura vencida. 🎉",
    invoicesSuffix: "faturas",
    linePlural: "linhas",
    lineSingular: "linha",
    loading: "Carregando…",
    overdueLower: "vencido",
    payableTitle: "A Pagar",
    receivableCustomerTitle: "A Receber — cliente",
    releasedExplainPre: '"Liberado" = cliente já pagou (gate). Detalhe por técnico em',
    releasedExplainSuf:
      ". Comissão de técnico/intermediário vem das linhas (os documentos de fatura ainda não são usados).",
    statAging0_30: "1–30 dias",
    statAging31_60: "31–60 dias",
    statAging61_90: "61–90 dias",
    statAging90plus: "+90 dias",
    statIntercompanyReceivable: "A receber intercompany",
    statIntermediaryIntercompany: "Intermediário (BS) — intercompany",
    statIntermediaryReleased: "Intermediário — liberado a repassar",
    statNotDue: "A vencer",
    statOpen: "Em aberto",
    statOverdue: "Vencido",
    statSupplierOpen: "Fornecedor — em aberto",
    statTechnicianReleased: "Técnico — liberado a pagar",
    statementBtn: "Relevé",
    techPaymentsLink: "Pagamentos Técnicos",
    viewByCustomer: "Por cliente",
    viewByInvoice: "Por fatura (vencidas)",
  },
  users: {
    accessPerCompany: "Acesso por empresa",
    accessRestricted: "Acesso restrito a administradores.",
    adminScopeNote:
      "Você vê as contas das empresas que administra. Contas de Administrador só o Super Admin altera.",
    cancelBtn: "Cancelar",
    cannotChangeOwnSuperAdmin: "Você não pode alterar o próprio super admin",
    closeBtn: "Fechar",
    colAccessPerCompany: "Acesso por empresa",
    colActions: "Ações",
    colEmail: "E-mail",
    colName: "Nome",
    colStatus: "Status",
    colSuperAdmin: "Super admin",
    copiedBtn: "Copiado ✓",
    copyLinkBtn: "Copiar link",
    createBtn: "Criar",
    createErrorTitle: "Erro ao criar usuário",
    createLinkBtn: "Criar e enviar o link",
    createLinkHint: "A pessoa recebe por e-mail um link para definir a própria senha (vale 72 h).",
    creatingBtn: "Criando…",
    deactivateAccount: "Desativar conta",
    deleteBtn: "Excluir usuário",
    deleteConfirmPre: "Excluir definitivamente",
    deleteConfirmSuf:
      "O nome e o e-mail ficam LIVRES para uma conta nova; o histórico (audit) é preservado. Esta ação não pode ser desfeita.",
    deleteConfirmTitle: "Excluir usuário?",
    deleteDonePre: "Conta excluída. O e-mail",
    deleteDoneSuf: "está livre para uma nova conta.",
    deleteDoneTitle: "Usuário excluído",
    editBtn: "Editar",
    editSavedMsg: "Nome e e-mail salvos.",
    editSavedTitle: "Dados atualizados",
    editTitle: "Editar usuário",
    emailLabel: "E-mail",
    emailLockedHint: "Conta já usada: só o Super Admin altera o e-mail.",
    errorTitle: "Erro",
    fullAccessAllCompanies: "Acesso total (todas as empresas)",
    impersonateBtn: "Entrar como",
    impersonateBtnTitle:
      "Abrir o app exatamente como este usuário vê (registrado na auditoria; sua sessão de admin será substituída)",
    impersonateConfirmMsg:
      'Sua sessão de admin neste navegador será substituída pela deste usuário (máx. 2h). Para voltar, use o botão "Encerrar visão" no banner laranja e faça login de novo. Tudo fica registrado na auditoria. Continuar?',
    introPre: "Acesso definido ",
    introStrong: "por empresa",
    introSuf:
      ". Super admin acessa tudo. O Administrador gere as contas das empresas que administra, menos as de Administrador.",
    inviteByEmail: "Convidar por e-mail",
    levelAdminDesc: "— gestão completa da empresa (inclui usuários e regras).",
    levelSuperAdminDesc:
      "— global: acesso irrestrito a todas as empresas, inclui o módulo Financeiro.",
    levelUserDesc: "— operacional: cria/edita/importa; não gerencia usuários.",
    levelViewerDesc: "— somente leitura: filtra e vê, não modifica.",
    levelsTitle: "Níveis (por empresa):",
    linkCopyHint: "Se o e-mail não chegar, copie o link e mande por WhatsApp:",
    linkHiddenNote: "Por segurança, o link de uma conta já usada só vai por e-mail.",
    linkMissingData: "Preencha o nome e o e-mail.",
    linkResentTitle: "Link enviado",
    linkResultFailed: "O e-mail não saiu. Copie o link abaixo e mande por outro meio (WhatsApp).",
    linkResultSent: "E-mail com o link enviado para",
    linkSentTitle: "Conta criada",
    loading: "Carregando…",
    localeLabel: "Idioma do e-mail",
    menuAgenda: "Agenda",
    menuChantiers: "Chantiers",
    menuClientes: "Clientes",
    menuDevis: "Devis",
    menuDossiers: "Dossiers",
    menuFaturas: "Faturas",
    menuLevelOperate: "operar",
    menuLevelView: "ver",
    menuPainel: "Painel",
    menuTecnicos: "Técnicos",
    menuVeiculos: "Veículos",
    menusBtn: "Acesso a menus",
    menusHint:
      "Só para papéis de portal (gerente, técnico, cliente). Os dados ficam restritos aos chantiers que a pessoa gerencia.",
    menusNone: "nenhum",
    menusSave: "Salvar menus",
    menusSaved: "Menus salvos.",
    menusTitle: "Menus do Gestion liberados",
    missingDataMessage: "Preencha nome, e-mail e uma senha de pelo menos 8 caracteres.",
    missingDataTitle: "Faltam dados",
    nameLabel: "Nome",
    needOneAccess: "Escolha o acesso em pelo menos uma empresa.",
    newUserBtn: "+ Novo usuário",
    noAccess: "Sem acesso",
    pageTitle: "Usuários",
    passwordLabel: "Senha (mín. 8)",
    reactivateAccount: "Reativar conta",
    resetPwBtn: "Redefinir senha",
    resetPwBtnTitle: "Definir uma senha nova para esta conta (a antiga deixa de valer)",
    resetPwDonePre: "Senha nova definida para",
    resetPwDoneSuf: "Informe ao usuário — a senha antiga deixou de valer.",
    resetPwDoneTitle: "Senha redefinida",
    resetPwPlaceholder: "Mínimo 8 caracteres — anote para informar ao usuário",
    resetPwTitle: "Nova senha",
    resetPwTooShort: "A senha precisa ter pelo menos 8 caracteres.",
    roleAdmin: "Administrador",
    roleClient: "Cliente (portal)",
    roleManager: "Gerente de projeto (chantier)",
    roleTechnician: "Técnico (portal)",
    roleTechnicianMontador: "Montador (portal)",
    roleTechnicianPdr: "Técnico PDR (portal)",
    roleUser: "Usuário",
    roleViewer: "Visualizador",
    sendLinkBtn: "Enviar",
    sendLinkConfirmPre: "Enviar a",
    sendLinkConfirmSuf: "um e-mail com o link para definir a senha?",
    sendLinkTitle: "Enviar link para definir a senha",
    statusActive: "Ativo",
    statusInactive: "Inativo",
    superAdmin: "Super admin",
    superAdminCheckbox: "Super admin (acesso irrestrito a todas as empresas)",
    technicianCreatedMsg:
      "o cadastro foi criado nesta empresa a partir da fiche que ele já tinha. Falta só configurar os pares técnico×cliente ou chantier em Técnicos → modificar.",
    technicianCreatedTitle: "Cadastro de técnico criado",
    technicianMissingMsg:
      "O acesso foi concedido, mas a função (PDR ou montador) só é gravada no cadastro do técnico desta empresa. Crie o técnico em Técnicos, vincule esta conta e escolha a função de novo.",
    technicianMissingTitle: "Sem cadastro de técnico",
    userCreatedSuffix: "criado.",
    userCreatedTitle: "Usuário criado",
    youTag: "(você)",
  },
  vehicles: {
    badgeActive: "ativo",
    badgeInactive: "inativo",
    cancel: "Cancelar",
    catalogBadge: "catálogo",
    catalogLinkedTitle: "Vinculado ao catálogo",
    chipCadastro: "Cadastro",
    chipDevis: "Devis",
    chipEmReparacao: "Em reparação",
    chipFaturado: "Faturado",
    chipPago: "Recebido",
    chipRecebidoPago: "Recebido · pago",
    chipRecebidoPendente: "Recebido · repassar",
    chipReparado: "Reparado",
    colActions: "Ações",
    colColor: "Cor",
    colCustomer: "Cliente",
    colMakeModel: "Marca / modelo",
    colPlate: "Placa",
    colStatus: "Status",
    colYear: "Ano",
    companyLabel: "Empresa",
    create: "Criar",
    customerOptionalLabel: "Cliente (opcional)",
    customerSearchPlaceholder: "Digite ao menos 2 letras para buscar",
    deactivate: "Desativar",
    deactivateMessage:
      "Veículo inativo não aparece em novos dossiers. Dossiers existentes não são afetados.",
    deactivatePlaceholder: "Ex: veículo sucateado",
    deactivateTitle: "Desativar veículo",
    dossiersWord: "dossiers",
    editLink: "editar",
    editTitle: "Editar veículo",
    emptyState: "Nenhum veículo encontrado.",
    errInvalidYear: "Ano inválido.",
    errPlateOrVin: "Informe pelo menos a placa ou o VIN.",
    filterActive: "Ativos",
    filterAll: "Todos",
    filterInactive: "Inativos",
    generationLabel: "geração",
    hintChooseMakeFirst: "Escolha a marca primeiro",
    hintMakeFreeText: "Marca em texto livre — modelo será texto livre",
    historyCurrent: "este dossier",
    historyDevis: "Devis",
    historyDevisPdf: "PDF do devis",
    historyDossierWord: "Dossier",
    historyDossiersWord: "dossiers",
    historyHint: "Cada dossier é um serviço do veículo; o mais recente fica no topo.",
    historyOpen: "Abrir",
    historyTitle: "Ficha do veículo",
    loading: "Carregando…",
    makeLabel: "Marca",
    makePlaceholder: "Ex: Peugeot, Renault…",
    menuTitle: "Dossiers do veículo",
    modelFreePlaceholder: "Modelo (texto livre)",
    modelLabel: "Modelo",
    modelPlaceholder: "Ex: 308, Clio…",
    newBtn: "Novo veículo",
    next: "Próxima",
    noCompanyAccess: "Você não tem acesso a nenhuma empresa.",
    noCustomer: "sem cliente",
    noCustomerFound: "Nenhum cliente encontrado.",
    noDossiers: "Sem dossiers ainda",
    noMakeInCatalog: "Nenhuma marca no catálogo. O texto digitado será salvo como livre.",
    noModelInCatalog:
      "Nenhum modelo no catálogo para esta marca. O texto digitado será salvo como livre.",
    notesLabel: "Notas",
    ofLabel: "de",
    pageLabel: "Página",
    prev: "Anterior",
    reactivate: "Reativar",
    remove: "remover",
    requestProforma: "Solicitar proforma (adiantar ao técnico)",
    save: "Salvar",
    saving: "Salvando…",
    searchLabel: "Buscar",
    searchPlaceholder: "Placa, chassi, marca, modelo…",
    searching: "Buscando…",
    statusLabel: "Status",
    vehiclePlural: "veículos",
    vehicleSingular: "veículo",
    vinLabel: "VIN (chassi)",
  },
  worklog: {
    carWordSingular: "carro",
    carsWord: "carros",
    clientSectionTitle: "Worklogs dos técnicos",
    emailBtn: "Enviar ao cliente",
    emailSentPre: "Worklog enviado para",
    emptyWeek: "Sem produção nesta semana.",
    exportHint:
      "Produção da semana por cliente — sem comissões. Baixe o PDF ou envie direto para o e-mail do cliente.",
    exportTitle: "Worklog semanal (documento do cliente)",
    generatingBtn: "Gerando…",
    interventionsWord: "intervenções",
    pdfBtn: "Baixar PDF",
    weekPre: "Semana",
  },
} as const;

export type PagesMessages = {
  [N in keyof typeof ptPages]: { [K in keyof (typeof ptPages)[N]]: string };
};

export const frPages: PagesMessages = {
  about: {
    buildLabel: "Build",
    productLabel: "Produit",
    tagline: "Système de gestion interne du groupe Euro Storm.",
    title: "À propos",
    versionLabel: "Version",
  },
  account: {
    changePassword: "Changer le mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    currentPassword: "Mot de passe actuel",
    emailHint:
      "Votre email sert à vous connecter et à récupérer le mot de passe. Pour le changer, contactez le bureau.",
    emailLabel: "Email",
    errorMinLength: "Le nouveau mot de passe doit contenir au moins 8 caractères.",
    errorMismatch: "La confirmation ne correspond pas au nouveau mot de passe.",
    errorSameAsCurrent: "Le nouveau mot de passe doit être différent de l'actuel.",
    minHint: "Minimum 8 caractères.",
    newPassword: "Nouveau mot de passe",
    pageSubtitle: "Vos données d'accès et gestion du mot de passe.",
    saving: "Enregistrement…",
    successChanged: "Mot de passe modifié avec succès.",
    title: "Mon compte",
    userLabel: "Utilisateur",
  },
  agendaPage: {
    cancelRdvBtn: "Annuler le RDV",
    chantierAutoHint: "Un client rattaché à un chantier hérite du chantier automatiquement.",
    chantierLabel: "Chantier",
    closeBtn: "Fermer",
    customerLabel: "Client",
    dateLabel: "Date",
    emptyDay: "Aucun RDV",
    filterAllLabel: "Tous les chantiers et clients",
    filterNoChantier: "Clients sans chantier",
    kpiToday: "aujourd'hui",
    kpiWeek: "sur la semaine",
    modalEditTitle: "Modifier le RDV",
    modalNewTitle: "Nouveau RDV",
    newRdvBtn: "Nouveau RDV",
    nextRdvLabel: "Prochains RDV",
    noRdvWeek: "Aucun RDV cette semaine.",
    noneOption: "— aucun —",
    notesLabel: "Notes",
    openAgenda: "Ouvrir l'agenda",
    plateLabel: "Immatriculation",
    saveBtn: "Enregistrer",
    savingBtn: "Enregistrement…",
    statusArrived: "Arrivé",
    statusDone: "Terminé",
    statusEmReparacao: "En réparation",
    statusFaturado: "Facturé",
    statusHint: "Cliquez sur le statut pour avancer (Prévu → Arrivé → Terminé).",
    statusOrcamento: "Devis",
    statusPago: "Payé",
    statusRecebido: "Encaissé",
    statusReparado: "Réparé",
    statusScheduled: "Prévu",
    subtitle: "RDV des chantiers et des clients — semaine par semaine",
    timeLabel: "Heure",
    title: "Agenda",
    todayBtn: "Aujourd'hui",
    vehicleLabel: "Véhicule (marque/modèle)",
    weekPre: "Semaine",
    weekTotalTitle: "Total à facturer sur la semaine (HT)",
  },
  audit: {
    actionPlaceholder: "action (ex : login)",
    asUserPre: "en tant que",
    colAction: "Action",
    colChanges: "Modifications",
    colEntity: "Entité",
    colWhen: "Quand",
    colWho: "Qui",
    companyLabel: "Société :",
    emptyState: "Aucun événement trouvé.",
    entityKindPlaceholder: "type d'entité (ex : customer)",
    filterAction: "Action",
    filterCompany: "Société",
    filterEntity: "Entité",
    loading: "Chargement…",
    nextBtn: "Suivant →",
    notAdmin: "Vous n'êtes administrateur d'aucune société.",
    of: "sur",
    page: "Page",
    prevBtn: "← Précédent",
    title: "Journal d'audit",
  },
  bankAccounts: {
    accountPlural: "comptes",
    accountSingular: "compte",
    adminCreatesZeroBalance:
      "Un admin standard crée le compte avec un solde de 0 (ajustement ultérieur via un super admin).",
    badgeActive: "active",
    badgeInactive: "inactive",
    bankLabel: "Banque",
    cancelBtn: "Annuler",
    colActions: "Actions",
    colCurrency: "Devise",
    colOpening: "Ouverture",
    colWise: "Wise",
    companyLabel: "Société",
    createBtn: "Créer",
    currencyIsoLabel: "Devise (ISO 4217)",
    deactivateAccountPre: "Désactiver le compte",
    deactivateBtn: "Désactiver",
    deactivateMessage:
      "Un compte inactif ne reçoit plus de nouveaux imports/synchronisations. Les transactions et rapprochements existants ne sont pas affectés.",
    deactivateReasonPlaceholder: "Ex : compte clôturé à la banque",
    defaultInvoicesBadge: "par défaut sur les factures",
    editBtn: "modifier",
    emptyState: "Aucun compte trouvé.",
    filterActive: "Actives",
    filterAll: "Toutes",
    filterInactive: "Inactives",
    ibanChangeReasonLabel: "Motif de la modification de l'IBAN",
    ibanPlaceholder: "FR76 ... (sans espaces)",
    invalidOpeningBalance: "Solde initial invalide.",
    labelField: "Libellé",
    labelPlaceholder: "Ex : SocGen ES — compte courant principal",
    loading: "Chargement…",
    makeDefaultInvoicesBtn: "Utiliser par défaut sur les factures",
    makeDefaultInvoicesShort: "Définir par défaut",
    modalTitleCreate: "Nouveau compte bancaire",
    modalTitleEdit: "Modifier le compte bancaire",
    newBtn: "+ Nouveau compte",
    nextBtn: "Suivante →",
    noCompanyAccess: "Vous n'avez accès à aucune société.",
    notesLabel: "Notes",
    ofWord: "sur",
    onlySuperAdminEditsOpening:
      "Seuls les super administrateurs peuvent modifier le solde initial.",
    onlySuperAdminOpening:
      "Seuls les super administrateurs peuvent modifier le solde initial ou la date d'ouverture.",
    openingBalanceLabel: "Solde initial",
    openingChangeReasonLabel: "Motif de la modification du solde/de la date d'ouverture",
    openingDateLabel: "Date d'ouverture",
    openingNonZeroReasonLabel: "Motif du solde initial != 0",
    openingReasonRequired:
      "Justification obligatoire pour modifier le solde initial / la date d'ouverture.",
    pageWord: "Page",
    prevBtn: "← Précédent",
    providerLabel: "Prestataire (définit l'importation)",
    providerOther: "Autre — sans importation automatique",
    providerSg: "Société Générale — import CSV",
    providerWise: "Wise — synchronisation API",
    reactivateBtn: "Réactiver",
    saveBtn: "Enregistrer",
    saving: "Enregistrement…",
    searchLabel: "Rechercher",
    searchPlaceholder: "Libellé, IBAN, banque…",
    statusLabel: "Statut",
    wiseAutoNote:
      "Une fois lié, le compte se synchronise seul chaque matin (à partir de 6 h, heure de Paris). Vous pouvez aussi cliquer sur Synchroniser maintenant.",
    wiseBalancePre: "solde",
    wiseConnectBtn: "Lier à Wise",
    wiseCopied: "copiée",
    wiseCopyBtn: "Copier la clé",
    wiseDisconnectBtn: "Délier",
    wiseDisconnectMsg:
      "Le jeton et la clé de signature sont supprimés. Les transactions déjà importées restent.",
    wiseDisconnectTitle: "Délier Wise de ce compte",
    wiseDoneBtn: "Terminer",
    wiseDownloadKeyBtn: "Télécharger la clé (.pem)",
    wiseFetchProfilesBtn: "Rechercher les profils",
    wiseKeyHint:
      "Wise exige une signature (SCA) pour fournir le relevé. Copiez la clé ci-dessous et enregistrez-la sur le site Wise : Paramètres → Clés API → Gérer les clés publiques → Ajouter. Puis cliquez sur Tester.",
    wiseKeyReused:
      "La clé précédente a été conservée : si elle est déjà enregistrée dans Wise, inutile de la réenregistrer.",
    wiseLastSyncPre: "dernière synchro",
    wiseLinkBtn: "Lier ce compte",
    wiseLinked: "lié",
    wiseLinkedTo: "Compte lié au profil",
    wiseModalTitle: "Lier à Wise",
    wiseNeverSynced: "jamais synchronisé",
    wiseNewTokenBtn: "Changer le jeton",
    wiseNoKey: "sans clé SCA",
    wiseNoProfiles: "Ce jeton ne donne accès à aucun profil.",
    wiseNotLinked: "non lié",
    wiseReconfigureBtn: "Reconfigurer",
    wiseStep1: "1 · Collez le jeton d'API Wise",
    wiseStep2: "2 · Choisissez le profil (la société)",
    wiseStep3: "3 · Enregistrez la clé publique dans Wise",
    wiseSyncDonePre: "Synchronisé :",
    wiseSyncDupSuf: "déjà présente(s)",
    wiseSyncNewSuf: "nouvelle(s)",
    wiseSyncNowBtn: "Synchroniser maintenant",
    wiseTestBtn: "Tester",
    wiseTestCountSuf: "mouvement(s) sur les 7 derniers jours",
    wiseTestOkPre: "Connexion OK :",
    wiseTestSca: "signature SCA acceptée",
    wiseTokenHint:
      "Créez le jeton sur le site Wise (pas dans l'application) : Paramètres → Clés API → Ajouter. Permission : lecture seule. Wise n'affiche le jeton qu'une fois : collez-le ici immédiatement. Il est chiffré dans Gestion et jamais réaffiché.",
    wiseTokenLabel: "Jeton d'API",
  },
  bankCategories: {
    appliedEligibleSuf: "éligibles",
    appliedNoMatchSuf: "sans correspondance",
    appliedPre: "Appliqué",
    appliedRulesSuf: "règles",
    appliedUnchangedSuf: "inchangées",
    appliedUpdatedSuf: "mises à jour",
    applyAllBtn: "↻ Tout appliquer",
    applyAllConfirmMessage:
      "Traite toutes les transactions éligibles avec les règles actives. Les transactions déjà catégorisées comme 'manual' sont préservées.",
    applyAllConfirmTitle: "Appliquer toutes les règles actives ?",
    applyAllLabel: "Tout appliquer",
    applyingBtn: "Application…",
    cancelBtn: "Annuler",
    categoryBankFee: "Frais bancaires",
    categoryInsurance: "Assurances",
    categoryIntermediaryFees: "Honoraires / intermédiaires",
    categoryOther: "Autres",
    categoryPartnerContribution: "Apport (associé)",
    categoryPartnerReimbursement: "Remboursement (associé)",
    categoryPersonal: "Personnel (associé)",
    categoryRent: "Loyer / location",
    categoryRevenue: "Recettes",
    categorySalary: "Salaire",
    categorySupplierPayment: "Fournisseur",
    categorySupplies: "Fournitures / consommables",
    categoryTax: "Impôt",
    categoryTransfer: "Virement",
    categoryTravel: "Déplacements / réception",
    categoryVatPayment: "TVA à l'État (reversement)",
    colActions: "Actions",
    colActive: "Active",
    colCategory: "Catégorie",
    colField: "Champ",
    colPriority: "Pri",
    colType: "Type",
    colValue: "Valeur",
    createBtn: "Créer",
    deactivateBtn: "désactiver",
    deactivateLabel: "Désactiver",
    deactivateReasonPlaceholder: "Ex : règle obsolète",
    deactivateRuleMessage:
      "La règle cesse d'être appliquée aux nouvelles catégorisations automatiques (les transactions déjà catégorisées conservent leur état).",
    deactivateRulePre: "Désactiver la règle",
    editBtn: "modifier",
    emptyState: "Aucune règle enregistrée.",
    errorTitle: "Erreur",
    filterActive: "Actives",
    filterAll: "Toutes",
    filterInactive: "Inactives",
    labelAmountMax: "Montant max",
    labelAmountMin: "Montant min",
    labelCategoryResult: "Catégorie (résultat)",
    labelMatchField: "Champ de correspondance",
    labelMatchType: "Type de correspondance",
    labelMatchValue: "Valeur de correspondance",
    labelNotes: "Notes",
    labelPriority: "Priorité",
    loading: "Chargement…",
    matchFieldAmount: "amount (numérique)",
    matchFieldBoth: "both (description + raw)",
    matchFieldDescription: "description (normalisée)",
    matchFieldRawDescription: "raw_description (original)",
    modalCreateTitle: "Nouvelle règle de catégorisation",
    modalEditTitle: "Modifier la règle",
    name: "Nom",
    newRuleBtn: "+ Nouvelle règle",
    noCompanyAccess: "Aucun accès aux sociétés.",
    placeholderContainsExample: "Ex : COMMISSION",
    placeholderRegexExample: "Ex : (CLIENT|RENAULT|RÈGLEMENT)",
    rulesCountSuf: "règle(s)",
    rulesOrderHint: "Triées par priorité DESC. La première règle qui correspond l'emporte.",
    saveBtn: "Enregistrer",
    savingBtn: "Enregistrement…",
    subtitle: "Règles de catégorisation automatique",
    subtitleCategories: "Catégories",
    testEligibleSuf: "transactions éligibles.",
    testMatchPre: "Correspondance sur",
    testRuleBtn: "↻ Tester la règle",
    testRunsTitle: "Teste sur toutes les transactions éligibles",
    testSampleNone: "(aucune)",
    testSamplePre: "Échantillon",
    testSaveFirstError:
      "Enregistrez d'abord la règle — le test s'exécute sur une règle déjà enregistrée en base.",
    testSaveFirstTitle: "Enregistrez d'abord la règle pour pouvoir la tester",
    testingBtn: "Test en cours…",
  },
  bankImport: {
    accountConfiguredPre: "Compte",
    accountConfiguredSuf: "configuré — identifiants chiffrés",
    accountProvider: "Fournisseur du compte",
    chooseAccountFirst:
      "Choisissez d'abord le compte du relevé, dans le sélecteur ci-dessus. Gestion ne le choisit pas pour vous.",
    closeBtn: "Fermer",
    colAccount: "Compte",
    colDate: "Date",
    colDuplicated: "Doubl.",
    colFailed: "Échecs",
    colFile: "Fichier",
    colImported: "Importées",
    colMethod: "Méthode",
    colStatus: "Statut",
    colTotal: "Total",
    duplicatedWord: "doublons",
    emptyBatches: "Aucune importation effectuée.",
    emptyFile: "Fichier vide.",
    failedWord: "échecs",
    fileReadError: "Échec de la lecture du fichier.",
    genericUploadHint:
      "Téléversement d'un CSV (ex. : relevé Wise). Détecte automatiquement le séparateur, les colonnes (Date, Valeur/Montant ou Débit/Crédit, Description) et le format des nombres/dates.",
    idempotentNote:
      "Analyseur idempotent — la réimportation du même fichier ne duplique pas les transactions.",
    importAnywayBtn: "Importer quand même",
    importCsv: "Importer un CSV",
    importCsvOrPdf: "Importer un relevé (CSV ou PDF)",
    importHistory: "Historique des importations",
    importOk: "Importation réussie",
    importStatements: "Importer des relevés",
    importSubtitle: "Importer",
    importedWord: "importées",
    noCompanyAccess: "Aucun accès aux sociétés.",
    previewAlready: "Déjà sur ce compte",
    previewAlreadySuf: "(comptés comme doublons, pas de doublon créé)",
    previewBalance: "Solde final du fichier",
    previewBank: "Banque du fichier",
    previewBankUnknown: "non reconnue",
    previewCancel: "Annuler",
    previewFile: "Fichier",
    previewGoesTo: "Va sur le compte",
    previewImportAnyway: "Importer quand même sur le compte",
    previewImportTo: "Importer sur le compte",
    previewMovements: "Mouvements",
    previewOtherHint: "Le fichier semble être celui de ce compte : vérifiez le compte choisi.",
    previewOtherMid: "des",
    previewOtherSuf: "mouvements sont déjà sur le compte",
    previewTitle: "Vérifiez avant d'importer",
    processing: "Traitement en cours…",
    readOnlyNotice:
      "Lecture seule — l'importation est disponible uniquement pour les utilisateurs disposant du droit de modification.",
    selectAccount: "— Choisissez le compte —",
    selectAccountAbove: "Sélectionnez un compte ci-dessus",
    sgUploadHint:
      "CSV exporté de la Société Générale ou le relevé mensuel en PDF (le « RELEVÉ DE COMPTE »). Un même mouvement venu par le CSV et par le PDF n'est pas dupliqué.",
    showEmptyFailed: "Afficher les tentatives vides du robot",
    statusCompleted: "Terminée",
    statusFailed: "Échouée",
    statusPending: "En attente",
    statusProcessing: "En cours",
    statusUndone: "Annulé",
    syncWiseBtn: "Synchroniser Wise",
    syncWiseOk: "Synchronisation Wise réussie",
    syncing: "Synchronisation…",
    totalWord: "au total",
    undoAlready: "Cet import a déjà été annulé.",
    undoBlockAttachment: "avec pièce jointe",
    undoBlockClosedYear: "dans un exercice clôturé",
    undoBlockLinked: "lié(s) à un encaissement, un paiement ou un autre enregistrement",
    undoBlockReconciled: "rapproché(s) — défaites le rapprochement d'abord",
    undoBlockedTitle: "Annulation impossible : certains mouvements ont déjà été utilisés.",
    undoBtn: "Annuler",
    undoConfirmBtn: "Annuler l'import",
    undoExplain:
      "Les mouvements enregistrés par cet import seront supprimés. L'import reste dans l'historique comme « Annulé », avec le motif, et entre dans l'audit. Ensuite, importez le fichier sur le bon compte.",
    undoMovements: "mouvement(s)",
    undoReasonLabel: "Motif (obligatoire)",
    undoReasonPlaceholder: "Ex. : relevé Wise importé sur le compte Wamo",
    undoTitle: "Annuler l'import",
    wiseOnlyHint: "Disponible uniquement pour les comptes avec fournisseur='wise'",
    wiseSyncTitle: "Synchronisation Wise API",
    wrongAccountHint: "Si le fichier est bien de ce compte, cliquez sur « Importer quand même ».",
    wrongAccountTitle: "Bon compte ?",
  },
  bankPartner: {
    accountCardSubtitle: "Solde courant dérivé des transactions + ouverture",
    accountCardTitle: "Compte courant d'associé",
    allMovementsCounted: "Tous les mouvements catégorisés sont comptés.",
    balanceZero: "Compte à zéro.",
    calcMovements: "mouvements",
    calcOpeningPre: "Calcul : ouverture",
    cancel: "Annuler",
    cancelBtnLower: "annuler",
    companyLabel: "Société",
    companyOwesPartner: "La société doit ce montant à l'associé.",
    contributions: "Apports",
    currentBalance: "Solde courant",
    editBtn: "modifier",
    emptyOpenings:
      "Aucune ouverture enregistrée. Le solde ci-dessus considère une ouverture = 0 et additionne les mouvements catégorisés.",
    error: "Erreur",
    loading: "Chargement…",
    missingDataTitle: "Données manquantes",
    missingPartnerName: "Veuillez saisir le nom de l'associé.",
    movementsFromPre: "Mouvements comptés à partir du",
    movementsFromSuf: "(après la date d'ouverture).",
    movementsSourceNote:
      "Les mouvements proviennent des transactions marquées comme Apport, Remboursement ou Personnel sur la page Relevés.",
    multiPartnerWarning:
      "Plusieurs associés sont enregistrés — les mouvements sont au niveau de la société et ne sont pas répartis par associé.",
    nameLabel: "Nom",
    newPartnerBtn: "+ Nouvel associé",
    noCompanyAccess: "Vous n'avez accès à aucune société.",
    opening: "Ouverture",
    openingBalanceLabel: "Solde d'ouverture (€)",
    openingDateLabel: "Date d'ouverture",
    openingEuroLabel: "Ouverture (€)",
    openingsCardTitle: "Ouvertures par associé",
    partnerNameLabel: "Nom de l'associé",
    partnerNamePlaceholder: "Ex. : Landione Souza",
    partnerOwesCompany: "L'associé doit ce montant à la société.",
    personalExpenses: "Dépenses personnelles",
    reimbursements: "Remboursements",
    remove: "Supprimer",
    removeBtn: "supprimer",
    removeConfirmPre: "Supprimer l'ouverture de",
    removeConfirmSuf: "Les transactions ne sont pas affectées.",
    removePartnerTitle: "Supprimer l'associé",
    save: "Enregistrer",
    saveBtnLower: "enregistrer",
    saving: "Enregistrement…",
    subtitle: "Associé",
  },
  bankReconciliation: {
    acceptBtn: "accepter",
    acceptCreatesReceiptTitle:
      "Accepter crée le reçu (source=bank_reconciliation) et marque la facture/le dossier comme payé",
    colActions: "Actions",
    colAmount: "Montant",
    colBankTransaction: "Transaction bancaire",
    colConfidence: "Confiance",
    colReason: "Motif",
    colStatus: "Statut",
    colSuggestion: "Suggestion",
    colTargetId: "ID cible",
    emptyState:
      "Aucune suggestion avec ces filtres. Cliquez sur « ↻ Générer les suggestions » pour lancer le moteur.",
    error: "Erreur",
    filterCompany: "Société",
    filterStatus: "Statut",
    generateBtn: "Générer les suggestions",
    generating: "Génération…",
    highConfidence: "confiance élevée",
    kindCustomerInvoice: "Facture ouverte → crée le reçu",
    kindCustomerReceipt: "Encaissement client",
    kindIntercompany: "Intercompany",
    kindOther: "Autres",
    kindTaxPayment: "Paiement d'impôt",
    kindTechnicianPayment: "Paiement technicien",
    loading: "Chargement…",
    minConfidenceLabel: "Confiance minimale",
    nextBtn: "Suivante",
    noCompanyAccess: "Aucun accès aux sociétés.",
    pageLabel: "Page",
    pageOf: "sur",
    prevBtn: "Précédent",
    reconciliationSubtitle: "Rapprochement",
    rejectBtn: "rejeter",
    rejectConfirm: "Rejeter",
    rejectMessage:
      "La suggestion sera bloquée — le moteur ne générera pas de nouvelle suggestion pour cette transaction tant qu'un admin n'aura pas effectué un unreject.",
    rejectPlaceholder: "Ex : cible erronée, montant qui ne correspond pas",
    rejectTitle: "Rejeter la suggestion",
    scanBlockedAccepted: "bloquées (accepted)",
    scanBlockedRejected: "bloquées (rejected)",
    scanCreated: "créées",
    scanLabel: "Scan",
    scanNoCandidate: "sans candidat",
    scanTx: "tx",
    scanUpdated: "mises à jour",
    statusAccepted: "Acceptée",
    statusAll: "Toutes",
    statusPending: "En attente",
    statusRejected: "Rejetée",
    suggestionsCount: "suggestion(s)",
    suggestionsSubtitle: "Suggestions de rapprochement",
    unrejectBtn: "unreject",
    unrejectConfirm: "Unreject",
    unrejectMessage:
      "Admin uniquement. Le statut repasse à 'pending' — le moteur peut régénérer des suggestions pour cette tx.",
    unrejectPlaceholder: "Ex : révision terminée, cible correcte identifiée",
    unrejectTitle: "Rouvrir la suggestion (unreject)",
  },
  bankShell: {
    moduleLabel: "Module banque",
    navCategories: "Catégories",
    navImport: "Importer",
    navPartner: "Associé",
    navReconciliation: "Rapprochement",
    navStatements: "Relevés",
  },
  bankStatements: {
    accountantLinkNote: "C'est le document que le relevé du comptable lie sur cette ligne.",
    additionalDetailsPlaceholder: "Détails supplémentaires",
    advAddRow: "autre technicien",
    advDescHint: "Description (facultatif ; par défaut = libellé du relevé)",
    advFillAll: "montant entier",
    advNoRows: "Indiquez au moins un technicien avec un montant.",
    advPickTech: "Technicien…",
    advRemoveRow: "Retirer",
    advRestNotAdvance: "reste hors avance :",
    advSumExceeds: "la somme dépasse le montant de la sortie",
    advSummaryTag: "avance à un technicien",
    advToggle: "C'est une avance à un technicien",
    advToggleHint:
      "Hôtel, outils, etc. payés par la société pour un ou plusieurs techniciens : chaque part devient une avance, déduite de sa prochaine facture.",
    allAccounts: "Tous les comptes",
    allCategories: "Toutes les catégories",
    allCredits: "➕ Entrées (toutes)",
    allCustomers: "Tous les clients",
    allDebits: "➖ Sorties (toutes)",
    allStatuses: "Tous les statuts",
    alreadyReceivedPre: "déjà encaissé",
    amountHtPlaceholder: "Montant HT",
    attachBtnTitle: "Joindre / voir les justificatifs (transaction et factures de l'écriture)",
    attachEdspPdfs: "Joindre les PDF des factures eDSP (correspondance par n°)",
    attachFiles: "Joindre le(s) fichier(s)",
    attachHelp:
      "Joignez le justificatif (PDF, image) de tout rapprochement — facture, reçu, avis d'impôt, preuve de paiement. Il devient le lien cliquable de cette ligne dans le PDF du relevé envoyé au comptable.",
    attachInvoicePdf: "Joindre le PDF de la facture",
    attachMonthBtn: "Joindre les factures du mois",
    attachMonthBtnTitle:
      "Joindre en masse les PDF des factures émises sur la période (correspondance par n°)",
    attachOriginalLabel: "Joignez le relevé original de la banque (PDF et/ou CSV)",
    attachOriginalMessage:
      "Vous n'avez pas joint le relevé original de la banque (PDF/CSV). Il doit accompagner le relevé rapproché. Envoyer quand même ?",
    attachOriginalTitle: "Joindre le relevé original ?",
    attachPdfsFolder: "Joindre des PDF (sélectionnez le dossier ou plusieurs fichiers)",
    autoRecognizeBtn: "Reconnaître les en-attente",
    autoRecognizeDoneMid: "sur",
    autoRecognizeDoneSuf:
      "en attente catégorisées automatiquement (confiance 'auto' — révisables via le sélecteur de chaque ligne).",
    autoRecognizeTitle:
      "Catégorise automatiquement les transactions sans catégorie : lien du rapprochement, fiches (client/fournisseur/associé/groupe) et motifs déjà utilisés ≥3× toujours avec la même catégorie. Ne modifie jamais une catégorisation manuelle ; tout reste modifiable.",
    autoRecognizing: "Reconnaissance…",
    avoirNumberMissing: "Impossible de proposer le numéro de l'avoir. Réessayez.",
    avoirOption: "La différence est un avoir",
    avoirOptionHint: "crée l'avoir sur cette facture et la marque payée :",
    avoirReasonDefault: "Avoir déduit par le client sur le virement du",
    avoirReasonLabel: "Motif de l'avoir",
    avoirTypeLabel: "Type d'avoir",
    avoirWord: "avoir",
    backBtn: "Retour",
    badgeIgnored: "ignorée",
    badgePending: "en attente",
    badgeReconciled: "Rapprochée",
    bankTransaction: "Transaction bancaire",
    cancel: "Annuler",
    cannotBeUndone: "Cette action est irréversible.",
    catBankFee: "Frais bancaires",
    catBankFeeShort: "Frais banc.",
    catFees: "Honoraires",
    catInsurance: "Assurances",
    catOther: "Autres",
    catPartnerContribution: "Apport (associé)",
    catPartnerReimbursement: "Remboursement (associé)",
    catPendingChip: "À catégoriser",
    catPersonal: "Personnel (associé)",
    catRent: "Loyer / location",
    catRevenue: "Recette",
    catSalary: "Salaire",
    catSupplier: "Fournisseur",
    catSupplies: "Fournitures",
    catTax: "Impôt",
    catTransfer: "Virement",
    catTravel: "Déplacements",
    catVatPayment: "TVA à l'État",
    categorizeBtn: "catégoriser",
    categorizeHelpPre: "Cliquez sur une catégorie pour l'appliquer. Le choix devient",
    categorizeHelpSuf: "— bloque les futures re-catégorisations automatiques par les règles.",
    categorizeTitle: "Catégoriser la transaction",
    changePdf: "Changer le PDF",
    chooseIndividualFiles: "ou choisir des fichiers isolés",
    clearCategory: "Effacer la catégorie",
    clearSelection: "Effacer",
    clickToChooseOr: "Cliquez pour choisir (plusieurs : Ctrl+A) ou",
    close: "Fermer",
    colAccount: "Compte",
    colActions: "Actions",
    colAmount: "Montant",
    colCategory: "Catégorie",
    colDate: "Date",
    colDescription: "Description",
    colEffectiveDate: "Date effective",
    colStatus: "Statut",
    colTarget: "Cible",
    confirm: "Confirmer",
    confirming: "Confirmation…",
    continueBtn: "Continuer",
    current: "actuel",
    currentCategoryLabel: "Catégorie actuelle",
    depositHigherMsg:
      "Si le dépôt paie plusieurs factures, utilisez « Plusieurs factures / encaissements ». Lier ici ne marque payée que cette facture.",
    depositHigherTitle: "Le dépôt est supérieur à la facture",
    depositLabel: "Dépôt",
    depositLowerMsg:
      "Paiement partiel : enregistre ce qui est arrivé et la facture reste ouverte pour le reste. Autres options : la marquer payée quand même.",
    depositLowerTitle: "Le dépôt est inférieur à la facture",
    descriptionLabel: "Description",
    diffWord: "différence",
    directBankFee: "Frais bancaires",
    directBankFeeHint: "Commission, tarif, cotisation annuelle",
    directCategoryLabel: "Catégorie",
    directComplementHint: "N° de facture, nom… sort tel quel, sans traduction.",
    directComplementLabel: "Complément / référence",
    directComplementRequired: "Décrivez le motif dans le complément (obligatoire pour « Autre »).",
    directConfirmQuestion: "aucun document lié — marquer comme rapprochée directement ?",
    directDescriptionPlaceholder: "Décrivez le motif du rapprochement direct",
    directNote:
      "La transaction est enregistrée avec la catégorie et la description ci-dessous dans le journal d'audit. Aucune entité comptable (factures, paiements) n'est mise à jour.",
    directOther: "Autre",
    directOtherHint: "Décrire le motif (obligatoire)",
    directPartnerReimbursement: "Remboursement associé",
    directPartnerReimbursementHint: "Avance, remboursement de dépense personnelle",
    directPriorYear: "Règlement 2025",
    directPriorYearHint:
      "Règle une dette de l'exercice précédent (commission / fournisseur / TVA 2025) — sans impact sur le résultat 2026",
    directReasonHint: "Le motif sort traduit dans le relevé au comptable, dans la langue choisie.",
    directReasonLabel: "Motif",
    directReasonNone: "— sans motif —",
    directReasonOthers: "Autres motifs",
    directReasonRequiredOther: "Choisissez un motif pour la catégorie « Autres ».",
    directReasonSuggested: "Suggérés pour cette catégorie",
    directSalaryPersonal: "Salaire / Personnel",
    directSalaryPersonalHint: "Paie, charges sociales",
    directSectionTitle:
      "Ou catégoriser directement (sans document) — même liste que les catégories",
    directSupplierPurchaseHint:
      "Outil, service, produit ou matériel payé immédiatement (carte/débit) — charge d'exploitation 2026",
    directTax: "Impôt / DGFiP",
    directTaxHint:
      "TVA, IS, CFE et autres impôts payés à la DGFiP (exercice courant). Utilisez « Règlement 2025 » s'il s'agit d'une dette de l'exercice précédent.",
    docKindTitle: "Quel type de document ?",
    docPickTitle: "Choisissez le document",
    docRegisterNew: "Pas dans la liste ? Enregistrer la facture fournisseur",
    downloadCsv: "Télécharger le CSV",
    downloadPdf: "Télécharger le PDF",
    downloadSection: "Télécharger",
    dragFilesHere: "glissez les fichiers ici",
    emailNote:
      "L'email contient le relevé rapproché de Gestion (PDF + CSV) + le relevé original joint. L'email du comptable est enregistré pour la prochaine fois.",
    emailPlaceholder: "email@comptable.fr",
    emailSection: "Envoyer au comptable par email",
    emptyState: "Aucune transaction trouvée avec ces filtres.",
    errorTitle: "Erreur",
    existingReceiptsTitle: "Encaissements existants (non liés)",
    expandHint: "Cliquer pour voir le libellé bancaire complet",
    exportBtnTitle: "Exporter le relevé de la période (PDF + CSV) et l'envoyer au comptable",
    exportModalTitle: "Relevé pour le comptable",
    failed: "échec",
    filterAccount: "Compte",
    filterByMonthTitle: "Filtrer par mois/année",
    filterCategory: "Catégorie",
    filterCompany: "Société",
    filterInvoicesByCustomerTitle: "Filtrer les factures par client",
    filterMonth: "Mois",
    filterPeriod: "Période",
    filterSearch: "Rechercher",
    filterStatus: "Statut",
    fullOptionHint: "la différence ne sera plus réclamée",
    fullPaymentBtn: "Payée en totalité",
    fullPaymentMsg:
      "La différence ne sera plus réclamée. Si le client doit encore payer le reste, revenez et choisissez paiement partiel.",
    fullPaymentTitle: "Marquer la facture payée quand même ?",
    generatePdfCsv: "Générer PDF + CSV",
    generating: "Génération…",
    higherNote:
      "Le dépôt est supérieur à la facture. S'il paie plusieurs factures, revenez et cochez « Ce dépôt paie plusieurs factures ».",
    hintBankFee: "Commission, frais de la banque",
    hintFees: "Comptable, avocat, consultants, intermédiaires",
    hintInsurance: "Primes d'assurance (RC, véhicules, multirisques…)",
    hintOther: "Ne correspond à aucune des catégories ci-dessus",
    hintPartnerContribution:
      "Prêt/apport de votre part VERS la société (entrée) — augmente ce qu'elle vous doit",
    hintPartnerReimbursement:
      "Remboursement de la société VERS vous (sortie) — règle une partie de ce qu'elle vous doit",
    hintPersonal:
      "Dépense personnelle sur la carte de la société (déduite de votre remboursement/résultat)",
    hintRent: "Loyer, leasing, charges locatives",
    hintRevenue: "Encaissement client, facturation",
    hintSalary: "Paie, charges sociales",
    hintSupplier: "Paiement à un fournisseur",
    hintSupplies: "Fournitures et consommables (non stockés)",
    hintTax: "IS, TVA, impôts",
    hintTransfer: "Virement entre comptes propres",
    hintTravel: "Voyages, carburant, péage, hôtel, réception",
    hintVatPayment:
      "Reversement de TVA à l'État — ce n'est PAS une charge (à recouper avec le module TVA)",
    ignoreBtn: "ignorer",
    ignoreConfirm: "Ignorer",
    ignoreMessage:
      "À utiliser pour les frais internes, virements entre comptes propres, etc. Motif obligatoire.",
    ignorePlaceholder: "Ex. : virement entre comptes",
    ignoreTitle: "Ignorer la transaction",
    invalidAmountMessage: "Vérifiez le HT et la TVA (%).",
    invalidAmountTitle: "Montant invalide",
    invalidEmailMessage: "Saisissez l'e-mail du comptable.",
    invalidEmailTitle: "E-mail invalide",
    invoiceCreatedPdfFailed: "Facture créée, mais l'ajout du PDF a échoué.",
    invoiceDocWord: "facture",
    invoiceFromPlaceholder: "Facture de (ex. : F2026-00300)",
    invoiceNumberPlaceholder: "N° de facture",
    invoiceToPlaceholder: "à (ex. : F2026-00334)",
    invoiceWord: "facture",
    invoicesOfEntry: "Factures de cette écriture",
    invoicesUnit: "facture(s)",
    langEn: "Anglais",
    langFr: "Français (comptable FR)",
    langPt: "Portugais",
    languageLabel: "Langue du relevé",
    lblCb: "Carte (CB)",
    lblFrais: "Frais bancaires",
    lblPrlv: "Prélèvement",
    lblVirEmis: "Virement émis",
    lblVirRecu: "Virement reçu",
    linkBtn: "lier",
    linkCustomerReceipt: "Encaissement client",
    linkProforma: "Proforma (paiement)",
    linkPurchaseInvoice: "Fournisseur / Achat",
    linkSectionTitle: "Lier à un document existant",
    linkTaxPayment: "Paiement d'impôt",
    linkTechnicianPayment: "Paiement technicien",
    linkedInvoicesAlertTitle: "Factures de l'écriture",
    loading: "Chargement…",
    manualWord: "manuelle",
    matchByAmount: "montant exact",
    matchByFilenameHint:
      "Correspondance par le n° du fichier (ex. : F2025-00006.pdf) · max. 25 Mo chacun",
    matchByNumber: "n° dans le virement",
    matchSurplus: "comble le reste",
    maxSizeEach: "max. 25 Mo chacun",
    missingDataMessage: "Sélectionnez le fournisseur et saisissez le n° de facture.",
    missingDataTitle: "Données manquantes",
    monthAttachAlertTitle: "Pièces jointes des factures du mois",
    monthInvoicesHelp:
      "Joignez les PDF (de l'eDSP) — chaque fichier est associé à la facture du même numéro et devient un lien dans le relevé du comptable.",
    monthInvoicesTitle: "Factures émises sur la période",
    moreActions: "Plus d'actions",
    multiBtn: "Plusieurs factures / encaissements",
    multiHelp:
      "Cochez les factures OUVERTES (elles seront payées : création d'un reçu + passage en payée) et/ou les encaissements DÉJÀ EXISTANTS (simple liaison). Les montants affichés sont le FACTURÉ TTC (ce que le client paie — base du dépôt) ; le reçu enregistré en interne est en HT (net). La somme doit être proche du dépôt.",
    multiSectionTitle: "Ou rapprocher PLUSIEURS factures client (un dépôt paie plusieurs factures)",
    multiShortfall:
      "La somme des factures cochées dépasse le dépôt : impossible de tout marquer payé. Décochez-en ou, pour un paiement partiel, laissez une seule facture.",
    newPurchaseHelp:
      "Aucune facture d'achat en attente ? Enregistrez-en une ici (PDF facultatif) et rapprochez le paiement en une seule fois. HT pré-rempli = |dépôt| ÷ 1,20.",
    next: "Suivant",
    nextMonth: "Mois suivant",
    noAttachments: "Aucun justificatif joint pour le moment.",
    noCandidates: "Aucun candidat en attente dans cette catégorie.",
    noCompanyAccess: "Vous n'avez accès à aucune société.",
    noInvoicesInPeriod: "Aucune facture émise sur cette période.",
    noMatchingInvoiceInEntry: "sans facture correspondante dans cette écriture",
    noMatchingInvoiceInPeriod: "sans facture correspondante sur la période",
    noOpenInvoices: "Aucune facture ouverte dans le filtre.",
    noPdf: "sans PDF",
    noPendingReceipts: "Aucun encaissement en attente de liaison dans le filtre.",
    noteLabel: "Observation",
    ofLabel: "sur",
    open: "ouvrir",
    openInvoicePdfTitle: "Ouvrir / télécharger le PDF de la facture",
    openInvoiceWord: "Facture ouverte",
    openInvoicesTitle: "Factures ouvertes",
    openPdf: "ouvrir le PDF",
    openProformaInvoicePdfTitle: "Ouvrir / télécharger le PDF de la facture jointe à la proforma",
    openPurchasePdfTitle: "Ouvrir / télécharger le PDF de la facture d'achat",
    optionalSuffix: "(facultatif)",
    otherOptionsBtn: "Autres options",
    pageLabel: "Page",
    partialOptionHint: "enregistre ce qui est arrivé ; la facture reste ouverte pour le reste",
    partialPaymentBtn: "Paiement partiel",
    pdfOptional: "PDF facultatif",
    pdfsAttached: "PDF joint(s).",
    pdfsAttachedToInvoices: "PDF joint(s) à la (aux) facture(s).",
    periodLabel: "Période",
    piAchatsConsommes: "Achats consommés",
    piAssurances: "Assurances",
    piAutresCharges: "Autres charges d'exploitation",
    piChargesPersonnel: "Charges de personnel",
    piDeplacements: "Déplacements / réception",
    piFournitures: "Fournitures / consommables",
    piFraisBancaires: "Frais bancaires",
    piHonoraires: "Honoraires / intermédiaires",
    piImpots: "Impôts / taxes",
    piLocations: "Locations / charges",
    pickOneToContinue: "Choisissez un élément pour continuer.",
    prev: "Précédent",
    prevMonth: "Mois précédent",
    proformaAlreadyPaid:
      "Déjà marquée payée — lier enregistre seulement le paiement sur le relevé (rien n'est refait).",
    proformaDocReconciled: "Proforma rapprochée — facture reçue",
    proformaNeedsApproval:
      "Proforma seulement envoyée — approuvez-la et enregistrez la facture reçue avant de rapprocher.",
    proformaNeedsInvoice:
      "La facture reçue n'est pas encore enregistrée sur la proforma — faites-le avant de rapprocher.",
    proformaNoInvoicePdf: "pas de PDF de facture — joignez-le à la proforma",
    proformaWillBePaid:
      "En liant, la proforma passe payée et ses véhicules sont payés au technicien.",
    purchaseInvoiceReconciled: "Facture d'achat rapprochée",
    purchaseWord: "Achat",
    readFileError: "Impossible de lire le fichier joint.",
    reasonRecorded: "Motif enregistré :",
    receiptFilterNumber: "n° de facture…",
    receiptMultiToggle: "Ce dépôt paie plusieurs factures",
    receiptPickHint: "Cochez une ou plusieurs ; la somme s'affiche au-dessus.",
    receiptPickTitle: "Quelles factures ce dépôt paie-t-il ?",
    receiptWord: "Encaissement",
    reconcileBtn: "Rapprocher",
    reconcileTitle: "Rapprocher la transaction",
    reconcileVerb: "Rapprocher",
    reconciling: "Rapprochement…",
    registerAndReconcile: "Enregistrer la facture + rapprocher",
    registering: "Enregistrement…",
    remainingWord: "reste",
    removeBtn: "supprimer",
    removeConfirm: "Supprimer",
    removeFileTitle: "Supprimer le fichier",
    removeQuestionPre: "Supprimer",
    removeReceiptTitle: "Supprimer le justificatif",
    removeTitle: "Supprimer",
    searchPlaceholder: "Description…",
    selectAllInvoices: "Tout sélectionner",
    selectAllReceipts: "Tout sélectionner",
    selectPdfsMid: "PDF (ex. :",
    selectPdfsPre: "Sélectionnez les",
    selectPdfsSuf: ".pdf) — chaque fichier est joint à sa facture.",
    selectPeriodFirst:
      "Sélectionnez un mois (ou une plage de dates) dans la barre avant d'exporter.",
    selectVisible: "Cocher les visibles",
    selectedCount: "sélectionné(s)",
    send: "Envoyer",
    sendAnyway: "Envoyer quand même",
    sendFailed: "Échec de l'envoi",
    sendToAccountantBtn: "Envoyer au comptable",
    sending: "Envoi",
    sendingEllipsis: "Envoi…",
    sentTitle: "Envoyé",
    sheetCloseLabel: "Fermer le panneau",
    sortNewest: "Plus récents d'abord",
    sortOldest: "Plus anciens d'abord",
    sortToggleTitle: "Inverser l'ordre de la liste",
    statementBalancePre: "solde du relevé au",
    statementBalanceTitle:
      "Solde indiqué par le fichier importé, à la date du relevé. Il n'est pas calculé par le Gestion.",
    statementSentTo: "Relevé envoyé à",
    statusIgnored: "Ignorée",
    statusPending: "En attente",
    statusReconciled: "Rapprochée",
    stepConfirm: "Confirmer",
    stepDetails: "Détails",
    stepWhat: "Qu'est-ce que c'est ?",
    subtitle: "Relevés bancaires",
    subtitleShort: "Relevés",
    sugAcceptMsgPre: "Rapprocher cette transaction sur la base de :",
    sugAcceptMsgSuf:
      "Cela crée le reçu et marque la facture payée (même effet que le rapprochement manuel).",
    sugAcceptTitle: "Accepter la suggestion de rapprochement",
    sugApplied: "Suggestion appliquée",
    sugBadge: "Suggestion de Gestion",
    sugEntityPre: "reconnu dans les fiches :",
    sugHistoryPre: "déjà utilisée",
    sugInvoicesCited: "factures citées dans le virement",
    sugMaybe: "Peut-être ?",
    sugReconcilePre: "Rapprocher :",
    sugSimilarMany: "opérations similaires",
    sugSimilarManySuf: "ont été marquées comme",
    sugSimilarOne: "opération similaire",
    sugSimilarOneSuf: "a été marquée comme",
    sugUseSame: "Utiliser la même",
    sumAvoirMid: "devient l'avoir",
    sumAvoirPre: "la différence de",
    sumAvoirSuf: "et la facture passe en payée.",
    sumDepositWord: "Dépôt de",
    sumDirectNote:
      "figure sur le relevé au comptable dans la langue choisie · catégorie modifiable ensuite",
    sumDocPaid: "Le document passe en payé et reste lié au relevé.",
    sumInvoiceFullAnyway: "qui passe en payée malgré tout (la différence ne sera plus réclamée).",
    sumInvoicePaid: "qui passe en payée.",
    sumInvoicePartial: "en partie —",
    sumLinksReceipt: "sera lié à l'encaissement",
    sumMatches: "correspond au dépôt",
    sumMultiMid: "lié à",
    sumMultiPaidSuf: "qui passent en payées.",
    sumMultiSuf: "facture(s) / encaissement(s), qui passent en payés.",
    sumNoReason: "sans motif",
    sumOutflowWord: "Sortie de",
    sumOverPre: "la somme dépasse le dépôt de",
    sumPartialHint: "paiement partiel possible à l'étape suivante",
    sumPaysDoc: "paie",
    sumPaysInvoice: "paie la facture",
    sumPaysInvoices: "paie les factures",
    sumSurplusPre: "reste sur le dépôt :",
    summaryPre: "Résultat :",
    supplierPlaceholderOption: "— Fournisseur —",
    tlMonthIn: "Entrées",
    tlMonthOut: "Sorties",
    toDate: "au",
    txAttachmentsTitle: "Justificatifs de la transaction",
    txCountMany: "transactions",
    txCountOne: "transaction",
    typeDirect: "Sans document",
    typeDirectHint: "Achat par carte, frais, virement. Catégorie + motif standardisé + complément.",
    typeDocument: "Paiement d'un document",
    typeDocumentHint:
      "Facture fournisseur, proforma, paiement de technicien, impôt. On choisit le document dans la liste.",
    typeReceipt: "Encaissement client",
    typeReceiptHint:
      "Paie une ou plusieurs factures. Gestion propose les factures ouvertes de ce montant.",
    undoBtn: "défaire",
    undoConfirm: "Défaire",
    unignoreMessage: "La transaction redeviendra en attente et pourra être rapprochée à nouveau.",
    unignoreTitle: "Ne plus ignorer",
    unreconcileBtn: "annuler le rapprochement",
    unreconcileMessage:
      "La transaction redeviendra en attente et le document lié sera à nouveau disponible pour un rapprochement.",
    unreconcilePlaceholder: "Ex. : j'ai lié à la mauvaise facture",
    unreconcileTitle: "Annuler le rapprochement",
    untriagedFilterBtn: "Voir et traiter",
    untriagedHint:
      "Elles n'entrent PAS dans les recettes fiscales tant qu'elles ne sont pas traitées.",
    untriagedManySuf: "entrées sans catégorie ni rapprochement sur la période",
    untriagedOneSuf: "entrée sans catégorie ni rapprochement sur la période",
    uploadFailed: "Échec de l'envoi du fichier.",
    withPdf: "avec PDF",
  },
  breakevenChart: {
    ariaLabel: "Graphique du seuil de rentabilité",
  },
  bulkActionBar: {
    clear: "Effacer",
    clearSelectionTitle: "Effacer la sélection",
    selectedMany: "sélectionnés",
    selectedOne: "sélectionné",
    selectionLabel: "Sélection",
  },
  chantier: {
    agendaAddBtn: "+ Planifier",
    agendaArrivedBtn: "Arrivé",
    agendaCancelBtn: "Annuler",
    agendaDoneBtn: "Terminé",
    agendaEmpty: "Rien de planifié les prochains jours.",
    agendaSaveBtn: "Enregistrer le rendez-vous",
    agendaTitle: "Agenda du chantier",
    attachChantierAutoPre: "En enregistrant la réception, le client",
    attachChantierAutoSuf: "rejoint le chantier",
    attachChantierHint:
      "Une fois le client rattaché au chantier, les techniciens ayant une paire par chantier voient ce véhicule dans leur portail.",
    attachChantierMid: "n'est rattaché à aucun chantier. L'ajouter au chantier",
    attachChantierNo: "Non",
    attachChantierPre: "Le client",
    attachChantierYes: "Oui, l'ajouter",
    carRepairedHint: "Toutes les prestations de ce véhicule sont terminées.",
    carRepairedTitle: "Véhicule déjà réparé",
    carsEmpty:
      "Aucun véhicule sur ce chantier pour l'instant (liez les clients au chantier dans leur fiche).",
    carsTitle: "Véhicules du chantier",
    claimRefLabel: "N° de sinistre",
    damagePlaceholder: "Ex. : rétroviseur gauche fissuré",
    damagesLabel: "Dommages / pièces cassées pré-existants",
    deliveryAlarmHint:
      "Véhicules réparés sans livraison enregistrée. Touchez la plaque et enregistrez la livraison et le contrôle : ce n'est qu'ensuite que le véhicule est facturé et compte dans votre commission.",
    deliveryAlarmInvoiced: "déjà facturé",
    deliveryAlarmTitle: "Livraisons en attente",
    deliveryPhotosMissingPre: "Il manque",
    deliveryPhotosMissingSuf:
      "photo(s) de livraison — photographiez le véhicule avant de le livrer.",
    deliveryPhotosTitle: "Photos de livraison",
    deliveryTitle: "Livraison et contrôle",
    deposeReposeLabel: "Dépose/Repose",
    devisPareBrise: "Pare-brise",
    devisPieces: "Pièces",
    devisTitle: "Devis",
    docCarteGrise: "Carte grise",
    docCnh: "Permis de conduire",
    docExpertise: "Rapport d'expertise",
    docReplaceBtn: "Remplacer",
    docSentBadge: "envoyé",
    docUploadFail: "Impossible de lire le fichier — réessayez.",
    docUploading: "Envoi du document…",
    docsTitle: "Documents de réception",
    doneBadge: "fait",
    expAlarmTitle: "Véhicule à finaliser",
    expAmountLabel: "Montant du rapport d'expertise (HT)",
    expConfirmBtn: "Confirmer la vérification",
    expDevisLabel: "Montant à facturer (devis)",
    expDiffBadge: "avec écart",
    expDiffOver: "au-dessus du montant à facturer.",
    expDiffPre: "Écart de",
    expDiffUnder: "en dessous du montant à facturer.",
    expHint:
      "Vérifiez le montant du rapport d'expertise avec le montant à facturer avant de finaliser le véhicule.",
    expInvoiceLabel: "Facture",
    expMatch: "Les montants correspondent.",
    expNeedDoc: "Joignez le rapport d'expertise ci-dessous avant de confirmer.",
    expNotePh: "Expliquez l'écart au bureau",
    expSaving: "Enregistrement…",
    expTitle: "Rapport d'expertise vérifié",
    expertEmailLabel: "E-mail de l'expertise",
    expertNameLabel: "Cabinet d'expertise",
    finalizeAlarmHint:
      "Rapport d'expertise à vérifier avec le montant à facturer. Cherchez la plaque pour terminer.",
    finalizeAlarmTitle: "Véhicules à finaliser",
    finalizeNoDoc: "sans rapport",
    franchiseAmountPh: "Montant de la franchise (€)",
    franchiseChangeBtn: "Modifier",
    franchiseFirstHint:
      "Répondez à la question de la franchise pour débloquer les photos et la signature.",
    franchiseLabel: "Franchise",
    franchiseNo: "Non",
    franchiseNone: "sans franchise",
    franchiseQ: "Le véhicule a-t-il une remise de franchise au client ?",
    franchiseRequiredBadge: "obligatoire",
    franchiseStep: "1 · Franchise — obligatoire",
    franchiseToggle: "Le véhicule aura une remise de franchise",
    franchiseYes: "Oui",
    hidePhotosBtn: "Masquer les photos",
    impactsWord: "impacts",
    incompleteBadge: "incomplet",
    insuranceHint: "La facture part au client ET à ces contacts. Sans eux le paiement traîne.",
    insuranceMissing: "à renseigner",
    insuranceTitle: "Assurance et expertise",
    insurerEmailLabel: "E-mail de l'assurance",
    insurerNameLabel: "Assurance",
    invColCount: "factures",
    invColOpen: "En attente",
    invColOverdue: "En retard",
    invColReceived: "Encaissé",
    invColTotal: "Facturé",
    invDaysLate: "jours",
    invDue: "éch.",
    invOverdueNone: "Aucune facture en retard.",
    invOverdueTitle: "Factures en retard",
    invoicesEmpty: "Aucune facture émise pour les clients de ce chantier.",
    invoicesHint:
      "Montants HT des factures émises aux clients de ce chantier. « En retard » = échue et sans aucun encaissement.",
    invoicesTitle: "Factures des clients du chantier",
    loanerPh: "Quel véhicule (plaque/modèle)",
    loanerToggle: "Véhicule de remplacement prêté au client ?",
    logout: "Quitter",
    mileageLabel: "Kilométrage",
    mileagePh: "km au compteur",
    montageShort: "Montage",
    noChantiers: "Aucun chantier créé — le bureau les crée dans Chantiers.",
    noResults: "Aucun véhicule avec cette immatriculation dans cette société.",
    noTechWarning:
      "Aucun technicien n'a pris ce véhicule dans le portail. Si vous enregistrez la livraison maintenant, le véhicule se ferme sans technicien et le bureau devra affecter le technicien dans le dossier.",
    notManagerNote: "Votre compte n'a le rôle chef de projet dans aucune société.",
    notesPh: "Remarques…",
    openGestion: "Ouvrir le Gestion",
    photosDelivery: "Livraison",
    photosDemontage: "Dépose",
    photosMontageEnd: "Fin du travail",
    photosReception: "Réception",
    recMissCiel: "répondre le ciel de toit",
    recMissPareBrise: "répondre le pare-brise",
    recMissPhoto: "photo",
    recMissPhotoCiel: "photo du ciel de toit",
    recMissPhotoPareBrise: "photo du pare-brise",
    recMissPhotos: "photos",
    recMissSignature: "signature du client",
    recMissingPre: "Il manque à la réception :",
    receptionTitle: "Réception du véhicule",
    remiseCheckPre: "Remise du client (fiche) :",
    remiseCheckSuf: "— à vérifier à la réception.",
    repasseByDelivery:
      "Le véhicule compte dans le mois où vous enregistrez sa LIVRAISON dans le portail.",
    repasseEmpty:
      "Aucune livraison enregistrée ce mois-ci (ou commission pas encore configurée par le bureau).",
    repasseParticular: "Particulier",
    repassePro: "Professionnel",
    repasseTitle: "Ma commission du mois",
    repasseTotal: "Total",
    reservesLabel: "Réserves de livraison",
    saveBtn: "Enregistrer",
    saved: "✓ Check-list enregistrée.",
    savingBtn: "Enregistrement…",
    scanFail:
      "Lecture impossible sur la photo — rapprochez-vous, évitez les reflets et réessayez, ou saisissez.",
    scanning: "Lecture de la photo…",
    searchBtn: "Chercher",
    searching: "Recherche…",
    serviceDemontage: "Dépose",
    serviceMontage: "Repose",
    servicePdrLabel: "PDR",
    servicesTitle: "Prestations de ce véhicule",
    showPhotosBtn: "Voir les photos",
    statusArrived: "reçu",
    statusDone: "terminé",
    statusScheduled: "planifié",
    stepBlockedHint:
      "Le technicien ne peut pas prendre ce véhicule tant que la réception n'est pas complète.",
    stepDelivered: "véhicule livré.",
    stepDoDelivery: "faire la livraison et le contrôle du travail.",
    stepInRepair: "réparation en cours.",
    stepNextPre: "Prochaine étape :",
    stepNotReceived: "Véhicule pas encore reçu",
    stepReceptionIncomplete: "Réception incomplète",
    stepReleased: "Véhicule libéré pour la réparation",
    stepWaitingTechnician: "attendre qu'un technicien la prenne.",
    title: "Chantier",
    undeliveredPre: "véhicule(s) déjà facturé(s) sans livraison enregistrée —",
    undeliveredSuf:
      "de commission en attente de l'enregistrement. Enregistrez la livraison pour être payé.",
    workOkNo: "Travail avec réserves",
    workOkToggle: "Travail contrôlé et approuvé",
    workOkYes: "Travail approuvé",
  },
  chantiers: {
    commBase: "Base",
    commBaseFaturado: "Facturé (Total Facture)",
    commBaseOrcamento: "Devis (Prix Brut)",
    commClientPct: "% Remise client",
    commHint:
      "S'applique à TOUS les techniciens × clients de ce chantier (pro ou particulier) sans paire spécifique — la paire technicien×client, si elle existe, l'emporte.",
    commIntermediary: "Intermédiaire",
    commIntermediaryNone: "— sans intermédiaire —",
    commIntermediaryPct: "% Intermédiaire",
    commPct: "% Technicien",
    commTitle: "Commission du chantier (par défaut)",
    customersWord: "clients",
    detailAgendaEmpty: "Rien de planifié.",
    detailAgendaTitle: "Agenda (prochains jours)",
    detailAgendaWord: "planifiés",
    detailCarsEmpty:
      "Aucun véhicule pour l'instant (ils arrivent via les devis/factures des clients liés).",
    detailCarsTitle: "Véhicules / dossiers",
    detailCarsWord: "véhicules",
    detailCustomersEmpty: "Aucun client lié — liez-les dans la fiche Clients.",
    detailCustomersTitle: "Clients du chantier",
    detailDevisWord: "devis à exécuter",
    devisChip: "devis",
    editBtn: "Modifier",
    editTitle: "Modifier le chantier",
    empty: "Aucun chantier. Créez le premier et liez les clients dans la fiche Clients.",
    fieldActive: "Actif",
    fieldAddress: "Adresse",
    fieldCity: "Ville",
    fieldEnd: "Fin",
    fieldName: "Nom",
    fieldNotes: "Remarques",
    fieldPostal: "Code postal",
    fieldStart: "Début",
    inactiveWord: "inactif",
    managerAdd: "Lier",
    managerHint:
      "Commission sur PDR + dégarnissage, base devis HT (après franchise), payée par la part maison.",
    managerNoCandidates:
      "Aucun utilisateur avec le rôle gérant dans cette société — créez le compte dans Utilisateurs d'abord.",
    managerPartShort: "Particulier",
    managerPick: "Choisir l'utilisateur (rôle gérant)…",
    managerProShort: "Pro",
    managerRemove: "Retirer",
    managerTitle: "Responsable du chantier",
    newBtn: "Nouveau chantier",
    openBtn: "Ouvrir",
    saveBtn: "Enregistrer",
    subtitle:
      "Lieux de travail — les clients sont liés à un chantier dans leur fiche (comme dans eDSP).",
    title: "Chantiers",
  },
  clientPortal: {
    bookBtn: "Planifier",
    bookTitle: "Planifier un véhicule",
    created: "✓ Véhicule planifié.",
    dateLabel: "Jour",
    logout: "Quitter",
    myBookingsEmpty: "Aucun rendez-vous pour l'instant.",
    myBookingsTitle: "Mes rendez-vous",
    notClientNote: "Votre compte n'a le rôle client dans aucune société.",
    notLinkedNote: "⚠ Compte pas encore lié à un client/chantier — contactez le bureau.",
    occupancyEmpty: "Agenda libre sur les 30 prochains jours.",
    occupancySuffix: "véhicule(s) planifié(s) ce jour",
    occupancyTitle: "Occupation du chantier (30 jours)",
    plateLabel: "Immatriculation",
    statusArrived: "reçu",
    statusDone: "terminé",
    statusScheduled: "planifié",
    svcMontage: "Montage",
    svcPeinture: "Peinture",
    svcPieces: "Pièces",
    timeLabel: "Heure",
    title: "Agenda",
    vehicleLabel: "Véhicule (optionnel)",
    vehiclePh: "Ex. : Renault Clio grise",
  },
  commissionCascade: {
    rowClient: "Client",
    rowIntermediary: "Interm.",
    rowMontage: "Montage",
    rowTech: "Tech.",
  },
  companies: {
    addrCity: "Ville",
    addrCountry: "Pays",
    addrPostal: "Code postal",
    addrStreet: "Adresse (rue)",
    bankAccountsLink: "Comptes bancaires",
    capitalSocial: "Capital social (€)",
    codeApe: "Code APE",
    dataSaved: "Données enregistrées.",
    descEmphasis: "émetteur",
    descMid:
      " qui apparaissent sur la facture (raison sociale, SIREN/SIRET, code APE, capital social, n° TVA, adresse). Les coordonnées bancaires (IBAN/BIC) se trouvent dans ",
    descPre: "Données fiscales de l'",
    fiscalIdOther: "Identifiant fiscal (autre)",
    institutionalEmail: "E-mail institutionnel",
    legalName: "Raison sociale",
    loading: "Chargement…",
    logoAlt: "Logo de la société",
    logoHintPre: "Cliquez sur ",
    logoHintSuf: " pour appliquer. SVG non pris en charge.",
    logoLabel: "Logo sur la facture (PNG ou JPEG)",
    logoUploaded: "Logo téléversé — cliquez sur Enregistrer pour appliquer.",
    noCompanies: "Aucune société accessible.",
    noLogo: "aucun logo",
    pageSubtitle: "Données qui figurent en en-tête et en pied de vos factures.",
    removeLogo: "supprimer le logo",
    save: "Enregistrer",
    saving: "Enregistrement…",
    secContact: "Contact de la société",
    secContactDesc: "Cette information figure sur les documents.",
    secIdentity: "Nom et adresse",
    secLegal: "Informations légales",
    secLegalDesc: "Données obligatoires utilisées sur les documents.",
    siren: "SIREN (9 chiffres)",
    siret: "SIRET (14 chiffres)",
    title: "Ma société",
    tradeName: "Nom commercial",
    uploadFailed: "Échec du téléversement",
    uploading: "Envoi…",
    vatNumber: "N° TVA",
  },
  comparisonTable: {
    colAnnualized: "Annualisé",
    colBudget: "Budget",
    colExercice: "Exercice",
    colRubrique: "Rubrique",
    colVarianceEur: "Écart (€)",
    colVariancePct: "Écart (%)",
  },
  creditNoteDoc: {
    cancel: "Annuler",
    emailBtn: "E-mail",
    emailTitle: "Envoyer l'avoir par e-mail",
    messageLabel: "Message (facultatif)",
    messagePlaceholder: "Vide = texte standard avec l'avoir en pièce jointe.",
    pdfTitle: "Télécharger le PDF de l'avoir",
    sendBtn: "Envoyer",
    sentTitle: "Avoir envoyé",
    toLabel: "À (e-mail du client)",
  },
  customerCredit: {
    amountLabel: "Montant à imputer (TTC)",
    available: "disponible",
    balanceWord: "solde",
    cancel: "Annuler",
    cardHint:
      "Reste d'un dépôt qui a payé plus que les factures. L'imputer sur une facture crée un encaissement lié au même dépôt ; annuler le rapprochement du dépôt annule le crédit et ce qui a été imputé.",
    cardTitle: "Crédit client",
    comboCitedOut: "Le motif du virement cite",
    comboCitedOutSuf: "qui reste en dehors (numéro probablement erroné).",
    comboMid: "font exactement",
    comboPre: "💡 Combinaison exacte :",
    comboUse: "Utiliser ces factures",
    confirmUse: "Imputer",
    errNone: "Aucun crédit disponible.",
    errNotOpen: "Cette facture n'est pas ouverte.",
    invoicePanelBtn: "Imputer sur cette facture",
    invoicePanelPre: "Crédit client disponible :",
    noOpenInvoices: "Aucune facture ouverte pour ce client.",
    originPre: "Reste du dépôt du",
    pickInvoice: "Facture ouverte",
    surplusNoCredit: "factures de clients différents : le reste ne devient pas un crédit",
    surplusToCredit: "→ devient un crédit du client",
    useBtn: "Imputer sur une facture",
    usedOk: "Crédit imputé :",
    usedOn: "sur",
    usedPre: "utilisé",
  },
  customerDetail: {
    activeValue: "actif",
    auditRequiresAdmin: "Le journal d'audit requiert des droits admin.",
    avgDaysToPayment: "Jours moyens de paiement",
    avgTicket: "Panier moyen",
    backLink: "Liste",
    backToList: "Retour à la liste",
    carsWordShort: "véhicules",
    colAction: "Action",
    colAmount: "Montant",
    colBy: "Par",
    colCode: "Code",
    colDate: "Date",
    colDossier: "Dossier",
    colDueDate: "Échéance",
    colInvoice: "Facture",
    colInvoiceNumber: "N° facture",
    colIssued: "Émise",
    colMethod: "Méthode",
    colPlate: "Plaque",
    colReason: "Motif",
    colReference: "Référence",
    colRetention: "Retenue",
    colSituation: "Situation",
    colTotalHt: "Total HT",
    colVehicle: "Véhicule",
    colWhen: "Quand",
    colorLabel: "Couleur",
    consolidatedHint: "Facture de plusieurs véhicules (consolidée)",
    consolidatedPre: "Facture consolidée ·",
    contactAddBtn: "Ajouter un contact",
    contactCancelBtn: "Annuler",
    contactEditBtn: "modifier",
    contactName: "Nom",
    contactNotes: "Remarque",
    contactReceivesInvoices: "reçoit les factures",
    contactReceivesInvoicesLong: "Reçoit les factures (proposé en premier à l'envoi par e-mail)",
    contactRemoveBtn: "supprimer",
    contactRemoveTitle: "Supprimer ce contact ?",
    contactRole: "Fonction",
    contactRolePh: "Ex. : comptabilité, chef d'atelier",
    contactSaveBtn: "Enregistrer le contact",
    contactsEmpty: "Aucun contact enregistré.",
    contactsTitle: "Contacts",
    country: "Pays",
    customerAuditLog: "Journal d'audit du client",
    customerDossiers: "Dossiers du client",
    customerInvoices: "Factures du client",
    customerNotFound: "Client introuvable dans les sociétés accessibles.",
    customerReceipts: "Encaissements du client",
    dayAbbr: "j",
    daysUnit: "jours",
    editBtn: "Modifier",
    email: "E-mail",
    emptyAudit: "Aucun événement.",
    emptyDossiers: "Aucun dossier sur cette période.",
    emptyInvoices: "Aucune facture sur cette période.",
    emptyReceipts: "Aucun encaissement sur cette période.",
    emptyVehicles: "Aucun véhicule enregistré pour ce client.",
    fiscalId: "N° fiscal",
    inactiveValue: "inactif",
    invalidId: "ID invalide.",
    invoicedHt: "Facturé HT",
    invoicesIssuedPaid: "Factures (émises + payées)",
    language: "Langue",
    loading: "Chargement…",
    openBalance: "Solde ouvert",
    openBtn: "ouvrir",
    openInvoiceTitle: "Ouvrir la facture",
    overdueBalance: "Solde en retard",
    overdueInvoices: "Factures en retard",
    paymentTerm: "Délai de paiement",
    period12m: "12 derniers mois",
    period30d: "30 derniers jours",
    period3m: "3 derniers mois",
    period6m: "6 derniers mois",
    periodAll: "Tout",
    periodSelectorLabel: "Période :",
    periodSince: "Depuis le 01/05/2026 (début Gestion)",
    periodYear: "Année en cours",
    phone: "Téléphone",
    receivedOnPre: "reçue le",
    registeredVehicles: "Véhicules enregistrés",
    reversalBadge: "extourne",
    sectionFinancial: "Financier",
    sectionOperational: "Opérationnel",
    sectionRecord: "Fiche",
    seeInCarros: "Voir dans Véhicules ↗",
    stageAll: "Tous",
    stageHint:
      "Étape choisie : affiche tous les dossiers dans cette situation aujourd'hui, sans la période.",
    stageReceived: "Encaissé",
    stageToday: "Situation des véhicules aujourd'hui",
    statementBtn: "📄 Relevé de compte",
    statusCancelled: "Annulée",
    statusIssued: "Émise",
    statusLabel: "Statut",
    statusPaid: "encaissée",
    statusPending: "En attente",
    statusUncollectible: "Irrécouvrable",
    statusVoid: "Annulée",
    stmtClose: "Fermer",
    stmtClosing: "Solde final (TTC)",
    stmtCredit: "Crédit disponible",
    stmtErrorTitle: "Impossible",
    stmtFrom: "Du",
    stmtMessage: "Message de l'e-mail",
    stmtModeOpen: "En attente à ce jour",
    stmtModePeriod: "Relevé sur une période",
    stmtMovements: "Mouvements sur la période",
    stmtNoEmail: "Le client n'a pas d'e-mail enregistré : saisissez une adresse.",
    stmtOpenInvoices: "Factures en attente",
    stmtOpening: "Solde antérieur",
    stmtOverdue: "dont échues",
    stmtPdfBtn: "📄 Ouvrir le PDF",
    stmtRecipient: "Envoyer à",
    stmtSendBtn: "✉ Envoyer par e-mail",
    stmtSentMsg: "Le relevé de compte a été envoyé à",
    stmtSentTitle: "Relevé envoyé",
    stmtTitle: "Relevé de compte",
    stmtTo: "Au",
    stmtToPay: "Solde à régler (TTC)",
    stmtTotalOpen: "Total en attente (TTC)",
    tabAudit: "Audit",
    tabDossiers: "Dossiers",
    tabFaturas: "Factures",
    tabRecebimentos: "Encaissements",
    tabResumo: "Résumé",
    tabVeiculos: "Véhicules",
    tabWorklog: "Worklog par atelier",
    total: "total",
    totalCredited: "Avoirs émis",
    totalIssued: "Total émis",
    totalReceived: "Total encaissé",
    totalRetention: "Retenue totale",
    wlColFacture: "Net HT (après remise)",
    wlColLines: "Prestations · technicien",
    wlColStatus: "Statut",
    wlLineDepose: "Dépose",
    wlLineEnCours: "en cours",
    wlLinePdr: "PDR",
    wlLineRepose: "Repose",
    wlLineTiers: "tiers (garage)",
    wlNoAtelier: "sans atelier",
    wlNoDemontage: "dépose non saisie",
    wlNoDemontageHint:
      "Le devis comporte une dépose/repose, mais personne n'a saisi ce service — il reste hors facture tant qu'il n'est pas saisi.",
    wlSelectHint:
      "Touchez un statut pour l'inclure ou le retirer du worklog (écran, PDF et e-mail).",
    wlSentScopePre: "PDF et e-mail au client :",
    wlSentScopeSuf:
      "réparés, en réparation et facturés (seuls les devis sans technicien restent dehors)",
    wlShowAll: "Afficher tout",
    wlStatusDevis: "Devis",
    wlStatusEmReparacao: "En réparation",
    wlStatusFacture: "Facturé",
    wlStatusRepare: "Réparé",
    wlValorDevis: "Devis HT",
    wlValorFacture: "Après remise client (HT)",
    wlValorFactureHint:
      "Super admin seulement. Montant que la facture facture (ou facturera) : devis moins remise et franchise. Un véhicule sans prestation saisie affiche — et reste hors total.",
    wlValorLabel: "Montants",
    worklogAllAteliers: "— tous les ateliers —",
    worklogAtelier: "Atelier",
    worklogBadPeriod: "La date de début est après la date de fin.",
    worklogCarsWord: "véhicule(s)",
    worklogChooseAtelier: "— choisir l'atelier —",
    worklogColAtelier: "Atelier",
    worklogColDate: "Date",
    worklogColDevis: "Total devis HT",
    worklogColPlate: "Plaque / VIN",
    worklogColTech: "Technicien PDR",
    worklogColVehicle: "Véhicule",
    worklogEmailBtn: "Envoyer au client",
    worklogEmailLabel: "E-mail du client",
    worklogEmpty: "Aucun véhicule dans cet atelier sur la période.",
    worklogFrom: "Du",
    worklogHint:
      "Tous les véhicules réalisés dans l'atelier, par tous les techniciens, sur la période : les lignes PDR / dépose / repose avec le technicien et le montant de chacune. Le PDF est en français pour le client.",
    worklogNoAtelier: "Ce client n'a aucun atelier enregistré.",
    worklogPdfBtn: "Télécharger le PDF",
    worklogSentPre: "Worklog envoyé à",
    worklogTitle: "Worklog par atelier",
    worklogTo: "Au",
  },
  customerReview: {
    badge: "à vérifier",
    bannerPre: "Client eDSP à vérifier.",
    cancel: "Annuler",
    chantierLabel: "Chantier",
    chantierNone: "— aucun chantier —",
    chip: "À vérifier",
    confirm: "✓ Confirmer",
    doneCarsPre: "Véhicules recalculés :",
    doneMsg: "Client confirmé.",
    errRemise: "Indiquez la remise du client professionnel (0 % accepté).",
    homeAction: "Vérifier",
    homeCarsWord: "véhicule(s) en cours",
    homeTitle: "Clients eDSP à vérifier",
    intro:
      "Les listes eDSP n'indiquent ni le type, ni le SIRET, ni la TVA. Vérifiez le type, la remise et le chantier ; Gestion a déjà proposé le type.",
    kindBusiness: "Professionnel",
    kindBusinessHint:
      "Indiquez la remise (0 % accepté). La franchise réduit la facture et la commission.",
    kindIndividual: "Particulier",
    kindIndividualHint:
      "Remise 0 %. La franchise ne réduit pas la facture, seulement la commission du technicien.",
    openCarsHint: "si quelque chose change, leur remise et leur franchise sont recalculées.",
    openCarsPre: "Véhicules pas encore facturés :",
    openRecord: "Ouvrir la fiche",
    proMissingRemise:
      "Professionnel sans remise : sans elle, Gestion ne calcule pas la commission des techniciens en base devis. Indiquez la remise (0 % accepté).",
    reasonIndefinido: "le nom ne permet pas de trancher, vérifiez",
    reasonNomeEmpresa: "nom d'entreprise",
    reasonNomePessoa: "nom de personne",
    reasonSiretTva: "a un SIRET ou une TVA",
    remiseLabel: "Remise du client (%)",
    reviewBtn: "Vérifier",
    suggestionPre: "Proposition de Gestion :",
    title: "Vérifier le client eDSP",
  },
  customers: {
    appliesTvaLabel: "Applique la TVA (décochez pour l'autoliquidation intra-UE)",
    atelierAddBtn: "Ajouter un atelier",
    atelierAliasesPh: "Noms dans l'eDSP, séparés par des virgules (ex. : REPARE GRELE P2)",
    atelierCityPh: "Ville (optionnel)",
    atelierNamePh: "Nom de l'atelier (ex. : Julien)",
    atelierRemiseCustomer: "remise de la fiche client",
    atelierRemiseLabel: "remise",
    atelierRemisePh: "Remise % (optionnel)",
    atelierSaveBtn: "Enregistrer",
    ateliersHelp:
      "Lieux de ce client où les véhicules sont réparés (ex. : Julien). Le technicien choisit l'atelier à l'import du devis.",
    ateliersTitle: "Ateliers / lieux du service",
    badgeActive: "actif",
    badgeInactive: "inactif",
    badgeInsurer: "Assureur",
    badgePart: "Part.",
    badgeProf: "Pro.",
    cancel: "Annuler",
    chantierHint:
      "Lie le client à un chantier (ses véhicules apparaissent sur le portail du chef de ce chantier).",
    chantierNone: "— aucun —",
    close: "Fermer",
    colActions: "Actions",
    colCountry: "Pays",
    colEmail: "E-mail",
    colFiscalId: "Identifiant fiscal",
    colName: "Nom",
    colStatus: "Statut",
    colType: "Type",
    commissionHelp:
      "Commission par défaut retenue par le client. Appliquée sur la base DEVIS lors de la création du dossier (modifiable par dossier).",
    commissionRangeError: "La % de commission doit être comprise entre 0 et 100.",
    companyLabel: "Société",
    create: "Créer",
    customerPlural: "clients",
    customerSingular: "client",
    deactivate: "Désactiver",
    deactivateMessage:
      "Un client inactif n'apparaît pas dans les nouvelles factures. Les factures existantes ne sont pas affectées.",
    deactivatePlaceholder: "Ex : le client a résilié le contrat",
    deactivateTitlePre: "Désactiver le client",
    editLink: "modifier",
    editTitle: "Modifier le client",
    emptyState: "Aucun client trouvé.",
    fieldBillingEmail: "E-mail de facturation",
    fieldChantier: "Chantier",
    fieldCommission: "% Commission (retenue du client)",
    fieldCountry: "Pays (ISO-2)",
    fieldDisplayName: "Nom (UI)",
    fieldEmail: "E-mail (général)",
    fieldFiscalIdKind: "Type d'identifiant fiscal",
    fieldLegalName: "Raison sociale (personne morale)",
    fieldManagerPct: "Commission du responsable du chantier pour ce client (%)",
    fieldNotes: "Notes",
    fieldPaymentTerm: "Délai de paiement (jours)",
    fieldPhone: "Téléphone",
    fieldPortalUser: "Compte du portail (client)",
    fieldPreferredLang: "Langue préférée",
    fieldReason: "Motif de la modification de l'identifiant fiscal",
    fieldTvaOnInvoice: "TVA sur la facture",
    fieldVatNumber: "N° VAT · TVA · USt-IdNr. · IVA (intracommunautaire)",
    fiscalAdminOnly: "Seuls les administrateurs peuvent modifier l'identifiant fiscal.",
    fiscalKindOther: "Autre",
    fiscalKindVatEu: "TVA (autre pays UE)",
    franchiseRequiredHelp:
      "Le client particulier exige toujours, indépendamment de cette option. Le montant est saisi par véhicule à la réception et y reste figé.",
    franchiseRequiredLabel: "Franchise à la réception",
    franchiseRequiredToggle: "Exiger l'information de franchise à la réception",
    kindBusiness: "Professionnel",
    kindIndividual: "Particulier",
    kindInsurer: "Assureur",
    loading: "Chargement…",
    managerPctHint:
      "Vide = le % de la fiche du responsable (professionnel ou particulier). À remplir seulement pour une exception de ce client ; pris sur la part de l'entreprise.",
    managerPctPlaceholder: "standard du chantier",
    newBtn: "Nouveau client",
    next: "Suivant",
    noAccess: "Vous n'avez accès à aucune société.",
    openLink: "ouvrir",
    pageMid: "sur",
    pagePre: "Page",
    parcCarsHelp:
      "Catégories à prix fixe (client, débosselage, montage). Sur le portail, quand le véhicule n'a pas de devis, le technicien choisit la catégorie et saisit marque et modèle.",
    parcCarsTitle: "Véhicules de parc",
    parcClosed: "clôturé",
    parcDefaultName: "Véhicules de parc",
    parcEditCategories: "Configurer les catégories",
    parcEnableBtn: "Activer les véhicules de parc",
    parcOpen: "ouvert",
    placeholderEx20: "ex : 20",
    placeholderEx30: "ex : 30",
    portalUserHint:
      "Lie un compte avec le rôle 'Client (portail)' — il voit l'agenda du chantier de ce client et planifie des véhicules.",
    portalUserNone: "— aucun —",
    prev: "Précédent",
    proLooksIndividual:
      "Professionnel sans SIRET, sans TVA et sans remise : s'agit-il d'un particulier ? Si c'est une personne physique, choisissez Particulier (remise 0 %). Sans remise, le Gestion ne calcule pas la commission des techniciens en base devis pour ce client.",
    purgeBtn: "supprimer",
    purgeBtnTitle:
      "Supprimer le client avec ses dossiers VIERGES et véhicules (super admin ; bloqué s'il y a facture/ligne/proforma)",
    purgeConfirmMsg:
      "Ceci supprime le client, ses dossiers SANS mouvement (ni ligne, facture, proforma ou achat) et les véhicules sans autres dossiers. Au moindre mouvement, rien n'est supprimé. Prévu pour annuler un import dans la mauvaise société. Continuer ?",
    purgeDoneDossiers: "dossier(s) supprimé(s)",
    purgeDoneTitle: "Client supprimé",
    purgeDoneVehicles: "véhicule(s) supprimé(s)",
    purgeReasonPlaceholder: "Ex. : import de devis dans la mauvaise société",
    purgeReasonTitle: "Motif de la suppression",
    purgeTitle: "Supprimer le client",
    reactivate: "Réactiver",
    reasonPlaceholder: "Obligatoire lors de la modification des données fiscales",
    save: "Enregistrer",
    saving: "Enregistrement…",
    searchLabel: "Rechercher",
    searchPlaceholder: "Nom, e-mail, identifiant fiscal…",
    statusActive: "Actifs",
    statusAll: "Tous",
    statusInactive: "Inactifs",
    statusLabel: "Statut",
    totalLabel: "Total",
    tvaExemptOption: "Exonéré / hors champ d'application",
    tvaHelpApplies: "Taux appliqué sur la facture (ex : 20% débosselage FR).",
    tvaHelpExempt: "Exonéré / hors champ : TVA 0%, sans mention d'autoliquidation.",
    tvaHelpReverse:
      "Autoliquidation : TVA 0% + mention légale sur la facture (TVA due par le preneur, intra-UE B2B). Ex. : Brazilian Storms OÜ → Euro Storm.",
    tvaReverseChargeOption: "Autoliquidation (reverse-charge, intra-UE B2B)",
    typeAll: "Tous les types",
    typeLabel: "Type",
  },
  dashboard: {
    accessBtn: "Accéder",
    actionInformFranchise: "Renseigner la franchise",
    actionInvoiceNow: "Facturer maintenant",
    allCaughtUp: "Tout est à jour",
    amendedInvoicesSub:
      "Le devis a changé après l'émission ; la facture a été refaite sous le même numéro",
    amendedInvoicesSuf: "factures modifiées — à renvoyer au client",
    awaitingReconciliationSuf: "transactions en attente de rapprochement",
    bankReconciliation: "Rapprochement bancaire",
    bankStatement: "Relevé bancaire",
    carWord: "véhicule",
    cardFranchise: "Franchise non renseignée",
    cardToInvoice: "Véhicules à facturer",
    carsWord: "véhicules",
    chantierNoEnd: "sans date de fin",
    chantierStartsPre: "Commence le",
    chantierUntilPre: "jusqu'au",
    chantiersBarHint: "Barre = véhicules livrés sur le total du chantier.",
    chantiersEmpty: "Aucun chantier actif.",
    chantiersTitle: "Chantiers en cours",
    chipAll: "Tous",
    chipPending: "En attente",
    chipToInvoice: "À facturer",
    colDate: "Date",
    colGarage: "Garage",
    colGross: "Brut",
    colProfit: "Bénéfice",
    colRef: "Réf.",
    colStatus: "Statut",
    colTechnician: "Technicien",
    colVehicle: "Véhicule",
    commissionsNotComputed: "commissions non calculées",
    degarnHint:
      "Véhicules déjà réparés (PDR terminé) dont le dégarnissage du devis n'est pas saisi ou pas terminé. Non saisi, son montant reste hors de la facture et du paiement du technicien.",
    degarnNoLine: "non saisi",
    degarnOpen: "non terminé",
    degarnOpenList: "Voir les véhicules",
    degarnOutOfInvoicePre: "hors facture :",
    degarnTitle: "Dégarnissage non finalisé",
    degarnTotalPre: "Dégarnissage en attente au devis :",
    dossiersCommissionsSuf: "dossiers — commissions",
    dossiersPayoutTechnicianSuf: "dossiers — à reverser au technicien",
    dossiersSuf: "dossiers",
    einvoiceLine:
      "Réception via PDP : depuis le 01/09/2026 · Émission obligatoire (ES) : 01/09/2027",
    emptyDossiers: "Aucun dossier",
    feedClaim: "Véhicule pris dans le portail",
    feedCreditNote: "Avoir créé",
    feedDelivery: "Livraison enregistrée",
    feedDerogation: "Dérogation appliquée",
    feedDevisEdit: "Devis modifié",
    feedDevisImport: "Devis importé par le portail",
    feedDocUpload: "Document de réception envoyé",
    feedEmailSent: "E-mail envoyé",
    feedEmpty: "Rien d'enregistré aujourd'hui pour l'instant.",
    feedInvoiceCancelled: "Facture annulée",
    feedInvoiceIssued: "Facture émise",
    feedInvoiceReissued: "Facture réémise",
    feedMarkPaid: "Paiement marqué",
    feedOfficeLaunch: "Technicien affecté par le bureau",
    feedReception: "Réception enregistrée",
    feedTitle: "Arrivé aujourd'hui",
    feedWiseFail: "Synchronisation Wise échouée",
    feedWiseOk: "Relevé Wise synchronisé",
    feedWorkOk: "travail approuvé",
    feedWorkReserves: "avec réserves",
    filters: "Filtres",
    fiscalYearLabel: "exercice",
    greetingAfternoon: "Bon après-midi",
    greetingEvening: "Bonsoir",
    greetingMorning: "Bonjour",
    importEdsp: "Importer eDSP",
    inFiscalYear: "sur l'exercice",
    invoicedMinusCommissionsPre: "facturé − commissions",
    itemsSuf: "éléments",
    kpiGrossProfit: "Bénéfice brut",
    kpiOpenDossiers: "Dossiers ouverts",
    kpiReceivable: "À recevoir",
    kpiReceived: "Déjà reçu",
    kpiRevenue: "Chiffre d'affaires (exercice)",
    kpiTechPayouts: "À reverser aux techniciens",
    moreCustomersSuf: "autres clients",
    needsYouTitle: "À traiter",
    newDossier: "Nouveau véhicule",
    nothingPending: "Rien en attente",
    nothingPendingLine: "Rien en attente.",
    ofInvoiced: "du facturé",
    open: "Ouvrir",
    openInvoicesSuf: "factures en cours",
    overdue: "En retard",
    overdueInvoices: "Factures en retard",
    overdueSuf: "échus",
    payableTechnicians: "À payer (techniciens)",
    pendingCustomerAction: "Confirmer sur la fiche du véhicule",
    pendingCustomerTitle: "Le client du devis a changé",
    pendingPlural: "éléments en attente",
    pendingSingular: "élément en attente",
    period12m: "12 m",
    periodMonth: "Mois",
    periodYear: "Exercice",
    receivableCustomers: "À recevoir (clients)",
    receivedToPaySuf: "reçu, à payer",
    recentDossiers: "Dossiers récents",
    reconciledSuf: "rapprochées",
    statusInvoiced: "Facturé",
    statusPending: "En attente",
    statusReview: "Révision",
    supplierInvoicesSuf: "factures fournisseurs",
    techApplicationsHint: "en attente de votre validation",
    techApplicationsOneSuf: "candidature de technicien",
    techApplicationsSuf: "candidatures de technicien",
    techPayoutsBlockedHint: "en attente du paiement client",
    techPayoutsEmpty: "Aucun technicien à payer",
    techPayoutsOthersPre: "+",
    techPayoutsOthersSuf: "autres techniciens",
    techPayoutsPayNow: "en caisse — à payer maintenant",
    techPayoutsReleasedHint: "reçu du client — débloqué",
    techPayoutsTechCountSuf: "techniciens à payer",
    techPayoutsTechCountSufSingular: "technicien à payer",
    tileActiveChantiers: "Chantiers actifs",
    tileOpenCars: "Véhicules en cours",
    tilePendingDeliveries: "Livraisons en attente",
    tileToInvoice: "À facturer · HT",
    tilesAria: "Indicateurs",
    title: "Tableau de bord",
    toInvoice: "à facturer",
    toInvoiceMoreCustomers: "autre(s) client(s)",
    toInvoiceSeeAll: "Voir tout",
    toInvoiceShowLess: "Afficher moins",
    toInvoiceTitle: "Il y a des véhicules à facturer",
    toPaySuf: "à payer",
    todoTitle: "À faire",
    treasuryTitle: "Trésorerie",
    unreconciledTxSuf: "transactions non rapprochées",
    unsentCardAction: "Envoyer",
    unsentCardTitle: "Factures non envoyées",
    viewAll: "Voir tout",
    weekPre: "semaine",
  },
  devisPage: {
    colCustomer: "Client",
    colDevis: "N° de devis",
    colImpacts: "Impacts",
    colStage: "Situation",
    colTotal: "Total HT",
    colVehicle: "Véhicule",
    countSuffix: "devis",
    empty: "Aucun devis avec ces filtres.",
    filterSearch: "Rechercher",
    filterStage: "Étape",
    pageTitle: "Devis",
    searchPlaceholder: "Client, plaque ou n° de devis…",
    stageAll: "Tous",
    stageDevis: "Devis",
    stageInvoiced: "Facturé",
    stageRepairing: "En réparation",
    withDegarnissage: "avec dégarnissage",
  },
  dossierDetail: {
    activityBadge: "Activité · 100% maison",
    activityCost: "Coût (HT)",
    activityMargin: "Marge",
    activityTypeLabel: "Type d'activité",
    addPaymentBtn: "+ Paiement",
    addReceiptBtn: "+ Encaissement",
    addServiceLineTitle: "Ajouter une ligne de service",
    amountEuro: "Montant (€)",
    amountMustBePositive: "Le montant doit être > 0.",
    amountPositiveShort: "Montant > 0.",
    appliedLabel: "Appliqué",
    approveInvoice: "approuver la facture",
    approveLower: "approuver",
    auditLogTitle: "Journal d'audit du dossier",
    auditRequiresAdmin: "Le journal d'audit requiert la permission admin.",
    autoCalculatedTitle: "Calculé automatiquement",
    avoirBtn: "Avoir",
    avoirBtnTitle: "Faire un avoir sur cette facture : complet ou partiel, avec motif",
    avoirCancelledTag: "annulé",
    avoirEmbeddedTag: "déjà déduit dans la facture",
    avoirWord: "Avoir",
    avoirsEffective: "Avoirs (absorbés par la maison)",
    avoirsLabel: "Avoirs",
    avoirsNotePre: "Avoirs de ce véhicule, déduits du résultat de la maison :",
    avoirsSplit: "réparti entre les véhicules de la facture",
    backShort: "← Liste",
    backToList: "← Retour à la liste",
    balance: "Solde",
    bankAccountOptional: "Compte bancaire (facultatif)",
    base: "Base",
    baseAfterFranchise: "Base après franchise",
    baseBudget: "Devis (Prix Brut)",
    baseInvoiced: "Facturé (Total Facture)",
    bruteCheck: "Vérification brute",
    calcAndPromote: "Calculer et promouvoir",
    calcBase: "Base de calcul",
    calcCommissionBtn: "⚠ Calculer la commission",
    calcCommissionTitle:
      "Ligne sans cascade calculée — cliquez pour définir les % client/technicien/intermédiaire",
    calcLineCommissionTitle: "⚠ Calculer la commission de la ligne",
    cancel: "Annuler",
    cancelIcTitle: "Annuler l'IC",
    cancelInvoiceMsg: "Annulation avec effet fiscal. Réversible via une réémission.",
    cancelInvoiceTitle: "Annuler la facture",
    cancelLineBtn: "Annuler la ligne",
    cancelLineMsg:
      "La ligne disparaît de la liste du technicien, de son paiement et de sa facture, et la prestation sort de la base de la facture client (si la maison doit encore la facturer, affectez un autre technicien). Irréversible. Indiquez le motif.",
    cancelLineTitle: "Annuler la ligne de service",
    cancelLower: "annuler",
    cascadeClient: "Client",
    cascadeIntermediary: "Intermédiaire",
    cascadeTechnician: "Technicien",
    cascadeTitle: "Cascade de commission",
    chantierDelivery: "Livraison",
    chantierDeliveryNa:
      "sans objet hors chantier (le véhicule compte comme livré à la facturation)",
    chantierFranchiseAmountPh: "Montant TTC",
    chantierFranchiseCancel: "Annuler",
    chantierFranchiseEdit: "Corriger",
    chantierFranchiseHas: "Ce véhicule a une franchise",
    chantierFranchiseHint:
      "La remise est recalculée sur le montant plein du devis et reste dans le journal d'audit.",
    chantierFranchisePre: "Franchise à déduire :",
    chantierFranchisePreParticular: "Franchise (client particulier) :",
    chantierFranchiseReasonPh: "Motif de la correction (obligatoire)",
    chantierFranchiseSave: "Enregistrer la franchise",
    chantierFranchiseSaving: "Enregistrement…",
    chantierFranchiseSuf: "— à déduire de la facture client ou générer un avoir.",
    chantierFranchiseSufParticular:
      "— la facture reste entière ; la franchise réduit seulement la base des commissions. Remise au client : uniquement par avoir.",
    chantierNoFranchise: "Réception sans franchise.",
    chantierPendingWord: "en attente",
    chantierReception: "Réception",
    chantierSectionTitle: "Chantier (chef de projet)",
    chantierWorkOkNo: "⚠ Travail avec réserves",
    chantierWorkOkYes: "✓ Travail contrôlé et approuvé",
    chgCustAtelier: "Atelier",
    chgCustBlocked: "Impossible de changer le client :",
    chgCustBtn: "Changer de client ou d'atelier",
    chgCustChoose: "— choisir le client —",
    chgCustColInvoiced: "À facturer",
    chgCustColRemise: "Remise",
    chgCustColService: "Service",
    chgCustColTech: "Technicien",
    chgCustColTechAmount: "Part technicien",
    chgCustCurrent: "Client actuel",
    chgCustDone: "Client changé — lignes, franchise et ordre de réparation recalculés.",
    chgCustImpact: "Ce qui change avec le nouveau client",
    chgCustNew: "Nouveau client",
    chgCustNoAtelier: "— sans atelier —",
    chgCustOnlyAtelier: "client actuel (changer seulement l'atelier)",
    chgCustReason: "Motif (gardé dans l'audit)",
    chgCustSave: "Changer de client",
    chgCustSearchPh: "Rechercher par nom…",
    chgCustTitle: "Changer le client ou l'atelier du dossier",
    clientPctRange: "Le % Client doit être compris entre 0 et 100.",
    clientRetainedPre: "Client a retenu",
    colAction: "Action",
    colBy: "Par",
    colReasonDetails: "Motif / détails",
    colWhen: "Quand",
    commBlockProSemRemise:
      "Pas de commission : le client est enregistré comme Professionnel sans remise. Indiquez la remise dans la fiche client ou, s'il s'agit d'une personne physique, passez le type à Particulier. Cliquez ensuite sur « Calculer la commission ».",
    commBlockSemPar:
      "Pas de commission : le technicien n'a pas de paire avec ce client (ni avec l'atelier ou le chantier). Configurez la paire puis cliquez sur « Calculer la commission ».",
    companyLabel: "Société",
    companyShort: "Sté",
    complementaryRequiresValues:
      "Le modèle complémentaire exige que le devis et le facturé soient renseignés.",
    create: "Créer",
    createIcDraftBtn: "+ Créer un brouillon IC",
    createIcDraftTitle: "Créer un brouillon IC",
    createTechInvoicesFirst: "Créez des factures de technicien avant d'enregistrer des paiements.",
    createsNegativeMirror: "Crée une écriture miroir avec un montant négatif.",
    creating: "Création…",
    customerEffective: "Client effectif",
    customerInvoicesTitle: "Factures pour le client",
    customerPct: "Client pct",
    dateTime: "Date/heure",
    degarnAlertHint:
      "Le véhicule compte comme réparé (PDR terminé), mais personne n'a enregistré qui a déposé et reposé. Tant que ce n'est pas saisi, le montant du dégarnissage reste hors de la facture et du paiement du technicien. À saisir dans le portail (technicien ou monteur, ou « fait par le garage »).",
    degarnAlertOpenHint:
      "Le véhicule compte comme réparé (PDR terminé). Le dégarnissage a été pris, mais la dépose ou la repose n'est pas marquée faite. Le montant est déjà dans la facture ; il reste à terminer les étapes dans le portail.",
    degarnAlertTitle: "Dégarnissage non finalisé",
    degarnLaunchBtn: "👷 Lancer le dégarnissage",
    degarnLaunchTabHint: "Le devis a un dégarnissage pas encore entièrement enregistré.",
    degarnLaunchTitle: "Lancer le dégarnissage",
    deletedTitle: "Supprimé",
    deliveryDerogBtn: "Marquer livré (dérogation)",
    deliveryDerogConfirm: "Marquer livré",
    deliveryDerogMessage:
      "Le véhicule passe à « livré » sans le contrôle du chantier. Indiquez le motif (conservé dans l'audit).",
    deliveryDerogTitle: "Enregistrer la livraison sans les photos du gérant",
    deposeReposeLabel: "Dépose/Repose",
    derogBtn: "Libérer la réparation sans réception",
    derogConfirm: "Confirmer la libération",
    derogHint: "Super admin uniquement. Sans réception, aucune franchise n'est enregistrée.",
    derogNoReception:
      "Véhicule sans réception : les techniciens ne peuvent pas le prendre avant la réception. En cas exceptionnel, libérez ici.",
    derogReasonPh: "Motif (obligatoire — reste dans l'historique)",
    derogReleased: "Réparation libérée sans réception",
    derogTitle: "Libération de la réparation",
    devisClassCol: "Classe",
    devisImpactsCol: "Impacts",
    devisMethodCol: "Méthode",
    devisNoteCol: "Remarque",
    devisOriginalBtn: "PDF d'origine",
    devisOriginalHint:
      "Ouvre le PDF du devis tel qu'il a été reçu (portail technicien, e-mail devis@ ou import du bureau).",
    devisOriginalLatest: "la plus récente",
    devisOriginalVersions: "versions",
    devisPanelCol: "Élément",
    devisSectionTitle: "Devis (eDSP)",
    downloadInvoicePdfTitle: "Télécharger le PDF de la facture",
    draftBannerOpen: "Ouvrir le brouillon",
    draftBannerPre: "Brouillon de facture en attente (pas encore émise)",
    draftBannerReplaces: "remplace la facture annulée",
    dueDate: "Échéance",
    dueQuick15: "15 jours",
    dueQuick30: "30 jours",
    dueQuick60: "2 mois",
    dueQuick7: "1 semaine",
    editActivityBtn: "Modifier l'activité",
    editActivityTitle: "Modifier la ligne d'activité",
    editCommission: "Modifier la commission",
    editDevisAddOther: "Autre poste",
    editDevisAddPanel: "Ajouter un élément",
    editDevisAmounts: "Montants",
    editDevisBlockedInvoice:
      "Facture déjà émise : impossible de lancer un technicien sur ce véhicule. Pour changer les montants, utilisez Modifier le devis (la facture est refaite sous le même numéro).",
    editDevisBtn: "Modifier le devis",
    editDevisDoneCreated: "ligne(s) créée(s)",
    editDevisDoneLines: "ligne(s) recalculée(s)",
    editDevisDoneOr: "Ordre de réparation mis à jour",
    editDevisDoneRemoved: "ligne(s) supprimée(s)",
    editDevisDoneTitle: "Devis mis à jour",
    editDevisDoneTotalPre: "Nouveau total HT :",
    editDevisHint:
      "Le devis est le point de départ : à l'enregistrement, les lignes de service, les commissions, la franchise et l'ordre de réparation sont recalculés.",
    editDevisInvoiceAmended: "refaite sous le même numéro",
    editDevisInvoiceConfirm:
      "Continuer ? La facture sera refaite sous le même numéro et marquée « à renvoyer au client ».",
    editDevisInvoiceNote:
      "Ce véhicule a déjà une facture émise. À l'enregistrement, la facture est refaite sous le MÊME numéro et pour le même client ; la version précédente est conservée et elle est marquée « à renvoyer au client ».",
    editDevisInvoiceResend: "renvoyez-la au client",
    editDevisPanels: "Éléments",
    editDevisReason: "Motif de la modification",
    editDevisRemiseExc: "Remise exceptionnelle (HT)",
    editDevisRemiseExcHint:
      "Apparaît sur la facture comme « Remise exceptionnelle » et baisse le montant à facturer de l'ordre de réparation. Ne change pas les commissions.",
    editDevisSave: "Enregistrer et recalculer",
    editDevisTitle: "Modifier le devis",
    editLineCommissionTitle: "Modifier la commission de la ligne",
    edspNonBank: "eDSP · non bancaire",
    edspReceiptTitle:
      "Encaissement importé depuis eDSP — il ne provient pas du relevé bancaire (non rapproché en banque). Le montant peut être le brut, non le net reçu.",
    emailBtn: "📧 E-mail",
    emailLabel: "E-mail",
    emailPlaceholder: "client@exemple.com",
    errorGeneratingPdf: "Erreur lors de la génération du PDF",
    errorSending: "Erreur lors de l'envoi",
    errorTitle: "Erreur",
    eurostormEffective: "Eurostorm effectif",
    eurostormPct: "Eurostorm pct",
    expected100: "attendu 100 %",
    fieldAtelier: "Atelier",
    fieldBillingCompany: "Société de facturation",
    fieldCustomer: "Client",
    fieldDate: "Date",
    fieldEndCustomer: "Client final",
    fieldInvoiceStatus: "Statut facture",
    fieldInvoices: "Facture(s)",
    fieldLines: "Lignes",
    fieldReceivingCompany: "Société bénéficiaire",
    fieldRepair: "Réparation",
    fieldVehicle: "Véhicule",
    fixedClearBtn: "Effacer (revenir à la paire)",
    fixedDspLabel: "PDR — le technicien reçoit (€ HT)",
    fixedEditBtn: "Modifier",
    fixedFollowPair: "vide = suit la paire",
    fixedHint:
      "Exception à la paire, pour ce véhicule seulement : vaut pour qui le prend (aussi avant que le technicien le prenne sur le portail). Qui prend le PDR reçoit le fixe du PDR ; qui démonte/monte reçoit le fixe du dégarnissage (moitiés 50/50). Seule la part du technicien change — remise client et intermédiaire suivent la paire, la maison garde le reste. La franchise, saisie par le technicien comme d'habitude, n'affecte que la facture du client : elle ne réduit pas le fixe. Confidentiel : sur le portail le technicien voit seulement « Votre commission », sans savoir qu'elle est fixe. Laissez vide pour suivre la paire.",
    fixedMontageLabel: "Dégarnissage — le technicien reçoit (€ HT)",
    fixedMontageShort: "Dégarnissage",
    fixedNone:
      "Par défaut : le technicien est payé selon la paire technicien × client. Montant fixe seulement en exception, défini ici.",
    fixedSaveBtn: "Enregistrer le montant fixe",
    fixedSetBtn: "Définir un montant fixe (exception)",
    fixedTechAmountHint:
      "Le technicien reçoit exactement ce montant ; le % est dérivé et la maison absorbe la différence. Reste un ajustement manuel (les recalculs automatiques n'y touchent pas).",
    fixedTechAmountLabel: "Montant fixe du technicien (€ HT) — optionnel",
    fixedTechAmountPh: "ex. : 1200",
    fixedTitle: "Montant fixe du technicien pour ce véhicule",
    fixedTopBtn: "Montant fixe",
    fixedTopHint:
      "Montant fixe du technicien pour ce véhicule (exception à la paire) — visible par l'admin seulement",
    franchiseAddBtn: "Saisir la franchise",
    franchiseCommissionsOnlyBadge: "exception : facture entière",
    franchiseCommissionsOnlyHint:
      "Règle normale du Professionnel : la franchise réduit la facture et les commissions. Coché, seules les commissions des techniciens sont réduites, comme pour un Particulier.",
    franchiseCommissionsOnlyLabel:
      "Exception : franchise uniquement sur les commissions (facture entière)",
    franchiseNoReception: "Véhicule sans réception enregistrée — franchise non renseignée.",
    franchiseSectionTitle: "Franchise",
    impactsWord: "impacts",
    intercompanyEffective: "Intercompany effectif",
    intercompanyInvoicesTitle: "Factures intercompany",
    intermediary: "Intermédiaire",
    intermediaryEffective: "Intermédiaire effectif",
    intermediaryPct: "Intermédiaire pct",
    intermediaryPctRange: "Le % Intermédiaire doit être compris entre 0 et 100.",
    internalCodePre: "n° interne",
    invalidEmail: "Saisissez une adresse e-mail valide.",
    invalidId: "ID invalide.",
    invoiceIssuedOnPre: "émise le",
    invoiceNumberField: "N° facture (facultatif — auto si vide)",
    invoiceNumberPlaceholder: "F2026-00001 (automatique si vide)",
    invoiceReceivedOnPre: "reçue le",
    invoiceSentTo: "Facture envoyée à",
    invoiced: "Facturé",
    invoicesNone: "aucune émise",
    issue: "Émettre",
    issueCustomerInvoiceTitle: "Émettre la facture client",
    issueInvoiceBeforeReceipts:
      "Émettez une facture dans le dossier avant d'enregistrer des encaissements.",
    issueInvoiceBtn: "+ Émettre une facture",
    issueLower: "émettre",
    issuer: "Émetteur",
    issuerCompany: "Société émettrice",
    issuing: "Émission…",
    launchTechBtn: "Affecter un technicien",
    launchTechCancel: "Annuler",
    launchTechChoice: "Ce qu'il a fait",
    launchTechChoose: "— choisir le technicien —",
    launchTechClose: "Fermer",
    launchTechDone: "Véhicule déjà réparé (PDR terminé et étapes faites)",
    launchTechHint:
      "Même règle que le portail : commission selon la paire technicien × client, carrosserie et pièces 100 % maison, franchise et ordre de réparation. Sans réception, le Super Admin débloque par dérogation avec le motif.",
    launchTechMontage: "Dépose et repose seules",
    launchTechOk: "Technicien affecté au véhicule.",
    launchTechPdr: "PDR seul",
    launchTechPdrMontage: "PDR + dépose et repose",
    launchTechReason: "Motif",
    launchTechSubmit: "Affecter",
    launchTechTech: "Technicien",
    launchTechTitle: "Affecter un technicien au véhicule",
    legacyHintPre: "Ligne legacy sans cascade — prérempli depuis le couple technicien×client",
    legacyHintSuf: "Ajustez et enregistrez pour promouvoir.",
    lineStatusApproved: "approuvée",
    lineStatusCancelled: "annulé",
    lineStatusNotApplicable: "non applicable",
    lineStatusPaid: "payé",
    lineStatusPending: "en attente",
    lineStatusProformaIssued: "proforma émise",
    lineStatusReceived: "reçue",
    lineStatusRejected: "refusée",
    lineTakenOnPre: "pris le",
    linesEmpty:
      "Aucune ligne. Les lignes sont créées automatiquement lors de l'import des dossiers depuis eDSP.",
    linesTotalTitle: "Total du dossier",
    loading: "Chargement…",
    managerAmount: "Commission du gérant",
    managerBase: "Base (PDR + dégarnissage après franchise)",
    managerCancelBtn: "Annuler",
    managerCardTitle: "Gérant du chantier",
    managerDefaultWas: "standard",
    managerDeliveredPre: "Compte dans le mois de la livraison enregistrée le",
    managerEditBtn: "Modifier",
    managerEditHint: "Pour ce véhicule seulement ; pris sur la part de l'entreprise.",
    managerEffective: "Gérant effectif",
    managerFixedWord: "fixe",
    managerHint:
      "Sur PDR + dégarnissage ; prise sur la part maison, ne change ni le technicien ni le client. Même calcul que le reversement du portail du gérant.",
    managerModeDefault: "Standard",
    managerModeFixed: "Montant fixe (€ HT)",
    managerModePct: "Pourcentage",
    managerNotDelivered:
      "En attente de l'enregistrement de la livraison par le gérant — sans lui, la commission ne compte dans aucun mois.",
    managerOverrideLabel: "Exception pour ce véhicule",
    managerPctEquiv: "% équivalent",
    managerPctOverride: "% (exception du véhicule)",
    managerPctParticular: "% particulier",
    managerPctPro: "% professionnel",
    managerPreview: "Le gérant reçoit",
    managerReasonPh: "Motif (obligatoire)",
    managerSaveBtn: "Enregistrer",
    markInvoiceReceived: "marquer la facture reçue",
    markPaid: "marquer payé",
    markPaidInvoice: "marquer payée",
    markReceived: "marquer reçue",
    method: "Méthode",
    methodCard: "Carte",
    methodCash: "Espèces",
    methodCheck: "Chèque",
    methodOther: "Autre",
    methodTransfer: "Virement",
    model: "Modèle",
    modelComplementary: "Complémentaire (F8)",
    modelLegacy: "Legacy (actuel)",
    moreBtn: "Plus",
    netAfterAvoirPre: "net après avoir",
    netInvoicedLabel: "Facturé net",
    netSuffix: "(net)",
    newReceiptTitle: "Nouvel encaissement",
    newTechnicianPaymentTitle: "Nouveau paiement au technicien",
    noCustomerEmailWarn: "⚠ Client sans e-mail enregistré — saisissez une adresse ci-dessus.",
    noEvents: "Aucun événement.",
    noIcCandidateTitle:
      "Aucune ligne n'a une responsible_company différente de la billing_company.",
    noIcForDossier: "Aucune IC pour ce dossier.",
    noInvoicesYet: "Aucune facture émise pour l'instant.",
    noPayments: "Aucun paiement.",
    noReceipts: "Aucun encaissement enregistré.",
    noTechnicianInvoices: "Aucune facture de technicien ne couvre encore de lignes de ce dossier.",
    noneOption: "— aucun —",
    notFound: "Dossier introuvable dans les sociétés accessibles.",
    notesLabel: "Notes",
    onDate: "Le",
    onPrixBrut: "sur Prix Brut",
    openBalance: "Solde ouvert",
    overrideApplied: "Override appliqué",
    overrideLabel: "Override",
    payment: "Paiement",
    payoutEffective: "À reverser (technicien + intermédiaire)",
    pctLabel: "Pourcentage",
    pdfAutoAttachHint:
      "Le PDF de la facture sera généré/mis à jour et joint automatiquement. L'e-mail est envoyé avec l'expéditeur de la société émettrice configuré dans SMTP.",
    pendingCustomerKeep: "Garder",
    pendingCustomerNow: "le véhicule est aujourd'hui chez",
    pendingCustomerPre: "Devis renvoyé avec un autre client :",
    pendingCustomerSwitch: "Passer à",
    phaseDemontage: "Démontage",
    phaseExternal: "tiers (garage)",
    phaseMontage: "Montage",
    phasePdrDone: "PDR terminé",
    phasePdrOpen: "PDR en cours",
    portalDoc_carte_grise: "Carte grise",
    portalDoc_cnh: "Permis de conduire",
    portalDoc_expertise: "Rapport d'expertise",
    portalDoc_outro: "Autre document",
    portalFilesHint:
      "Envoyés par le portail du chef de chantier et des techniciens (réception, livraison et repose). Touchez la photo pour l'ouvrir en taille réelle.",
    portalFilesTitle: "Documents et photos des portails",
    portalOpenBtn: "Ouvrir",
    portalPhotosDelivery: "Photos de livraison",
    portalPhotosMontage: "Photos de dépose",
    portalPhotosMontageEnd: "Photos de repose",
    portalPhotosReception: "Photos de réception",
    quote: "Devis",
    reasonInline: "· motif :",
    reasonRequired: "Motif obligatoire.",
    reassignBtn: "Réattribuer",
    reassignDemontageDone: "Démontage terminé",
    reassignDemontageExternal:
      "Démontage fait par un tiers (garage) — personne chez ES/BS n'est payé",
    reassignDemontageLabel: "Démontage (titulaire de la ligne)",
    reassignDspDone: "PDR terminé",
    reassignExternalHint:
      "La moitié externe compte comme faite (le véhicule se clôture), n'entre pas dans la facture du client et personne du groupe n'est payé pour elle.",
    reassignHint:
      "La commission est recalculée selon le binôme du nouveau technicien avec le client. Sans binôme, la ligne reste legacy jusqu'au recalcul par le bureau. Les étapes déjà terminées sont conservées.",
    reassignMontageDone: "Montage terminé",
    reassignMontageExternal: "Montage fait par un tiers (garage) — personne chez ES/BS n'est payé",
    reassignMontageLabel: "Montage",
    reassignPdrLabel: "Technicien du PDR",
    reassignReasonLabel: "Motif (obligatoire)",
    reassignReasonMin: "Saisissez au moins 3 lettres pour activer le bouton.",
    reassignSameAsOwner: "Même technicien que le démontage",
    reassignSave: "Réattribuer",
    reassignTitle: "Réattribuer le technicien",
    reassignWorkState: "État du travail",
    receiptsByInvoiceTitle: "Encaissements par facture",
    received: "Reçu",
    receiver: "Destinataire",
    receiverBillingCompany: "Destinataire (billing_company)",
    recipient: "Destinataire",
    reference: "Référence",
    register: "Enregistrer",
    rejectInvoice: "rejeter la facture",
    rejectLower: "rejeter",
    rejectTechnicianInvoiceTitle: "Rejeter la facture technicien",
    repairEdspOrderPre: "ordre eDSP du",
    requestProformaBtn: "Demander une proforma au technicien",
    requestProformaTitle:
      "Avancer le paiement du technicien : la proforma ne dépend ni de la facture ni de l'encaissement client.",
    responsibleCompany: "Société responsable",
    responsibleCompanyRequired: "La société responsable est obligatoire.",
    retentionFromPairNote:
      "Remise du client définie dans la paire technicien × client (somme des lignes).",
    retentionPctVaries: "varie selon la ligne",
    reversalOf: "contre-passation de",
    reverseLower: "contre-passer",
    reversePaymentTitle: "Contre-passer le paiement",
    reverseReceiptTitle: "Contre-passer l'encaissement",
    roAddMontageAmount: "Montant du dégarnissage (HT)",
    roAddMontageBtn: "Lancer le montage du devis",
    roAddMontageConfirm: "Lancer",
    roAddMontageExternal: "Fait par un tiers (garage) — personne chez ES/BS n'est payé",
    roAddMontageHint:
      "Le devis a un dégarnissage mais personne n'a pris le montage sur le portail. Choisissez qui l'a fait (ou cochez tiers), confirmez le montant et les étapes faites.",
    roAddMontageTech: "Technicien (démontage et montage)",
    roAddMontageTitle: "Lancer la ligne de montage (dégarnissage du devis)",
    roAmount: "Montant à facturer HT",
    roClientPo: "N° de bon de commande client",
    roComment: "Commentaire",
    roCreateBtn: "Créer l'ordre",
    roDevisAmount: "Devis HT",
    roEditBtn: "Modifier",
    roEditHint:
      "Baisser le montant génère une remise exceptionnelle sur la facture. Possible uniquement avant facturation.",
    roEmpty: "L'ordre naît quand le technicien prend le véhicule dans le portail.",
    roIncompleteAsk: "Facturer quand même ?",
    roIncompleteConfirm: "Facturer quand même",
    roIncompleteTitle: "Le véhicule n'est pas terminé",
    roInitialAmount: "Montant initial HT",
    roInvoicedLocked: "Véhicule déjà facturé — l'ordre est figé.",
    roMissingDelivery: "livraison en attente",
    roMissingDsp: "débosselage manquant",
    roMissingMontage: "montage en attente",
    roMissingMontagePhases: "le monteur n'a pas fini",
    roReady: "Prête à facturer",
    roRemise: "Remise exceptionnelle",
    roSectionTitle: "Ordre de réparation",
    roSplitDegBtn: "Dégarnissage fait par le technicien lui-même",
    roSplitDegConfirm: "Scinder et marquer terminé",
    roSplitDegMsgPre:
      "La ligne PDR inclut le dégarnissage du devis. La ligne de montage, déjà terminée, sera créée pour",
    roSplitDegMsgSuf:
      "Aucun montant ne change (client, technicien, maison, OR). Le PDR sera aussi marqué terminé. Indiquez le motif.",
    roSplitDegTitle: "Scinder la ligne PDR en PDR + montage",
    save: "Enregistrer",
    saveCommission: "Enregistrer la commission",
    saving: "Enregistrement…",
    sectionCustomerRetention: "Retenue du client",
    sectionHeader: "En-tête",
    sectionTotals: "Totaux agrégés",
    selectIssuer: "Sélectionnez l'émetteur.",
    selectPlaceholder: "— sélectionner —",
    selectTechnicianForCascade:
      "Sélectionnez un technicien pour modifier la cascade de commission.",
    send: "Envoyer",
    sendInvoiceEmailTitle: "Envoyer la facture par e-mail",
    sending: "Envoi…",
    serviceLinesTitle: "Lignes de service",
    serviceTypeMontage: "Montage/Démontage",
    serviceTypePeinture: "Carrosserie/Peinture",
    serviceTypePieces: "Pièces",
    softDeletedBadge: "supprimé",
    statusApproved: "approuvée",
    statusCancelled: "annulée",
    statusCustomerReceived: "encaissée",
    statusDraft: "brouillon",
    statusIssued: "émise",
    statusPaid: "payée",
    statusPending: "en attente",
    statusReceived: "reçue",
    statusRejected: "rejetée",
    statusReversed: "contre-passée",
    statusVoid: "nulle",
    suggestedFromDossierHint:
      "Suggéré depuis le dossier (conserve le format original d'eDSP — ne le modifiez pas si vous voulez que les encaissements du CSV correspondent à cette facture).",
    suggestedLabel: "Suggéré",
    suggestedNextHint: "Prochain numéro de la série — modifiable.",
    sumEquals: "Somme =",
    sumExceedsPre: "⚠ La somme des pourcentages dépasse 100 %.",
    sumExceedsSuf: "serait négatif.",
    sumMust100: "La somme des pourcentages doit être de 100 %",
    sumMust100Save: "La somme des pourcentages doit être de 100 % pour enregistrer.",
    tabAudit: "Audit",
    tabFaturacao: "Facturation client",
    tabFinanceiro: "Facturation et paiements",
    tabHistorico: "Historique et documents",
    tabIntercompany: "Intercompany",
    tabLinhas: "Lignes",
    tabRecebimentos: "Encaissements",
    tabResumo: "Résumé",
    tabServicos: "Services et techniciens",
    tabTecnicoFaturas: "Factures technicien",
    tabTecnicoPagamentos: "Paiements technicien",
    technician: "Technicien",
    technicianAmountKnown: "Montant du technicien connu",
    technicianAmountUnknownWarn: "Montant du technicien pas encore connu.",
    technicianEffective: "Technicien effectif",
    technicianInvoice: "Facture technicien",
    technicianInvoiceImportHint:
      "La facture du technicien est importée en la joignant à la proforma correspondante.",
    technicianInvoicesTitle: "Factures des techniciens (avec des lignes de ce dossier)",
    technicianPaymentsTitle: "Paiements aux techniciens",
    technicianPct: "Technicien pct",
    technicianPctRange: "Le % Technicien (override) doit être compris entre 0 et 100.",
    technicianRequired: "Le technicien est obligatoire.",
    thirdPartyNotBilledAll:
      "Démontage et montage faits par un tiers (garage) : ce dégarnissage n'entre pas dans la facture.",
    thirdPartyNotBilledHalf:
      "Une moitié faite par un tiers (garage) : seule la moitié faite par le groupe entre dans la facture.",
    tlActIssue: "Émettre la facture",
    tlActPayout: "Reverser au technicien",
    tlActReceipt: "Enregistrer l'encaissement",
    tlDelivered: "Livrée",
    tlDevis: "Devis",
    tlDone: "Terminé",
    tlInvoiced: "Facturée",
    tlMontage: "Montage",
    tlNoTech: "sans technicien",
    tlPayout: "Reversement technicien",
    tlPortal: "sur le portail",
    tlPortalHint: "Étape enregistrée sur le portail (technicien ou responsable).",
    tlReceived: "Encaissée",
    tlRepaired: "Réparée",
    tlTitle: "Où en est le véhicule",
    total: "Total",
    totalCustomerRetention: "Retenue client",
    totalIntercompanyInvoice: "Facture intercompany",
    totalIntermediaryCommission: "Commission intermédiaire",
    totalInvoiced: "Total facturé",
    totalNetUpper: "TOTAL NET",
    totalQuote: "Total devis",
    totalTechnicianCommission: "Commission technicien",
    totalUpper: "TOTAL",
    type: "Type",
    usingBillingEmailHint:
      "Utilisation de l'e-mail de facturation du client. Modifiez-le pour envoyer à un autre destinataire.",
    vehicleHistoryBtn: "Fiche du véhicule",
    vehicleOthersHint: "Ce véhicule a d'autres dossiers : ouvrez la fiche pour tous les voir.",
    voidInvoiceMsg: "Mise à nulle (void). Différent de l'annulation : sans effet fiscal.",
    voidInvoiceTitle: "Annuler (void) la facture",
    voidLower: "mettre à nulle",
  },
  dossierWizard: {
    addFirstLineHint: "(vous pourrez l'ajouter/la modifier plus tard dans le détail)",
    addFirstLineNow: "Ajouter la première ligne de service maintenant",
    back: "← Retour",
    cancel: "Annuler",
    commissionAmountKnown: "Montant de la commission connu",
    commissionUnknownValue: "montant inconnu (sera défini plus tard)",
    dupConfirmBtn: "C'est une nouvelle intervention — créer un autre dossier quand même",
    errAmountUnknownFieldsEmpty:
      "technicianAmountKnown=false : le pct, la base et le montant de la commission doivent rester vides.",
    errCommissionAmountMin: "Montant de la commission : ≥ 0.",
    errCommissionPctRange: "Commission % : entre 0 et 100.",
    errInvoicedMin: "Le facturé doit être ≥ 0.",
    errLineCreatePre: "Dossier créé, mais l'ajout de la première ligne a échoué",
    errLineCreateSuf: "Vous pouvez l'ajouter manuellement dans l'onglet « Lignes » du détail.",
    errQuoteMin: "Le devis doit être ≥ 0.",
    errResponsibleCompanyRequired: "La société responsable est obligatoire.",
    errRetentionRange: "Rétention du client : le % doit être compris entre 0 et 100.",
    errSelectBillingCompany: "Sélectionnez la société de facturation.",
    errSelectCustomer: "Sélectionnez le client.",
    errTechnicianRequired: "Le technicien est obligatoire.",
    errVehicleRequired: "Renseignez un véhicule, une plaque ou un VIN.",
    fieldBase: "Base",
    fieldBillingCompany: "Société de facturation",
    fieldCommissionPct: "Commission %",
    fieldCustomer: "Client",
    fieldCustomerRetention: "Rétention du client (%) — facultatif",
    fieldEffectiveAmountEur: "Montant effectif (€)",
    fieldExternalInvoiceNumber: "N° de facture externe (eDSP)",
    fieldInvoiceDate: "Date de la facture",
    fieldInvoicedEur: "Facturé (€)",
    fieldNotes: "Notes",
    fieldPlate: "Plaque",
    fieldQuoteEur: "Devis (€)",
    fieldReceivingCompany: "Société bénéficiaire (facultatif)",
    fieldResponsibleCompany: "Société responsable",
    fieldSelectVehicle: "Sélectionner le véhicule du client",
    fieldServiceType: "Type de service",
    fieldTechnician: "Technicien",
    fieldVin: "VIN",
    lineNotCreated: "(non créée)",
    loading: "chargement…",
    next: "Suivant →",
    noLineHint: "Vous pouvez ajouter des lignes à tout moment dans le détail du dossier.",
    optionAuto: "auto",
    optionBaseInvoiced: "facturé",
    optionBaseQuote: "devis",
    optionNoVehicleLink: "— sans lien (renseigner plaque/VIN ci-dessous) —",
    optionNone: "— aucune —",
    optionSelect: "— sélectionner —",
    optionSelectCustomerFirst: "sélectionnez d'abord le client",
    optionServiceDsp: "DSP (débosselage sans peinture)",
    optionServiceDspShort: "DSP",
    optionServiceMontage: "Montage/Démontage",
    overrideNotice:
      "Les montants effectifs seront calculés par le backend (suggested = pct × base) et enregistrés comme override uniquement si vous saisissez un montant différent. L'override exige le rôle admin + un motif.",
    placeholderAutoCalculated: "auto (calculé)",
    placeholderAutoFromContract: "auto (fiche/contrat)",
    placeholderAutoFromRecord: "auto (fiche)",
    placeholderExternalInvoiceNumber: "facultatif · ex : F-2026-0042",
    placeholderOptional: "facultatif",
    placeholderPlate: "ex : AB-123-CD",
    rowBillingCompany: "Société de facturation",
    rowCustomerRetention: "Rétention client %",
    rowDate: "Date",
    rowExternalInvoiceNumber: "N° de facture externe",
    rowInvoiced: "Facturé",
    rowQuote: "Devis",
    rowReceivingCompany: "Société bénéficiaire",
    rowTechnicianCommission: "Commission technicien",
    rowType: "Type",
    saveDossier: "Enregistrer le dossier",
    saving: "Enregistrement…",
    sectionVehicle: "Véhicule",
    stepFirstLine: "Première ligne de service",
    stepHeader: "En-tête",
    stepLabelPre: "Étape",
    stepLabelSuf: "sur 3",
    stepReviewAndSave: "Vérifier et enregistrer",
    stepperLine: "1re ligne",
    stepperReview: "Vérifier",
    title: "Nouveau dossier",
    vehicleManualHint:
      "Ou renseignez la plaque/le VIN manuellement (sans fiche). Au moins un est obligatoire.",
  },
  dossiers: {
    actIssue: "Émettre la facture",
    actLaunch: "Affecter un technicien",
    actOpen: "Ouvrir",
    actPayout: "Reverser",
    actReceipt: "Enregistrer l'encaissement",
    analyzing: "Analyse…",
    applying: "Application…",
    assignBtn: "Attribuer",
    assignTechBtn: "Attribuer un technicien",
    assignTechHintBold: "toutes",
    assignTechHintPre: "S'applique à",
    assignTechHintSuf: "les service_lines de chaque dossier sélectionné.",
    assignTechModalTitlePre: "Attribuer un technicien à",
    assignTechReasonPlaceholder: "Ex. : réattribution de portefeuille",
    assignTechTitle:
      "Attribue (ou remplace) le technicien dans toutes les service_lines des dossiers sélectionnés",
    badgeApproved: "approuvée",
    badgeCancelled: "annulée",
    badgeClientPre: "Client",
    badgeDraft: "brouillon",
    badgeInvoicePaid: "encaissée",
    badgeIssued: "émise",
    badgePaid: "payé",
    badgePartial: "partiel",
    badgePending: "en attente",
    badgeReceived: "reçue",
    badgeRejected: "rejetée",
    badgeTechPre: "Tech",
    bulkGroupClient: "Facture client",
    bulkGroupDocs: "Documents",
    bulkGroupEdit: "Édition",
    bulkGroupExport: "Exporter",
    bulkGroupTech: "Paiement technicien",
    bulkSelectedWord: "sélectionné",
    bulkSelectedWordPlural: "sélectionnés",
    cancelBtn: "Annuler",
    cancelReasonPlaceholder: "Ex. : erreur d'émission en lot",
    cancelStatusConfirmLabel: "Annuler le statut",
    cancelStatusMessage:
      "Annule le statut de la facture client. Différent de supprimer — le dossier reste dans la liste. Réversible.",
    cancelStatusTitle: "Marque les dossiers sélectionnés comme « Annulée » (statut de la facture)",
    cardDevisSub: "en attente d'un technicien",
    cardInRepairSub: "technicien au travail",
    cardInvoicedPartial: "facturé",
    cardInvoicedSuf: "HT facturé, à encaisser",
    cardToInvoiceSuf: "HT à facturer",
    chipAll: "Toutes",
    chipInRepair: "En réparation",
    chipInvoiced: "Facturées",
    chipNoTech: "Sans technicien",
    chipReceived: "Encaissées",
    chipRepaired: "Réparées à facturer",
    chipToExecute: "À exécuter",
    clearFilters: "Effacer les filtres",
    clearFiltersTitle: "Effacer tous les filtres",
    close: "Fermer",
    colAction: "Action",
    colActions: "Actions",
    colBenefice: "Bénéfice",
    colComm: "Comm.",
    colCommTitle: "Répartition de la commission : Technicien / Intermédiaire / Euro Storm",
    colCustomer: "Client",
    colDateDossier: "Date / dossier",
    colDevis: "Devis",
    colEncaisse: "Encaiss.",
    colEncaisseTitle: "Encaissement client : statut de la facture client",
    colFactTec: "Fact. tech.",
    colFactTecTitle: "Statut du document de la facture du technicien",
    colFacture: "Facturé",
    colInvoiceNumber: "N° facture",
    colMake: "Marque",
    colModel: "Modèle",
    colNumFactTec: "N° fact. tech.",
    colNumFactTecTitle: "Numéro de la facture du technicien",
    colPagTec: "Paiem. tech.",
    colPagTecTitle: "Statut du paiement au technicien",
    colPj: "PJ",
    colPjTitle: "Pièce jointe (PJ) : document ou justificatif",
    colPlate: "Plaque",
    colRepartition: "Répartition",
    colStatut: "Situation",
    colTechnician: "Technicien",
    colValeurs: "Valeurs",
    colVehicule: "Véhicule",
    columnsBtn: "Colonnes",
    commHintFormula: "100 − client − technicien − intermédiaire",
    commHintMid: "(F8). Les lines legacy sont ignorées.",
    commHintPre: "S'applique uniquement aux service_lines avec le modèle",
    commHintResidual: "est recalculé comme résidu",
    commHintSuf: "Laissez vide ce que vous ne souhaitez pas modifier.",
    commissionReasonPlaceholder: "Ex. : réajustement du % par défaut du technicien",
    companyLabel: "Société",
    confirmMarkReceivedPre: "Marquer",
    confirmMarkReceivedSuf:
      "dossier(s) comme Reçue ? La customer_invoice (issued) passera automatiquement à paid.",
    confirmRevertIssuedPre: "Rétablir",
    confirmRevertIssuedSuf: "dossier(s) à Émise (sortie de Reçue) ?",
    confirmTechPaidPre: "Marquer le paiement TECHNICIEN comme payé sur",
    confirmTechPaidSuf:
      "dossier(s) sélectionné(s) ? Le badge Tech passe à “payé” et ils sortent du KPI “Techniciens à payer”. C'est un marqueur de statut — le paiement en argent n'est pas enregistré.",
    confirmTechPendingPre: "Remettre le paiement TECHNICIEN en attente sur",
    confirmTechPendingSuf: "dossier(s) sélectionné(s) ?",
    confirmTitle: "Confirmer",
    csvBenefice: "Bénéfice",
    csvCode: "Code",
    csvCustomer: "Client",
    csvDate: "Date",
    csvDevis: "Devis",
    csvFacturado: "Facturé",
    csvInvoiceNumber: "N° Facture",
    csvInvoiceStatus: "Statut facture",
    csvMake: "Marque",
    csvModel: "Modèle",
    csvPlate: "Plaque",
    csvTechInvoiceNumber: "N° Fact. tech.",
    csvTechInvoiceStatus: "Statut Fact. tech.",
    csvTechnician: "Technicien",
    customerLabel: "Client",
    dateFromTitle: "Date de début",
    dateKindCreated: "Date de création du dossier (ni devis ni facture)",
    dateKindDevis: "Date du devis (pas encore facturé)",
    dateKindInvoice: "Date de la facture",
    dateKindRepaired: "Date de la réparation (PDR terminé ; pas encore facturé)",
    dateLabel: "Date",
    dateToTitle: "Date de fin",
    deleteBtn: "supprimer",
    deleteConfirmLabel: "Supprimer",
    deleteDossierMessage:
      "Soft delete. Réversible via « restaurer ». Motif obligatoire pour le journal d'audit.",
    deleteDossierTitlePre: "Supprimer le dossier",
    deleteReasonPlaceholder: "Ex. : créé par erreur",
    devisToExecuteBannerSuf:
      "devis à exécuter — en attente qu'un technicien les prenne sur le portail.",
    devisToExecuteBannerSufSingular:
      "devis à exécuter — en attente qu'un technicien le prenne sur le portail.",
    doneLabel: "Terminé",
    emptyState: "Aucun véhicule trouvé.",
    errorTitle: "Erreur",
    exportCsvBtn: "Exporter CSV",
    faturadoLabel: "Facturé",
    filterBtn: "Filtrer",
    filterTechPayTitle: "Paiement au technicien/intermédiaire (colonne PAG. TEC)",
    filterTechnicianTitle: "Filtrer par technicien (via service_lines)",
    filtersActivePre: "Filtres actifs",
    filtersBtn: "Filtres",
    generateProformaBtn: "Générer une proforma",
    generateProformaTitle:
      "Crée une proforma avec les dossiers sélectionnés — tous du même technicien",
    generating: "Génération…",
    includeDeleted: "Inclure les supprimés",
    invoiceFromTitle: "N° de facture minimum (ex. : F-2025-0045)",
    invoiceRangeLabel: "Plage de n° de facture",
    invoiceStatusLabel: "Statut facture",
    invoiceToTitle: "N° de facture maximum (ex. : F-2025-0089)",
    issueInvoiceBtn: "Émettre la facture",
    issueInvoiceTitle:
      "Vérifier et émettre 1 facture couvrant les services sélectionnés (même client)",
    kpiAReceber: "À recevoir du client",
    kpiAllPaid: "tout est payé",
    kpiAvoirsWord: "avoirs",
    kpiCardToggleTitle: "Filtre rapide — cliquez pour basculer",
    kpiClickToFilter: "cliquez pour filtrer",
    kpiCommissionsNotComputed: "commissions non calculées",
    kpiDossiers: "Dossiers",
    kpiEurostormShare: "Part totale Euro Storm",
    kpiFaturadoMinusCommissions: "Facturé − commissions",
    kpiFilterAppliedClickRemove: "filtre appliqué — cliquez pour le retirer",
    kpiGrossWord: "brut",
    kpiIssuedPending: "factures émises en attente",
    kpiLucroBruto: "Bénéfice brut",
    kpiLucroPrevisto: "Bénéfice prévu",
    kpiPctOfDevisSuf: "du total devis",
    kpiPctOfFactureSuf: "du facturé",
    kpiScopeFiltered: "Filtré",
    kpiScopeGeneral: "Général",
    kpiTechniciansToPay: "Techniciens à payer",
    kpiTotalDevis: "Total devis",
    kpiTotalFacture: "Total facturé",
    kpisCollapse: "Compact",
    kpisExpand: "Détails",
    linesWord: "lignes",
    loading: "Chargement…",
    markReceivedBtn: "Marquer Reçue",
    markReceivedTitle: "Marque les dossiers sélectionnés comme « Reçue » (payée)",
    markTechPaidBtn: "Tech payé",
    markTechPaidTitle:
      "Marque le paiement technicien comme PAYÉ sur toutes les lignes des dossiers sélectionnés (même signal que le badge Tech et le KPI Techniciens à payer)",
    menuAttach: "Joindre un document",
    menuDeleteHint: "annule la facture",
    menuHistory: "Voir l'historique",
    menuModify: "Modifier",
    menuRestoreHint: "réactive la facture",
    montageOtherLabel: "Montage (autre technicien)",
    newDossierBtn: "Nouveau véhicule",
    nextPage: "Suivant",
    noCompanyAccess: "Vous n'avez accès à aucune société.",
    okBtn: "OK",
    onlySelectedActive: "Affichage des sélectionnés uniquement",
    onlySelectedIdle: "Voir uniquement les sélectionnés",
    onlySelectedTitle: "Filtre le tableau pour n'afficher que les dossiers cochés",
    openBtn: "ouvrir",
    optAllCustomers: "Tous les clients",
    optAllInvoiceStatus: "Tous les statuts de facture",
    optAllProformas: "Toutes",
    optAllTechPay: "Tous paiem. tech.",
    optAllTechnicians: "Tous les techniciens",
    optCancelled: "Annulée",
    optChooseTechnician: "— choisissez un technicien —",
    optIssued: "Émise",
    optPending: "En attente",
    optReceived: "Reçue",
    optTechPayPaid: "Paiem. tech. : payé",
    optTechPayPending: "Paiem. tech. : en attente",
    optWithoutTechnician: "Sans technicien",
    pageOf: "sur",
    pageWord: "Page",
    paidTechnicianLabel: "Payé technicien",
    pctCustomer: "% Client",
    pctCustomerPlaceholder: "ex. : 30",
    pctIntermediary: "% Intermédiaire",
    pctIntermediaryPlaceholder: "ex. : 10",
    pctTechnician: "% Technicien",
    pctTechnicianPlaceholder: "ex. : 40",
    periodLabel: "Période (date facture)",
    pjNotImplementedTitle: "Pièce jointe pas encore implémentée (PJ)",
    prevPage: "Précédent",
    previewNotApplied: "Preview (non appliqué)",
    proformaFilterLabel: "Proforma Euro Storm",
    proformaFilterTitle: "Seuls les véhicules miroir de cette proforma (une facture par proforma).",
    proformaOptSuffix: "à facturer",
    promoteAndMorePre: "et encore",
    promoteApplyingV3: "en appliquant V3.",
    promoteBrokenCode: "complementary avec facturé=devis",
    promoteBrokenDesc:
      "— bug de l'ancien importateur eDSP (n'appliquait pas la retenue du client). Ne modifie que si le client a",
    promoteBtnPre: "Promouvoir",
    promoteBullet1: "Combien de lignes seront promues",
    promoteBullet2: "Combien seront ignorées (et pour quel motif)",
    promoteBullet3:
      "Combien échoueront (ex. : somme > 100 % en raison de valeurs par défaut incohérentes)",
    promoteErrorsDuringCalc: "erreur(s) pendant le calcul",
    promoteErrorsLogged: "erreur(s) enregistrée(s) dans le journal d'audit",
    promoteIntro:
      "Applique les valeurs par défaut des fiches technicien et client dans 3 scénarios :",
    promoteLinesWord: "Lignes",
    promotePromoted: "Promues",
    promoteRecommendedLabel: "Recommandé :",
    promoteRecommendedPre: "lancez d'abord le",
    promoteRecommendedSuf: "(ne modifie rien) pour voir :",
    promoteRemainedLegacy: "Restées legacy",
    promoteSeeReasonsPre: "Voir les motifs des",
    promoteSeeReasonsSuf: "ignorée(s)",
    promoteStaleCode: "technicien=0% (même avec intermédiaire)",
    promoteStaleDesc: "— import avec paire obsolète ; ligne déjà payée exclue",
    promoteToWord: "promeut vers",
    promoteTotalLegacy: "Total legacy",
    promoteTotalLegacyWas: "Total legacy avant",
    promoteWarnPre:
      "Avant l'exécution réelle, assurez-vous que chaque paire technicien×client est liée dans Techniciens → Commissions par client et que les clients ont",
    promoteWarnSuf: "renseignés.",
    promoteWillPromote: "À promouvoir",
    promoteWillSkip: "À ignorer",
    promoting: "Promotion…",
    rangeFromPlaceholder: "de",
    rangeToPlaceholder: "à",
    reasonOptionalLabel: "Motif (facultatif)",
    recalcCommissionsBtn: "Recalculer les commissions",
    recalcCommissionsTitle:
      "Recalcule la commission dans 3 scénarios (legacy → complementary ; complementary stale ; facturé=devis).",
    reportBtn: "Générer un rapport",
    reportBtnTitle: "Génère un PDF des dossiers cochés avec les totaux (facturé / payé technicien)",
    reportErrorTitle: "Erreur lors de la génération du rapport",
    residualWord: "résidu",
    restoreBtn: "restaurer",
    revertIssuedBtn: "Émise",
    revertIssuedTitle: "Rétablit « Émise » (si le paiement a été annulé)",
    revertTechPendingBtn: "Tech en attente",
    revertTechPendingTitle:
      "Annule : remet le paiement technicien EN ATTENTE sur les dossiers sélectionnés",
    runDryRunBtn: "Lancer le preview (dry-run)",
    searchLabel: "Rechercher",
    searchPlaceholder: "N° facture / code / plaque / VIN…",
    selectPageTitle: "Sélectionner la page actuelle",
    sitCancelled: "Facture annulée",
    sitDeleted: "Supprimé",
    sitDevisWaiting: "Devis · en attente d'un technicien",
    sitInRepair: "En réparation",
    sitInvoiced: "Facturée",
    sitNoTech: "⚠ sans technicien",
    sitPartial: "Facturée · encaissée en partie",
    sitPayoutMissingPre: "Reste à reverser :",
    sitPayoutPending: "reversement technicien en attente",
    sitPayoutTbd: "à calculer",
    sitReceived: "Encaissée",
    sitRepairedToInvoice: "Réparée · à facturer",
    sitTechPaid: "technicien payé",
    sortActivity: "Date de la liste (facture, réparation ou devis)",
    sortAsc: "Croissant",
    sortAscTitle: "Croissant — cliquez pour décroissant",
    sortByLabel: "Trier par",
    sortByTitlePre: "Trier par",
    sortDesc: "Décroissant",
    sortDescTitle: "Décroissant — cliquez pour croissant",
    sortFieldTitle: "Champ de tri",
    statDevis: "Devis",
    statDossiersWord: "dossiers",
    statFiltered: "filtré",
    statGross: "Marge brute",
    statInvoiced: "Facturé",
    statOfDevis: "du devis",
    statReceivable: "À recevoir",
    statTechPay: "À reverser aux techniciens",
    statTechPayHint: "cliquer pour filtrer",
    statTechPayOn: "filtre actif",
    statTechPayTitle: "Cliquez pour filtrer les dossiers avec reversement en attente",
    sumLabel: "Somme client+technicien+intermédiaire =",
    sumTooHigh: "somme > 100 %, impossible.",
    techPartAwaiting: "attente client",
    techPartMissing: "reste",
    techPartPaid: "payé",
    techPartPaidBefore: "payé avant le client",
    techPartReleased: "libéré",
    techPartToReceive: "à recevoir",
    techPayLabel: "Paiem. technicien",
    technicianLabel: "Technicien",
    title: "Véhicules",
    toastCommissionUpdatedPre: "Commission mise à jour dans",
    toastSkippedNoComplementaryReason: "sans lines complementary ou somme > 100",
    toastSkippedSameStatusReason: "le statut était déjà identique ou invalide",
    toastSkippedWord: "ignoré",
    toastSkippedWordPlural: "ignorés",
    toastStatusUpdatedPre: "Statut mis à jour dans",
    toastTechAssignedPre: "Technicien attribué dans",
    updateBtn: "Mettre à jour",
    updateCommissionBtn: "Mettre à jour la commission",
    updateCommissionModalTitlePre: "Mettre à jour la commission dans",
    updateCommissionTitle:
      "Met à jour les % client/technicien/intermédiaire dans les service_lines complementary",
    valDevisShort: "Devis",
    valFactShort: "Fact.",
    vehicleDossiersHint: "Dossiers de ce véhicule : ouvrir la fiche du véhicule",
    viewCompact: "Vue compacte",
    withoutTechBannerSuf: "sans technicien associé — à vérifier.",
  },
  emailOutbox: {
    allKinds: "Tous les types",
    allStatus: "Envoyés et échecs",
    asUserPre: "en tant que",
    attachmentsPre: "Pièces jointes :",
    backfillHint: "historique (importé de l'audit, sans détail des pièces jointes)",
    ccPre: "Copie :",
    colBy: "Envoyé par",
    colKind: "Type",
    colRef: "Référence",
    colStatus: "Statut",
    colSubject: "Objet",
    colTo: "Destinataire",
    colWhen: "Quand",
    companyLabel: "Société :",
    customMessagePre: "Message :",
    emptyState: "Aucun e-mail trouvé.",
    errorPre: "Erreur :",
    filterCompany: "Société",
    filterKind: "Type",
    filterSearch: "Rechercher",
    filterStatus: "Statut",
    kindBankStatement: "Relevé au comptable",
    kindCreditNote: "Avoir",
    kindCustomerInvoice: "Facture",
    kindInvoiceReminder: "Relance de facture",
    kindOther: "Autre",
    kindPasswordReset: "Réinitialisation du mot de passe",
    kindProforma: "Proforma",
    kindTechnicianApplication: "Approbation de technicien",
    kindUserInvite: "Invitation utilisateur",
    kindWorklog: "Worklog (semaine)",
    loading: "Chargement…",
    nextBtn: "Suivant →",
    notAdmin: "Vous n'êtes administrateur d'aucune société.",
    of: "sur",
    openDossier: "Ouvrir le dossier",
    openProforma: "Ouvrir la proforma",
    page: "Page",
    prevBtn: "← Précédent",
    searchPh: "Rechercher destinataire, objet, n° facture/proforma…",
    statusFailed: "Échec",
    statusSent: "Envoyé",
    subtitle:
      "Tous les e-mails envoyés par Gestion : factures, proformas, worklogs, relevés, invitations.",
    title: "Boîte d'envoi",
  },
  erpShell: {
    backToPortal: "Retour au portail du chantier",
    impersonatingBy: "par",
    impersonatingExit: "Quitter la vue",
    impersonatingPre: "Vue en tant que",
    navAgenda: "Agenda",
    navBankAccounts: "Comptes bancaires",
    navCaGap: "Écart de CA",
    navChantiers: "Chantiers",
    navDevis: "Devis",
    navEmailOutbox: "Boîte d'envoi",
    navIntermediaries: "Intermédiaires",
    navParcGrele: "Parc Grêle",
    notifAmendedSub: "Le devis a changé après l'émission (même numéro)",
    notifAmendedSuffix: "factures modifiées — à renvoyer au client",
    notifDossiersCommissionsSuffix: "dossiers — commissions",
    notifEmpty: "Rien en attente",
    notifNoticeTitle: "Message du bureau",
    notifOverdueInvoices: "Factures en retard",
    notifOverdueSuffix: "échus",
    notifSupplierInvoicesSuffix: "factures fournisseurs",
    notifToPaySuffix: "à payer",
    notifUnreconciledSuffix: "transactions non rapprochées",
    pinTitle: "Épingler : toutes les recherches filtrent sur cet élément",
    unpinTitle: "Détacher l'épingle — recherches générales",
    wsFin: "Finances",
    wsOps: "Opération",
  },
  financeApp: {
    loading: "chargement…",
  },
  financeClosing: {
    by: "par",
    closingBalanceByAccount: "Solde final par compte (cumulé)",
    colClosingBalance: "Solde final",
    colInflows: "Entrées",
    colMonth: "Mois",
    colOutflows: "Sorties",
    colResult: "Résultat",
    consolidatedSummary: "Résumé consolidé",
    edit: "Modifier",
    emptyHint: "Classez/répartissez des écritures pour voir la clôture.",
    emptyTitle: "Aucune écriture classée pour l'instant.",
    footnote:
      "Entrées/Sorties = mouvement externe du mois (les virements internes entre comptes ne comptent pas dans le brut). Solde final = cumulé (reporté d'un mois à l'autre). Reflète ce qui est saisi dans l'application.",
    loading: "Chargement…",
    monthApr: "avr.",
    monthAug: "août",
    monthDec: "déc.",
    monthFeb: "févr.",
    monthJan: "janv.",
    monthJul: "juil.",
    monthJun: "juin",
    monthMar: "mars",
    monthMay: "mai",
    monthMovementByAccount: "Mouvement du mois par compte",
    monthNov: "nov.",
    monthOct: "oct.",
    monthSep: "sept.",
    openingBalances: "Soldes d'ouverture",
    range12Months: "12 mois",
    range3Months: "3 mois",
    range6Months: "6 mois",
    rangeAll: "Tout",
    title: "Clôture mensuelle",
    updatedOn: "mis à jour le",
  },
  financeEntries: {
    accountLabel: "Compte",
    addBtn: "Ajouter",
    addDestination: "Ajouter une destination",
    addSource: "Ajouter une source",
    allocated: "Alloué",
    amountPlaceholder: "montant",
    applyBtn: "Appliquer",
    autoReconcileBtn: "Rapprochement automatique",
    bankLabel: "banque",
    bulkOptCompany: "— société —",
    bulkOptIn: "↓ entrée —",
    bulkOptOut: "↑ sortie —",
    bulkOptType: "— type —",
    cancel: "Annuler",
    childManagedTitle: "Ligne gérée par l'écriture parente",
    classifyAs: "Classer comme :",
    clearPendingBtn: "Vider les en attente",
    close: "Fermer",
    colAccounts: "Comptes",
    colCompany: "Société",
    colDate: "Date",
    colDescription: "Description",
    colIn: "Entrée",
    colOut: "Sortie",
    colType: "Type",
    confirmClearPending: "Supprimer toutes les écritures en attente importées ?",
    confirmDeleteEntry: "Supprimer cette écriture manuelle ? Cette action est définitive.",
    confirmTitle: "Confirmer",
    deletePermanentTitle: "Supprimer (définitif)",
    destinations: "Destinations",
    distExpenseHint:
      "Choisissez de quel compte chaque part SORT (source) — le compte est débité et peut devenir négatif. Le reste sort du compte de la société.",
    distParentAccountTitle:
      "Parent de distribution — compte géré par les lignes filles. Utilisez ⚡ pour modifier.",
    distRevenueHint:
      "Chaque ligne crédite la destination et débite la société ; le résiduel reste dans la société.",
    distributeBtn: "Distribuer",
    distributeExpenseTitle: "Distribuer la dépense",
    distributeRevenueTitle: "Distribuer la recette",
    distributeTitle: "Distribuer",
    distributionChild: "distribution",
    duplicatesRemoved: "doublon(s) supprimé(s).",
    editing: "modification",
    emptyState: "Aucune écriture pour l'instant.",
    emptyStateHint: "Importez un CSV ou ajoutez manuellement.",
    entriesPlural: "écritures",
    entrySingular: "écriture",
    entryTotal: "Total de l'écriture",
    errMinTwoWords: "Utilisez au moins 2 mots.",
    exceeds: "(dépasse !)",
    fieldIn: "↓ Entrée (compte · montant)",
    fieldOut: "↑ Sortie (compte · montant)",
    filterAllAccounts: "Tous les comptes",
    filterAllCompanies: "Toutes les sociétés",
    filterAllTypes: "Tous les types",
    finalBalance: "Solde final",
    inMonth: "en",
    loading: "Chargement…",
    monthLabel: "Mois",
    newBtn: "Nouveau",
    newEntryTitle: "Nouvelle écriture",
    noRulesYet: "Aucune règle pour l'instant.",
    optAccountPlaceholder: "— compte —",
    reconciledByRule: "par règle",
    reconciledToCompanyAccount: "sur le compte de la société.",
    reconciling: "Rapprochement…",
    redistributeTitle: "Redistribuer",
    removeDuplicatesBtn: "Supprimer les doublons",
    residualFrom: "Résiduel sort de →",
    residualTo: "Résiduel →",
    residualZeroTitle: "Résiduel à zéro — réduisez un montant déjà alloué pour libérer de la place",
    ruleActive: "active",
    ruleInactive: "inactive",
    rulesBtn: "Règles",
    rulesDescription:
      "Si la description contient le motif, l'écriture est rapprochée sur le compte (une sortie débite le compte ; une entrée le crédite). Appliqué à l'import et via le bouton « Rapprochement automatique ». Motif : min. 2 mots.",
    rulesPatternLabel: "Motif (≥ 2 mots)",
    rulesPatternPlaceholder: "ex. : Milton Vieira",
    rulesTitle: "Règles de rapprochement automatique",
    save: "Enregistrer",
    saveChanges: "Enregistrer les modifications",
    searchPlaceholder: "Rechercher une description…",
    selectedCount: "sélectionné(s)",
    sources: "Sources (de quel compte cela sort)",
    toDistribute: "à distribuer",
    toReconcile: "à rapprocher",
    unreconcileTitle: "Annuler le rapprochement — l'écriture repasse en attente (sans suppression)",
    warnAddAtLeastOneLine: "Ajoutez au moins une ligne avec un montant.",
    warnAllocatedExceeds: "Le montant alloué dépasse l'écriture.",
    warnFillDateAndDescription: "Renseignez la date et la description.",
    warnSymmetricTransfer: "Transfert symétrique : l'entrée et la sortie doivent être identiques.",
    warningTitle: "Avertissement",
  },
  financeImport: {
    accountLabel: "compte",
    andMorePre: "… et",
    andMoreSuf: "autres transactions",
    bankLabel: "banque",
    cancel: "Annuler",
    colAmount: "Montant",
    colDate: "Date",
    colDescription: "Description",
    colStatus: "Statut",
    companyGeneral: "Général",
    confirmImportBtn: "✓ Confirmer l'importation",
    dropzoneEncoding: "Encodage ISO-8859-1 / UTF-8 détecté automatiquement",
    dropzoneFormats: "CSV exporté de la banque · Société Générale et autres formats",
    dropzoneHint: "Glissez le fichier ici ou cliquez pour sélectionner",
    dropzoneTitle: "Charger le relevé CSV",
    duplicatesSkipped: "doublons ignorés",
    entriesImported: "écritures importées",
    headerLineLabel: "ligne d'en-tête",
    importing: "Importation…",
    newEntryBtn: "+ Nouvelle écriture",
    orAddManually: "Ou ajouter manuellement :",
    parsingFile: "Analyse du fichier…",
    previewTitle: "Aperçu de l'importation (30 premières)",
    separatorLabel: "séparateur",
    statementCompanyLabel: "Société du relevé :",
    statusPending: "En attente",
    transactionsDetected: "transactions détectées",
  },
  financeKpis: {
    addBtn: "+ Ajouter",
    balancesInMonth: "Soldes du mois",
    cancel: "Annuler",
    cardBalanceLandione: "Solde Landione",
    cardBalanceNeto: "Solde Neto",
    cardExpensesForecast: "Dépenses prévisionnelles",
    cardExpensesPaid: "Dépenses payées",
    cardForecastBalance: "Solde prévisionnel",
    cardForecastBalanceLandione: "Solde prévisionnel Landione",
    cardForecastBalanceNeto: "Solde prévisionnel Neto",
    cardInflows: "Encaissements",
    cardOperatingCash: "Trésorerie opérationnelle",
    cardOutflows: "Décaissements",
    cardResult: "Résultat",
    closingOf: "clôture de",
    colTotal: "Total",
    fixedCostsEmpty:
      "Aucune charge fixe enregistrée. Ajoutez les impôts mensuels, la comptabilité, etc.",
    fixedCostsTitle: "Charges fixes mensuelles",
    formTitle: "Charge fixe mensuelle",
    labelAmount: "Montant (€)",
    labelCategory: "Catégorie",
    labelCompany: "Société",
    labelDescription: "Description",
    labelExpenses: "Dépenses",
    labelRevenue: "Chiffre d'affaires",
    loading: "Chargement…",
    monthApr: "avr",
    monthAug: "août",
    monthDec: "déc",
    monthFeb: "févr",
    monthJan: "janv",
    monthJul: "juil",
    monthJun: "juin",
    monthMar: "mars",
    monthMay: "mai",
    monthNov: "nov",
    monthOct: "oct",
    monthSep: "sept",
    negativeCashAlertPre: "⚠️ Trésorerie opérationnelle (Dépenses) négative :",
    negativeCashAlertSuf: "— les distributions/dépenses dépassent les encaissements.",
    optionAdministrative: "Administratif",
    optionGeneral: "Général",
    optionOperational: "Coût opérationnel",
    optionOther: "Autre",
    optionTax: "Impôt / taxe",
    perMonthSuffix: "/mois",
    period12m: "12m",
    period3m: "3m",
    period6m: "6m",
    periodAll: "Tout",
    periodCurrentMonth: "Mois en cours",
    placeholderDescription: "Ex : Comptabilité",
    rowCompanyAccountBalance: "Solde compte société",
    rowCompanyExpenses: "(-) Dépenses société",
    rowGrossRevenue: "Chiffre d'affaires brut",
    rowOperationalCosts: "(-) Coûts opérationnels",
    save: "Enregistrer",
    sectionBreakdown: "Détail consolidé",
    sectionPartners: "Associés",
    sectionPeriodMovement: "Mouvements de la période",
    subAfterForecastExpenses: "après dépenses prévisionnelles",
    subExpensesAccount: "compte Dépenses",
    subFixedPlusFuture: "charges fixes + à venir enregistrées",
    subInflowsMinusOutflows: "encaissements − décaissements",
    subPaidToDate: "payées à ce jour",
    subReceivedInPeriod: "reçu sur la période",
    subShare: "participation",
    subSpentInPeriod: "dépensé sur la période",
    toggleByCompany: "voir par société ▾",
    toggleHide: "masquer ▴",
  },
  financeLayout: {
    accountExpenses: "Dépenses",
    accountPayTechnician: "À payer technicien",
    backToErp: "← ERP",
    monthApr: "avr",
    monthAug: "août",
    monthDec: "déc",
    monthFeb: "févr",
    monthJan: "janv",
    monthJul: "juil",
    monthJun: "juin",
    monthMar: "mars",
    monthMay: "mai",
    monthNov: "nov",
    monthOct: "oct",
    monthSep: "sept",
    parameters: "Paramètres",
    rowClassified: "Classées",
    rowPending: "En attente",
    sumBanks: "Σ = banques",
    summary: "Résumé",
    tabClosing: "Clôture",
    tabEntries: "Écritures",
    tabImport: "Importer",
    tabKpis: "KPIs",
    totalCash: "Trésorerie totale",
    virtualAccounts: "Comptes virtuels",
  },
  financeOpeningBalances: {
    cancel: "Annuler",
    close: "Fermer",
    confirmSave:
      "Confirmez-vous la modification des soldes d'ouverture ? La modification est enregistrée (qui/quand).",
    save: "Enregistrer",
    saving: "Enregistrement…",
    subtitle:
      "Solde de chaque compte avant la 1re écriture dans l'application. S'ajoute à la base de tous les calculs (barre latérale et clôture).",
    title: "Soldes d'ouverture",
    yesSave: "Oui, enregistrer",
  },
  fiscal: {
    accountingCashLabel: "Trésorerie comptable",
    accountingCashTooltip: "Solde de trésorerie de la dernière écriture avec bilan renseigné",
    accountsSuf: "compte(s)",
    actualCumulative: "Réel cumulé",
    aggregateLabel: "Agrégat",
    alertDsoHighPre: "Délai clients élevé",
    alertDsoHighSuf: "alerte si > 60 jours.",
    alertGapNarrowPre: "Écart du seuil étroit",
    alertGapNarrowSuf: "alerte si < 10%.",
    alertLowMarginPre: "Taux de marge globale faible",
    alertLowMarginSuf: "alerte si < 15%.",
    alertNegativeCashPre: "Trésorerie nette négative",
    alertPersonnelHighPre: "Charges de personnel élevées",
    alertPersonnelHighSuf: "alerte si > 35%.",
    annualized: "Annualisé",
    balanceSheetPre: "Bilan",
    bankBalanceEmptyTooltip: "Aucune bank_transaction dans l'intervalle de l'exercice sélectionné",
    bankBalanceLabel: "Solde bancaire actuel",
    bankBalanceTooltip:
      "Σ opening_balance des comptes actifs + Σ amount des bank_transactions sur l'intervalle du FY",
    breakEvenLabel: "Seuil de rentabilité",
    breakEvenTooltip:
      "CA minimum pour couvrir les coûts fixes (économique) et le cash-flow (financier)",
    caHtLabel: "CA HT",
    caLabel: "Chiffre d'affaires",
    caTooltip: "Somme des customer_invoices issued+paid sur l'exercice",
    cafLabel: "CAF",
    cafTooltip: "Capacité d'autofinancement = RN + dotations",
    closedBadge: "Clôturé — recalcul indisponible",
    closedForecastNote:
      "Exercice clôturé — données réelles disponibles. La projection n'est pas calculée pour un exercice clôturé.",
    closedRecomputeTitle: "Exercice clôturé — rouvrez l'exercice pour recalculer",
    commercialConvention: "Convention commerciale (mois = 30 j)",
    computationPre: "Calcul",
    computedAtPre: "Calculé le",
    contextTitle: "Contexte de l'exercice",
    corporateTaxLabel: "Impôt sur les sociétés",
    corporateTaxTooltip: "IS saisi dans les fiscal_month_entries (cumulé)",
    dpoLabel: "Délai fournisseurs (DPO)",
    dpoTooltip: "(Dettes fournisseurs / Achats consommés) × nb_jours_exercice",
    dsoLabel: "Délai clients (DSO)",
    dsoTooltip: "(Créances clients / CA HT) × nb_jours_exercice",
    ebeLabel: "EBE",
    ebeTooltip: "Excédent brut d'exploitation = VA − impôts/taxes − charges de personnel",
    exercisePre: "Exercice",
    externalChargesLabel: "Charges externes (total)",
    externalChargesTooltip:
      "Σ fournitures + locations + primes + intermédiaires + déplacements + frais bancaires",
    financialLabel: "Financier",
    forecastEmptySubtitle:
      "Aucune projection générée pour l'instant. Cliquez pour estimer la clôture.",
    forecastTitle: "Projection de Clôture",
    fyStatusLabel: "Statut FY",
    generateForecastBtn: "Générer la projection",
    generating: "Génération…",
    goToEntries: "Accédez aux Écritures",
    grossMarginLabel: "Marge globale",
    grossMarginTooltip: "CA − Achats consommés",
    monthsElapsedLabel: "Mois écoulés",
    monthsElapsedSuf: "mois écoulés",
    nbMonthsFyLabel: "Nb mois exercice",
    netResultLabel: "Résultat net",
    netResultTooltip: "Résultat d'exploitation − IS",
    noBalanceSheet: "Aucun bilan",
    noFiscalYearBody: "Aucun exercice fiscal n'est sélectionné.",
    noFiscalYearTitle: "Aucun exercice sélectionné",
    noKpisBodyPre: "Cet exercice n'a pas encore de KPIs calculés. Cliquez sur",
    noKpisBodySuf: "ci-dessus pour les générer.",
    noKpisTitle: "Aucun KPI calculé",
    noTransactionsImported: "Aucune transaction importée",
    ofCaSuf: "du CA",
    ofVaSuf: "de la VA",
    operatingResultLabel: "Résultat d'exploitation",
    operatingResultTooltip: "EBE − dotations − autres charges + autres produits",
    otherVarChargesLabel: "Autres charges var.",
    pctDuCa: "% du CA",
    pctOnCa: "% sur CA",
    pctOnRe: "% sur RE",
    pointMortLabel: "Point mort",
    pointMortTooltip: "Jours nécessaires pour atteindre le seuil de rentabilité",
    purchasesConsumedLabel: "Achats consommés",
    recomputeBtn: "Recalculer les KPIs",
    recomputing: "Recalcul…",
    selectCompanyBody:
      "Choisissez une société dans le sélecteur ci-dessus pour afficher le module fiscal.",
    selectCompanyTitle: "Sélectionnez une société",
    subtitle: "Tableau de bord KPIs",
    thresholdGapLabel: "Écart du seuil",
    thresholdGapTooltip: "CA − Seuil. Indique la marge de sécurité jusqu'au point d'équilibre",
    toCreateOneSuf: "pour en créer un.",
    txSuf: "tx",
    unavailable: "Indisponible",
    vaLabel: "Valeur ajoutée",
    vaTooltip: "Marge globale − Charges externes (PRD §3)",
  },
  fiscalBilan: {
    actif: "Actif",
    autresCreances: "Autres créances",
    autresDettes: "Autres dettes",
    bfr: "BFR",
    bilanAsOf: "Bilan",
    bilanNotFilledPre:
      "Aucun fiscal_month_entry de cet exercice ne contient de données de bilan. Accédez à",
    bilanNotFilledSuf:
      "et modifiez un mois en renseignant les 8 champs de bilan (immobilisations, créances, trésorerie, capitaux, dettes…).",
    bilanNotFilledTitle: "Bilan non rempli",
    capitauxPropres: "Capitaux propres",
    creancesClients: "Créances clients",
    dettesFinancieres: "Dettes financières",
    dettesFournisseurs: "Dettes fournisseurs",
    dpo: "Délai fournisseurs (DPO)",
    dso: "Délai clients (DSO)",
    ecartBilanTreso: "Écart bilan/trésorerie",
    emptyValue: "— vide —",
    entriesLabel: "Écritures",
    fondsRoulement: "Fonds de roulement (FR)",
    immobilisationsNettes: "Immobilisations nettes",
    mismatchMid: "et Passif",
    mismatchSuf: "ne correspondent pas — écart",
    noKpisTitle: "Aucun KPI",
    passif: "Passif",
    runRecompute: "Lancez le recalcul depuis le tableau de bord.",
    selectCompanyFy: "Sélectionnez une société + un exercice.",
    subtitle: "Bilan patrimonial",
    tooltipBfr: "Créances clients + autres créances − dettes fournisseurs − autres dettes",
    tooltipDpo: "(Dettes fournisseurs / Achats consommés) × nb_jours_exercice",
    tooltipDso: "(Créances clients / CA HT) × nb_jours_exercice",
    tooltipEcart: "Trésorerie de l'écriture − trésorerie nette calculée",
    tooltipFr: "Capitaux propres + dettes financières − immobilisations",
    tooltipTresorerieNette: "FR − BFR",
    totalActif: "Total actif",
    totalPassif: "Total passif",
    tresorerie: "Trésorerie",
    tresorerieEntry: "Trésorerie (écriture)",
    tresorerieNette: "Trésorerie nette",
  },
  fiscalBudget: {
    activeBadge: "active",
    activeSuffix: "ACTIVE",
    archiveLabel: "Archiver",
    archiveMessage: "Suppression logique — libère le nom pour réutilisation. Motif obligatoire.",
    archivePlaceholder: "ex : scénario écarté",
    archiveTitlePre: "Archiver la révision",
    baselinePre: "Baseline :",
    cancel: "annuler",
    cloneLabel: "Cloner",
    cloneMessage: "Nouveau nom (doit être unique au sein de l'exercice).",
    colDeltaVsReal: "Δ vs Réel",
    colEffective: "Effectif",
    colRealiseN: "Réalisé N",
    colRubrique: "Rubrique",
    colSuggested: "Suggéré",
    colVariationPct: "Variation %",
    compareBtn: "Comparer",
    createBudgetBtn: "+ Créer un budget",
    createLabel: "Créer",
    creating: "Création…",
    daysUnit: "j",
    groupAggregate: "Agrégats",
    groupChargesExternes: "Charges externes",
    groupOtherCharges: "Autres charges",
    groupOtherIncome: "Autres produits",
    identificationTitle: "Identification",
    kpiCaf: "CAF (proj.)",
    kpiEbe: "EBE (proj.)",
    kpiMargeGlobale: "Marge globale (proj.)",
    kpiPointMort: "Point mort (proj.)",
    kpiRn: "RN (proj.)",
    kpiSeuilEco: "Seuil économique (proj.)",
    kpiSeuilFin: "Seuil financier (proj.)",
    kpiVa: "VA (proj.)",
    lineAchatsConsommes: "Achats consommés",
    lineAutresChargesExploitation: "Autres charges d'exploitation",
    lineAutresChargesVariables: "Autres charges variables",
    lineAutresProduitsExploitation: "Autres produits d'exploitation",
    lineCaHt: "Chiffre d'affaires HT",
    lineChargesPersonnel: "Charges de personnel",
    lineDeplacementsReception: "Déplacements & réception",
    lineDotationsAmortissements: "Dotations amortissements",
    lineDotationsProvisions: "Dotations provisions",
    lineFournituresConsommables: "Fournitures & consommables",
    lineFraisBancaires: "Frais bancaires",
    lineImpotSocietes: "Impôt sur les sociétés",
    lineImpotsTaxes: "Impôts & taxes",
    lineIntermediairesHonoraires: "Intermédiaires & honoraires",
    lineLocationsChargesLocatives: "Locations & charges locatives",
    linePrimesAssurance: "Primes d'assurance",
    lineSubventionsExploitation: "Subventions d'exploitation",
    newRevisionBtn: "+ Nouvelle révision",
    newRevisionMessage:
      "Nom unique au sein de l'exercice (ex : « optimiste », « v2-conservateur »).",
    newRevisionPlaceholder: "ex : optimiste",
    newRevisionTitle: "Nouvelle révision de budget",
    noBudgetHelp:
      "Le backend résoudra automatiquement l'exercice précédent comme baseline, s'assurera que ses KPIs sont calculés et générera les valeurs suggested/effective à partir de variations à zéro (copie directe de la baseline). Vous pourrez ensuite ajuster.",
    noBudgetSubtitle:
      "Un budget peut être créé à partir de l'exercice précédent (détection automatique).",
    noBudgetTitle: "Aucun budget pour cet exercice",
    overrideTooltip: "Cliquez pour saisir un override",
    placeholderExPre: "ex :",
    realN: "Réel N",
    revisionLabel: "Révision",
    save: "Enregistrer",
    saving: "Enregistrement…",
    selectCompanyFy: "Sélectionnez une société + un exercice.",
    setActiveBtn: "Marquer active",
    subtitle: "Budget N+1",
    toastArchived: "Révision archivée.",
    toastSaved: "Budget mis à jour.",
    toastSetActive: "Révision marquée comme active.",
    updatedAtPre: "Mis à jour le",
    variationsSubtitle:
      "Variation % = ajustement par rapport à la baseline. Override = valeur absolue qui ignore la variation.",
    variationsTitle: "Variations & overrides",
  },
  fiscalBudgetCompare: {
    activeSuffix: "ACTIVE",
    backToBudgets: "Retour aux budgets",
    colCategory: "Catégorie",
    colKpi: "KPI",
    goToBudgets: "Aller aux budgets",
    inputsTitle: "Entrées effectives",
    kpiCaf: "CAF",
    kpiEbe: "EBE",
    kpiMargeGlobale: "Marge globale",
    kpiPointMort: "Point mort (j)",
    kpiResultatExploitation: "Résultat d'exploitation",
    kpiResultatNet: "Résultat net",
    kpiSeuilEconomique: "Seuil économique",
    kpiSeuilFinancier: "Seuil financier",
    kpiValeurAjoutee: "Valeur ajoutée",
    kpisTitle: "KPI projetés",
    leftLabel: "Gauche",
    lineAchatsConsommes: "Achats consommés",
    lineAutresChargesExpl: "Autres charges expl.",
    lineAutresChargesVariables: "Autres charges variables",
    lineAutresProduits: "Autres produits",
    lineCaHt: "CA HT",
    lineChargesPersonnel: "Charges de personnel",
    lineDeplacements: "Déplacements",
    lineDotationsAmort: "Dotations amort.",
    lineDotationsProv: "Dotations prov.",
    lineFournitures: "Fournitures",
    lineFraisBancaires: "Frais bancaires",
    lineImpotsTaxes: "Impôts & taxes",
    lineIntermediaires: "Intermédiaires",
    lineIs: "IS",
    lineLocations: "Locations",
    linePrimesAssurance: "Primes d'assurance",
    lineSubventions: "Subventions",
    needTwoRevisionsPre: "Il faut au moins 2 révisions pour comparer. Actuellement :",
    rightLabel: "Droite",
    selectCompanyYear: "Sélectionnez une société + un exercice.",
    subtitle: "Comparer les révisions de budget",
  },
  fiscalEntries: {
    bilanSectionTitle: "Bilan (laisser vide si non applicable)",
    cancel: "Annuler",
    closeFyBtn: "Clôturer l'exercice",
    closeFyFailPre: "Échec de la clôture de l'exercice",
    closeFyModalMsg:
      "Toutes les écritures non verrouillées seront verrouillées automatiquement. Motif obligatoire pour le journal d'audit.",
    closeFyModalTitle: "Clôturer l'exercice fiscal",
    closeFyPlaceholder: "Ex : clôture comptable 2025",
    closingFy: "Clôture…",
    createEntryTitle: "Créer l'écriture",
    createFyBtn: "Créer l'exercice",
    creatingFy: "Création…",
    daysSuf: "jours",
    editEntryTitle: "Modifier l'écriture",
    endField: "Fin",
    errorTitle: "Erreur",
    fieldAutresChargesExploitation: "Autres charges d'exploitation",
    fieldAutresCreances: "Autres créances",
    fieldAutresDettes: "Autres dettes",
    fieldAutresProduitsExploitation: "Autres produits d'exploitation",
    fieldCapitauxPropres: "Capitaux propres",
    fieldChargesPersonnel: "Charges de personnel",
    fieldCreancesClients: "Créances clients",
    fieldDeplacementsReception: "Déplacements & réception",
    fieldDettesFinancieres: "Dettes financières",
    fieldDettesFournisseurs: "Dettes fournisseurs",
    fieldDotationsAmortissements: "Dotations amortissements",
    fieldDotationsProvisions: "Dotations provisions",
    fieldFournituresConsommables: "Fournitures & consommables",
    fieldFraisBancaires: "Frais bancaires",
    fieldImmobilisationsNettes: "Immobilisations nettes",
    fieldImpotSocietes: "Impôt sur les sociétés",
    fieldImpotsTaxes: "Impôts & taxes",
    fieldIntermediairesHonoraires: "Intermédiaires & honoraires",
    fieldLocationsChargesLocatives: "Locations & charges locatives",
    fieldPrimesAssurance: "Primes d'assurance",
    fieldRecettesATrier: "Entrées à trier (TTC)",
    fieldRecettesEncaisseesHt: "Recettes encaissées HT",
    fieldSubventionsExploitation: "Subventions d'exploitation",
    fieldTresorerie: "Trésorerie",
    fieldTvaCollecteeEncaissements: "TVA collectée (encaissements)",
    fiscalYearPre: "Exercice",
    groupChargesExternes: "Charges externes",
    groupOutrasCargas: "Autres charges",
    groupOutrosProdutos: "Autres produits",
    groupRecettes: "Recettes (trésorerie)",
    invalidValuePre: "Valeur invalide dans",
    labelField: "Libellé",
    lockEntryMsg:
      "Motif (facultatif). Le verrouillage empêche toute modification jusqu'au déverrouillage par un admin.",
    lockEntryPlaceholder: "Ex : clôture mensuelle validée",
    lockEntryTitle: "Verrouiller l'écriture",
    lockFailPre: "Échec du verrouillage",
    monthsSuf: "mois",
    newFyBtn: "+ Nouvel exercice",
    newFyModalTitle: "Nouvel exercice fiscal",
    reopenConfirm: "Rouvrir",
    reopenFyBtn: "Rouvrir l'exercice",
    reopenFyFailPre: "Échec de la réouverture de l'exercice",
    reopenFyModalMsg:
      "Le statut repasse à 'open'. Les écritures restent verrouillées (utilisez le déverrouillage individuel si besoin).",
    reopenFyModalTitle: "Rouvrir l'exercice fiscal",
    reopenFyPlaceholder: "Ex : correction d'écriture",
    reopeningFy: "Réouverture…",
    save: "Enregistrer",
    saving: "Enregistrement…",
    selectCompany: "Sélectionnez une société.",
    selectFyHint: "Choisissez un exercice existant ou créez-en un nouveau via le bouton ci-dessus.",
    selectFyTitle: "Sélectionnez un exercice",
    startField: "Début",
    subtitle: "Écritures mensuelles",
    syncATrierPre: "⚠ entrées à trier",
    syncBtn: "↻ Synchroniser depuis la banque (charges + recettes)",
    syncBtnTitle:
      "Remplit les cases de charges des mois (loyer, assurance, salaires, honoraires, fournitures, taxes, impôts) à partir du relevé + factures d'achat. Ne touche ni les amortissements/IS/bilan ni les mois clôturés.",
    syncFailPre: "Échec de la synchronisation des charges",
    syncMonthsSkippedSuf: "ignoré(s) (clôturés)",
    syncMonthsUpdatedSuf: "mois rempli(s) à partir du relevé (banque) + factures d'achat",
    syncRecettesPre: "recettes encaissées HT",
    syncRecomputeHint:
      "Lancez ensuite « ↻ Recompute KPIs » dans le tableau de bord fiscal pour mettre à jour le résultat/SIG.",
    syncSuccessTitle: "Synchronisé depuis la banque",
    syncingBtn: "Synchronisation…",
    unlockEntryMsg: "Réservé aux admins. Motif obligatoire pour le journal d'audit.",
    unlockEntryPlaceholder: "Ex : correction demandée par le comptable",
    unlockEntryTitle: "Déverrouiller l'écriture",
    unlockFailPre: "Échec du déverrouillage",
  },
  fiscalResultat: {
    cardSubtitleNoBudget: "Réel vs Annualisé — aucun budget créé pour cet exercice",
    cardSubtitleWithBudget: "Réel vs Annualisé vs Budget N+1",
    cascadeTitle: "Compte de résultat en cascade",
    hintCaf: "RN + dotations amortissements + dotations provisions",
    hintEbe: "VA − impôts/taxes − personnel + subventions",
    hintMargeGlobale: "CA HT − Achats consommés",
    hintValeurAjoutee: "Marge globale − Charges externes",
    noKpisTitle: "Aucun KPI calculé",
    recomputeKpisBtn: "↻ Recompute KPIs",
    rowAchatsConsommes: "− Achats consommés",
    rowAutresChargesExploitation: "− Autres charges d'exploitation",
    rowAutresChargesVariables: "− Autres charges variables",
    rowAutresProduitsExploitation: "+ Autres produits d'exploitation",
    rowCaHt: "Chiffre d'affaires (CA HT)",
    rowCaf: "= CAF",
    rowChargesExternesTotal: "− Charges externes (total)",
    rowChargesPersonnel: "− Charges de personnel",
    rowDeplacementsReception: "Déplacements & réception",
    rowDotationsAmortissements: "− Dotations amortissements",
    rowDotationsProvisions: "− Dotations provisions",
    rowEbe: "= EBE",
    rowFournituresConsommables: "Fournitures & consommables",
    rowFraisBancaires: "Frais bancaires",
    rowImpotSocietes: "− Impôt sur les sociétés",
    rowImpotsTaxes: "− Impôts & taxes",
    rowIntermediairesHonoraires: "Intermédiaires & honoraires",
    rowLocationsChargesLocatives: "Locations & charges locatives",
    rowMargeGlobale: "= Marge globale",
    rowPrimesAssurance: "Primes d'assurance",
    rowResultatExploitation: "= Résultat d'exploitation",
    rowResultatNet: "= Résultat net",
    rowSubventionsExploitation: "+ Subventions d'exploitation",
    rowValeurAjoutee: "= Valeur ajoutée (VA)",
    runRecomputePre: "Lancez",
    runRecomputeSuf: "depuis le tableau de bord.",
    selectCompanyPrompt: "Sélectionnez la société + l'exercice en haut de page.",
    subtitle: "Compte de résultat",
    tresoATrierPre: "Entrées à trier (hors résultat) :",
    tresoColCumule: "Cumulé",
    tresoColDepenses: "Dépenses",
    tresoColMois: "Mois",
    tresoColRecettes: "Recettes HT",
    tresoColResultat: "Résultat",
    tresoColTva: "TVA collectée",
    tresoEmpty:
      "Pas encore de données de trésorerie — lancez “Synchroniser depuis la banque” dans l'onglet Saisies.",
    tresoNote:
      "Base : relevé bancaire catégorisé (trésorerie). Amortissements, provisions et IS ne sont pas des décaissements du mois et restent hors de cette vue. La TVA collectée est informative (non incluse dans le résultat).",
    tresoSubtitle:
      "Recettes encaissées HT − dépenses catégorisées du relevé (synchronisées dans l'onglet Saisies)",
    tresoTitle: "Résultat de trésorerie — mois par mois",
    tresoTotalLabel: "Total de l'exercice",
    viewEngagement: "Engagement (factures)",
    viewTresorerie: "Trésorerie (relevé)",
  },
  fiscalSeuil: {
    achatsConsommes: "Achats consommés",
    autresChargesVar: "Autres charges var.",
    breakevenChartSubtitle:
      "Croisement des courbes Recettes × Coûts totaux. Zone verte = bénéfice.",
    breakevenChartTitle: "Diagramme du point mort",
    caHt: "CA HT",
    chargesFixes: "Charges fixes",
    chargesFixesSeuilFin: "Charges fixes (seuil fin.)",
    chargesVariables: "Charges variables",
    componentsSubtitle: "Structure de coûts de l'exercice",
    componentsTitle: "Composantes du seuil",
    ecartSeuil: "Écart du seuil",
    ecartSeuilTooltip: "CA − seuil économique",
    margeCv: "Marge sur coûts variables",
    noKpisHint: "Lancez le recalcul depuis le tableau de bord.",
    noKpisTitle: "Aucun KPI",
    pctOfCa: "% du CA",
    pointMort: "Point mort",
    pointMortSubtitle: "Convention commerciale (mois = 30 j)",
    pointMortTooltip: "Jours pour atteindre le seuil",
    selectCompanyFy: "Sélectionnez une société + un exercice.",
    seuilEconomique: "Seuil économique",
    seuilEconomiqueTooltip: "Charges fixes / taux de marge sur coûts variables",
    seuilFinancier: "Seuil financier",
    seuilFinancierSubtitle: "Interprétation cash-flow",
    seuilFinancierTooltip: "(CF − dotations + IS − autres produits) / taux",
    subtitle: "Seuil de rentabilité",
    tauxMargeCv: "Taux de marge sur CV",
  },
  fiscalShell: {
    moduleLabel: "Module fiscal",
    navBilan: "Bilan",
    navBudget: "Budget N+1",
    navEntries: "Écritures",
    navKpis: "KPIs",
    navResultat: "Résultat",
    navSeuil: "Seuil",
    navSig: "SIG",
    navTva: "TVA",
  },
  fiscalSig: {
    achatsSubtitle:
      "La marge = CA − Achats. Les Achats proviennent des factures INTERCOMPANY (BS→ES) + des factures de TECHNICIEN — PAS des Fournisseurs/Achats. Vérifiez ici s'il existe un doublon qui gonfle le coût.",
    achatsTitle: "Détail des Achats consommés",
    achatsTotalLabel: "Achats consommés (total)",
    blockCaFormula: "Σ customer_invoices issued+paid",
    blockCaLabel: "Chiffre d'affaires (CA HT)",
    blockCafFormula: "RN + dotations amortissements + dotations provisions",
    blockCafLabel: "CAF (Capacité d'autofinancement)",
    blockEbeFormula: "VA − impôts/taxes − personnel + subventions",
    blockEbeLabel: "EBE",
    blockMargeFormula: "CA HT − Achats consommés",
    blockMargeLabel: "Marge globale",
    blockRexFormula: "EBE − dotations − autres charges + autres produits",
    blockRexLabel: "Résultat d'exploitation",
    blockRnFormula: "Résultat d'exploitation − IS",
    blockRnLabel: "Résultat net",
    blockVaFormula: "Marge globale − Charges externes",
    blockVaLabel: "Valeur ajoutée (VA)",
    cascadeSubtitle: "Chaque bloc applique une déduction/addition sur le bloc précédent",
    cascadeTitle: "Cascade SIG",
    colAmount: "Montant",
    colDate: "Date",
    colNumber: "N°",
    colOrigin: "Origine",
    colStatus: "Statut",
    emptyState: "Aucune facture intercompany ou de technicien sur l'exercice.",
    intercompanyLabel: "Intercompany",
    isCardSubtitle:
      "Estimation sur le résultat d'exploitation cumulé, AVANT les retraitements fiscaux (2058-A) du comptable",
    isCardTitle: "IS estimé (15 % / 25 %)",
    isNoProfit: "Pas de bénéfice cumulé sur l'exercice — IS estimé : 0 €.",
    isRowBase: "Résultat d'exploitation cumulé",
    isRowNet: "Résultat net estimé",
    isRowTotal: "IS estimé total",
    isRowTranche15Pre: "Tranche réduite — jusqu'à",
    isRowTranche25Pre: "Tranche normale — au-delà de",
    noKpisHintPre: "Lancez",
    noKpisHintSuf: "dans le tableau de bord.",
    noKpisTitle: "Aucun KPI",
    recomputeKpisLabel: "↻ Recompute KPIs",
    selectCompanyFy: "Sélectionnez une société + un exercice.",
    subtitle: "Soldes intermédiaires de gestion (SIG)",
    technicianLabel: "Technicien",
  },
  fiscalTva: {
    colAchatsHt: "Achats HT",
    colCaHt: "CA HT",
    colMonth: "Mois",
    colToPayCredit: "À payer / Crédit",
    computeBtn: "↻ calculer",
    computedAtPre: "Calculé le",
    creditSuf: "crédit",
    declareConfirm: "Déclarer (verrouiller)",
    declareMessage:
      "Le statut passe à « déclarée » et l'édition des champs numériques est verrouillée. Référence DGFiP (facultative).",
    declarePlaceholder: "Ex : référence renvoyée par impots.gouv.fr",
    declareTitle: "Déclarer à la DGFiP",
    declaredAtPre: "Déclarée le",
    detailPre: "Détail",
    emptyMonth: "— vide —",
    error: "Erreur",
    errorGeneratingExport: "Erreur lors de la génération de l'export",
    exportCsvBtn: "📦 Export CSV",
    exportPdfBtn: "📄 Export PDF",
    generateCsvTitle: "Générer ZIP avec recettes.csv + depenses.csv",
    generatePdfTitle: "Générer export PDF pour cabinet",
    labelAchatsHtDeductible: "Achats HT déductibles",
    labelCaHtCollected: "CA HT collecté",
    labelCreditReportable: "Crédit reportable",
    labelDgfipReference: "Référence DGFiP",
    labelPaidAmount: "Montant payé",
    labelTvaAPayer: "TVA à Payer",
    lastPre: "dernier",
    markPaidBtn: "Marquer comme payée",
    markPaidConfirm: "Marquer comme payé",
    markPaidTitle: "Marquer comme payée à la DGFiP",
    monthApril: "Avril",
    monthAugust: "Août",
    monthDecember: "Décembre",
    monthFebruary: "Février",
    monthJanuary: "Janvier",
    monthJuly: "Juillet",
    monthJune: "Juin",
    monthMarch: "Mars",
    monthMay: "Mai",
    monthNovember: "Novembre",
    monthOctober: "Octobre",
    monthSeptember: "Septembre",
    overrideAppliedPre: "Override appliqué le",
    overrideSuf: "override",
    paidAtPre: "Payée le",
    regeneratePre: "Re-générer",
    reopenConfirm: "Rouvrir",
    reopenMessage:
      "Réservé aux admins. Le statut revient à « brouillon » et l'édition est déverrouillée.",
    reopenPlaceholder: "Motif de la réouverture",
    reopenTitle: "Rouvrir la déclaration TVA",
    selectCompany: "Sélectionnez une société.",
    status: "Statut",
    statusCancelled: "annulée",
    statusDeclared: "déclarée",
    statusDraft: "brouillon",
    statusPaid: "encaissée",
    subAchatsHtDeductible: "Somme des factures d'achat (received/paid) du mois",
    subCaHtCollected: "Encaissements clients du mois (base trésorerie, relevé)",
    subCreditReportable: "Déductible − Collectée (min. 0)",
    subTvaAPayer: "Collectée − Déductible (min. 0)",
    subtitle: "Déclarations TVA (CA3 mensuelle)",
    suggestedPre: "Suggéré",
    tableSubtitle: "Une ligne par mois. Cliquez pour ouvrir / calculer.",
    tvaCollectee: "TVA Collectée",
    tvaDeductible: "TVA Déductible",
    tvaYearLabel: "Année TVA",
    yearPre: "Année",
  },
  fiscalYearSelector: {
    companyLabel: "Société",
    fiscalYearLabel: "Exercice",
    loadingOption: "Chargement…",
    noAccessOption: "— sans accès —",
    noFiscalYearOption: "— aucun exercice —",
  },
  forecastPanel: {
    colKpi: "KPI",
    colProjection: "Projection",
    colRealN1: "Réel N-1",
    colVariation: "Variation",
    computedAt: "Projection calculée le",
    factorLabel: "facteur",
    isStrategyLabel: "stratégie IS :",
    isStrategyLancements: "IS comptabilisé × facteur",
    isStrategyNone: "Aucune estimation (RE ≤ 0)",
    isStrategyTaxeFr25: "Taux FR 25 % sur RE",
    linearTrend: "Tendance linéaire",
    monthsActual: "mois réels",
    monthsProjected: "mois projetés",
    recomputeBtn: "Actualiser la projection",
    recomputing: "Actualisation…",
    rowCaf: "CAF",
    rowChiffreAffaires: "Chiffre d'affaires",
    rowIsEstime: "IS estimé",
    rowMargeGlobale: "Marge globale",
    rowPointMort: "Point mort",
    rowResultatNet: "Résultat net",
    rowTresorerieEstimee: "Trésorerie estimée",
    title: "Projection de clôture",
  },
  hailParcDetail: {
    addBtn: "Ajouter",
    autoPlaceholder: "auto",
    backToParcs: "Parc Grêle",
    cancel: "Annuler",
    cancelInvoiceBtn: "Annuler la facture",
    catPlaceholder: "Cat",
    close: "Fermer",
    colClient: "Client",
    colDebosselage: "Débosselage",
    colForfaitName: "Forfait (nom)",
    colMontage: "Montage",
    colQty: "Qté",
    colRetained: "Retenu ES/BS",
    colTotalHt: "Total HT",
    colUnitPriceHt: "PU HT",
    colVehicle: "Véhicule",
    confirmCancelMsgPre: "Annuler",
    confirmCancelMsgSuf: "Vous pourrez en générer une nouvelle.",
    confirmCancelTitle: "Annuler la facture ?",
    downloadPdfBtn: "Télécharger le PDF",
    downloadTemplate: "Télécharger le modèle (.xlsx)",
    dueLabel: "échéance",
    emptyVehicles: "Aucun véhicule pour le moment.",
    errChooseForfait: "Choisissez le forfait.",
    errPdf: "Échec de la génération du PDF.",
    errPlateOrVin: "Indiquez la plaque ou le VIN.",
    errReadFile: "Échec de la lecture du fichier.",
    errorsCountSuffix: "erreur(s) :",
    forfaitGridHelp:
      "Le montage (démontage/remontage) est une part réservée du forfait — il ne s'ajoute pas au prix. Retenu ES/BS = client − débosselage − montage. Laissez le nom vide pour ignorer la ligne.",
    forfaitGridTitle: "Grille de prix par véhicule (jusqu'à 5 forfaits)",
    generateInvoiceBtn: "Générer la facture",
    generating: "Génération…",
    importBtn: "Importer",
    importModalTitle: "Importer des véhicules",
    importSheetBtn: "Importer un fichier",
    importedSuffix: "véhicule(s) importé(s).",
    importing: "Importation…",
    invoiceSectionTitle: "Facture de la carrosserie",
    issuedOnPrefix: "Émise le",
    labelDebosShort: "Débos.",
    labelForfait: "Forfait",
    labelMake: "Marque",
    labelModel: "Modèle",
    labelPlate: "Plaque",
    labelVin: "VIN",
    linePrefix: "Ligne",
    linesReadFrom: "ligne(s) lue(s) de",
    loading: "Chargement…",
    missingForfaitSuffix: "sans forfait — seront rejetées.",
    missingIdSuffix: "sans plaque ni VIN — seront rejetées.",
    noForfaitsWarning: "Définissez la grille de forfaits avant d'ajouter des véhicules.",
    noInvoiceHint: "Aucune facture émise. Générez la facture avec les véhicules du parc × forfait.",
    removeFromParcTitle: "Retirer du parc",
    saveGridBtn: "Enregistrer la grille",
    saved: "Enregistré",
    saving: "Enregistrement…",
    skippedSuffix: "étaient déjà dans le parc (ignorés).",
    statToPayDebos: "À payer débos.",
    statToPayMontage: "À payer montage",
    statTotalClient: "Total client",
    statusClosed: "Fermé",
    statusOpen: "Ouvert",
    techOverClient:
      "débosselage + montage dépassent le prix client — corrigez avant d'enregistrer.",
    totalTtc: "Total TTC",
    tvaReverseChargeNote: "TVA non applicable — autoliquidation",
    vehiclesCountSuffix: "véhicules",
    vehiclesTitle: "Véhicules",
  },
  hailParcs: {
    cancel: "Annuler",
    colActions: "Actions",
    colCarrosserie: "Carrosserie",
    colDate: "Date",
    colName: "Nom",
    colStatus: "Statut",
    create: "Créer",
    createModalTitle: "Nouveau parc grêle",
    creating: "Création…",
    customerLabel: "Carrosserie (client)",
    emptyState: "Aucun parc pour le moment. Créez le premier.",
    eventDateLabel: "Date de l'événement",
    loading: "Chargement…",
    nameLabel: "Nom du chantier",
    namePlaceholder: "Ex : Grêle Montpellier juin 2026",
    newBtn: "+ Nouveau parc",
    openLink: "ouvrir",
    selectPlaceholder: "— sélectionner —",
    statusClosed: "fermé",
    statusOpen: "ouvert",
    subtitle: "Chantiers de réparation de grêle — devis au forfait",
    title: "Parc Grêle",
    validationNameCustomer: "Renseignez le nom et la carrosserie.",
  },
  importEdsp: {
    alreadyExisted: "existaient déjà",
    alreadyExistsInline: "(existe déjà)",
    clientCol: "Client",
    companyBannerPre: "Vous importez vers :",
    companyBannerSuf:
      "vérifiez avant d'importer (devis, listes et encaissements entrent TOUS dans cette société).",
    companyLabel: "Société :",
    csvColumnsLabel: "CSV ou XLSX avec colonnes",
    custBadHeader:
      "En-tête non reconnu — exportez la liste directement depuis eDSP (Nom usuel / Raison sociale / Adresse / CP / Ville).",
    custColName: "Client",
    custColStatus: "Statut",
    custContactsWord: "contact(s)",
    custEnrichedWord: "enrichis",
    custFileClients: "Liste des clients :",
    custFileContacts: "Liste des contacts (optionnel) :",
    custHint:
      "Exportez dans eDSP la liste-clients.xlsx (et en option la liste-contacts.xlsx pour email/téléphone). Sans doublons : les clients existants sont seulement enrichis (champs vides).",
    custImportBtn: "Importer les clients",
    custImported: "Clients importés",
    custPreviewBtn: "Prévisualiser",
    custRowsWord: "clients dans le fichier",
    custStatusEnrich: "enrichir",
    custStatusNew: "nouveau",
    custStatusUnchanged: "déjà complet",
    custTitle: "Clients (eDSP)",
    custUnchangedWord: "déjà complets",
    dateCol: "Date",
    devisAlignBlockedPre: "Ne sera pas aligné :",
    devisAlignedWord: "alignés sur le devis",
    devisBatchOf: "sur",
    devisBatchPre: "lot",
    devisColClient: "Client",
    devisColDate: "Date",
    devisColDevis: "Devis",
    devisColFile: "Fichier",
    devisColPlate: "Immatriculation",
    devisColStatus: "Statut",
    devisColTotal: "Total HT",
    devisEnrichedWord: "enrichis (éléments)",
    devisImportBtn: "Importer les nouveaux devis",
    devisImported: "Devis importés",
    devisParsing: "Lecture des PDF…",
    devisStatusAlign: "sera aligné sur le devis",
    devisStatusEnrich: "Existant — recevra les éléments",
    devisStatusError: "erreur",
    devisStatusExisting: "existe déjà",
    devisStatusNew: "nouveau",
    devisUnreadableHint:
      "Extrayez le .zip dans un dossier avant de sélectionner (pas depuis le zip) et réessayez — les autres ont été traités normalement.",
    devisUnreadablePre: "Fichiers illisibles par le navigateur",
    docAttachBtn: "Joindre les originaux",
    docColDoc: "Document",
    docColGestionHt: "HT dans le Gestion",
    docColPdfHt: "HT du PDF",
    docDupPre: "Même document que",
    docHint:
      "Joint le PDF ORIGINAL de l'eDSP (le document reçu par le client) à la facture ou à l'avoir déjà présent dans le Gestion. Le Gestion vérifie le numéro et les montants ; s'ils ne correspondent pas, il ne joint rien. Plusieurs à la fois, par lots.",
    docStAlready: "déjà joint",
    docStAttach: "à joindre",
    docStAttached: "joint",
    docStDuplicate: "doublon",
    docStMismatch: "montant différent",
    docStNotFound: "absent du Gestion",
    docStUnreadable: "non reconnu",
    docTitle: "Factures et avoirs (PDF) de l'eDSP",
    dossierWord: "dossier",
    dossiersImported: "Dossiers importés",
    emptyRaw: "(vide)",
    errorsLabel: "Erreurs",
    existLabel: "existent déjà",
    failures: "échecs",
    file1Title: "Fichier 1 — Dossiers / Factures",
    file2Title: "Fichier 2 — Encaissements",
    file3Hint:
      'Exportez les devis de l\'eDSP en PDF et sélectionnez-en plusieurs — crée des dossiers "à exécuter" avec le détail du devis, sans facture.',
    file3Title: "Devis (PDF) — avant facturation",
    importAction: "Importer",
    importReceiptsBtn: "Importer les reçus",
    importingLabel: "Importation…",
    invoiceSettledInline: "(facture déjà soldée par un autre encaissement — ignorée)",
    invoicesSplitCol: "Factures (split)",
    lineLabel: "Ligne",
    linesParseErrorExpand: "ligne(s) avec erreur d'analyse — cliquer pour développer",
    mailAddress: "Transférer à :",
    mailColDetail: "Détail",
    mailColDevis: "Devis · immat.",
    mailColFrom: "Expéditeur",
    mailColStatus: "Statut",
    mailColWhen: "Reçu",
    mailDisabled: "réception désactivée sur le serveur",
    mailEmpty: "Aucun email reçu pour l'instant.",
    mailHint:
      "Le technicien envoie le devis depuis l'eDSP vers la boîte de l'entreprise, qui le transfère à l'adresse ci-dessous. Le Gestion lit le PDF et crée le devis tout seul, dans l'entreprise émettrice imprimée (EURO STORM ou BRAZILIAN STORMS). Un devis renvoyé pour un véhicule existant met à jour les lignes (sauf facture émise ou ligne payée). Actualisé toutes les 30 s.",
    mailNoAddress: "adresse pas encore configurée",
    mailStDuplicate: "existait déjà",
    mailStEnriched: "complété",
    mailStError: "erreur",
    mailStIgnored: "ignoré",
    mailStImported: "créé",
    mailStProcessing: "en cours",
    mailStReview: "à revoir",
    mailStUpdated: "mis à jour",
    mailTitle: "Devis reçus par email",
    morePre: "et ",
    moreSuf: " de plus.",
    new: "nouveaux",
    noInvoiceV2: "sans facture dans v2",
    noValueInline: "(sans montant net — ignorée)",
    oldPdfAttachBtn: "Archiver les PDF",
    oldPdfColDevis: "N° de devis",
    oldPdfColDossier: "Dossier",
    oldPdfHint:
      "Pour les véhicules importés avant le 26/10/2026, quand le Gestion n'archivait pas encore le fichier : téléchargez à nouveau les devis dans l'eDSP et choisissez les PDF ici. Le Gestion retrouve le dossier par le n° de devis et la plaque et archive seulement le PDF, visible dans « PDF d'origine ». Rien n'est réimporté : montants, lignes et franchise restent inchangés. Plusieurs à la fois, par lots.",
    oldPdfStAlready: "déjà archivé",
    oldPdfStAmbiguous: "plusieurs dossiers",
    oldPdfStAttach: "à archiver",
    oldPdfStAttached: "archivé",
    oldPdfStNotFound: "dossier introuvable",
    oldPdfStUnreadable: "pas un devis",
    oldPdfTitle: "Anciens PDF de devis (archivage seul)",
    oldPdfViaPlate: "trouvé par la plaque (le n° de devis n'était pas dans le dossier)",
    omitted: "omises",
    openDossierTag: "facture le dossier ouvert du véhicule",
    parseErrorsBadge: "erreurs d'analyse",
    parseErrorsShort: "erreurs d'analyse",
    parseErrorsSummaryShort: "ligne(s) avec erreur d'analyse",
    parsingLabel: "Analyse…",
    partialLabel: "partiels",
    readOnlyNote:
      "Lecture seule — importation disponible uniquement pour les utilisateurs disposant de droits de modification.",
    receiptsColumnsNote:
      ". N° Facture peut contenir plusieurs numéros séparés par un espace (répartition au prorata du Prix Net).",
    receiptsCreated: "Reçus créés",
    receiptsDisabledNote:
      "Désactivé. Les règlements clients sont désormais enregistrés uniquement par le rapprochement du relevé bancaire (Banque → Rapprochement), avec l'argent réellement reçu.",
    repairsApplyFixesPre: "appliquer les corrections de montants",
    repairsApplyFixesSuf:
      "vérifiez le devis avant : si le HT du fichier est déjà le net (remise appliquée dans eDSP), NE cochez PAS",
    repairsBadHeader:
      "En-tête non reconnu — attendu : Client, Date Réparation, N° Ordre, Utilisateur, HT, Immatriculation.",
    repairsChipExists: "déjà présents",
    repairsChipFix: "à corriger (montants)",
    repairsChipMismatch: "divergence technicien",
    repairsChipNew: "nouveaux",
    repairsChipNoPlate: "sans plaque (véhicule neuf · VIN)",
    repairsChipPlateConflict: "n° utilisé par un autre véhicule",
    repairsColClient: "Client",
    repairsColDate: "Réparation",
    repairsColOrdre: "Ordre",
    repairsColPlate: "Immat.",
    repairsColStatus: "Statut",
    repairsColTech: "Technicien",
    repairsCreatedWord: "créées",
    repairsDevisNoTech:
      "n'existe que comme devis, sans technicien, et a déjà des photos/checks — le technicien le prend dans le portail",
    repairsEmptyFile: "Fichier sans lignes de réparation.",
    repairsFixedWord: "corrigées",
    repairsHint:
      "Export des réparations eDSP : crée les véhicules réparés absents de Gestion, statut Réparé, technicien du fichier et commission par la paire — ils arrivent dans « à facturer ». Ré-importable : l'existant (n° d'ordre ou plaque) est ignoré.",
    repairsImportBtn: "Importer les réparations",
    repairsNoPlateCandidatesPre: "probable :",
    repairsNoPlateMsg:
      "sans plaque dans le fichier — véhicule neuf entre par le devis (VIN) ; cet ordre ne crée pas de dossier",
    repairsResultPre: "Réparations importées",
    repairsStatusExists: "existe déjà",
    repairsStatusNew: "nouveau",
    repairsTagMismatchPre: "dans Gestion :",
    repairsTagNewTech: "technicien sera créé",
    repairsTagNoPair: "sans paire ou 0 %",
    repairsTagPlateConflictPre:
      "n° d'ordre déjà utilisé par un autre véhicule — ignoré ; plaque existante :",
    repairsTitle: "Réparations (liste-orders)",
    repairsUpgradeDevisPre: "complète le devis",
    repairsWillFix: "montants corrigés à l'import (remise client)",
    settledLabel: "déjà soldés (rien à créer)",
    settledWord: "soldé",
    statusCol: "Statut",
    technicianCol: "Technicien",
    warningsLabel: "Avertissements",
  },
  intermediaries: {
    awaitingSuf:
      "véhicule(s) en attente du règlement du client — ils entreront une fois le client payé. Total",
    badgeActive: "actif",
    badgeInactive: "inactif",
    blockedSuf: "dossier(s) sont déjà dans une autre proforma active et ont été ignorés :",
    cancelBtn: "Annuler",
    closeBtn: "Fermer",
    colActions: "Actions",
    colAmount: "Montant",
    colCountry: "Pays",
    colCustomer: "Client",
    colDossier: "Dossier",
    colEmail: "E-mail",
    colName: "Nom",
    colPlate: "Plaque",
    colStatus: "Statut",
    colTaxId: "Identifiant fiscal",
    colTechnician: "Technicien",
    deactivateBtn: "désactiver",
    dossierCount: "dossier(s)",
    editBtn: "modifier",
    emptyState: "Aucun intermédiaire externe enregistré.",
    fieldCountry: "Pays (2 lettres)",
    fieldEmail: "E-mail",
    fieldName: "Nom *",
    fieldNotes: "Notes",
    fieldPhone: "Téléphone",
    fieldTaxId: "Identifiant fiscal",
    fieldTaxIdKind: "Type d'identifiant",
    fieldTaxIdPlaceholder: "SIRET / TVA / CNPJ…",
    generatePaymentBtn: "générer le paiement",
    generateProformasBtn: "Générer la/les proforma(s)",
    generatingBtn: "Génération…",
    includeInactive: "Inclure les inactifs",
    loading: "Chargement…",
    loadingEligible: "Recherche des dossiers éligibles…",
    modalTitleEdit: "Modifier l'intermédiaire",
    modalTitleNew: "Nouvel intermédiaire externe",
    newBtn: "+ Nouvel intermédiaire",
    noEligible:
      "Aucun dossier éligible pour le moment (rien à payer ou tous déjà dans une proforma active).",
    payModalSubtitle:
      "Proforma cumulant la commission du technicien + de l'intermédiaire (l'externe reverse le technicien en dehors). Un document par société payeuse.",
    payModalTitle: "Générer le paiement",
    payingCompaniesSuf: "sociétés payeuses",
    proformaGeneratedSingular: "Proforma générée avec succès.",
    proformasGeneratedSuf: "proformas générées avec succès.",
    reactivateBtn: "réactiver",
    saveBtn: "Enregistrer",
    savingBtn: "Enregistrement…",
    searchPlaceholder: "Rechercher par nom / e-mail / identifiant fiscal…",
    subtitle:
      "Personnes/sociétés hors du groupe qui perçoivent une commission. Liées par paire technicien×client ; le paiement (proforma) est généré ici.",
    title: "Intermédiaires externes",
    totalLabel: "Total",
    viewInProformas: "Voir dans Proformas →",
  },
  invites: {
    accessGrantedTo: "Accès accordé à :",
    actions: "Actions",
    alreadyHadAccess: "Avait déjà accès/invitation dans :",
    cancel: "Annuler",
    companiesLabel: "Sociétés (une ou plusieurs)",
    companyLabel: "Société :",
    email: "E-mail",
    emailLang: "Langue de l'e-mail",
    expires: "Expire",
    inviteSentTitle: "Invitation envoyée",
    invitedBy: "Invité par",
    loading: "Chargement…",
    name: "Nom",
    newInviteBtn: "+ Nouvelle invitation",
    noInvites: "Aucune invitation enregistrée.",
    notAdminOfAnyCompany: "Vous n'êtes administrateur d'aucune société.",
    pageTitle: "Invitations",
    permission: "Autorisation",
    resend: "Renvoyer",
    revoke: "Révoquer",
    revokeConfirmPre: "L'invitation envoyée à",
    revokeConfirmSuf: " sera annulée. Le lien d'acceptation cessera de fonctionner.",
    revokeInviteTitle: "Révoquer l'invitation",
    roleAdmin: "Administrateur",
    roleAdminOption: "Administrateur (gestion)",
    roleClient: "Client",
    roleClientOption: "Client (portail)",
    roleManager: "Chef de projet",
    roleManagerOption: "Chef de projet (chantier)",
    roleTechnician: "Technicien (portail)",
    roleTechnicianOption: "Technicien (portail — sans accès à l'ERP)",
    roleUser: "Utilisateur",
    roleUserOption: "Utilisateur (opérationnel)",
    roleViewer: "Lecteur",
    roleViewerOption: "Lecteur (lecture seule)",
    selectAtLeastOneCompany: "Sélectionnez au moins une société.",
    sendInvite: "Envoyer l'invitation",
    sending: "Envoi…",
    status: "Statut",
    statusAccepted: "Accepté",
    statusExpired: "Expiré",
    statusPending: "En attente",
    statusRevoked: "Révoqué",
  },
  invoiceDraft: {
    ackWarnings: "J'ai lu les alertes ci-dessus et je veux émettre quand même.",
    bankDefaultTag: "par défaut",
    blocksWord: "blocage(s)",
    cClientesDiferentes: "Véhicules de clients différents : impossible sur une seule facture.",
    cDegarnPre: "dégarnissage en attente :",
    cDegarnSuf: "— à saisir avant de facturer.",
    cDevis: "Devis",
    cFatura: "facture",
    cFranquiaExcecao:
      "TTC (exception sur ce véhicule) : la facture sort entière ; seules les commissions des techniciens ont été réduites.",
    cFranquiaNaoInformada: "franchise non renseignée à la réception.",
    cFranquiaParticular:
      "TTC (particulier) : la facture reste entière ; seule la commission du technicien est réduite.",
    cFranquiaPre: "franchise de",
    cFranquiaPro: "TTC (professionnel) : déjà déduite de la facture et de la commission.",
    cJaFaturado: "déjà facturé (facture émise).",
    cOldAvoir: "l'ancienne facture a un avoir émis de",
    cOldPaid:
      "Le paiement déjà reçu sur l'ancienne facture passe sur la nouvelle ; le surplus devient un crédit client :",
    cParticularSemTva:
      "Client particulier enregistré sans TVA : un particulier paie la TVA — vérifiez la fiche.",
    cProSemRemise:
      "Client professionnel sans remise configurée : les commissions risquent d'être fausses.",
    cProSemSiret: "Client professionnel sans SIRET ni n° de TVA.",
    cReparoIncompleto: "réparation incomplète, il manque :",
    cReplaces: "Remplace la facture",
    cSemComissao: "ligne(s) sans commission configurée (paire technicien × client).",
    cSemEmail: "Client sans e-mail : la facture ne pourra pas être envoyée depuis Gestion.",
    cSemEndereco: "Client sans adresse : la facture exige l'adresse du client.",
    cSemPlaca: "Véhicule sans immatriculation ni VIN : la facture n'identifiera pas le véhicule.",
    cTecnicoAReceber:
      "technicien déjà payé par la proforma précédente a encore à recevoir (devis en hausse) : payez à part",
    cTotalZero: "montant nul : rien à facturer.",
    cTudoCerto: "Tout est en ordre : aucun problème détecté.",
    checksTitle: "Vérification automatique",
    createdBy: "créé par",
    discardBtn: "Supprimer le brouillon",
    draftsChip: "Brouillons",
    draftsPanelTitle: "Brouillons de facture (pas encore émis)",
    errBlocked: "La vérification signale un blocage : corrigez-le avant d'émettre.",
    errReplacementHasPayment:
      "L'ancienne facture a un paiement reçu : validez le remplacement (le paiement passe sur la nouvelle). Impossible de supprimer.",
    errWarnings: "Cochez la case de lecture des alertes avant d'émettre.",
    fieldBankAccount: "Paiement sur le compte",
    fieldDue: "Échéance",
    fieldNotes: "Remarques",
    fieldNumber: "N° de facture (vide = suivant de la série)",
    issueAndSendBtn: "Émettre et envoyer",
    issueAndSendTitle: "Émet la facture et ouvre l'envoi par e-mail au client (PDF joint).",
    issueBtn: "Valider et émettre",
    issuedOk: "Facture émise :",
    numberJumpRetry: "Le numéro saisi saute la série. Émettre quand même ?",
    openDraft: "📝 Brouillon en cours",
    openNewTab: "Ouvrir dans un nouvel onglet",
    pdfBtn: "Voir le PDF (brouillon)",
    previewLoading: "Génération de l'aperçu…",
    previewStale: "Enregistrez les modifications pour mettre à jour l'aperçu.",
    previewTitle: "Aperçu du PDF (brouillon)",
    replacesCancelled: "déjà annulée",
    replacesOld: "ancien total",
    replacesPayment: "paiement déjà reçu, transféré sur la nouvelle facture :",
    replacesPre: "Remplace la facture",
    reverseCharge: "Autoliquidation (sans TVA)",
    save: "Enregistrer les modifications",
    saveAsDraft: "📝 Brouillon et vérification",
    saveFirst: "Enregistrez d'abord les modifications",
    sendNowBtn: "Envoyer par e-mail",
    sentToPre: "envoyée à",
    stepDelivery: "livraison",
    stepMontage: "montage (garnissage)",
    stepMontagePhases: "étapes du montage (démontage/remontage)",
    stepPdr: "débosselage (PDR)",
    summaryTitle: "Récapitulatif (montants actuels des dossiers)",
    title: "Brouillon de facture",
    totalHt: "Total HT",
    totalTtc: "Total TTC",
    tva: "TVA à",
    warningsWord: "alerte(s)",
  },
  invoiceNew: {
    addDossiers: "+ Ajouter des dossiers",
    addDossiersTitle: "Sélectionnez d’autres dossiers du même client et réémettez",
    alreadyInvoicedBadge: "déjà facturé — sera exclu",
    cancel: "Annuler",
    cannotIssueTitle: "Résolvez les blocages ci-dessus (client unique, au moins 1 dossier valide).",
    colDossier: "Dossier",
    colPlate: "Plaque",
    colTotalHt: "Total HT",
    colVehicle: "Véhicule",
    confirmEmit: "Confirmer et émettre",
    customer: "Client",
    degarnOpenBadge: "dégarnissage non terminé :",
    degarnOpenTitle:
      "Le dégarnissage a été pris, mais la dépose ou la repose n'est pas marquée. Le montant est déjà dans cette facture.",
    degarnPendingBadge: "dégarnissage hors facture :",
    degarnPendingTitle:
      "Le devis comporte un dégarnissage, mais personne ne l'a saisi : le montant n'entre pas dans cette facture. Saisissez-le dans le portail avant de facturer, ou facturez sans.",
    differentCustomersBold: "clients différents",
    differentCustomersPre: "Les dossiers sélectionnés proviennent de",
    differentCustomersSuf:
      "Une facture consolidée doit concerner un seul client — retirez ceux qui n’appartiennent pas.",
    dueQuick15: "15 jours",
    dueQuick30: "30 jours",
    dueQuick60: "2 mois",
    dueQuick7: "1 semaine",
    emailPlaceholder: "laisser vide pour ne pas envoyer",
    fieldDueDate: "Date d’échéance (facultatif)",
    fieldEmail: "E-mail du client (envoie la facture à la confirmation)",
    fieldInvoiceNumber: "N° de facture (suit le dernier ; modifiez selon le format de la société)",
    fieldNotes: "Notes (interne, facultatif)",
    invoiceNumberPlaceholder: "ex. : F-2026-0001",
    issuer: "Émetteur",
    issuing: "Émission…",
    loadingPreview: "Chargement de l’aperçu…",
    noDossierPre: "Aucun dossier sélectionné. Retournez à",
    noDossierSuf: "et utilisez « Émettre la facture ».",
    numberJumpAsk:
      "Toutes les factures suivantes continueront à partir de ce numéro. Confirmer quand même ?",
    numberJumpConfirm: "Émettre avec ce numéro",
    numberJumpMid: "saute",
    numberJumpMid2: "positions de la série — le suivant serait",
    numberJumpTitle: "Numéro hors séquence",
    removeDossierTitle: "Retirer ce dossier de la facture",
    reverseChargeNote: "Autoliquidation — TVA due par le destinataire (art. 283-2 CGI).",
    servicePlural: "services",
    serviceSingular: "service",
    toastEmailFailed: "émise, mais l’envoi de l’e-mail a échoué",
    toastInvoiceWord: "Facture",
    toastIssued: "émise",
    toastSentTo: "et envoyée à",
    totalTtc: "Total TTC",
  },
  invoices: {
    allCustomers: "Tous les clients",
    allStatuses: "Tous les statuts",
    allocateMenu: "Véhicules soldés par le paiement",
    amendDonePre: "mise à jour sous le même numéro",
    amendDoneResend: "Renvoyez-la au client.",
    amendDoneTitle: "Facture mise à jour",
    amendNoChange:
      "Les valeurs des véhicules sont les mêmes que celles de la facture : rien n'a changé. Pour changer le montant, modifiez le devis du véhicule ; la facture suit sous le même numéro.",
    amendedResendBadge: "à renvoyer au client",
    amendedResendHint:
      "Le devis a changé après l'émission et la facture a été refaite sous le même numéro. Envoyez la nouvelle version au client (E-mail) ou marquez-la comme envoyée hors Gestion.",
    amendedResentNote: "version actuelle déjà envoyée au client",
    amendedTitle: "Modifiée le",
    amountHtLabel: "Montant HT",
    attach: "Joindre",
    attachMenu: "Joindre un PDF externe",
    attachPdfErrorPre: "Erreur lors de la jointure du PDF : ",
    attachStatement: "Joindre le relevé de compte (factures en attente)",
    attachTitle:
      "Joindre le PDF externe de cette facture (utilisé dans le rapport mensuel au comptable)",
    avoirBtn: "Avoir",
    avoirCreateErrorTitle: "Erreur lors de la création de l'avoir",
    avoirCreatedMid: " — TTC ",
    avoirCreatedSuf: ".",
    avoirCreatedTitle: "Avoir créé",
    avoirDeleteConfirmPre: "Supprimer l'avoir ",
    avoirDeleteConfirmSuf: " ? Cette action est irréversible.",
    avoirDeleteConfirmTitle: "Supprimer l'avoir ?",
    avoirDeleteErrorTitle: "Erreur lors de la suppression de l'avoir",
    avoirDeleteTitle: "Supprimer l'avoir",
    avoirFullBtn: "Avoir complet",
    avoirMenu: "Émettre un avoir",
    avoirModalTitle: "Avoir (note de crédit)",
    avoirNumberLabel: "N° de l'avoir",
    avoirPartialBtn: "Avoir partiel",
    avoirStatusCancelled: "annulé",
    avoirStatusEmbedded: "déjà déduit dans la facture",
    backAllClients: "Tous les clients",
    badgeAmended: "modifiée",
    badgeCancelled: "annulée",
    badgeIssued: "émise",
    badgePaid: "encaissée",
    badgeVoid: "annulée",
    bankChangeBtn: "Changer de compte",
    bankChangeDone:
      "Compte changé : le PDF a été régénéré avec le même numéro. Renvoyez-le au client.",
    bankChangeLocked: "facture payée : le compte ne change pas",
    bankChangeReasonPh: "Motif du changement (journal d'audit)",
    bankChangeResend: "Renvoyer par e-mail",
    bankChangeSave: "Changer et régénérer le PDF",
    bulkAttachLabel: "Joindre des PDF en masse :",
    bulkDoneTitle: "Envoi en masse terminé",
    bulkErrorTitle: "Erreur lors de l'envoi en masse",
    bulkFailedMid: " ont échoué à l'envoi : ",
    bulkFailedPre: "❌ ",
    bulkHintMid: "). ",
    bulkHintOr: " ou ",
    bulkHintPre: "Nommez chaque PDF comme la facture (ex. : ",
    bulkHintStrong: "« Sélectionner un dossier »",
    bulkHintSuf: " récupère tout d'un coup.",
    bulkOkPre: "✅ ",
    bulkOkSuf: " PDF joint(s) avec succès.",
    bulkSelectTitle:
      "Sélectionnez plusieurs PDF à la fois ; chacun est joint à la facture du même numéro",
    bulkUnmatchedMid: " sans facture correspondante : ",
    bulkUnmatchedPre: "⚠️ ",
    byClientColCount: "Factures",
    byClientColOverdue: "En retard",
    byClientHint:
      "Cliquez sur le client pour ouvrir ses factures. En retard = émise, sans encaissement et échéance dépassée.",
    cancel: "Annuler",
    cancelInvoiceBtn: "Annuler la facture",
    cancelInvoiceHint: "La facture est annulée (le numéro n'est pas réutilisé). Indiquez le motif.",
    cancelledOn: "Annulée le",
    checking: "Vérification…",
    chipAll: "Toutes",
    chipAmended: "Modifiées — à renvoyer",
    chipAwaiting: "En attente",
    chipOverdue: "En retard",
    chipPartial: "Partiel",
    chipsAria: "Filtrer par situation",
    cleanDuplicates: "Nettoyer les doublons",
    cleanupDoneTitle: "Nettoyage terminé",
    cleanupErrorTitle: "Erreur lors du nettoyage",
    clearFilters: "effacer les filtres",
    clearSearch: "effacer",
    clearSearchTitle: "Effacer la recherche",
    clearSelection: "effacer la sélection",
    close: "Fermer",
    colActions: "Actions",
    colCars: "Véhicules",
    colCustomer: "Client",
    colDate: "Date",
    colHt: "HT",
    colInvoiceNumber: "N° facture",
    colNum: "N°",
    colServices: "Services",
    colSituation: "Situation",
    colStatus: "Statut",
    colTotal: "Total",
    colTotalHt: "Total HT",
    colTtc: "TTC",
    colType: "Type",
    collectBtn: "Relancer",
    companyLabel: "Société :",
    consolidatedBadge: "multi-véhicules",
    consolidatedExplain:
      "Facture multi-véhicules (une seule facture pour plusieurs dossiers, ex. : facture mensuelle du client). Ouvrez chaque véhicule via les dossiers.",
    consolidatedNoLinkHint: "Facture consolidée (plusieurs dossiers) — ouvrir via les dossiers",
    createAvoirBtn: "Créer l'avoir",
    creating: "Création…",
    creditNoteTitle: "Générer un avoir (note de crédit)",
    creditTypeCommercial: "Remise commerciale (réduit le CA)",
    creditTypeError: "Correction d'erreur (réduit le CA)",
    creditTypeIrrecoverable: "Irrécouvrable (perte, ne réduit pas le CA)",
    creditTypeReturn: "Retour (réduit le CA)",
    customersWord: "clients",
    dayWord: "jour",
    daysWord: "jours",
    dedupeConfirmP1: "J'ai trouvé ",
    dedupeConfirmP2: " copie(s) en double dans ",
    dedupeConfirmP3: " document(s) (~",
    dedupeConfirmP4:
      " Mo). Je conserve toujours la plus récente de chacune et supprime le reste. Cette action est irréversible. Confirmer ?",
    dedupeTitle: "Supprime les copies en double du même PDF (conserve la plus récente)",
    deleteConfirm: "Supprimer",
    detailBankAccount: "Compte de paiement",
    detailCars: "Véhicules",
    detailDue: "Échéance",
    detailEditHint:
      "Facture émise : quand le devis du véhicule change, elle est mise à jour sous le même numéro et marquée « à renvoyer au client ». Remise ponctuelle : avoir.",
    detailGeneratePdf: "Générer le PDF",
    detailIssued: "Émise",
    detailReceived: "Encaissé",
    detailReceivedOn: "Reçue le",
    email: "E-mail",
    emailBtn: "E-mail",
    emailFailedTitle: "Échec de l'envoi",
    emailMessageLabel: "Message (optionnel)",
    emailMessagePh: "Remplace la phrase standard de l'e-mail. La facture reste en pièce jointe.",
    emailModalInvoicePre: "Facture",
    emailModalTitle: "Envoyer la facture par e-mail",
    emailSentMid: " envoyée à ",
    emailSentPre: "Facture ",
    emailSentSuf: ".",
    emailSentTitle: "E-mail envoyé",
    emailTitle: "Envoyer la facture par e-mail",
    emptyState: "Aucune facture.",
    filterCompanyLabel: "Société",
    filterSearchLabel: "Rechercher",
    filterStatusLabel: "Statut",
    folderSelectTitle:
      "Choisissez le DOSSIER entier de PDF — sans avoir à les sélectionner un par un",
    generatePdfOption: "Générer le PDF ▾",
    generatePdfTitle:
      "Générer le PDF de la facture — la langue provient de la société (Euro Storm → français, Brazilian Storms → anglais) ou choisissez ici",
    generateReportBtn: "Générer le rapport (PDF avec liens)",
    generating: "Génération…",
    invalidMonthMsg: "Choisissez un mois valide.",
    invalidMonthTitle: "Mois invalide",
    langAuto: "Langue automatique",
    loading: "Chargement…",
    markSentMenu: "Marquer comme envoyée (hors Gestion)",
    markSentPh: "Ex. : remise en main propre, envoyée par WhatsApp",
    markSentTitle: "Comment la facture a-t-elle été remise au client ?",
    matchingFiles: "Association des fichiers aux factures…",
    modifyBtn: "Modifier la facture",
    modifyHint:
      "La facture est refaite avec les valeurs actuelles du véhicule (devis et ordre de réparation), sous le MÊME numéro et pour le même client. La version précédente est conservée et la facture est marquée « à renvoyer au client ». Pour changer le montant, modifiez d'abord le devis du véhicule. Motif :",
    monthlyChartTitle: "Facturé par mois (HT)",
    monthlyInReportNote: "Le facturé par mois est dans Rapports → Rapport CA.",
    monthlyReportLabel: "Rapport mensuel (comptable) :",
    moreBtn: "Plus",
    next: "Suivant",
    noCustomerEmailMsg: "Client sans e-mail enregistré — indiquez une adresse.",
    noDuplicatesMsg: "Aucune pièce jointe en double trouvée dans cette société.",
    noDuplicatesTitle: "Aucun doublon",
    noInvoices: "Aucune facture",
    noPdfYet: "PDF pas encore généré — utilisez le menu ⋮",
    openDetailTitle: "Ouvrir la facture (actions, véhicules, encaissements)",
    openDossierBtn: "Ouvrir le dossier",
    openInvoiceBtn: "Ouvrir",
    openPdfErrorPre: "Erreur lors de l'ouverture du PDF : ",
    or: "ou",
    overdueBadge: "en retard",
    overdueSince: "Échue le",
    pagePre: "Page ",
    pageSubInvoices: "factures",
    pageTitle: "Factures",
    pdfAttachedMsg:
      "Le PDF externe a été joint à la facture et sera utilisé dans le rapport mensuel au comptable.",
    pdfAttachedTitle: "PDF joint",
    pdfAutoAttachedMsg: "Le PDF de la facture est joint automatiquement.",
    pdfBtn: "PDF",
    pdfErrorPre: "Erreur lors de la génération du PDF : ",
    pdfMenuGen: "Générer le PDF en",
    pdfMenuRegen: "Régénérer le PDF en",
    previous: "Précédent",
    reasonLabel: "Motif (optionnel)",
    reasonPlaceholder: "Remise 40% sur le devis…",
    receivedOnPre: "reçue le",
    recipientEmailLabel: "E-mail du destinataire",
    recipientEmailPlaceholder: "client@exemple.com",
    regeneratePdfTitle: "Régénérer le PDF (remplace le fichier actuel)",
    registerReceiptBtn: "Enregistrer l'encaissement",
    reissueBtn: "Réémettre",
    reissueDonePre: "Nouvelle facture :",
    reissueDoneTitle: "Facture réémise",
    reissueHint:
      "Annule cette facture et en émet une nouvelle avec les valeurs actuelles du dossier (nouveau numéro). Indiquez le motif.",
    relancerBtn: "Relancer",
    relancerTitle: "Envoyer une relance de cette facture par e-mail, PDF joint",
    remainingPre: "reste",
    reminderBatchMultiCustomers:
      "Factures de plusieurs clients : chaque client reçoit un e-mail à l'adresse de facturation enregistrée, avec ses factures en pièce jointe.",
    reminderBatchSentTitle: "Relances envoyées",
    reminderBatchTitlePre: "Relancer",
    reminderBatchTitleSuf: "factures",
    reminderModalHint:
      "Un e-mail de RELANCE (rappel de paiement) sera envoyé avec la facture PDF en pièce jointe.",
    reminderModalTitle: "Relancer le client",
    removeDuplicatesConfirm: "Supprimer les doublons",
    removeDuplicatesTitle: "Supprimer les pièces jointes en double",
    removedDuplicatesPre: "Supprimé ",
    removedDuplicatesSuf: " doublon(s).",
    replacedBy: "remplacée par",
    reportErrorPre: "Erreur lors de la génération du rapport : ",
    reportGeneratedTitle: "Rapport généré",
    reportHint:
      "Liste les factures émises dans le mois avec un lien pour télécharger le PDF de chacune (pièce jointe externe si elle existe, sinon celle générée).",
    reportMsgP1: " facture(s) sur le mois · Total HT ",
    reportMsgP2: " · TTC ",
    reportMsgP3: ".",
    reportWarnPre: " ⚠️ ",
    reportWarnSuf:
      " facture(s) sans PDF — joignez le PDF sur la ligne de la facture (bouton « ⬆ Joindre ») et régénérez.",
    resyncApplyPre: "Appliquer sur",
    resyncBtn: "Resynchroniser les montants",
    resyncBtnTitle:
      "Corrige le montant de la facture à partir des lignes du dossier (après un Recalculer les commissions)",
    resyncClose: "Fermer",
    resyncColInvoice: "Facture",
    resyncColNew: "Corrigé (HT)",
    resyncColOld: "Montant actuel (HT)",
    resyncColReceipt: "Encaissement eDSP",
    resyncDoneSuf: "facture(s) corrigée(s). Lancez ensuite le Synchroniser/Recompute fiscal.",
    resyncEmpty: "Tout est cohérent — aucune facture ne diffère des lignes.",
    resyncHelp:
      "Liste les factures de l'exercice ouvert dont le montant diffère de la somme des lignes du dossier (ex. : devis gonflé de l'ancien importateur). Appliquer corrige le montant de la facture et l'encaissement eDSP correspondant. Rien n'est modifié sans votre confirmation.",
    resyncLoading: "Analyse…",
    resyncRun: "Vérifier les écarts",
    resyncTitle: "Resynchroniser les montants (lignes → factures)",
    searchPlaceholder:
      "Rechercher n° de facture ou immatriculation… (ex. : F2025-00274, GK-294-GV)",
    selectAllOpenTitle: "Sélectionner toutes les factures ouvertes de cette page",
    selectFolder: "Sélectionner un dossier",
    selectForReminderTitle: "Sélectionner pour relance",
    selectPdfs: "Sélectionner des PDF…",
    selectedMany: "factures sélectionnées",
    selectedOne: "facture sélectionnée",
    send: "Envoyer",
    sendReminder: "Envoyer la relance",
    sending: "Envoi…",
    sendingProgressPre: "Envoi ",
    showingMid: " sur ",
    showingPre: "Affichage de ",
    sitAwaiting: "à encaisser",
    sitUncollectible: "Irrécouvrable",
    sortByDateTitle: "Trier par date (la plus récente d'abord)",
    sortByNumberTitle: "Trier par numero de facture (cliquer pour inverser)",
    statusCancelled: "Annulée",
    statusIssued: "Émise",
    statusPaid: "Encaissée",
    statusVoid: "Annulée",
    toastErrorTitle: "Erreur",
    toolsBtn: "Outils",
    ttcCalculatedLabel: "TTC (calculé)",
    ttcInputLabel: "Montant TTC",
    tvaLabel: "TVA %",
    typeCommercial: "Remise",
    typeError: "Erreur",
    typeIrrecoverable: "Irrécouvrable",
    typeReturn: "Retour",
    uncollectibleBtn: "Déclarer irrécouvrable",
    uncollectibleHint:
      "La facture reste émise, mais sort des relances et de la liste en retard. Indiquez le motif (conservé dans l'audit).",
    uncollectibleTitle: "Déclarer la facture irrécouvrable",
    uncollectibleUndoBtn: "Annuler l'irrécouvrable",
    unsentBadge: "non envoyée",
    unsentBadgeTitle: "Aucun envoi de cette facture au client enregistré dans Gestion.",
    unsentHint:
      "Envoyez-les avec le ✉ de la ligne, ou marquez-les comme envoyées via le menu ⋮ si elles ont été remises autrement.",
    unsentMany: "factures émises pas encore envoyées au client",
    unsentOne: "facture émise pas encore envoyée au client",
    unsentShowAll: "Afficher toutes",
    unsentShowOnly: "Voir seulement les non envoyées",
    uploadFailedPre: "Échec de l'envoi (HTTP ",
    uploadFailedSuf: ").",
    vehiclesMoreHint: "Voir tous les véhicules de cette facture",
    versionUntil: "valable jusqu'au",
    versionsTitle: "Versions précédentes",
    voidInvoiceBtn: "Invalider la facture",
    voidInvoiceHint: "Invalide une facture déjà encaissée. Indiquez le motif.",
  },
  modals: {
    alertTitle: "Avertissement",
    cancel: "Annuler",
    close: "Fermer",
    confirm: "Confirmer",
    invalidValue: "Montant invalide",
    maxAbbr: "max",
    minAbbr: "min",
    ok: "OK",
  },
  monthlyEntryGrid: {
    aTrierTitlePre: "Entrées sans catégorie/rapprochement ce mois :",
    cellEmpty: "— vide —",
    colActions: "Actions",
    colBilan: "Bilan ?",
    colChargesExternes: "Charges externes",
    colMonth: "Mois",
    colOtherCharges: "Autres charges",
    colOtherIncome: "Autres produits",
    colRecettes: "Recettes HT",
    colStatus: "Statut",
    createBtn: "créer",
    editBtn: "modifier",
    lockBtn: "verrouiller",
    monthApril: "Avril",
    monthAugust: "Août",
    monthDecember: "Décembre",
    monthFebruary: "Février",
    monthJanuary: "Janvier",
    monthJuly: "Juillet",
    monthJune: "Juin",
    monthMarch: "Mars",
    monthMay: "Mai",
    monthNovember: "Novembre",
    monthOctober: "Octobre",
    monthSeptember: "Septembre",
    statusLocked: "🔒 verrouillé",
    statusOpen: "ouvert",
    totalLabel: "Total",
    unlockBtn: "déverrouiller",
  },
  notFound: {
    backHome: "Retour à l'accueil",
    title: "Page introuvable",
  },
  operationBoard: {
    allCustomers: "Tous les clients",
    degarnChip: "dégarnissage en attente",
    degarnChipTitle: "PDR terminé ; il manque qui a fait le dégarnissage",
    empty: "Aucun véhicule dans cette situation.",
    emptyAll: "Aucun véhicule en opération.",
    franchiseChip: "franchise",
    hideDelivered: "Masquer les livrés",
    moreCars: "autres véhicules",
    noChantier: "Hors chantier",
    notReceived: "sans réception",
    openList: "Ouvrir la liste",
    showDelivered: "Afficher les livrés",
    statusDelivered: "Livré",
    statusInRepair: "En réparation",
    statusRepaired: "Réparé",
    statusToRepair: "À réparer",
    title: "Véhicules en opération",
    totalWord: "véhicules",
  },
  pagination: {
    aria: "Pages de la liste",
    next: "Suivant",
    of: "sur",
    page: "Page",
    prev: "Précédent",
  },
  paymentAllocation: {
    alreadyReceived: "déjà encaissé",
    available: "Disponible",
    cancelBtn: "Annuler",
    cars: "véhicules",
    colCar: "Véhicule",
    colOrder: "Ordre",
    colStatus: "Situation",
    colTech: "Technicien",
    colValue: "Montant HT",
    creditLeft: "Reste en crédit",
    exceeds: "Les véhicules cochés dépassent le montant encaissé",
    hint: "Paiement partiel d'une facture multi-véhicules : cochez les véhicules soldés par ce montant. Seuls eux libèrent le reversement au technicien ; le reste reste en crédit sur la facture pour le prochain paiement. Le Gestion propose déjà les plus anciens.",
    invoiceBtn: "Véhicules payés",
    invoiceBtnTitle: "Paiement partiel : définir les véhicules soldés par le montant encaissé",
    invoiceTotal: "facture",
    linkBtn: "Lier et solder les cochés",
    linkNoCarsBtn: "Lier sans choisir de véhicules",
    linkNoCarsTitle: "Tout le montant reste en crédit ; aucun véhicule n'est libéré",
    loading: "Chargement…",
    lockProforma: "Dans une proforma active — ne peut pas être retiré",
    lockTechPaid: "Technicien déjà payé — ne peut pas être retiré",
    saveBtn: "Enregistrer",
    selected: "Cochés",
    stPaid: "soldé",
    suggestBtn: "Proposer les plus anciens",
    techGets: "reversement",
    thisDeposit: "ce virement",
    title: "Quels véhicules ce paiement solde-t-il ?",
  },
  proformaDetail: {
    add: "Ajouter",
    addItemBtn: "+ Ajouter un élément",
    addItemTitle: "Ajouter un élément",
    adding: "Ajout…",
    advancesExpected: "Montant attendu de la facture :",
    advancesHint:
      "La facture du technicien doit comporter la déduction de ces avances. Décochez ce qu'il n'a PAS déduit (reste ouvert pour la prochaine).",
    advancesTitle: "Avances à déduire",
    allAlreadyImported: "Tous les éléments avaient déjà été importés.",
    alreadyExistedSuffix: "existai(en)t déjà.",
    alreadyImported: "✓ Déjà importée",
    alsoSendEmail: "Envoyer aussi par e-mail maintenant",
    attachInvoicePdfLabel: "Joindre le PDF de la facture (optionnel)",
    attachPdf: "📎 Joindre un PDF",
    auditAdminOnlyPost: "pour le journal complet.",
    auditAdminOnlyPre: "Seuls les administrateurs peuvent voir l'historique ici. Accédez à",
    byPlate: "(par plaque)",
    canReattachLater: "Vous pourrez la rejoindre plus tard.",
    cancel: "Annuler",
    cancelMirrorsBlockedMid: "sur",
    cancelMirrorsBlockedPre: "Annulation impossible :",
    cancelMirrorsBlockedSuf:
      "dossier(s) miroir dans la société destinataire sont déjà payés, mis en proforma ou facturés. Réglez-le là-bas d'abord.",
    cancelMirrorsPre: "Cette proforma a déjà été importée dans la société destinataire :",
    cancelMirrorsSuf: "dossier(s) miroir y seront supprimés à l'annulation.",
    colAction: "Action",
    colAmount: "Montant",
    colCustomerVehicle: "Client / Véhicule",
    colDate: "Date",
    colDescription: "Description",
    colDossierBs: "Dossier BS",
    colExpected: "Attendu",
    colGross: "Brut",
    colInBs: "Chez BS",
    colIntermShare: "Intermédiaire",
    colInvoice: "Facture",
    colInvoiced: "Facturé",
    colInvoicedTitle: "Facturé HT au client pour le travail de ce technicien sur le véhicule",
    colMargin: "Marge",
    colMarginTitle: "Facturé − payé au technicien (reste à la société)",
    colNet: "Net",
    colOk: "OK ?",
    colPlate: "Plaque",
    colReasonChanges: "Motif / Modifications",
    colTechShare: "Technicien",
    colTechnician: "Technicien",
    companiesBold: "Entreprises",
    confirm: "Confirmer",
    dossierIdHelp:
      "Le backend valide R12 (job dans une seule proforma active) et l'appartenance à la société.",
    dossierIdLabel: "ID du dossier",
    dossierIdPlaceholder: "ex : 501",
    dossierWord: "dossier",
    dossiersCreatedSuffix: "dossier(s) créé(s) dans la société destinataire.",
    emailFailedPre: "Proforma envoyée, mais l'e-mail a échoué pour :",
    emailResendFailed: "Échec du renvoi de l'e-mail",
    emailResent: "E-mail renvoyé.",
    errInvalidDossierId: "ID de dossier invalide.",
    errInvalidEmail: "E-mail invalide :",
    errNoRecipient:
      "Cochez l'e-mail enregistré ou saisissez un autre e-mail (ou décochez l'envoi par e-mail).",
    errReasonRequired: "Motif obligatoire.",
    errRetentionRange: "La retenue doit être comprise entre 0 et 100.",
    errSelectTechnician: "Sélectionnez un technicien.",
    errSupplierInvoiceNumberRequired: "Indiquez le n° de la facture du fournisseur.",
    errTooManyRecipients: "5 destinataires au maximum.",
    error: "Erreur",
    expectedProforma: "Attendu (proforma)",
    extHint:
      "Enregistrement interne : sans e-mail, PDF ni facture du technicien. Les pièces ci-dessous sont payées.",
    extMethodDinheiro: "Espèces",
    extMethodOutro: "Autre",
    extMethodSalario: "Salaire (équipe interne)",
    extMethodTransferencia: "Virement",
    extTitle: "Payé hors proforma (enregistrement interne)",
    extUndoBtn: "Annuler (les pièces repassent à payer)",
    extUndoCancel: "Retour",
    extUndoConfirm: "Annuler le paiement",
    extUndoReasonPh: "Motif (5 lettres minimum)",
    extUndoneReason: "Motif",
    extUndoneTitle: "Paiement hors proforma annulé",
    importBtnTitle:
      "Crée des dossiers propres dans la société destinataire à partir des éléments de cette proforma",
    importConfirmMid: "dossier(s) vers",
    importConfirmPre: "Importer",
    importConfirmSuffix:
      "Crée des dossiers propres dans la société destinataire (client = société émettrice).",
    importFailed: "Échec de l'importation",
    importTo: "Importer vers",
    importedWithWarnings: "Importé avec avertissements",
    importing: "Importation…",
    intercompanyHint:
      "Cette proforma est intersociété. Envoyez-la (passez le statut à « envoyée ») pour activer l'importation des dossiers vers la société destinataire.",
    invalidId: "ID invalide.",
    invoiceSavedUploadFailedPre: "Facture enregistrée, mais l'envoi du PDF a échoué",
    kpiAdvancesShort: "avances",
    kpiGross: "Brut",
    kpiNet: "Net",
    kpiPeriod: "Période",
    kpiRetention: "Retenue",
    kpiToPay: "À payer",
    linesWithoutCommission: "ligne(s) sans commission configurée (créées en legacy) :",
    loading: "Chargement…",
    loadingAudit: "Chargement du journal…",
    marginAlert:
      "La proforma paie autant ou plus que le montant facturé au client — vérifiez avant d'envoyer.",
    marginGross: "Marge brute de la société",
    marginHint: "Facturé = somme HT des lignes de ce technicien sur les véhicules de la proforma.",
    marginInvoiced: "Facturé au client (HT)",
    marginPaid: "Payé par cette proforma",
    marginTitle: "Contrôle de marge (interne — non envoyé au technicien)",
    mirrorAllOk: "✓ Tout est mis en miroir et les montants correspondent",
    mirrorCheckPre: "Vérification du miroir chez",
    mirroredBs: "Mis en miroir (BS)",
    mirroredCount: "mis en miroir",
    missing: "✗ manquant",
    noAuditEntries: "Aucune entrée de journal d'audit.",
    noEmailOtherPre:
      "Destinataire sans e-mail enregistré. Pour envoyer la proforma, cochez « Envoyer aussi par e-mail maintenant » et saisissez l'adresse dans « Autre e-mail (facultatif) ». Sinon elle est seulement marquée comme envoyée. Pour ne plus avoir à la saisir, enregistrez l'e-mail dans",
    noEmailWarnMid: "et utilisez",
    noEmailWarnPost: "ensuite.",
    noEmailWarnPre:
      "⚠ Destinataire sans e-mail enregistré. La proforma sera marquée comme envoyée (transition administrative) mais aucun e-mail ne sera envoyé. Pour envoyer un e-mail, enregistrez l'e-mail du destinataire dans",
    noItemsYet: "Aucun élément pour l'instant.",
    noOtherServices: "Aucun autre service.",
    noPdfAttached: "(aucun PDF joint)",
    notFound: "Proforma introuvable dans les sociétés accessibles.",
    optIntercompanyInvoice: "Facture intersociété",
    optTechnicianInvoice: "Facture technicien",
    otherEmailHint:
      "Plusieurs : séparez par une virgule. Valable pour cet envoi seulement — la fiche ne change pas.",
    otherEmailLabel: "Autre e-mail (facultatif)",
    pdfAttachedNote: "(le PDF de la proforma est joint)",
    pdfBtn: "📄 Télécharger le PDF",
    pdfBtnTitle: "Ouvre le PDF de la proforma (celui envoyé par e-mail)",
    pdfErrorPre: "Impossible d'ouvrir le PDF : ",
    pdfGenerating: "Génération du PDF…",
    processing: "Traitement…",
    reasonLabel: "Motif",
    reasonPlaceholder: "Obligatoire pour le journal d'audit.",
    recipientEmailLabel: "E-mail du destinataire",
    recipientPrefix: "Pour",
    refreshItemsBtn: "Recalculer les montants",
    refreshItemsDoneSuf: "élément(s) mis à jour",
    refreshItemsHint:
      "Recalcule les montants des éléments à partir des lignes actuelles (ex. : moitié du montage cochée après la création de la proforma).",
    refreshItemsNone: "Aucun montant n'a changé.",
    refreshItemsResend:
      "La proforma avait déjà été envoyée : renvoyez l'e-mail au technicien pour qu'il reçoive les nouveaux montants.",
    registeredEmailTag: "e-mail enregistré",
    remainingPre: "reste",
    removeBtn: "supprimer",
    removeConfirmPre: "Supprimer",
    requiresAdminRole: "Rôle admin requis",
    resendConfirmPre: "Renvoyer la proforma par e-mail à",
    resendEmail: "📧 Renvoyer l'e-mail",
    resendEmailBold: "📧 Renvoyer l'e-mail",
    resendInvalidEmail: "Adresse e-mail invalide.",
    resendPromptMessage:
      "Vérifiez ou modifiez l’adresse du destinataire. La modification ne vaut que pour cet envoi — la proforma et le PDF ne changent pas.",
    resendPromptPlaceholder: "destinataire@exemple.com",
    resendPromptTitle: "Renvoyer la proforma par e-mail",
    resendSendBtn: "Envoyer",
    resendSentToPre: "E-mail envoyé à",
    resendTo: "Renvoyer à",
    retentionLabel: "Retenue (%)",
    returnedInvoice: "Facture retournée",
    returnedInvoiceTypeLabel: "Type de facture retournée",
    selectPlaceholder: "— sélectionner —",
    sendFirst: "envoyez d'abord la proforma",
    sendToLabel: "Envoyer à",
    sending: "Envoi…",
    sentNoEmail:
      "Proforma marquée comme envoyée (sans e-mail automatique). Utilisez 📧 Renvoyer l'e-mail quand vous voulez déclencher l'envoi.",
    sentWithEmailPost: "S'il n'arrive pas, utilisez 📧 Renvoyer l'e-mail pour réessayer.",
    sentWithEmailPre: "Proforma marquée comme envoyée et e-mail envoyé à",
    splitTotalsLabel: "Totaux (technicien · intermédiaire · brut)",
    statusApproved: "approuvée",
    statusCancelled: "annulée",
    statusClosed: "fermée",
    statusDraft: "brouillon",
    statusInvoiceReceived: "facture reçue",
    statusPaid: "payée",
    statusRejected: "rejetée",
    statusSent: "envoyée",
    supplierInvoiceNumberHelp:
      "Numéro du document émis par le fournisseur (la facture qu'il a envoyée).",
    supplierInvoiceNumberLabel: "N° de la facture du fournisseur",
    supplierInvoiceNumberPlaceholder: "ex : BS-2026-0042",
    tabAudit: "Journal d'audit",
    tabItems: "Éléments",
    tabOtherServices: "Autres services",
    technicianLabel: "Technicien",
    techniciansBold: "Techniciens (fiche du technicien)",
    transApprove: "Approuver",
    transCancel: "Annuler",
    transCancelAdmin: "Annuler (admin)",
    transClose: "Fermer",
    transMarkPaid: "Marquer payée",
    transReceiveInvoice: "Enregistrer la facture",
    transReject: "Rejeter",
    transReopen: "Rouvrir",
    transSend: "Envoyer",
    uploadFailed: "Échec de l'envoi",
    uploading: "Envoi…",
    uploadingAttachment: "Envoi de la pièce jointe…",
    valueMismatch: "≠ montant",
  },
  proformaNew: {
    addAtLeastOne: "Ajoutez au moins 1 dossier.",
    addEditDossiers: "Ajouter / modifier des dossiers",
    allCustomers: "Tous les clients",
    allTechnicians: "Tous les techniciens",
    backToList: "← Retour à la liste",
    backendQueryError: "Erreur dans la requête backend",
    causesPost: "et ne sélectionnez que des dossiers avec un technicien déjà enregistré.",
    causesPre:
      "Causes possibles : dossiers sans technicien assigné, dossiers dans une société différente de celle sélectionnée (Euro Storm Débosselage), ou dossiers sans client. Retournez à",
    changeCompanyTitle: "Changez de société en revenant à l'étape 1",
    clientRetentionLabel: "Retenue du client",
    clientRetentionSubtitle: "ce que le client conserve",
    colCustomer: "Client",
    colDate: "Date",
    colDossier: "Dossier",
    colGross: "Brut",
    colInterm: "Interm.",
    colPlate: "Plaque",
    colTec: "Tech.",
    colTechnician: "Technicien",
    colTotal: "Total",
    commissionIntermShort: "Commission interm.",
    commissionIntermediary: "Commission de l'intermédiaire",
    commissionTecShort: "Commission tech.",
    commissionTechnician: "Commission du technicien",
    commissionTechnicianReceive: "Commission du technicien — ce que le technicien va recevoir",
    conflictsBannerSuffix:
      " dossier(s) sont déjà dans une autre proforma active — retirez-les avant de créer :",
    createProformaDraft: "Créer proforma (BROUILLON)",
    creating: "Création…",
    customMessageLabel: "Message pour le destinataire (facultatif)",
    customMessagePlaceholder: "Texte libre qui apparaît dans le corps de l'e-mail.",
    dateFromTitle: "Date de début",
    dateToTitle: "Date de fin",
    dossierInActiveProformaPre: "Dossier déjà dans une proforma active (ligne ",
    dossiersSelectedSuffix: "dossier(s) sélectionné(s).",
    dossiersWordSuffix: "dossier(s)",
    emailHelper:
      "Facultatif. Sans e-mail enregistré, la proforma n'est disponible qu'en téléchargement manuel du PDF.",
    emailPlaceholderIntercompany: "Rempli automatiquement si la société a un e-mail enregistré",
    emailPlaceholderPartner: "Saisir manuellement (partenaire externe)",
    emailPlaceholderTechnician: "Rempli automatiquement si le technicien a un e-mail enregistré",
    eurostormKeepsLabel: "Euro Storm conserve",
    eurostormNegativeSubtitle: "⚠ négatif — la proforma couvre plus que ce qu'Euro Storm reçoit",
    eurostormPositiveSubtitle: "sur ces dossiers, après paiement de la proforma",
    fieldDestinatario: "Destinataire",
    fieldIdioma: "Langue",
    fieldItens: "Éléments",
    fieldTipo: "Type",
    filterCustomerTitle: "Filtrer par client",
    filterPlateTitle: "Filtrer par plaque",
    financialSummaryDesc:
      "Aperçu informatif du flux d'argent. Ne modifie pas la proforma — aide seulement à approuver en contexte.",
    financialSummaryTitle: "Résumé financier de ces dossiers",
    grossColTitle: "Commission V3 à facturer (dépend du type de destinataire)",
    grossQuoteLabel: "Devis brut (Prix Brut)",
    grossTotal: "Total brut",
    inProformaBadge: "en proforma",
    invalidRetention: "Retenue invalide (0..100).",
    issuerCompanyLabel: "Société émettrice :",
    loadedReadySuffix: " dossier(s) chargé(s) — prêt à réviser.",
    loading: "Chargement…",
    loadingDossierLines: "Chargement des lignes des dossiers…",
    net: "Net",
    nextArrow: "Suivant →",
    noCompanyAccess: "Vous n'avez accès à aucune société.",
    noDossierInFilter: "Aucun dossier dans le filtre. Ajustez la période ou le technicien.",
    noLinesReturned: "Aucune ligne retournée par les dossiers sélectionnés",
    notesLabel: "Notes (interne)",
    notesPlaceholder: "Ex : payé par virement, commission supplémentaire…",
    pairMismatchHint:
      "La proforma utilise les montants des LIGNES. Corrigez d'abord dans Dossier → Lignes → Modifier la commission (l'intermédiaire de chaque ligne), puis revenez ici.",
    pairMismatchLines: "lignes",
    pairMismatchOpen: "ouvrir le dossier",
    pairMismatchPair: "couple",
    pairMismatchTitle:
      "Les lignes de ces véhicules ont été calculées avec une autre part de l'intermédiaire que celle du couple technicien × client :",
    partnerHelper: "Partenaire externe (hors groupe). Sans contrainte CHECK stricte.",
    partnerParenSuffix: "(partenaire)",
    pdfLanguageLabel: "Langue du PDF",
    platePlaceholder: "Plaque",
    populatingSelection: "Remplissage de la sélection…",
    preselectedFromDossiersSuffix: " dossier(s) présélectionné(s) depuis /dossiers",
    preselectedLabel: "Dossiers présélectionnés",
    preselectionWaitTitle:
      "Attendez le chargement des dossiers, ou retournez à /dossiers si le message jaune ci-dessus signale un problème.",
    prevArrow: "← Précédent",
    proformaTotalForDossier: "Total de la proforma pour ce dossier (= tech + interm)",
    readOnlyNotice:
      "Lecture seule — la création de proforma requiert une autorisation de modification.",
    recipientCompanyLabel: "Société destinataire",
    recipientEmailLabel: "E-mail du destinataire",
    recipientPartnerLabel: "Société partenaire (FK app-layer)",
    recipientTechnicianLabel: "Technicien destinataire",
    recipientTypeIntercompany: "Société du groupe",
    recipientTypePartner: "Partenaire externe",
    recipientTypeTechnician: "Technicien",
    removeAria: "Supprimer",
    removeConflictsPre: "Supprimer les",
    removeConflictsSuf: "en conflit",
    removeConflictsTitlePre: "Retirez les",
    removeConflictsTitleSuf: "dossier(s) déjà dans une autre proforma avant de créer.",
    removeDossierTitle: "Retirer ce dossier de la proforma",
    removeHintPost: "ou ajoutez-en d'autres ci-dessous.",
    removeHintPre: "Retirez un dossier avec",
    retentionLabel: "Retenue",
    retentionLabel2: "Retenue (%) — appliquée à tous les éléments",
    reviewArrow: "Réviser →",
    searchPlaceholder: "Rechercher : dossier / plaque / n° facture",
    selectPlaceholder: "— sélectionnez —",
    step1Title: "Type de destinataire",
    step2Title: "Sélectionner des dossiers",
    step3Title: "Révision",
    stepDestinatario: "Destinataire",
    stepDossiers: "Dossiers",
    stepRevisao: "Révision",
    technicianParenSuffix: "(technicien)",
    thisProforma: "cette proforma",
    toPayTo: "À payer à",
    totalInvoicedClientLabel: "Total facturé au client",
    totalInvoicedClientSubtitle: "= Prix Brut − retenue (= Total Facture xlsx)",
  },
  proformas: {
    approveBtn: "✓ Approuver",
    approveBtnTitle: "Transition sent → approved en lot",
    approveConfirmMsg:
      "Seules les proformas « envoyée » sont approuvées. Les autres sont ignorées.",
    approveVerb: "Approuver",
    cancelBtn: "✕ Annuler",
    cancelBtnTitle: "Annule les proformas sélectionnées (R14 : bloque si IC déjà émise)",
    cancelConfirmLabel: "Annuler les proformas",
    cancelReasonMsg:
      "Annule les proformas dans tout état pré-IC. Le motif est obligatoire (va au journal d'audit).",
    cancelReasonPlaceholder: "Ex : client s'est désisté / doublon",
    cancelVerb: "Annuler",
    clearFilters: "✕ Effacer les filtres",
    clientAll: "Tous les clients",
    clientFilterTitle: "Client final des dossiers liés (pas le destinataire de la proforma)",
    clientLabel: "Client",
    colCreatedAt: "Créée le",
    colGross: "Brut",
    colInvoiced: "Facturé",
    colInvoicedTitle: "Facturé HT au client pour le travail du technicien de cette proforma",
    colNet: "Net",
    colRecipient: "Destinataire",
    colReference: "Référence",
    colStatus: "Statut",
    colTecExpected: "Tech. prévu",
    colTecExpectedTitle:
      "Montant du technicien selon les couples technicien×client (ce que la proforma doit demander)",
    colTecInvoiced: "Tech. facturé",
    colTecInvoicedTitle: "Montant des factures physiques déjà émises par les techniciens",
    colTecPct: "Tech. %",
    colTecPctTitle: "Pourcentage moyen pondéré de la commission technicien dans les dossiers",
    colType: "Type",
    companyLabel: "Société",
    dateFromTitle: "Date de début (created_at)",
    dateToTitle: "Date de fin (created_at)",
    dossiersWord: "dossier(s)",
    emptyState: "Aucune proforma trouvée.",
    errorMany: "erreurs",
    errorOne: "erreur",
    errorPrefix: "Erreur",
    errorTitle: "Erreur",
    errorsWord: "erreur(s)",
    importBtn: "📥 Importer vers BS",
    importBtnTitle:
      "Reflète les proformas intersociétés comme dossiers dans la société de destination (BS)",
    importConfirmLabel: "Importer vers BS",
    importConfirmMsg:
      "Reflète les dossiers des proformas intersociétés dans la société de destination (BS). Idempotent — déjà importées ou non éligibles (non intersociétés, pas encore envoyées) sont ignorées. Ne modifie pas le statut.",
    importLimitTitle: "Importation limitée à 200 par appel",
    importTitleSuf: "proforma(s) vers Brazilian Storms ?",
    importVerb: "Importer",
    imported: "Importées",
    inBS: "dans BS",
    includeDeleted: "Inclure les supprimées (annulées)",
    loading: "Chargement…",
    newBtn: "+ Nouvelle proforma",
    nextPage: "Suivant →",
    noCompanyAccess: "Vous n'avez accès à aucune société.",
    ofWord: "sur",
    okSuffix: "ok",
    pageWord: "Page",
    pdfBtnTitle: "Ouvrir le PDF de la proforma (celui envoyé par e-mail)",
    pdfErrorPre: "Impossible d'ouvrir le PDF : ",
    pdfErrorTitle: "Erreur",
    periodLabel: "Période (création)",
    prevPage: "← Précédent",
    proformasParen: "proforma(s)",
    proformasParenQ: "proforma(s) ?",
    proformasWord: "proforma(s)",
    recipientAll: "Tous les destinataires",
    recipientIntercompany: "Intersociétés",
    recipientLabel: "Destinataire",
    recipientPartner: "Partenaire",
    recipientTechnician: "Technicien",
    rejectReasonMsg: "Motif obligatoire pour le rejet.",
    rejectReasonPlaceholder: "Ex : écart sur le montant facturé",
    rejectVerb: "Rejeter",
    resendBtnTitle: "Régénère le PDF + renvoie l'e-mail",
    resendConfirmLabel: "Renvoyer",
    resendConfirmMsg:
      "Régénère le PDF et déclenche un nouvel envoi. Les échecs individuels ne bloquent pas les autres.",
    resendEmailBtn: "✉ Renvoyer l'e-mail",
    resendEmailOfPre: "Renvoyer l'e-mail de",
    resendLimitTitle: "Renvoi d'e-mail limité à 200 par appel",
    searchLabel: "Rechercher",
    searchPlaceholder: "Référence / destinataire…",
    selectCurrentPage: "Sélectionner la page actuelle",
    selectedMany: "sélectionnées",
    selectedOne: "sélectionnée",
    skippedImport: "ignorée(s) (non éligible ou déjà importée)",
    skippedMany: "ignorées",
    skippedOne: "ignorée",
    statusAll: "Tous les statuts",
    statusApproved: "approuvée",
    statusApprovedOpt: "Approuvée",
    statusCancelled: "annulée",
    statusCancelledOpt: "Annulée",
    statusClosed: "clôturée",
    statusClosedOpt: "Clôturée",
    statusDraft: "brouillon",
    statusDraftOpt: "Brouillon",
    statusInvoiceReceived: "facture reçue",
    statusInvoiceReceivedOpt: "Facture reçue",
    statusLabel: "Statut",
    statusPaid: "payée",
    statusPaidOpt: "Payée",
    statusRejected: "rejetée",
    statusRejectedOpt: "Rejetée",
    statusSent: "envoyée",
    statusSentOpt: "Envoyée",
    summaryApproved: "Approuvées",
    summaryCancelled: "Annulées",
    summaryEmailsSent: "E-mails envoyés",
    summaryStatusUpdated: "Statut mis à jour",
    technicianAll: "Tous les techniciens",
    technicianFilterTitle:
      "Technicien des lignes des dossiers (pas le destinataire quand type=Technicien)",
    technicianLabel: "Technicien",
    updateStatusConfirmLabel: "Mettre à jour",
    updateStatusConfirmMsg:
      "Seules les transitions valides seront appliquées. Les autres sont ignorées.",
    updateStatusOptApproved: "Approuver (sent → approved)",
    updateStatusOptClosed: "Clôturer (paid → closed)",
    updateStatusOptDefault: "↻ Mettre à jour le statut…",
    updateStatusOptPaid: "Marquer payée (invoice_received → paid)",
    updateStatusOptRejected: "Rejeter (sent → rejected)",
    updateStatusOptReopen: "Rouvrir (rejected → draft)",
    updateStatusOptSent: "Envoyer (draft → sent)",
    updateStatusSelectTitle:
      "Transition de statut générique (send/approve/reject/reopen/mark_paid/close)",
    updateStatusTitleMid: "pour",
    updateStatusTitlePre: "Mettre à jour le statut vers",
  },
  purchaseInvoices: {
    allSuppliers: "Tous les fournisseurs",
    attachBtnTitle: "Joindre / voir le PDF de la facture",
    attachFilesCta: "+ Joindre le(s) fichier(s) (sélection multiple possible · max. 25 Mo chacun)",
    attachmentsHelp:
      "Joignez le PDF/l'image de la facture du fournisseur. Le document devient le lien cliquable de la facture dans le PDF du relevé et dans les rapports envoyés au comptable.",
    attachmentsModalTitle: "Pièces jointes de la facture d'achat",
    bulkAttachTitle: "📎 Joindre des PDF en masse :",
    bulkAttachedSuf: "PDF joint(s) avec succès.",
    bulkDoneTitle: "Import en masse terminé",
    bulkErrorTitle: "Erreur lors de l'import en masse",
    bulkFailedSuf: "échecs à l'envoi",
    bulkHintFolderQuoted: "« Sélectionner un dossier »",
    bulkHintPre: "Nommez chaque PDF avec le n° externe de la facture (ex. :",
    bulkHintSuf: "les prend tous en une seule fois.",
    bulkMatching: "Rapprochement des fichiers avec les factures…",
    bulkPickFiles: "Sélectionner des PDF…",
    bulkPickFilesTitle:
      "Sélectionnez plusieurs PDF à la fois ; chacun est joint à la facture portant le même numéro externe",
    bulkPickFolder: "📁 Sélectionner un dossier",
    bulkPickFolderTitle:
      "Choisissez le DOSSIER entier de PDF — sans avoir à les sélectionner un par un",
    bulkSendingPre: "Envoi",
    bulkUnmatchedSuf: "sans facture correspondante",
    cancelBtn: "annuler",
    cancelFormBtn: "Annuler",
    cancelInvoiceConfirm: "Annuler la facture",
    cancelInvoiceMessage:
      "Une facture annulée n'apparaît pas dans les totaux. Motif obligatoire pour le journal d'audit.",
    cancelInvoiceTitlePre: "Annuler la facture",
    cancelReasonPlaceholder: "Ex. : le fournisseur a annulé la commande",
    close: "Fermer",
    colActions: "Actions",
    colCategory: "Catégorie",
    colDate: "Date",
    colExternalNumber: "N° externe",
    colHt: "HT",
    colStatus: "Statut",
    colSupplier: "Fournisseur",
    colTtc: "TTC",
    colTva: "TVA",
    colTvaRate: "TVA %",
    companyLabel: "Société :",
    createBtn: "Créer la facture",
    createModalTitle: "Nouvelle facture d'achat",
    creating: "Création…",
    dupNumberPrefix: "n°",
    dupWarnHint:
      "Vérifiez avant de créer — il peut s'agir de la même facture saisie avec un numéro différent.",
    dupWarnTitle:
      "⚠️ Doublon possible — une facture de ce fournisseur avec ce montant existe déjà :",
    emptyState: "Aucune facture trouvée.",
    errInvalidTotalHt: "Total HT invalide.",
    errInvalidTvaRate: "Taux TVA invalide (0..30).",
    errSelectSupplier: "Sélectionnez un fournisseur.",
    error: "Erreur",
    fieldCurrency: "Devise",
    fieldDueDate: "Échéance",
    fieldInvoiceNumber: "N° facture (fournisseur)",
    fieldIssueDate: "Date d'émission",
    fieldNotes: "Notes",
    fieldTotalHt: "Total HT",
    fieldTvaRate: "Taux TVA (%)",
    filterAllExceptCancelled: "Toutes (sauf annulées)",
    filterCompany: "Société",
    filterSearch: "Rechercher",
    filterStatus: "Statut",
    filterSupplier: "Fournisseur",
    invoiceNumberPlaceholder: "ex. : HERTZ-2025-0042",
    invoicePlural: "factures",
    invoiceSingular: "facture",
    loading: "Chargement…",
    markPaidBtn: "marquer payée",
    markReceivedBtn: "marquer reçue",
    newBtn: "+ Nouvelle facture d'achat",
    nextPage: "Suivante →",
    noAttachmentsYet: "Aucune pièce jointe pour le moment.",
    noCompanyAccess: "Vous n'avez accès à aucune société.",
    ofWord: "sur",
    or: "ou",
    pageWord: "Page",
    prevPage: "← Précédente",
    previewLabel: "Aperçu",
    removeAttachmentPre: "Supprimer",
    removeAttachmentSuf: "Cette action est irréversible.",
    removeAttachmentTitle: "Supprimer la pièce jointe",
    removeBtn: "supprimer",
    removeConfirm: "Supprimer",
    searchPlaceholder: "Rechercher n° facture...",
    sending: "Envoi…",
    statusCancelled: "Annulée",
    statusCancelledBadge: "annulée",
    statusDraft: "Brouillon",
    statusDraftBadge: "brouillon",
    statusPaid: "Payée",
    statusPaidBadge: "payée",
    statusReceived: "Reçue",
    statusReceivedBadge: "reçue",
    uploadFailed: "Échec de l'envoi du fichier.",
  },
  report: {
    all: "Tous",
    allFem: "Toutes",
    awaiting: "En attente",
    billingCompany: "Société de facturation",
    cancelled: "Annulé",
    colCompany: "Société",
    colCustomer: "Client",
    colDate: "Date",
    colExpectedProfit: "Bénéfice prév.",
    colInvoiced: "Facturé",
    colPayTech: "Payer tech.",
    colPayTechStatus: "Paie. tech.",
    colPctTech: "% Tech.",
    colPlate: "Plaque",
    colQuote: "Devis",
    colReceipt: "Encaiss.",
    colTechnician: "Technicien",
    colToReceive: "À recevoir",
    companyLabel: "Société :",
    csvDossier: "Dossier",
    csvPaidTechnician: "Payé technicien",
    csvPayTechnician: "Payer technicien",
    csvPayingCompany: "Société payeuse",
    csvPaymentStatus: "Statut paiement",
    csvPctTechnician: "% Technicien",
    csvVehicle: "Véhicule",
    customer: "Client",
    dateFrom: "Date de début",
    dateTo: "Date de fin",
    emptyState:
      "Aucune écriture trouvée. Ajustez les filtres et cliquez sur « Générer le rapport ».",
    entriesTitle: "Écritures de la période",
    expectedProfit: "Bénéfice prévu",
    expectedProfitAbbrev: "Bénéfice prév.",
    exportCsvBtn: "Exporter CSV",
    filtersTitle: "Filtres du rapport",
    freeSearch: "Recherche libre",
    freeSearchPlaceholder: "dossier / plaque / client / technicien",
    generateReport: "Générer le rapport",
    invoiceNumber: "N° Facture",
    invoiceNumberPlaceholder: "Ex : 2025-001",
    invoiced: "Facturé",
    loading: "Chargement…",
    negativeProfitAlert: "écritures avec bénéfice prévu négatif sur la période.",
    negativeProfitAlertSingular: "écriture avec bénéfice prévu négatif sur la période.",
    noCompanyAccess: "Vous n'avez accès à aucune société.",
    paid: "Payé",
    paidTechnicians: "Payé techniciens",
    payTechnicians: "Payer techniciens",
    pending: "En attente",
    quickRange: "Période rapide",
    quote: "Devis",
    receiptStatus: "Statut encaissement",
    receivedPartial: "Reçu partiel",
    receivedTotal: "Reçu total",
    recordWord: "enregistrements",
    recordWordSingular: "enregistrement",
    recordsAbbrev: "enr.",
    sixMonths: "6 mois",
    technician: "Technicien",
    technicianPaymentStatus: "Statut paiement technicien",
    toReceive: "À recevoir",
    totalsRow: "Totaux",
    truncatedPre: "Résultat limité à",
    truncatedSuf: "enregistrements. Affinez les filtres pour en voir plus.",
    twelveMonths: "12 mois",
  },
  reportCaGap: {
    colAmount: "Montant",
    colCaHt: "CA HT",
    colDate: "Date",
    colDescription: "Description",
    colMonth: "Mois",
    colOpenHt: "En attente HT",
    colReceivedHt: "Reçu HT",
    colTvaCollected: "TVA collectée",
    creditsCardSubtitle:
      "Entrées non encore rapprochées à une facture (et qui ne sont ni personnelles ni apport d'associé). Ce sont les principaux suspects d'une vente encaissée mais non facturée — ce qui explique bilan > Gestion.",
    creditsCardTitle: "Crédits en banque sans facture",
    creditsEmpty:
      "Aucun crédit sans facture sur la période. 🎉 (Ou le relevé n'a pas encore été importé / rapproché.)",
    entriesUnit: "écriture(s)",
    eyebrow: "Rapports — Écart de CA (HT)",
    kpiCaInvoiced: "CA facturé (HT)",
    kpiCreditsNoInvoice: "Crédits sans facture",
    kpiOpen: "En attente (HT)",
    kpiReceived: "Reçu (HT)",
    loading: "Calcul en cours…",
    methodology:
      "Méthodologie v1 (itérable). Le CA et la TVA proviennent des factures client ; les suspects proviennent du relevé rapproché. Si un chiffre ne correspond pas à la réalité, on ajuste la règle — c'est en lecture seule.",
    monthlyCardTitle: "CA facturé par mois (HT)",
    monthlyEmpty: "Aucune facture émise sur l'exercice.",
    selectPrompt: "Sélectionnez la société et l'exercice.",
    total: "Total",
    totalCapped: "(200+ — tronqué)",
    tvaCardSubtitle:
      "À payer à l'État = collectée (ventes) − déductible (achats). Comparez avec le virement réel sur le relevé.",
    tvaCardTitle: "TVA de la période",
    tvaCollected: "Collectée (ventes)",
    tvaDeductible: "Déductible (achats)",
    tvaDue: "Due",
  },
  suppliers: {
    badgeActive: "actif",
    badgeInactive: "inactif",
    cancel: "Annuler",
    colActions: "Actions",
    colDefaultCategory: "Catégorie par défaut",
    colName: "Nom",
    colStatus: "Statut",
    companyLabel: "Société",
    create: "Créer",
    deactivate: "Désactiver",
    deactivateMessage:
      "Un fournisseur inactif n'apparaît pas dans les nouvelles factures. Les factures existantes ne sont pas affectées.",
    deactivatePlaceholder: "Ex : fournisseur a cessé son activité",
    deactivateTitlePrefix: "Désactiver le fournisseur",
    editAction: "modifier",
    editSupplier: "Modifier le fournisseur",
    emptyState: "Aucun fournisseur trouvé.",
    fieldCountry: "Pays (ISO 2)",
    fieldDefaultCategory: "Catégorie par défaut",
    fieldDefaultTvaRate: "Taux de TVA par défaut (%)",
    fieldDisplayName: "Nom d'affichage",
    fieldEmail: "E-mail",
    fieldKind: "Type",
    fieldLegalName: "Raison sociale",
    fieldNotes: "Notes",
    fieldPhone: "Téléphone",
    fieldSiren: "SIREN (9 chiffres)",
    fieldSiret: "SIRET (14 chiffres)",
    fieldVatNumber: "TVA intracomm.",
    filterActive: "Actifs",
    filterAll: "Tous",
    filterInactive: "Inactifs",
    kindBusiness: "Société",
    kindIndividual: "Individu (freelance)",
    loading: "Chargement…",
    newSupplier: "Nouveau fournisseur",
    nextPage: "Suivant",
    noCompanyAccess: "Vous n'avez accès à aucune société.",
    pageLabel: "Page",
    pageOf: "sur",
    prevPage: "Précédent",
    reactivate: "Réactiver",
    save: "Enregistrer",
    saving: "Enregistrement…",
    searchLabel: "Rechercher",
    searchPlaceholder: "Nom, SIRET, vatNumber…",
    supplierPlural: "fournisseurs",
    supplierSingular: "fournisseur",
  },
  tasks: {
    backBtn: "Retour",
    boardEmpty: "Aucune tâche créée pour l'instant.",
    boardTitle: "Tâches de l'équipe",
    cancelBtn: "Annuler la tâche",
    cancelConfirm: "Annuler cette tâche ? Elle disparaît de la liste de la personne.",
    cancelledBadge: "Annulée",
    commentPh: "Commentaire (facultatif)",
    companyLabel: "Entreprise",
    confirmBtn: "Confirmer",
    createBtn: "Créer la tâche",
    created: "Tâche créée. La personne la voit dans la cloche et le tableau de bord.",
    descLabel: "Détails (facultatif)",
    doneBtn: "Fait",
    dueAtLabel: "Échéance (jour et heure)",
    dueBy: "avant",
    endLabel: "Fin (facultatif)",
    endOfDay: "fin de journée",
    everyMonthWord: "de chaque mois",
    groupOffice: "Bureau",
    groupOverdue: "En retard",
    groupToday: "Aujourd'hui",
    groupUpcoming: "7 prochains jours",
    hint: "Tâches du bureau pour l'équipe. Une tâche non faite à temps passe en retard et reste dans la liste jusqu'à ce qu'elle soit faite.",
    historyLabel: "Derniers jours",
    kindLabel: "Type",
    kindOnce: "Ponctuelle",
    kindRecurring: "Récurrente",
    lastDone: "Dernière faite",
    mineEmpty: "Aucune tâche pour vous.",
    monthDayLabel: "Jour du mois",
    monthDayWord: "le",
    myCardTitle: "Vos tâches",
    newTitle: "Nouvelle tâche",
    noAdmin: "Seuls les administrateurs créent des tâches.",
    notifMineOverdue: "Vous avez des tâches en retard",
    notifMineToday: "Tâches du jour",
    notifTeamOverdue: "Tâches en retard de l'équipe",
    onceWord: "Ponctuelle",
    openTasks: "Ouvrir les tâches",
    overdueWord: "en retard",
    personLabel: "Pour qui",
    personPh: "Choisir la personne",
    rec_business_days: "Chaque jour ouvré (lundi à vendredi)",
    rec_monthly_day: "Chaque mois, le jour",
    rec_monthly_last_business: "Dernier jour ouvré du mois",
    rec_weekly: "Certains jours de la semaine",
    recurringBadge: "Récurrente",
    repeatLabel: "Répétition",
    requestedBy: "Demandée par",
    showCancelled: "Afficher les annulées",
    sinceWord: "depuis",
    skipBtn: "Sans objet",
    skipReasonPh: "Pourquoi ? (obligatoire)",
    st_done: "Faite",
    st_doneLate: "Faite en retard",
    st_open: "Ouverte",
    st_overdue: "En retard",
    st_skipped: "Sans objet",
    startLabel: "Début",
    tabMine: "Mes tâches",
    tabTeam: "Équipe",
    teamOverdueNone: "Aucune tâche en retard dans l'équipe.",
    teamOverdueTitle: "Tâches en retard de l'équipe",
    timeHint: "Vide = jusqu'à la fin de journée",
    timeLabel: "Avant quelle heure",
    title: "Tâches",
    titleLabel: "Quoi faire",
    titlePh: "Ex. : Vérifier les proformas émises",
    urgent: "Urgent",
    urgentLabel: "Marquer comme urgente",
  },
  teamNotices: {
    ackBtn: "Lu",
    cancelBtn: "Annuler",
    closeBtn: "Fermer",
    closeConfirmMsg: "Êtes-vous conscient qu'il reste des tâches à réaliser ?",
    closeConfirmNo: "Non",
    closeConfirmTitle: "Fermer les tâches ?",
    closeConfirmYes: "Oui, fermer",
    companyLabel: "Entreprise",
    dayLong1: "lun",
    dayLong2: "mar",
    dayLong3: "mer",
    dayLong4: "jeu",
    dayLong5: "ven",
    dayLong6: "sam",
    dayLong7: "dim",
    doneBtn: "Fait",
    doneBy: "fait par",
    expiresHint: "Vide = sans limite.",
    expiresLabel: "Valable jusqu'au",
    hint: "Le message s'ouvre en pop-up quand la personne entre dans Gestion (ou dans le portail, pour un technicien). « Lu » le ferme jusqu'à la prochaine connexion ; « Fait » le termine pour cette personne.",
    infoBadge: "information",
    laterBtn: "Voir plus tard",
    listEmpty: "Aucun message pour l'instant.",
    listTitle: "Messages envoyés",
    messagePlaceholder: "Ex. : vendredi à 17 h, clôturez les worklogs de la semaine.",
    noAdmin: "Seuls les administrateurs envoient des messages.",
    popupHint: "« Lu » ferme jusqu'à la prochaine connexion · « Fait » n'apparaît plus.",
    popupNoticesSub: "Informations",
    popupOpenTasks: "Ouvrir Mes tâches",
    popupTasksHint:
      "Cochez « Fait » une fois terminé. « Voir plus tard » ferme jusqu'à la prochaine connexion ; une tâche en retard reste dans la liste jusqu'à ce qu'elle soit faite.",
    popupTasksTitle: "Tâches à réaliser",
    popupTitle: "Informations",
    readBy: "lu par",
    repeatDoneHint: "Message récurrent : « Fait » ne vaut que pour aujourd'hui.",
    repeatEvery: "chaque",
    repeatHint:
      "N'apparaît que ces jours-là (heure de Paris). « Fait » vaut pour la journée ; revient le prochain jour coché. Utilisez « Valable jusqu'au » pour la fin.",
    repeatLabel: "Répéter les jours",
    roleLabel: "Rôle",
    role_admin: "Administrateur",
    role_client: "Client",
    role_manager: "Responsable de chantier",
    role_technician: "Technicien",
    role_user: "Utilisateur",
    role_viewer: "Lecteur",
    sendBtn: "Envoyer le message",
    sent: "Message envoyé.",
    showFromHint: "Vide = maintenant.",
    showFromLabel: "Afficher à partir du",
    statusActive: "en cours",
    statusCancelled: "annulé",
    statusExpired: "expiré",
    statusScheduled: "programmé",
    targetAll: "Tous (bureau + techniciens)",
    targetCompany: "Équipe du bureau (Gestion)",
    targetLabel: "Pour qui",
    targetRole: "Un rôle",
    targetTechnicians: "Tous les techniciens (portail)",
    targetUser: "Une personne",
    title: "Messages pour l'équipe",
    today: "aujourd'hui",
    userLabel: "Personne",
  },
  techPortal: {
    advDeductedIn: "déduite sur",
    advHint:
      "La société a avancé ces montants. Déduisez le total sur votre prochaine facture (l'e-mail de la proforma indique déjà le montant attendu).",
    advHistory: "déjà déduites",
    advNoneOpen: "Aucune avance en cours.",
    advTitle: "Avances à déduire",
    agendaEmpty: "Rien de planifié les prochains jours.",
    agendaTitle: "Agenda du chantier",
    alreadyInvoicedHint:
      "La réparation précédente est clôturée. Si le véhicule revient pour une nouvelle réparation, le nouveau devis doit entrer dans le Gestion (par le bureau ou par le bouton d'import du devis ci-dessous) ; il apparaîtra ensuite ici pour que vous le preniez.",
    alreadyInvoicedTitle: "Le service de ce véhicule a déjà été facturé",
    camAimPlate: "Cadrez la plaque dans le cadre",
    camAimVin: "Cadrez le VIN dans le cadre",
    camClose: "Fermer",
    camConflictDevis: "mais le devis est de",
    camConflictPre: "Le VIN est de",
    camDenied:
      "Caméra bloquée. Autorisez la caméra pour ce site dans les réglages du navigateur. En attendant, saisissez.",
    camNotFound: "Absent du Gestion — lecture en cours.",
    camOffline: "Pas de connexion — nouvel essai en cours.",
    camPickOne: "Lequel de ces véhicules ?",
    camRetry: "Relire",
    camStarting: "Ouverture de la caméra…",
    camTitlePlate: "Plaque",
    camTorch: "Lampe torche",
    camType: "Saisir",
    camUnavailable: "Caméra indisponible sur cet appareil — saisissez.",
    camUseAnyway: "Utiliser quand même",
    carClosedNoTechHint:
      "Le chef de chantier a enregistré la livraison, mais personne n'a pris ce véhicule dans le portail. Prévenez le bureau pour affecter le technicien dans le dossier : c'est la seule façon pour que le véhicule entre dans votre liste et votre paiement.",
    carClosedNoTechTitle: "Véhicule livré sans technicien affecté",
    carRepairedHint: "Toutes les prestations de ce véhicule sont terminées.",
    carRepairedTitle: "Véhicule déjà réparé",
    chkCielLabel: "Ciel de toit",
    chkClaimQ: "Comment allez-vous réparer ce véhicule ?",
    chkClearIssue: "Retirer le signalement",
    chkCompleteBadge: "Check-list complet",
    chkCrackedBtn: "Fissuré",
    chkDefectBtn: "Défectueux",
    chkFranchiseEditBtn: "Modifier la franchise",
    chkIncompleteHint:
      "Check-list incomplet — complétez les points ci-dessous pour débloquer la réparation.",
    chkIssueNotePlaceholder: "Qu'est-ce qui ne va pas ? (facultatif)",
    chkIssuesBrokenSummary: "pièce(s) cassée(s) pendant le travail",
    chkIssuesDefectSummary: "pièce(s) déjà défectueuse(s)",
    chkMarkBroken: "Cassée pendant le travail",
    chkMarkDefect: "Pièce déjà défectueuse",
    chkMileageLabel: "Kilométrage (km)",
    chkMileagePh: "Ex. : 45200",
    chkMissingCiel: "répondre le ciel de toit",
    chkMissingPareBrise: "répondre le pare-brise",
    chkMissingPhoto: "photo",
    chkMissingPhotos: "photos",
    chkMissingPre: "Il manque :",
    chkMissingSignature: "signature du client",
    chkNextPhotoPre: "Photo suivante :",
    chkOkBtn: "OK",
    chkPareBriseLabel: "Pare-brise",
    chkPhotoAngle1: "Avant gauche",
    chkPhotoAngle2: "Avant droit",
    chkPhotoAngle3: "Arrière gauche",
    chkPhotoAngle4: "Arrière droit",
    chkPhotoCameraBtn: "Appareil photo",
    chkPhotoCancelBtn: "Annuler",
    chkPhotoDashboard: "Tableau de bord (contact mis)",
    chkPhotoDoorTrim1: "Garniture porte 1",
    chkPhotoDoorTrim2: "Garniture porte 2",
    chkPhotoDoorTrim3: "Garniture porte 3",
    chkPhotoDoorTrim4: "Garniture porte 4",
    chkPhotoDoorTrim5: "Garniture porte 5",
    chkPhotoFree: "Photo libre",
    chkPhotoFront: "Avant",
    chkPhotoFrontLeft: "Latéral avant gauche",
    chkPhotoFrontRight: "Latéral avant droit",
    chkPhotoGalleryBtn: "Galerie",
    chkPhotoHeadliner: "Ciel défectueux",
    chkPhotoHeadlinerFront: "Ciel de toit — avant",
    chkPhotoHeadlinerRear: "Ciel de toit — arrière",
    chkPhotoHood: "Capot",
    chkPhotoHoodLiner: "Garniture du capot",
    chkPhotoRear: "Arrière",
    chkPhotoRearLeft: "Latéral arrière gauche",
    chkPhotoRearLight1: "Feu arrière 1",
    chkPhotoRearLight2: "Feu arrière 2",
    chkPhotoRearLight3: "Feu arrière 3",
    chkPhotoRearRight: "Latéral arrière droit",
    chkPhotoRoof: "Toit",
    chkPhotoSourcePre: "Photo :",
    chkPhotoTake: "Prendre",
    chkPhotoWindshield: "Pare-brise fissuré",
    chkPhotosDone: "Photos complètes",
    chkPhotosTitle: "Photos du véhicule (obligatoires)",
    chkRetakePhoto: "Reprendre la photo",
    chkSaveBtn: "Enregistrer le check-list",
    chkSavedMsg: "Check-list enregistré.",
    chkSaving: "Enregistrement…",
    chkSignClear: "Effacer",
    chkSignHint: "Signez avec le doigt dans le cadre blanc",
    chkSignNamePh: "Nom du signataire",
    chkSignTitle: "Signature du client",
    chkSignedBadge: "Signature enregistrée",
    chkTakePhotoBtn: "Prendre la photo",
    chkTitle: "Check-list du véhicule",
    chkUploading: "Envoi…",
    claimDemontageHint: "La repose reste à vous, sauf si un autre technicien la prend.",
    claimDemontageQ: "Prendre la dépose ?",
    claimDevisNoPanels:
      "Devis sans tableau de pièces (importé avant le parseur — demander le re-upload du PDF)",
    claimFranchisePre: "Franchise de",
    claimFranchiseSuf: "déduite de la base de calcul — devis intact.",
    claimFranchiseSufParticular:
      "client particulier : facture intégrale (avoir) ; commissions sur base réduite.",
    claimMontage: "Prendre le démontage",
    claimMontageOnly: "Prendre seulement le dégarnissage",
    claimNeedsReception: "Enregistrez la réception ci-dessus pour débloquer la prise du véhicule.",
    claimNoMontage:
      "Ce devis n'a pas de dégarnissage — rien à faire pour le monteur sur ce véhicule.",
    claimOkPre: "✓ Pris :",
    claimPdr: "Prendre PDR seul",
    claimPdrMontage: "Prendre PDR + Montage",
    claimedAlready: "Vous avez déjà pris ce véhicule",
    commissionDemontage: "Dépose",
    commissionFixedBadge: "montant fixe",
    commissionMontageHalf: "Repose",
    commissionPendingHint: "à faire",
    commissionTbd: "à calculer",
    degarnissageGarageBtn: "Dégarnissage fait par le garage (tiers)",
    degarnissageGarageConfirm:
      "Confirmer : la dépose et la repose de ce véhicule ont été faites par le garage ? Personne chez ES/BS ne sera payé pour elles.",
    degarnissageGarageDone: "Dégarnissage enregistré comme fait par le garage.",
    deposeReposeLabel: "Dépose/Repose",
    devisHtLabel: "Devis HT",
    devisNetOfFranchise: "franchise déjà déduite",
    docsA1: "Certificat A1 ou attestation URSSAF",
    docsAllDone: "Documents complets. Merci.",
    docsBannerTitle: "Vos documents manquent",
    docsDaysLeftPre: "Il vous reste",
    docsDaysLeftSuf: "jours pour les envoyer.",
    docsIdentity: "Pièce d’identité",
    docsIdentity2: "Pièce d’identité",
    docsKbis: "Kbis / auto-entrepreneur",
    docsKbis2: "Kbis ou immatriculation de l'entreprise (statuts)",
    docsLastDay: "Dernier jour du délai.",
    docsOverdue: "Délai dépassé — envoyez aujourd’hui.",
    docsRcPro: "Assurance RC Pro",
    docsSendBtn: "Envoyer",
    docsSending: "Envoi…",
    docsSentBadge: "envoyé",
    docsUrssaf: "Attestation de vigilance URSSAF ou certificat A1",
    filterAll: "Tous",
    filterMonth: "30 derniers jours",
    filterRange: "Plage de dates",
    filterSince: "Depuis le 01/05/2026",
    filterThisWeek: "Cette semaine",
    filterWeek: "7 derniers jours",
    foundInOtherCompanyPre: "Ce véhicule est dans la société",
    hidePhotosBtn: "Masquer les photos",
    impactsWord: "impacts",
    impersonatingBy: "par",
    impersonatingExit: "Quitter la vue",
    impersonatingPre: "Vue en tant que",
    importAtelierLabel: "Atelier / lieu du service",
    importAtelierPlaceholder: "— choisir l'atelier —",
    importChantierHint:
      "Le client vient du nom imprimé sur le devis et entre dans le chantier. À utiliser pour un véhicule de particulier.",
    importClientPlaceholder: "— choisir le client —",
    importExistsPre: "Ce devis EXISTE DÉJÀ dans Gestion — rien n'a été dupliqué. Véhicule :",
    importHint:
      "Vous avez reçu sur place un devis introuvable dans la recherche ? Choisissez le client du chantier et envoyez le PDF — le véhicule est créé et vous pouvez le prendre.",
    importLink: "ou importer un devis (PDF)",
    importNoClients:
      "Aucun client rattaché à vous — demandez au bureau de configurer la paire de commission.",
    importOkPre: "Devis importé :",
    importPanelsWord: "pièces",
    importPhotoBtn: "Importer par photo / capture d'écran",
    importPhotoFail:
      "Impossible de lire le devis sur la photo — essayez une capture plus nette ou utilisez le PDF.",
    importPhotoHint:
      "Une capture d'écran marche mieux qu'une photo de papier. La lecture se fait sur votre appareil ; la 1ère fois télécharge le lecteur (~6 Mo).",
    importPhotoReading: "Lecture de la photo…",
    importPickBtn: "Choisir le PDF et importer",
    importReadFail: "Impossible de lire le fichier — réessayez (hors zip).",
    importScanCancelBtn: "Annuler",
    importScanConfirmBtn: "Importer avec cette immatriculation",
    importScanFail:
      "Impossible de lire le PDF numérisé. Photographiez le devis avec une bonne lumière et utilisez le bouton photo.",
    importScanPlatePrompt:
      "Immatriculation lue sur le devis — confirmez ou corrigez avant d'importer :",
    importScanReading: "PDF numérisé — lecture du texte par OCR sur l'appareil…",
    importTitle: "Importer un devis (PDF)",
    importing: "Import en cours…",
    logout: "Quitter",
    menuBtnAria: "Menu",
    menuHome: "Accueil",
    modePlate: "Immatriculation",
    montageEndPhotosTitle: "Photos de fin de travail",
    montageExternalBtn: "Repose faite par un tiers (garage)",
    montageExternalConfirm:
      "Confirmer : la repose de ce véhicule a été faite par un tiers (garage) ? Personne chez ES/BS ne sera payé pour elle.",
    montageExternalDone: "repose faite par un tiers (garage)",
    montageExternalHint: "Personne chez ES/BS n'est payé pour cette étape.",
    montageHtLabel: "Montage HT",
    montagePhotosTitle: "Photos du démontage",
    montageShort: "Montage",
    myCarsEmpty: "Aucun véhicule pris pour l'instant.",
    myCarsTitle: "Mes véhicules",
    myCommissionMontage: "Votre commission (Montage)",
    myCommissionPdr: "Votre commission (PDR)",
    myTasksDoneBtn: "Fait",
    myTasksDue: "Échéance",
    myTasksHint:
      "Touchez Fait quand c'est terminé. Une tâche en retard reste ici jusqu'à ce qu'elle soit faite.",
    myTasksLaterBtn: "Voir plus tard",
    myTasksOverdue: "En retard",
    myTasksTitle: "Tâches du bureau",
    myTasksToday: "Aujourd'hui",
    mycarsMarkPhasesBtn: "Marquer dépose / repose (ouvre le véhicule)",
    navCars: "Véhicules",
    navMore: "Plus",
    navPayments: "Paiements",
    navScanner: "Scanner",
    navWorklog: "Worklog",
    noPairHint:
      "Ce véhicule appartient à un client pour lequel vous n'avez pas de paire configurée, et ce client n'est rattaché à aucun chantier où vous en avez une. Demandez au bureau de configurer la paire ou de rattacher le client au chantier.",
    noPairTitle: "Véhicule trouvé, mais il ne vous est pas attribué",
    noResults:
      'Aucun véhicule "à exécuter" avec cette immatriculation. Vérifiez ou contactez le bureau.',
    notLinkedNote:
      "⚠ Compte pas encore lié à une fiche technicien — demandez au bureau (Techniciens → modifier → Compte du portail).",
    notTechnicianNote: "Votre compte n'a le rôle technicien dans aucune société.",
    noticeAckBtn: "Lu et compris",
    noticeAckHint: "Lu : revient à la prochaine connexion · Fait : n'apparaît plus.",
    noticeBlockedHint: "Terminez les tâches en attente ou consultez le bureau :",
    noticeBlockedTitle: "Portail bloqué",
    noticeBlockedWait:
      "Seul le bureau peut débloquer le portail (nouveau véhicule, import de devis et scanner).",
    noticeDoneBtn: "Fait",
    noticeTitle: "Message du bureau",
    openCarBtn: "Ouvrir le véhicule",
    openCarsMontage: "remontage non enregistré · démontage :",
    openCarsNoMontage:
      "dégarnissage du devis non lancé — prenez-le ou déclarez-le fait par le garage",
    openCarsNote:
      "Votre PDR est terminé, mais le remontage n'a pas été enregistré. Terminez le véhicule : enregistrez le remontage ou prévenez le monteur.",
    openCarsOpen: "Ouvrir",
    openCarsTitle: "Véhicules commencés et non terminés",
    otherCarsHint:
      "Pour prendre ce véhicule il faut le devis — importez le PDF ci-dessous ou contactez le bureau.",
    otherCarsTitle: "Cette plaque est déjà dans Gestion, mais sans devis importé :",
    otherCarsWith: "avec",
    panelsTitle: "Éléments à réparer",
    parcCarBtn: "Véhicule de parc",
    parcChoiceLater:
      "Le montant est fixé quand vous prenez le véhicule, après la réception : PDR seul, ou PDR + démontage/montage.",
    parcChooseAtelier: "— choisir l'atelier —",
    parcChooseCategory: "— choisir la catégorie —",
    parcChooseClient: "— choisir le client —",
    parcCreateBtn: "Enregistrer le véhicule de parc",
    parcCreatedPre: "Véhicule de parc enregistré — faites la réception :",
    parcImportPdfBtn: "Importer le PDF du devis",
    parcMakePh: "Marque",
    parcModelPh: "Modèle",
    parcNoneHint:
      "Aucun de vos clients n'a de catégories de véhicule de parc — contactez le bureau.",
    parcOnlyPdr: "PDR seul",
    parcPlateLabel: "Immatriculation :",
    parcWithMontage: "PDR + démontage/montage",
    parcYouReceive: "vous recevez",
    pdrDoneBtn: "Marquer le PDR terminé",
    pdrDoneQ: "PDR de ce véhicule terminé ?",
    pdrPendingNote: "Terminez le PDR de ces véhicules avant d'en prendre un autre :",
    pendingTasksBtn: "Tâches en attente",
    pendingTasksClose: "Fermer",
    pendingTasksHint:
      "Vous pouvez fermer et consulter vos véhicules, mais vous ne prenez ni n'ajoutez de nouveau véhicule tant qu'un PDR n'est pas marqué terminé.",
    pendingTasksNone: "Aucune tâche en attente.",
    pendingTasksTitle: "Tâches en attente",
    periodAria: "Période",
    phaseBothDoneBy: "Dépose et repose faites par",
    phaseDemontageBtn: "Marquer la dépose terminée",
    phaseDemontageByPre: "Démonté par",
    phaseDemontageDone: "Démontage fait",
    phaseDemontageTitle: "Démontage",
    phaseDoneDemontageHint: "Elle est déjà dans votre liste comme déposée. Il reste la repose.",
    phaseDoneDemontageMsg: "Véhicule déposé",
    phaseDoneMontageHint: "Travail terminé sur ce véhicule.",
    phaseDoneMontageMsg: "Véhicule reposé",
    phaseExternalShort: "tiers (garage)",
    phaseMontageAfterDemontage: "2 · Montage — après avoir terminé le démontage.",
    phaseMontageBtn: "Marquer la repose terminée",
    phaseMontageDone: "Montage fait",
    phaseMontagePending: "il reste la repose",
    phaseMontageTitle: "Montage",
    photoUploadFailPre: "La photo n'est pas passée :",
    photosDemontage: "Dépose",
    photosMontageEnd: "Fin du travail",
    photosReception: "Réception",
    plateLabel: "Immatriculation",
    prodAllTime: "Depuis le début",
    prodCar: "véhicule",
    prodCars: "véhicules",
    prodPaid: "Payé",
    prodTbdNote: "les véhicules dont le montant reste à calculer ne sont pas comptés",
    prodTitle: "Ma production",
    prodToReceive: "à recevoir",
    readOnlyNote:
      "Compte en consultation seule : vous voyez les véhicules réalisés et l'état de chaque paiement, sans pouvoir rien saisir ni modifier.",
    recAmountPh: "Montant de la franchise (€ TTC)",
    recDamagesPh: "Dommages/pièces cassées pré-existants (optionnel, séparés par des virgules)",
    recDoneLabel: "Réception faite",
    recFranchiseFirstHint:
      "Répondez à la question de la franchise pour débloquer les photos de réception.",
    recFranchisePre: "Franchise :",
    recFranchiseQ: "Le véhicule a-t-il une remise de franchise au client ?",
    recFranchiseStep: "1 · Franchise — obligatoire",
    recHint:
      "Renseignez la franchise et notez les dommages pré-existants. Le chef de chantier peut aussi le faire — si c'est déjà fait, le véhicule arrive débloqué.",
    recHintNoPhotos:
      "Hors chantier, pas de photos : indiquez seulement si le véhicule a une déduction de franchise (obligatoire) et prenez le service.",
    recIncompleteWait:
      "Réception incomplète — celui qui l'a faite (gérant, senior ou technicien PDR) doit la compléter avant que vous preniez le service.",
    recNo: "Non",
    recNoFranchise: "sans franchise",
    recPhotosStep: "2 · Dommages et photos",
    recSaveBtn: "Enregistrer la réception",
    recSavedMsg: "Réception enregistrée — le véhicule est débloqué pour réparation.",
    recSaving: "Enregistrement…",
    recTitle: "Réception du véhicule (obligatoire avant réparation)",
    recWaitingHint:
      "Sur un chantier, la réception (franchise, check-list, photos et signature) est faite par le gérant ou le technicien senior ; hors chantier, par le technicien PDR de le véhicule. Vous pourrez ensuite prendre le service.",
    recWaitingTitle: "En attente de la réception",
    recYes: "Oui",
    repairedAtPre: "Pris en charge le",
    roleMontador: "Monteur",
    rolePdr: "Technicien PDR",
    rowDemontageDone: "déposé",
    rowMontageDone: "reposé",
    rowPaid: "Payé",
    rowPaidPartial: "Payé en partie",
    scanFail:
      "Lecture impossible sur la photo — rapprochez-vous, évitez les reflets et réessayez, ou saisissez.",
    scanTitle: "Lire avec la caméra",
    scanWarn_car_existed:
      "Le véhicule existait déjà dans Gestion — dossier complété, rien de dupliqué.",
    scanWarn_customer_created: "Nouveau client créé d'après le devis.",
    scanWarn_customer_matched: "Client rattaché à une fiche déjà existante.",
    scanWarn_devis_linked_existing: "N° du devis rattaché au dossier déjà existant.",
    scanWarn_make_model_backfilled: "Marque/modèle du véhicule complétés d'après le devis.",
    scanWarn_num_from_filename: "N° du devis lu depuis le nom du fichier.",
    scanWarn_plate_confirmed: "Immatriculation confirmée par vous.",
    scanWarn_scan_deg_adjusted:
      "Dégarnissage ajusté d'après le Total HT (la case était illisible pour l'OCR).",
    scanWarn_scan_dsp_derived:
      "Total DSP calculé à partir du Total HT (l'OCR n'a pas lu la case DSP).",
    scanWarn_scan_ht_from_sum: "Total HT calculé par la somme des postes.",
    scanWarn_scan_ht_from_ttc: "Total HT calculé à partir du TTC.",
    scanWarn_scan_no_client: "Nom du client non identifié.",
    scanWarn_scan_no_date: "Date du devis non reconnue.",
    scanWarn_scan_no_panels: "Pièces et impacts non extraits du schéma (devis numérisé).",
    scanWarn_scan_no_plate: "Immatriculation non identifiée sur le document.",
    scanWarn_scan_ocr:
      "Devis numérisé lu par OCR — vérifiez l'immatriculation, le client et les montants sur le document.",
    scanWarn_scan_plate_ocr: "Immatriculation lue par OCR — vérifiez.",
    scanWarn_scan_sum_mismatch: "La somme des postes diffère du Total HT — vérifiez le document.",
    scanning: "Lecture de la photo…",
    searchBtn: "Chercher",
    searchCarBtn: "Chercher le véhicule",
    searchHint:
      "Saisir une immatriculation OU un VIN pour rechercher le véhicule. Le bouton ⇄ permet de basculer entre les deux champs.",
    searching: "Recherche…",
    servicePdrLabel: "PDR",
    servicesTitle: "Prestations de ce véhicule",
    showPhotosBtn: "Voir les photos",
    sitDone: "Terminée · à recevoir",
    sitInRepair: "En réparation",
    sitMontage: "Montage à faire",
    statusAria: "Statut du paiement",
    statusPaid: "Payés",
    statusPending: "À recevoir",
    switchCompanyBtn: "Voir dans",
    takeDemontageBtn: "Prendre la dépose",
    takeHint: "Vous recevez la moitié de cette étape, à votre pourcentage avec le client.",
    takeMontageBtn: "Prendre la repose",
    takeOwnMontageBtn: "Prendre le montage",
    takeOwnMontageHint:
      "Démontage terminé. Prenez le montage quand vous le commencez — d'ici là un autre technicien peut le prendre.",
    title: "Portail Technicien",
    toastDemontageDone: "Démontage terminé",
    toastDemontageTaken: "Démontage pris",
    toastMontageDone: "Montage terminé",
    toastPdrDone: "Service PDR terminé",
    toastPdrStarted: "Service PDR démarré",
    weekWord: "Semaine",
    worklogEmpty: "Aucune intervention cette semaine.",
    worklogPdfBtn: "Télécharger le PDF",
    worklogTitle: "Worklog (PDF)",
    worklogWeekPre: "Semaine",
  },
  techSignup: {
    backToLogin: "J'ai déjà un compte",
    countryLabel: "Pays où vous travaillez",
    docsNotice:
      "Une fois validé, le portail vous demandera vos documents : pièce d'identité, Kbis ou document équivalent et — selon votre pays de résidence — l'attestation URSSAF (résidents en France) ou le certificat A1. Vous avez 7 jours pour les envoyer ; le travail ne s'arrête pas en attendant.",
    emailHint: "Ce sera votre identifiant. Vous y recevrez le lien pour créer le mot de passe.",
    emailLabel: "E-mail",
    errorRequired: "Remplissez nom, e-mail, téléphone et pays.",
    intro: "Remplissez vos informations. Euro Storm vérifie et vous ouvre l'accès au portail.",
    langLabel: "Langue du portail",
    nameLabel: "Nom complet",
    phoneLabel: "Téléphone / WhatsApp",
    residenceHint: "C’est ce qui définit les documents qui vous seront demandés ensuite.",
    residenceLabel: "Pays de résidence / autorisation de travail",
    roleDebosselage: "Technicien PDR (débosselage)",
    roleLabel: "Ce que vous faites",
    roleMontage: "Monteur (dépose et repose)",
    sending: "Envoi…",
    submitBtn: "Envoyer l'inscription",
    subtitle: "Inscription technicien",
    successBody:
      "Euro Storm va vérifier vos informations. Une fois validé, vous recevrez un e-mail pour créer votre mot de passe.",
    successTitle: "Inscription envoyée.",
  },
  technicianDetail: {
    approvalRate: "Taux d'approbation",
    auditLogOfTechnician: "Journal d'audit du technicien",
    auditRequiresAdmin: "Le journal d'audit requiert une permission admin.",
    avgDaysToPayment: "Jours moyens de paiement",
    avgInvoicedPerLine: "Facturé moyen par ligne",
    backToList: "Retour à la liste",
    colAction: "Action",
    colAmount: "Montant",
    colBy: "Par",
    colCode: "Code",
    colCustomer: "Client",
    colDate: "Date",
    colInvoiceNumber: "N° facture",
    colIssueDate: "Date d'émission",
    colMethod: "Méthode",
    colNumberExternal: "N° (externe)",
    colPeriod: "Période",
    colPlate: "Plaque",
    colReason: "Motif",
    colReference: "Référence",
    colStatus: "Statut",
    colTi: "TI",
    colTotal: "Total",
    colWhen: "Quand",
    commissionsByCustomer: "Commissions (par client)",
    configureCommissions: "Configurer les commissions",
    country: "Pays",
    createPortalAccess: "Créer l'accès au portail",
    dossiers: "Dossiers",
    dossiersOfTechnician: "Dossiers du technicien",
    emptyAudit: "Aucun événement.",
    emptyDossiers: "Aucun dossier dans cette période.",
    emptyInvoices: "Aucune facture dans cette période.",
    emptyPayments: "Aucun paiement dans cette période.",
    financial: "Financier",
    inactive: "inactif",
    invalidId: "ID invalide.",
    invoicedHtLines: "Facturé HT (lignes)",
    invoicesIssuedByTechnician: "Factures émises par le technicien",
    linesHandled: "Lignes traitées",
    list: "Liste",
    loading: "Chargement…",
    net: "net",
    noPairConfigured: "aucune paire configurée",
    notFound: "Technicien introuvable dans les sociétés accessibles.",
    noticesBlockHint:
      "Le technicien ne prend pas de nouveau véhicule, n'importe pas de devis et n'utilise pas le scanner. « Lu et compris » ne débloque pas : seul le bouton « Tâche terminée — débloquer » ici.",
    noticesBlockLabel: "Bloquer le portail jusqu'au déblocage par le bureau",
    noticesBlockedBadge: "portail bloqué",
    noticesDonePre: "fait le",
    noticesEmpty: "Aucun message envoyé.",
    noticesHint:
      "Le message s'ouvre en pop-up à chaque entrée du technicien dans le portail. « Lu » le ferme jusqu'à la prochaine connexion ; « Fait » le termine. Écrivez dans sa langue. Pour toute l'équipe, utilisez le menu Messages équipe.",
    noticesNoLogin: "Ce technicien n'a pas d'accès au portail.",
    noticesPlaceholder: "Ex. : terminez les véhicules GE-707-JH et GC-166-WP dans le portail…",
    noticesReadPre: "lu le",
    noticesResolveBtn: "Tâche terminée — débloquer le portail",
    noticesResolvedPre: "débloqué le",
    noticesSendBtn: "Envoyer le message",
    noticesTitle: "Message dans le portail du technicien",
    noticesUnread: "pas encore lu",
    open: "ouvrir",
    operational: "Opérationnel",
    paymentsToTechnician: "Paiements au technicien",
    period12m: "12 derniers mois",
    period30d: "30 derniers jours",
    period3m: "3 derniers mois",
    period6m: "6 derniers mois",
    periodAll: "Tout",
    periodCustom: "Dates personnalisées",
    periodSince: "Depuis le 01/05/2026 (début Gestion)",
    periodYear: "Année en cours",
    phone: "Téléphone",
    portalRoleLabel: "Fonction dans le portail",
    registration: "Fiche",
    reversal: "extourne",
    statusApproved: "approuvée",
    statusCancelled: "annulée",
    statusCustomerReceived: "encaissée",
    statusDraft: "brouillon",
    statusIssued: "émise",
    statusPaid: "payée",
    statusPending: "en attente",
    statusReceived: "reçue",
    statusRejected: "rejetée",
    tabAudit: "Journal d'audit",
    tabFaturas: "Factures technicien",
    tabNotices: "Messages portail",
    tabPagamentos: "Paiements",
    tabResumo: "Résumé",
    tabWorklog: "Journal de travail",
    taxId: "Tax ID",
    toPay: "À payer",
    total: "total",
    totalIssuedByTechnician: "Total émis par le technicien",
    totalPaid: "Total payé",
    window: "Fenêtre",
    wlAwaitingClient: "En attente du client",
    wlByCustomer: "CA par client",
    wlCardFilterHint: "Cliquez sur une carte pour filtrer la liste ci-dessous.",
    wlCarsWord: "véhicules sur la période",
    wlClearFilter: "effacer le filtre",
    wlClientInvoiced: "Facturé",
    wlClientPaidBadge: "Encaissé",
    wlClientReceived: "Encaissé du client",
    wlClientToInvoice: "À facturer",
    wlColCar: "Véhicule",
    wlColClientReceived: "Encaissé client",
    wlColCommission: "Commission",
    wlColProduced: "Produit",
    wlColService: "Service",
    wlEmpty: "Aucune ligne de service sur la période.",
    wlMontage: "Montage",
    wlNoPairBtn: "Configurer les paires",
    wlNoPairChip: "Paire technicien×client absente ou à 0% — commission non calculée",
    wlNoPairPre: "Commission à zéro — paire technicien×client absente ou à 0% avec :",
    wlNoPairShort: "sans paire",
    wlNoPairSuf:
      "Modifiez le % de la paire (et enregistrez la ligne) puis utilisez « Recalculer les commissions » dans Dossiers.",
    wlOfProduced: "du produit",
    wlPaidBeforeClient: "Payé avant le client",
    wlPaidBeforeClientHint:
      "Le technicien a été payé pour ce véhicule avant le paiement du client (avancé par l'entreprise).",
    wlPayBtn: "Payer les libérés",
    wlPendingCalc: "lignes à calculer",
    wlProduced: "Produit (facturé)",
    wlProducedShort: "prod.",
    wlProducedSub: "montant HT de ses véhicules",
    wlReceived: "Payé au technicien (période)",
    wlReceivedShort: "encaiss.",
    wlReleased: "Libéré (client encaissé)",
    wlRemaining: "Reste",
    wlShareDemontage: "Démontage (moitié)",
    wlShareMontage: "Montage (moitié)",
    wlStatusAwaiting: "Attente client",
    wlStatusReleased: "Libéré",
    wlTbd: "à calculer",
    wlToReceive: "CA à recevoir (commissions)",
  },
  technicianPayments: {
    advAccountHint:
      "Chaque avance reste ouverte jusqu'à ce que le technicien la déduise de sa facture (cochée dans « Enregistrer la facture reçue »).",
    advAmount: "Montant",
    advBankHint:
      "Sorti du compte de la société ? Alors rapprochez la sortie dans le relevé et cochez « C'est une avance à un technicien » là-bas — ne saisissez pas ici.",
    advCancel: "Annuler",
    advCancelMsg: "Motif de l'annulation (conservé dans l'historique) :",
    advCancelTitle: "Annuler l'avance",
    advDate: "Date",
    advDescription: "Description",
    advDescriptionHint: "Ex. : hôtel Ibis 3 nuits, outils PDR PILLON…",
    advFormIncomplete:
      "Choisissez le technicien, saisissez un montant supérieur à zéro et une description.",
    advNew: "Nouvelle avance",
    advNoneOpen: "Aucune avance sur compte en cours.",
    advOrigin: "Origine",
    advOriginAdjustment: "ajustement du devis",
    advOriginBank: "Compte de la société (relevé)",
    advOriginCash: "Espèces",
    advOriginPartner: "Poche / compte de l'associé",
    advPartnerNote: "Payés de la poche de l'associé (ne sortent pas de la caisse de la société) :",
    advSave: "Enregistrer",
    allPayers: "Toutes les payeuses",
    allPaymentStatuses: "Tous les statuts paiement",
    allTechnicians: "Tous les techniciens",
    amountLabel: "Montant (€)",
    backAllTechs: "Tous les techniciens",
    byTechCars: "véhicule(s)",
    byTechColAdvanced: "Avancé",
    byTechColAdvancedTitle: "Avances sur compte pas encore déduites de la facture du technicien",
    byTechColPaid: "Payé",
    byTechColPending: "En attente",
    byTechColReleased: "Libéré (à reverser)",
    byTechColWaiting: "En attente client",
    byTechHint:
      "Cliquez sur le technicien pour ouvrir ses lignes. Libéré = le client a déjà payé ; En attente = la facture client est encore ouverte.",
    byTechLines: "ligne(s)",
    cancel: "Annuler",
    cardNoInvoice: "Sans facture technicien",
    cardPaid: "Payé",
    cardPaidTotal: "Payé intégralement",
    cardToPay: "À payer",
    cardWaiting: "En attente",
    clearBtn: "Effacer",
    clearFilters: "Effacer les filtres",
    clearFiltersTitle: "Réinitialise tous les filtres par défaut",
    colAction: "Action",
    colAttachment: "Pièce jointe",
    colCustomer: "Client",
    colCustomerInvoice: "Facture client",
    colDossier: "Dossier",
    colInvoiceStatus: "Statut facture",
    colPaid: "Payé",
    colPaymentStatus: "Statut paiement",
    colPlate: "Plaque",
    colSituation: "Situation",
    colTechnician: "Technicien",
    colToPay: "À payer",
    colVehicle: "Véhicule",
    commissionInvalid: "commissionPercent invalide (0..100).",
    commissionLabel: "Commission (%) — optionnel",
    createProforma: "Créer la proforma",
    creating: "Création…",
    custRecAll: "Tous",
    custRecReceived: "Encaissé (règlement libéré)",
    custRecWaiting: "En attente du client",
    customMessageLabel: "Message personnalisé (optionnel)",
    cxAdvances: "Avances en cours",
    cxAdvancesAccount: "avances sur compte",
    cxAdvancesAccountTitle:
      "Hôtel, outils, argent de l'associé… déduits de la prochaine facture du technicien",
    cxAdvancesTitle:
      "Véhicules pas encore payés par le client mais déjà payés au technicien ou en proforma",
    cxAvailable: "Disponible à reverser",
    cxBankBalance: "Solde du relevé",
    cxBankBalanceNone: "aucun solde importé : importez le dernier relevé dans Banque → Importer",
    cxBankBalanceTitle:
      "Solde indiqué par le dernier fichier bancaire importé, à la date du relevé. Il n'est pas calculé par le Gestion.",
    cxColAdvanced: "Avancé",
    cxHint:
      "L'argent encaissé est commun : on peut avancer des véhicules d'un technicien (onglet « En attente du client ») avec la trésorerie d'un autre. Chaque véhicule n'est payé qu'une fois — en proforma ou payé, il ne revient pas.",
    cxInProforma: "Déjà en proforma",
    cxNoAdvances: "Aucune avance en cours.",
    cxOverBankPre: "Le disponible dépasse le solde du relevé de",
    cxOverBankSuf:
      "Payez au maximum le plus petit des deux (l'argent reçu a aussi payé impôts, fournisseurs et associés).",
    cxPaidBefore: "payé avant le client",
    cxReleasedFree: "Encaissé à reverser (hors proforma)",
    dateFrom: "Date de début",
    dateTo: "Date de fin",
    degPendingHint:
      "Chaque pièce du véhicule (PDR, démontage, montage) est payée une seule fois, à celui qui l'a faite. Vous pouvez payer ce qui est prêt maintenant ; le reste ira dans la prochaine proforma de celui qui le fera.",
    degPendingOther:
      "il manque le démontage ou le montage d'un autre technicien (hors de cette proforma)",
    degPendingOwn:
      "le démontage ou le montage de ce technicien n'est pas encore fait : cette part ira dans une prochaine proforma",
    degPendingTitle: "Dégarnissage pas encore terminé sur ces véhicules",
    detailsHint:
      "Totaux sur tout le filtre. Cliquez sur le véhicule pour voir la répartition, la facture du technicien et payer.",
    devisLabel: "Devis",
    diffTechnicians: "techniciens différents — sélectionnez le même technicien",
    emptyState: "Aucune écriture trouvée.",
    entryPlural: "écritures",
    entrySingular: "écriture",
    extBtn: "Enregistrer payé hors proforma",
    extBtnHint: "Le technicien a déjà été payé hors proforma (équipe interne)",
    extDate: "Date du paiement",
    extHint:
      "Pour qui a déjà été payé hors proforma : équipe interne, salaire, espèces ou virement. Le Gestion crée un enregistrement interne (INT) déjà payé : les pièces passent en payé et sortent du « à payer ». Aucun e-mail, aucun PDF, rien dans la banque ni dans les avances. Annuler : sur la page de l'enregistrement (admin).",
    extIntermPre: "La part de l'intermédiaire",
    extIntermSuf: "n'entre pas dans cet enregistrement : seule la part du technicien est payée.",
    extMethod: "Mode",
    extMethodDinheiro: "Espèces",
    extMethodOutro: "Autre",
    extMethodSalario: "Salaire (équipe interne)",
    extMethodTransferencia: "Virement",
    extNote: "Motif / remarque (obligatoire)",
    extNotePh: "ex. : salaire d'octobre, équipe interne",
    extSubmit: "Enregistrer le paiement",
    extTitle: "Enregistrer un paiement fait hors proforma",
    filterCompany: "Société",
    filterCustomerReceived: "Client encaissé",
    filterPayer: "Société payeuse",
    filterPaymentStatus: "Statut paiement",
    filterPeriod: "Période (date facture)",
    filterSearch: "Rechercher",
    filterSortBy: "Trier par",
    filterTechnician: "Technicien",
    flowDetected: "Flux détecté :",
    flowDirect: "Direct au technicien",
    flowExternal: "Intermédiaire externe",
    flowExternalPre: "Ce technicien est payé par",
    flowExternalSuf: "(intermédiaire externe). Générez le paiement dans Intermédiaires.",
    flowGroup: "Société du groupe (intercompany)",
    flowMismatchHint:
      "La proforma utilise les montants des LIGNES. Corrigez la commission des lignes dans le dossier avant de générer.",
    flowMismatchLines: "lignes",
    flowMismatchPair: "couple",
    flowMismatchTitle:
      "Lignes calculées avec une autre part de l'intermédiaire que celle du couple :",
    flowPreviewError: "Impossible de déterminer le destinataire.",
    flowSourceNote:
      "Décidé par le couple technicien × client de chaque véhicule (ou par l'intermédiaire de la fiche du technicien).",
    forceOverride: "Forcer (override admin)",
    gateBlocked: "Payment gate (F10.3) a bloqué :",
    generateProforma: "Générer la proforma",
    inProforma: "En proforma",
    invStatusApproved: "approuvée",
    invStatusPending: "sans facture",
    invStatusReceived: "reçue",
    invStatusRejected: "rejetée",
    invalidAmount: "Montant invalide.",
    invoiceLabel: "Facture",
    invoicedLabel: "Facturé",
    kpiPrefix: "Les KPI reflètent la page actuelle",
    kpiSuffix: "lignes dans le filtre",
    lineInProforma: "La ligne est déjà dans la proforma",
    linePlural: "lignes",
    lineSelectedPlural: "lignes sélectionnées",
    lineSelectedSingular: "ligne sélectionnée",
    lineSingular: "ligne",
    linesSubtitle: "lignes",
    loading: "Chargement…",
    loadingTechnician: "Chargement du technicien…",
    methodBankTransfer: "Virement",
    methodCard: "Carte",
    methodCash: "Espèces",
    methodCheck: "Chèque",
    methodLabel: "Méthode",
    methodOther: "Autre",
    next: "Suivant",
    noCommissionTag: "sans commission",
    noCommissionTitle:
      "Véhicules payés par le client sans commission calculée : le couple technicien × client n'est pas configuré.",
    noCommissionWarn:
      "véhicule(s) payé(s) par le client n'ont PAS de commission calculée (couple technicien × client non configuré) et ne comptent pas dans le montant libéré. Configurez le couple dans la fiche du technicien.",
    noCompanyAccess: "Vous n'avez accès à aucune société.",
    noInvoiceAlert:
      "Cette ligne n'a pas encore de facture du technicien. Créez la technician_invoice avant de payer.",
    noTechInvoice: "pas encore reçue",
    noTechnicianData: "Aucune donnée du technicien.",
    notReceived: "à encaisser",
    notesLabel: "Notes (optionnel)",
    of: "sur",
    optCancelled: "Annulé",
    optPaid: "Payé",
    optPending: "En attente",
    overridePlaceholder: "Justification (min 5 caractères) — enregistrée dans le journal d'audit",
    pageWord: "Page",
    paidAtLabel: "Payé le",
    payBtn: "Payer",
    payDialogTitle: "Enregistrer le paiement au technicien",
    payStatusCancelled: "annulé",
    payStatusPaid: "payé",
    payStatusPending: "en attente",
    payTitle: "Enregistrer le paiement",
    payTitleNoInvoice: "Créez d'abord la technician_invoice",
    pdfLanguageLabel: "Langue du PDF",
    pillReleased: "Libéré",
    pillWaiting: "Attente client",
    prev: "Précédent",
    proformaDialogTitle: "Générer la proforma du technicien",
    proformaTechnicianNote: "Proforma technicien — le déclencheur administratif NE se lance PAS.",
    receivedOn: "encaissé le",
    receivedWord: "encaissé",
    recipientLabel: "Destinataire :",
    recipientTypeLabel: "Type de destinataire :",
    referenceLabel: "Référence (optionnel)",
    register: "Enregistrer",
    retentionInvalid: "retentionPercent invalide (0..100).",
    retentionLabel: "Rétention (%)",
    saving: "Enregistrement…",
    searchPlaceholder: "N° facture / dossier / plaque…",
    selAdvanceOver: "l'avance dépasse le disponible :",
    selAdvancePart: "avance",
    selIntermPart: "intermédiaire",
    selReleasedPart: "libéré",
    selTechPart: "technicien",
    selectFreeLines: "Sélectionner les lignes libres",
    selectionLabel: "Sélection",
    sortDefault: "Ordre : date ↓ (par défaut)",
    sortInvoiceAsc: "N° facture ↑",
    sortInvoiceDesc: "N° facture ↓",
    sortTitle: "Tri",
    stageAll: "Tous",
    stageReleased: "Libéré à reverser",
    stageReleasedShort: "libéré(s)",
    stageWaiting: "En attente du client",
    stageWaitingShort: "en attente",
    statusWord: "statut",
    techInvoiceLabel: "Facture du technicien",
    technicianLabel: "Technicien",
    totalToPay: "Total à payer",
  },
  technicians: {
    allLinked: "— tous les clients sont déjà associés —",
    appApproveBtn: "Valider",
    appApproved: "Validé",
    appCompaniesLabel: "Sociétés :",
    appExistsCars: "véhicules",
    appExistsPre: "Déjà dans Gestion en tant que",
    appExistsSuf: "— la fiche sera réutilisée, rien n’est dupliqué.",
    appPending: "En attente",
    appPrefixMade: "préfixe généré",
    appRejectBtn: "Refuser",
    appRejectPrompt: "Motif du refus :",
    appRejected: "Refusé",
    appRoleLabel: "Fonction",
    appRoleMontador: "Monteur",
    appRolePdr: "Technicien PDR",
    appShowAll: "Voir toutes",
    appShowPending: "En attente seulement",
    appsEmpty: "Aucune candidature en attente.",
    appsHint:
      "Inscriptions envoyées depuis la page publique. Valider crée le compte et la fiche technicien, avec le préfixe d’ordre généré sans collision.",
    badgeActive: "actif",
    badgeBlocked: "portail bloqué",
    badgeInactive: "inactif",
    baseFaturado: "Facturé",
    baseFaturadoFull: "Facturé (Total Facture)",
    baseOrcamento: "Devis",
    baseOrcamentoFull: "Devis (Prix Brut)",
    cancel: "Annuler",
    chantierAllLinked: "Tous les chantiers déjà liés",
    chantierBaseFaturado: "Facturé (Total Facture)",
    chantierBaseLabel: "Base de calcul",
    chantierBaseOrcamento: "Devis (Prix Brut)",
    chantierCommHint:
      "le % de ce technicien sur le chantier vaut pour tous ses clients sans paire spécifique",
    chantierCommTitle: "Commissions par chantier",
    chantierIntermLabel: "Intermédiaire",
    chantierIntermNone: "— sans intermédiaire —",
    chantierIntermPctLabel: "% Intermédiaire",
    chantierLinkOption: "+ Lier un chantier — sélectionner…",
    chantierNewTag: "nouveau — définissez le %",
    chantierPctLabel: "Commission du technicien (%)",
    chantierRemiseNote:
      "La remise vient de la FICHE de chaque client (particulier inclus) et est vérifiée à la réception du véhicule — le chantier ne définit pas de remise.",
    chantierSave: "Enregistrer",
    chantierUnlink: "Supprimer le lien",
    clientPctFallbackPre: "Vide : utilise la retenue de la fiche client —",
    clientPctFallbackSuf: "",
    clientPctHint: "Ce % ne vaut que pour ce lien et prime sur la fiche client.",
    clientPctMissing:
      "⚠ Client sans retenue dans la fiche — renseignez le % ici pour la base devis.",
    clientShort: "cli.",
    colActions: "Actions",
    colCommission: "Commission",
    colTaxId: "Identifiant fiscal",
    commissionRange: "La commission doit être comprise entre 0 et 100 %",
    commissionsSaveFirst:
      "Commissions par client : enregistrez d'abord le technicien, puis rouvrez pour associer des clients avec leur propre % et base.",
    commissionsSectionHint:
      "chaque paire client×technicien a son propre %, sa base et son intermédiaire",
    commissionsSectionTitle: "Commissions par client",
    companyLabel: "Société",
    create: "Créer",
    customerMissingPre: "Le client",
    customerMissingSuf:
      "n'a pas de % de rétention enregistré. Mettez à jour la fiche du client (menu Clients) — en base DEVIS, le client entre dans la répartition.",
    dash: "—",
    deactivate: "Désactiver",
    deactivateMessage:
      "Un technicien inactif n'apparaît pas dans les nouvelles lignes de dossier. Les lignes existantes ne sont pas affectées.",
    deactivatePlaceholder: "Ex. : le technicien a mis fin au partenariat",
    deactivateTitle: "Désactiver le technicien",
    dossierCountSuffix: "dossier(s)",
    edit: "modifier",
    email: "E-mail",
    emptyState: "Aucun technicien trouvé.",
    fieldBase: "Base de calcul",
    fieldClientPct: "% Remise du client (pour ce lien)",
    fieldCommissionPct: "Commission (%)",
    fieldCountry: "Pays (ISO-2)",
    fieldIntermediaryPct: "% Intermédiaire",
    fieldNotes: "Notes",
    fieldParcRole: "Type de service — Parc Grêle",
    fieldPhone: "Téléphone",
    fieldPortalUser: "Compte du portail (login du technicien)",
    fieldSenior: "Technicien senior (peut modifier la franchise)",
    fieldTaxId: "Identifiant fiscal (RIB/CPF/...)",
    fieldTaxIdKind: "Type d'identifiant fiscal",
    fieldTaxReason: "Motif de la modification de l'identifiant fiscal",
    fillIntermediary: "Renseignez l'intermédiaire",
    filterActive: "Actifs",
    filterAll: "Tous",
    filterInactive: "Inactifs",
    hintFatPre:
      "En base FACTURÉ, le client a déjà retenu avant la facture ; technicien + intermédiaire +",
    hintFatSuf: "= 100 % sur le reste.",
    hintOrcPre: "En base DEVIS, le client entre dans la répartition ;",
    hintOrcSuf: "absorbe le reste.",
    intermShort: "+ interm.",
    intermediary: "Intermédiaire",
    linkCustomerOption: "+ Associer un client — sélectionner…",
    loading: "Chargement…",
    loadingLinks: "Chargement des associations…",
    modalTitleCreate: "Nouveau technicien",
    modalTitleEdit: "Modifier le technicien",
    name: "Nom",
    newBtn: "+ Nouveau technicien",
    next: "Suivant",
    noCompanyAccess: "Vous n'avez accès à aucune société.",
    noIntermediary: "Sans intermédiaire",
    noIntermediaryAvailable:
      "Aucun intermédiaire disponible. Créez-en un dans « Intermédiaires » (externe) ou ajoutez une autre société au groupe.",
    noLinkedWarning:
      "Aucun client associé — sans paire configurée, la création/le recalcul des lignes de ce technicien échoue (saisissez les % manuellement dans le dossier ou associez le client ici).",
    noPctRegistered: "aucun % enregistré",
    open: "ouvrir",
    optgroupExternal: "Intermédiaires externes",
    optgroupGroupCompanies: "Sociétés du groupe",
    paginationOf: "sur",
    paginationPage: "Page",
    pairMissingTag: "sans paire",
    pairZeroTag: "paire à 0 %",
    parcRoleHint:
      "Pertinent uniquement pour les chantiers de grêle (Parc Grêle). Chaque technicien est autorisé pour UN seul type de service ; le paiement provient du montant fixe du forfait (et non de la commission).",
    parcRoleMontage: "Monteur / démontage",
    parcRoleNone: "— n'intervient pas sur le parc (technicien normal) —",
    perCustomer: "par client",
    portalUserHint:
      'Créez l\'utilisateur dans Utilisateurs avec le rôle "Technicien (portail)" et liez-le ici. Le technicien se connecte et prend les véhicules par immatriculation sur /portal.',
    portalUserNone: "— aucun compte lié —",
    prev: "Précédent",
    previewSampleBase: "base d'exemple : 1 000,00 €",
    previewTitle: "Aperçu de la répartition",
    reactivate: "Réactiver",
    removeLink: "Retirer l'association",
    residualExceedFat: "Technicien + intermédiaire",
    residualExceedOrc: "Client + technicien + intermédiaire",
    residualExceedSuf: "serait négatif — l'enregistrement de la ligne échouera.",
    save: "Enregistrer",
    savedNoChanges: "Enregistré — aucune modification",
    savedShort: "Enregistré",
    saving: "Enregistrement…",
    searchLabel: "Rechercher",
    searchPlaceholder: "Nom, e-mail, identifiant fiscal…",
    selectOption: "— Sélectionner —",
    seniorHint:
      "Tout technicien VOIT la franchise dans le portail. Seul le senior autorisé peut la modifier — et jamais le monteur.",
    status: "Statut",
    sumExceedPre: "Technicien + intermédiaire =",
    sumExceedSuf: "% > 100%.",
    sumOver100: "Technicien + intermédiaire dépasse 100 %",
    tabActive: "Techniciens",
    tabApplications: "Candidatures",
    taxIdAdminOnly: "Seuls les administrateurs peuvent modifier l'identifiant fiscal.",
    taxKindOther: "Autre",
    taxKindVatEu: "TVA (autre pays UE)",
    taxReasonPlaceholder: "Obligatoire lors de la modification des données fiscales",
    technicianLabel: "Technicien",
    technicianPlural: "techniciens",
    technicianSingular: "technicien",
    theCompany: "la société",
    totalLabel: "Total",
    withIntermediary: "Avec intermédiaire",
    withoutPairCount: "client(s) avec des dossiers sans paire configurée ou avec une paire à 0 %",
    withoutPairHint:
      "Sans paire, le calcul utilise la base par défaut (facturé) par repli ; une paire à 0 % laisse la commission du technicien à zéro. Configurez/ajustez la paire ci-dessous pour que le calcul soit correct :",
  },
  treasury: {
    allCommissionsOk:
      "Toutes les lignes bouclent avec la bonne base (client + technicien + moitiés + intermédiaire + Euro Storm = devis − franchise − part faite par le garage). Rien de suspect.",
    badgeConsolidated: "consolidée",
    blockedClientNotPaid: "bloqué (client non payé)",
    blockedLabel: "bloqué",
    cascadeBaseHint:
      "Base attendue = devis − franchise (client particulier et valeur manuelle : devis complet) − moitié du dégarnissage faite par le garage. La somme inclut les moitiés confiées à un autre technicien.",
    cascadeNotClosingSuffix:
      "avec une cascade qui NE boucle PAS avec la base — à revoir avant paiement.",
    col1_30: "1–30 j",
    col31_60: "31–60 j",
    col61_90: "61–90 j",
    col90: "> 90 j",
    colBalance: "Solde",
    colBudget: "Devis",
    colCascadeSum: "Somme cascade",
    colCustomer: "Client",
    colDelay: "Retard",
    colDiff: "Différence",
    colDossier: "Dossier",
    colDueDate: "Échéance",
    colExpectedBase: "Base attendue",
    colIntermediary: "Interm.",
    colInvoiceNumber: "N° facture",
    colInvoices: "Factures",
    colMaxDelay: "retard max.",
    colNotDue: "Non échu",
    colTechnician: "Technicien",
    colTotalHt: "En attente HT",
    colTotalTtc: "À régler TTC",
    commissionCheckTitle: "Vérification des commissions",
    companyLabel: "Société :",
    daysAbbrev: "j",
    emptyByCustomer: "Aucune facture en attente.",
    emptyNoOverdue: "Aucune facture échue. 🎉",
    invoicesSuffix: "factures",
    linePlural: "lignes",
    lineSingular: "ligne",
    loading: "Chargement…",
    overdueLower: "échu",
    payableTitle: "À payer",
    receivableCustomerTitle: "À recevoir — client",
    releasedExplainPre: "« Débloqué » = le client a déjà payé (gate). Détail par technicien dans",
    releasedExplainSuf:
      ". La commission technicien/intermédiaire provient des lignes (les documents de facture ne sont pas encore utilisés).",
    statAging0_30: "1–30 jours",
    statAging31_60: "31–60 jours",
    statAging61_90: "61–90 jours",
    statAging90plus: "+90 jours",
    statIntercompanyReceivable: "À recevoir intercompany",
    statIntermediaryIntercompany: "Intermédiaire (BS) — intercompany",
    statIntermediaryReleased: "Intermédiaire — débloqué à reverser",
    statNotDue: "À échoir",
    statOpen: "En cours",
    statOverdue: "Échu",
    statSupplierOpen: "Fournisseur — en cours",
    statTechnicianReleased: "Technicien — débloqué à payer",
    statementBtn: "Relevé",
    techPaymentsLink: "Paiements techniciens",
    viewByCustomer: "Par client",
    viewByInvoice: "Par facture (échues)",
  },
  users: {
    accessPerCompany: "Accès par société",
    accessRestricted: "Accès réservé aux administrateurs.",
    adminScopeNote:
      "Vous voyez les comptes des sociétés que vous administrez. Seul le Super Admin modifie les comptes Administrateur.",
    cancelBtn: "Annuler",
    cannotChangeOwnSuperAdmin: "Vous ne pouvez pas modifier votre propre statut de super admin",
    closeBtn: "Fermer",
    colAccessPerCompany: "Accès par société",
    colActions: "Actions",
    colEmail: "E-mail",
    colName: "Nom",
    colStatus: "Statut",
    colSuperAdmin: "Super admin",
    copiedBtn: "Copié ✓",
    copyLinkBtn: "Copier le lien",
    createBtn: "Créer",
    createErrorTitle: "Erreur lors de la création de l'utilisateur",
    createLinkBtn: "Créer et envoyer le lien",
    createLinkHint:
      "La personne reçoit par e-mail un lien pour définir son mot de passe (valable 72 h).",
    creatingBtn: "Création…",
    deactivateAccount: "Désactiver le compte",
    deleteBtn: "Supprimer l'utilisateur",
    deleteConfirmPre: "Supprimer définitivement",
    deleteConfirmSuf:
      "Le nom et l'e-mail seront LIBÉRÉS pour un nouveau compte ; l'historique (audit) est conservé. Action irréversible.",
    deleteConfirmTitle: "Supprimer l'utilisateur ?",
    deleteDonePre: "Compte supprimé. L'e-mail",
    deleteDoneSuf: "est libre pour un nouveau compte.",
    deleteDoneTitle: "Utilisateur supprimé",
    editBtn: "Modifier",
    editSavedMsg: "Nom et e-mail enregistrés.",
    editSavedTitle: "Données mises à jour",
    editTitle: "Modifier l'utilisateur",
    emailLabel: "E-mail",
    emailLockedHint: "Compte déjà utilisé : seul le Super Admin change l'e-mail.",
    errorTitle: "Erreur",
    fullAccessAllCompanies: "Accès total (toutes les sociétés)",
    impersonateBtn: "Se connecter en tant que",
    impersonateBtnTitle:
      "Ouvrir l'app exactement comme cet utilisateur la voit (tracé dans l'audit ; votre session admin sera remplacée)",
    impersonateConfirmMsg:
      "Votre session admin dans ce navigateur sera remplacée par celle de cet utilisateur (max 2 h). Pour revenir, utilisez « Quitter la vue » dans le bandeau orange puis reconnectez-vous. Tout est tracé dans l'audit. Continuer ?",
    introPre: "Accès défini ",
    introStrong: "par société",
    introSuf:
      ". Le super admin accède à tout. L'Administrateur gère les comptes des sociétés qu'il administre, sauf ceux des Administrateurs.",
    inviteByEmail: "Inviter par e-mail",
    levelAdminDesc: "— gestion complète de la société (y compris les utilisateurs et les règles).",
    levelSuperAdminDesc:
      "— global : accès illimité à toutes les sociétés, inclut le module Financier.",
    levelUserDesc: "— opérationnel : crée/modifie/importe ; ne gère pas les utilisateurs.",
    levelViewerDesc: "— lecture seule : filtre et consulte, ne modifie pas.",
    levelsTitle: "Niveaux (par société) :",
    linkCopyHint: "Si l'e-mail n'arrive pas, copiez le lien et envoyez-le par WhatsApp :",
    linkHiddenNote: "Par sécurité, le lien d'un compte déjà utilisé part uniquement par e-mail.",
    linkMissingData: "Renseignez le nom et l'e-mail.",
    linkResentTitle: "Lien envoyé",
    linkResultFailed:
      "L'e-mail n'est pas parti. Copiez le lien ci-dessous et envoyez-le autrement (WhatsApp).",
    linkResultSent: "E-mail avec le lien envoyé à",
    linkSentTitle: "Compte créé",
    loading: "Chargement…",
    localeLabel: "Langue de l'e-mail",
    menuAgenda: "Agenda",
    menuChantiers: "Chantiers",
    menuClientes: "Clients",
    menuDevis: "Devis",
    menuDossiers: "Dossiers",
    menuFaturas: "Factures",
    menuLevelOperate: "opérer",
    menuLevelView: "voir",
    menuPainel: "Tableau de bord",
    menuTecnicos: "Techniciens",
    menuVeiculos: "Véhicules",
    menusBtn: "Menus",
    menusHint:
      "Uniquement pour les rôles de portail (gérant, technicien, client). Les données restent limitées aux chantiers gérés par la personne.",
    menusNone: "aucun",
    menusSave: "Enregistrer les menus",
    menusSaved: "Menus enregistrés.",
    menusTitle: "Menus du Gestion autorisés",
    missingDataMessage: "Renseignez le nom, l'e-mail et un mot de passe d'au moins 8 caractères.",
    missingDataTitle: "Données manquantes",
    nameLabel: "Nom",
    needOneAccess: "Choisissez l'accès dans au moins une société.",
    newUserBtn: "+ Nouvel utilisateur",
    noAccess: "Aucun accès",
    pageTitle: "Utilisateurs",
    passwordLabel: "Mot de passe (min. 8)",
    reactivateAccount: "Réactiver le compte",
    resetPwBtn: "Réinitialiser le mot de passe",
    resetPwBtnTitle:
      "Définir un nouveau mot de passe pour ce compte (l'ancien cesse d'être valable)",
    resetPwDonePre: "Nouveau mot de passe défini pour",
    resetPwDoneSuf: "Communiquez-le à l'utilisateur — l'ancien mot de passe ne fonctionne plus.",
    resetPwDoneTitle: "Mot de passe réinitialisé",
    resetPwPlaceholder: "Minimum 8 caractères — notez-le pour l'utilisateur",
    resetPwTitle: "Nouveau mot de passe",
    resetPwTooShort: "Le mot de passe doit comporter au moins 8 caractères.",
    roleAdmin: "Administrateur",
    roleClient: "Client (portail)",
    roleManager: "Chef de projet (chantier)",
    roleTechnician: "Technicien (portail)",
    roleTechnicianMontador: "Monteur (portail)",
    roleTechnicianPdr: "Technicien PDR (portail)",
    roleUser: "Utilisateur",
    roleViewer: "Lecteur",
    sendLinkBtn: "Envoyer",
    sendLinkConfirmPre: "Envoyer à",
    sendLinkConfirmSuf: "un e-mail avec le lien pour définir le mot de passe ?",
    sendLinkTitle: "Envoyer le lien de mot de passe",
    statusActive: "Actif",
    statusInactive: "Inactif",
    superAdmin: "Super admin",
    superAdminCheckbox: "Super admin (accès illimité à toutes les sociétés)",
    technicianCreatedMsg:
      "la fiche a été créée dans cette société à partir de celle qu'il avait déjà. Il ne reste qu'à configurer les paires technicien×client ou chantier dans Techniciens → modifier.",
    technicianCreatedTitle: "Fiche technicien créée",
    technicianMissingMsg:
      "L'accès a été accordé, mais la fonction (PDR ou monteur) n'est enregistrée que sur la fiche technicien de cette société. Créez le technicien dans Techniciens, liez ce compte et choisissez à nouveau la fonction.",
    technicianMissingTitle: "Aucune fiche technicien",
    userCreatedSuffix: "créé.",
    userCreatedTitle: "Utilisateur créé",
    youTag: "(vous)",
  },
  vehicles: {
    badgeActive: "actif",
    badgeInactive: "inactif",
    cancel: "Annuler",
    catalogBadge: "catalogue",
    catalogLinkedTitle: "Lié au catalogue",
    chipCadastro: "Création",
    chipDevis: "Devis",
    chipEmReparacao: "En réparation",
    chipFaturado: "Facturé",
    chipPago: "Encaissé",
    chipRecebidoPago: "Encaissé · payé",
    chipRecebidoPendente: "Encaissé · à payer",
    chipReparado: "Réparé",
    colActions: "Actions",
    colColor: "Couleur",
    colCustomer: "Client",
    colMakeModel: "Marque / modèle",
    colPlate: "Plaque",
    colStatus: "Statut",
    colYear: "Année",
    companyLabel: "Société",
    create: "Créer",
    customerOptionalLabel: "Client (facultatif)",
    customerSearchPlaceholder: "Saisissez au moins 2 lettres pour rechercher",
    deactivate: "Désactiver",
    deactivateMessage:
      "Un véhicule inactif n'apparaît pas dans les nouveaux dossiers. Les dossiers existants ne sont pas affectés.",
    deactivatePlaceholder: "Ex : véhicule mis à la casse",
    deactivateTitle: "Désactiver le véhicule",
    dossiersWord: "dossiers",
    editLink: "modifier",
    editTitle: "Modifier le véhicule",
    emptyState: "Aucun véhicule trouvé.",
    errInvalidYear: "Année invalide.",
    errPlateOrVin: "Renseignez au moins la plaque ou le VIN.",
    filterActive: "Actifs",
    filterAll: "Tous",
    filterInactive: "Inactifs",
    generationLabel: "génération",
    hintChooseMakeFirst: "Choisissez d'abord la marque",
    hintMakeFreeText: "Marque en texte libre — le modèle sera en texte libre",
    historyCurrent: "ce dossier",
    historyDevis: "Devis",
    historyDevisPdf: "PDF du devis",
    historyDossierWord: "Dossier",
    historyDossiersWord: "dossiers",
    historyHint:
      "Chaque dossier est une intervention sur le véhicule ; le plus récent est en haut.",
    historyOpen: "Ouvrir",
    historyTitle: "Fiche du véhicule",
    loading: "Chargement…",
    makeLabel: "Marque",
    makePlaceholder: "Ex : Peugeot, Renault…",
    menuTitle: "Dossiers du véhicule",
    modelFreePlaceholder: "Modèle (texte libre)",
    modelLabel: "Modèle",
    modelPlaceholder: "Ex : 308, Clio…",
    newBtn: "Nouveau véhicule",
    next: "Suivant",
    noCompanyAccess: "Vous n'avez accès à aucune société.",
    noCustomer: "sans client",
    noCustomerFound: "Aucun client trouvé.",
    noDossiers: "Aucun dossier",
    noMakeInCatalog:
      "Aucune marque dans le catalogue. Le texte saisi sera enregistré en texte libre.",
    noModelInCatalog:
      "Aucun modèle dans le catalogue pour cette marque. Le texte saisi sera enregistré en texte libre.",
    notesLabel: "Notes",
    ofLabel: "sur",
    pageLabel: "Page",
    prev: "Précédent",
    reactivate: "Réactiver",
    remove: "retirer",
    requestProforma: "Demander une proforma (avance au technicien)",
    save: "Enregistrer",
    saving: "Enregistrement…",
    searchLabel: "Rechercher",
    searchPlaceholder: "Plaque, châssis, marque, modèle…",
    searching: "Recherche…",
    statusLabel: "Statut",
    vehiclePlural: "véhicules",
    vehicleSingular: "véhicule",
    vinLabel: "VIN (châssis)",
  },
  worklog: {
    carWordSingular: "véhicule",
    carsWord: "véhicules",
    clientSectionTitle: "Worklogs des techniciens",
    emailBtn: "Envoyer au client",
    emailSentPre: "Worklog envoyé à",
    emptyWeek: "Aucune intervention cette semaine.",
    exportHint:
      "Production de la semaine par client — sans commissions. Téléchargez le PDF ou envoyez-le directement au client.",
    exportTitle: "Worklog hebdomadaire (document client)",
    generatingBtn: "Génération…",
    interventionsWord: "interventions",
    pdfBtn: "Télécharger le PDF",
    weekPre: "Semaine",
  },
};

export const enPages: PagesMessages = {
  about: {
    buildLabel: "Build",
    productLabel: "Product",
    tagline: "Internal management system of the Euro Storm group.",
    title: "About",
    versionLabel: "Version",
  },
  account: {
    changePassword: "Change password",
    confirmNewPassword: "Confirm new password",
    currentPassword: "Current password",
    emailHint:
      "Your email is used to sign in and to recover your password. To change it, contact the office.",
    emailLabel: "Email",
    errorMinLength: "The new password must contain at least 8 characters.",
    errorMismatch: "The confirmation does not match the new password.",
    errorSameAsCurrent: "The new password must be different from the current one.",
    minHint: "Minimum 8 characters.",
    newPassword: "New password",
    pageSubtitle: "Your sign-in details and password management.",
    saving: "Saving…",
    successChanged: "Password changed successfully.",
    title: "My account",
    userLabel: "User",
  },
  agendaPage: {
    cancelRdvBtn: "Cancel appointment",
    chantierAutoHint: "A customer linked to a chantier inherits it automatically.",
    chantierLabel: "Chantier",
    closeBtn: "Close",
    customerLabel: "Customer",
    dateLabel: "Date",
    emptyDay: "No appointments",
    filterAllLabel: "All chantiers and customers",
    filterNoChantier: "Customers without chantier",
    kpiToday: "today",
    kpiWeek: "this week",
    modalEditTitle: "Edit appointment",
    modalNewTitle: "New appointment",
    newRdvBtn: "New appointment",
    nextRdvLabel: "Next appointments",
    noRdvWeek: "No appointments this week.",
    noneOption: "— none —",
    notesLabel: "Notes",
    openAgenda: "Open agenda",
    plateLabel: "Plate",
    saveBtn: "Save",
    savingBtn: "Saving…",
    statusArrived: "Arrived",
    statusDone: "Done",
    statusEmReparacao: "In repair",
    statusFaturado: "Invoiced",
    statusHint: "Click the status to advance (Scheduled → Arrived → Done).",
    statusOrcamento: "Estimate",
    statusPago: "Paid",
    statusRecebido: "Received",
    statusReparado: "Repaired",
    statusScheduled: "Scheduled",
    subtitle: "Chantier and customer appointments — week by week",
    timeLabel: "Time",
    title: "Agenda",
    todayBtn: "Today",
    vehicleLabel: "Vehicle (make/model)",
    weekPre: "Week",
    weekTotalTitle: "Week total to invoice (excl. VAT)",
  },
  audit: {
    actionPlaceholder: "action (e.g. login)",
    asUserPre: "as",
    colAction: "Action",
    colChanges: "Changes",
    colEntity: "Entity",
    colWhen: "When",
    colWho: "Who",
    companyLabel: "Company:",
    emptyState: "No events found.",
    entityKindPlaceholder: "entity kind (e.g. customer)",
    filterAction: "Action",
    filterCompany: "Company",
    filterEntity: "Entity",
    loading: "Loading…",
    nextBtn: "Next →",
    notAdmin: "You are not an administrator of any company.",
    of: "of",
    page: "Page",
    prevBtn: "← Previous",
    title: "Audit log",
  },
  bankAccounts: {
    accountPlural: "accounts",
    accountSingular: "account",
    adminCreatesZeroBalance:
      "A regular admin creates the account with a balance of 0 (adjust later via a super admin).",
    badgeActive: "active",
    badgeInactive: "inactive",
    bankLabel: "Bank",
    cancelBtn: "Cancel",
    colActions: "Actions",
    colCurrency: "Currency",
    colOpening: "Opening",
    colWise: "Wise",
    companyLabel: "Company",
    createBtn: "Create",
    currencyIsoLabel: "Currency (ISO 4217)",
    deactivateAccountPre: "Deactivate account",
    deactivateBtn: "Deactivate",
    deactivateMessage:
      "An inactive account no longer receives new imports/syncs. Existing transactions and reconciliations are not affected.",
    deactivateReasonPlaceholder: "E.g.: account closed at the bank",
    defaultInvoicesBadge: "default on invoices",
    editBtn: "edit",
    emptyState: "No accounts found.",
    filterActive: "Active",
    filterAll: "All",
    filterInactive: "Inactive",
    ibanChangeReasonLabel: "Reason for the IBAN change",
    ibanPlaceholder: "FR76 ... (no spaces)",
    invalidOpeningBalance: "Invalid opening balance.",
    labelField: "Label",
    labelPlaceholder: "E.g.: SocGen ES — main current account",
    loading: "Loading…",
    makeDefaultInvoicesBtn: "Use as default on invoices",
    makeDefaultInvoicesShort: "Make default",
    modalTitleCreate: "New bank account",
    modalTitleEdit: "Edit bank account",
    newBtn: "+ New account",
    nextBtn: "Next →",
    noCompanyAccess: "You do not have access to any company.",
    notesLabel: "Notes",
    ofWord: "of",
    onlySuperAdminEditsOpening: "Only super administrators can edit the opening balance.",
    onlySuperAdminOpening:
      "Only super administrators can change the opening balance or opening date.",
    openingBalanceLabel: "Opening balance",
    openingChangeReasonLabel: "Reason for the opening balance/date change",
    openingDateLabel: "Opening date",
    openingNonZeroReasonLabel: "Reason for opening balance != 0",
    openingReasonRequired:
      "A justification is required to change the opening balance / opening date.",
    pageWord: "Page",
    prevBtn: "← Previous",
    providerLabel: "Provider (determines the import)",
    providerOther: "Other — no automatic import",
    providerSg: "Société Générale — CSV upload",
    providerWise: "Wise — API sync",
    reactivateBtn: "Reactivate",
    saveBtn: "Save",
    saving: "Saving…",
    searchLabel: "Search",
    searchPlaceholder: "Label, IBAN, bank…",
    statusLabel: "Status",
    wiseAutoNote:
      "Once linked, the account syncs by itself every morning (from 6 am Paris time). You can also click Sync now.",
    wiseBalancePre: "balance",
    wiseConnectBtn: "Link to Wise",
    wiseCopied: "copied",
    wiseCopyBtn: "Copy key",
    wiseDisconnectBtn: "Unlink",
    wiseDisconnectMsg:
      "The token and the signing key are deleted. Already imported transactions stay.",
    wiseDisconnectTitle: "Unlink Wise from this account",
    wiseDoneBtn: "Done",
    wiseDownloadKeyBtn: "Download key (.pem)",
    wiseFetchProfilesBtn: "Fetch profiles",
    wiseKeyHint:
      "Wise requires a signature (SCA) to deliver the statement. Copy the key below and register it on the Wise website: Settings → API tokens → Manage public keys → Add. Then click Test.",
    wiseKeyReused:
      "The previous key was kept: if it is already registered in Wise, no need to register it again.",
    wiseLastSyncPre: "last sync",
    wiseLinkBtn: "Link this account",
    wiseLinked: "linked",
    wiseLinkedTo: "Account linked to profile",
    wiseModalTitle: "Link to Wise",
    wiseNeverSynced: "never synced",
    wiseNewTokenBtn: "Change the token",
    wiseNoKey: "no SCA key",
    wiseNoProfiles: "This token gives access to no profile.",
    wiseNotLinked: "not linked",
    wiseReconfigureBtn: "Reconfigure",
    wiseStep1: "1 · Paste the Wise API token",
    wiseStep2: "2 · Choose the profile (the company)",
    wiseStep3: "3 · Register the public key in Wise",
    wiseSyncDonePre: "Synced:",
    wiseSyncDupSuf: "already present",
    wiseSyncNewSuf: "new",
    wiseSyncNowBtn: "Sync now",
    wiseTestBtn: "Test",
    wiseTestCountSuf: "transaction(s) in the last 7 days",
    wiseTestOkPre: "Connection OK:",
    wiseTestSca: "SCA signature accepted",
    wiseTokenHint:
      "Create the token on the Wise website (not the app): Settings → API tokens → Add. Permission: read only. Wise shows the token only once: paste it here right away. It is encrypted in Gestion and never shown again.",
    wiseTokenLabel: "API token",
  },
  bankCategories: {
    appliedEligibleSuf: "eligible",
    appliedNoMatchSuf: "no match",
    appliedPre: "Applied",
    appliedRulesSuf: "rules",
    appliedUnchangedSuf: "unchanged",
    appliedUpdatedSuf: "updated",
    applyAllBtn: "↻ Apply all",
    applyAllConfirmMessage:
      "Processes all eligible transactions with the active rules. Transactions already categorized as 'manual' are preserved.",
    applyAllConfirmTitle: "Apply all active rules?",
    applyAllLabel: "Apply all",
    applyingBtn: "Applying…",
    cancelBtn: "Cancel",
    categoryBankFee: "Bank fees",
    categoryInsurance: "Insurance",
    categoryIntermediaryFees: "Fees / intermediaries",
    categoryOther: "Other",
    categoryPartnerContribution: "Contribution (partner)",
    categoryPartnerReimbursement: "Reimbursement (partner)",
    categoryPersonal: "Personal (partner)",
    categoryRent: "Rent / leasing",
    categoryRevenue: "Revenue",
    categorySalary: "Salary",
    categorySupplierPayment: "Supplier",
    categorySupplies: "Materials / supplies",
    categoryTax: "Tax",
    categoryTransfer: "Transfer",
    categoryTravel: "Travel / reception",
    categoryVatPayment: "TVA to the State (payout)",
    colActions: "Actions",
    colActive: "Active",
    colCategory: "Category",
    colField: "Field",
    colPriority: "Pri",
    colType: "Type",
    colValue: "Value",
    createBtn: "Create",
    deactivateBtn: "deactivate",
    deactivateLabel: "Deactivate",
    deactivateReasonPlaceholder: "E.g.: obsolete rule",
    deactivateRuleMessage:
      "The rule will no longer be applied in new automatic categorizations (already categorized transactions keep their state).",
    deactivateRulePre: "Deactivate rule",
    editBtn: "edit",
    emptyState: "No rules registered.",
    errorTitle: "Error",
    filterActive: "Active",
    filterAll: "All",
    filterInactive: "Inactive",
    labelAmountMax: "Amount max",
    labelAmountMin: "Amount min",
    labelCategoryResult: "Category (result)",
    labelMatchField: "Match field",
    labelMatchType: "Match type",
    labelMatchValue: "Match value",
    labelNotes: "Notes",
    labelPriority: "Priority",
    loading: "Loading…",
    matchFieldAmount: "amount (numeric)",
    matchFieldBoth: "both (description + raw)",
    matchFieldDescription: "description (normalized)",
    matchFieldRawDescription: "raw_description (original)",
    modalCreateTitle: "New categorization rule",
    modalEditTitle: "Edit rule",
    name: "Name",
    newRuleBtn: "+ New rule",
    noCompanyAccess: "No access to companies.",
    placeholderContainsExample: "E.g.: COMMISSION",
    placeholderRegexExample: "E.g.: (CLIENT|RENAULT|RÈGLEMENT)",
    rulesCountSuf: "rule(s)",
    rulesOrderHint: "Sorted by priority DESC. The first matching rule wins.",
    saveBtn: "Save",
    savingBtn: "Saving…",
    subtitle: "Automatic categorization rules",
    subtitleCategories: "Categories",
    testEligibleSuf: "eligible transactions.",
    testMatchPre: "Match on",
    testRuleBtn: "↻ Test rule",
    testRunsTitle: "Tests against all eligible transactions",
    testSampleNone: "(none)",
    testSamplePre: "Sample",
    testSaveFirstError:
      "Save the rule first — the test runs against a rule already saved in the database.",
    testSaveFirstTitle: "Save the rule first to be able to test it",
    testingBtn: "Testing…",
  },
  bankImport: {
    accountConfiguredPre: "Account",
    accountConfiguredSuf: "configured — encrypted credentials",
    accountProvider: "Account provider",
    chooseAccountFirst:
      "First choose the statement's account in the selector above. Gestion does not choose it for you.",
    closeBtn: "Close",
    colAccount: "Account",
    colDate: "Date",
    colDuplicated: "Dupl.",
    colFailed: "Failed",
    colFile: "File",
    colImported: "Imported",
    colMethod: "Method",
    colStatus: "Status",
    colTotal: "Total",
    duplicatedWord: "duplicates",
    emptyBatches: "No imports yet.",
    emptyFile: "Empty file.",
    failedWord: "failed",
    fileReadError: "Failed to read the file.",
    genericUploadHint:
      "Upload a CSV (e.g. Wise statement). Automatically detects the separator, the columns (Date, Value/Amount or Debit/Credit, Description) and the number/date format.",
    idempotentNote:
      "Idempotent parser — re-importing the same file does not duplicate transactions.",
    importAnywayBtn: "Import anyway",
    importCsv: "Import CSV",
    importCsvOrPdf: "Import statement (CSV or PDF)",
    importHistory: "Import history",
    importOk: "Import successful",
    importStatements: "Import statements",
    importSubtitle: "Import",
    importedWord: "imported",
    noCompanyAccess: "No access to companies.",
    previewAlready: "Already in this account",
    previewAlreadySuf: "(counted as duplicates, not duplicated)",
    previewBalance: "File's closing balance",
    previewBank: "File's bank",
    previewBankUnknown: "not recognized",
    previewCancel: "Cancel",
    previewFile: "File",
    previewGoesTo: "Goes to the account",
    previewImportAnyway: "Import anyway into account",
    previewImportTo: "Import into account",
    previewMovements: "Transactions",
    previewOtherHint: "The file seems to belong there: check the chosen account.",
    previewOtherMid: "of the",
    previewOtherSuf: "transactions are already in the account",
    previewTitle: "Check before importing",
    processing: "Processing…",
    readOnlyNotice: "Read-only — import is available only to users with edit permission.",
    selectAccount: "— Choose the account —",
    selectAccountAbove: "Select an account above",
    sgUploadHint:
      'CSV exported from Société Générale or the monthly statement PDF (the "RELEVÉ DE COMPTE"). The same transaction coming from the CSV and the PDF is not duplicated.',
    showEmptyFailed: "Show empty robot attempts",
    statusCompleted: "Completed",
    statusFailed: "Failed",
    statusPending: "Pending",
    statusProcessing: "Processing",
    statusUndone: "Undone",
    syncWiseBtn: "Sync Wise",
    syncWiseOk: "Wise sync successful",
    syncing: "Syncing…",
    totalWord: "total",
    undoAlready: "This import has already been undone.",
    undoBlockAttachment: "with attachment",
    undoBlockClosedYear: "in a closed fiscal year",
    undoBlockLinked: "linked to a receipt, payment or other record",
    undoBlockReconciled: "reconciled — undo the reconciliation first",
    undoBlockedTitle: "Cannot undo: some transactions have already been used.",
    undoBtn: "Undo",
    undoConfirmBtn: "Undo import",
    undoExplain:
      'The transactions recorded by this import will be deleted. The import stays in the history as "Undone", with the reason, and is audited. Then upload the file to the right account.',
    undoMovements: "transaction(s)",
    undoReasonLabel: "Reason (required)",
    undoReasonPlaceholder: "E.g.: Wise statement uploaded to the Wamo account",
    undoTitle: "Undo import",
    wiseOnlyHint: "Available only for accounts with provider='wise'",
    wiseSyncTitle: "Wise API sync",
    wrongAccountHint: 'If the file really belongs to this account, click "Import anyway".',
    wrongAccountTitle: "Right account?",
  },
  bankPartner: {
    accountCardSubtitle: "Current balance derived from transactions + opening",
    accountCardTitle: "Partner current account",
    allMovementsCounted: "All categorized movements are counted.",
    balanceZero: "Balance is zero.",
    calcMovements: "movements",
    calcOpeningPre: "Calculation: opening",
    cancel: "Cancel",
    cancelBtnLower: "cancel",
    companyLabel: "Company",
    companyOwesPartner: "The company owes this amount to the partner.",
    contributions: "Contributions",
    currentBalance: "Current balance",
    editBtn: "edit",
    emptyOpenings:
      "No opening registered. The balance above assumes opening = 0 and sums the categorized movements.",
    error: "Error",
    loading: "Loading…",
    missingDataTitle: "Missing data",
    missingPartnerName: "Please enter the partner's name.",
    movementsFromPre: "Movements counted from",
    movementsFromSuf: "(after the opening date).",
    movementsSourceNote:
      "Movements come from transactions marked as Contribution, Reimbursement or Personal on the Statements page.",
    multiPartnerWarning:
      "More than one partner is registered — movements are at company level and are not split per partner.",
    nameLabel: "Name",
    newPartnerBtn: "+ New partner",
    noCompanyAccess: "You do not have access to any company.",
    opening: "Opening",
    openingBalanceLabel: "Opening balance (€)",
    openingDateLabel: "Opening date",
    openingEuroLabel: "Opening (€)",
    openingsCardTitle: "Openings per partner",
    partnerNameLabel: "Partner name",
    partnerNamePlaceholder: "E.g.: Landione Souza",
    partnerOwesCompany: "The partner owes this amount to the company.",
    personalExpenses: "Personal expenses",
    reimbursements: "Reimbursements",
    remove: "Remove",
    removeBtn: "remove",
    removeConfirmPre: "Remove the opening of",
    removeConfirmSuf: "Transactions are not affected.",
    removePartnerTitle: "Remove partner",
    save: "Save",
    saveBtnLower: "save",
    saving: "Saving…",
    subtitle: "Partner",
  },
  bankReconciliation: {
    acceptBtn: "accept",
    acceptCreatesReceiptTitle:
      "Accepting creates the receipt (source=bank_reconciliation) and marks the invoice/dossier as paid",
    colActions: "Actions",
    colAmount: "Amount",
    colBankTransaction: "Bank transaction",
    colConfidence: "Confidence",
    colReason: "Reason",
    colStatus: "Status",
    colSuggestion: "Suggestion",
    colTargetId: "Target ID",
    emptyState:
      'No suggestions with these filters. Click "↻ Generate suggestions" to run the engine.',
    error: "Error",
    filterCompany: "Company",
    filterStatus: "Status",
    generateBtn: "Generate suggestions",
    generating: "Generating…",
    highConfidence: "high confidence",
    kindCustomerInvoice: "Open invoice → creates receipt",
    kindCustomerReceipt: "Customer receipt",
    kindIntercompany: "Intercompany",
    kindOther: "Other",
    kindTaxPayment: "Tax payment",
    kindTechnicianPayment: "Technician payment",
    loading: "Loading…",
    minConfidenceLabel: "Minimum confidence",
    nextBtn: "Next",
    noCompanyAccess: "No access to companies.",
    pageLabel: "Page",
    pageOf: "of",
    prevBtn: "Previous",
    reconciliationSubtitle: "Reconciliation",
    rejectBtn: "reject",
    rejectConfirm: "Reject",
    rejectMessage:
      "The suggestion will be blocked — the engine will not generate a new suggestion for this transaction until an admin unrejects it.",
    rejectPlaceholder: "E.g. wrong target, amount does not match",
    rejectTitle: "Reject suggestion",
    scanBlockedAccepted: "blocked (accepted)",
    scanBlockedRejected: "blocked (rejected)",
    scanCreated: "created",
    scanLabel: "Scan",
    scanNoCandidate: "no candidate",
    scanTx: "tx",
    scanUpdated: "updated",
    statusAccepted: "Accepted",
    statusAll: "All",
    statusPending: "Pending",
    statusRejected: "Rejected",
    suggestionsCount: "suggestion(s)",
    suggestionsSubtitle: "Reconciliation suggestions",
    unrejectBtn: "unreject",
    unrejectConfirm: "Unreject",
    unrejectMessage:
      "Admin only. Status returns to 'pending' — the engine can regenerate suggestions for this tx.",
    unrejectPlaceholder: "E.g. review completed, correct target identified",
    unrejectTitle: "Reopen suggestion (unreject)",
  },
  bankShell: {
    moduleLabel: "Bank module",
    navCategories: "Categories",
    navImport: "Import",
    navPartner: "Partner",
    navReconciliation: "Reconciliation",
    navStatements: "Statements",
  },
  bankStatements: {
    accountantLinkNote: "This is the document the accountant's statement links on this line.",
    additionalDetailsPlaceholder: "Additional details",
    advAddRow: "another technician",
    advDescHint: "Description (optional; default = statement text)",
    advFillAll: "full amount",
    advNoRows: "Enter at least one technician with an amount.",
    advPickTech: "Technician…",
    advRemoveRow: "Remove",
    advRestNotAdvance: "remainder not an advance:",
    advSumExceeds: "the sum exceeds the debit amount",
    advSummaryTag: "advance to a technician",
    advToggle: "It is an advance to a technician",
    advToggleHint:
      "Hotel, tools, etc. paid by the company for one or more technicians: each share becomes an advance, deducted from their next invoice.",
    allAccounts: "All accounts",
    allCategories: "All categories",
    allCredits: "➕ Credits (all)",
    allCustomers: "All customers",
    allDebits: "➖ Debits (all)",
    allStatuses: "All statuses",
    alreadyReceivedPre: "already received",
    amountHtPlaceholder: "Amount HT",
    attachBtnTitle: "Attach / view supporting documents (transaction and invoices of the entry)",
    attachEdspPdfs: "Attach eDSP invoice PDFs (matched by number)",
    attachFiles: "Attach file(s)",
    attachHelp:
      "Attach the supporting document (PDF, image) for any reconciliation — invoice, receipt, tax notice, proof of payment. It becomes the clickable link for this line in the statement PDF sent to the accountant.",
    attachInvoicePdf: "Attach invoice PDF",
    attachMonthBtn: "Attach the month's invoices",
    attachMonthBtnTitle: "Bulk attach PDFs of invoices issued in the period (matched by number)",
    attachOriginalLabel: "Attach the original bank statement (PDF and/or CSV)",
    attachOriginalMessage:
      "You have not attached the original bank statement (PDF/CSV). It must accompany the reconciled statement. Send anyway?",
    attachOriginalTitle: "Attach the original statement?",
    attachPdfsFolder: "Attach PDFs (select the folder or several files)",
    autoRecognizeBtn: "Recognize pending",
    autoRecognizeDoneMid: "of",
    autoRecognizeDoneSuf:
      "pending auto-categorized ('auto' confidence — reviewable via each row's selector).",
    autoRecognizeTitle:
      "Auto-categorizes uncategorized transactions: reconciliation link, registered entities (client/supplier/partner/group) and patterns already used ≥3× always with the same category. Never overrides manual categorization; everything stays editable.",
    autoRecognizing: "Recognizing…",
    avoirNumberMissing: "Could not suggest the credit note number. Try again.",
    avoirOption: "The difference is a credit note",
    avoirOptionHint: "creates the credit note on this invoice and marks it paid:",
    avoirReasonDefault: "Credit note deducted by the customer on the transfer of",
    avoirReasonLabel: "Credit note reason",
    avoirTypeLabel: "Credit note type",
    avoirWord: "credit note",
    backBtn: "Back",
    badgeIgnored: "ignored",
    badgePending: "pending",
    badgeReconciled: "Reconciled",
    bankTransaction: "Bank transaction",
    cancel: "Cancel",
    cannotBeUndone: "This action cannot be undone.",
    catBankFee: "Bank charges",
    catBankFeeShort: "Bank fee",
    catFees: "Professional fees",
    catInsurance: "Insurance",
    catOther: "Other",
    catPartnerContribution: "Contribution (partner)",
    catPartnerReimbursement: "Reimbursement (partner)",
    catPendingChip: "To categorize",
    catPersonal: "Personal (partner)",
    catRent: "Rent / lease",
    catRevenue: "Revenue",
    catSalary: "Salary",
    catSupplier: "Supplier",
    catSupplies: "Supplies",
    catTax: "Tax",
    catTransfer: "Transfer",
    catTravel: "Travel",
    catVatPayment: "TVA to the State",
    categorizeBtn: "categorize",
    categorizeHelpPre: "Click a category to apply it. The choice becomes",
    categorizeHelpSuf: "— blocking future automatic re-categorization by the rules.",
    categorizeTitle: "Categorize transaction",
    changePdf: "Change PDF",
    chooseIndividualFiles: "or choose individual files",
    clearCategory: "Clear category",
    clearSelection: "Clear",
    clickToChooseOr: "Click to choose (multiple: Ctrl+A) or",
    close: "Close",
    colAccount: "Account",
    colActions: "Actions",
    colAmount: "Amount",
    colCategory: "Category",
    colDate: "Date",
    colDescription: "Description",
    colEffectiveDate: "Effective date",
    colStatus: "Status",
    colTarget: "Target",
    confirm: "Confirm",
    confirming: "Confirming…",
    continueBtn: "Continue",
    current: "current",
    currentCategoryLabel: "Current category",
    depositHigherMsg:
      "If the deposit pays several invoices, use «Plusieurs factures / encaissements». Linking here marks only this invoice paid.",
    depositHigherTitle: "The deposit is higher than the invoice",
    depositLabel: "Deposit",
    depositLowerMsg:
      "Partial payment: records what arrived and the invoice stays open for the rest. Other options: mark it paid anyway.",
    depositLowerTitle: "The deposit is lower than the invoice",
    descriptionLabel: "Description",
    diffWord: "difference",
    directBankFee: "Bank fee",
    directBankFeeHint: "Commission, fee, annual charge",
    directCategoryLabel: "Category",
    directComplementHint: "Invoice number, name… printed as written, not translated.",
    directComplementLabel: "Complement / reference",
    directComplementRequired: 'Describe the reason in the complement (required for "Other").',
    directConfirmQuestion: "no document linked — mark as reconciled directly?",
    directDescriptionPlaceholder: "Describe the reason for the direct reconciliation",
    directNote:
      "The transaction is recorded with the category and description below in the audit log. It does not update any accounting entity (invoices, payments).",
    directOther: "Other",
    directOtherHint: "Describe the reason (required)",
    directPartnerReimbursement: "Partner reimbursement",
    directPartnerReimbursementHint: "Advance, reimbursement of personal expense",
    directPriorYear: "2025 settlement",
    directPriorYearHint:
      "Settles a prior-year debt (commission / supplier / TVA 2025) — no impact on the 2026 P&L",
    directReasonHint:
      "The reason is printed translated in the accountant's statement, in the chosen language.",
    directReasonLabel: "Reason",
    directReasonNone: "— no reason —",
    directReasonOthers: "Other reasons",
    directReasonRequiredOther: 'Choose a reason for the "Other" category.',
    directReasonSuggested: "Suggested for this category",
    directSalaryPersonal: "Salary / Personal",
    directSalaryPersonalHint: "Payroll, social charges",
    directSectionTitle: "Or categorize directly (no document) — same list as the categories",
    directSupplierPurchaseHint:
      "Tool, service, product or material paid on the spot (card/debit) — 2026 operating charge",
    directTax: "Tax / DGFiP",
    directTaxHint:
      "TVA, IS, CFE and other taxes paid to the DGFiP (current year). Use '2025 settlement' for a prior-year debt.",
    docKindTitle: "Which kind of document?",
    docPickTitle: "Pick the document",
    docRegisterNew: "Not in the list? Register the supplier invoice",
    downloadCsv: "Download CSV",
    downloadPdf: "Download PDF",
    downloadSection: "Download",
    dragFilesHere: "drag the files here",
    emailNote:
      "The email carries the reconciled statement from Gestion (PDF + CSV) plus the attached original statement. The accountant's email is saved for next time.",
    emailPlaceholder: "email@accountant.fr",
    emailSection: "Send to the accountant by email",
    emptyState: "No transactions found with these filters.",
    errorTitle: "Error",
    existingReceiptsTitle: "Existing receipts (not linked)",
    expandHint: "Click to see the full bank label",
    exportBtnTitle: "Export the period statement (PDF + CSV) and send it to the accountant",
    exportModalTitle: "Statement for the accountant",
    failed: "failed",
    filterAccount: "Account",
    filterByMonthTitle: "Filter by month/year",
    filterCategory: "Category",
    filterCompany: "Company",
    filterInvoicesByCustomerTitle: "Filter invoices by customer",
    filterMonth: "Month",
    filterPeriod: "Period",
    filterSearch: "Search",
    filterStatus: "Status",
    fullOptionHint: "the difference is no longer claimed",
    fullPaymentBtn: "Paid in full",
    fullPaymentMsg:
      "The difference will no longer be claimed. If the customer will still pay the rest, go back and choose partial payment.",
    fullPaymentTitle: "Mark the invoice paid anyway?",
    generatePdfCsv: "Generate PDF + CSV",
    generating: "Generating…",
    higherNote:
      "The deposit is higher than the invoice. If it pays several invoices, go back and tick “This deposit pays several invoices”.",
    hintBankFee: "Commission, bank charges",
    hintFees: "Accountant, lawyer, consultants, intermediaries",
    hintInsurance: "Insurance premiums (liability, vehicles, multi-risk…)",
    hintOther: "Does not fit the categories above",
    hintPartnerContribution:
      "Your loan/contribution TO the company (inflow) — increases what it owes you",
    hintPartnerReimbursement:
      "Reimbursement from the company TO you (outflow) — settles part of what it owes you",
    hintPersonal:
      "Your personal spending on the company card (deducted from your reimbursement/profit)",
    hintRent: "Rent, leasing, rental charges",
    hintRevenue: "Customer receipt, invoicing",
    hintSalary: "Payroll, social charges",
    hintSupplier: "Payment to a supplier",
    hintSupplies: "Supplies and consumables (not stocked)",
    hintTax: "IS, TVA, taxes",
    hintTransfer: "Transfer between own accounts",
    hintTravel: "Travel, fuel, tolls, hotel, entertainment",
    hintVatPayment: "TVA payment to the State — NOT an expense (cross-check with the TVA module)",
    ignoreBtn: "ignore",
    ignoreConfirm: "Ignore",
    ignoreMessage:
      "Use for internal charges, transfers between own accounts, etc. Reason required.",
    ignorePlaceholder: "E.g. virement entre comptes",
    ignoreTitle: "Ignore transaction",
    invalidAmountMessage: "Check the HT amount and TVA (%).",
    invalidAmountTitle: "Invalid amount",
    invalidEmailMessage: "Enter the accountant's email.",
    invalidEmailTitle: "Invalid email",
    invoiceCreatedPdfFailed: "Invoice created, but attaching the PDF failed.",
    invoiceDocWord: "invoice",
    invoiceFromPlaceholder: "Invoice from (e.g. F2026-00300)",
    invoiceNumberPlaceholder: "Invoice no.",
    invoiceToPlaceholder: "to (e.g. F2026-00334)",
    invoiceWord: "invoice",
    invoicesOfEntry: "Invoices of this entry",
    invoicesUnit: "invoice(s)",
    langEn: "English",
    langFr: "French (FR accountant)",
    langPt: "Portuguese",
    languageLabel: "Statement language",
    lblCb: "Card (CB)",
    lblFrais: "Bank fee",
    lblPrlv: "Direct debit",
    lblVirEmis: "Transfer sent",
    lblVirRecu: "Transfer received",
    linkBtn: "link",
    linkCustomerReceipt: "Customer receipt",
    linkProforma: "Proforma (payment)",
    linkPurchaseInvoice: "Supplier / Purchase",
    linkSectionTitle: "Link to an existing document",
    linkTaxPayment: "Tax payment",
    linkTechnicianPayment: "Technician payment",
    linkedInvoicesAlertTitle: "Invoices of the entry",
    loading: "Loading…",
    manualWord: "manual",
    matchByAmount: "exact amount",
    matchByFilenameHint: "Matched by the file number (e.g. F2025-00006.pdf) · max. 25 MB each",
    matchByNumber: "number in the transfer",
    matchSurplus: "matches the leftover",
    maxSizeEach: "max. 25 MB each",
    missingDataMessage: "Select the supplier and enter the invoice number.",
    missingDataTitle: "Missing data",
    monthAttachAlertTitle: "Attachments for the month's invoices",
    monthInvoicesHelp:
      "Attach the PDFs (from eDSP) — each file is matched to the invoice with the same number and becomes a link in the accountant's statement.",
    monthInvoicesTitle: "Invoices issued in the period",
    moreActions: "More actions",
    multiBtn: "Several invoices / receipts",
    multiHelp:
      "Tick OPEN invoices (they will be paid: creates a receipt + marks as paid) and/or ALREADY EXISTING receipts (link only). The amounts shown are the INVOICED amount incl. tax (what the customer pays — the deposit base); the receipt stored internally is HT (net). The total should be close to the deposit.",
    multiSectionTitle: "Or reconcile SEVERAL customer invoices (one deposit pays many invoices)",
    multiShortfall:
      "The total of the ticked invoices exceeds the deposit: everything cannot be marked paid. Untick some or, for a partial payment, keep a single invoice.",
    newPurchaseHelp:
      "No pending purchase invoice? Register one here (PDF optional) and reconcile the payment in one go. Pre-filled HT = |deposit| ÷ 1.20.",
    next: "Next",
    nextMonth: "Next month",
    noAttachments: "No supporting document attached yet.",
    noCandidates: "No pending candidate in this category.",
    noCompanyAccess: "You do not have access to any company.",
    noInvoicesInPeriod: "No invoice issued in this period.",
    noMatchingInvoiceInEntry: "with no matching invoice in this entry",
    noMatchingInvoiceInPeriod: "with no matching invoice in the period",
    noOpenInvoices: "No open invoice in the filter.",
    noPdf: "no PDF",
    noPendingReceipts: "No receipt awaiting linking in the filter.",
    noteLabel: "Note",
    ofLabel: "of",
    open: "open",
    openInvoicePdfTitle: "Open / download the invoice PDF",
    openInvoiceWord: "Open invoice",
    openInvoicesTitle: "Open invoices",
    openPdf: "open PDF",
    openProformaInvoicePdfTitle: "Open / download the invoice PDF attached to the proforma",
    openPurchasePdfTitle: "Open / download the purchase invoice PDF",
    optionalSuffix: "(optional)",
    otherOptionsBtn: "Other options",
    pageLabel: "Page",
    partialOptionHint: "records what arrived; the invoice stays open for the rest",
    partialPaymentBtn: "Partial payment",
    pdfOptional: "PDF optional",
    pdfsAttached: "PDF(s) attached.",
    pdfsAttachedToInvoices: "PDF(s) attached to the invoice(s).",
    periodLabel: "Period",
    piAchatsConsommes: "Consumed purchases",
    piAssurances: "Insurance",
    piAutresCharges: "Other operating charges",
    piChargesPersonnel: "Personnel costs",
    piDeplacements: "Travel / entertainment",
    piFournitures: "Supplies / consumables",
    piFraisBancaires: "Bank charges",
    piHonoraires: "Fees / intermediaries",
    piImpots: "Taxes / duties",
    piLocations: "Rent / charges",
    pickOneToContinue: "Pick one item to continue.",
    prev: "Previous",
    prevMonth: "Previous month",
    proformaAlreadyPaid:
      "Already marked paid — linking only records the payment on the statement (nothing is redone).",
    proformaDocReconciled: "Proforma reconciled — invoice received",
    proformaNeedsApproval:
      "Proforma only sent — approve it and record the received invoice before reconciling.",
    proformaNeedsInvoice:
      "The received invoice is not recorded on the proforma yet — do it before reconciling.",
    proformaNoInvoicePdf: "no invoice PDF — attach it to the proforma",
    proformaWillBePaid: "Linking marks the proforma paid and its cars paid to the technician.",
    purchaseInvoiceReconciled: "Purchase invoice reconciled",
    purchaseWord: "Purchase",
    readFileError: "The attached file could not be read.",
    reasonRecorded: "Reason recorded:",
    receiptFilterNumber: "invoice no…",
    receiptMultiToggle: "This deposit pays several invoices",
    receiptPickHint: "Tick one or several; the total shows above.",
    receiptPickTitle: "Which invoices does this deposit pay?",
    receiptWord: "Receipt",
    reconcileBtn: "Reconcile",
    reconcileTitle: "Reconcile the transaction",
    reconcileVerb: "Reconcile",
    reconciling: "Reconciling…",
    registerAndReconcile: "Register invoice + reconcile",
    registering: "Registering…",
    remainingWord: "remaining",
    removeBtn: "delete",
    removeConfirm: "Delete",
    removeFileTitle: "Delete file",
    removeQuestionPre: "Delete",
    removeReceiptTitle: "Delete supporting document",
    removeTitle: "Delete",
    searchPlaceholder: "Description…",
    selectAllInvoices: "Select all",
    selectAllReceipts: "Select all",
    selectPdfsMid: "PDFs (e.g.",
    selectPdfsPre: "Select the",
    selectPdfsSuf: ".pdf) — each file is attached to its invoice.",
    selectPeriodFirst: "Select a month (or a date range) in the bar before exporting.",
    selectVisible: "Tick the visible ones",
    selectedCount: "selected",
    send: "Send",
    sendAnyway: "Send anyway",
    sendFailed: "Sending failed",
    sendToAccountantBtn: "Send to the accountant",
    sending: "Sending",
    sendingEllipsis: "Sending…",
    sentTitle: "Sent",
    sheetCloseLabel: "Close the panel",
    sortNewest: "Newest first",
    sortOldest: "Oldest first",
    sortToggleTitle: "Reverse the list order",
    statementBalancePre: "statement balance on",
    statementBalanceTitle:
      "Balance stated by the imported file, at the statement date. Not computed by Gestion.",
    statementSentTo: "Statement sent to",
    statusIgnored: "Ignored",
    statusPending: "Pending",
    statusReconciled: "Reconciled",
    stepConfirm: "Confirm",
    stepDetails: "Details",
    stepWhat: "What is it?",
    subtitle: "Bank statements",
    subtitleShort: "Statements",
    sugAcceptMsgPre: "Reconcile this transaction based on:",
    sugAcceptMsgSuf:
      "This creates the receipt and marks the invoice paid (same effect as manual reconciliation).",
    sugAcceptTitle: "Accept reconciliation suggestion",
    sugApplied: "Suggestion applied",
    sugBadge: "Gestion's suggestion",
    sugEntityPre: "recognized from records:",
    sugHistoryPre: "already used",
    sugInvoicesCited: "invoices cited in the transfer",
    sugMaybe: "Maybe?",
    sugReconcilePre: "Reconcile:",
    sugSimilarMany: "similar transactions",
    sugSimilarManySuf: "were marked as",
    sugSimilarOne: "similar transaction",
    sugSimilarOneSuf: "was marked as",
    sugUseSame: "Use the same",
    sumAvoirMid: "becomes credit note",
    sumAvoirPre: "the difference of",
    sumAvoirSuf: "and the invoice is marked paid.",
    sumDepositWord: "Deposit of",
    sumDirectNote:
      "appears on the accountant's statement in the chosen language · category editable later",
    sumDocPaid: "The document is marked paid and linked to the statement.",
    sumInvoiceFullAnyway: "which is marked paid anyway (the difference is no longer claimed).",
    sumInvoicePaid: "which is marked paid.",
    sumInvoicePartial: "in part —",
    sumLinksReceipt: "is linked to receipt",
    sumMatches: "matches the deposit",
    sumMultiMid: "linked to",
    sumMultiPaidSuf: "which are marked paid.",
    sumMultiSuf: "invoice(s) / receipt(s), marked paid.",
    sumNoReason: "no reason",
    sumOutflowWord: "Outflow of",
    sumOverPre: "the total exceeds the deposit by",
    sumPartialHint: "partial payment possible at the next step",
    sumPaysDoc: "pays",
    sumPaysInvoice: "pays invoice",
    sumPaysInvoices: "pays invoices",
    sumSurplusPre: "left on the deposit:",
    summaryPre: "It will be:",
    supplierPlaceholderOption: "— Supplier —",
    tlMonthIn: "Inflows",
    tlMonthOut: "Outflows",
    toDate: "to",
    txAttachmentsTitle: "Transaction supporting documents",
    txCountMany: "transactions",
    txCountOne: "transaction",
    typeDirect: "No document",
    typeDirectHint: "Card purchase, fee, transfer. Category + standard reason + note.",
    typeDocument: "Payment of a document",
    typeDocumentHint:
      "Supplier invoice, proforma, technician payment, tax. You pick the document from the list.",
    typeReceipt: "Customer payment",
    typeReceiptHint:
      "Pays one or several invoices. Gestion suggests the open invoices with this amount.",
    undoBtn: "undo",
    undoConfirm: "Undo",
    unignoreMessage: "The transaction goes back to pending and can be reconciled again.",
    unignoreTitle: "Undo ignore",
    unreconcileBtn: "undo reconciliation",
    unreconcileMessage:
      "The transaction goes back to pending and the linked document becomes available for a new reconciliation.",
    unreconcilePlaceholder: "E.g. I linked the wrong invoice",
    unreconcileTitle: "Undo reconciliation",
    untriagedFilterBtn: "View and handle",
    untriagedHint: "They do NOT count as fiscal receipts until handled.",
    untriagedManySuf: "inflows without category or reconciliation in the period",
    untriagedOneSuf: "inflow without category or reconciliation in the period",
    uploadFailed: "Failed to upload the file.",
    withPdf: "with PDF",
  },
  breakevenChart: {
    ariaLabel: "Break-even chart",
  },
  bulkActionBar: {
    clear: "Clear",
    clearSelectionTitle: "Clear selection",
    selectedMany: "selected",
    selectedOne: "selected",
    selectionLabel: "Selection",
  },
  chantier: {
    agendaAddBtn: "+ Book",
    agendaArrivedBtn: "Arrived",
    agendaCancelBtn: "Cancel",
    agendaDoneBtn: "Done",
    agendaEmpty: "Nothing scheduled in the coming days.",
    agendaSaveBtn: "Save booking",
    agendaTitle: "Site agenda",
    attachChantierAutoPre: "When you save the reception, the customer",
    attachChantierAutoSuf: "joins the site",
    attachChantierHint:
      "Once the customer is attached to the site, technicians with a site pair can see this car in their portal.",
    attachChantierMid: "is not attached to any site yet. Add to site",
    attachChantierNo: "No",
    attachChantierPre: "Customer",
    attachChantierYes: "Yes, add",
    carRepairedHint: "All services on this car are complete.",
    carRepairedTitle: "Vehicle already repaired",
    carsEmpty: "No cars on this site yet (link customers to the site in their record).",
    carsTitle: "Site cars",
    claimRefLabel: "Claim number",
    damagePlaceholder: "E.g.: left mirror cracked",
    damagesLabel: "Pre-existing damage / broken parts",
    deliveryAlarmHint:
      "Repaired cars with no delivery recorded. Tap the plate and record the delivery and the check: only then is the car invoiced and counted in your commission.",
    deliveryAlarmInvoiced: "already invoiced",
    deliveryAlarmTitle: "Pending deliveries",
    deliveryPhotosMissingPre: "Missing",
    deliveryPhotosMissingSuf: "delivery photo(s) — photograph the car before delivering it.",
    deliveryPhotosTitle: "Delivery photos",
    deliveryTitle: "Delivery and control",
    deposeReposeLabel: "Remove/Refit",
    devisPareBrise: "Windshield",
    devisPieces: "Parts",
    devisTitle: "Quote",
    docCarteGrise: "Registration card",
    docCnh: "Driver's license",
    docExpertise: "Expert report",
    docReplaceBtn: "Replace",
    docSentBadge: "sent",
    docUploadFail: "Could not read the file — try again.",
    docUploading: "Uploading document…",
    docsTitle: "Reception documents",
    doneBadge: "done",
    expAlarmTitle: "Car to finalise",
    expAmountLabel: "Expertise report amount (excl. VAT)",
    expConfirmBtn: "Confirm check",
    expDevisLabel: "Amount to invoice (quote)",
    expDiffBadge: "with difference",
    expDiffOver: "above the amount to invoice.",
    expDiffPre: "Difference of",
    expDiffUnder: "below the amount to invoice.",
    expHint:
      "Check the expertise report amount against the amount to invoice before finalising the car.",
    expInvoiceLabel: "Invoice",
    expMatch: "The amounts match.",
    expNeedDoc: "Attach the expertise report below before confirming.",
    expNotePh: "Explain the difference to the office",
    expSaving: "Saving…",
    expTitle: "Expertise report checked",
    expertEmailLabel: "Expert e-mail",
    expertNameLabel: "Expert firm",
    finalizeAlarmHint:
      "Expertise report still to check against the amount to invoice. Search the plate to finish.",
    finalizeAlarmTitle: "Cars to finalise",
    finalizeNoDoc: "no report",
    franchiseAmountPh: "Deductible amount (€)",
    franchiseChangeBtn: "Change",
    franchiseFirstHint: "Answer the deductible question to unlock the photos and signature.",
    franchiseLabel: "Deductible",
    franchiseNo: "No",
    franchiseNone: "no deductible",
    franchiseQ: "Does the car have a deductible discount for the customer?",
    franchiseRequiredBadge: "required",
    franchiseStep: "1 · Deductible — required",
    franchiseToggle: "The car gets a deductible discount",
    franchiseYes: "Yes",
    hidePhotosBtn: "Hide photos",
    impactsWord: "impacts",
    incompleteBadge: "incomplete",
    insuranceHint:
      "The invoice goes to the customer AND to these contacts. Without them payment drags on.",
    insuranceMissing: "to be filled in",
    insuranceTitle: "Insurer and expert",
    insurerEmailLabel: "Insurer e-mail",
    insurerNameLabel: "Insurer",
    invColCount: "invoices",
    invColOpen: "Outstanding",
    invColOverdue: "Overdue",
    invColReceived: "Received",
    invColTotal: "Invoiced",
    invDaysLate: "days",
    invDue: "due",
    invOverdueNone: "No overdue invoice.",
    invOverdueTitle: "Overdue invoices",
    invoicesEmpty: "No invoice issued to this site's customers.",
    invoicesHint:
      "Net amounts of the invoices issued to this site's customers. “Overdue” = past due with no payment received.",
    invoicesTitle: "Invoices of the site's customers",
    loanerPh: "Which car (plate/model)",
    loanerToggle: "Loaner vehicle provided to the client?",
    logout: "Log out",
    mileageLabel: "Mileage",
    mileagePh: "km on the dash",
    montageShort: "Assembly",
    noChantiers: "No sites created yet — the office creates them under Sites.",
    noResults: "No car with this plate in this company.",
    noTechWarning:
      "No technician has taken this car in the portal. If you record the delivery now, the car closes with no technician and the office will have to assign one in the dossier.",
    notManagerNote: "Your account has no project-manager role in any company.",
    notesPh: "Notes…",
    openGestion: "Open Gestion",
    photosDelivery: "Delivery",
    photosDemontage: "Removal",
    photosMontageEnd: "End of work",
    photosReception: "Reception",
    recMissCiel: "answer the headliner",
    recMissPareBrise: "answer the windshield",
    recMissPhoto: "photo",
    recMissPhotoCiel: "headliner photo",
    recMissPhotoPareBrise: "windshield photo",
    recMissPhotos: "photos",
    recMissSignature: "customer signature",
    recMissingPre: "Missing in the reception:",
    receptionTitle: "Vehicle reception",
    remiseCheckPre: "Client discount (record):",
    remiseCheckSuf: "— verify at reception.",
    repasseByDelivery: "A car counts in the month you register its DELIVERY in the portal.",
    repasseEmpty:
      "No delivery registered this month (or commission not yet configured by the office).",
    repasseParticular: "Individual",
    repassePro: "Business",
    repasseTitle: "My monthly payout",
    repasseTotal: "Total",
    reservesLabel: "Delivery reserves",
    saveBtn: "Save",
    saved: "✓ Checklist saved.",
    savingBtn: "Saving…",
    scanFail: "Could not read the photo — get closer, avoid glare and retry, or type it.",
    scanning: "Reading the photo…",
    searchBtn: "Search",
    searching: "Searching…",
    serviceDemontage: "Removal",
    serviceMontage: "Refit",
    servicePdrLabel: "PDR",
    servicesTitle: "Services on this car",
    showPhotosBtn: "See photos",
    statusArrived: "arrived",
    statusDone: "done",
    statusScheduled: "scheduled",
    stepBlockedHint: "The technician cannot take this car until the reception is complete.",
    stepDelivered: "car delivered.",
    stepDoDelivery: "do the delivery and work check.",
    stepInRepair: "repair under way.",
    stepNextPre: "Next step:",
    stepNotReceived: "Vehicle not received yet",
    stepReceptionIncomplete: "Reception incomplete",
    stepReleased: "Car released for repair",
    stepWaitingTechnician: "waiting for a technician to take it.",
    title: "Site",
    undeliveredPre: "car(s) already invoiced without a registered delivery —",
    undeliveredSuf:
      "of commission waiting for the registration. Register the delivery to get paid.",
    workOkNo: "Work with reserves",
    workOkToggle: "Work checked and approved",
    workOkYes: "Work approved",
  },
  chantiers: {
    commBase: "Base",
    commBaseFaturado: "Invoiced (Total Facture)",
    commBaseOrcamento: "Budget (Prix Brut)",
    commClientPct: "Client discount %",
    commHint:
      "Applies to ALL technicians × clients of this chantier (pro or individual) without a specific pair — the technician×client pair, when set, wins.",
    commIntermediary: "Intermediary",
    commIntermediaryNone: "— no intermediary —",
    commIntermediaryPct: "Intermediary %",
    commPct: "Technician %",
    commTitle: "Chantier commission (default)",
    customersWord: "customers",
    detailAgendaEmpty: "Nothing scheduled.",
    detailAgendaTitle: "Agenda (coming days)",
    detailAgendaWord: "scheduled",
    detailCarsEmpty: "No vehicles yet (they come via linked customers' quotes/invoices).",
    detailCarsTitle: "Vehicles / dossiers",
    detailCarsWord: "cars",
    detailCustomersEmpty: "No customers linked — link them in the Customers form.",
    detailCustomersTitle: "Site customers",
    detailDevisWord: "quotes to execute",
    devisChip: "quote",
    editBtn: "Edit",
    editTitle: "Edit site",
    empty: "No sites yet. Create one and link customers in the Customers form.",
    fieldActive: "Active",
    fieldAddress: "Address",
    fieldCity: "City",
    fieldEnd: "End",
    fieldName: "Name",
    fieldNotes: "Notes",
    fieldPostal: "Postal code",
    fieldStart: "Start",
    inactiveWord: "inactive",
    managerAdd: "Link",
    managerHint:
      "Commission on PDR + dégarnissage, devis HT base (after deductible), paid from the house share.",
    managerNoCandidates:
      "No user with the manager role in this company — create the account in Users first.",
    managerPartShort: "Individual",
    managerPick: "Pick a user (manager role)…",
    managerProShort: "Business",
    managerRemove: "Remove",
    managerTitle: "Site manager",
    newBtn: "New site",
    openBtn: "Open",
    saveBtn: "Save",
    subtitle: "Work sites — customers are linked to a site in their record (as in eDSP).",
    title: "Sites",
  },
  clientPortal: {
    bookBtn: "Book",
    bookTitle: "Book a vehicle",
    created: "✓ Vehicle booked.",
    dateLabel: "Day",
    logout: "Log out",
    myBookingsEmpty: "No bookings yet.",
    myBookingsTitle: "My bookings",
    notClientNote: "Your account has no client role in any company.",
    notLinkedNote: "⚠ Account not yet linked to a customer/site — contact the office.",
    occupancyEmpty: "Agenda free for the next 30 days.",
    occupancySuffix: "vehicle(s) booked that day",
    occupancyTitle: "Site occupancy (30 days)",
    plateLabel: "Plate",
    statusArrived: "arrived",
    statusDone: "done",
    statusScheduled: "scheduled",
    svcMontage: "Assembly",
    svcPeinture: "Paint",
    svcPieces: "Parts",
    timeLabel: "Time",
    title: "Agenda",
    vehicleLabel: "Vehicle (optional)",
    vehiclePh: "E.g.: grey Renault Clio",
  },
  commissionCascade: {
    rowClient: "Customer",
    rowIntermediary: "Interm.",
    rowMontage: "Assembly",
    rowTech: "Tech.",
  },
  companies: {
    addrCity: "City",
    addrCountry: "Country",
    addrPostal: "Postal code",
    addrStreet: "Address (street)",
    bankAccountsLink: "Bank accounts",
    capitalSocial: "Share capital (€)",
    codeApe: "APE code",
    dataSaved: "Data saved.",
    descEmphasis: "issuer",
    descMid:
      " that appear on the invoice (legal name, SIREN/SIRET, APE code, share capital, VAT no., address). Bank details (IBAN/BIC) are in ",
    descPre: "Fiscal data of the ",
    fiscalIdOther: "Fiscal ID (other)",
    institutionalEmail: "Institutional email",
    legalName: "Legal name",
    loading: "Loading…",
    logoAlt: "Company logo",
    logoHintPre: "Click ",
    logoHintSuf: " to apply. SVG is not supported.",
    logoLabel: "Logo on the invoice (PNG or JPEG)",
    logoUploaded: "Logo uploaded — click Save to apply.",
    noCompanies: "No accessible company.",
    noLogo: "no logo",
    pageSubtitle: "Details printed in the header and footer of your invoices.",
    removeLogo: "remove logo",
    save: "Save",
    saving: "Saving…",
    secContact: "Company contact",
    secContactDesc: "This information appears on the documents.",
    secIdentity: "Name and address",
    secLegal: "Legal details",
    secLegalDesc: "Mandatory details used on the documents.",
    siren: "SIREN (9 digits)",
    siret: "SIRET (14 digits)",
    title: "My company",
    tradeName: "Trade name",
    uploadFailed: "Upload failed",
    uploading: "Uploading…",
    vatNumber: "VAT number",
  },
  comparisonTable: {
    colAnnualized: "Annualized",
    colBudget: "Budget",
    colExercice: "Fiscal year",
    colRubrique: "Line item",
    colVarianceEur: "Variance (€)",
    colVariancePct: "Variance (%)",
  },
  creditNoteDoc: {
    cancel: "Cancel",
    emailBtn: "E-mail",
    emailTitle: "Send the credit note by e-mail",
    messageLabel: "Message (optional)",
    messagePlaceholder: "Empty = standard text with the credit note attached.",
    pdfTitle: "Download the credit note PDF",
    sendBtn: "Send",
    sentTitle: "Credit note sent",
    toLabel: "To (customer e-mail)",
  },
  customerCredit: {
    amountLabel: "Amount to apply (incl. VAT)",
    available: "available",
    balanceWord: "balance",
    cancel: "Cancel",
    cardHint:
      "Surplus from a deposit that paid more than the invoices. Applying it to an invoice creates a receipt linked to the same deposit; undoing the deposit's reconciliation undoes the credit and what was applied.",
    cardTitle: "Customer credit",
    comboCitedOut: "The transfer reference mentions",
    comboCitedOutSuf: "which is left out (probably a wrong number).",
    comboMid: "add up exactly to",
    comboPre: "💡 Exact match:",
    comboUse: "Use these invoices",
    confirmUse: "Apply",
    errNone: "No credit available.",
    errNotOpen: "This invoice isn't open.",
    invoicePanelBtn: "Apply to this invoice",
    invoicePanelPre: "Customer credit available:",
    noOpenInvoices: "No open invoices for this customer.",
    originPre: "Surplus from the deposit of",
    pickInvoice: "Open invoice",
    surplusNoCredit: "invoices from different customers: the surplus doesn't become credit",
    surplusToCredit: "→ becomes customer credit for",
    useBtn: "Apply to an invoice",
    usedOk: "Credit applied:",
    usedOn: "on",
    usedPre: "used",
  },
  customerDetail: {
    activeValue: "active",
    auditRequiresAdmin: "Audit log requires admin permission.",
    avgDaysToPayment: "Average days to payment",
    avgTicket: "Average ticket",
    backLink: "List",
    backToList: "Back to list",
    carsWordShort: "cars",
    colAction: "Action",
    colAmount: "Amount",
    colBy: "By",
    colCode: "Code",
    colDate: "Date",
    colDossier: "Dossier",
    colDueDate: "Due date",
    colInvoice: "Invoice",
    colInvoiceNumber: "Invoice no.",
    colIssued: "Issued",
    colMethod: "Method",
    colPlate: "Plate",
    colReason: "Reason",
    colReference: "Reference",
    colRetention: "Retention",
    colSituation: "Status",
    colTotalHt: "Total HT",
    colVehicle: "Vehicle",
    colWhen: "When",
    colorLabel: "Color",
    consolidatedHint: "Multi-car (consolidated) invoice",
    consolidatedPre: "Consolidated invoice ·",
    contactAddBtn: "Add contact",
    contactCancelBtn: "Cancel",
    contactEditBtn: "edit",
    contactName: "Name",
    contactNotes: "Note",
    contactReceivesInvoices: "receives invoices",
    contactReceivesInvoicesLong: "Receives invoices (suggested first when e-mailing)",
    contactRemoveBtn: "remove",
    contactRemoveTitle: "Remove this contact?",
    contactRole: "Role",
    contactRolePh: "E.g. accounting, workshop manager",
    contactSaveBtn: "Save contact",
    contactsEmpty: "No contacts yet.",
    contactsTitle: "Contacts",
    country: "Country",
    customerAuditLog: "Customer audit log",
    customerDossiers: "Customer dossiers",
    customerInvoices: "Customer invoices",
    customerNotFound: "Customer not found in accessible companies.",
    customerReceipts: "Customer receipts",
    dayAbbr: "d",
    daysUnit: "days",
    editBtn: "Edit",
    email: "Email",
    emptyAudit: "No events.",
    emptyDossiers: "No dossiers in this period.",
    emptyInvoices: "No invoices in this period.",
    emptyReceipts: "No receipts in this period.",
    emptyVehicles: "No vehicles registered for this customer.",
    fiscalId: "Fiscal ID",
    inactiveValue: "inactive",
    invalidId: "Invalid ID.",
    invoicedHt: "Invoiced HT",
    invoicesIssuedPaid: "Invoices (issued + paid)",
    language: "Language",
    loading: "Loading…",
    openBalance: "Open balance",
    openBtn: "open",
    openInvoiceTitle: "Open the invoice",
    overdueBalance: "Overdue balance",
    overdueInvoices: "Overdue invoices",
    paymentTerm: "Payment term",
    period12m: "Last 12 months",
    period30d: "Last 30 days",
    period3m: "Last 3 months",
    period6m: "Last 6 months",
    periodAll: "All",
    periodSelectorLabel: "Period:",
    periodSince: "Since 01/05/2026 (Gestion start)",
    periodYear: "Current year",
    phone: "Phone",
    receivedOnPre: "received on",
    registeredVehicles: "Registered vehicles",
    reversalBadge: "reversal",
    sectionFinancial: "Financial",
    sectionOperational: "Operations",
    sectionRecord: "Record",
    seeInCarros: "See in Cars ↗",
    stageAll: "All",
    stageHint: "Stage selected: shows every file in this status today, ignoring the date window.",
    stageReceived: "Received",
    stageToday: "Vehicles' status today",
    statementBtn: "📄 Statement of account",
    statusCancelled: "Cancelled",
    statusIssued: "Issued",
    statusLabel: "Status",
    statusPaid: "received",
    statusPending: "Pending",
    statusUncollectible: "Uncollectible",
    statusVoid: "Voided",
    stmtClose: "Close",
    stmtClosing: "Closing balance (incl. VAT)",
    stmtCredit: "Available credit",
    stmtErrorTitle: "Could not",
    stmtFrom: "From",
    stmtMessage: "E-mail message",
    stmtModeOpen: "Open today",
    stmtModePeriod: "Statement for a period",
    stmtMovements: "Transactions in the period",
    stmtNoEmail: "The customer has no e-mail on file: type an address.",
    stmtOpenInvoices: "Open invoices",
    stmtOpening: "Opening balance",
    stmtOverdue: "of which overdue",
    stmtPdfBtn: "📄 Open the PDF",
    stmtRecipient: "Send to",
    stmtSendBtn: "✉ Send by e-mail",
    stmtSentMsg: "The statement of account was sent to",
    stmtSentTitle: "Statement sent",
    stmtTitle: "Statement of account",
    stmtTo: "To",
    stmtToPay: "Balance to pay (incl. VAT)",
    stmtTotalOpen: "Total open (incl. VAT)",
    tabAudit: "Audit",
    tabDossiers: "Dossiers",
    tabFaturas: "Invoices",
    tabRecebimentos: "Receipts",
    tabResumo: "Summary",
    tabVeiculos: "Vehicles",
    tabWorklog: "Workshop worklog",
    total: "total",
    totalCredited: "Credit notes issued",
    totalIssued: "Total issued",
    totalReceived: "Total received",
    totalRetention: "Total retention",
    wlColFacture: "Net excl. VAT (after discount)",
    wlColLines: "Services · technician",
    wlColStatus: "Status",
    wlLineDepose: "Removal",
    wlLineEnCours: "in progress",
    wlLinePdr: "PDR",
    wlLineRepose: "Refit",
    wlLineTiers: "third party (garage)",
    wlNoAtelier: "no workshop",
    wlNoDemontage: "removal not entered",
    wlNoDemontageHint:
      "The quote includes removal/refitting, but nobody entered that service — it stays off the invoice until it is entered.",
    wlSelectHint:
      "Tap a status to include it in or remove it from the worklog (screen, PDF and e-mail).",
    wlSentScopePre: "PDF and e-mail to the client:",
    wlSentScopeSuf:
      "repaired, under repair and invoiced (only quotes without a technician are left out)",
    wlShowAll: "Show all",
    wlStatusDevis: "Quote",
    wlStatusEmReparacao: "In repair",
    wlStatusFacture: "Invoiced",
    wlStatusRepare: "Repaired",
    wlValorDevis: "Quote excl. VAT",
    wlValorFacture: "After customer discount (excl. VAT)",
    wlValorFactureHint:
      "Super admin only. Amount the invoice charges (or will charge): quote minus discount and excess. A car with no recorded service shows — and is left out of the total.",
    wlValorLabel: "Amounts",
    worklogAllAteliers: "— all workshops —",
    worklogAtelier: "Workshop",
    worklogBadPeriod: "The start date is after the end date.",
    worklogCarsWord: "car(s)",
    worklogChooseAtelier: "— choose the workshop —",
    worklogColAtelier: "Workshop",
    worklogColDate: "Date",
    worklogColDevis: "Total quote excl. VAT",
    worklogColPlate: "Plate / VIN",
    worklogColTech: "PDR technician",
    worklogColVehicle: "Vehicle",
    worklogEmailBtn: "Send to customer",
    worklogEmailLabel: "Customer e-mail",
    worklogEmpty: "No car at this workshop in the period.",
    worklogFrom: "From",
    worklogHint:
      "Every car done in the workshop, by every technician, over the period: the PDR / removal / refit lines with the technician and the amount of each. The PDF is in French for the customer.",
    worklogNoAtelier: "This customer has no workshop registered.",
    worklogPdfBtn: "Download PDF",
    worklogSentPre: "Worklog sent to",
    worklogTitle: "Worklog by workshop",
    worklogTo: "To",
  },
  customerReview: {
    badge: "to review",
    bannerPre: "eDSP customer to review.",
    cancel: "Cancel",
    chantierLabel: "Chantier",
    chantierNone: "— no chantier —",
    chip: "To review",
    confirm: "✓ Confirm",
    doneCarsPre: "Vehicles recalculated:",
    doneMsg: "Customer confirmed.",
    errRemise: "Enter the business customer's discount (0% is fine).",
    homeAction: "Review",
    homeCarsWord: "vehicle(s) in progress",
    homeTitle: "eDSP customers to review",
    intro:
      "eDSP lists don't include the type, SIRET or VAT number. Check the type, discount and chantier; Gestion has already suggested the type.",
    kindBusiness: "Business",
    kindBusinessHint:
      "Enter the discount (0% is fine). The deductible reduces the invoice and the commission.",
    kindIndividual: "Private customer",
    kindIndividualHint:
      "0% discount. The deductible doesn't reduce the invoice, only the technician's commission.",
    openCarsHint: "if anything changes, their discount and deductible are recalculated.",
    openCarsPre: "Vehicles not invoiced yet:",
    openRecord: "Open record",
    proMissingRemise:
      "Business without a discount: without it, Gestion can't calculate the technicians' quote-based commission. Enter the discount (0% is fine).",
    reasonIndefinido: "the name gives no clue, please check",
    reasonNomeEmpresa: "company name",
    reasonNomePessoa: "person's name",
    reasonSiretTva: "has a SIRET or VAT number",
    remiseLabel: "Customer discount (%)",
    reviewBtn: "Review",
    suggestionPre: "Gestion suggests:",
    title: "Review eDSP customer",
  },
  customers: {
    appliesTvaLabel: "Applies VAT (uncheck for intra-EU reverse charge)",
    atelierAddBtn: "Add workshop",
    atelierAliasesPh: "Names in eDSP, comma-separated (e.g. REPARE GRELE P2)",
    atelierCityPh: "City (optional)",
    atelierNamePh: "Workshop name (e.g. Julien)",
    atelierRemiseCustomer: "customer's default discount",
    atelierRemiseLabel: "discount",
    atelierRemisePh: "Discount % (optional)",
    atelierSaveBtn: "Save",
    ateliersHelp:
      "This client's repair locations. The technician picks one when importing the estimate.",
    ateliersTitle: "Workshops / service locations",
    badgeActive: "active",
    badgeInactive: "inactive",
    badgeInsurer: "Insurer",
    badgePart: "Indiv.",
    badgeProf: "Bus.",
    cancel: "Cancel",
    chantierHint: "Links the customer to a site (their cars appear on that site manager's portal).",
    chantierNone: "— none —",
    close: "Close",
    colActions: "Actions",
    colCountry: "Country",
    colEmail: "Email",
    colFiscalId: "Fiscal ID",
    colName: "Name",
    colStatus: "Status",
    colType: "Type",
    commissionHelp:
      "Default commission retained by the customer. Applied on the QUOTE basis when creating a dossier (editable per dossier).",
    commissionRangeError: "% Commission must be between 0 and 100.",
    companyLabel: "Company",
    create: "Create",
    customerPlural: "customers",
    customerSingular: "customer",
    deactivate: "Deactivate",
    deactivateMessage:
      "An inactive customer doesn't appear on new invoices. Existing invoices are not affected.",
    deactivatePlaceholder: "E.g. customer ended the contract",
    deactivateTitlePre: "Deactivate customer",
    editLink: "edit",
    editTitle: "Edit customer",
    emptyState: "No customers found.",
    fieldBillingEmail: "Billing email",
    fieldChantier: "Site",
    fieldCommission: "% Commission (customer retention)",
    fieldCountry: "Country (ISO-2)",
    fieldDisplayName: "Name (UI)",
    fieldEmail: "Email (general)",
    fieldFiscalIdKind: "Fiscal ID type",
    fieldLegalName: "Legal name (business)",
    fieldManagerPct: "Site manager commission for this customer (%)",
    fieldNotes: "Notes",
    fieldPaymentTerm: "Payment term (days)",
    fieldPhone: "Phone",
    fieldPortalUser: "Portal account (client)",
    fieldPreferredLang: "Preferred language",
    fieldReason: "Reason for the fiscal ID change",
    fieldTvaOnInvoice: "VAT on invoice",
    fieldVatNumber: "VAT No. · TVA · USt-IdNr. · IVA (intra-community)",
    fiscalAdminOnly: "Only administrators can edit the fiscal ID.",
    fiscalKindOther: "Other",
    fiscalKindVatEu: "VAT (other EU country)",
    franchiseRequiredHelp:
      "Individual clients always require it, regardless of this option. The amount is entered per vehicle at reception and frozen there.",
    franchiseRequiredLabel: "Deductible at reception",
    franchiseRequiredToggle: "Require deductible info at reception",
    kindBusiness: "Business",
    kindIndividual: "Individual",
    kindInsurer: "Insurer",
    loading: "Loading…",
    managerPctHint:
      "Empty = the manager's % (business or private). Fill in only for an exception for this customer; taken from the company share.",
    managerPctPlaceholder: "site default",
    newBtn: "New customer",
    next: "Next",
    noAccess: "You don't have access to any company.",
    openLink: "open",
    pageMid: "of",
    pagePre: "Page",
    parcCarsHelp:
      "Fixed-price categories (customer, débosselage, assembly). In the portal, when the car has no quote, the technician picks the category and enters make and model.",
    parcCarsTitle: "Parc cars",
    parcClosed: "closed",
    parcDefaultName: "Parc cars",
    parcEditCategories: "Set up categories",
    parcEnableBtn: "Enable parc cars",
    parcOpen: "open",
    placeholderEx20: "e.g. 20",
    placeholderEx30: "e.g. 30",
    portalUserHint:
      "Links an account with the 'Client (portal)' role — it sees this customer's site agenda and books vehicles.",
    portalUserNone: "— none —",
    prev: "Previous",
    proLooksIndividual:
      "Business with no SIRET, no VAT and no discount: is it a private person? If so, choose Private (0% discount). Without a discount, Gestion does not calculate the technicians' budget-based commission for this customer.",
    purgeBtn: "delete",
    purgeBtnTitle:
      "Delete the client with its UNTOUCHED dossiers and vehicles (super admin; blocked if any invoice/line/proforma exists)",
    purgeConfirmMsg:
      "This deletes the client, their dossiers WITHOUT activity (no line, invoice, proforma or purchase) and vehicles with no other dossiers. If any activity exists, nothing is deleted. Meant to undo an import into the wrong company. Continue?",
    purgeDoneDossiers: "dossier(s) deleted",
    purgeDoneTitle: "Client deleted",
    purgeDoneVehicles: "vehicle(s) deleted",
    purgeReasonPlaceholder: "E.g.: devis import done into the wrong company",
    purgeReasonTitle: "Reason for deletion",
    purgeTitle: "Delete client",
    reactivate: "Reactivate",
    reasonPlaceholder: "Required when changing fiscal data",
    save: "Save",
    saving: "Saving…",
    searchLabel: "Search",
    searchPlaceholder: "Name, email, fiscal id…",
    statusActive: "Active",
    statusAll: "All",
    statusInactive: "Inactive",
    statusLabel: "Status",
    totalLabel: "Total",
    tvaExemptOption: "Exempt / out of scope",
    tvaHelpApplies: "Rate applied on the invoice (e.g. 20% débosselage FR).",
    tvaHelpExempt: "Exempt / out of scope: VAT 0%, no reverse-charge mention.",
    tvaHelpReverse:
      "Reverse charge: VAT 0% + legal mention on the invoice (VAT due by the recipient, intra-EU B2B). E.g. Brazilian Storms OÜ → Euro Storm.",
    tvaReverseChargeOption: "Reverse charge (intra-EU B2B)",
    typeAll: "All types",
    typeLabel: "Type",
  },
  dashboard: {
    accessBtn: "Open",
    actionInformFranchise: "Enter the deductible",
    actionInvoiceNow: "Invoice now",
    allCaughtUp: "All caught up",
    amendedInvoicesSub:
      "The estimate changed after issue; the invoice was rebuilt under the same number",
    amendedInvoicesSuf: "amended invoices — re-send to customer",
    awaitingReconciliationSuf: "transactions awaiting reconciliation",
    bankReconciliation: "Bank reconciliation",
    bankStatement: "Bank statement",
    carWord: "car",
    cardFranchise: "Deductible not entered",
    cardToInvoice: "Vehicles to invoice",
    carsWord: "cars",
    chantierNoEnd: "no end date",
    chantierStartsPre: "Starts",
    chantierUntilPre: "until",
    chantiersBarHint: "Bar = delivered cars over the site total.",
    chantiersEmpty: "No active site.",
    chantiersTitle: "Sites in progress",
    chipAll: "All",
    chipPending: "Pending",
    chipToInvoice: "To invoice",
    colDate: "Date",
    colGarage: "Garage",
    colGross: "Gross",
    colProfit: "Profit",
    colRef: "Ref.",
    colStatus: "Status",
    colTechnician: "Technician",
    colVehicle: "Vehicle",
    commissionsNotComputed: "commissions not computed",
    degarnHint:
      "Cars already repaired (PDR finished) whose quote dégarnissage is not entered or not finished. Not entered, its amount stays out of the invoice and the technician's pay.",
    degarnNoLine: "not entered",
    degarnOpen: "not finished",
    degarnOpenList: "See the cars",
    degarnOutOfInvoicePre: "out of the invoice:",
    degarnTitle: "Dégarnissage not finished",
    degarnTotalPre: "Pending dégarnissage on the quotes:",
    dossiersCommissionsSuf: "dossiers — commissions",
    dossiersPayoutTechnicianSuf: "dossiers — payout to technician",
    dossiersSuf: "dossiers",
    einvoiceLine: "Reception via PDP: since 01/09/2026 · Mandatory issuing (ES): 01/09/2027",
    emptyDossiers: "No dossiers",
    feedClaim: "Car taken in the portal",
    feedCreditNote: "Credit note created",
    feedDelivery: "Delivery recorded",
    feedDerogation: "Derogation applied",
    feedDevisEdit: "Quote edited",
    feedDevisImport: "Quote imported from the portal",
    feedDocUpload: "Reception document uploaded",
    feedEmailSent: "E-mail sent",
    feedEmpty: "Nothing recorded today yet.",
    feedInvoiceCancelled: "Invoice cancelled",
    feedInvoiceIssued: "Invoice issued",
    feedInvoiceReissued: "Invoice reissued",
    feedMarkPaid: "Payment marked",
    feedOfficeLaunch: "Technician assigned by the office",
    feedReception: "Reception recorded",
    feedTitle: "Came in today",
    feedWiseFail: "Wise sync failed",
    feedWiseOk: "Wise statement synced",
    feedWorkOk: "work approved",
    feedWorkReserves: "with reservations",
    filters: "Filters",
    fiscalYearLabel: "fiscal year",
    greetingAfternoon: "Good afternoon",
    greetingEvening: "Good evening",
    greetingMorning: "Good morning",
    importEdsp: "Import eDSP",
    inFiscalYear: "in the fiscal year",
    invoicedMinusCommissionsPre: "invoiced − commissions",
    itemsSuf: "items",
    kpiGrossProfit: "Gross profit",
    kpiOpenDossiers: "Open dossiers",
    kpiReceivable: "Receivable",
    kpiReceived: "Already received",
    kpiRevenue: "Revenue (fiscal year)",
    kpiTechPayouts: "To pay out to technicians",
    moreCustomersSuf: "more customers",
    needsYouTitle: "Needs you",
    newDossier: "New car",
    nothingPending: "Nothing pending",
    nothingPendingLine: "Nothing pending.",
    ofInvoiced: "of invoiced",
    open: "Open",
    openInvoicesSuf: "open invoices",
    overdue: "Overdue",
    overdueInvoices: "Overdue invoices",
    overdueSuf: "overdue",
    payableTechnicians: "Payable (technicians)",
    pendingCustomerAction: "Confirm on the vehicle page",
    pendingCustomerTitle: "Quote customer changed",
    pendingPlural: "pending items",
    pendingSingular: "pending item",
    period12m: "12 m",
    periodMonth: "Month",
    periodYear: "Fiscal year",
    receivableCustomers: "Receivable (customers)",
    receivedToPaySuf: "received, to pay",
    recentDossiers: "Recent dossiers",
    reconciledSuf: "reconciled",
    statusInvoiced: "Invoiced",
    statusPending: "Pending",
    statusReview: "Review",
    supplierInvoicesSuf: "supplier invoices",
    techApplicationsHint: "waiting for your approval",
    techApplicationsOneSuf: "technician application",
    techApplicationsSuf: "technician applications",
    techPayoutsBlockedHint: "waiting for customer payment",
    techPayoutsEmpty: "No technician to pay",
    techPayoutsOthersPre: "+",
    techPayoutsOthersSuf: "other technicians",
    techPayoutsPayNow: "in hand — pay now",
    techPayoutsReleasedHint: "received from customer — released",
    techPayoutsTechCountSuf: "technicians to pay",
    techPayoutsTechCountSufSingular: "technician to pay",
    tileActiveChantiers: "Active sites",
    tileOpenCars: "Open cars",
    tilePendingDeliveries: "Pending deliveries",
    tileToInvoice: "To invoice · net",
    tilesAria: "Indicators",
    title: "Dashboard",
    toInvoice: "to invoice",
    toInvoiceMoreCustomers: "more customer(s)",
    toInvoiceSeeAll: "See all",
    toInvoiceShowLess: "Show less",
    toInvoiceTitle: "There are cars to invoice",
    toPaySuf: "to pay",
    todoTitle: "To do",
    treasuryTitle: "Treasury",
    unreconciledTxSuf: "unreconciled transactions",
    unsentCardAction: "Send",
    unsentCardTitle: "Invoices not sent",
    viewAll: "View all",
    weekPre: "week",
  },
  devisPage: {
    colCustomer: "Customer",
    colDevis: "Quote no.",
    colImpacts: "Impacts",
    colStage: "Stage",
    colTotal: "Total excl. VAT",
    colVehicle: "Vehicle",
    countSuffix: "quotes",
    empty: "No quotes with these filters.",
    filterSearch: "Search",
    filterStage: "Stage",
    pageTitle: "Quotes",
    searchPlaceholder: "Customer, plate or quote no.…",
    stageAll: "All",
    stageDevis: "Quoted",
    stageInvoiced: "Invoiced",
    stageRepairing: "In repair",
    withDegarnissage: "with disassembly",
  },
  dossierDetail: {
    activityBadge: "Activity · 100% house",
    activityCost: "Cost (excl. VAT)",
    activityMargin: "Margin",
    activityTypeLabel: "Activity type",
    addPaymentBtn: "+ Payment",
    addReceiptBtn: "+ Receipt",
    addServiceLineTitle: "Add service line",
    amountEuro: "Amount (€)",
    amountMustBePositive: "Amount must be > 0.",
    amountPositiveShort: "Amount > 0.",
    appliedLabel: "Applied",
    approveInvoice: "approve invoice",
    approveLower: "approve",
    auditLogTitle: "Dossier audit log",
    auditRequiresAdmin: "The audit log requires admin permission.",
    autoCalculatedTitle: "Automatically calculated",
    avoirBtn: "Credit note",
    avoirBtnTitle: "Issue a credit note on this invoice: full or partial, with a reason",
    avoirCancelledTag: "cancelled",
    avoirEmbeddedTag: "already deducted in the invoice",
    avoirWord: "Credit note",
    avoirsEffective: "Credit notes (absorbed by the house)",
    avoirsLabel: "Credit notes",
    avoirsNotePre: "Credit notes on this vehicle, deducted from the house's profit:",
    avoirsSplit: "split across the invoice's vehicles",
    backShort: "← List",
    backToList: "← Back to list",
    balance: "Balance",
    bankAccountOptional: "Bank account (optional)",
    base: "Base",
    baseAfterFranchise: "Base after deductible",
    baseBudget: "Quote (Prix Brut)",
    baseInvoiced: "Invoiced (Total Facture)",
    bruteCheck: "Gross check",
    calcAndPromote: "Calculate and promote",
    calcBase: "Calculation base",
    calcCommissionBtn: "⚠ Calculate commission",
    calcCommissionTitle:
      "Line without a calculated cascade — click to set the customer/technician/intermediary %",
    calcLineCommissionTitle: "⚠ Calculate the line commission",
    cancel: "Cancel",
    cancelIcTitle: "Cancel IC",
    cancelInvoiceMsg: "Cancels with fiscal effect. Reversible via reissue.",
    cancelInvoiceTitle: "Cancel invoice",
    cancelLineBtn: "Cancel line",
    cancelLineMsg:
      "The line leaves the technician's list, payment and invoice, and the service leaves the customer invoice base (if the company still has to bill it, assign another technician). Irreversible. Give the reason.",
    cancelLineTitle: "Cancel the service line",
    cancelLower: "cancel",
    cascadeClient: "Customer",
    cascadeIntermediary: "Intermediary",
    cascadeTechnician: "Technician",
    cascadeTitle: "Commission cascade",
    chantierDelivery: "Delivery",
    chantierDeliveryNa: "not applicable outside a site (the car counts as delivered when invoiced)",
    chantierFranchiseAmountPh: "Amount incl. VAT",
    chantierFranchiseCancel: "Cancel",
    chantierFranchiseEdit: "Fix",
    chantierFranchiseHas: "This car has a deductible",
    chantierFranchiseHint:
      "The discount is recomputed from the full quote amount and stays in the audit log.",
    chantierFranchisePre: "Deductible to discount:",
    chantierFranchisePreParticular: "Excess (private customer):",
    chantierFranchiseReasonPh: "Reason for the fix (required)",
    chantierFranchiseSave: "Save deductible",
    chantierFranchiseSaving: "Saving…",
    chantierFranchiseSuf: "— deduct from the customer invoice or issue a credit note.",
    chantierFranchiseSufParticular:
      "— the invoice stays in full; the excess only reduces the commission base. Any discount to the customer: by credit note only.",
    chantierNoFranchise: "Reception without deductible.",
    chantierPendingWord: "pending",
    chantierReception: "Reception",
    chantierSectionTitle: "Site (project manager)",
    chantierWorkOkNo: "⚠ Work with reserves",
    chantierWorkOkYes: "✓ Work checked and approved",
    chgCustAtelier: "Workshop",
    chgCustBlocked: "The customer cannot be changed:",
    chgCustBtn: "Change customer or workshop",
    chgCustChoose: "— choose the customer —",
    chgCustColInvoiced: "To invoice",
    chgCustColRemise: "Discount",
    chgCustColService: "Service",
    chgCustColTech: "Technician",
    chgCustColTechAmount: "Technician gets",
    chgCustCurrent: "Current customer",
    chgCustDone: "Customer changed — lines, deductible and repair order recalculated.",
    chgCustImpact: "What changes with the new customer",
    chgCustNew: "New customer",
    chgCustNoAtelier: "— no workshop —",
    chgCustOnlyAtelier: "current customer (change the workshop only)",
    chgCustReason: "Reason (kept in the audit log)",
    chgCustSave: "Change customer",
    chgCustSearchPh: "Search by name…",
    chgCustTitle: "Change the dossier's customer or workshop",
    clientPctRange: "Customer % must be between 0 and 100.",
    clientRetainedPre: "Client retained",
    colAction: "Action",
    colBy: "By",
    colReasonDetails: "Reason / details",
    colWhen: "When",
    commBlockProSemRemise:
      'No commission: the customer is registered as Business with no discount. Set the discount on the customer record or, if it is a private person, change the type to Private. Then click "Calculate commission".',
    commBlockSemPar:
      'No commission: the technician has no pair with this customer (nor with the workshop or site). Set up the pair, then click "Calculate commission".',
    companyLabel: "Company",
    companyShort: "Co.",
    complementaryRequiresValues:
      "The complementary model requires the quote and invoiced amounts to be filled in.",
    create: "Create",
    createIcDraftBtn: "+ Create IC draft",
    createIcDraftTitle: "Create IC draft",
    createTechInvoicesFirst: "Create technician invoices before recording payments.",
    createsNegativeMirror: "Creates a mirror entry with a negative amount.",
    creating: "Creating…",
    customerEffective: "Customer effective",
    customerInvoicesTitle: "Customer invoices",
    customerPct: "Customer pct",
    dateTime: "Date/time",
    degarnAlertHint:
      'The car counts as repaired (PDR finished), but nobody recorded who dismounted and remounted. Until it is entered, the dégarnissage amount stays out of the invoice and the technician\'s pay. Enter it in the portal (technician or fitter, or "done by the garage").',
    degarnAlertOpenHint:
      "The car counts as repaired (PDR finished). The dégarnissage was taken, but dismount or remount is not marked done. The amount is already in the invoice; the steps still need finishing in the portal.",
    degarnAlertTitle: "Dégarnissage not finished",
    degarnLaunchBtn: "👷 Record the dégarnissage",
    degarnLaunchTabHint: "The quote has a dégarnissage that isn't fully recorded yet.",
    degarnLaunchTitle: "Record the dégarnissage",
    deletedTitle: "Deleted",
    deliveryDerogBtn: "Mark delivered (override)",
    deliveryDerogConfirm: "Mark delivered",
    deliveryDerogMessage:
      "The car becomes 'delivered' without the chantier check. Give the reason (kept in the audit).",
    deliveryDerogTitle: "Record delivery without the manager's photos",
    deposeReposeLabel: "Remove/Refit",
    derogBtn: "Release repair without reception",
    derogConfirm: "Confirm release",
    derogHint: "Super admin only. Without reception, no deductible is recorded.",
    derogNoReception:
      "Car without reception: technicians can't take it until reception is done. In exceptional cases, release it here.",
    derogReasonPh: "Reason (required — kept in the history)",
    derogReleased: "Repair released without reception",
    derogTitle: "Repair release",
    devisClassCol: "Class",
    devisImpactsCol: "Impacts",
    devisMethodCol: "Method",
    devisNoteCol: "Note",
    devisOriginalBtn: "Original PDF",
    devisOriginalHint:
      "Opens the quote PDF exactly as received (technician portal, quotes inbox or office import).",
    devisOriginalLatest: "latest",
    devisOriginalVersions: "revisions",
    devisPanelCol: "Panel",
    devisSectionTitle: "Quote (eDSP)",
    downloadInvoicePdfTitle: "Download invoice PDF",
    draftBannerOpen: "Open the draft",
    draftBannerPre: "Invoice draft waiting (not issued yet)",
    draftBannerReplaces: "replaces cancelled invoice",
    dueDate: "Due date",
    dueQuick15: "15 days",
    dueQuick30: "30 days",
    dueQuick60: "2 months",
    dueQuick7: "1 week",
    editActivityBtn: "Edit activity",
    editActivityTitle: "Edit activity line",
    editCommission: "Edit commission",
    editDevisAddOther: "Other item",
    editDevisAddPanel: "Add panel",
    editDevisAmounts: "Amounts",
    editDevisBlockedInvoice:
      "Invoice already issued: you can't launch a technician on this vehicle. To change amounts, use Edit estimate (the invoice is rebuilt under the same number).",
    editDevisBtn: "Edit quote",
    editDevisDoneCreated: "line(s) created",
    editDevisDoneLines: "line(s) recalculated",
    editDevisDoneOr: "Repair order updated",
    editDevisDoneRemoved: "line(s) removed",
    editDevisDoneTitle: "Quote updated",
    editDevisDoneTotalPre: "New total excl. VAT:",
    editDevisHint:
      "The quote drives everything: on save, service lines, commissions, deductible and repair order are recalculated.",
    editDevisInvoiceAmended: "rebuilt under the same number",
    editDevisInvoiceConfirm:
      "Continue? The invoice will be rebuilt under the same number and flagged to be re-sent to the customer.",
    editDevisInvoiceNote:
      "This vehicle already has an issued invoice. On save, the invoice is rebuilt under the SAME number and for the same customer; the previous version is kept and it is flagged to be re-sent to the customer.",
    editDevisInvoiceResend: "re-send it to the customer",
    editDevisPanels: "Panels",
    editDevisReason: "Reason for the change",
    editDevisRemiseExc: "Exceptional discount (excl. VAT)",
    editDevisRemiseExcHint:
      'Shows on the invoice as "Remise exceptionnelle" and lowers the repair order amount to invoice. Does not change commissions.',
    editDevisSave: "Save and recalculate",
    editDevisTitle: "Edit the quote",
    editLineCommissionTitle: "Edit the line commission",
    edspNonBank: "eDSP · non-bank",
    edspReceiptTitle:
      "Receipt imported from eDSP — it did not come from the bank statement (not reconciled with the bank). The amount may be gross, not the net received.",
    emailBtn: "📧 Email",
    emailLabel: "Email",
    emailPlaceholder: "customer@example.com",
    errorGeneratingPdf: "Error generating PDF",
    errorSending: "Error sending",
    errorTitle: "Error",
    eurostormEffective: "Eurostorm effective",
    eurostormPct: "Eurostorm pct",
    expected100: "expected 100%",
    fieldAtelier: "Workshop",
    fieldBillingCompany: "Billing company",
    fieldCustomer: "Customer",
    fieldDate: "Date",
    fieldEndCustomer: "End customer",
    fieldInvoiceStatus: "Invoice status",
    fieldInvoices: "Invoice(s)",
    fieldLines: "Lines",
    fieldReceivingCompany: "Receiving company",
    fieldRepair: "Repair",
    fieldVehicle: "Vehicle",
    fixedClearBtn: "Clear (back to the pair)",
    fixedDspLabel: "PDR — technician gets (€ excl. VAT)",
    fixedEditBtn: "Edit",
    fixedFollowPair: "empty = follows the pair",
    fixedHint:
      'Exception to the pair, for this car only: applies to whoever takes it (also before the technician takes it on the portal). Whoever takes the PDR gets the PDR fixed amount; whoever removes/refits gets the trim-removal fixed amount (50/50 halves). Only the technician\'s share changes — customer discount and intermediary follow the pair, the house keeps the rest. The deductible, entered by the technician as usual, only affects the customer invoice: it does not reduce the fixed amount. Confidential: on the portal the technician only sees "Your commission", without knowing it is fixed. Leave empty to follow the pair.',
    fixedMontageLabel: "Trim removal — technician gets (€ excl. VAT)",
    fixedMontageShort: "Trim removal",
    fixedNone:
      "Default: the technician is paid by the technician × customer pair. Fixed amount only as an exception, set here.",
    fixedSaveBtn: "Save fixed amount",
    fixedSetBtn: "Set fixed amount (exception)",
    fixedTechAmountHint:
      "The technician gets exactly this amount; the % is derived and the house absorbs the difference. Kept as a manual override (automatic recalculations leave it alone).",
    fixedTechAmountLabel: "Fixed technician amount (€ excl. VAT) — optional",
    fixedTechAmountPh: "e.g. 1200",
    fixedTitle: "Fixed technician amount for this car",
    fixedTopBtn: "Fixed amount",
    fixedTopHint: "Technician's fixed amount for this vehicle (exception to the pair) — admin only",
    franchiseAddBtn: "Enter deductible",
    franchiseCommissionsOnlyBadge: "exception: full invoice",
    franchiseCommissionsOnlyHint:
      "Normal rule for a Professional: the franchise reduces the invoice and the commissions. When checked, only the technicians' commissions are reduced, as for a Private customer.",
    franchiseCommissionsOnlyLabel: "Exception: franchise on commissions only (full invoice)",
    franchiseNoReception: "Car without a recorded reception — no deductible entered.",
    franchiseSectionTitle: "Deductible",
    impactsWord: "impacts",
    intercompanyEffective: "Intercompany effective",
    intercompanyInvoicesTitle: "Intercompany invoices",
    intermediary: "Intermediary",
    intermediaryEffective: "Intermediary effective",
    intermediaryPct: "Intermediary pct",
    intermediaryPctRange: "Intermediary % must be between 0 and 100.",
    internalCodePre: "internal no.",
    invalidEmail: "Enter a valid email address.",
    invalidId: "Invalid ID.",
    invoiceIssuedOnPre: "issued on",
    invoiceNumberField: "Invoice no. (optional — auto if empty)",
    invoiceNumberPlaceholder: "F2026-00001 (automatic if empty)",
    invoiceReceivedOnPre: "received on",
    invoiceSentTo: "Invoice sent to",
    invoiced: "Invoiced",
    invoicesNone: "none issued",
    issue: "Issue",
    issueCustomerInvoiceTitle: "Issue customer invoice",
    issueInvoiceBeforeReceipts: "Issue an invoice on the dossier before recording receipts.",
    issueInvoiceBtn: "+ Issue invoice",
    issueLower: "issue",
    issuer: "Issuer",
    issuerCompany: "Issuing company",
    issuing: "Issuing…",
    launchTechBtn: "Assign technician",
    launchTechCancel: "Cancel",
    launchTechChoice: "What they did",
    launchTechChoose: "— choose the technician —",
    launchTechClose: "Close",
    launchTechDone: "Car already repaired (marks PDR finished and steps done)",
    launchTechHint:
      "Same rule as the portal: commission from the technician × client pair, bodywork and parts 100% house, deductible and repair order. Without a reception check, the Super Admin releases it by derogation with the reason.",
    launchTechMontage: "Removal and refitting only",
    launchTechOk: "Technician assigned to the car.",
    launchTechPdr: "PDR only",
    launchTechPdrMontage: "PDR + removal and refitting",
    launchTechReason: "Reason",
    launchTechSubmit: "Assign",
    launchTechTech: "Technician",
    launchTechTitle: "Assign a technician to the car",
    legacyHintPre: "Legacy line without a cascade — prefilled from the technician×customer pair",
    legacyHintSuf: "Adjust and save to promote.",
    lineStatusApproved: "approved",
    lineStatusCancelled: "cancelled",
    lineStatusNotApplicable: "not applicable",
    lineStatusPaid: "paid",
    lineStatusPending: "pending",
    lineStatusProformaIssued: "proforma issued",
    lineStatusReceived: "received",
    lineStatusRejected: "rejected",
    lineTakenOnPre: "taken on",
    linesEmpty: "No lines. Lines are created automatically when importing dossiers from eDSP.",
    linesTotalTitle: "Dossier total",
    loading: "Loading…",
    managerAmount: "Manager commission",
    managerBase: "Base (PDR + dégarnissage after deductible)",
    managerCancelBtn: "Cancel",
    managerCardTitle: "Site manager",
    managerDefaultWas: "default",
    managerDeliveredPre: "Counts in the month of the delivery registered on",
    managerEditBtn: "Edit",
    managerEditHint: "This car only; taken from the company share.",
    managerEffective: "Manager effective",
    managerFixedWord: "fixed",
    managerHint:
      "On PDR + dégarnissage; taken from the house share, doesn't change technician or customer. Same calculation as the manager portal payout.",
    managerModeDefault: "Default",
    managerModeFixed: "Fixed amount (€ excl. VAT)",
    managerModePct: "Percentage",
    managerNotDelivered:
      "Waiting for the manager to register the delivery — without it the commission counts in no month.",
    managerOverrideLabel: "Exception for this car",
    managerPctEquiv: "Equivalent %",
    managerPctOverride: "% (car exception)",
    managerPctParticular: "% private",
    managerPctPro: "% business",
    managerPreview: "The manager receives",
    managerReasonPh: "Reason (required)",
    managerSaveBtn: "Save",
    markInvoiceReceived: "mark invoice received",
    markPaid: "mark paid",
    markPaidInvoice: "mark paid",
    markReceived: "mark received",
    method: "Method",
    methodCard: "Card",
    methodCash: "Cash",
    methodCheck: "Check",
    methodOther: "Other",
    methodTransfer: "Transfer",
    model: "Model",
    modelComplementary: "Complementary (F8)",
    modelLegacy: "Legacy (current)",
    moreBtn: "More",
    netAfterAvoirPre: "net after credit note",
    netInvoicedLabel: "Net invoiced",
    netSuffix: "(net)",
    newReceiptTitle: "New receipt",
    newTechnicianPaymentTitle: "New technician payment",
    noCustomerEmailWarn: "⚠ Customer has no email on file — enter an address above.",
    noEvents: "No events.",
    noIcCandidateTitle: "No line has a responsible_company different from the billing_company.",
    noIcForDossier: "No IC for this dossier.",
    noInvoicesYet: "No invoice issued yet.",
    noPayments: "No payments.",
    noReceipts: "No receipt recorded.",
    noTechnicianInvoices: "No technician invoice covers lines from this dossier yet.",
    noneOption: "— none —",
    notFound: "Dossier not found in the accessible companies.",
    notesLabel: "Notes",
    onDate: "On",
    onPrixBrut: "on Prix Brut",
    openBalance: "Open balance",
    overrideApplied: "Override applied",
    overrideLabel: "Override",
    payment: "Payment",
    payoutEffective: "To pay out (technician + intermediary)",
    pctLabel: "Percentage",
    pdfAutoAttachHint:
      "The invoice PDF will be generated/updated and attached automatically. The email is sent with the issuing company's sender configured in SMTP.",
    pendingCustomerKeep: "Keep",
    pendingCustomerNow: "the vehicle is currently under",
    pendingCustomerPre: "Quote re-sent with another customer:",
    pendingCustomerSwitch: "Switch to",
    phaseDemontage: "Disassembly",
    phaseExternal: "third party (garage)",
    phaseMontage: "Reassembly",
    phasePdrDone: "PDR finished",
    phasePdrOpen: "PDR in progress",
    portalDoc_carte_grise: "Registration certificate",
    portalDoc_cnh: "Driving licence",
    portalDoc_expertise: "Expert report",
    portalDoc_outro: "Other document",
    portalFilesHint:
      "Uploaded through the manager and technician portals (reception, delivery and refit). Tap a photo to open it full size.",
    portalFilesTitle: "Portal documents and photos",
    portalOpenBtn: "Open",
    portalPhotosDelivery: "Delivery photos",
    portalPhotosMontage: "Removal photos",
    portalPhotosMontageEnd: "Refit photos",
    portalPhotosReception: "Reception photos",
    quote: "Quote",
    reasonInline: "· reason:",
    reasonRequired: "Reason required.",
    reassignBtn: "Reassign",
    reassignDemontageDone: "Disassembly done",
    reassignDemontageExternal:
      "Disassembly done by a third party (garage) — nobody at ES/BS is paid",
    reassignDemontageLabel: "Disassembly (line owner)",
    reassignDspDone: "PDR finished",
    reassignExternalHint:
      "The external half counts as done (the car closes), is not invoiced to the customer and nobody in the group is paid for it.",
    reassignHint:
      "The commission is recomputed from the new technician's pair with the customer. Without a pair the line stays legacy until the office recalculates. Completed steps are kept.",
    reassignMontageDone: "Reassembly done",
    reassignMontageExternal: "Reassembly done by a third party (garage) — nobody at ES/BS is paid",
    reassignMontageLabel: "Reassembly",
    reassignPdrLabel: "PDR technician",
    reassignReasonLabel: "Reason (required)",
    reassignReasonMin: "Type at least 3 letters to enable the button.",
    reassignSameAsOwner: "Same technician as disassembly",
    reassignSave: "Reassign",
    reassignTitle: "Reassign technician",
    reassignWorkState: "Work status",
    receiptsByInvoiceTitle: "Receipts by invoice",
    received: "Received",
    receiver: "Receiver",
    receiverBillingCompany: "Receiver (billing_company)",
    recipient: "Recipient",
    reference: "Reference",
    register: "Record",
    rejectInvoice: "reject invoice",
    rejectLower: "reject",
    rejectTechnicianInvoiceTitle: "Reject technician invoice",
    repairEdspOrderPre: "eDSP order of",
    requestProformaBtn: "Request a proforma from the technician",
    requestProformaTitle:
      "Advance the technician's pay: the proforma needs neither the customer invoice nor the payment.",
    responsibleCompany: "Responsible company",
    responsibleCompanyRequired: "The responsible company is required.",
    retentionFromPairNote:
      "Customer discount set in the technician × customer pair (sum of the lines).",
    retentionPctVaries: "varies per line",
    reversalOf: "reversal of",
    reverseLower: "reverse",
    reversePaymentTitle: "Reverse payment",
    reverseReceiptTitle: "Reverse receipt",
    roAddMontageAmount: "Trim removal amount (excl. VAT)",
    roAddMontageBtn: "Add the quote's assembly line",
    roAddMontageConfirm: "Add",
    roAddMontageExternal: "Done by a third party (garage) — nobody at ES/BS is paid",
    roAddMontageHint:
      "The quote has trim removal but nobody took the assembly on the portal. Pick who did it (or tick third party), confirm the amount and the steps done.",
    roAddMontageTech: "Technician (disassembly and reassembly)",
    roAddMontageTitle: "Add the assembly line (quote's trim removal)",
    roAmount: "Amount to invoice HT",
    roClientPo: "Client PO number",
    roComment: "Comment",
    roCreateBtn: "Create the order",
    roDevisAmount: "Quote HT",
    roEditBtn: "Edit",
    roEditHint:
      "Lowering the amount creates an exceptional discount on the invoice. Only possible before invoicing.",
    roEmpty: "The order is created when the technician takes the car in the portal.",
    roIncompleteAsk: "Invoice anyway?",
    roIncompleteConfirm: "Invoice anyway",
    roIncompleteTitle: "The car is not finished",
    roInitialAmount: "Initial amount HT",
    roInvoicedLocked: "Car already invoiced — the order is frozen.",
    roMissingDelivery: "delivery pending",
    roMissingDsp: "debossing missing",
    roMissingMontage: "assembly pending",
    roMissingMontagePhases: "assembler not finished",
    roReady: "Ready to invoice",
    roRemise: "Exceptional discount",
    roSectionTitle: "Repair order",
    roSplitDegBtn: "Trim removal done by the same technician",
    roSplitDegConfirm: "Split and mark done",
    roSplitDegMsgPre:
      "The PDR line includes the trim removal from the quote. The assembly line, already completed, will be created for",
    roSplitDegMsgSuf:
      "No amount changes (client, technician, house, RO). The PDR will also be marked done. Give the reason.",
    roSplitDegTitle: "Split the PDR line into PDR + assembly",
    save: "Save",
    saveCommission: "Save commission",
    saving: "Saving…",
    sectionCustomerRetention: "Customer retention",
    sectionHeader: "Header",
    sectionTotals: "Aggregated totals",
    selectIssuer: "Select the issuer.",
    selectPlaceholder: "— select —",
    selectTechnicianForCascade: "Select a technician to edit the commission cascade.",
    send: "Send",
    sendInvoiceEmailTitle: "Send invoice by email",
    sending: "Sending…",
    serviceLinesTitle: "Service lines",
    serviceTypeMontage: "Assembly/Disassembly",
    serviceTypePeinture: "Bodywork/Paint",
    serviceTypePieces: "Parts",
    softDeletedBadge: "soft-deleted",
    statusApproved: "approved",
    statusCancelled: "cancelled",
    statusCustomerReceived: "received",
    statusDraft: "draft",
    statusIssued: "issued",
    statusPaid: "paid",
    statusPending: "pending",
    statusReceived: "received",
    statusRejected: "rejected",
    statusReversed: "reversed",
    statusVoid: "void",
    suggestedFromDossierHint:
      "Suggested from the dossier (keeps the original eDSP format — do not change it if you want the CSV receipts to match this invoice).",
    suggestedLabel: "Suggested",
    suggestedNextHint: "Next number in the series — editable.",
    sumEquals: "Sum =",
    sumExceedsPre: "⚠ The sum of the percentages exceeds 100%.",
    sumExceedsSuf: "would be negative.",
    sumMust100: "The sum of the percentages must be 100%",
    sumMust100Save: "The sum of the percentages must be 100% to save.",
    tabAudit: "Audit",
    tabFaturacao: "Customer invoicing",
    tabFinanceiro: "Billing and payments",
    tabHistorico: "History and documents",
    tabIntercompany: "Intercompany",
    tabLinhas: "Lines",
    tabRecebimentos: "Receipts",
    tabResumo: "Summary",
    tabServicos: "Services and technicians",
    tabTecnicoFaturas: "Technician invoices",
    tabTecnicoPagamentos: "Technician payments",
    technician: "Technician",
    technicianAmountKnown: "Technician amount known",
    technicianAmountUnknownWarn: "Technician amount not known yet.",
    technicianEffective: "Technician effective",
    technicianInvoice: "Technician invoice",
    technicianInvoiceImportHint:
      "The technician invoice is imported by attaching it to the matching proforma.",
    technicianInvoicesTitle: "Technician invoices (with lines from this dossier)",
    technicianPaymentsTitle: "Technician payments",
    technicianPct: "Technician pct",
    technicianPctRange: "Technician % (override) must be between 0 and 100.",
    technicianRequired: "The technician is required.",
    thirdPartyNotBilledAll:
      "Disassembly and reassembly done by a third party (garage): this trim removal is not invoiced.",
    thirdPartyNotBilledHalf:
      "One half done by a third party (garage): only the half done by the group is invoiced.",
    tlActIssue: "Issue invoice",
    tlActPayout: "Pay the technician",
    tlActReceipt: "Record receipt",
    tlDelivered: "Delivered",
    tlDevis: "Quote",
    tlDone: "Done",
    tlInvoiced: "Invoiced",
    tlMontage: "Assembly",
    tlNoTech: "no technician",
    tlPayout: "Technician payout",
    tlPortal: "on the portal",
    tlPortalHint: "Step recorded on the portal (technician or manager).",
    tlReceived: "Received",
    tlRepaired: "Repaired",
    tlTitle: "Where the car is",
    total: "Total",
    totalCustomerRetention: "Customer retention",
    totalIntercompanyInvoice: "Intercompany invoice",
    totalIntermediaryCommission: "Intermediary commission",
    totalInvoiced: "Total invoiced",
    totalNetUpper: "TOTAL NET",
    totalQuote: "Total quote",
    totalTechnicianCommission: "Technician commission",
    totalUpper: "TOTAL",
    type: "Type",
    usingBillingEmailHint:
      "Using the customer's billing email. Edit it to send to another recipient.",
    vehicleHistoryBtn: "Vehicle record",
    vehicleOthersHint: "This vehicle has other dossiers: open its record to see them all.",
    voidInvoiceMsg: "Voided. Different from cancel: no fiscal effect.",
    voidInvoiceTitle: "Void invoice",
    voidLower: "void",
  },
  dossierWizard: {
    addFirstLineHint: "(you can add/edit it later in the details)",
    addFirstLineNow: "Add the first service line now",
    back: "← Back",
    cancel: "Cancel",
    commissionAmountKnown: "Commission amount known",
    commissionUnknownValue: "amount unknown (to be set later)",
    dupConfirmBtn: "It is a new job — create another file anyway",
    errAmountUnknownFieldsEmpty:
      "technicianAmountKnown=false: commission pct, base and amount must be left empty.",
    errCommissionAmountMin: "Commission amount: ≥ 0.",
    errCommissionPctRange: "Commission %: between 0 and 100.",
    errInvoicedMin: "Invoiced must be ≥ 0.",
    errLineCreatePre: "Dossier created, but adding the first line failed",
    errLineCreateSuf: "You can add it manually in the 'Lines' tab of the details.",
    errQuoteMin: "Quote must be ≥ 0.",
    errResponsibleCompanyRequired: "Responsible company is required.",
    errRetentionRange: "Customer retention: % must be between 0 and 100.",
    errSelectBillingCompany: "Select the billing company.",
    errSelectCustomer: "Select the customer.",
    errTechnicianRequired: "Technician is required.",
    errVehicleRequired: "Enter a vehicle, plate or VIN.",
    fieldBase: "Base",
    fieldBillingCompany: "Billing company",
    fieldCommissionPct: "Commission %",
    fieldCustomer: "Customer",
    fieldCustomerRetention: "Customer retention (%) — optional",
    fieldEffectiveAmountEur: "Effective amount (€)",
    fieldExternalInvoiceNumber: "External invoice no. (eDSP)",
    fieldInvoiceDate: "Invoice date",
    fieldInvoicedEur: "Invoiced (€)",
    fieldNotes: "Notes",
    fieldPlate: "Plate",
    fieldQuoteEur: "Quote (€)",
    fieldReceivingCompany: "Receiving company (optional)",
    fieldResponsibleCompany: "Responsible company",
    fieldSelectVehicle: "Select the customer's vehicle",
    fieldServiceType: "Service type",
    fieldTechnician: "Technician",
    fieldVin: "VIN",
    lineNotCreated: "(not created)",
    loading: "loading…",
    next: "Next →",
    noLineHint: "You can add lines at any time in the dossier details.",
    optionAuto: "auto",
    optionBaseInvoiced: "invoiced",
    optionBaseQuote: "quote",
    optionNoVehicleLink: "— no link (enter plate/VIN below) —",
    optionNone: "— none —",
    optionSelect: "— select —",
    optionSelectCustomerFirst: "select a customer first",
    optionServiceDsp: "DSP (paintless dent repair)",
    optionServiceDspShort: "DSP",
    optionServiceMontage: "Assembly/Disassembly",
    overrideNotice:
      "Effective amounts will be calculated by the backend (suggested = pct × base) and recorded as an override only if you enter a different amount. An override requires the admin role + a reason.",
    placeholderAutoCalculated: "auto (calculated)",
    placeholderAutoFromContract: "auto (from record/contract)",
    placeholderAutoFromRecord: "auto (from record)",
    placeholderExternalInvoiceNumber: "optional · e.g. F-2026-0042",
    placeholderOptional: "optional",
    placeholderPlate: "e.g. AB-123-CD",
    rowBillingCompany: "Billing company",
    rowCustomerRetention: "Customer retention %",
    rowDate: "Date",
    rowExternalInvoiceNumber: "External invoice no.",
    rowInvoiced: "Invoiced",
    rowQuote: "Quote",
    rowReceivingCompany: "Receiving company",
    rowTechnicianCommission: "Technician commission",
    rowType: "Type",
    saveDossier: "Save dossier",
    saving: "Saving…",
    sectionVehicle: "Vehicle",
    stepFirstLine: "First service line",
    stepHeader: "Header",
    stepLabelPre: "Step",
    stepLabelSuf: "of 3",
    stepReviewAndSave: "Review and save",
    stepperLine: "1st line",
    stepperReview: "Review",
    title: "New dossier",
    vehicleManualHint: "Or enter the plate/VIN manually (no record). At least one is required.",
  },
  dossiers: {
    actIssue: "Issue invoice",
    actLaunch: "Assign technician",
    actOpen: "Open",
    actPayout: "Pay out",
    actReceipt: "Record receipt",
    analyzing: "Analyzing…",
    applying: "Applying…",
    assignBtn: "Assign",
    assignTechBtn: "Assign technician",
    assignTechHintBold: "all",
    assignTechHintPre: "Applies to",
    assignTechHintSuf: "the service_lines of each selected dossier.",
    assignTechModalTitlePre: "Assign technician to",
    assignTechReasonPlaceholder: "e.g. portfolio reassignment",
    assignTechTitle:
      "Assigns (or replaces) the technician in all service_lines of the selected dossiers",
    badgeApproved: "approved",
    badgeCancelled: "cancelled",
    badgeClientPre: "Client",
    badgeDraft: "draft",
    badgeInvoicePaid: "received",
    badgeIssued: "issued",
    badgePaid: "paid",
    badgePartial: "partial",
    badgePending: "pending",
    badgeReceived: "received",
    badgeRejected: "rejected",
    badgeTechPre: "Tech",
    bulkGroupClient: "Client invoice",
    bulkGroupDocs: "Documents",
    bulkGroupEdit: "Edit",
    bulkGroupExport: "Export",
    bulkGroupTech: "Technician pay",
    bulkSelectedWord: "selected",
    bulkSelectedWordPlural: "selected",
    cancelBtn: "Cancel",
    cancelReasonPlaceholder: "e.g. batch issuing error",
    cancelStatusConfirmLabel: "Cancel status",
    cancelStatusMessage:
      "Cancels the customer invoice status. Different from deleting — the dossier stays in the list. Reversible.",
    cancelStatusTitle: "Marks the selected dossiers as 'Cancelled' (invoice status)",
    cardDevisSub: "waiting for a technician",
    cardInRepairSub: "technician at work",
    cardInvoicedPartial: "invoiced",
    cardInvoicedSuf: "excl. VAT invoiced, to collect",
    cardToInvoiceSuf: "excl. VAT to invoice",
    chipAll: "All",
    chipInRepair: "In repair",
    chipInvoiced: "Invoiced",
    chipNoTech: "No technician",
    chipReceived: "Received",
    chipRepaired: "Repaired, to invoice",
    chipToExecute: "To do",
    clearFilters: "Clear filters",
    clearFiltersTitle: "Clear all filters",
    close: "Close",
    colAction: "Action",
    colActions: "Actions",
    colBenefice: "Profit",
    colComm: "Comm.",
    colCommTitle: "Commission split: Technician / Intermediary / Euro Storm",
    colCustomer: "Customer",
    colDateDossier: "Date / file",
    colDevis: "Quote",
    colEncaisse: "Collection",
    colEncaisseTitle: "Customer collection: customer invoice status",
    colFactTec: "Tech. inv.",
    colFactTecTitle: "Status of the technician invoice document",
    colFacture: "Invoiced",
    colInvoiceNumber: "Invoice no.",
    colMake: "Make",
    colModel: "Model",
    colNumFactTec: "Tech. inv. no.",
    colNumFactTecTitle: "Technician invoice number",
    colPagTec: "Tech. pay.",
    colPagTecTitle: "Status of the payment to the technician",
    colPj: "Att.",
    colPjTitle: "Attachment (PJ): document or receipt",
    colPlate: "Plate",
    colRepartition: "Split",
    colStatut: "Situation",
    colTechnician: "Technician",
    colValeurs: "Amounts",
    colVehicule: "Vehicle",
    columnsBtn: "Columns",
    commHintFormula: "100 − customer − technician − intermediary",
    commHintMid: "(F8). Legacy lines are skipped.",
    commHintPre: "Applies only to service_lines with model",
    commHintResidual: "is recalculated as the residual",
    commHintSuf: "Leave blank whatever you don't want to change.",
    commissionReasonPlaceholder: "e.g. adjusting the technician's default %",
    companyLabel: "Company",
    confirmMarkReceivedPre: "Mark",
    confirmMarkReceivedSuf:
      "dossier(s) as Received? The customer_invoice (issued) will automatically become paid.",
    confirmRevertIssuedPre: "Revert",
    confirmRevertIssuedSuf: "dossier(s) to Issued (out of Received)?",
    confirmTechPaidPre: "Mark TECHNICIAN payment as paid on",
    confirmTechPaidSuf:
      "selected dossier(s)? The Tech badge becomes “paid” and they leave the “Technicians to pay” KPI. This is a status marker — no money payment record is created.",
    confirmTechPendingPre: "Set TECHNICIAN payment back to pending on",
    confirmTechPendingSuf: "selected dossier(s)?",
    confirmTitle: "Confirm",
    csvBenefice: "Profit",
    csvCode: "Code",
    csvCustomer: "Customer",
    csvDate: "Date",
    csvDevis: "Quote",
    csvFacturado: "Invoiced",
    csvInvoiceNumber: "Invoice No.",
    csvInvoiceStatus: "Invoice status",
    csvMake: "Make",
    csvModel: "Model",
    csvPlate: "Plate",
    csvTechInvoiceNumber: "Tech. Inv. No.",
    csvTechInvoiceStatus: "Tech. Inv. Status",
    csvTechnician: "Technician",
    customerLabel: "Customer",
    dateFromTitle: "Start date",
    dateKindCreated: "Dossier creation date (no quote or invoice)",
    dateKindDevis: "Quote date (not invoiced yet)",
    dateKindInvoice: "Invoice date",
    dateKindRepaired: "Repair date (PDR finished; not invoiced yet)",
    dateLabel: "Date",
    dateToTitle: "End date",
    deleteBtn: "delete",
    deleteConfirmLabel: "Delete",
    deleteDossierMessage:
      "Soft delete. Reversible via 'restore'. Reason required for the audit log.",
    deleteDossierTitlePre: "Delete dossier",
    deleteReasonPlaceholder: "e.g. created by mistake",
    devisToExecuteBannerSuf:
      "quotes to execute — waiting for a technician to take them on the portal.",
    devisToExecuteBannerSufSingular:
      "quote to execute — waiting for a technician to take it on the portal.",
    doneLabel: "Done",
    emptyState: "No car found.",
    errorTitle: "Error",
    exportCsvBtn: "Export CSV",
    faturadoLabel: "Invoiced",
    filterBtn: "Filter",
    filterTechPayTitle: "Payment to the technician/intermediary (PAG. TEC column)",
    filterTechnicianTitle: "Filter by technician (via service_lines)",
    filtersActivePre: "Active filters",
    filtersBtn: "Filters",
    generateProformaBtn: "Generate proforma",
    generateProformaTitle:
      "Creates a proforma with the selected dossiers — all from the same technician",
    generating: "Generating…",
    includeDeleted: "Include deleted",
    invoiceFromTitle: "Minimum invoice no. (e.g. F-2025-0045)",
    invoiceRangeLabel: "Invoice no. range",
    invoiceStatusLabel: "Invoice status",
    invoiceToTitle: "Maximum invoice no. (e.g. F-2025-0089)",
    issueInvoiceBtn: "Issue invoice",
    issueInvoiceTitle: "Review and issue 1 invoice covering the selected services (same customer)",
    kpiAReceber: "Receivable from customer",
    kpiAllPaid: "all paid",
    kpiAvoirsWord: "credit notes",
    kpiCardToggleTitle: "Quick filter — click to toggle",
    kpiClickToFilter: "click to filter",
    kpiCommissionsNotComputed: "commissions not computed",
    kpiDossiers: "Dossiers",
    kpiEurostormShare: "Euro Storm total share",
    kpiFaturadoMinusCommissions: "Invoiced − commissions",
    kpiFilterAppliedClickRemove: "filter applied — click to remove",
    kpiGrossWord: "gross",
    kpiIssuedPending: "issued invoices pending",
    kpiLucroBruto: "Gross profit",
    kpiLucroPrevisto: "Expected profit",
    kpiPctOfDevisSuf: "of total quotes",
    kpiPctOfFactureSuf: "of invoiced",
    kpiScopeFiltered: "Filtered",
    kpiScopeGeneral: "Overall",
    kpiTechniciansToPay: "Technicians to pay",
    kpiTotalDevis: "Total quotes",
    kpiTotalFacture: "Total invoiced",
    kpisCollapse: "Compact",
    kpisExpand: "Details",
    linesWord: "lines",
    loading: "Loading…",
    markReceivedBtn: "Mark as Received",
    markReceivedTitle: "Marks the selected dossiers as 'Received' (paid)",
    markTechPaidBtn: "Tech paid",
    markTechPaidTitle:
      "Marks technician payment as PAID on all lines of the selected dossiers (same signal as the Tech badge and the Technicians-to-pay KPI)",
    menuAttach: "Attach a document",
    menuDeleteHint: "cancels the invoice",
    menuHistory: "View history",
    menuModify: "Edit",
    menuRestoreHint: "reactivates the invoice",
    montageOtherLabel: "Assembly (other technician)",
    newDossierBtn: "New car",
    nextPage: "Next",
    noCompanyAccess: "You don't have access to any company.",
    okBtn: "OK",
    onlySelectedActive: "Showing only selected",
    onlySelectedIdle: "Show only selected",
    onlySelectedTitle: "Filters the table to show only the checked dossiers",
    openBtn: "open",
    optAllCustomers: "All customers",
    optAllInvoiceStatus: "All invoice statuses",
    optAllProformas: "All",
    optAllTechPay: "All tech. payments",
    optAllTechnicians: "All technicians",
    optCancelled: "Cancelled",
    optChooseTechnician: "— choose a technician —",
    optIssued: "Issued",
    optPending: "Pending",
    optReceived: "Received",
    optTechPayPaid: "Tech. pay: paid",
    optTechPayPending: "Tech. pay: pending",
    optWithoutTechnician: "Without technician",
    pageOf: "of",
    pageWord: "Page",
    paidTechnicianLabel: "Paid to technician",
    pctCustomer: "% Customer",
    pctCustomerPlaceholder: "e.g. 30",
    pctIntermediary: "% Intermediary",
    pctIntermediaryPlaceholder: "e.g. 10",
    pctTechnician: "% Technician",
    pctTechnicianPlaceholder: "e.g. 40",
    periodLabel: "Period (invoice date)",
    pjNotImplementedTitle: "Attachment not implemented yet (PJ)",
    prevPage: "Previous",
    previewNotApplied: "Preview (not applied)",
    proformaFilterLabel: "Euro Storm proforma",
    proformaFilterTitle: "Only this proforma's mirror vehicles (one invoice per proforma).",
    proformaOptSuffix: "to invoice",
    promoteAndMorePre: "plus",
    promoteApplyingV3: "applying V3.",
    promoteBrokenCode: "complementary with invoiced=quote",
    promoteBrokenDesc:
      "— bug in the old eDSP importer (it didn't apply the customer retention). Only changes if the customer has",
    promoteBtnPre: "Promote",
    promoteBullet1: "How many lines will be promoted",
    promoteBullet2: "How many will be skipped (and for what reason)",
    promoteBullet3: "How many will fail (e.g. sum > 100% due to inconsistent defaults)",
    promoteErrorsDuringCalc: "error(s) during the calculation",
    promoteErrorsLogged: "error(s) logged in the audit log",
    promoteIntro: "Applies the defaults from the technician and customer records in 3 scenarios:",
    promoteLinesWord: "Lines",
    promotePromoted: "Promoted",
    promoteRecommendedLabel: "Recommended:",
    promoteRecommendedPre: "first run the",
    promoteRecommendedSuf: "(changes nothing) to see:",
    promoteRemainedLegacy: "Remained legacy",
    promoteSeeReasonsPre: "See reasons for the",
    promoteSeeReasonsSuf: "skipped",
    promoteStaleCode: "technician=0% (even with intermediary)",
    promoteStaleDesc: "— import with outdated pair; already-paid lines excluded",
    promoteToWord: "promotes to",
    promoteTotalLegacy: "Legacy total",
    promoteTotalLegacyWas: "Total legacy was",
    promoteWarnPre:
      "Before the real run, make sure every technician×customer pair is linked in Technicians → Commissions per customer and that customers have",
    promoteWarnSuf: "filled in.",
    promoteWillPromote: "Will promote",
    promoteWillSkip: "Will skip",
    promoting: "Promoting…",
    rangeFromPlaceholder: "from",
    rangeToPlaceholder: "to",
    reasonOptionalLabel: "Reason (optional)",
    recalcCommissionsBtn: "Recalculate commissions",
    recalcCommissionsTitle:
      "Recalculates the commission in 3 scenarios (legacy → complementary; complementary stale; invoiced=quote).",
    reportBtn: "Generate report",
    reportBtnTitle:
      "Generates a PDF of the checked dossiers with the totals (invoiced / paid to technician)",
    reportErrorTitle: "Error generating the report",
    residualWord: "residual",
    restoreBtn: "restore",
    revertIssuedBtn: "Issued",
    revertIssuedTitle: "Reverts to 'Issued' (in case the payment was reversed)",
    revertTechPendingBtn: "Tech pending",
    revertTechPendingTitle:
      "Undo: sets technician payment back to PENDING on the selected dossiers",
    runDryRunBtn: "Run preview (dry run)",
    searchLabel: "Search",
    searchPlaceholder: "Invoice no. / code / plate / VIN…",
    selectPageTitle: "Select current page",
    sitCancelled: "Invoice cancelled",
    sitDeleted: "Deleted",
    sitDevisWaiting: "Quote · waiting for a technician",
    sitInRepair: "In repair",
    sitInvoiced: "Invoiced",
    sitNoTech: "⚠ no technician",
    sitPartial: "Invoiced · partly received",
    sitPayoutMissingPre: "Still to pay out:",
    sitPayoutPending: "technician payout pending",
    sitPayoutTbd: "to compute",
    sitReceived: "Received",
    sitRepairedToInvoice: "Repaired · to invoice",
    sitTechPaid: "technician paid",
    sortActivity: "List date (invoice, repair or quote)",
    sortAsc: "Ascending",
    sortAscTitle: "Ascending — click for descending",
    sortByLabel: "Sort by",
    sortByTitlePre: "Sort by",
    sortDesc: "Descending",
    sortDescTitle: "Descending — click for ascending",
    sortFieldTitle: "Sort field",
    statDevis: "Quotes",
    statDossiersWord: "dossiers",
    statFiltered: "filtered",
    statGross: "Gross profit",
    statInvoiced: "Invoiced",
    statOfDevis: "of the quotes",
    statReceivable: "Receivable",
    statTechPay: "Technicians to pay",
    statTechPayHint: "click to filter",
    statTechPayOn: "filter on",
    statTechPayTitle: "Click to filter dossiers with pending payout",
    sumLabel: "Customer+technician+intermediary sum =",
    sumTooHigh: "sum > 100%, impossible.",
    techPartAwaiting: "awaiting customer",
    techPartMissing: "remaining",
    techPartPaid: "paid",
    techPartPaidBefore: "paid before the customer",
    techPartReleased: "released",
    techPartToReceive: "to receive",
    techPayLabel: "Tech. payment",
    technicianLabel: "Technician",
    title: "Cars",
    toastCommissionUpdatedPre: "Commission updated in",
    toastSkippedNoComplementaryReason: "no complementary lines or sum > 100",
    toastSkippedSameStatusReason: "status was already the same or invalid",
    toastSkippedWord: "skipped",
    toastSkippedWordPlural: "skipped",
    toastStatusUpdatedPre: "Status updated in",
    toastTechAssignedPre: "Technician assigned in",
    updateBtn: "Update",
    updateCommissionBtn: "Update commission",
    updateCommissionModalTitlePre: "Update commission in",
    updateCommissionTitle:
      "Updates the customer/technician/intermediary % in complementary service_lines",
    valDevisShort: "Quote",
    valFactShort: "Inv.",
    vehicleDossiersHint: "This vehicle's dossiers: open the vehicle record",
    viewCompact: "Compact view",
    withoutTechBannerSuf: "without an assigned technician — please review.",
  },
  emailOutbox: {
    allKinds: "All types",
    allStatus: "Sent and failed",
    asUserPre: "as",
    attachmentsPre: "Attachments:",
    backfillHint: "history (imported from the audit log, no attachment details)",
    ccPre: "Cc:",
    colBy: "Sent by",
    colKind: "Type",
    colRef: "Reference",
    colStatus: "Status",
    colSubject: "Subject",
    colTo: "Recipient",
    colWhen: "When",
    companyLabel: "Company:",
    customMessagePre: "Message:",
    emptyState: "No e-mail found.",
    errorPre: "Error:",
    filterCompany: "Company",
    filterKind: "Type",
    filterSearch: "Search",
    filterStatus: "Status",
    kindBankStatement: "Statement to accountant",
    kindCreditNote: "Credit note",
    kindCustomerInvoice: "Invoice",
    kindInvoiceReminder: "Invoice reminder",
    kindOther: "Other",
    kindPasswordReset: "Password reset",
    kindProforma: "Proforma",
    kindTechnicianApplication: "Technician approval",
    kindUserInvite: "User invite",
    kindWorklog: "Worklog (week)",
    loading: "Loading…",
    nextBtn: "Next →",
    notAdmin: "You are not an administrator of any company.",
    of: "of",
    openDossier: "Open dossier",
    openProforma: "Open proforma",
    page: "Page",
    prevBtn: "← Previous",
    searchPh: "Search recipient, subject, invoice/proforma no.…",
    statusFailed: "Failed",
    statusSent: "Sent",
    subtitle: "Every e-mail sent by Gestion: invoices, proformas, worklogs, statements, invites.",
    title: "Outbox",
  },
  erpShell: {
    backToPortal: "Back to the site portal",
    impersonatingBy: "by",
    impersonatingExit: "Exit view",
    impersonatingPre: "Viewing as",
    navAgenda: "Agenda",
    navBankAccounts: "Bank accounts",
    navCaGap: "Revenue gap",
    navChantiers: "Sites",
    navDevis: "Quotes",
    navEmailOutbox: "Outbox",
    navIntermediaries: "Intermediaries",
    navParcGrele: "Parc Grêle",
    notifAmendedSub: "The estimate changed after issue (same number)",
    notifAmendedSuffix: "amended invoices — re-send to customer",
    notifDossiersCommissionsSuffix: "dossiers — commissions",
    notifEmpty: "Nothing pending",
    notifNoticeTitle: "Office notice",
    notifOverdueInvoices: "Overdue invoices",
    notifOverdueSuffix: "overdue",
    notifSupplierInvoicesSuffix: "supplier invoices",
    notifToPaySuffix: "to pay",
    notifUnreconciledSuffix: "unreconciled transactions",
    pinTitle: "Pin: all searches filter on this item",
    unpinTitle: "Unpin — back to general searches",
    wsFin: "Finance",
    wsOps: "Operations",
  },
  financeApp: {
    loading: "loading…",
  },
  financeClosing: {
    by: "by",
    closingBalanceByAccount: "Closing balance by account (cumulative)",
    colClosingBalance: "Closing balance",
    colInflows: "Inflows",
    colMonth: "Month",
    colOutflows: "Outflows",
    colResult: "Result",
    consolidatedSummary: "Consolidated summary",
    edit: "Edit",
    emptyHint: "Classify/allocate entries to see the closing.",
    emptyTitle: "No classified entries yet.",
    footnote:
      "Inflows/Outflows = external movement of the month (internal transfers between accounts are excluded from the gross). Closing balance = cumulative (carried over from one month to the next). Reflects what is recorded in the app.",
    loading: "Loading…",
    monthApr: "apr",
    monthAug: "aug",
    monthDec: "dec",
    monthFeb: "feb",
    monthJan: "jan",
    monthJul: "jul",
    monthJun: "jun",
    monthMar: "mar",
    monthMay: "may",
    monthMovementByAccount: "Month movement by account",
    monthNov: "nov",
    monthOct: "oct",
    monthSep: "sep",
    openingBalances: "Opening balances",
    range12Months: "12 months",
    range3Months: "3 months",
    range6Months: "6 months",
    rangeAll: "All",
    title: "Monthly closing",
    updatedOn: "updated on",
  },
  financeEntries: {
    accountLabel: "Account",
    addBtn: "Add",
    addDestination: "Add destination",
    addSource: "Add source",
    allocated: "Allocated",
    amountPlaceholder: "amount",
    applyBtn: "Apply",
    autoReconcileBtn: "Auto reconcile",
    bankLabel: "bank",
    bulkOptCompany: "— company —",
    bulkOptIn: "↓ in —",
    bulkOptOut: "↑ out —",
    bulkOptType: "— type —",
    cancel: "Cancel",
    childManagedTitle: "Line managed by the parent entry",
    classifyAs: "Classify as:",
    clearPendingBtn: "Clear pending",
    close: "Close",
    colAccounts: "Accounts",
    colCompany: "Company",
    colDate: "Date",
    colDescription: "Description",
    colIn: "In",
    colOut: "Out",
    colType: "Type",
    confirmClearPending: "Delete all imported pending entries?",
    confirmDeleteEntry: "Delete this manual entry? This action is permanent.",
    confirmTitle: "Confirm",
    deletePermanentTitle: "Delete (permanent)",
    destinations: "Destinations",
    distExpenseHint:
      "Choose which account each part COMES OUT of (source) — the account is debited and may go negative. The remainder comes out of the company account.",
    distParentAccountTitle:
      "Distribution parent — account managed by the child lines. Use ⚡ to edit.",
    distRevenueHint:
      "Each line credits the destination and debits the company; the remainder stays with the company.",
    distributeBtn: "Distribute",
    distributeExpenseTitle: "Distribute expense",
    distributeRevenueTitle: "Distribute revenue",
    distributeTitle: "Distribute",
    distributionChild: "distribution",
    duplicatesRemoved: "duplicate(s) removed.",
    editing: "editing",
    emptyState: "No entries yet.",
    emptyStateHint: "Import a CSV or add one manually.",
    entriesPlural: "entries",
    entrySingular: "entry",
    entryTotal: "Entry total",
    errMinTwoWords: "Use at least 2 words.",
    exceeds: "(exceeds!)",
    fieldIn: "↓ In (account · amount)",
    fieldOut: "↑ Out (account · amount)",
    filterAllAccounts: "All accounts",
    filterAllCompanies: "All companies",
    filterAllTypes: "All types",
    finalBalance: "Final balance",
    inMonth: "in",
    loading: "Loading…",
    monthLabel: "Month",
    newBtn: "New",
    newEntryTitle: "New entry",
    noRulesYet: "No rules yet.",
    optAccountPlaceholder: "— account —",
    reconciledByRule: "by rule",
    reconciledToCompanyAccount: "on the company account.",
    reconciling: "Reconciling…",
    redistributeTitle: "Redistribute",
    removeDuplicatesBtn: "Remove duplicates",
    residualFrom: "Remainder comes from →",
    residualTo: "Remainder →",
    residualZeroTitle: "Remainder is zero — reduce an already allocated amount to free up space",
    ruleActive: "active",
    ruleInactive: "inactive",
    rulesBtn: "Rules",
    rulesDescription:
      'If the description contains the pattern, the entry is reconciled to the account (an out debits the account; an in credits it). Applied on import and via the "Auto reconcile" button. Pattern: min. 2 words.',
    rulesPatternLabel: "Pattern (≥ 2 words)",
    rulesPatternPlaceholder: "e.g. Milton Vieira",
    rulesTitle: "Automatic reconciliation rules",
    save: "Save",
    saveChanges: "Save changes",
    searchPlaceholder: "Search description…",
    selectedCount: "selected",
    sources: "Sources (which account it comes from)",
    toDistribute: "to distribute",
    toReconcile: "to reconcile",
    unreconcileTitle: "Unreconcile — returns the entry to pending (does not delete)",
    warnAddAtLeastOneLine: "Add at least one line with an amount.",
    warnAllocatedExceeds: "The allocated amount exceeds the entry.",
    warnFillDateAndDescription: "Fill in the date and description.",
    warnSymmetricTransfer: "Symmetric transfer: In and Out must be equal.",
    warningTitle: "Warning",
  },
  financeImport: {
    accountLabel: "account",
    andMorePre: "… and",
    andMoreSuf: "more transactions",
    bankLabel: "bank",
    cancel: "Cancel",
    colAmount: "Amount",
    colDate: "Date",
    colDescription: "Description",
    colStatus: "Status",
    companyGeneral: "General",
    confirmImportBtn: "✓ Confirm import",
    dropzoneEncoding: "ISO-8859-1 / UTF-8 encoding detected automatically",
    dropzoneFormats: "CSV exported from the bank · Société Générale and other formats",
    dropzoneHint: "Drag the file here or click to select",
    dropzoneTitle: "Upload CSV statement",
    duplicatesSkipped: "duplicates skipped",
    entriesImported: "entries imported",
    headerLineLabel: "header line",
    importing: "Importing…",
    newEntryBtn: "+ New entry",
    orAddManually: "Or add manually:",
    parsingFile: "Parsing file…",
    previewTitle: "Import preview (first 30)",
    separatorLabel: "separator",
    statementCompanyLabel: "Statement company:",
    statusPending: "Pending",
    transactionsDetected: "transactions detected",
  },
  financeKpis: {
    addBtn: "+ Add",
    balancesInMonth: "Balances for month",
    cancel: "Cancel",
    cardBalanceLandione: "Landione balance",
    cardBalanceNeto: "Neto balance",
    cardExpensesForecast: "Forecast expenses",
    cardExpensesPaid: "Expenses paid",
    cardForecastBalance: "Forecast balance",
    cardForecastBalanceLandione: "Forecast balance Landione",
    cardForecastBalanceNeto: "Forecast balance Neto",
    cardInflows: "Inflows",
    cardOperatingCash: "Operating cash",
    cardOutflows: "Outflows",
    cardResult: "Result",
    closingOf: "closing of",
    colTotal: "Total",
    fixedCostsEmpty: "No fixed cost registered. Add monthly taxes, accounting, etc.",
    fixedCostsTitle: "Monthly fixed costs",
    formTitle: "Monthly fixed cost",
    labelAmount: "Amount (€)",
    labelCategory: "Category",
    labelCompany: "Company",
    labelDescription: "Description",
    labelExpenses: "Expenses",
    labelRevenue: "Revenue",
    loading: "Loading…",
    monthApr: "apr",
    monthAug: "aug",
    monthDec: "dec",
    monthFeb: "feb",
    monthJan: "jan",
    monthJul: "jul",
    monthJun: "jun",
    monthMar: "mar",
    monthMay: "may",
    monthNov: "nov",
    monthOct: "oct",
    monthSep: "sep",
    negativeCashAlertPre: "⚠️ Operating cash (Expenses) negative:",
    negativeCashAlertSuf: "— distributions/spending exceed the inflows.",
    optionAdministrative: "Administrative",
    optionGeneral: "General",
    optionOperational: "Operational cost",
    optionOther: "Other",
    optionTax: "Tax / duty",
    perMonthSuffix: "/month",
    period12m: "12m",
    period3m: "3m",
    period6m: "6m",
    periodAll: "All",
    periodCurrentMonth: "Current month",
    placeholderDescription: "E.g. Accounting",
    rowCompanyAccountBalance: "Company account balance",
    rowCompanyExpenses: "(-) Company expenses",
    rowGrossRevenue: "Gross revenue",
    rowOperationalCosts: "(-) Operational costs",
    save: "Save",
    sectionBreakdown: "Consolidated breakdown",
    sectionPartners: "Partners",
    sectionPeriodMovement: "Period movements",
    subAfterForecastExpenses: "after forecast expenses",
    subExpensesAccount: "Expenses account",
    subFixedPlusFuture: "fixed + registered future items",
    subInflowsMinusOutflows: "inflows − outflows",
    subPaidToDate: "paid to date",
    subReceivedInPeriod: "received in the period",
    subShare: "share",
    subSpentInPeriod: "spent in the period",
    toggleByCompany: "view by company ▾",
    toggleHide: "hide ▴",
  },
  financeLayout: {
    accountExpenses: "Expenses",
    accountPayTechnician: "Technician payable",
    backToErp: "← ERP",
    monthApr: "apr",
    monthAug: "aug",
    monthDec: "dec",
    monthFeb: "feb",
    monthJan: "jan",
    monthJul: "jul",
    monthJun: "jun",
    monthMar: "mar",
    monthMay: "may",
    monthNov: "nov",
    monthOct: "oct",
    monthSep: "sep",
    parameters: "Parameters",
    rowClassified: "Classified",
    rowPending: "Pending",
    sumBanks: "Σ = banks",
    summary: "Summary",
    tabClosing: "Closing",
    tabEntries: "Entries",
    tabImport: "Import",
    tabKpis: "KPIs",
    totalCash: "Total cash",
    virtualAccounts: "Virtual accounts",
  },
  financeOpeningBalances: {
    cancel: "Cancel",
    close: "Close",
    confirmSave: "Confirm changing the opening balances? The change is logged (who/when).",
    save: "Save",
    saving: "Saving…",
    subtitle:
      "Balance of each account before the 1st entry in the app. Added to the base of all calculations (sidebar and closing).",
    title: "Opening balances",
    yesSave: "Yes, save",
  },
  fiscal: {
    accountingCashLabel: "Accounting cash position",
    accountingCashTooltip: "Cash balance from the last entry with a filled balance sheet",
    accountsSuf: "account(s)",
    actualCumulative: "Actual cumulative",
    aggregateLabel: "Aggregate",
    alertDsoHighPre: "High customer collection delay",
    alertDsoHighSuf: "alert if > 60 days.",
    alertGapNarrowPre: "Narrow break-even gap",
    alertGapNarrowSuf: "alert if < 10%.",
    alertLowMarginPre: "Low overall margin rate",
    alertLowMarginSuf: "alert if < 15%.",
    alertNegativeCashPre: "Negative net cash",
    alertPersonnelHighPre: "High personnel costs",
    alertPersonnelHighSuf: "alert if > 35%.",
    annualized: "Annualized",
    balanceSheetPre: "Balance sheet",
    bankBalanceEmptyTooltip: "No bank_transaction in the selected fiscal year range",
    bankBalanceLabel: "Current bank balance",
    bankBalanceTooltip:
      "Σ opening_balance of active accounts + Σ amount of bank_transactions in the FY range",
    breakEvenLabel: "Break-even point",
    breakEvenTooltip: "Minimum revenue to cover fixed costs (economic) and cash flow (financial)",
    caHtLabel: "Revenue excl. VAT",
    caLabel: "Revenue",
    caTooltip: "Sum of customer_invoices issued+paid in the fiscal year",
    cafLabel: "CAF",
    cafTooltip: "Self-financing capacity = net result + depreciation",
    closedBadge: "Closed — recompute unavailable",
    closedForecastNote:
      "Fiscal year closed — actual data available. The projection is not computed for a closed fiscal year.",
    closedRecomputeTitle: "Fiscal year closed — reopen the fiscal year to recompute",
    commercialConvention: "Commercial convention (month = 30 days)",
    computationPre: "Computed",
    computedAtPre: "Computed on",
    contextTitle: "Fiscal year context",
    corporateTaxLabel: "Corporate income tax",
    corporateTaxTooltip: "Corporate tax recorded in fiscal_month_entries (cumulative)",
    dpoLabel: "Supplier delay (DPO)",
    dpoTooltip: "(Supplier payables / consumed purchases) × nb_jours_exercice",
    dsoLabel: "Customer delay (DSO)",
    dsoTooltip: "(Customer receivables / revenue excl. VAT) × nb_jours_exercice",
    ebeLabel: "EBE",
    ebeTooltip: "Gross operating surplus = VA − taxes − personnel costs",
    exercisePre: "Fiscal year",
    externalChargesLabel: "External charges (total)",
    externalChargesTooltip: "Σ supplies + rentals + premiums + intermediaries + travel + bank fees",
    financialLabel: "Financial",
    forecastEmptySubtitle: "No projection generated yet. Click to estimate the closing.",
    forecastTitle: "Closing Projection",
    fyStatusLabel: "FY status",
    generateForecastBtn: "Generate projection",
    generating: "Generating…",
    goToEntries: "Go to Entries",
    grossMarginLabel: "Overall margin",
    grossMarginTooltip: "Revenue − consumed purchases",
    monthsElapsedLabel: "Months elapsed",
    monthsElapsedSuf: "months elapsed",
    nbMonthsFyLabel: "No. of FY months",
    netResultLabel: "Net result",
    netResultTooltip: "Operating result − corporate tax",
    noBalanceSheet: "No balance sheet",
    noFiscalYearBody: "No fiscal year is selected.",
    noFiscalYearTitle: "No fiscal year selected",
    noKpisBodyPre: "This fiscal year has no computed KPIs yet. Click",
    noKpisBodySuf: "above to generate them.",
    noKpisTitle: "No KPIs computed",
    noTransactionsImported: "No transactions imported",
    ofCaSuf: "of revenue",
    ofVaSuf: "of value added",
    operatingResultLabel: "Operating result",
    operatingResultTooltip: "EBE − depreciation − other charges + other income",
    otherVarChargesLabel: "Other var. charges",
    pctDuCa: "% of revenue",
    pctOnCa: "% of revenue",
    pctOnRe: "% of operating result",
    pointMortLabel: "Break-even date",
    pointMortTooltip: "Days needed to reach the break-even point",
    purchasesConsumedLabel: "Consumed purchases",
    recomputeBtn: "Recompute KPIs",
    recomputing: "Recomputing…",
    selectCompanyBody: "Choose a company in the selector above to view the fiscal module.",
    selectCompanyTitle: "Select a company",
    subtitle: "KPI Dashboard",
    thresholdGapLabel: "Break-even gap",
    thresholdGapTooltip: "Revenue − threshold. Indicates the safety margin down to break-even",
    toCreateOneSuf: "to create one.",
    txSuf: "tx",
    unavailable: "Unavailable",
    vaLabel: "Value added",
    vaTooltip: "Overall margin − external charges (PRD §3)",
  },
  fiscalBilan: {
    actif: "Actif",
    autresCreances: "Autres créances",
    autresDettes: "Autres dettes",
    bfr: "BFR",
    bilanAsOf: "Bilan",
    bilanNotFilledPre: "No fiscal_month_entry of this FY has balance sheet data filled in. Go to",
    bilanNotFilledSuf:
      "and edit a month filling in the 8 bilan fields (immobilisations, créances, trésorerie, capitaux, dettes…).",
    bilanNotFilledTitle: "Bilan not filled in",
    capitauxPropres: "Capitaux propres",
    creancesClients: "Créances clients",
    dettesFinancieres: "Dettes financières",
    dettesFournisseurs: "Dettes fournisseurs",
    dpo: "Délai fournisseurs (DPO)",
    dso: "Délai clients (DSO)",
    ecartBilanTreso: "Bilan/trésorerie gap",
    emptyValue: "— empty —",
    entriesLabel: "Entries",
    fondsRoulement: "Fonds de roulement (FR)",
    immobilisationsNettes: "Immobilisations nettes",
    mismatchMid: "and Passif",
    mismatchSuf: "do not match — difference",
    noKpisTitle: "No KPIs",
    passif: "Passif",
    runRecompute: "Run recompute from the dashboard.",
    selectCompanyFy: "Select a company + fiscal year.",
    subtitle: "Balance sheet (bilan)",
    tooltipBfr: "Créances clients + autres créances − dettes fournisseurs − autres dettes",
    tooltipDpo: "(Dettes fournisseurs / Achats consommés) × nb_jours_exercice",
    tooltipDso: "(Créances clients / CA HT) × nb_jours_exercice",
    tooltipEcart: "Entry trésorerie − calculated trésorerie nette",
    tooltipFr: "Capitaux propres + dettes financières − immobilisations",
    tooltipTresorerieNette: "FR − BFR",
    totalActif: "Total actif",
    totalPassif: "Total passif",
    tresorerie: "Trésorerie",
    tresorerieEntry: "Trésorerie (entry)",
    tresorerieNette: "Trésorerie nette",
  },
  fiscalBudget: {
    activeBadge: "active",
    activeSuffix: "ACTIVE",
    archiveLabel: "Archive",
    archiveMessage: "Soft delete — frees the name for reuse. Reason required.",
    archivePlaceholder: "e.g. discarded scenario",
    archiveTitlePre: "Archive revision",
    baselinePre: "Baseline:",
    cancel: "cancel",
    cloneLabel: "Clone",
    cloneMessage: "New name (must be unique within the fiscal year).",
    colDeltaVsReal: "Δ vs Actual",
    colEffective: "Effective",
    colRealiseN: "Actual N",
    colRubrique: "Line item",
    colSuggested: "Suggested",
    colVariationPct: "Variation %",
    compareBtn: "Compare",
    createBudgetBtn: "+ Create budget",
    createLabel: "Create",
    creating: "Creating…",
    daysUnit: "d",
    groupAggregate: "Aggregate",
    groupChargesExternes: "External charges",
    groupOtherCharges: "Other charges",
    groupOtherIncome: "Other income",
    identificationTitle: "Identification",
    kpiCaf: "CAF (proj.)",
    kpiEbe: "EBITDA (proj.)",
    kpiMargeGlobale: "Overall margin (proj.)",
    kpiPointMort: "Break-even point (proj.)",
    kpiRn: "Net income (proj.)",
    kpiSeuilEco: "Economic break-even (proj.)",
    kpiSeuilFin: "Financial break-even (proj.)",
    kpiVa: "VA (proj.)",
    lineAchatsConsommes: "Purchases consumed",
    lineAutresChargesExploitation: "Other operating expenses",
    lineAutresChargesVariables: "Other variable costs",
    lineAutresProduitsExploitation: "Other operating income",
    lineCaHt: "Revenue excl. VAT",
    lineChargesPersonnel: "Personnel costs",
    lineDeplacementsReception: "Travel & entertainment",
    lineDotationsAmortissements: "Depreciation charges",
    lineDotationsProvisions: "Provision charges",
    lineFournituresConsommables: "Supplies & consumables",
    lineFraisBancaires: "Bank fees",
    lineImpotSocietes: "Corporate income tax",
    lineImpotsTaxes: "Taxes & duties",
    lineIntermediairesHonoraires: "Intermediaries & fees",
    lineLocationsChargesLocatives: "Rents & rental charges",
    linePrimesAssurance: "Insurance premiums",
    lineSubventionsExploitation: "Operating subsidies",
    newRevisionBtn: "+ New revision",
    newRevisionMessage:
      "Unique name within the fiscal year (e.g. 'optimistic', 'v2-conservative').",
    newRevisionPlaceholder: "e.g. optimistic",
    newRevisionTitle: "New budget revision",
    noBudgetHelp:
      "The backend will automatically resolve the previous fiscal year as the baseline, ensure its KPIs are calculated, and generate suggested/effective values from zero variations (a direct copy of the baseline). You can adjust afterwards.",
    noBudgetSubtitle: "A budget can be created from the previous fiscal year (auto-detection).",
    noBudgetTitle: "No budget for this fiscal year",
    overrideTooltip: "Click to override",
    placeholderExPre: "e.g.",
    realN: "Actual N",
    revisionLabel: "Revision",
    save: "Save",
    saving: "Saving…",
    selectCompanyFy: "Select a company + fiscal year.",
    setActiveBtn: "Set active",
    subtitle: "Budget N+1",
    toastArchived: "Revision archived.",
    toastSaved: "Budget updated.",
    toastSetActive: "Revision set as active.",
    updatedAtPre: "Updated on",
    variationsSubtitle:
      "Variation % = adjustment over the baseline. Override = absolute value that ignores the variation.",
    variationsTitle: "Variations & overrides",
  },
  fiscalBudgetCompare: {
    activeSuffix: "ACTIVE",
    backToBudgets: "Back to budgets",
    colCategory: "Category",
    colKpi: "KPI",
    goToBudgets: "Go to budgets",
    inputsTitle: "Effective inputs",
    kpiCaf: "Cash flow (CAF)",
    kpiEbe: "EBITDA",
    kpiMargeGlobale: "Overall margin",
    kpiPointMort: "Break-even point (days)",
    kpiResultatExploitation: "Operating income",
    kpiResultatNet: "Net income",
    kpiSeuilEconomique: "Economic break-even",
    kpiSeuilFinancier: "Financial break-even",
    kpiValeurAjoutee: "Value added",
    kpisTitle: "Projected KPIs",
    leftLabel: "Left",
    lineAchatsConsommes: "Purchases consumed",
    lineAutresChargesExpl: "Other operating costs",
    lineAutresChargesVariables: "Other variable costs",
    lineAutresProduits: "Other income",
    lineCaHt: "Revenue excl. VAT",
    lineChargesPersonnel: "Personnel costs",
    lineDeplacements: "Travel",
    lineDotationsAmort: "Depreciation",
    lineDotationsProv: "Provisions",
    lineFournitures: "Supplies",
    lineFraisBancaires: "Bank fees",
    lineImpotsTaxes: "Taxes & duties",
    lineIntermediaires: "Intermediaries",
    lineIs: "Corporate tax",
    lineLocations: "Rentals",
    linePrimesAssurance: "Insurance premiums",
    lineSubventions: "Operating grants",
    needTwoRevisionsPre: "At least 2 revisions are required to compare. Currently:",
    rightLabel: "Right",
    selectCompanyYear: "Select a company + fiscal year.",
    subtitle: "Compare budget revisions",
  },
  fiscalEntries: {
    bilanSectionTitle: "Balance sheet (leave empty if not applicable)",
    cancel: "Cancel",
    closeFyBtn: "Close fiscal year",
    closeFyFailPre: "Failed to close fiscal year",
    closeFyModalMsg:
      "All unlocked entries will be locked automatically. Reason required for the audit log.",
    closeFyModalTitle: "Close fiscal year",
    closeFyPlaceholder: "E.g. 2025 accounting close",
    closingFy: "Closing…",
    createEntryTitle: "Create entry",
    createFyBtn: "Create fiscal year",
    creatingFy: "Creating…",
    daysSuf: "days",
    editEntryTitle: "Edit entry",
    endField: "End",
    errorTitle: "Error",
    fieldAutresChargesExploitation: "Other operating expenses",
    fieldAutresCreances: "Other receivables",
    fieldAutresDettes: "Other liabilities",
    fieldAutresProduitsExploitation: "Other operating income",
    fieldCapitauxPropres: "Equity",
    fieldChargesPersonnel: "Personnel expenses",
    fieldCreancesClients: "Customer receivables",
    fieldDeplacementsReception: "Travel & entertainment",
    fieldDettesFinancieres: "Financial debt",
    fieldDettesFournisseurs: "Supplier payables",
    fieldDotationsAmortissements: "Depreciation charges",
    fieldDotationsProvisions: "Provision charges",
    fieldFournituresConsommables: "Supplies & consumables",
    fieldFraisBancaires: "Bank fees",
    fieldImmobilisationsNettes: "Net fixed assets",
    fieldImpotSocietes: "Corporate income tax",
    fieldImpotsTaxes: "Taxes & duties",
    fieldIntermediairesHonoraires: "Intermediaries & fees",
    fieldLocationsChargesLocatives: "Rent & rental charges",
    fieldPrimesAssurance: "Insurance premiums",
    fieldRecettesATrier: "Inflows to sort (incl. VAT)",
    fieldRecettesEncaisseesHt: "Cash receipts (excl. VAT)",
    fieldSubventionsExploitation: "Operating subsidies",
    fieldTresorerie: "Treasury",
    fieldTvaCollecteeEncaissements: "VAT collected (on receipts)",
    fiscalYearPre: "Fiscal year",
    groupChargesExternes: "External expenses",
    groupOutrasCargas: "Other expenses",
    groupOutrosProdutos: "Other income",
    groupRecettes: "Receipts (cash)",
    invalidValuePre: "Invalid value in",
    labelField: "Label",
    lockEntryMsg: "Reason (optional). Locking prevents editing until an admin unlocks it.",
    lockEntryPlaceholder: "E.g. monthly close validated",
    lockEntryTitle: "Lock entry",
    lockFailPre: "Failed to lock",
    monthsSuf: "months",
    newFyBtn: "+ New fiscal year",
    newFyModalTitle: "New fiscal year",
    reopenConfirm: "Reopen",
    reopenFyBtn: "Reopen fiscal year",
    reopenFyFailPre: "Failed to reopen fiscal year",
    reopenFyModalMsg:
      "Status goes back to 'open'. Entries remain locked (use individual unlock when needed).",
    reopenFyModalTitle: "Reopen fiscal year",
    reopenFyPlaceholder: "E.g. entry correction",
    reopeningFy: "Reopening…",
    save: "Save",
    saving: "Saving…",
    selectCompany: "Select a company.",
    selectFyHint: "Choose an existing fiscal year or create a new one with the button above.",
    selectFyTitle: "Select a fiscal year",
    startField: "Start",
    subtitle: "Monthly entries",
    syncATrierPre: "⚠ inflows to sort",
    syncBtn: "↻ Sync from bank (costs + receipts)",
    syncBtnTitle:
      "Fills the monthly cost boxes (rent, insurance, payroll, fees, supplies, taxes, duties) from the statement + purchase invoices. Does not touch depreciation/corporate tax/balance sheet or closed months.",
    syncFailPre: "Failed to sync costs",
    syncMonthsSkippedSuf: "skipped (closed)",
    syncMonthsUpdatedSuf: "month(s) filled from the statement (bank) + purchase invoices",
    syncRecettesPre: "cash receipts (excl. VAT)",
    syncRecomputeHint: 'Now run "↻ Recompute KPIs" on the fiscal dashboard to update profit/SIG.',
    syncSuccessTitle: "Synced from bank",
    syncingBtn: "Syncing…",
    unlockEntryMsg: "Admin only. Reason required for the audit log.",
    unlockEntryPlaceholder: "E.g. correction requested by the accountant",
    unlockEntryTitle: "Unlock entry",
    unlockFailPre: "Failed to unlock",
  },
  fiscalResultat: {
    cardSubtitleNoBudget: "Actual vs Annualized — no budget created for this FY",
    cardSubtitleWithBudget: "Actual vs Annualized vs Budget N+1",
    cascadeTitle: "Compte de résultat en cascade",
    hintCaf: "RN + dotations amortissements + dotations provisions",
    hintEbe: "VA − impôts/taxes − personnel + subventions",
    hintMargeGlobale: "CA HT − Achats consommés",
    hintValeurAjoutee: "Marge globale − Charges externes",
    noKpisTitle: "No KPIs calculated",
    recomputeKpisBtn: "↻ Recompute KPIs",
    rowAchatsConsommes: "− Achats consommés",
    rowAutresChargesExploitation: "− Autres charges d'exploitation",
    rowAutresChargesVariables: "− Autres charges variables",
    rowAutresProduitsExploitation: "+ Autres produits d'exploitation",
    rowCaHt: "Chiffre d'affaires (CA HT)",
    rowCaf: "= CAF",
    rowChargesExternesTotal: "− Charges externes (total)",
    rowChargesPersonnel: "− Charges de personnel",
    rowDeplacementsReception: "Déplacements & réception",
    rowDotationsAmortissements: "− Dotations amortissements",
    rowDotationsProvisions: "− Dotations provisions",
    rowEbe: "= EBE",
    rowFournituresConsommables: "Fournitures & consommables",
    rowFraisBancaires: "Frais bancaires",
    rowImpotSocietes: "− Impôt sur les sociétés",
    rowImpotsTaxes: "− Impôts & taxes",
    rowIntermediairesHonoraires: "Intermédiaires & honoraires",
    rowLocationsChargesLocatives: "Locations & charges locatives",
    rowMargeGlobale: "= Marge globale",
    rowPrimesAssurance: "Primes d'assurance",
    rowResultatExploitation: "= Résultat d'exploitation",
    rowResultatNet: "= Résultat net",
    rowSubventionsExploitation: "+ Subventions d'exploitation",
    rowValeurAjoutee: "= Valeur ajoutée (VA)",
    runRecomputePre: "Run",
    runRecomputeSuf: "on the dashboard.",
    selectCompanyPrompt: "Select a company + fiscal year at the top.",
    subtitle: "Compte de résultat",
    tresoATrierPre: "Inflows to sort (excluded from result):",
    tresoColCumule: "Cumulative",
    tresoColDepenses: "Expenses",
    tresoColMois: "Month",
    tresoColRecettes: "Receipts excl. VAT",
    tresoColResultat: "Result",
    tresoColTva: "VAT collected",
    tresoEmpty: "No cash data yet — run “Sync from bank” in the Entries tab.",
    tresoNote:
      "Basis: categorized bank statement (cash). Depreciation, provisions and corporate tax are not monthly cash outflows and stay out of this view. VAT collected is informational (not added to the result).",
    tresoSubtitle:
      "Cash receipts (excl. VAT) − categorized bank expenses (synced in the Entries tab)",
    tresoTitle: "Cash result — month by month",
    tresoTotalLabel: "Fiscal year total",
    viewEngagement: "Accrual (invoices)",
    viewTresorerie: "Cash (bank)",
  },
  fiscalSeuil: {
    achatsConsommes: "Purchases consumed",
    autresChargesVar: "Other variable costs",
    breakevenChartSubtitle:
      "Intersection of the Revenue × Total costs curves. Green area = profit.",
    breakevenChartTitle: "Break-even chart",
    caHt: "Revenue (excl. VAT)",
    chargesFixes: "Fixed costs",
    chargesFixesSeuilFin: "Fixed costs (financial break-even)",
    chargesVariables: "Variable costs",
    componentsSubtitle: "Cost structure for the fiscal year",
    componentsTitle: "Break-even components",
    ecartSeuil: "Break-even margin",
    ecartSeuilTooltip: "Revenue − economic break-even",
    margeCv: "Contribution margin",
    noKpisHint: "Run recompute from the dashboard.",
    noKpisTitle: "No KPIs",
    pctOfCa: "% of revenue",
    pointMort: "Break-even date",
    pointMortSubtitle: "Commercial convention (month = 30 days)",
    pointMortTooltip: "Days to reach break-even",
    selectCompanyFy: "Select a company + fiscal year.",
    seuilEconomique: "Economic break-even",
    seuilEconomiqueTooltip: "Fixed costs / contribution margin ratio",
    seuilFinancier: "Financial break-even",
    seuilFinancierSubtitle: "Cash-flow interpretation",
    seuilFinancierTooltip: "(Fixed costs − depreciation + corporate tax − other income) / ratio",
    subtitle: "Break-even point",
    tauxMargeCv: "Contribution margin ratio",
  },
  fiscalShell: {
    moduleLabel: "Tax module",
    navBilan: "Balance sheet",
    navBudget: "Budget N+1",
    navEntries: "Entries",
    navKpis: "KPIs",
    navResultat: "Income statement",
    navSeuil: "Break-even",
    navSig: "SIG",
    navTva: "TVA",
  },
  fiscalSig: {
    achatsSubtitle:
      "Margin = CA − Achats. Achats comes from INTERCOMPANY invoices (BS→ES) + TECHNICIAN invoices — NOT from Suppliers/Achats. Check here for duplicates inflating the cost.",
    achatsTitle: "Achats consommés breakdown",
    achatsTotalLabel: "Achats consommés (total)",
    blockCaFormula: "Σ customer_invoices issued+paid",
    blockCaLabel: "Chiffre d'affaires (CA HT)",
    blockCafFormula: "RN + dotations amortissements + dotations provisions",
    blockCafLabel: "CAF (Capacité d'autofinancement)",
    blockEbeFormula: "VA − impôts/taxes − personnel + subventions",
    blockEbeLabel: "EBE",
    blockMargeFormula: "CA HT − Achats consommés",
    blockMargeLabel: "Marge globale",
    blockRexFormula: "EBE − dotations − autres charges + autres produits",
    blockRexLabel: "Résultat d'exploitation",
    blockRnFormula: "Résultat d'exploitation − IS",
    blockRnLabel: "Résultat net",
    blockVaFormula: "Marge globale − Charges externes",
    blockVaLabel: "Valeur ajoutée (VA)",
    cascadeSubtitle: "Each block applies a deduction/addition on the previous block",
    cascadeTitle: "Cascade SIG",
    colAmount: "Amount",
    colDate: "Date",
    colNumber: "No.",
    colOrigin: "Origin",
    colStatus: "Status",
    emptyState: "No intercompany or technician invoices in the fiscal year.",
    intercompanyLabel: "Intercompany",
    isCardSubtitle:
      "Estimate on cumulative operating result, BEFORE the accountant's tax adjustments (2058-A)",
    isCardTitle: "Estimated corporate tax (15% / 25%)",
    isNoProfit: "No cumulative profit this fiscal year — estimated tax: €0.",
    isRowBase: "Cumulative operating result",
    isRowNet: "Estimated net profit",
    isRowTotal: "Total estimated tax",
    isRowTranche15Pre: "Reduced bracket — up to",
    isRowTranche25Pre: "Standard bracket — above",
    noKpisHintPre: "Run",
    noKpisHintSuf: "in the dashboard.",
    noKpisTitle: "No KPIs",
    recomputeKpisLabel: "↻ Recompute KPIs",
    selectCompanyFy: "Select a company + fiscal year.",
    subtitle: "Soldes intermédiaires de gestion (SIG)",
    technicianLabel: "Technician",
  },
  fiscalTva: {
    colAchatsHt: "Achats HT",
    colCaHt: "CA HT",
    colMonth: "Month",
    colToPayCredit: "To pay / Credit",
    computeBtn: "↻ compute",
    computedAtPre: "Computed on",
    creditSuf: "credit",
    declareConfirm: "Declare (lock)",
    declareMessage:
      "Status changes to 'declared' and numeric fields are locked for editing. DGFiP reference (optional).",
    declarePlaceholder: "E.g. reference returned by impots.gouv.fr",
    declareTitle: "Declare to DGFiP",
    declaredAtPre: "Declared on",
    detailPre: "Detail",
    emptyMonth: "— empty —",
    error: "Error",
    errorGeneratingExport: "Error generating export",
    exportCsvBtn: "📦 Export CSV",
    exportPdfBtn: "📄 Export PDF",
    generateCsvTitle: "Generate ZIP with recettes.csv + depenses.csv",
    generatePdfTitle: "Generate PDF export for the accounting firm",
    labelAchatsHtDeductible: "Achats HT deductible",
    labelCaHtCollected: "CA HT collected",
    labelCreditReportable: "Crédit reportable",
    labelDgfipReference: "DGFiP reference",
    labelPaidAmount: "Amount paid",
    labelTvaAPayer: "TVA à Payer",
    lastPre: "last",
    markPaidBtn: "Mark as paid",
    markPaidConfirm: "Mark as paid",
    markPaidTitle: "Mark as paid to DGFiP",
    monthApril: "April",
    monthAugust: "August",
    monthDecember: "December",
    monthFebruary: "February",
    monthJanuary: "January",
    monthJuly: "July",
    monthJune: "June",
    monthMarch: "March",
    monthMay: "May",
    monthNovember: "November",
    monthOctober: "October",
    monthSeptember: "September",
    overrideAppliedPre: "Override applied on",
    overrideSuf: "override",
    paidAtPre: "Paid on",
    regeneratePre: "Regenerate",
    reopenConfirm: "Reopen",
    reopenMessage: "Admin only. Status returns to 'draft' and editing is unlocked.",
    reopenPlaceholder: "Reason for reopening",
    reopenTitle: "Reopen the TVA declaration",
    selectCompany: "Select a company.",
    status: "Status",
    statusCancelled: "cancelled",
    statusDeclared: "declared",
    statusDraft: "draft",
    statusPaid: "received",
    subAchatsHtDeductible: "Sum of the month's purchase invoices (received/paid)",
    subCaHtCollected: "Customer receipts of the month (cash basis, bank statement)",
    subCreditReportable: "Déductible − Collectée (min. 0)",
    subTvaAPayer: "Collectée − Déductible (min. 0)",
    subtitle: "TVA declarations (monthly CA3)",
    suggestedPre: "Suggested",
    tableSubtitle: "One row per month. Click to open / compute.",
    tvaCollectee: "TVA Collectée",
    tvaDeductible: "TVA Déductible",
    tvaYearLabel: "TVA year",
    yearPre: "Year",
  },
  fiscalYearSelector: {
    companyLabel: "Company",
    fiscalYearLabel: "Fiscal year",
    loadingOption: "Loading…",
    noAccessOption: "— no access —",
    noFiscalYearOption: "— no fiscal year —",
  },
  forecastPanel: {
    colKpi: "KPI",
    colProjection: "Projection",
    colRealN1: "Actual N-1",
    colVariation: "Change",
    computedAt: "Projection computed on",
    factorLabel: "factor",
    isStrategyLabel: "IS strategy:",
    isStrategyLancements: "Booked IS × factor",
    isStrategyNone: "No estimate (RE ≤ 0)",
    isStrategyTaxeFr25: "FR rate 25% on RE",
    linearTrend: "Linear trend",
    monthsActual: "actual months",
    monthsProjected: "projected months",
    recomputeBtn: "Refresh projection",
    recomputing: "Refreshing…",
    rowCaf: "CAF",
    rowChiffreAffaires: "Revenue",
    rowIsEstime: "Estimated IS",
    rowMargeGlobale: "Overall margin",
    rowPointMort: "Break-even point",
    rowResultatNet: "Net income",
    rowTresorerieEstimee: "Estimated treasury",
    title: "Year-end projection",
  },
  hailParcDetail: {
    addBtn: "Add",
    autoPlaceholder: "auto",
    backToParcs: "Parc Grêle",
    cancel: "Cancel",
    cancelInvoiceBtn: "Cancel invoice",
    catPlaceholder: "Cat",
    close: "Close",
    colClient: "Customer",
    colDebosselage: "Débosselage",
    colForfaitName: "Forfait (name)",
    colMontage: "Montage",
    colQty: "Qty",
    colRetained: "Retained ES/BS",
    colTotalHt: "Total excl. tax",
    colUnitPriceHt: "Unit price excl. tax",
    colVehicle: "Vehicle",
    confirmCancelMsgPre: "Cancel",
    confirmCancelMsgSuf: "You will be able to generate a new one.",
    confirmCancelTitle: "Cancel invoice?",
    downloadPdfBtn: "Download PDF",
    downloadTemplate: "Download template (.xlsx)",
    dueLabel: "due",
    emptyVehicles: "No vehicles yet.",
    errChooseForfait: "Choose the forfait.",
    errPdf: "Failed to generate the PDF.",
    errPlateOrVin: "Enter a plate or VIN.",
    errReadFile: "Failed to read the file.",
    errorsCountSuffix: "error(s):",
    forfaitGridHelp:
      "Montage (removal/refitting) is a reserved part of the forfait — it is not added to the price. Retained ES/BS = customer − débosselage − montage. Leave the name empty to skip the row.",
    forfaitGridTitle: "Price grid per vehicle (up to 5 forfaits)",
    generateInvoiceBtn: "Generate invoice",
    generating: "Generating…",
    importBtn: "Import",
    importModalTitle: "Import vehicles",
    importSheetBtn: "Import spreadsheet",
    importedSuffix: "vehicle(s) imported.",
    importing: "Importing…",
    invoiceSectionTitle: "Body shop invoice",
    issuedOnPrefix: "Issued on",
    labelDebosShort: "Débos.",
    labelForfait: "Forfait",
    labelMake: "Make",
    labelModel: "Model",
    labelPlate: "Plate",
    labelVin: "VIN",
    linePrefix: "Line",
    linesReadFrom: "line(s) read from",
    loading: "Loading…",
    missingForfaitSuffix: "without forfait — will be rejected.",
    missingIdSuffix: "without plate or VIN — will be rejected.",
    noForfaitsWarning: "Define the forfait grid before adding vehicles.",
    noInvoiceHint: "No invoice issued. Generate the invoice from the parc vehicles × forfait.",
    removeFromParcTitle: "Remove from parc",
    saveGridBtn: "Save grid",
    saved: "Saved",
    saving: "Saving…",
    skippedSuffix: "were already in the parc (skipped).",
    statToPayDebos: "To pay débos.",
    statToPayMontage: "To pay montage",
    statTotalClient: "Customer total",
    statusClosed: "Closed",
    statusOpen: "Open",
    techOverClient: "débosselage + assembly exceed the customer price — fix before saving.",
    totalTtc: "Total incl. tax",
    tvaReverseChargeNote: "TVA not applicable — reverse charge",
    vehiclesCountSuffix: "vehicles",
    vehiclesTitle: "Vehicles",
  },
  hailParcs: {
    cancel: "Cancel",
    colActions: "Actions",
    colCarrosserie: "Body shop",
    colDate: "Date",
    colName: "Name",
    colStatus: "Status",
    create: "Create",
    createModalTitle: "New hail parc",
    creating: "Creating…",
    customerLabel: "Body shop (customer)",
    emptyState: "No parcs yet. Create the first one.",
    eventDateLabel: "Event date",
    loading: "Loading…",
    nameLabel: "Worksite name",
    namePlaceholder: "E.g. Grêle Montpellier juin 2026",
    newBtn: "+ New parc",
    openLink: "open",
    selectPlaceholder: "— select —",
    statusClosed: "closed",
    statusOpen: "open",
    subtitle: "Hail repair worksites — flat-rate quote",
    title: "Parc Grêle",
    validationNameCustomer: "Enter the name and the body shop.",
  },
  importEdsp: {
    alreadyExisted: "already existed",
    alreadyExistsInline: "(already exists)",
    clientCol: "Customer",
    companyBannerPre: "You are importing into:",
    companyBannerSuf:
      "check before importing (quotes, lists and receipts ALL go into this company).",
    companyLabel: "Company:",
    csvColumnsLabel: "CSV or XLSX with columns",
    custBadHeader:
      "Header not recognized — export the list directly from eDSP (Nom usuel / Raison sociale / Adresse / CP / Ville).",
    custColName: "Customer",
    custColStatus: "Status",
    custContactsWord: "contact(s)",
    custEnrichedWord: "enriched",
    custFileClients: "Customers list:",
    custFileContacts: "Contacts list (optional):",
    custHint:
      "Export liste-clients.xlsx from eDSP (and optionally liste-contacts.xlsx for email/phone). No duplicates: existing customers are only enriched (empty fields).",
    custImportBtn: "Import customers",
    custImported: "Customers imported",
    custPreviewBtn: "Preview",
    custRowsWord: "customers in the file",
    custStatusEnrich: "enrich",
    custStatusNew: "new",
    custStatusUnchanged: "already complete",
    custTitle: "Customers (eDSP)",
    custUnchangedWord: "already complete",
    dateCol: "Date",
    devisAlignBlockedPre: "Won't align:",
    devisAlignedWord: "aligned to the devis",
    devisBatchOf: "of",
    devisBatchPre: "batch",
    devisColClient: "Customer",
    devisColDate: "Date",
    devisColDevis: "Quote",
    devisColFile: "File",
    devisColPlate: "Plate",
    devisColStatus: "Status",
    devisColTotal: "Total excl. VAT",
    devisEnrichedWord: "enriched with panels",
    devisImportBtn: "Import new quotes",
    devisImported: "Quotes imported",
    devisParsing: "Reading PDFs…",
    devisStatusAlign: "will align to the devis",
    devisStatusEnrich: "Existing — will get panels",
    devisStatusError: "error",
    devisStatusExisting: "already exists",
    devisStatusNew: "new",
    devisUnreadableHint:
      "Extract the .zip to a folder before selecting (do not pick files from inside the zip) and retry — the rest were processed normally.",
    devisUnreadablePre: "Files the browser could not read",
    docAttachBtn: "Attach the originals",
    docColDoc: "Document",
    docColGestionHt: "Gestion excl. VAT",
    docColPdfHt: "PDF excl. VAT",
    docDupPre: "Same document as",
    docHint:
      "Attaches the ORIGINAL eDSP PDF (the document the customer received) to the invoice or credit note already in Gestion. Gestion checks the number and amounts; if they don't match, nothing is attached. Several at once, in batches.",
    docStAlready: "already attached",
    docStAttach: "to attach",
    docStAttached: "attached",
    docStDuplicate: "duplicate",
    docStMismatch: "amount differs",
    docStNotFound: "not in Gestion",
    docStUnreadable: "not recognised",
    docTitle: "eDSP invoices and credit notes (PDF)",
    dossierWord: "dossier",
    dossiersImported: "Dossiers imported",
    emptyRaw: "(empty)",
    errorsLabel: "Errors",
    existLabel: "already exist",
    failures: "failures",
    file1Title: "File 1 — Dossiers / Invoices",
    file2Title: "File 2 — Receipts",
    file3Hint:
      'Export eDSP quotes as PDF and select several at once — creates "to execute" files with the quote breakdown, no invoice.',
    file3Title: "Quotes (PDF) — before invoicing",
    importAction: "Import",
    importReceiptsBtn: "Import receipts",
    importingLabel: "Importing…",
    invoiceSettledInline: "(invoice already settled by another receipt — skipped)",
    invoicesSplitCol: "Invoices (split)",
    lineLabel: "Line",
    linesParseErrorExpand: "line(s) with parse error — click to expand",
    mailAddress: "Forward to:",
    mailColDetail: "Detail",
    mailColDevis: "Quote · plate",
    mailColFrom: "Sender",
    mailColStatus: "Status",
    mailColWhen: "Received",
    mailDisabled: "receiving turned off on the server",
    mailEmpty: "No email received yet.",
    mailHint:
      "The technician sends the quote from eDSP to the company mailbox, which forwards it to the address below. Gestion reads the PDF and creates the quote by itself, in the issuing company printed on it (EURO STORM or BRAZILIAN STORMS). A quote re-sent for an existing car updates the lines (unless invoiced or a line is paid). Refreshes every 30 s.",
    mailNoAddress: "address not configured yet",
    mailStDuplicate: "already existed",
    mailStEnriched: "completed",
    mailStError: "error",
    mailStIgnored: "ignored",
    mailStImported: "created",
    mailStProcessing: "processing",
    mailStReview: "to review",
    mailStUpdated: "updated",
    mailTitle: "Quotes received by email",
    morePre: "and ",
    moreSuf: " more.",
    new: "new",
    noInvoiceV2: "without invoice in v2",
    noValueInline: "(no net amount — skipped)",
    oldPdfAttachBtn: "Store the PDFs",
    oldPdfColDevis: "Quote no.",
    oldPdfColDossier: "Dossier",
    oldPdfHint:
      'For vehicles imported before 26/10/2026, when Gestion did not keep the file yet: download the quotes again from eDSP and choose the PDFs here. Gestion finds the dossier by quote number and plate and only stores the PDF, shown under "Original PDF". Nothing is re-imported: amounts, lines and excess stay the same. Several at once, in batches.',
    oldPdfStAlready: "already stored",
    oldPdfStAmbiguous: "more than one dossier",
    oldPdfStAttach: "to store",
    oldPdfStAttached: "stored",
    oldPdfStNotFound: "dossier not found",
    oldPdfStUnreadable: "not a quote",
    oldPdfTitle: "Old quote PDFs (store only)",
    oldPdfViaPlate: "found by plate (the quote number was not on the dossier)",
    omitted: "omitted",
    openDossierTag: "invoices the car's open file",
    parseErrorsBadge: "parse errors",
    parseErrorsShort: "parse errors",
    parseErrorsSummaryShort: "line(s) with parse error",
    parsingLabel: "Parsing…",
    partialLabel: "partial",
    readOnlyNote: "Read-only — import available only to users with edit permission.",
    receiptsColumnsNote:
      ". N° Facture may contain multiple numbers separated by a space (pro-rata split by Prix Net).",
    receiptsCreated: "Receipts created",
    receiptsDisabledNote:
      "Disabled. Customer payments are now recorded only through bank statement reconciliation (Bank → Reconciliation), with the money actually received.",
    repairsApplyFixesPre: "apply amount corrections",
    repairsApplyFixesSuf:
      "check the quote first: if the file HT is already net (discount applied in eDSP), do NOT tick",
    repairsBadHeader:
      "Header not recognized — expected: Client, Date Réparation, N° Ordre, Utilisateur, HT, Immatriculation.",
    repairsChipExists: "already exist",
    repairsChipFix: "to fix (amounts)",
    repairsChipMismatch: "technician mismatch",
    repairsChipNew: "new",
    repairsChipNoPlate: "no plate (new car · VIN)",
    repairsChipPlateConflict: "number used by another car",
    repairsColClient: "Client",
    repairsColDate: "Repair",
    repairsColOrdre: "Order",
    repairsColPlate: "Plate",
    repairsColStatus: "Status",
    repairsColTech: "Technician",
    repairsCreatedWord: "created",
    repairsDevisNoTech:
      "exists only as a quote, with no technician, and already has photos/checks — the technician claims it in the portal",
    repairsEmptyFile: "File has no repair rows.",
    repairsFixedWord: "fixed",
    repairsHint:
      'eDSP repairs export: creates repaired cars missing from Gestion, status Repaired, technician from the file and pair-based commission — they land in the "to invoice" card. Re-importable: existing rows (order no. or plate) are skipped.',
    repairsImportBtn: "Import repairs",
    repairsNoPlateCandidatesPre: "likely:",
    repairsNoPlateMsg:
      "no plate in the file — a new car comes in via the quote (VIN); this order creates no dossier",
    repairsResultPre: "Repairs imported",
    repairsStatusExists: "exists",
    repairsStatusNew: "new",
    repairsTagMismatchPre: "in Gestion:",
    repairsTagNewTech: "technician will be created",
    repairsTagNoPair: "no pair or 0%",
    repairsTagPlateConflictPre:
      "order number already used by another car — skipped; existing plate:",
    repairsTitle: "Repairs (liste-orders)",
    repairsUpgradeDevisPre: "completes the quote",
    repairsWillFix: "amounts fixed on import (client discount)",
    settledLabel: "already settled (nothing to create)",
    settledWord: "settled",
    statusCol: "Status",
    technicianCol: "Technician",
    warningsLabel: "Warnings",
  },
  intermediaries: {
    awaitingSuf:
      "car(s) awaiting the customer's payment — they will be included once the customer pays. Total",
    badgeActive: "active",
    badgeInactive: "inactive",
    blockedSuf: "dossier(s) are already in another active proforma and were ignored:",
    cancelBtn: "Cancel",
    closeBtn: "Close",
    colActions: "Actions",
    colAmount: "Amount",
    colCountry: "Country",
    colCustomer: "Customer",
    colDossier: "Dossier",
    colEmail: "Email",
    colName: "Name",
    colPlate: "Plate",
    colStatus: "Status",
    colTaxId: "Tax ID",
    colTechnician: "Technician",
    deactivateBtn: "deactivate",
    dossierCount: "dossier(s)",
    editBtn: "edit",
    emptyState: "No external intermediary registered.",
    fieldCountry: "Country (2 letters)",
    fieldEmail: "Email",
    fieldName: "Name *",
    fieldNotes: "Notes",
    fieldPhone: "Phone",
    fieldTaxId: "Tax ID",
    fieldTaxIdKind: "ID type",
    fieldTaxIdPlaceholder: "SIRET / TVA / CNPJ…",
    generatePaymentBtn: "generate payment",
    generateProformasBtn: "Generate proforma(s)",
    generatingBtn: "Generating…",
    includeInactive: "Include inactive",
    loading: "Loading…",
    loadingEligible: "Searching eligible dossiers…",
    modalTitleEdit: "Edit intermediary",
    modalTitleNew: "New external intermediary",
    newBtn: "+ New intermediary",
    noEligible:
      "No eligible dossier at the moment (nothing to pay or all already in an active proforma).",
    payModalSubtitle:
      "Proforma summing the technician + intermediary commission (the external party pays the technician separately). One document per paying company.",
    payModalTitle: "Generate payment",
    payingCompaniesSuf: "paying companies",
    proformaGeneratedSingular: "Proforma generated successfully.",
    proformasGeneratedSuf: "proformas generated successfully.",
    reactivateBtn: "reactivate",
    saveBtn: "Save",
    savingBtn: "Saving…",
    searchPlaceholder: "Search by name / email / tax ID…",
    subtitle:
      "People/companies outside the group who earn a commission. Linked by technician×customer pair; the payment (proforma) is generated here.",
    title: "External intermediaries",
    totalLabel: "Total",
    viewInProformas: "View in Proformas →",
  },
  invites: {
    accessGrantedTo: "Access granted to:",
    actions: "Actions",
    alreadyHadAccess: "Already had access/invitation in:",
    cancel: "Cancel",
    companiesLabel: "Companies (one or more)",
    companyLabel: "Company:",
    email: "Email",
    emailLang: "Email language",
    expires: "Expires",
    inviteSentTitle: "Invitation sent",
    invitedBy: "Invited by",
    loading: "Loading…",
    name: "Name",
    newInviteBtn: "+ New invitation",
    noInvites: "No invitations recorded.",
    notAdminOfAnyCompany: "You are not an administrator of any company.",
    pageTitle: "Invitations",
    permission: "Permission",
    resend: "Resend",
    revoke: "Revoke",
    revokeConfirmPre: "The invitation sent to",
    revokeConfirmSuf: " will be cancelled. The acceptance link will stop working.",
    revokeInviteTitle: "Revoke invitation",
    roleAdmin: "Administrator",
    roleAdminOption: "Administrator (management)",
    roleClient: "Client",
    roleClientOption: "Client (portal)",
    roleManager: "Manager",
    roleManagerOption: "Project manager (site)",
    roleTechnician: "Technician (portal)",
    roleTechnicianOption: "Technician (portal — no ERP access)",
    roleUser: "User",
    roleUserOption: "User (operational)",
    roleViewer: "Viewer",
    roleViewerOption: "Viewer (read only)",
    selectAtLeastOneCompany: "Select at least one company.",
    sendInvite: "Send invitation",
    sending: "Sending…",
    status: "Status",
    statusAccepted: "Accepted",
    statusExpired: "Expired",
    statusPending: "Pending",
    statusRevoked: "Revoked",
  },
  invoiceDraft: {
    ackWarnings: "I've read the warnings above and want to issue anyway.",
    bankDefaultTag: "default",
    blocksWord: "blocking issue(s)",
    cClientesDiferentes: "Vehicles from different customers can't share one invoice.",
    cDegarnPre: "pending dégarnissage of",
    cDegarnSuf: "— record it before invoicing.",
    cDevis: "Quote",
    cFatura: "invoice",
    cFranquiaExcecao:
      "TTC (exception on this vehicle): the invoice is issued in full; only the technicians' commissions were reduced.",
    cFranquiaNaoInformada: "deductible not recorded at reception.",
    cFranquiaParticular:
      "incl. VAT (private customer): the invoice stays full; only the technician's commission is reduced.",
    cFranquiaPre: "deductible of",
    cFranquiaPro:
      "incl. VAT (business customer): already deducted from the invoice and the commission.",
    cJaFaturado: "already invoiced.",
    cOldAvoir: "the old invoice has a credit note issued for",
    cOldPaid:
      "Payment already received on the old invoice moves to the new one; any surplus becomes customer credit:",
    cParticularSemTva:
      "Private customer set up without VAT: private customers pay VAT — check the record.",
    cProSemRemise: "Business customer with no discount set: commissions may be wrong.",
    cProSemSiret: "Business customer with no SIRET or VAT number.",
    cReparoIncompleto: "repair incomplete, missing:",
    cReplaces: "Replaces invoice",
    cSemComissao: "line(s) without a configured commission (technician × customer pair).",
    cSemEmail: "Customer has no email: Gestion can't send the invoice.",
    cSemEndereco: "Customer has no address: the invoice needs it.",
    cSemPlaca: "Vehicle with no plate or VIN: the invoice won't identify it.",
    cTecnicoAReceber:
      "technician already paid by the previous proforma is still owed (quote went up): pay separately",
    cTotalZero: "zero amount: nothing to invoice.",
    cTudoCerto: "All good: no issues found.",
    checksTitle: "Automatic check",
    createdBy: "created by",
    discardBtn: "Discard draft",
    draftsChip: "Drafts",
    draftsPanelTitle: "Invoice drafts (not issued yet)",
    errBlocked: "The check found a blocking issue: fix it before issuing.",
    errReplacementHasPayment:
      "The old invoice has a payment: validate the replacement (the payment moves to the new one). It can't be discarded.",
    errWarnings: "Tick that you've read the warnings before issuing.",
    fieldBankAccount: "Payment to account",
    fieldDue: "Due date",
    fieldNotes: "Notes",
    fieldNumber: "Invoice no. (empty = next in series)",
    issueAndSendBtn: "Issue and send",
    issueAndSendTitle: "Issues the invoice and opens the e-mail to the customer (PDF attached).",
    issueBtn: "Validate and issue",
    issuedOk: "Invoice issued:",
    numberJumpRetry: "The number you typed skips the series. Issue anyway?",
    openDraft: "📝 Open draft",
    openNewTab: "Open in a new tab",
    pdfBtn: "View PDF (draft)",
    previewLoading: "Generating the preview…",
    previewStale: "Save your changes to refresh the preview.",
    previewTitle: "PDF preview (draft)",
    replacesCancelled: "already cancelled",
    replacesOld: "previous total",
    replacesPayment: "payment already received, moved to the new invoice:",
    replacesPre: "Replaces invoice",
    reverseCharge: "Reverse charge (no VAT)",
    save: "Save changes",
    saveAsDraft: "📝 Draft and check",
    saveFirst: "Save your changes first",
    sendNowBtn: "Send by e-mail",
    sentToPre: "sent to",
    stepDelivery: "delivery",
    stepMontage: "assembly",
    stepMontagePhases: "assembly steps (removal/refit)",
    stepPdr: "dent repair (PDR)",
    summaryTitle: "Summary (current dossier amounts)",
    title: "Invoice draft",
    totalHt: "Total excl. VAT",
    totalTtc: "Total incl. VAT",
    tva: "VAT at",
    warningsWord: "warning(s)",
  },
  invoiceNew: {
    addDossiers: "+ Add dossiers",
    addDossiersTitle: "Select more dossiers for the same customer and issue again",
    alreadyInvoicedBadge: "already invoiced — will be excluded",
    cancel: "Cancel",
    cannotIssueTitle: "Resolve the blocks above (single customer, at least 1 valid dossier).",
    colDossier: "Dossier",
    colPlate: "Plate",
    colTotalHt: "Total HT",
    colVehicle: "Vehicle",
    confirmEmit: "Confirm and issue",
    customer: "Customer",
    degarnOpenBadge: "dégarnissage not finished:",
    degarnOpenTitle:
      "The dégarnissage was taken but dismount or remount is not marked. The amount is already in this invoice.",
    degarnPendingBadge: "dégarnissage left out:",
    degarnPendingTitle:
      "The quote has a dégarnissage but nobody recorded it: the amount is not in this invoice. Enter it in the portal before invoicing, or invoice without it.",
    differentCustomersBold: "different customers",
    differentCustomersPre: "The selected dossiers belong to",
    differentCustomersSuf:
      "A consolidated invoice must be for a single customer — remove those that don’t belong.",
    dueQuick15: "15 days",
    dueQuick30: "30 days",
    dueQuick60: "2 months",
    dueQuick7: "1 week",
    emailPlaceholder: "leave empty to not send",
    fieldDueDate: "Due date (optional)",
    fieldEmail: "Customer email (sends the invoice on confirm)",
    fieldInvoiceNumber: "Invoice number (follows the last one; edit to match the company format)",
    fieldNotes: "Notes (internal, optional)",
    invoiceNumberPlaceholder: "e.g. F-2026-0001",
    issuer: "Issuer",
    issuing: "Issuing…",
    loadingPreview: "Loading preview…",
    noDossierPre: "No dossier selected. Go back to",
    noDossierSuf: "and use “Issue invoice”.",
    numberJumpAsk: "All following invoices will continue from this number. Confirm anyway?",
    numberJumpConfirm: "Issue with this number",
    numberJumpMid: "skips",
    numberJumpMid2: "positions in the series — the next one would be",
    numberJumpTitle: "Number out of sequence",
    removeDossierTitle: "Remove this dossier from the invoice",
    reverseChargeNote: "Reverse charge — VAT due by the recipient (art. 283-2 CGI).",
    servicePlural: "services",
    serviceSingular: "service",
    toastEmailFailed: "issued, but the email sending failed",
    toastInvoiceWord: "Invoice",
    toastIssued: "issued",
    toastSentTo: "and sent to",
    totalTtc: "Total TTC",
  },
  invoices: {
    allCustomers: "All customers",
    allStatuses: "All statuses",
    allocateMenu: "Cars settled by the payment",
    amendDonePre: "updated under the same number",
    amendDoneResend: "Re-send it to the customer.",
    amendDoneTitle: "Invoice updated",
    amendNoChange:
      "The vehicles' values are the same as the invoice's: nothing changed. To change the amount, edit the vehicle's estimate; the invoice follows under the same number.",
    amendedResendBadge: "re-send to customer",
    amendedResendHint:
      "The estimate changed after issue and the invoice was rebuilt under the same number. Send the new version to the customer (E-mail) or mark it as sent outside Gestion.",
    amendedResentNote: "current version already sent to the customer",
    amendedTitle: "Amended on",
    amountHtLabel: "Amount excl. tax",
    attach: "Attach",
    attachMenu: "Attach external PDF",
    attachPdfErrorPre: "Error attaching PDF: ",
    attachStatement: "Attach the statement of account (open invoices)",
    attachTitle:
      "Attach the external PDF of this invoice (used in the monthly report to the accountant)",
    avoirBtn: "Credit note",
    avoirCreateErrorTitle: "Error creating credit note",
    avoirCreatedMid: " — incl. tax ",
    avoirCreatedSuf: ".",
    avoirCreatedTitle: "Credit note created",
    avoirDeleteConfirmPre: "Delete credit note ",
    avoirDeleteConfirmSuf: "? This action cannot be undone.",
    avoirDeleteConfirmTitle: "Delete credit note?",
    avoirDeleteErrorTitle: "Error deleting credit note",
    avoirDeleteTitle: "Delete credit note",
    avoirFullBtn: "Full credit note",
    avoirMenu: "Issue credit note",
    avoirModalTitle: "Credit note",
    avoirNumberLabel: "Credit note no.",
    avoirPartialBtn: "Partial credit note",
    avoirStatusCancelled: "cancelled",
    avoirStatusEmbedded: "already deducted in the invoice",
    backAllClients: "All clients",
    badgeAmended: "amended",
    badgeCancelled: "cancelled",
    badgeIssued: "issued",
    badgePaid: "received",
    badgeVoid: "void",
    bankChangeBtn: "Change account",
    bankChangeDone:
      "Account changed: the PDF was regenerated with the same number. Send it to the customer again.",
    bankChangeLocked: "paid invoice: the account cannot change",
    bankChangeReasonPh: "Reason for the change (audit log)",
    bankChangeResend: "Resend by e-mail",
    bankChangeSave: "Change and regenerate the PDF",
    bulkAttachLabel: "Attach PDFs in bulk:",
    bulkDoneTitle: "Bulk upload completed",
    bulkErrorTitle: "Bulk upload error",
    bulkFailedMid: " failed to upload: ",
    bulkFailedPre: "❌ ",
    bulkHintMid: "). ",
    bulkHintOr: " or ",
    bulkHintPre: "Name each PDF like the invoice (e.g. ",
    bulkHintStrong: '"Select folder"',
    bulkHintSuf: " grabs them all at once.",
    bulkOkPre: "✅ ",
    bulkOkSuf: " PDF(s) attached successfully.",
    bulkSelectTitle:
      "Select several PDFs at once; each is attached to the invoice with the same number",
    bulkUnmatchedMid: " without a matching invoice: ",
    bulkUnmatchedPre: "⚠️ ",
    byClientColCount: "Invoices",
    byClientColOverdue: "Overdue",
    byClientHint:
      "Click a client to open their invoices. Overdue = issued, no receipt and past due date.",
    cancel: "Cancel",
    cancelInvoiceBtn: "Cancel invoice",
    cancelInvoiceHint: "The invoice is cancelled (the number is not reused). Give the reason.",
    cancelledOn: "Cancelled on",
    checking: "Checking…",
    chipAll: "All",
    chipAmended: "Amended — re-send",
    chipAwaiting: "Awaiting",
    chipOverdue: "Overdue",
    chipPartial: "Partial",
    chipsAria: "Filter by status",
    cleanDuplicates: "Clean duplicates",
    cleanupDoneTitle: "Cleanup completed",
    cleanupErrorTitle: "Cleanup error",
    clearFilters: "clear filters",
    clearSearch: "clear",
    clearSearchTitle: "Clear search",
    clearSelection: "clear selection",
    close: "Close",
    colActions: "Actions",
    colCars: "Cars",
    colCustomer: "Customer",
    colDate: "Date",
    colHt: "Excl. tax",
    colInvoiceNumber: "Invoice no.",
    colNum: "No.",
    colServices: "Services",
    colSituation: "Status",
    colStatus: "Status",
    colTotal: "Total",
    colTotalHt: "Total excl. VAT",
    colTtc: "Incl. tax",
    colType: "Type",
    collectBtn: "Send reminder",
    companyLabel: "Company:",
    consolidatedBadge: "multi-car",
    consolidatedExplain:
      "Multi-car invoice (one invoice for several dossiers, e.g. the customer's monthly invoice). Open each car via the dossiers.",
    consolidatedNoLinkHint: "Consolidated invoice (multiple dossiers) — open via the dossiers",
    createAvoirBtn: "Create credit note",
    creating: "Creating…",
    creditNoteTitle: "Generate a credit note",
    creditTypeCommercial: "Commercial discount (reduces revenue)",
    creditTypeError: "Error correction (reduces revenue)",
    creditTypeIrrecoverable: "Uncollectible (loss, does not reduce revenue)",
    creditTypeReturn: "Return (reduces revenue)",
    customersWord: "customers",
    dayWord: "day",
    daysWord: "days",
    dedupeConfirmP1: "Found ",
    dedupeConfirmP2: " duplicate copy/copies in ",
    dedupeConfirmP3: " document(s) (~",
    dedupeConfirmP4:
      " MB). I always keep the most recent of each and remove the rest. This action cannot be undone. Confirm?",
    dedupeTitle: "Removes duplicate copies of the same PDF (keeps the most recent)",
    deleteConfirm: "Delete",
    detailBankAccount: "Payment account",
    detailCars: "Cars",
    detailDue: "Due",
    detailEditHint:
      "Issued invoice: when the vehicle's estimate changes, it is updated under the same number and flagged to be re-sent to the customer. One-off discount: credit note.",
    detailGeneratePdf: "Generate PDF",
    detailIssued: "Issued",
    detailReceived: "Received",
    detailReceivedOn: "Received on",
    email: "Email",
    emailBtn: "E-mail",
    emailFailedTitle: "Sending failed",
    emailMessageLabel: "Message (optional)",
    emailMessagePh: "Replaces the standard e-mail sentence. The invoice stays attached.",
    emailModalInvoicePre: "Invoice",
    emailModalTitle: "Send invoice by email",
    emailSentMid: " sent to ",
    emailSentPre: "Invoice ",
    emailSentSuf: ".",
    emailSentTitle: "Email sent",
    emailTitle: "Send invoice by email",
    emptyState: "No invoices.",
    filterCompanyLabel: "Company",
    filterSearchLabel: "Search",
    filterStatusLabel: "Status",
    folderSelectTitle: "Choose the whole FOLDER of PDFs — no need to select them one by one",
    generatePdfOption: "Generate PDF ▾",
    generatePdfTitle:
      "Generate the invoice PDF — the language comes from the company (Euro Storm → French, Brazilian Storms → English) or choose here",
    generateReportBtn: "Generate report (PDF with links)",
    generating: "Generating…",
    invalidMonthMsg: "Choose a valid month.",
    invalidMonthTitle: "Invalid month",
    langAuto: "Automatic language",
    loading: "Loading…",
    markSentMenu: "Mark as sent (outside Gestion)",
    markSentPh: "E.g. handed over, sent by WhatsApp",
    markSentTitle: "How was the invoice delivered to the customer?",
    matchingFiles: "Matching files to invoices…",
    modifyBtn: "Modify invoice",
    modifyHint:
      "The invoice is rebuilt from the vehicle's current values (estimate and repair order), under the SAME number and for the same customer. The previous version is kept and the invoice is flagged to be re-sent to the customer. To change the amount, edit the vehicle's estimate first. Reason:",
    monthlyChartTitle: "Invoiced per month (excl. VAT)",
    monthlyInReportNote: "Monthly invoicing is in Reports → Revenue report.",
    monthlyReportLabel: "Monthly report (accountant):",
    moreBtn: "More",
    next: "Next",
    noCustomerEmailMsg: "Customer has no email on file — enter an address.",
    noDuplicatesMsg: "No duplicate attachments found in this company.",
    noDuplicatesTitle: "No duplicates",
    noInvoices: "No invoices",
    noPdfYet: "PDF not generated yet — use the ⋮ menu",
    openDetailTitle: "Open the invoice (actions, cars, receipts)",
    openDossierBtn: "Open the file",
    openInvoiceBtn: "Open",
    openPdfErrorPre: "Error opening PDF: ",
    or: "or",
    overdueBadge: "overdue",
    overdueSince: "Due since",
    pagePre: "Page ",
    pageSubInvoices: "invoices",
    pageTitle: "Invoices",
    pdfAttachedMsg:
      "The external PDF has been attached to the invoice and will be used in the monthly report to the accountant.",
    pdfAttachedTitle: "PDF attached",
    pdfAutoAttachedMsg: "The invoice PDF is attached automatically.",
    pdfBtn: "PDF",
    pdfErrorPre: "Error generating PDF: ",
    pdfMenuGen: "Generate PDF in",
    pdfMenuRegen: "Regenerate PDF in",
    previous: "Previous",
    reasonLabel: "Reason (optional)",
    reasonPlaceholder: "40% discount on the quote…",
    receivedOnPre: "received on",
    recipientEmailLabel: "Recipient email",
    recipientEmailPlaceholder: "customer@example.com",
    regeneratePdfTitle: "Regenerate the PDF (replaces the current file)",
    registerReceiptBtn: "Record payment",
    reissueBtn: "Reissue",
    reissueDonePre: "New invoice:",
    reissueDoneTitle: "Invoice reissued",
    reissueHint:
      "Cancels this invoice and issues a new one with the dossier's current values (new number). Give the reason.",
    relancerBtn: "Remind",
    relancerTitle: "Send a payment reminder for this invoice by e-mail, PDF attached",
    remainingPre: "remaining",
    reminderBatchMultiCustomers:
      "Invoices from several customers: each customer receives one e-mail at the billing address on file, with their invoices attached.",
    reminderBatchSentTitle: "Reminders sent",
    reminderBatchTitlePre: "Remind",
    reminderBatchTitleSuf: "invoices",
    reminderModalHint: "A payment REMINDER e-mail will be sent with the invoice PDF attached.",
    reminderModalTitle: "Send payment reminder",
    removeDuplicatesConfirm: "Remove duplicates",
    removeDuplicatesTitle: "Remove duplicate attachments",
    removedDuplicatesPre: "Removed ",
    removedDuplicatesSuf: " duplicate(s).",
    replacedBy: "replaced by",
    reportErrorPre: "Error generating report: ",
    reportGeneratedTitle: "Report generated",
    reportHint:
      "Lists the invoices issued in the month with a link to download each one's PDF (external attachment if any, otherwise the generated one).",
    reportMsgP1: " invoice(s) in the month · Total excl. tax ",
    reportMsgP2: " · incl. tax ",
    reportMsgP3: ".",
    reportWarnPre: " ⚠️ ",
    reportWarnSuf:
      ' invoice(s) without a PDF — attach the PDF on the invoice row (button "⬆ Attach") and generate again.',
    resyncApplyPre: "Apply to",
    resyncBtn: "Resync amounts",
    resyncBtnTitle: "Fixes the invoice amount from the dossier lines (after a commission recalc)",
    resyncClose: "Close",
    resyncColInvoice: "Invoice",
    resyncColNew: "Corrected (excl. VAT)",
    resyncColOld: "Current (excl. VAT)",
    resyncColReceipt: "eDSP receipt",
    resyncDoneSuf: "invoice(s) fixed. Run the fiscal Sync/Recompute next.",
    resyncEmpty: "All consistent — no invoice differs from its lines.",
    resyncHelp:
      "Lists open-fiscal-year invoices whose amount differs from the sum of the dossier lines (e.g., inflated quote from the old importer). Applying fixes the invoice snapshot and the matching eDSP receipt. Nothing changes without your confirmation.",
    resyncLoading: "Analyzing…",
    resyncRun: "Check differences",
    resyncTitle: "Resync amounts (lines → invoices)",
    searchPlaceholder: "Search invoice no. or plate… (e.g. F2025-00274, GK-294-GV)",
    selectAllOpenTitle: "Select all open invoices on this page",
    selectFolder: "Select folder",
    selectForReminderTitle: "Select for reminder",
    selectPdfs: "Select PDFs…",
    selectedMany: "invoices selected",
    selectedOne: "invoice selected",
    send: "Send",
    sendReminder: "Send reminder",
    sending: "Uploading…",
    sendingProgressPre: "Uploading ",
    showingMid: " of ",
    showingPre: "Showing ",
    sitAwaiting: "to collect",
    sitUncollectible: "Uncollectible",
    sortByDateTitle: "Sort by date (most recent first)",
    sortByNumberTitle: "Sort by invoice number (click to toggle)",
    statusCancelled: "Cancelled",
    statusIssued: "Issued",
    statusPaid: "Received",
    statusVoid: "Void",
    toastErrorTitle: "Error",
    toolsBtn: "Tools",
    ttcCalculatedLabel: "Incl. tax (calculated)",
    ttcInputLabel: "Amount incl. VAT",
    tvaLabel: "TVA %",
    typeCommercial: "Discount",
    typeError: "Error",
    typeIrrecoverable: "Uncollectible",
    typeReturn: "Return",
    uncollectibleBtn: "Mark uncollectible",
    uncollectibleHint:
      "The invoice stays issued but leaves reminders and the overdue list. Give the reason (kept in the audit).",
    uncollectibleTitle: "Mark the invoice uncollectible",
    uncollectibleUndoBtn: "Undo uncollectible",
    unsentBadge: "not sent",
    unsentBadgeTitle: "No sending of this invoice to the customer recorded in Gestion.",
    unsentHint:
      "Send them with the row's ✉, or mark them as sent from the ⋮ menu if delivered another way.",
    unsentMany: "issued invoices not yet sent to the customer",
    unsentOne: "issued invoice not yet sent to the customer",
    unsentShowAll: "Show all",
    unsentShowOnly: "Show unsent only",
    uploadFailedPre: "Upload failed (HTTP ",
    uploadFailedSuf: ").",
    vehiclesMoreHint: "See all vehicles on this invoice",
    versionUntil: "valid until",
    versionsTitle: "Previous versions",
    voidInvoiceBtn: "Void invoice",
    voidInvoiceHint: "Voids an invoice already received. Give the reason.",
  },
  modals: {
    alertTitle: "Notice",
    cancel: "Cancel",
    close: "Close",
    confirm: "Confirm",
    invalidValue: "Invalid amount",
    maxAbbr: "max",
    minAbbr: "min",
    ok: "OK",
  },
  monthlyEntryGrid: {
    aTrierTitlePre: "Uncategorized/unreconciled inflows this month:",
    cellEmpty: "— empty —",
    colActions: "Actions",
    colBilan: "Bilan?",
    colChargesExternes: "Charges externes",
    colMonth: "Month",
    colOtherCharges: "Other charges",
    colOtherIncome: "Other income",
    colRecettes: "Receipts (excl. VAT)",
    colStatus: "Status",
    createBtn: "create",
    editBtn: "edit",
    lockBtn: "lock",
    monthApril: "April",
    monthAugust: "August",
    monthDecember: "December",
    monthFebruary: "February",
    monthJanuary: "January",
    monthJuly: "July",
    monthJune: "June",
    monthMarch: "March",
    monthMay: "May",
    monthNovember: "November",
    monthOctober: "October",
    monthSeptember: "September",
    statusLocked: "🔒 locked",
    statusOpen: "open",
    totalLabel: "Total",
    unlockBtn: "unlock",
  },
  notFound: {
    backHome: "Back to home",
    title: "Page not found",
  },
  operationBoard: {
    allCustomers: "All customers",
    degarnChip: "dégarnissage pending",
    degarnChipTitle: "PDR finished; who did the dégarnissage is not recorded",
    empty: "No car in this state.",
    emptyAll: "No car in operation.",
    franchiseChip: "excess",
    hideDelivered: "Hide delivered",
    moreCars: "more cars",
    noChantier: "Outside a chantier",
    notReceived: "no reception",
    openList: "Open the list",
    showDelivered: "Show delivered",
    statusDelivered: "Delivered",
    statusInRepair: "In repair",
    statusRepaired: "Repaired",
    statusToRepair: "To repair",
    title: "Cars in operation",
    totalWord: "cars",
  },
  pagination: {
    aria: "List pages",
    next: "Next",
    of: "of",
    page: "Page",
    prev: "Previous",
  },
  paymentAllocation: {
    alreadyReceived: "already received",
    available: "Available",
    cancelBtn: "Cancel",
    cars: "cars",
    colCar: "Car",
    colOrder: "Order",
    colStatus: "Status",
    colTech: "Technician",
    colValue: "Amount excl. VAT",
    creditLeft: "Left as credit",
    exceeds: "Selected cars exceed the amount received",
    hint: "Partial payment of a multi-car invoice: tick the cars this money settles. Only those release the technician payout; the remainder stays as credit on the invoice for the next payment. Gestion already suggests the oldest ones.",
    invoiceBtn: "Paid cars",
    invoiceBtnTitle: "Partial payment: choose which cars the received amount settles",
    invoiceTotal: "invoice",
    linkBtn: "Link and settle selected",
    linkNoCarsBtn: "Link without choosing cars",
    linkNoCarsTitle: "The whole amount stays as credit; no car is released",
    loading: "Loading…",
    lockProforma: "In an active proforma — cannot be removed",
    lockTechPaid: "Technician already paid — cannot be removed",
    saveBtn: "Save",
    selected: "Selected",
    stPaid: "settled",
    suggestBtn: "Suggest oldest",
    techGets: "payout",
    thisDeposit: "this deposit",
    title: "Which cars does this payment settle?",
  },
  proformaDetail: {
    add: "Add",
    addItemBtn: "+ Add item",
    addItemTitle: "Add item",
    adding: "Adding…",
    advancesExpected: "Expected invoice amount:",
    advancesHint:
      "The technician's invoice should carry the deduction of these advances. Untick what they did NOT deduct (stays open for the next one).",
    advancesTitle: "Advances to deduct",
    allAlreadyImported: "All items had already been imported.",
    alreadyExistedSuffix: "already existed.",
    alreadyImported: "✓ Already imported",
    alsoSendEmail: "Also send by email now",
    attachInvoicePdfLabel: "Attach invoice PDF (optional)",
    attachPdf: "📎 Attach PDF",
    auditAdminOnlyPost: "for the full log.",
    auditAdminOnlyPre: "Only administrators can see the history here. Go to",
    byPlate: "(by plate)",
    canReattachLater: "You can reattach it later.",
    cancel: "Cancel",
    cancelMirrorsBlockedMid: "of",
    cancelMirrorsBlockedPre: "Cannot cancel:",
    cancelMirrorsBlockedSuf:
      "mirror dossier(s) in the recipient company are already paid, in a proforma or invoiced. Sort it out there first.",
    cancelMirrorsPre: "This proforma was already imported into the recipient company:",
    cancelMirrorsSuf: "mirror dossier(s) there will be deleted on cancel.",
    colAction: "Action",
    colAmount: "Amount",
    colCustomerVehicle: "Customer / Vehicle",
    colDate: "Date",
    colDescription: "Description",
    colDossierBs: "Dossier BS",
    colExpected: "Expected",
    colGross: "Gross",
    colInBs: "In BS",
    colIntermShare: "Intermediary",
    colInvoice: "Invoice",
    colInvoiced: "Invoiced",
    colInvoicedTitle: "Invoiced (excl. VAT) to the customer for this technician's work on the car",
    colMargin: "Margin",
    colMarginTitle: "Invoiced − paid to technician (kept by the company)",
    colNet: "Net",
    colOk: "OK?",
    colPlate: "Plate",
    colReasonChanges: "Reason / Changes",
    colTechShare: "Technician",
    colTechnician: "Technician",
    companiesBold: "Companies",
    confirm: "Confirm",
    dossierIdHelp:
      "The backend validates R12 (job in only one active proforma) and that it belongs to the company.",
    dossierIdLabel: "Dossier ID",
    dossierIdPlaceholder: "e.g. 501",
    dossierWord: "dossier",
    dossiersCreatedSuffix: "dossier(s) created in the destination company.",
    emailFailedPre: "Proforma sent, but the email failed for:",
    emailResendFailed: "Failed to resend email",
    emailResent: "Email resent.",
    errInvalidDossierId: "Invalid dossier ID.",
    errInvalidEmail: "Invalid email:",
    errNoRecipient: "Tick the registered email or enter another one (or untick sending by email).",
    errReasonRequired: "Reason required.",
    errRetentionRange: "Retention must be between 0 and 100.",
    errSelectTechnician: "Select a technician.",
    errSupplierInvoiceNumberRequired: "Enter the supplier invoice number.",
    errTooManyRecipients: "At most 5 recipients.",
    error: "Error",
    expectedProforma: "Expected (proforma)",
    extHint: "Internal record: no e-mail, PDF or technician invoice. The pieces below are paid.",
    extMethodDinheiro: "Cash",
    extMethodOutro: "Other",
    extMethodSalario: "Salary (in-house team)",
    extMethodTransferencia: "Bank transfer",
    extTitle: "Paid outside the pro forma (internal record)",
    extUndoBtn: "Undo (pieces go back to unpaid)",
    extUndoCancel: "Back",
    extUndoConfirm: "Undo payment",
    extUndoReasonPh: "Reason (at least 5 letters)",
    extUndoneReason: "Reason",
    extUndoneTitle: "Outside payment undone",
    importBtnTitle: "Creates own dossiers in the destination company from this proforma's items",
    importConfirmMid: "dossier(s) to",
    importConfirmPre: "Import",
    importConfirmSuffix:
      "Creates own dossiers in the destination company (customer = sending company).",
    importFailed: "Import failed",
    importTo: "Import to",
    importedWithWarnings: "Imported with warnings",
    importing: "Importing…",
    intercompanyHint:
      "This proforma is intercompany. Send it (change the status to 'sent') to enable importing the dossiers into the destination company.",
    invalidId: "Invalid ID.",
    invoiceSavedUploadFailedPre: "Invoice registered, but the PDF upload failed",
    kpiAdvancesShort: "advances",
    kpiGross: "Gross",
    kpiNet: "Net",
    kpiPeriod: "Period",
    kpiRetention: "Retention",
    kpiToPay: "To pay",
    linesWithoutCommission: "line(s) without configured commission (created as legacy):",
    loading: "Loading…",
    loadingAudit: "Loading audit log…",
    marginAlert:
      "The proforma pays as much as or more than was invoiced to the customer — check before sending.",
    marginGross: "Company gross margin",
    marginHint: "Invoiced = sum (excl. VAT) of this technician's lines on the proforma's cars.",
    marginInvoiced: "Invoiced to customer (excl. VAT)",
    marginPaid: "Paid by this proforma",
    marginTitle: "Margin check (internal — not sent to the technician)",
    mirrorAllOk: "✓ All mirrored and amounts match",
    mirrorCheckPre: "Mirror check at",
    mirroredBs: "Mirrored (BS)",
    mirroredCount: "mirrored",
    missing: "✗ missing",
    noAuditEntries: "No audit log entries.",
    noEmailOtherPre:
      "Recipient has no registered e-mail. To send the proforma, tick “Also send by email now” and type the address in “Other email (optional)”. Otherwise it is only marked as sent. To avoid typing it next time, register the e-mail in",
    noEmailWarnMid: "and use",
    noEmailWarnPost: "afterward.",
    noEmailWarnPre:
      "⚠ Recipient has no email on file. The proforma will be marked as sent (administrative transition) but no email will be dispatched. To send an email, register the recipient's email in",
    noItemsYet: "No items yet.",
    noOtherServices: "No other services.",
    noPdfAttached: "(no PDF attached)",
    notFound: "Proforma not found in accessible companies.",
    optIntercompanyInvoice: "Intercompany invoice",
    optTechnicianInvoice: "Technician invoice",
    otherEmailHint:
      "Several: separate with commas. Only for this sending — the record doesn't change.",
    otherEmailLabel: "Other email (optional)",
    pdfAttachedNote: "(the proforma PDF is attached)",
    pdfBtn: "📄 Download PDF",
    pdfBtnTitle: "Opens the proforma PDF (the one sent by email)",
    pdfErrorPre: "Could not open the PDF: ",
    pdfGenerating: "Generating PDF…",
    processing: "Processing…",
    reasonLabel: "Reason",
    reasonPlaceholder: "Required for the audit log.",
    recipientEmailLabel: "Recipient email",
    recipientPrefix: "To",
    refreshItemsBtn: "Recalculate amounts",
    refreshItemsDoneSuf: "item(s) updated",
    refreshItemsHint:
      "Rebuilds the item amounts from the current lines (e.g. assembly half ticked after the proforma was created).",
    refreshItemsNone: "No amount changed.",
    refreshItemsResend:
      "The proforma had already been sent: resend the e-mail to the technician so they get the new amounts.",
    registeredEmailTag: "registered email",
    remainingPre: "remaining",
    removeBtn: "remove",
    removeConfirmPre: "Remove",
    requiresAdminRole: "Requires admin role",
    resendConfirmPre: "Resend proforma by email to",
    resendEmail: "📧 Resend email",
    resendEmailBold: "📧 Resend email",
    resendInvalidEmail: "Invalid email address.",
    resendPromptMessage:
      "Check or change the recipient address. The change applies to this send only — the proforma record and the PDF are unchanged.",
    resendPromptPlaceholder: "recipient@example.com",
    resendPromptTitle: "Resend proforma by email",
    resendSendBtn: "Send",
    resendSentToPre: "Email sent to",
    resendTo: "Resend to",
    retentionLabel: "Retention (%)",
    returnedInvoice: "Returned invoice",
    returnedInvoiceTypeLabel: "Returned invoice type",
    selectPlaceholder: "— select —",
    sendFirst: "send the proforma first",
    sendToLabel: "Send to",
    sending: "Sending…",
    sentNoEmail:
      "Proforma marked as sent (no automatic email). Use 📧 Resend email when you want to trigger the send.",
    sentWithEmailPost: "If it doesn't arrive, use 📧 Resend email to try again.",
    sentWithEmailPre: "Proforma marked as sent and email dispatched to",
    splitTotalsLabel: "Totals (technician · intermediary · gross)",
    statusApproved: "approved",
    statusCancelled: "cancelled",
    statusClosed: "closed",
    statusDraft: "draft",
    statusInvoiceReceived: "invoice received",
    statusPaid: "paid",
    statusRejected: "rejected",
    statusSent: "sent",
    supplierInvoiceNumberHelp:
      "Number of the document issued by the supplier (the invoice they sent).",
    supplierInvoiceNumberLabel: "Supplier invoice number",
    supplierInvoiceNumberPlaceholder: "e.g. BS-2026-0042",
    tabAudit: "Audit log",
    tabItems: "Items",
    tabOtherServices: "Other services",
    technicianLabel: "Technician",
    techniciansBold: "Technicians (technician record)",
    transApprove: "Approve",
    transCancel: "Cancel",
    transCancelAdmin: "Cancel (admin)",
    transClose: "Close",
    transMarkPaid: "Mark paid",
    transReceiveInvoice: "Register invoice",
    transReject: "Reject",
    transReopen: "Reopen",
    transSend: "Send",
    uploadFailed: "Upload failed",
    uploading: "Uploading…",
    uploadingAttachment: "Uploading attachment…",
    valueMismatch: "≠ amount",
  },
  proformaNew: {
    addAtLeastOne: "Add at least 1 dossier.",
    addEditDossiers: "Add / edit dossiers",
    allCustomers: "All customers",
    allTechnicians: "All technicians",
    backToList: "← Back to list",
    backendQueryError: "Backend query error",
    causesPost: "and select only dossiers with a technician already registered.",
    causesPre:
      "Possible causes: dossiers with no technician assigned, dossiers in a company different from the selected one (Euro Storm Débosselage), or dossiers with no customer. Go back to",
    changeCompanyTitle: "Change the company by going back to step 1",
    clientRetentionLabel: "Customer retention",
    clientRetentionSubtitle: "what the customer keeps",
    colCustomer: "Customer",
    colDate: "Date",
    colDossier: "Dossier",
    colGross: "Gross",
    colInterm: "Interm.",
    colPlate: "Plate",
    colTec: "Tech.",
    colTechnician: "Technician",
    colTotal: "Total",
    commissionIntermShort: "Interm. commission",
    commissionIntermediary: "Intermediary commission",
    commissionTecShort: "Tech. commission",
    commissionTechnician: "Technician commission",
    commissionTechnicianReceive: "Technician commission — how much the technician will receive",
    conflictsBannerSuffix:
      " dossier(s) are already in another active proforma — remove before creating:",
    createProformaDraft: "Create proforma (DRAFT)",
    creating: "Creating…",
    customMessageLabel: "Message for the recipient (optional)",
    customMessagePlaceholder: "Free text that appears in the email body.",
    dateFromTitle: "Start date",
    dateToTitle: "End date",
    dossierInActiveProformaPre: "Dossier already in an active proforma (line ",
    dossiersSelectedSuffix: "dossier(s) selected.",
    dossiersWordSuffix: "dossier(s)",
    emailHelper:
      "Optional. Without a registered email the proforma is only available for manual PDF download.",
    emailPlaceholderIntercompany: "Auto-filled if the company has a registered email",
    emailPlaceholderPartner: "Enter manually (external partner)",
    emailPlaceholderTechnician: "Auto-filled if the technician has a registered email",
    eurostormKeepsLabel: "Euro Storm keeps",
    eurostormNegativeSubtitle: "⚠ negative — the proforma covers more than Euro Storm receives",
    eurostormPositiveSubtitle: "on these dossiers, after paying the proforma",
    fieldDestinatario: "Recipient",
    fieldIdioma: "Language",
    fieldItens: "Items",
    fieldTipo: "Type",
    filterCustomerTitle: "Filter by customer",
    filterPlateTitle: "Filter by plate",
    financialSummaryDesc:
      "Informative overview of the money flow. Does not change the proforma — only helps to approve with context.",
    financialSummaryTitle: "Financial summary of these dossiers",
    grossColTitle: "V3 commission to invoice (depends on recipient type)",
    grossQuoteLabel: "Gross quote (Prix Brut)",
    grossTotal: "Gross total",
    inProformaBadge: "in proforma",
    invalidRetention: "Invalid retention (0..100).",
    issuerCompanyLabel: "Issuing company:",
    loadedReadySuffix: " dossier(s) loaded — ready to review.",
    loading: "Loading…",
    loadingDossierLines: "Loading dossier lines…",
    net: "Net",
    nextArrow: "Next →",
    noCompanyAccess: "You do not have access to any company.",
    noDossierInFilter: "No dossier in the filter. Adjust the period or the technician.",
    noLinesReturned: "No lines returned for the selected dossiers",
    notesLabel: "Notes (internal)",
    notesPlaceholder: "E.g. paid by transfer, extra commission…",
    pairMismatchHint:
      "The proforma uses the LINE amounts. Fix them first in File → Lines → Edit commission (each line's intermediary), then come back here.",
    pairMismatchLines: "lines",
    pairMismatchOpen: "open the file",
    pairMismatchPair: "pair",
    pairMismatchTitle:
      "These cars' lines were calculated with a different intermediary share than the technician × customer pair:",
    partnerHelper: "External partner (outside the group). No strict CHECK constraint.",
    partnerParenSuffix: "(partner)",
    pdfLanguageLabel: "PDF language",
    platePlaceholder: "Plate",
    populatingSelection: "Populating selection…",
    preselectedFromDossiersSuffix: " dossier(s) preselected from /dossiers",
    preselectedLabel: "Preselected dossiers",
    preselectionWaitTitle:
      "Wait for the dossiers to load, or go back to /dossiers if the yellow message above indicates a problem.",
    prevArrow: "← Previous",
    proformaTotalForDossier: "Proforma total for this dossier (= tech + interm)",
    readOnlyNotice: "Read-only — creating a proforma requires edit permission.",
    recipientCompanyLabel: "Recipient company",
    recipientEmailLabel: "Recipient email",
    recipientPartnerLabel: "Partner company (FK app-layer)",
    recipientTechnicianLabel: "Recipient technician",
    recipientTypeIntercompany: "Group company",
    recipientTypePartner: "External partner",
    recipientTypeTechnician: "Technician",
    removeAria: "Remove",
    removeConflictsPre: "Remove the",
    removeConflictsSuf: "conflicting",
    removeConflictsTitlePre: "Remove the",
    removeConflictsTitleSuf: "dossier(s) already in another proforma before creating.",
    removeDossierTitle: "Remove this dossier from the proforma",
    removeHintPost: "or add more below.",
    removeHintPre: "Remove a dossier with",
    retentionLabel: "Retention",
    retentionLabel2: "Retention (%) — applied to all items",
    reviewArrow: "Review →",
    searchPlaceholder: "Search: dossier / plate / invoice no.",
    selectPlaceholder: "— select —",
    step1Title: "Recipient type",
    step2Title: "Select dossiers",
    step3Title: "Review",
    stepDestinatario: "Recipient",
    stepDossiers: "Dossiers",
    stepRevisao: "Review",
    technicianParenSuffix: "(technician)",
    thisProforma: "this proforma",
    toPayTo: "To pay to",
    totalInvoicedClientLabel: "Total invoiced to customer",
    totalInvoicedClientSubtitle: "= Prix Brut − retention (= Total Facture xlsx)",
  },
  proformas: {
    approveBtn: "✓ Approve",
    approveBtnTitle: "Bulk sent → approved transition",
    approveConfirmMsg: "Only proformas in 'sent' are approved. The others are skipped.",
    approveVerb: "Approve",
    cancelBtn: "✕ Cancel",
    cancelBtnTitle: "Cancels the selected proformas (R14: blocks if IC already issued)",
    cancelConfirmLabel: "Cancel proformas",
    cancelReasonMsg:
      "Cancels proformas in any pre-IC state. Reason is required (goes to the audit log).",
    cancelReasonPlaceholder: "E.g. customer withdrew / duplicate",
    cancelVerb: "Cancel",
    clearFilters: "✕ Clear filters",
    clientAll: "All customers",
    clientFilterTitle: "Final customer of the linked dossiers (not the proforma recipient)",
    clientLabel: "Customer",
    colCreatedAt: "Created on",
    colGross: "Gross",
    colInvoiced: "Invoiced",
    colInvoicedTitle: "Invoiced (excl. VAT) to the customer for this proforma's technician",
    colNet: "Net",
    colRecipient: "Recipient",
    colReference: "Reference",
    colStatus: "Status",
    colTecExpected: "Tech. expected",
    colTecExpectedTitle:
      "Technician amount from technician×customer pairs (what the proforma should request)",
    colTecInvoiced: "Tech. invoiced",
    colTecInvoicedTitle: "Amount of the physical invoices already issued by the technicians",
    colTecPct: "Tech. %",
    colTecPctTitle: "Weighted average percentage of the technician commission across the dossiers",
    colType: "Type",
    companyLabel: "Company",
    dateFromTitle: "Start date (created_at)",
    dateToTitle: "End date (created_at)",
    dossiersWord: "dossier(s)",
    emptyState: "No proforma found.",
    errorMany: "errors",
    errorOne: "error",
    errorPrefix: "Error",
    errorTitle: "Error",
    errorsWord: "error(s)",
    importBtn: "📥 Import to BS",
    importBtnTitle:
      "Mirrors the intercompany proformas as dossiers in the destination company (BS)",
    importConfirmLabel: "Import to BS",
    importConfirmMsg:
      "Mirrors the dossiers of the intercompany proformas into the destination company (BS). Idempotent — already imported or non-eligible (non-intercompany, not yet sent) ones are skipped. Does not change the status.",
    importLimitTitle: "Import limited to 200 per call",
    importTitleSuf: "proforma(s) to Brazilian Storms?",
    importVerb: "Import",
    imported: "Imported",
    inBS: "into BS",
    includeDeleted: "Include deleted (cancelled)",
    loading: "Loading…",
    newBtn: "+ New proforma",
    nextPage: "Next →",
    noCompanyAccess: "You do not have access to any company.",
    ofWord: "of",
    okSuffix: "ok",
    pageWord: "Page",
    pdfBtnTitle: "Open the proforma PDF (the one sent by email)",
    pdfErrorPre: "Could not open the PDF: ",
    pdfErrorTitle: "Error",
    periodLabel: "Period (creation)",
    prevPage: "← Previous",
    proformasParen: "proforma(s)",
    proformasParenQ: "proforma(s)?",
    proformasWord: "proforma(s)",
    recipientAll: "All recipients",
    recipientIntercompany: "Intercompany",
    recipientLabel: "Recipient",
    recipientPartner: "Partner",
    recipientTechnician: "Technician",
    rejectReasonMsg: "Reason required for rejection.",
    rejectReasonPlaceholder: "E.g. discrepancy in the invoiced amount",
    rejectVerb: "Reject",
    resendBtnTitle: "Regenerates PDF + resends email",
    resendConfirmLabel: "Resend",
    resendConfirmMsg:
      "Regenerates the PDF and triggers a new send. Individual failures do not block the others.",
    resendEmailBtn: "✉ Resend email",
    resendEmailOfPre: "Resend email for",
    resendLimitTitle: "Email resend limited to 200 per call",
    searchLabel: "Search",
    searchPlaceholder: "Reference / recipient…",
    selectCurrentPage: "Select current page",
    selectedMany: "selected",
    selectedOne: "selected",
    skippedImport: "skipped (not eligible or already imported)",
    skippedMany: "skipped",
    skippedOne: "skipped",
    statusAll: "All statuses",
    statusApproved: "approved",
    statusApprovedOpt: "Approved",
    statusCancelled: "cancelled",
    statusCancelledOpt: "Cancelled",
    statusClosed: "closed",
    statusClosedOpt: "Closed",
    statusDraft: "draft",
    statusDraftOpt: "Draft",
    statusInvoiceReceived: "invoice received",
    statusInvoiceReceivedOpt: "Invoice received",
    statusLabel: "Status",
    statusPaid: "paid",
    statusPaidOpt: "Paid",
    statusRejected: "rejected",
    statusRejectedOpt: "Rejected",
    statusSent: "sent",
    statusSentOpt: "Sent",
    summaryApproved: "Approved",
    summaryCancelled: "Cancelled",
    summaryEmailsSent: "Emails sent",
    summaryStatusUpdated: "Status updated",
    technicianAll: "All technicians",
    technicianFilterTitle:
      "Technician of the dossier lines (not the recipient when type=Technician)",
    technicianLabel: "Technician",
    updateStatusConfirmLabel: "Update",
    updateStatusConfirmMsg: "Only valid transitions will be applied. The others are skipped.",
    updateStatusOptApproved: "Approve (sent → approved)",
    updateStatusOptClosed: "Close (paid → closed)",
    updateStatusOptDefault: "↻ Update status…",
    updateStatusOptPaid: "Mark paid (invoice_received → paid)",
    updateStatusOptRejected: "Reject (sent → rejected)",
    updateStatusOptReopen: "Reopen (rejected → draft)",
    updateStatusOptSent: "Send (draft → sent)",
    updateStatusSelectTitle:
      "Generic status transition (send/approve/reject/reopen/mark_paid/close)",
    updateStatusTitleMid: "for",
    updateStatusTitlePre: "Update status to",
  },
  purchaseInvoices: {
    allSuppliers: "All suppliers",
    attachBtnTitle: "Attach / view invoice PDF",
    attachFilesCta: "+ Attach file(s) (multiple selection allowed · max. 25 MB each)",
    attachmentsHelp:
      "Attach the supplier invoice PDF/image. The document becomes the clickable invoice link in the statement PDF and in the reports sent to the accountant.",
    attachmentsModalTitle: "Purchase invoice attachments",
    bulkAttachTitle: "📎 Bulk attach PDFs:",
    bulkAttachedSuf: "PDF(s) attached successfully.",
    bulkDoneTitle: "Bulk upload completed",
    bulkErrorTitle: "Bulk upload error",
    bulkFailedSuf: "failed to upload",
    bulkHintFolderQuoted: '"Select folder"',
    bulkHintPre: "Name each PDF with the invoice external number (e.g.:",
    bulkHintSuf: "picks them all at once.",
    bulkMatching: "Matching files with invoices…",
    bulkPickFiles: "Select PDFs…",
    bulkPickFilesTitle:
      "Select several PDFs at once; each one is attached to the invoice with the same external number",
    bulkPickFolder: "📁 Select folder",
    bulkPickFolderTitle: "Choose the whole FOLDER of PDFs — no need to select them one by one",
    bulkSendingPre: "Uploading",
    bulkUnmatchedSuf: "with no matching invoice",
    cancelBtn: "cancel",
    cancelFormBtn: "Cancel",
    cancelInvoiceConfirm: "Cancel invoice",
    cancelInvoiceMessage:
      "A cancelled invoice does not appear in totals. Reason required for the audit log.",
    cancelInvoiceTitlePre: "Cancel invoice",
    cancelReasonPlaceholder: "e.g.: the supplier cancelled the order",
    close: "Close",
    colActions: "Actions",
    colCategory: "Category",
    colDate: "Date",
    colExternalNumber: "External no.",
    colHt: "HT",
    colStatus: "Status",
    colSupplier: "Supplier",
    colTtc: "TTC",
    colTva: "TVA",
    colTvaRate: "TVA %",
    companyLabel: "Company:",
    createBtn: "Create invoice",
    createModalTitle: "New purchase invoice",
    creating: "Creating…",
    dupNumberPrefix: "No.",
    dupWarnHint:
      "Check before creating — it may be the same invoice entered with a different number.",
    dupWarnTitle:
      "⚠️ Possible duplicate — an invoice from this supplier with this amount already exists:",
    emptyState: "No invoices found.",
    errInvalidTotalHt: "Invalid total HT.",
    errInvalidTvaRate: "Invalid TVA rate (0..30).",
    errSelectSupplier: "Select a supplier.",
    error: "Error",
    fieldCurrency: "Currency",
    fieldDueDate: "Due date",
    fieldInvoiceNumber: "Invoice no. (supplier)",
    fieldIssueDate: "Issue date",
    fieldNotes: "Notes",
    fieldTotalHt: "Total HT",
    fieldTvaRate: "TVA rate (%)",
    filterAllExceptCancelled: "All (except cancelled)",
    filterCompany: "Company",
    filterSearch: "Search",
    filterStatus: "Status",
    filterSupplier: "Supplier",
    invoiceNumberPlaceholder: "e.g.: HERTZ-2025-0042",
    invoicePlural: "invoices",
    invoiceSingular: "invoice",
    loading: "Loading…",
    markPaidBtn: "mark paid",
    markReceivedBtn: "mark received",
    newBtn: "+ New purchase invoice",
    nextPage: "Next →",
    noAttachmentsYet: "No attachments yet.",
    noCompanyAccess: "You do not have access to any company.",
    ofWord: "of",
    or: "or",
    pageWord: "Page",
    prevPage: "← Previous",
    previewLabel: "Preview",
    removeAttachmentPre: "Delete",
    removeAttachmentSuf: "This action cannot be undone.",
    removeAttachmentTitle: "Delete attachment",
    removeBtn: "delete",
    removeConfirm: "Delete",
    searchPlaceholder: "Search invoice no....",
    sending: "Uploading…",
    statusCancelled: "Cancelled",
    statusCancelledBadge: "cancelled",
    statusDraft: "Draft",
    statusDraftBadge: "draft",
    statusPaid: "Paid",
    statusPaidBadge: "paid",
    statusReceived: "Received",
    statusReceivedBadge: "received",
    uploadFailed: "Failed to upload the file.",
  },
  report: {
    all: "All",
    allFem: "All",
    awaiting: "Awaiting",
    billingCompany: "Billing company",
    cancelled: "Cancelled",
    colCompany: "Company",
    colCustomer: "Customer",
    colDate: "Date",
    colExpectedProfit: "Exp. profit",
    colInvoiced: "Invoiced",
    colPayTech: "Pay tech.",
    colPayTechStatus: "Tech. pay.",
    colPctTech: "% Tech.",
    colPlate: "Plate",
    colQuote: "Quote",
    colReceipt: "Receipt",
    colTechnician: "Technician",
    colToReceive: "To receive",
    companyLabel: "Company:",
    csvDossier: "Dossier",
    csvPaidTechnician: "Paid technician",
    csvPayTechnician: "Pay technician",
    csvPayingCompany: "Paying company",
    csvPaymentStatus: "Payment status",
    csvPctTechnician: "% Technician",
    csvVehicle: "Vehicle",
    customer: "Customer",
    dateFrom: "Start date",
    dateTo: "End date",
    emptyState: 'No entries found. Adjust the filters and click "Generate report".',
    entriesTitle: "Entries for the period",
    expectedProfit: "Expected profit",
    expectedProfitAbbrev: "Exp. profit",
    exportCsvBtn: "Export CSV",
    filtersTitle: "Report filters",
    freeSearch: "Free search",
    freeSearchPlaceholder: "dossier / plate / customer / technician",
    generateReport: "Generate report",
    invoiceNumber: "Invoice No.",
    invoiceNumberPlaceholder: "E.g.: 2025-001",
    invoiced: "Invoiced",
    loading: "Loading…",
    negativeProfitAlert: "entries with negative expected profit in the period.",
    negativeProfitAlertSingular: "entry with negative expected profit in the period.",
    noCompanyAccess: "You do not have access to any company.",
    paid: "Paid",
    paidTechnicians: "Paid technicians",
    payTechnicians: "Pay technicians",
    pending: "Pending",
    quickRange: "Quick range",
    quote: "Quote",
    receiptStatus: "Receipt status",
    receivedPartial: "Partially received",
    receivedTotal: "Fully received",
    recordWord: "records",
    recordWordSingular: "record",
    recordsAbbrev: "rec.",
    sixMonths: "6 months",
    technician: "Technician",
    technicianPaymentStatus: "Technician payment status",
    toReceive: "To receive",
    totalsRow: "Totals",
    truncatedPre: "Result limited to",
    truncatedSuf: "records. Refine the filters to see more.",
    twelveMonths: "12 months",
  },
  reportCaGap: {
    colAmount: "Amount",
    colCaHt: "Revenue excl. tax",
    colDate: "Date",
    colDescription: "Description",
    colMonth: "Month",
    colOpenHt: "Outstanding excl. tax",
    colReceivedHt: "Received excl. tax",
    colTvaCollected: "TVA collected",
    creditsCardSubtitle:
      "Inflows not yet reconciled to any invoice (and that are not personal / partner contribution). These are the prime suspects of a sale received but not invoiced — which explains bilan > Gestion.",
    creditsCardTitle: "Bank credits without an invoice",
    creditsEmpty:
      "No credit without an invoice for the period. 🎉 (Or the statement has not yet been imported / reconciled.)",
    entriesUnit: "entry(ies)",
    eyebrow: "Reports — Revenue gap (excl. tax)",
    kpiCaInvoiced: "Invoiced revenue (excl. tax)",
    kpiCreditsNoInvoice: "Credits without invoice",
    kpiOpen: "Outstanding (excl. tax)",
    kpiReceived: "Received (excl. tax)",
    loading: "Calculating…",
    methodology:
      "Methodology v1 (iterable). Revenue and TVA come from customer invoices; the suspects come from the reconciled statement. If a figure does not match reality, we adjust the rule — it is read-only.",
    monthlyCardTitle: "Invoiced revenue by month (excl. tax)",
    monthlyEmpty: "No invoice issued in the fiscal year.",
    selectPrompt: "Select a company and fiscal year.",
    total: "Total",
    totalCapped: "(200+ — truncated)",
    tvaCardSubtitle:
      "Payable to the State = collected (sales) − deductible (purchases). Compare with the actual transfer on the statement.",
    tvaCardTitle: "TVA for the period",
    tvaCollected: "Collected (sales)",
    tvaDeductible: "Deductible (purchases)",
    tvaDue: "Due",
  },
  suppliers: {
    badgeActive: "active",
    badgeInactive: "inactive",
    cancel: "Cancel",
    colActions: "Actions",
    colDefaultCategory: "Default category",
    colName: "Name",
    colStatus: "Status",
    companyLabel: "Company",
    create: "Create",
    deactivate: "Deactivate",
    deactivateMessage:
      "An inactive supplier does not appear in new invoices. Existing invoices are not affected.",
    deactivatePlaceholder: "E.g. supplier ceased activity",
    deactivateTitlePrefix: "Deactivate supplier",
    editAction: "edit",
    editSupplier: "Edit supplier",
    emptyState: "No suppliers found.",
    fieldCountry: "Country (ISO 2)",
    fieldDefaultCategory: "Default category",
    fieldDefaultTvaRate: "Default TVA rate (%)",
    fieldDisplayName: "Display name",
    fieldEmail: "Email",
    fieldKind: "Type",
    fieldLegalName: "Legal name",
    fieldNotes: "Notes",
    fieldPhone: "Phone",
    fieldSiren: "SIREN (9 digits)",
    fieldSiret: "SIRET (14 digits)",
    fieldVatNumber: "Intra-community TVA",
    filterActive: "Active",
    filterAll: "All",
    filterInactive: "Inactive",
    kindBusiness: "Company",
    kindIndividual: "Individual (freelance)",
    loading: "Loading…",
    newSupplier: "New supplier",
    nextPage: "Next",
    noCompanyAccess: "You do not have access to any company.",
    pageLabel: "Page",
    pageOf: "of",
    prevPage: "Previous",
    reactivate: "Reactivate",
    save: "Save",
    saving: "Saving…",
    searchLabel: "Search",
    searchPlaceholder: "Name, SIRET, vatNumber…",
    supplierPlural: "suppliers",
    supplierSingular: "supplier",
  },
  tasks: {
    backBtn: "Back",
    boardEmpty: "No tasks created yet.",
    boardTitle: "Team tasks",
    cancelBtn: "Cancel task",
    cancelConfirm: "Cancel this task? It disappears from the person's list.",
    cancelledBadge: "Cancelled",
    commentPh: "Comment (optional)",
    companyLabel: "Company",
    confirmBtn: "Confirm",
    createBtn: "Create task",
    created: "Task created. The person sees it in the bell and on the dashboard.",
    descLabel: "Details (optional)",
    doneBtn: "Done",
    dueAtLabel: "Due (date and time)",
    dueBy: "by",
    endLabel: "Ends on (optional)",
    endOfDay: "end of day",
    everyMonthWord: "of every month",
    groupOffice: "Office",
    groupOverdue: "Overdue",
    groupToday: "Today",
    groupUpcoming: "Next 7 days",
    hint: "Office tasks for the team. A task not done on time becomes overdue and stays on the list until it is done.",
    historyLabel: "Recent days",
    kindLabel: "Type",
    kindOnce: "One-off",
    kindRecurring: "Recurring",
    lastDone: "Last done",
    mineEmpty: "No tasks for you.",
    monthDayLabel: "Day of month",
    monthDayWord: "day",
    myCardTitle: "Your tasks",
    newTitle: "New task",
    noAdmin: "Only administrators create tasks.",
    notifMineOverdue: "You have overdue tasks",
    notifMineToday: "Tasks for today",
    notifTeamOverdue: "Team overdue tasks",
    onceWord: "One-off",
    openTasks: "Open tasks",
    overdueWord: "overdue",
    personLabel: "Assigned to",
    personPh: "Choose the person",
    rec_business_days: "Every business day (Monday to Friday)",
    rec_monthly_day: "Every month, on day",
    rec_monthly_last_business: "Last business day of the month",
    rec_weekly: "On chosen weekdays",
    recurringBadge: "Recurring",
    repeatLabel: "Repeats",
    requestedBy: "Requested by",
    showCancelled: "Show cancelled",
    sinceWord: "since",
    skipBtn: "Not applicable",
    skipReasonPh: "Why? (required)",
    st_done: "Done",
    st_doneLate: "Done late",
    st_open: "Open",
    st_overdue: "Overdue",
    st_skipped: "Not applicable",
    startLabel: "Starts on",
    tabMine: "My tasks",
    tabTeam: "Team",
    teamOverdueNone: "No overdue tasks in the team.",
    teamOverdueTitle: "Team overdue tasks",
    timeHint: "Empty = until end of day",
    timeLabel: "By what time",
    title: "Tasks",
    titleLabel: "What to do",
    titlePh: "E.g. Check the issued proformas",
    urgent: "Urgent",
    urgentLabel: "Mark as urgent",
  },
  teamNotices: {
    ackBtn: "Got it",
    cancelBtn: "Cancel",
    closeBtn: "Close",
    closeConfirmMsg: "Are you aware that there are tasks still to complete?",
    closeConfirmNo: "No",
    closeConfirmTitle: "Close the tasks?",
    closeConfirmYes: "Yes, close",
    companyLabel: "Company",
    dayLong1: "Mon",
    dayLong2: "Tue",
    dayLong3: "Wed",
    dayLong4: "Thu",
    dayLong5: "Fri",
    dayLong6: "Sat",
    dayLong7: "Sun",
    doneBtn: "Done",
    doneBy: "done by",
    expiresHint: "Empty = no limit.",
    expiresLabel: "Valid until",
    hint: "The notice opens as a pop-up when the person signs in to Gestion (or the portal, for a technician). “Got it” closes it until the next sign-in; “Done” ends it for that person.",
    infoBadge: "info",
    laterBtn: "Later",
    listEmpty: "No notices yet.",
    listTitle: "Sent notices",
    messagePlaceholder: "E.g. Friday 5 pm, close the week's worklogs.",
    noAdmin: "Only administrators send notices.",
    popupHint: "“Got it” closes until next sign-in · “Done” never shows again.",
    popupNoticesSub: "Information",
    popupOpenTasks: "Open My tasks",
    popupTasksHint:
      "Mark “Done” when finished. “Later” closes it until the next sign-in; an overdue task stays on the list until it is done.",
    popupTasksTitle: "Tasks to do",
    popupTitle: "Information",
    readBy: "read by",
    repeatDoneHint: "Recurring notice: “Done” only counts for today.",
    repeatEvery: "every",
    repeatHint:
      "Shows only on those days (Paris time). “Done” counts for the day; it returns on the next ticked day. Use “Valid until” to end it.",
    repeatLabel: "Repeat on days",
    roleLabel: "Role",
    role_admin: "Administrator",
    role_client: "Customer",
    role_manager: "Site manager",
    role_technician: "Technician",
    role_user: "User",
    role_viewer: "Viewer",
    sendBtn: "Send notice",
    sent: "Notice sent.",
    showFromHint: "Empty = now.",
    showFromLabel: "Show from",
    statusActive: "active",
    statusCancelled: "cancelled",
    statusExpired: "expired",
    statusScheduled: "scheduled",
    targetAll: "Everyone (office + technicians)",
    targetCompany: "Office team (Gestion)",
    targetLabel: "Audience",
    targetRole: "One role",
    targetTechnicians: "All technicians (portal)",
    targetUser: "One person",
    title: "Team notices",
    today: "today",
    userLabel: "Person",
  },
  techPortal: {
    advDeductedIn: "deducted on",
    advHint:
      "The company advanced these amounts. Deduct the total on your next invoice (the proforma e-mail already shows the expected amount).",
    advHistory: "already deducted",
    advNoneOpen: "No open advances.",
    advTitle: "Advances to deduct",
    agendaEmpty: "Nothing scheduled in the coming days.",
    agendaTitle: "Site agenda",
    alreadyInvoicedHint:
      "The previous repair is closed. If the car came back for a new repair, the new quote must be entered in Gestion (by the office or with the quote import button below); it will then appear here for you to take.",
    alreadyInvoicedTitle: "This car's service has already been invoiced",
    camAimPlate: "Fit the plate inside the frame",
    camAimVin: "Fit the VIN inside the frame",
    camClose: "Close",
    camConflictDevis: "but the quote is for",
    camConflictPre: "The VIN is from",
    camDenied:
      "Camera blocked. Allow the camera for this site in the browser settings. Meanwhile, type it.",
    camNotFound: "Not in Gestion — still reading.",
    camOffline: "No connection — still trying.",
    camPickOne: "Which of these cars?",
    camRetry: "Read again",
    camStarting: "Opening the camera…",
    camTitlePlate: "Plate",
    camTorch: "Torch",
    camType: "Type",
    camUnavailable: "Camera unavailable on this device — type it.",
    camUseAnyway: "Use it anyway",
    carClosedNoTechHint:
      "The manager recorded the delivery, but nobody took this car in the portal. Ask the office to assign the technician in the dossier — only then does the car enter your list and your payment.",
    carClosedNoTechTitle: "Car delivered with no technician assigned",
    carRepairedHint: "All services on this car are complete.",
    carRepairedTitle: "Vehicle already repaired",
    chkCielLabel: "Headliner",
    chkClaimQ: "How will you repair this car?",
    chkClearIssue: "Clear the flag",
    chkCompleteBadge: "Checklist complete",
    chkCrackedBtn: "Cracked",
    chkDefectBtn: "Damaged",
    chkFranchiseEditBtn: "Edit deductible",
    chkIncompleteHint: "Checklist incomplete — complete the points below to unlock the repair.",
    chkIssueNotePlaceholder: "What is wrong? (optional)",
    chkIssuesBrokenSummary: "part(s) broken during the work",
    chkIssuesDefectSummary: "part(s) already faulty",
    chkMarkBroken: "Broke during the work",
    chkMarkDefect: "Part already faulty",
    chkMileageLabel: "Mileage (km)",
    chkMileagePh: "E.g. 45200",
    chkMissingCiel: "answer the headliner",
    chkMissingPareBrise: "answer the windshield",
    chkMissingPhoto: "photo",
    chkMissingPhotos: "photos",
    chkMissingPre: "Missing:",
    chkMissingSignature: "customer signature",
    chkNextPhotoPre: "Next photo:",
    chkOkBtn: "OK",
    chkPareBriseLabel: "Windshield",
    chkPhotoAngle1: "Front left",
    chkPhotoAngle2: "Front right",
    chkPhotoAngle3: "Rear left",
    chkPhotoAngle4: "Rear right",
    chkPhotoCameraBtn: "Camera",
    chkPhotoCancelBtn: "Cancel",
    chkPhotoDashboard: "Dashboard (ignition on)",
    chkPhotoDoorTrim1: "Door trim 1",
    chkPhotoDoorTrim2: "Door trim 2",
    chkPhotoDoorTrim3: "Door trim 3",
    chkPhotoDoorTrim4: "Door trim 4",
    chkPhotoDoorTrim5: "Door trim 5",
    chkPhotoFree: "Extra photo",
    chkPhotoFront: "Front",
    chkPhotoFrontLeft: "Front left side",
    chkPhotoFrontRight: "Front right side",
    chkPhotoGalleryBtn: "Gallery",
    chkPhotoHeadliner: "Damaged headliner",
    chkPhotoHeadlinerFront: "Headliner — front",
    chkPhotoHeadlinerRear: "Headliner — rear",
    chkPhotoHood: "Hood",
    chkPhotoHoodLiner: "Hood liner",
    chkPhotoRear: "Rear",
    chkPhotoRearLeft: "Rear left side",
    chkPhotoRearLight1: "Rear light 1",
    chkPhotoRearLight2: "Rear light 2",
    chkPhotoRearLight3: "Rear light 3",
    chkPhotoRearRight: "Rear right side",
    chkPhotoRoof: "Roof",
    chkPhotoSourcePre: "Photo:",
    chkPhotoTake: "Take",
    chkPhotoWindshield: "Cracked windshield",
    chkPhotosDone: "Photos complete",
    chkPhotosTitle: "Vehicle photos (required)",
    chkRetakePhoto: "Retake the photo",
    chkSaveBtn: "Save checklist",
    chkSavedMsg: "Checklist saved.",
    chkSaving: "Saving…",
    chkSignClear: "Clear",
    chkSignHint: "Sign with your finger in the white box",
    chkSignNamePh: "Signer name",
    chkSignTitle: "Customer signature",
    chkSignedBadge: "Signature recorded",
    chkTakePhotoBtn: "Take photo",
    chkTitle: "Vehicle checklist",
    chkUploading: "Uploading…",
    claimDemontageHint: "The refit stays with you unless another technician takes it.",
    claimDemontageQ: "Take the disassembly?",
    claimDevisNoPanels:
      "Quote has no parts table (imported before the parser — ask for a PDF re-upload)",
    claimFranchisePre: "Deductible of",
    claimFranchiseSuf: "deducted from the calculation base — quote untouched.",
    claimFranchiseSufParticular:
      "individual client: full invoice (credit note); commissions on reduced base.",
    claimMontage: "Take the disassembly",
    claimMontageOnly: "Take only the disassembly/refit",
    claimNeedsReception: "Save the reception above to unlock taking the car.",
    claimNoMontage: "This quote has no disassembly — nothing for the assembler on this car.",
    claimOkPre: "✓ Taken:",
    claimPdr: "Take PDR only",
    claimPdrMontage: "Take PDR + Assembly",
    claimedAlready: "You already took this car",
    commissionDemontage: "Removal",
    commissionFixedBadge: "fixed amount",
    commissionMontageHalf: "Refit",
    commissionPendingHint: "to do",
    commissionTbd: "to be set",
    degarnissageGarageBtn: "Disassembly done by the garage (third party)",
    degarnissageGarageConfirm:
      "Confirm: the removal and refit of this car were done by the garage? Nobody at ES/BS will be paid for them.",
    degarnissageGarageDone: "Disassembly recorded as done by the garage.",
    deposeReposeLabel: "Remove/Refit",
    devisHtLabel: "Estimate (excl. VAT)",
    devisNetOfFranchise: "deductible already deducted",
    docsA1: "A1 certificate or URSSAF certificate",
    docsAllDone: "Documents complete. Thank you.",
    docsBannerTitle: "Your documents are missing",
    docsDaysLeftPre: "You have",
    docsDaysLeftSuf: "days to send them.",
    docsIdentity: "ID document",
    docsIdentity2: "Identity card",
    docsKbis: "Kbis / self-employed proof",
    docsKbis2: "Kbis or company registration (articles of association)",
    docsLastDay: "Last day of the deadline.",
    docsOverdue: "Deadline passed — send today.",
    docsRcPro: "Professional liability insurance",
    docsSendBtn: "Send",
    docsSending: "Sending…",
    docsSentBadge: "sent",
    docsUrssaf: "URSSAF certificate or A1 certificate",
    filterAll: "All",
    filterMonth: "Last month",
    filterRange: "Date range",
    filterSince: "Since 01/05/2026",
    filterThisWeek: "This week",
    filterWeek: "Last 7 days",
    foundInOtherCompanyPre: "This car is in company",
    hidePhotosBtn: "Hide photos",
    impactsWord: "impacts",
    impersonatingBy: "by",
    impersonatingExit: "Exit view",
    impersonatingPre: "Viewing as",
    importAtelierLabel: "Workshop / service location",
    importAtelierPlaceholder: "— choose the workshop —",
    importChantierHint:
      "The customer comes from the name printed on the quote and joins the site. Use this for a private customer's car.",
    importClientPlaceholder: "— pick the client —",
    importExistsPre: "This quote ALREADY EXISTS in Gestion — nothing was duplicated. Vehicle:",
    importHint:
      "Got a quote on-site that the search can't find? Pick the site's client and upload the PDF — the car is created and you can claim it.",
    importLink: "or import a quote (PDF)",
    importNoClients: "No client linked to you — ask the office to configure the commission pair.",
    importOkPre: "Quote imported:",
    importPanelsWord: "panels",
    importPhotoBtn: "Import from photo / screenshot",
    importPhotoFail:
      "Could not read the quote from the photo — try a sharper screenshot or use the PDF.",
    importPhotoHint:
      "A screenshot works better than a paper photo. Reading happens on your device; first use downloads the reader (~6 MB).",
    importPhotoReading: "Reading the photo…",
    importPickBtn: "Pick PDF and import",
    importReadFail: "Could not read the file — try again (outside any zip).",
    importScanCancelBtn: "Cancel",
    importScanConfirmBtn: "Import with this plate",
    importScanFail:
      "Could not read the scanned PDF. Photograph the quote in good light and use the photo button.",
    importScanPlatePrompt: "Plate read from the quote — confirm or fix before importing:",
    importScanReading: "Scanned PDF — reading the text with on-device OCR…",
    importTitle: "Import quote (PDF)",
    importing: "Importing…",
    logout: "Log out",
    menuBtnAria: "Menu",
    menuHome: "Home",
    modePlate: "Plate",
    montageEndPhotosTitle: "End-of-work photos",
    montageExternalBtn: "Refit done by a third party (garage)",
    montageExternalConfirm:
      "Confirm: the refit of this car was done by a third party (garage)? Nobody at ES/BS will be paid for it.",
    montageExternalDone: "refit done by a third party (garage)",
    montageExternalHint: "Nobody at ES/BS is paid for this step.",
    montageHtLabel: "Assembly (excl. VAT)",
    montagePhotosTitle: "Disassembly photos",
    montageShort: "Assembly",
    myCarsEmpty: "No cars taken yet.",
    myCarsTitle: "My cars",
    myCommissionMontage: "Your commission (Assembly)",
    myCommissionPdr: "Your commission (PDR)",
    myTasksDoneBtn: "Done",
    myTasksDue: "Due",
    myTasksHint: "Tap Done when finished. An overdue task stays here until it is done.",
    myTasksLaterBtn: "Later",
    myTasksOverdue: "Overdue",
    myTasksTitle: "Office tasks",
    myTasksToday: "Today",
    mycarsMarkPhasesBtn: "Mark removal / refit (opens the car)",
    navCars: "Cars",
    navMore: "More",
    navPayments: "Payments",
    navScanner: "Scan",
    navWorklog: "Worklog",
    noPairHint:
      "This car belongs to a customer you have no pair with, and the customer is not attached to a site where you have one. Ask the office to set up the pair or attach the customer to the site.",
    noPairTitle: "Car found, but it is not assigned to you",
    noResults: 'No car "to execute" with this plate. Check the plate or contact the office.',
    notLinkedNote:
      "⚠ Account not yet linked to a technician record — ask the office (Technicians → edit → Portal account).",
    notTechnicianNote: "Your account has no technician role in any company.",
    noticeAckBtn: "Got it",
    noticeAckHint: "Got it: back at next sign-in · Done: never again.",
    noticeBlockedHint: "Finish the pending tasks or contact the office:",
    noticeBlockedTitle: "Portal locked",
    noticeBlockedWait:
      "Only the office can unlock the portal (new vehicle, quote import and scanner).",
    noticeDoneBtn: "Done",
    noticeTitle: "Message from the office",
    openCarBtn: "Open the car",
    openCarsMontage: "reassembly not recorded · disassembly:",
    openCarsNoMontage: "quote disassembly not recorded — take it or declare it done by the garage",
    openCarsNote:
      "Your PDR is done, but the reassembly has not been recorded. Finish the vehicle: record the reassembly or tell the fitter.",
    openCarsOpen: "Open",
    openCarsTitle: "Vehicles you started and have not finished",
    otherCarsHint:
      "To take this car the quote is needed — import the PDF below or contact the office.",
    otherCarsTitle: "This plate is already in Gestion, but with no imported quote:",
    otherCarsWith: "with",
    panelsTitle: "Panels to repair",
    parcCarBtn: "Parc car",
    parcChoiceLater:
      "The amount is set when you take the car, after the reception: PDR only, or PDR + disassembly/assembly.",
    parcChooseAtelier: "— choose the workshop —",
    parcChooseCategory: "— choose the category —",
    parcChooseClient: "— choose the customer —",
    parcCreateBtn: "Register parc car",
    parcCreatedPre: "Parc car registered — do the reception:",
    parcImportPdfBtn: "Import the quote PDF",
    parcMakePh: "Make",
    parcModelPh: "Model",
    parcNoneHint: "None of your customers has parc car categories — contact the office.",
    parcOnlyPdr: "PDR only",
    parcPlateLabel: "Plate:",
    parcWithMontage: "PDR + disassembly/assembly",
    parcYouReceive: "you receive",
    pdrDoneBtn: "Mark PDR finished",
    pdrDoneQ: "Finished the PDR on this car?",
    pdrPendingNote: "Finish the PDR of these cars before taking another car:",
    pendingTasksBtn: "Pending tasks",
    pendingTasksClose: "Close",
    pendingTasksHint:
      "You can close this and check your cars, but you cannot take or add a new car while a PDR is not marked finished.",
    pendingTasksNone: "No pending tasks.",
    pendingTasksTitle: "Pending tasks",
    periodAria: "Period",
    phaseBothDoneBy: "Removal and refit done by",
    phaseDemontageBtn: "Mark removal as done",
    phaseDemontageByPre: "Removed by",
    phaseDemontageDone: "Disassembly done",
    phaseDemontageTitle: "Disassembly",
    phaseDoneDemontageHint:
      "It is already in your list as disassembled. The refit is still pending.",
    phaseDoneDemontageMsg: "Car disassembled",
    phaseDoneMontageHint: "Work finished on this car.",
    phaseDoneMontageMsg: "Car reassembled",
    phaseExternalShort: "third party (garage)",
    phaseMontageAfterDemontage: "2 · Reassembly — after finishing the disassembly.",
    phaseMontageBtn: "Mark refit as done",
    phaseMontageDone: "Assembly done",
    phaseMontagePending: "refit still pending",
    phaseMontageTitle: "Assembly",
    photoUploadFailPre: "The photo did not upload:",
    photosDemontage: "Removal",
    photosMontageEnd: "End of work",
    photosReception: "Reception",
    plateLabel: "Plate",
    prodAllTime: "All time",
    prodCar: "car",
    prodCars: "cars",
    prodPaid: "Paid",
    prodTbdNote: "cars whose amount is still to be calculated are not counted",
    prodTitle: "My production",
    prodToReceive: "to receive",
    readOnlyNote:
      "View-only account: you can see the cars you did and the status of each payment, but you cannot add or change anything.",
    recAmountPh: "Deductible amount (€ incl. VAT)",
    recDamagesPh: "Pre-existing damage/broken parts (optional, comma-separated)",
    recDoneLabel: "Reception done",
    recFranchiseFirstHint: "Answer the deductible question to unlock the reception photos.",
    recFranchisePre: "Deductible:",
    recFranchiseQ: "Does the vehicle have a deductible discount to the client?",
    recFranchiseStep: "1 · Deductible — required",
    recHint:
      "Answer the deductible and note pre-existing damage. The site manager can also do this — if done, the car arrives unlocked.",
    recHintNoPhotos:
      "Outside the site there are no photos: just say whether the car has a deductible (required) and take the job.",
    recIncompleteWait:
      "Reception incomplete — whoever did it (manager, senior or PDR technician) must complete it before you take the job.",
    recNo: "No",
    recNoFranchise: "no deductible",
    recPhotosStep: "2 · Damages and photos",
    recSaveBtn: "Save reception",
    recSavedMsg: "Reception saved — the car is unlocked for repair.",
    recSaving: "Saving…",
    recTitle: "Vehicle reception (required before repairing)",
    recWaitingHint:
      "On a site, reception (deductible, checklist, photos and signature) is done by the manager or the senior technician; off-site, by the car's PDR technician. You can take the job afterwards.",
    recWaitingTitle: "Waiting for reception",
    recYes: "Yes",
    repairedAtPre: "Taken on",
    roleMontador: "Assembler",
    rolePdr: "PDR technician",
    rowDemontageDone: "removed",
    rowMontageDone: "refitted",
    rowPaid: "Paid",
    rowPaidPartial: "Partly paid",
    scanFail: "Could not read the photo — get closer, avoid glare and retry, or type it.",
    scanTitle: "Read with the camera",
    scanWarn_car_existed:
      "The car already existed in Gestion — file completed, nothing duplicated.",
    scanWarn_customer_created: "New customer created from the quote.",
    scanWarn_customer_matched: "Customer matched to an existing record.",
    scanWarn_devis_linked_existing: "Quote number linked to the existing file.",
    scanWarn_make_model_backfilled: "Vehicle make/model filled in from the quote.",
    scanWarn_num_from_filename: "Quote number taken from the file name.",
    scanWarn_plate_confirmed: "Plate confirmed by you.",
    scanWarn_scan_deg_adjusted:
      "Dégarnissage adjusted from Total HT (the box was unreadable for OCR).",
    scanWarn_scan_dsp_derived: "Total DSP computed from Total HT (OCR did not read the DSP box).",
    scanWarn_scan_ht_from_sum: "Total HT computed as the sum of the items.",
    scanWarn_scan_ht_from_ttc: "Total HT computed from the TTC.",
    scanWarn_scan_no_client: "Customer name not identified.",
    scanWarn_scan_no_date: "Quote date not recognised.",
    scanWarn_scan_no_panels: "Panels and impacts not extracted from the diagram (scanned quote).",
    scanWarn_scan_no_plate: "Plate not identified on the document.",
    scanWarn_scan_ocr:
      "Scanned quote read by OCR — check plate, customer and amounts against the document.",
    scanWarn_scan_plate_ocr: "Plate read by OCR — check it.",
    scanWarn_scan_sum_mismatch: "The sum of the items differs from Total HT — check the document.",
    scanning: "Reading the photo…",
    searchBtn: "Search",
    searchCarBtn: "Find the car",
    searchHint:
      "Enter a plate OR a VIN to find the vehicle. The ⇄ button switches between the two fields.",
    searching: "Searching…",
    servicePdrLabel: "PDR",
    servicesTitle: "Services on this car",
    showPhotosBtn: "See photos",
    sitDone: "Done · to receive",
    sitInRepair: "In repair",
    sitMontage: "Assembly to do",
    statusAria: "Payment status",
    statusPaid: "Paid",
    statusPending: "To receive",
    switchCompanyBtn: "View in",
    takeDemontageBtn: "Take the removal",
    takeHint: "You get this half, at your own rate with the customer.",
    takeMontageBtn: "Take the refit",
    takeOwnMontageBtn: "Take the reassembly",
    takeOwnMontageHint:
      "Disassembly done. Take the reassembly when you start it — until then another technician may take it.",
    title: "Technician Portal",
    toastDemontageDone: "Disassembly finished",
    toastDemontageTaken: "Disassembly taken",
    toastMontageDone: "Reassembly finished",
    toastPdrDone: "PDR job finished",
    toastPdrStarted: "PDR job started",
    weekWord: "Week",
    worklogEmpty: "No production this week.",
    worklogPdfBtn: "Download PDF",
    worklogTitle: "Worklog (PDF)",
    worklogWeekPre: "Week",
  },
  techSignup: {
    backToLogin: "I already have an account",
    countryLabel: "Country where you work",
    docsNotice:
      "Once approved, the portal will ask for your documents: identity card, Kbis or equivalent, and — depending on where you live — the URSSAF certificate (residents in France) or the A1 certificate. You have 7 days to send them; work does not wait for them.",
    emailHint: "This will be your login. You will receive the password link there.",
    emailLabel: "Email",
    errorRequired: "Fill in name, email, phone and country.",
    intro: "Fill in your details. Euro Storm reviews them and opens your portal access.",
    langLabel: "Portal language",
    nameLabel: "Full name",
    phoneLabel: "Phone / WhatsApp",
    residenceHint: "This is what defines which documents we will ask for later.",
    residenceLabel: "Country of residence / work permit",
    roleDebosselage: "PDR technician",
    roleLabel: "What you do",
    roleMontage: "Fitter (remove and refit)",
    sending: "Sending…",
    submitBtn: "Submit registration",
    subtitle: "Technician registration",
    successBody:
      "Euro Storm will review your details. Once approved, you will get an email to create your password.",
    successTitle: "Registration submitted.",
  },
  technicianDetail: {
    approvalRate: "Approval rate",
    auditLogOfTechnician: "Technician audit log",
    auditRequiresAdmin: "Audit log requires admin permission.",
    avgDaysToPayment: "Average days to payment",
    avgInvoicedPerLine: "Average invoiced per line",
    backToList: "Back to list",
    colAction: "Action",
    colAmount: "Amount",
    colBy: "By",
    colCode: "Code",
    colCustomer: "Customer",
    colDate: "Date",
    colInvoiceNumber: "Invoice no.",
    colIssueDate: "Issue date",
    colMethod: "Method",
    colNumberExternal: "No. (external)",
    colPeriod: "Period",
    colPlate: "Plate",
    colReason: "Reason",
    colReference: "Reference",
    colStatus: "Status",
    colTi: "TI",
    colTotal: "Total",
    colWhen: "When",
    commissionsByCustomer: "Commissions (per customer)",
    configureCommissions: "Configure commissions",
    country: "Country",
    createPortalAccess: "Create portal access",
    dossiers: "Dossiers",
    dossiersOfTechnician: "Technician dossiers",
    emptyAudit: "No events.",
    emptyDossiers: "No dossiers in this window.",
    emptyInvoices: "No invoices in this window.",
    emptyPayments: "No payments in this window.",
    financial: "Financial",
    inactive: "inactive",
    invalidId: "Invalid ID.",
    invoicedHtLines: "Invoiced excl. VAT (lines)",
    invoicesIssuedByTechnician: "Invoices issued by technician",
    linesHandled: "Lines handled",
    list: "List",
    loading: "Loading…",
    net: "net",
    noPairConfigured: "no pair configured",
    notFound: "Technician not found in accessible companies.",
    noticesBlockHint:
      "The technician cannot take a new vehicle, import a quote or use the scanner. “Got it” does not unlock: only the “Task done — unlock” button here.",
    noticesBlockLabel: "Lock the portal until the office releases it",
    noticesBlockedBadge: "portal locked",
    noticesDonePre: "done on",
    noticesEmpty: "No messages sent.",
    noticesHint:
      "The notice pops up every time the technician enters the portal. “Got it” closes it until next sign-in; “Done” ends it. Write in their language. For the whole team, use the Team notices menu.",
    noticesNoLogin: "This technician has no portal login.",
    noticesPlaceholder: "E.g.: finish cars GE-707-JH and GC-166-WP in the portal…",
    noticesReadPre: "read on",
    noticesResolveBtn: "Task done — unlock the portal",
    noticesResolvedPre: "unlocked on",
    noticesSendBtn: "Send message",
    noticesTitle: "Message in the technician portal",
    noticesUnread: "not read yet",
    open: "open",
    operational: "Operational",
    paymentsToTechnician: "Payments to technician",
    period12m: "Last 12 months",
    period30d: "Last 30 days",
    period3m: "Last 3 months",
    period6m: "Last 6 months",
    periodAll: "All",
    periodCustom: "Custom dates",
    periodSince: "Since 01/05/2026 (Gestion start)",
    periodYear: "Current year",
    phone: "Phone",
    portalRoleLabel: "Portal role",
    registration: "Profile",
    reversal: "reversal",
    statusApproved: "approved",
    statusCancelled: "cancelled",
    statusCustomerReceived: "received",
    statusDraft: "draft",
    statusIssued: "issued",
    statusPaid: "paid",
    statusPending: "pending",
    statusReceived: "received",
    statusRejected: "rejected",
    tabAudit: "Audit log",
    tabFaturas: "Technician invoices",
    tabNotices: "Portal messages",
    tabPagamentos: "Payments",
    tabResumo: "Summary",
    tabWorklog: "Worklog",
    taxId: "Tax ID",
    toPay: "To pay",
    total: "total",
    totalIssuedByTechnician: "Total issued by technician",
    totalPaid: "Total paid",
    window: "Window",
    wlAwaitingClient: "Awaiting client",
    wlByCustomer: "Revenue by client",
    wlCardFilterHint: "Click a card to filter the list below.",
    wlCarsWord: "cars in period",
    wlClearFilter: "clear filter",
    wlClientInvoiced: "Invoiced",
    wlClientPaidBadge: "Received",
    wlClientReceived: "Received from customer",
    wlClientToInvoice: "To invoice",
    wlColCar: "Car",
    wlColClientReceived: "Customer paid",
    wlColCommission: "Commission",
    wlColProduced: "Produced",
    wlColService: "Service",
    wlEmpty: "No service lines in the period.",
    wlMontage: "Assembly",
    wlNoPairBtn: "Configure pairs",
    wlNoPairChip: "Technician×client pair missing or at 0% — commission not calculated",
    wlNoPairPre: "Commission at zero — technician×client pair missing or at 0% with:",
    wlNoPairShort: "no pair",
    wlNoPairSuf:
      "Edit the pair's % (and save the row), then use 'Recalculate commissions' in Dossiers.",
    wlOfProduced: "of produced",
    wlPaidBeforeClient: "Paid before the customer",
    wlPaidBeforeClientHint:
      "The technician was paid for this car before the customer paid (advanced by the company).",
    wlPayBtn: "Pay released",
    wlPendingCalc: "lines to calculate",
    wlProduced: "Produced (invoiced)",
    wlProducedShort: "prod.",
    wlProducedSub: "excl. VAT value of his cars",
    wlReceived: "Paid to technician (period)",
    wlReceivedShort: "rec.",
    wlReleased: "Released (client paid)",
    wlRemaining: "Remaining",
    wlShareDemontage: "Disassembly (half)",
    wlShareMontage: "Reassembly (half)",
    wlStatusAwaiting: "Awaiting client",
    wlStatusReleased: "Released",
    wlTbd: "tbd",
    wlToReceive: "Revenue to receive (commissions)",
  },
  technicianPayments: {
    advAccountHint:
      'Each advance stays open until the technician deducts it on their invoice (ticked in "Record received invoice").',
    advAmount: "Amount",
    advBankHint:
      'Paid from the company account? Then reconcile the debit in the statement and tick "It is an advance to a technician" there — do not enter it here.',
    advCancel: "Cancel",
    advCancelMsg: "Reason for cancelling (kept in the history):",
    advCancelTitle: "Cancel advance",
    advDate: "Date",
    advDescription: "Description",
    advDescriptionHint: "E.g. Ibis hotel 3 nights, PDR PILLON tools…",
    advFormIncomplete: "Pick the technician, enter an amount above zero and a description.",
    advNew: "New advance",
    advNoneOpen: "No open account advances.",
    advOrigin: "Origin",
    advOriginAdjustment: "quote adjustment",
    advOriginBank: "Company account (statement)",
    advOriginCash: "Cash",
    advOriginPartner: "Partner's pocket / account",
    advPartnerNote: "Paid from the partner's pocket (do not leave the company's cash):",
    advSave: "Save",
    allPayers: "All payers",
    allPaymentStatuses: "All payment statuses",
    allTechnicians: "All technicians",
    amountLabel: "Amount (€)",
    backAllTechs: "All technicians",
    byTechCars: "car(s)",
    byTechColAdvanced: "Advanced",
    byTechColAdvancedTitle: "Account advances not yet deducted from the technician's invoice",
    byTechColPaid: "Paid",
    byTechColPending: "Pending",
    byTechColReleased: "Released (to pay)",
    byTechColWaiting: "Awaiting client",
    byTechHint:
      "Click a technician to open their lines. Released = the client already paid; Awaiting = the client invoice is still open.",
    byTechLines: "line(s)",
    cancel: "Cancel",
    cardNoInvoice: "No technician invoice",
    cardPaid: "Paid",
    cardPaidTotal: "Fully paid",
    cardToPay: "To pay",
    cardWaiting: "Pending",
    clearBtn: "Clear",
    clearFilters: "Clear filters",
    clearFiltersTitle: "Reset all filters to default",
    colAction: "Action",
    colAttachment: "Attachment",
    colCustomer: "Customer",
    colCustomerInvoice: "Customer invoice",
    colDossier: "Dossier",
    colInvoiceStatus: "Invoice status",
    colPaid: "Paid",
    colPaymentStatus: "Payment status",
    colPlate: "Plate",
    colSituation: "Status",
    colTechnician: "Technician",
    colToPay: "To pay",
    colVehicle: "Vehicle",
    commissionInvalid: "Invalid commissionPercent (0..100).",
    commissionLabel: "Commission (%) — optional",
    createProforma: "Create proforma",
    creating: "Creating…",
    custRecAll: "All",
    custRecReceived: "Received (payout released)",
    custRecWaiting: "Waiting for customer",
    customMessageLabel: "Custom message (optional)",
    cxAdvances: "Open advances",
    cxAdvancesAccount: "account advances",
    cxAdvancesAccountTitle:
      "Hotel, tools, partner's money… deducted from the technician's next invoice",
    cxAdvancesTitle:
      "Cars not yet paid by the customer but already paid to the technician or in a proforma",
    cxAvailable: "Available to pay out",
    cxBankBalance: "Statement balance",
    cxBankBalanceNone: "no balance imported: import the latest statement in Bank → Import",
    cxBankBalanceTitle:
      "Balance stated by the last imported bank file, at the statement date. Not computed by Gestion.",
    cxColAdvanced: "Advanced",
    cxHint:
      "Received money is shared: you can advance one technician's cars (\"Awaiting customer\" tab) with another's cash. Each car is paid only once — in a proforma or paid, it never comes back.",
    cxInProforma: "Already in a proforma",
    cxNoAdvances: "No open advances.",
    cxOverBankPre: "The available amount exceeds the statement balance by",
    cxOverBankSuf:
      "Pay up to the smaller of the two (the money received also paid taxes, suppliers and partners).",
    cxPaidBefore: "paid before customer",
    cxReleasedFree: "Received, to pay out (no proforma)",
    dateFrom: "Start date",
    dateTo: "End date",
    degPendingHint:
      "Each part of the vehicle (PDR, disassembly, reassembly) is paid once, to whoever did it. You can pay what is ready now; the rest goes into the next proforma of whoever does it.",
    degPendingOther:
      "another technician's disassembly or reassembly is still missing (not in this proforma)",
    degPendingOwn:
      "this technician's disassembly or reassembly is not done yet: that part goes into a later proforma",
    degPendingTitle: "Trim removal not finished on these vehicles",
    detailsHint:
      "Totals cover the whole filter. Click a car to see the split, the technician invoice and pay.",
    devisLabel: "Quote",
    diffTechnicians: "different technicians — select from the same technician",
    emptyState: "No entries found.",
    entryPlural: "entries",
    entrySingular: "entry",
    extBtn: "Record paid outside",
    extBtnHint: "The technician was already paid outside the pro forma (in-house team)",
    extDate: "Payment date",
    extHint:
      'For someone already paid outside the pro forma: in-house team, salary, cash or bank transfer. Gestion creates an internal record (INT) already paid: the pieces become paid and leave "to pay". No e-mail, no PDF, nothing in the bank or in the advances. Undo: on the record\'s page (admin).',
    extIntermPre: "The intermediary's share",
    extIntermSuf: "is not part of this record: only the technician's share becomes paid.",
    extMethod: "Method",
    extMethodDinheiro: "Cash",
    extMethodOutro: "Other",
    extMethodSalario: "Salary (in-house team)",
    extMethodTransferencia: "Bank transfer",
    extNote: "Reason / note (required)",
    extNotePh: "e.g. October salary, in-house team",
    extSubmit: "Record payment",
    extTitle: "Record a payment made outside the pro forma",
    filterCompany: "Company",
    filterCustomerReceived: "Customer paid",
    filterPayer: "Paying company",
    filterPaymentStatus: "Payment status",
    filterPeriod: "Period (invoice date)",
    filterSearch: "Search",
    filterSortBy: "Sort by",
    filterTechnician: "Technician",
    flowDetected: "Detected flow:",
    flowDirect: "Direct to the technician",
    flowExternal: "External intermediary",
    flowExternalPre: "This technician is paid through",
    flowExternalSuf: "(external intermediary). Generate the payment in Intermediaries.",
    flowGroup: "Group company (intercompany)",
    flowMismatchHint:
      "The proforma uses the LINE amounts. Fix the lines' commission in the file before generating.",
    flowMismatchLines: "lines",
    flowMismatchPair: "pair",
    flowMismatchTitle: "Lines calculated with a different intermediary share than the pair:",
    flowPreviewError: "Could not determine the recipient.",
    flowSourceNote:
      "Decided by each car's technician × customer pair (or by the technician's registered intermediary).",
    forceOverride: "Force (admin override)",
    gateBlocked: "Payment gate (F10.3) blocked:",
    generateProforma: "Generate proforma",
    inProforma: "In proforma",
    invStatusApproved: "approved",
    invStatusPending: "no invoice",
    invStatusReceived: "received",
    invStatusRejected: "rejected",
    invalidAmount: "Invalid amount.",
    invoiceLabel: "Invoice",
    invoicedLabel: "Invoiced",
    kpiPrefix: "KPIs reflect the current page",
    kpiSuffix: "lines in the filter",
    lineInProforma: "Line is already in proforma",
    linePlural: "lines",
    lineSelectedPlural: "lines selected",
    lineSelectedSingular: "line selected",
    lineSingular: "line",
    linesSubtitle: "lines",
    loading: "Loading…",
    loadingTechnician: "Loading technician…",
    methodBankTransfer: "Bank transfer",
    methodCard: "Card",
    methodCash: "Cash",
    methodCheck: "Check",
    methodLabel: "Method",
    methodOther: "Other",
    next: "Next",
    noCommissionTag: "no commission",
    noCommissionTitle:
      "Cars paid by the customer with no commission computed: the technician × customer pair is not configured.",
    noCommissionWarn:
      "car(s) paid by the customer have NO commission computed (technician × customer pair not configured) and are not counted in the released amount. Configure the pair on the technician's record.",
    noCompanyAccess: "You don't have access to any company.",
    noInvoiceAlert:
      "This line doesn't have a technician invoice yet. Create the technician_invoice before paying.",
    noTechInvoice: "not received yet",
    noTechnicianData: "No technician data.",
    notReceived: "not received yet",
    notesLabel: "Notes (optional)",
    of: "of",
    optCancelled: "Cancelled",
    optPaid: "Paid",
    optPending: "Pending",
    overridePlaceholder: "Justification (min 5 chars) — recorded in audit log",
    pageWord: "Page",
    paidAtLabel: "Paid on",
    payBtn: "Pay",
    payDialogTitle: "Record technician payment",
    payStatusCancelled: "cancelled",
    payStatusPaid: "paid",
    payStatusPending: "pending",
    payTitle: "Record payment",
    payTitleNoInvoice: "Create technician_invoice first",
    pdfLanguageLabel: "PDF language",
    pillReleased: "Released",
    pillWaiting: "Awaiting customer",
    prev: "Previous",
    proformaDialogTitle: "Generate technician proforma",
    proformaTechnicianNote: "Technician proforma — administrative trigger does NOT fire.",
    receivedOn: "received on",
    receivedWord: "received",
    recipientLabel: "Recipient:",
    recipientTypeLabel: "Recipient type:",
    referenceLabel: "Reference (optional)",
    register: "Record",
    retentionInvalid: "Invalid retentionPercent (0..100).",
    retentionLabel: "Retention (%)",
    saving: "Recording…",
    searchPlaceholder: "Invoice no. / dossier / plate…",
    selAdvanceOver: "advance exceeds available:",
    selAdvancePart: "advance",
    selIntermPart: "intermediary",
    selReleasedPart: "released",
    selTechPart: "technician",
    selectFreeLines: "Select free lines",
    selectionLabel: "Selection",
    sortDefault: "Order: date ↓ (default)",
    sortInvoiceAsc: "Invoice no. ↑",
    sortInvoiceDesc: "Invoice no. ↓",
    sortTitle: "Sorting",
    stageAll: "All",
    stageReleased: "Released to pay out",
    stageReleasedShort: "released",
    stageWaiting: "Awaiting customer",
    stageWaitingShort: "waiting",
    statusWord: "status",
    techInvoiceLabel: "Technician invoice",
    technicianLabel: "Technician",
    totalToPay: "Total to pay",
  },
  technicians: {
    allLinked: "— all customers already linked —",
    appApproveBtn: "Approve",
    appApproved: "Approved",
    appCompaniesLabel: "Companies:",
    appExistsCars: "cars",
    appExistsPre: "Already in Gestion as",
    appExistsSuf: "— the record will be reused, nothing is duplicated.",
    appPending: "Pending",
    appPrefixMade: "prefix generated",
    appRejectBtn: "Reject",
    appRejectPrompt: "Reason for rejection:",
    appRejected: "Rejected",
    appRoleLabel: "Role",
    appRoleMontador: "Fitter",
    appRolePdr: "PDR technician",
    appShowAll: "Show all",
    appShowPending: "Pending only",
    appsEmpty: "No pending applications.",
    appsHint:
      "Registrations sent from the public page. Approving creates the user and the technician record, with a non-colliding order prefix.",
    badgeActive: "active",
    badgeBlocked: "portal locked",
    badgeInactive: "inactive",
    baseFaturado: "Invoiced",
    baseFaturadoFull: "Invoiced (Total Facture)",
    baseOrcamento: "Quote",
    baseOrcamentoFull: "Quote (Prix Brut)",
    cancel: "Cancel",
    chantierAllLinked: "All chantiers already linked",
    chantierBaseFaturado: "Invoiced (Total Facture)",
    chantierBaseLabel: "Calculation base",
    chantierBaseOrcamento: "Budget (Prix Brut)",
    chantierCommHint:
      "this technician's % on the chantier applies to all its clients without a specific pair",
    chantierCommTitle: "Commissions per chantier",
    chantierIntermLabel: "Intermediary",
    chantierIntermNone: "— no intermediary —",
    chantierIntermPctLabel: "Intermediary %",
    chantierLinkOption: "+ Link chantier — select…",
    chantierNewTag: "new — set the %",
    chantierPctLabel: "Technician commission (%)",
    chantierRemiseNote:
      "The client discount comes from each client's RECORD (individuals included) and is verified at vehicle reception — the chantier does not define discounts.",
    chantierSave: "Save",
    chantierUnlink: "Unlink",
    clientPctFallbackPre: "Empty: uses the client record's retention —",
    clientPctFallbackSuf: "",
    clientPctHint: "This % applies only to this pair and overrides the client record.",
    clientPctMissing:
      "⚠ Client has no retention on record — set the % here for the quote base to work.",
    clientShort: "cli.",
    colActions: "Actions",
    colCommission: "Commission",
    colTaxId: "Tax ID",
    commissionRange: "Commission must be 0–100%",
    commissionsSaveFirst:
      "Per-customer commissions: save the technician first, then reopen to link customers with their own % and base.",
    commissionsSectionHint: "each customer×technician pair has its own %, base and intermediary",
    commissionsSectionTitle: "Commissions per customer",
    companyLabel: "Company",
    create: "Create",
    customerMissingPre: "Customer",
    customerMissingSuf:
      "has no retention % registered. Update it on the customer record (Customers menu) — in QUOTE base the customer is part of the split.",
    dash: "—",
    deactivate: "Deactivate",
    deactivateMessage:
      "An inactive technician doesn't appear in new dossier lines. Existing lines are not affected.",
    deactivatePlaceholder: "E.g.: technician ended the partnership",
    deactivateTitle: "Deactivate technician",
    dossierCountSuffix: "dossier(s)",
    edit: "edit",
    email: "Email",
    emptyState: "No technician found.",
    fieldBase: "Calculation base",
    fieldClientPct: "% Client discount (this pair)",
    fieldCommissionPct: "Commission (%)",
    fieldCountry: "Country (ISO-2)",
    fieldIntermediaryPct: "% Intermediary",
    fieldNotes: "Notes",
    fieldParcRole: "Service type — Parc Grêle",
    fieldPhone: "Phone",
    fieldPortalUser: "Portal account (technician login)",
    fieldSenior: "Senior technician (may change the deductible)",
    fieldTaxId: "Tax ID (RIB/CPF/...)",
    fieldTaxIdKind: "Tax ID type",
    fieldTaxReason: "Reason for changing the Tax ID",
    fillIntermediary: "Fill in the intermediary",
    filterActive: "Active",
    filterAll: "All",
    filterInactive: "Inactive",
    hintFatPre:
      "In INVOICED base the customer already withheld before the invoice; technician + intermediary +",
    hintFatSuf: "= 100% on what remains.",
    hintOrcPre: "In QUOTE base the customer is part of the split;",
    hintOrcSuf: "absorbs the rest.",
    intermShort: "+ interm.",
    intermediary: "Intermediary",
    linkCustomerOption: "+ Link customer — select…",
    loading: "Loading…",
    loadingLinks: "Loading links…",
    modalTitleCreate: "New technician",
    modalTitleEdit: "Edit technician",
    name: "Name",
    newBtn: "+ New technician",
    next: "Next",
    noCompanyAccess: "You don't have access to any company.",
    noIntermediary: "No intermediary",
    noIntermediaryAvailable:
      "No intermediary available. Create one in “Intermediaries” (external) or add another company to the group.",
    noLinkedWarning:
      "No linked customer — without a configured pair, creating/recalculating this technician's lines fails (enter the % manually in the dossier or link the customer here).",
    noPctRegistered: "no % registered",
    open: "open",
    optgroupExternal: "External intermediaries",
    optgroupGroupCompanies: "Group companies",
    paginationOf: "of",
    paginationPage: "Page",
    pairMissingTag: "no pair",
    pairZeroTag: "0% pair",
    parcRoleHint:
      "Only relevant for hail worksites (Parc Grêle). Each technician is authorised for ONE service type; payment comes from the fixed forfait amount (not from commission).",
    parcRoleMontage: "Assembler / disassembly",
    parcRoleNone: "— not on the parc (regular technician) —",
    perCustomer: "per customer",
    portalUserHint:
      'Create the user in Users with the "Technician (portal)" role and link it here. The technician logs in and takes cars by plate at /portal.',
    portalUserNone: "— no linked account —",
    prev: "Previous",
    previewSampleBase: "sample base: 1 000,00 €",
    previewTitle: "Split preview",
    reactivate: "Reactivate",
    removeLink: "Remove link",
    residualExceedFat: "Technician + intermediary",
    residualExceedOrc: "Customer + technician + intermediary",
    residualExceedSuf: "would go negative — saving the line will fail.",
    save: "Save",
    savedNoChanges: "Saved — no changes",
    savedShort: "Saved",
    saving: "Saving…",
    searchLabel: "Search",
    searchPlaceholder: "Name, email, tax ID…",
    selectOption: "— Select —",
    seniorHint:
      "Every technician SEES the deductible in the portal. Only the authorised senior may change it — never the fitter.",
    status: "Status",
    sumExceedPre: "Technician + intermediary =",
    sumExceedSuf: "% > 100%.",
    sumOver100: "Technician + intermediary exceeds 100%",
    tabActive: "Technicians",
    tabApplications: "Applications",
    taxIdAdminOnly: "Only administrators can edit the Tax ID.",
    taxKindOther: "Other",
    taxKindVatEu: "VAT (other EU country)",
    taxReasonPlaceholder: "Required when changing tax data",
    technicianLabel: "Technician",
    technicianPlural: "technicians",
    technicianSingular: "technician",
    theCompany: "the company",
    totalLabel: "Total",
    withIntermediary: "With intermediary",
    withoutPairCount: "customer(s) with dossiers without a configured pair or with a 0% pair",
    withoutPairHint:
      "Without a pair the calculation falls back to the default base (invoiced); a 0% pair leaves the technician commission at zero. Configure/adjust the pair below so the calculation is correct:",
  },
  treasury: {
    allCommissionsOk:
      "All lines reconcile with the right base (customer + technician + halves + intermediary + Euro Storm = quote − deductible − part done by the garage). Nothing suspicious.",
    badgeConsolidated: "consolidated",
    blockedClientNotPaid: "blocked (customer not paid)",
    blockedLabel: "blocked",
    cascadeBaseHint:
      "Expected base = quote − deductible (private customer and manual value: full quote) − trim-removal half done by the garage. The sum includes halves handed to another technician.",
    cascadeNotClosingSuffix:
      "with a cascade that does NOT reconcile with the base — review before paying.",
    col1_30: "1–30 d",
    col31_60: "31–60 d",
    col61_90: "61–90 d",
    col90: "> 90 d",
    colBalance: "Balance",
    colBudget: "Quote",
    colCascadeSum: "Cascade sum",
    colCustomer: "Customer",
    colDelay: "Delay",
    colDiff: "Difference",
    colDossier: "Dossier",
    colDueDate: "Due date",
    colExpectedBase: "Expected base",
    colIntermediary: "Interm.",
    colInvoiceNumber: "Invoice no.",
    colInvoices: "Invoices",
    colMaxDelay: "max. delay",
    colNotDue: "Not due",
    colTechnician: "Technician",
    colTotalHt: "Open excl. VAT",
    colTotalTtc: "To pay incl. VAT",
    commissionCheckTitle: "Commission check",
    companyLabel: "Company:",
    daysAbbrev: "d",
    emptyByCustomer: "No open invoice.",
    emptyNoOverdue: "No overdue invoices. 🎉",
    invoicesSuffix: "invoices",
    linePlural: "lines",
    lineSingular: "line",
    loading: "Loading…",
    overdueLower: "overdue",
    payableTitle: "Payable",
    receivableCustomerTitle: "Receivable — customer",
    releasedExplainPre: '"Released" = customer has already paid (gate). Detail by technician in',
    releasedExplainSuf:
      ". Technician/intermediary commission comes from the lines (invoice documents are not used yet).",
    statAging0_30: "1–30 days",
    statAging31_60: "31–60 days",
    statAging61_90: "61–90 days",
    statAging90plus: "+90 days",
    statIntercompanyReceivable: "Intercompany receivable",
    statIntermediaryIntercompany: "Intermediary (BS) — intercompany",
    statIntermediaryReleased: "Intermediary — released to pay out",
    statNotDue: "Not due",
    statOpen: "Outstanding",
    statOverdue: "Overdue",
    statSupplierOpen: "Supplier — outstanding",
    statTechnicianReleased: "Technician — released to pay",
    statementBtn: "Statement",
    techPaymentsLink: "Technician Payments",
    viewByCustomer: "By customer",
    viewByInvoice: "By invoice (overdue)",
  },
  users: {
    accessPerCompany: "Access per company",
    accessRestricted: "Access restricted to administrators.",
    adminScopeNote:
      "You see the accounts of the companies you manage. Only the Super Admin changes Administrator accounts.",
    cancelBtn: "Cancel",
    cannotChangeOwnSuperAdmin: "You cannot change your own super admin status",
    closeBtn: "Close",
    colAccessPerCompany: "Access per company",
    colActions: "Actions",
    colEmail: "Email",
    colName: "Name",
    colStatus: "Status",
    colSuperAdmin: "Super admin",
    copiedBtn: "Copied ✓",
    copyLinkBtn: "Copy link",
    createBtn: "Create",
    createErrorTitle: "Error creating user",
    createLinkBtn: "Create and send the link",
    createLinkHint:
      "The person receives an e-mail with a link to set their own password (valid 72 h).",
    creatingBtn: "Creating…",
    deactivateAccount: "Deactivate account",
    deleteBtn: "Delete user",
    deleteConfirmPre: "Permanently delete",
    deleteConfirmSuf:
      "The name and e-mail become FREE for a new account; history (audit) is kept. This cannot be undone.",
    deleteConfirmTitle: "Delete user?",
    deleteDonePre: "Account deleted. The e-mail",
    deleteDoneSuf: "is free for a new account.",
    deleteDoneTitle: "User deleted",
    editBtn: "Edit",
    editSavedMsg: "Name and e-mail saved.",
    editSavedTitle: "Details updated",
    editTitle: "Edit user",
    emailLabel: "Email",
    emailLockedHint: "Account already in use: only the Super Admin changes the e-mail.",
    errorTitle: "Error",
    fullAccessAllCompanies: "Full access (all companies)",
    impersonateBtn: "Log in as",
    impersonateBtnTitle:
      "Open the app exactly as this user sees it (audited; your admin session will be replaced)",
    impersonateConfirmMsg:
      'Your admin session in this browser will be replaced by this user\'s (max 2h). To return, use "Exit view" in the orange banner and log in again. Everything is audited. Continue?',
    introPre: "Access defined ",
    introStrong: "per company",
    introSuf:
      ". Super admin accesses everything. An Administrator manages the accounts of the companies they manage, except Administrator accounts.",
    inviteByEmail: "Invite by email",
    levelAdminDesc: "— full management of the company (including users and rules).",
    levelSuperAdminDesc:
      "— global: unlimited access to all companies, includes the Finance module.",
    levelUserDesc: "— operational: creates/edits/imports; does not manage users.",
    levelViewerDesc: "— read only: filters and views, does not modify.",
    levelsTitle: "Levels (per company):",
    linkCopyHint: "If the e-mail does not arrive, copy the link and send it by WhatsApp:",
    linkHiddenNote: "For security, the link of an account already in use is sent by e-mail only.",
    linkMissingData: "Fill in the name and e-mail.",
    linkResentTitle: "Link sent",
    linkResultFailed:
      "The e-mail was not sent. Copy the link below and send it another way (WhatsApp).",
    linkResultSent: "E-mail with the link sent to",
    linkSentTitle: "Account created",
    loading: "Loading…",
    localeLabel: "E-mail language",
    menuAgenda: "Calendar",
    menuChantiers: "Sites",
    menuClientes: "Customers",
    menuDevis: "Quotes",
    menuDossiers: "Dossiers",
    menuFaturas: "Invoices",
    menuLevelOperate: "operate",
    menuLevelView: "view",
    menuPainel: "Dashboard",
    menuTecnicos: "Technicians",
    menuVeiculos: "Vehicles",
    menusBtn: "Menus",
    menusHint:
      "Only for portal roles (manager, technician, client). Data stays limited to the chantiers the person manages.",
    menusNone: "none",
    menusSave: "Save menus",
    menusSaved: "Menus saved.",
    menusTitle: "Gestion menus granted",
    missingDataMessage: "Fill in the name, email and a password of at least 8 characters.",
    missingDataTitle: "Missing data",
    nameLabel: "Name",
    needOneAccess: "Choose the access in at least one company.",
    newUserBtn: "+ New user",
    noAccess: "No access",
    pageTitle: "Users",
    passwordLabel: "Password (min. 8)",
    reactivateAccount: "Reactivate account",
    resetPwBtn: "Reset password",
    resetPwBtnTitle: "Set a new password for this account (the old one stops working)",
    resetPwDonePre: "New password set for",
    resetPwDoneSuf: "Tell the user — the old password no longer works.",
    resetPwDoneTitle: "Password reset",
    resetPwPlaceholder: "Minimum 8 characters — note it down for the user",
    resetPwTitle: "New password",
    resetPwTooShort: "Password must be at least 8 characters.",
    roleAdmin: "Administrator",
    roleClient: "Client (portal)",
    roleManager: "Project manager (site)",
    roleTechnician: "Technician (portal)",
    roleTechnicianMontador: "Assembler (portal)",
    roleTechnicianPdr: "PDR technician (portal)",
    roleUser: "User",
    roleViewer: "Viewer",
    sendLinkBtn: "Send",
    sendLinkConfirmPre: "Send",
    sendLinkConfirmSuf: "an e-mail with the link to set the password?",
    sendLinkTitle: "Send password link",
    statusActive: "Active",
    statusInactive: "Inactive",
    superAdmin: "Super admin",
    superAdminCheckbox: "Super admin (unlimited access to all companies)",
    technicianCreatedMsg:
      "the record was created in this company from the one he already had. Only the technician×customer or site pairs remain, under Technicians → edit.",
    technicianCreatedTitle: "Technician record created",
    technicianMissingMsg:
      "Access was granted, but the role (PDR or assembler) is only stored on this company's technician record. Create the technician under Technicians, link this account and pick the role again.",
    technicianMissingTitle: "No technician record",
    userCreatedSuffix: "created.",
    userCreatedTitle: "User created",
    youTag: "(you)",
  },
  vehicles: {
    badgeActive: "active",
    badgeInactive: "inactive",
    cancel: "Cancel",
    catalogBadge: "catalog",
    catalogLinkedTitle: "Linked to the catalog",
    chipCadastro: "Created",
    chipDevis: "Quote",
    chipEmReparacao: "In repair",
    chipFaturado: "Invoiced",
    chipPago: "Received",
    chipRecebidoPago: "Received · paid",
    chipRecebidoPendente: "Received · to pay",
    chipReparado: "Repaired",
    colActions: "Actions",
    colColor: "Color",
    colCustomer: "Customer",
    colMakeModel: "Make / model",
    colPlate: "Plate",
    colStatus: "Status",
    colYear: "Year",
    companyLabel: "Company",
    create: "Create",
    customerOptionalLabel: "Customer (optional)",
    customerSearchPlaceholder: "Type at least 2 letters to search",
    deactivate: "Deactivate",
    deactivateMessage:
      "An inactive vehicle does not appear in new dossiers. Existing dossiers are not affected.",
    deactivatePlaceholder: "E.g. vehicle scrapped",
    deactivateTitle: "Deactivate vehicle",
    dossiersWord: "dossiers",
    editLink: "edit",
    editTitle: "Edit vehicle",
    emptyState: "No vehicle found.",
    errInvalidYear: "Invalid year.",
    errPlateOrVin: "Enter at least the plate or the VIN.",
    filterActive: "Active",
    filterAll: "All",
    filterInactive: "Inactive",
    generationLabel: "generation",
    hintChooseMakeFirst: "Choose the make first",
    hintMakeFreeText: "Make in free text — model will be free text",
    historyCurrent: "this dossier",
    historyDevis: "Quote",
    historyDevisPdf: "Quote PDF",
    historyDossierWord: "Dossier",
    historyDossiersWord: "dossiers",
    historyHint: "Each dossier is one service on the vehicle; the most recent is on top.",
    historyOpen: "Open",
    historyTitle: "Vehicle record",
    loading: "Loading…",
    makeLabel: "Make",
    makePlaceholder: "E.g. Peugeot, Renault…",
    menuTitle: "Vehicle dossiers",
    modelFreePlaceholder: "Model (free text)",
    modelLabel: "Model",
    modelPlaceholder: "E.g. 308, Clio…",
    newBtn: "New vehicle",
    next: "Next",
    noCompanyAccess: "You don't have access to any company.",
    noCustomer: "no customer",
    noCustomerFound: "No customer found.",
    noDossiers: "No dossiers yet",
    noMakeInCatalog: "No make in the catalog. The typed text will be saved as free text.",
    noModelInCatalog:
      "No model in the catalog for this make. The typed text will be saved as free text.",
    notesLabel: "Notes",
    ofLabel: "of",
    pageLabel: "Page",
    prev: "Previous",
    reactivate: "Reactivate",
    remove: "remove",
    requestProforma: "Request a proforma (advance to the technician)",
    save: "Save",
    saving: "Saving…",
    searchLabel: "Search",
    searchPlaceholder: "Plate, VIN, make, model…",
    searching: "Searching…",
    statusLabel: "Status",
    vehiclePlural: "vehicles",
    vehicleSingular: "vehicle",
    vinLabel: "VIN (chassis)",
  },
  worklog: {
    carWordSingular: "car",
    carsWord: "cars",
    clientSectionTitle: "Technician worklogs",
    emailBtn: "Send to client",
    emailSentPre: "Worklog sent to",
    emptyWeek: "No production this week.",
    exportHint:
      "Week's production per client — no commissions. Download the PDF or send it straight to the client.",
    exportTitle: "Weekly worklog (client document)",
    generatingBtn: "Generating…",
    interventionsWord: "interventions",
    pdfBtn: "Download PDF",
    weekPre: "Week",
  },
};
